webpackJsonp([471],{

/***/ 12:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.workbench_data = exports.NoticeGetSystemNoticePage = exports.getCustomerData = exports.getProjectInformation = exports.getPmData = exports.getIndexSyntheticData = exports.eSignature = exports.WorkOrderGetWorkTicketsNumber = exports.WorkOrderCompleteWorkOrder = exports.WorkOrderReturnWorkOrder = exports.WorkOrderChangeWorkOrder = exports.WorkOrderAgreeWorkOrder = exports.WorkOrderDisagreeWorkOrder = exports.WorkOrderGetWorkOrderDetail = exports.WorkOrderGetWorkOrderDelete = exports.WorkOrderSaveWorkOrder = exports.WorkOrderGetWorkOrderPage = exports.saveSupplier = exports.getSupplierBlacklistsPageList = exports.updateSupplierBlacklistsStatus = exports.delSupplierIssueById = exports.removeSupplierIssueById = exports.saveSupplierIssue = exports.findSupplierIssuePageList = exports.findSupplierById = exports.getSupplierPage = exports.findProjectPublicizeById = exports.addOrUpdProjectPublicize = exports.getPublicizeProjectChooseCount = exports.getPublicizePage = exports.getQueryCustomerIntentionPage = exports.getEchartsCollectReportDataByGrade = exports.getEchartsCollectReportDataBySource = exports.getEchartsCollectReportDataByRegion = exports.getEchartsCollectReportDataByDispatchRatio = exports.getEchartsCollectReportDataByProgressRatio = exports.getEchartsBidsReportDataByMapOfChina = exports.getEchartsBidsReportDataByProvince = exports.getEchartsBidsReportDataByTrend = exports.getEchartsBidsReportData = exports.getEchartsProjectOrDesignOrBuyingIsMoneyAndNumber = exports.getEchartsSignedReportDataByRegion = exports.getEchartsSignedReportDataByProjectNumber = exports.getEchartsSignedReportDataByDirectorMoney = exports.getEchartsSignedReportDataByProjectMoney = exports.getEchartsSignedReportDataByGrade = exports.getEchartsSignedReportDataByCooperationType = exports.getEchartsSignedReportDataByProjectType = exports.getEchartsSignedReportDataByEngineeringType = undefined;
exports.getEchartsSignedReportDataByInfo = exports.laborReturnedReportItemData = exports.payableReturnedReportItemData = exports.financeReturnedSummaryReportItemData = exports.getEchartsSettlementReportDataByCooperationType = exports.getEchartsSettlementReportDataByType = exports.getEchartsSettlementReportDataByProject = exports.payableReceivableReportItemData = exports.invoiceTicktReceivableReportItemData = exports.financeReceivableSummaryReportItemData = exports.getEchartsFoldOrPostFinanceIncomeData = exports.getEchartsClaimedFinanceIncomeTypeReportItemData = exports.getEchartsSummaryFinanceIncomeTypeReportItemData = exports.getEchartsTrendFinanceIncomeData = exports.getEchartsSummaryFinanceIncomeReportItemData = exports.getEchartsBuyingAbnormalTypeReportItemData = exports.getEchartsBuyingReportItemData = exports.getEchartsBuyingReportDataByRegion = exports.getEchartsBuyingTypeReportItemData = exports.getEchartsBiddingReportDataByDirectorMoney = exports.getEchartsBiddingReportDataByProjectMoney = exports.getEchartsBiddingReportDataByType = exports.getEchartsBiddingReportDataBySource = exports.getEchartsBiddingReportDataByMoney = exports.getEchartsBiddingReportDataByCount = exports.getEchartsDesignAbnormalTypeReportItemData = exports.getEchartsDesignReportItemData = exports.getEchartsDesignReportDataByRegion = exports.getEchartsDesignTypeReportItemData = exports.getEchartsPollingReportDataByDirectorScore = exports.getEchartsPollingReportDataByProjectScore = exports.getEchartsPollingReportDataByRegion = exports.getEchartsPollingReportDataByProject = exports.getEchartsPollingReportDataByGrade = exports.getEchartsPollingReportDataByTrend = exports.getEchartsDispatchReportDataByGrade = exports.getEchartsDispatchReportDataBySource = exports.getEchartsDispatchReportDataByRegion = exports.getEchartsDispatchReportDataByTrend = exports.getEchartsAbnormalTypeReportItemData = exports.getEchartsAbnormalReportDataBySource = exports.getEchartsLoseReportDataBySource = exports.getEchartsLoseReportDataByType = exports.getEchartsLoseReportDataByTrend = exports.getEchartsBidReportDataByType = exports.getEchartsBidReportDataBySource = exports.getEchartsBidReportDataByTrend = exports.getEchartsInitiateReportDataByTrend = exports.getEchartsInitiateReportDataByType = exports.getEchartsInitiateReportDataBySource = exports.getEchartsSkillReportItemData = exports.getEchartsRegisterAndManageReportItemData = exports.getEchartsTalentsTypeReportItemData = exports.getEchartsTalentsPartnershipReportItemData = exports.getEchartsTalentsCountReportItemData = exports.getEchartsReportItemDataByElite = exports.getEchartsChargeReportItemData = exports.getEchartsStatusCountReportItemData = exports.getEchartsRegisterReportItemData = exports.getEchartsCustomerIndustryReportItemData = exports.getEchartsCustomerNatureReportItemData = exports.getEchartsCustomerCountReportItemData = exports.getEchartsReportItemDataByCustomer = exports.getXappReportMenuByRole = exports.getAuthorizeBackRole = exports.getEchartsProjectReportDataByLine = exports.getEchartsSyntheticReportDataByLine = exports.validation_rules = exports.getTitleTypeQualificationCertificatePage = exports.getSafetyTypeQualificationCertificatePage = exports.getTitleTypeQualificationCertificateList = exports.getSafetyTypeQualificationCertificateList = exports.qualificationCertificate_getManageMajorType = exports.certificateApply_getProjectPage = exports.getSkillQualificationCertificatePage = exports.getManageQualificationCertificatePage = exports.getRegisterQualificationCertificatePage = exports.getManageTypeQualificationCertificateList = exports.getRegisterTypeQualificationCertificateList = exports.addCertificateApply = exports.getOverdueQualificationCertificatePage = exports.releasedCertificateApplyById = exports.getCertificateApplyByPersonIdPage = exports.delQualificationCertificatebyId = exports.getQualificationCertificateList = exports.addQualificationCertificate = exports.delPersonInfoById = exports.getPersonInfoById = exports.getPersonInfoPage = exports.addPersonInfo = exports.sealApply_deleteRecycle = exports.sealApply_restartSealApply = exports.update_pm_phone = exports.sealApply_attaches = exports.get_cm_list = exports.complete_project_manager = exports.return_project_manager = exports.change_project_manager = exports.agree_project_manager = exports.disagree_project_manager = undefined;
exports.sealApply_recycleExecute = exports.del_sealApply = exports.return_flow_sealApply = exports.change_sealApply = exports.disagree_sealApply = exports.agree_sealApply = exports.get_employees_account = exports.get_return_list = exports.get_sealApply_page = exports.query_sealApply = exports.submit_sealApply = exports.save_sealApply = exports.update_other_sealapply = exports.get_approve_project = exports.get_sealApply_category = exports.get_flow_process_progress = exports.get_flow_node = exports.get_sealApply_file_category = exports.sealApplyGetOtherSealApplyPage = exports.sealApplySaveOtherSealApply = exports.sealApplySubmitOtherSealApply = exports.sealApplyQueryOtherSealApply = exports.sealApplyDelOtherSealApply = exports.sealApplyChangeOtherSealApply = exports.sealApplyReturnCustomFlowOtherSealApply = exports.sealApplyDisagreeOtherSealApply = exports.sealApplyAgreeOtherSealApply = exports.get_report_item = exports.get_operation_report_menu = exports.get_report_orgList = exports.get_project_page = exports.project_record = exports.data_all_pm = exports.projectPunishment_delProjectPunishment = exports.projectPunishment_restartPunishmentApply = exports.updateFeedback = exports.feedbackList = exports.auditProjectPunishment = exports.getProjectPunishmentInfo = exports.delProjectPunishment = exports.save_project_punishment = exports.add_project_punishment = exports.addPunishmentTreatmentScheme = exports.update_punishment = exports.get_project_punishment_list = exports.issut_workerList = exports.issue_releaseIssue = exports.issue_deleteIssue = exports.issue_editIssue = exports.getIssuePage = exports.projectLitigation_delProjectLitigation = exports.projectLitigation_restartLitigationApply = exports.casualty_grade = exports.auditProjectLitigation = exports.getLitigationInfo = exports.delProjectLitigation = exports.updateLitigationResult = exports.addLitigationTreatmentScheme = exports.updateLitigationHandlePerson = exports.getProjectLitigationTreatment = exports.getProjectLitigationPage = exports.saveProjectLitigation = exports.addProjectLitigation = exports.litigation_getProjectPage = exports.complaint_deleteComplaintApply = exports.complaint_restartComplaintApply = exports.complaint_sumbitComplaint = exports.complaint_returnComplaints = exports.complaint_changeComplaint = exports.complaint_disagreeComplaint = exports.complaint_agreeComplaint = exports.complaint_completeComplaint = exports.complaint_grade = exports.complaint_returnComplaint = exports.complaint_saveDealWith = exports.apply_addOtherAmount = exports.report_finance_statistics_summary_print = exports.complaint_getPMComplaint = exports.complaint_frozen = exports.complaint_dealwith = exports.complaint_dealwithUser = exports.complaint_dispatch = exports.complaint_invalid = exports.complaint_complainantDetail = exports.complaint_saveOrEdit = exports.project_getComplaintProject = exports.proManager_getComplaintsProManagerPage = exports.complaint_page_date = exports.complaint_getComplaintTypeCats = exports.authorizationToAppJump = exports.project_saveDocFileBatch = exports.find_by_idCard = exports.flie_saveDocFile = exports.flie_delete = exports.flie_projectDocFile = exports.flie_projectDocDir = exports.flie_workingAndFinish = exports.project_stylistContractInfoExcel = exports.project_getContractInfoPro = exports.project_getStylistPro = undefined;
exports.apply_realEstate_collateral_info = exports.apply_saveBidBond = exports.apply_projectByBidBond = exports.materialTicket_saveUpload = exports.materialTicket_export_errorData = exports.materialTicket_repeat = exports.materialTicket_check_upload = exports.relevanceMaterial = exports.auditMaterialTicketApply = exports.exportMaterialTicketInfoPage = exports.delMaterialTicketInfo = exports.getMaterialTicketInfo = exports.saveMaterialTicketApply = exports.getMaterialTicketPurchace = exports.getMaterialTicketProject = exports.materialTicketList = exports.addSalesTicket = exports.batchImportSalesTicket = exports.batchExportSalesTicketUnsuccessList = exports.checkExcelSalesTicket = exports.findProjectContractInfo = exports.invoice_complete_void = exports.invoice_change_void = exports.invoice_return_void = exports.invoice_disagree_void = exports.invoice_agree_void = exports.invoice_confirmVoid = exports.invoice_deleteInvoiceApplyData = exports.invoice_restartInvoiceApplyDataBizItemId = exports.invoice_complete_red_rush = exports.invoice_change_red_rush = exports.invoice_return_red_rush = exports.invoice_disagree_red_rush = exports.invoice_agree_red_rush = exports.invoice_getVoidApplyInfo = exports.invoice_saveRedPunchApply = exports.invoice_saveVoidApply = exports.invoice_complete = exports.invoice_return = exports.invoice_change = exports.invoice_disagree = exports.invoice_agree = exports.invoice_findNewestInvoiceByProjectId = exports.invoice_invoiceApply_page_export = exports.invoice_auditInvoiceApply = exports.invoice_deleteInvoiceApply = exports.invoice_saveInvoiceNo = exports.invoice_checkInvoiceNos = exports.invoice_getInvoiceApplyInfo = exports.invoice_getInvoiceApplyPage = exports.invoice_saveInvoiceApply = exports.enum_data_find_invoice_content_type = exports.invoice_findBillingProjectById = exports.invoice_findBillingProjectList = exports.findProjectContractList = exports.exportSalesTicketList = exports.findInvoiceList = exports.project_commission_export = exports.project_manage_export = exports.getDetail = exports.getStampPage = exports.attendance_projectExperienceList = exports.attendance_workerDetailsInfo = exports.attendance_allWorkerInfoList = exports.addAttendanceDeviceByProjectId = exports.delAttendanceDeviceById = exports.stopAttendanceDeviceById = exports.getChooseAttendanceDeviceList = exports.getAttendanceDeviceListByProjectId = exports.exportAttendanceRecord = exports.worker_salary_pageInfo = exports.attendance_updatePersonInfo = exports.attendance_deleteWorkerIssue = exports.attendance_editWorkerIssue = exports.attendance_releaseWorkerIssue = exports.attendance_addWorkerIssue = exports.attendance_getWorkerIssueList = exports.attendance_editGradeAndScore = exports.attendance_checkWorkerData = exports.attendance_multiImport = exports.attendance_getAttendanceRecordList = exports.attendance_createQrCode = exports.attendance_addWorker = exports.attendance_getOccupationCategoryList = exports.attendance_getPersonInfoByIdcardNo = exports.attendance_getEditWorkerInfo = exports.attendance_addProjectUnitTeam = exports.attendance_addProjectUnit = exports.attendance_getTeamList = exports.attendance_getUnitList = exports.attendance_getWorkerInfoList = exports.projectDispatchPerson_getProjectDispatchPersonRecord = exports.projectDispatchPerson_getProjectDispatchPersonInfo = exports.projectManagement_editProjectDispatch = exports.projectDispatchPerson_getDispatchPersonPage = exports.project_getProjectMaterialProductPage = exports.project_getProjectMaterialDetail = exports.project_getProjectMaterialList = exports.projectHonor_getProjectHonorByProjectId = exports.projectHonor_saveProjectHonor = undefined;
exports.project_getProjectExList = exports.openEquipment = exports.project_getProjectMonitorInfoById = exports.project_addProjectMonitorSnapshot = exports.project_getDeviceListById = exports.project_updateConstructionSpecification = exports.project_manager_KPI_statistics_export = exports.project_manage__KPI_statistics = exports.project_return_export = exports.project_return_page = exports.project_manager_monitoring_statistics_export = exports.project_manager_monitoring_statistics = exports.getCategoryId = exports.guaranteeLetter_addGuaranteeLetter = exports.project_get_billMaterials = exports.project_get_rollContract = exports.project_Guarantee_info = exports.project_monitoring_statistics_export = exports.project_get_play_table_list_info = exports.project_get_play_table_list = exports.project_manage_monitoring_statistics = exports.project_manage_no_supervisors = exports.project_manage_cancel_audit = exports.project_manage_cancel_dispatch = exports.project_manage_assign_supervisor = exports.project_manage_info = exports.project_manage_list = exports.back_user_supervisor_list = exports.common_save_attachment = exports.payment_apply_info = exports.payment_apply_list = exports.credit_restartCreditApply = exports.creditApply_submit = exports.creditApply_deal = exports.creditApply_change = exports.creditApply_return = exports.creditApply_disagree = exports.creditApply_agree = exports.get_credit_portrait = exports.getCreditApplyPortraitByProjectId = exports.getCreditProjectPage = exports.getCreditPortraitAuditByPortraitId = exports.auditCreditApplyPortrait = exports.updateSysCreditApplyPortrait = exports.updateCreditApplyPortrait = exports.getCreditApplyPortrait = exports.updateCreditAmount = exports.credit_pm_credit_project_info = exports.credit_pm_credit_info = exports.credit_pm_credit_list = exports.getCreditOrderGoodsList = exports.getCreditOrderRepaymentList = exports.getCreditOrderInfo = exports.creditOrderPay = exports.auditCreditOrderByFM = exports.checkUserOrder = exports.getCreditOrderPage = exports.credit_apply_audit = exports.credit_detail = exports.credit_apply_list = exports.apply_checkWorkerSalaryUploadData = exports.printApplyInfo = exports.finance_changeApply = exports.finance_disagreeApply = exports.finance_print = exports.editAdvanceTaxAmount = exports.finance_doDelete = exports.finance_doPay = exports.finance_modifyPayAmount = exports.finance_doAudit = exports.finance_getApplyInfo = exports.advanceTax_getProjectInfo = exports.apply_getProjectDedOfBackRisk = exports.finance_submitAudit = exports.userBank_editBankAttach = exports.userBank_saveUserBank = exports.userBank_getUserBankList = exports.getSettleDefaultUserBank = exports.userBank_getDefaultUserBank = exports.changeLaborApply = exports.disAgreeLaborApply = exports.apply_delete_labor = exports.apply_editLaborApplyInfo = exports.apply_getProjectIncomeInfo = exports.apply_addLaborPayment = exports.apply_laborApplyInfo = exports.apply_laborConfirmStatus = exports.apply_saveLaborApply = exports.apply_addLaborApply = exports.apply_laborOddNumbers = exports.apply_getProjectDeductionsInfo = exports.apply_getProjectByLabor = exports.apply_getLaborApplyPage = exports.exportPayRollContractPage = exports.apply_seal_save = exports.apply_seal_type = exports.apply_seal_get_detail = exports.apply_seal_getProject = exports.apply_seal_DataPage = exports.payRoll_savePayRollMarkContent = undefined;
exports.payRoll_getPayRollContractPageByProject = exports.payRoll_savePayRollInvoices = exports.payRoll_auditContract = exports.payRoll_payRollContractInfo = exports.payRoll_branchName = exports.addNewSupplier = exports.payRoll_getSupplyList = exports.payRoll_getPayRollContractNo = exports.payRoll_updatePayRollContract = exports.payRoll_savePayRollContract = exports.payRoll_addPayRollContract = exports.payRoll_contract_list = exports.reset_process_apply = exports.del_process_apply = exports.del_buy_apply = exports.getOtherMallBillMaterials = exports.relevanceMaterialTicket = exports.cancelRelevanceMaterial = exports.getPaidMaterialTicket = exports.getNoDeductionMaterialPage = exports.getNoAssociatedMaterial = exports.apply_project_info = exports.apply_getOtherMallCallout = exports.apply_getDFOddNumbers = exports.apply_saveApplyAmount = exports.apply_otherMallPayment = exports.apply_OtherMall_print = exports.apply_OtherMall_select_pro = exports.apply_OtherMall_edit = exports.apply_get_branchList = exports.apply_get_bankList = exports.getSupplierChooseList = exports.apply_getSupplyList = exports.applyData_saveOtherMall = exports.editBillMaterialByApplyId = exports.apply_otherMallPageExport = exports.applyData_getOtherMallPage = exports.materialTicketInfo_deleteXmFinanceItemManualBehalf = exports.materialTicketInfo_deleteXmFinanceItemManual = exports.changeTenementDepositApply = exports.disagreeTenementDepositApply = exports.changeBidBondApply = exports.disagreeBidBondApply = exports.changeOtherMall = exports.disagreeOtherMall = exports.applyData_audit_otherMall = exports.payRoll_checkRepeatPaidMaterial = exports.payRoll_delete_payRollContract = exports.payRoll_staging_payRollContract = exports.applyData_save_otherMall = exports.getProjectAdvanceTaxList = exports.xmFinance_item_delete_by_id = exports.xmFinance_item_audit_ok_by_fm = exports.xmFinance_item_audit_ok_by_finance = exports.xmFinance_item_save_draft = exports.xmFinance_item_find_by_id = exports.xmFinance_item_get_page = exports.applyData_audit_getCash = exports.applyData_save_getCash = exports.applyData_audit_addCredit = exports.applyData_save_addCredit = exports.applyData_audit_invoiceBill = exports.applyData_save_invoiceBill = exports.delete_stamp = exports.applyData_audit_stamp = exports.applyData_save_stamp = exports.applyData_get_dataInfo = exports.applyData_getCash_getPage = exports.applyData_getPage = exports.financeStat_export_project_view = exports.financeStat_income_excel = exports.financeStat_pm_financeitemTotal = exports.financeStat_pm_financeitemPage = exports.financeStat_pm_findById = exports.financeStat_income_autoCalList = exports.financeStat_project_findById = exports.financeStat_project_pageData = exports.advanceTaxApply_delAdvanceTaxApplyById = exports.advanceTaxApply_delAdvanceTaxById = exports.advanceTaxApply_restartAdvanceTaxById = exports.advanceTaxApply_complete = exports.advanceTaxApply_return = exports.advanceTaxApply_agree = exports.advanceTaxApply_change = exports.advanceTaxApply_disagree = exports.checkAdvanceTaxReceiptNo = exports.delAdvanceTaxApplyById = exports.advanceTax_auditAdvanceTaxApply = exports.getAdvanceTaxApplyRecordPage = exports.advanceTax_getAdvanceTaxApplyInfo = exports.addOrUpdateAdvanceTaxApply = exports.getAdvanceTaxProjectById = exports.advanceTax_getApproveProjectPage = exports.getAdvanceTaxApplyPage = exports.advanceTax_getAdvanceTaxList = exports.advanceTax_saveProjectAdvanceTax = exports.advanceTax_getAdvanceTaxProjectPage = exports.financePay_uploadExcelFinancePay_save = exports.financePay_manualDeductionErrorDataExcel = exports.financePay_check_xmFinanceItem = undefined;
exports.financePay_uploadExcelFinancePay_check = exports.financePay_manualDeductionListExcel = exports.financePay_deduction_list = exports.financePay_deduction_detail = exports.financePay_deduct_calcItem = exports.financePay_financeItem = exports.financePay_manualList = exports.insurance_getProjectViewInsurancePage = exports.financePay_deleteById = exports.financePay_pageData = exports.financePay_saveData = exports.financePay_deductionsType = exports.danger_auditIncomeList = exports.danger_resetFinanceIncomeAuditStatus = exports.danger_reset_apply_data_audit_status = exports.danger_reset_contract_audit_status = exports.message_unreadCopyMsgCount = exports.message_unreadCopyMsgPage = exports.message_open_close = exports.message_unreadMsgPage = exports.message_unreadMsgCount = exports.message_remarkRead = exports.message_unread = exports.message_list = exports.message_type = exports.all_customerIntention_data = exports.reset_process_project = exports.reset_process_guarantee = exports.del_process_guarantee = exports.del_buy_guarantee = exports.followPro_addProjectInfo = exports.flow_getFlowDealProcessOps = exports.submit_complete_project = exports.submit_return_project = exports.submit_change_project = exports.submit_disagree_project = exports.submit_agree_project = exports.get_project_list = exports.delete_qualification = exports.get_qualification_list = exports.add_qualification = exports.add_guarantee = exports.buy_guarantee = exports.del_guarantee = exports.change_guarantee = exports.return_flowt_guarantee = exports.disagree_guarantee = exports.agree_guarantee = exports.submit_guarantee = exports.save_guarantee = exports.get_project_info = exports.get_guarantee_letter_apply = exports.get_guarantee_project_choose = exports.get_agency_ops = exports.get_guarantee_list = exports.getDataByLabelList = exports.getLevelByLabel = exports.getDataByLabel = exports.getProcess = exports.getProjectPhase = exports.operationCenter_updateById = exports.operationCenter_delById = exports.operationCenter_findBySubCompanyId = exports.operationCenter_findById = exports.operationCenter_save = exports.operationCenter_page_data = exports.enum_data_getEnumDataByType = exports.business_introducer_save = exports.business_introducer_find_by_id = exports.business_introducer_page_data = exports.bankInfo_save_bank_or_branch = exports.bankInfo_get_branch_list_by_parent = exports.bankInfo_get_bank_list = exports.bankInfo_findByType = exports.bankInfo_updateById = exports.bankInfo_delById = exports.bankInfo_findByName = exports.bankInfo_findById = exports.bankInfo_save = exports.bankInfo_page_data = exports.ProDetailedInfo_updateEnclosure = exports.processlog_updateEnclosure = exports.boss_doAuditById = exports.boss_findFIById = exports.boss_getPages = exports.delete_lose_by_bizItemId = exports.submit_complete_project_lose = exports.submit_return_project_lose = exports.submit_agree_project_lose = exports.submit_disagree_project_lose = exports.submit_change_project_lose = exports.project_lose_order_bizItemId = exports.project_lose_order_update = exports.project_lose_order_pages = exports.financePay_salesTicketManualList = exports.project_lose_order_page = exports.materialTicketLaborPage = exports.relevanceSupplier = exports.getSupplierPageByProjectId = exports.getMaterialTicketPage = undefined;
exports.getMaterialTicketList = exports.finance_income_check_billing_balance = exports.financeStat_project_settlement = exports.finDirector_project_visible = exports.finDirector_doAuditById = exports.finDirector_findFIById = exports.finDirector_getPages = exports.finance_income__printing_prompt = exports.finance_income_printing = exports.finManager_xm_company_bank = exports.finManager_doAuditById = exports.finManager_findFIById = exports.finManager_getPages = exports.income_data_all_cm = exports.contractInfo_claim_payment = exports.finance_income_relate_apply = exports.finance_add_markContents = exports.getCompanyName = exports.finance_sendAudit = exports.finance_delFIById = exports.finance_findFIById = exports.finance_updateFIById = exports.finance_get_auditStatus = exports.finance_computing_page_number = exports.finance_income_delete_by_id = exports.finance_income_check_duplicate = exports.finance_income_do_audit = exports.finance_income_audit_ok_by_fm = exports.finance_income_audit_ok_by_cm = exports.finance_income_send_confirm = exports.finance_income_find_by_id = exports.finance_income_get_history_page = exports.finance_income_get_page = exports.finance_income_save_draft = exports.cmDirector_project_update_cm = exports.cmDirector_introducer_doAudit = exports.cmDirector_projectManager_doAudit = exports.cmDirector_projectManager_findPMById = exports.uploadSettlementApply = exports.settlementPay = exports.settlementApply_complete = exports.settlementApply_disAgree = exports.settlementApply_return = exports.settlementApply_change = exports.settlementApply_audit = exports.settlementApplyInfo = exports.getSettlementApplyPage = exports.submitSettlementApply = exports.project_working_project_page = exports.insurance_deleteContractInsurance = exports.insurance_deleteInsurance = exports.insurance_restartInsuranceApply = exports.insurance_addInsurance = exports.getInsuranceInfoByProjectId = exports.insurance_editInsuranceStatus = exports.insurance_changeInsurance = exports.insurance_returnInsurance = exports.insurance_disagreeInsurance = exports.insurance_agreeInsurance = exports.insurance_getContractInsuranceDetail = exports.insurance_getProjectInfo = exports.insurance_getInsuranceCategoryRateOps = exports.insurance_getInsurancePurchaseWayOps = exports.insurance_getInsuranceCategoryOps = exports.insurance_edit = exports.insurance_purchaseContractInsurance = exports.insurance_delete = exports.insurance_get_excel = exports.insurance_get_CID_Page = exports.insurance_list = exports.insurance_saveContractInsurance = exports.contractInfo_secondSubmitContract = exports.contractInfo_secondSaveContract = exports.contractInfo_changeContract = exports.contractInfo_submitContract = exports.contractInfo_saveContract = exports.contractInfo_returnContract = exports.contractInfo_disagreeContract = exports.contractInfo_agreeContract = exports.projectDocDir_getProjectDocDirTitle = exports.contractInfo_get_taxCatValue = exports.contractInfo_export_Excel = exports.contractInfo_upload_files = exports.finance_income_check_effective = exports.contractInfo_old_contractInfo = exports.contractInfo_getAuditStatus = exports.contractInfo_saveInvoiceAmount = exports.contractInfo_upload_attach = exports.contractInfo_getInsuranceCats = exports.contractInfo_update_finance = exports.contractInfo_update_operate = exports.contractInfo_getMainContractNo = exports.contractInfo_getSonContractNo = exports.contractInfo_findByContractNo = exports.contractInfo_toexamine = exports.contractInfo_getAllMainContractionInfo = exports.contractInfo_do_audit = exports.contractInfo_save_draft = exports.contractInfo_delById = exports.contractInfo_findById = undefined;
exports.contractInfo_updateById = exports.contractInfo_all_ok_page_type = exports.contractInfo_all_ok_page = exports.contractInfo_valid_page = exports.contractInfo_getPages = exports.contractInfo_getContractPages = exports.deleteRegisterPlatformReport = exports.updateRegisterPlatformReport = exports.addRegisterPlatformReport = exports.customer_shiftBlack = exports.updateRegisterPlatform = exports.getRegisterPlatformDetail = exports.addRegisterPlatform = exports.getRegisterPlatformList = exports.deleteCustomerMarket = exports.deleteCustomerContact = exports.deleteCustomerIssue = exports.customer_Contact = exports.customer_issue = exports.insertOrUpdateCustomerMarket = exports.customer_shareholder = exports.customer_findByProjectId = exports.customer_delete_by_id = exports.customer_save1 = exports.customer_save = exports.customer_findById = exports.customer_page_data_ui = exports.customer_page_data = exports.company_getAll = exports.company_page_data = exports.company_delById = exports.company_updateById = exports.company_addCompany = exports.company_findCompanyInfoById = exports.company_findById = exports.company_getCompanyPages = exports.pMSubTeam_delById = exports.pMSubTeam_findById = exports.pMSubTeam_get_page = exports.pMSubTeam_save = exports.introducer_getAllUserByIntroducer = exports.introducer_page_data = exports.introducer_delete_by_id = exports.introducer_findTeamTwoById = exports.introducer_findTeamOneById = exports.introducer_getPage = exports.introducer_findRelationByIdForCommission = exports.introducer_findRelationById = exports.introducer_findIntroducerBriefInfoById = exports.introducer_findInfoById = exports.introducer_find_by_id = exports.introducer_update_by_id = exports.introducer_add_introducer = exports.introducer_create_new = exports.proManager_getProjectByPmIdAndStatus = exports.proManager_getProjectManagerInfo = exports.proManager_interview_getDataByPM = exports.proManager_interview_findbyPmId = exports.proManager_interview_submit = exports.proManager_interview_save = exports.proManager_findProjectManagerByCm = exports.proManager_interview_leaderEvaluation = exports.proManager_interview_findbyId = exports.proManager_interview_page_data = exports.updatePmFreezeAndUnfreeze = exports.proManager_getPmFreezePage = exports.proManager_saveOrUpdateByTemp = exports.proManager_cancelMonitorById = exports.proManager_deletePMIssueById = exports.proManager_addProjectManagerIssue = exports.proManager_getPMBySearchCondition = exports.addProjectManagerOfSimple = exports.proManager_deleteSalesList = exports.proManager_getSalesList = exports.proManager_saveOrUpdateSales = exports.financePay_getAdvanceTaxInfo = exports.financePay_statisticalAdvanceTaxList = exports.financePay_editLeagueDeposit = exports.financePay_leagueDepositPage = exports.proManager_saveBankData = exports.proManager_findByPhone = exports.proManager_partyInfoFullCom = exports.proManager_partyInfoFullPre = exports.proManager_projectManager_deleteDraftPMById = exports.proManager_projectManager_updateApplayAudit = exports.proManager_projectManager_updateApply = exports.proManager_projectManager_updateMoreInfo = exports.proManager_projectManager_getMoreInfo = exports.proManager_projectManager_findPMInfoById = exports.proManager_projectManager_findPMById = exports.proManager_projectManagerStatus_change = exports.approval_add_update = exports.proManager_updateProjectManagerBusiness = exports.proManager_auditProjectManager = exports.proManager_projectManager_update = exports.proManager_projectManager_save = exports.get_pm_page_data = exports.pm_page_data = exports.proManager_getUpdateApplayProcess = exports.proManager_getProjectManagerPages4UpdateApply = undefined;
exports.proManager_getPMPagesByCmDirectorAudit = exports.getPMPagesByManage = exports.proManager_getPMPagesByBmAudit = exports.proManager_getAuditStatusCode = exports.proManager_getProjectManagerPages = exports.proManager_getPersonalInfo = exports.proManager_updatePersonalInfo = exports.rewardsPunish_delRPById = exports.rewardsPunish_findRPById = exports.rewardsPunish_page_data = exports.cusManager_getPMBlacklistsPages = exports.cusManager_blacklistsStatus = exports.cusManager_getPMPages = exports.cusManager_getContractPages = exports.cusManager_getFinancePages = exports.cusManager_findFIById = exports.cusManager_updateFinance = exports.cusManager_addPersonalInfo = exports.cusManager_getPersonalInfo = exports.file_delete_attach = exports.file_get_attach_list = exports.common_delete_attach = exports.common_get_attach_list = exports.common_upload_image = exports.receivable_upload_file_save = exports.receivable_upload_file = exports.download_file = exports.upload_file = exports.get_all_project = exports.district_insert = exports.district_delById = exports.district_updateById = exports.districtData = exports.engineer_addEngineerCat = exports.engineer_delById = exports.engineer_updateById = exports.engineerList = exports.fee_edit_update = exports.fee_edit_find = exports.fee_history = exports.fee_application = exports.customerIntention_assigningPm = exports.customerIntention_assigningCm = exports.getIntentionLinkmanList = exports.customerIntention_sys_cm = exports.getCustomerIntentionInfoById = exports.getCustomerIntentionPage = exports.addCustomerIntention = exports.contract_getChageContractAuditStatusAndOwn = exports.contract_change_delete = exports.contract_getChageContractAuditStatus = exports.projct_change_commonList = exports.projct_change_CMlist = exports.contract_do_audit = exports.contract_save_draft = exports.contract_getMainContractNo = exports.contract_find_change_type = exports.projct_change_add = exports.projct_change_choose = exports.project_deleteLoseByBizItemId = exports.project_restartProjectLoseApply = exports.getSealApplyListByProject = exports.getProjectCertifiedPersonnel = exports.getBuildingProjectPhase = exports.getProcessLogEcho = exports.getWithProjectPhase = exports.update_project_status = exports.processLog_addInfo = exports.processLog_getAll = exports.processLog_delById = exports.processLog_updateById = exports.processLog_findById = exports.project_lose_order_report = exports.project_follow_type = exports.project_lose_apply = exports.casualtyReport_deleteInsuranceClaim = exports.casualtyReport_restartCasualtyApply = exports.get_enum_data_phase = exports.insurance_getPreviousInfo = exports.casualtyReport_getInsuranceClaimByProjectId = exports.casualtyReport_getInsurancePage = exports.casualtyReport_saveCasualtyReport = exports.casualtyReport_delete = exports.casualtyReport_deal = exports.casualtyReport_change = exports.casualtyReport_return = exports.casualtyReport_disagree = exports.casualtyReport_agree = exports.casualtyReport_getPMCasualtyReport = exports.casualtyReport_addInsuranceClaim = exports.casualtyReport_updateCasualtyRepor = exports.casualtyReport_doAudit = exports.casualtyReport_addCasualtyReport = exports.project_getCasualtyReportPro = exports.getCasualtyApplyInfo = exports.casualtyReport_getProject = exports.casualtyReport_getAllPage = exports.project_getProjectScheduleInfo = exports.project_Lightspot_update = exports.project_Lightspot_list = undefined;
exports.project_updateById = exports.project_loss_findByBizItemId = exports.update_project_info = exports.project_findByBizItemId = exports.project_findById = exports.prodetailedinfo_delById = exports.prodetailedinfo_findById = exports.prodetailedinfo_fileList = exports.prodetailedinfo_findByProId = exports.prodetailedinfo_addInfo = exports.project_delById = exports.project_finish_audit = exports.project_finish_status = exports.project_confirm_status = exports.project_contract_index = exports.new_project_submit = exports.attachRelevanceProjectPreparation = exports.new_project_save = exports.project_revised = exports.project_query_list = exports.project_auto_check_duplicate = exports.project_add_check_duplicate = exports.project_manul_check_duplicate = exports.project_get_finish_page = exports.project_get_finish_wait_page = exports.project_get_working_receivable_page = exports.project_get_working_page = exports.project_get_canCashProjectDetail = exports.project_get_duplicate_page = exports.project_get_wait_page = exports.project_get_valid_page = exports.project_get_processed_page = exports.project_get_draft_page = exports.project_send_comfirm = exports.project_save = exports.subCom_deleteBank = exports.subCom_getPageBankAccountByAccount = exports.subCom_getBankAccountByAccount = exports.subCom_getCompanyBankPage = exports.subCom_saveBankData = exports.subCom_subCom_add_required = exports.subCom_findById = exports.get_all_company = exports.subCom_getPages = exports.subCom_update = exports.subCom_del = exports.subCom_save_data = exports.getAllEnumData = exports.get_financeManage = exports.get_getEnumDataByLabel = exports.get_projectDirDocStatusList = exports.get_ex_enumData = exports.get_all_enum_data_map = exports.introducer_commission_export = exports.terminationProjectList = exports.terminationProject = exports.addSysAllowanceAbortProject = exports.getNoAbortContractPage = exports.exportSysAllowanceAbortContractPage = exports.getPMByNoCommissionList = exports.getSysAllowanceAbortContractPage = exports.getExceptionContractById = exports.getIntroducerTeamDetail = exports.getIntroducerCommissionInfo = exports.exportIntroducerCommissionData = exports.getIntroducerSearchByNameList = exports.getIntroducerCommissionPage = exports.finance_income_save_billing_balance = exports.index_data_finance_remark = exports.index_data_finance_detail_excel = exports.manualDeductionInfo = exports.manual_deduct_calcItem = exports.index_data_summary_calculate = exports.get_contract_attach = exports.report_finance_statistics_summary_information = exports.apply_delSettlementPayInfo = exports.index_data_finance_detail = exports.index_data_finance_info_supervision = exports.index_data_finance_info = exports.index_data_finance_statistics_summary_excel = exports.index_data_finance_statistics_excel = exports.index_data_finance_statistics = exports.internal_commission_by_project_export = exports.internal_commission_by_customer_export = exports.customer_commission_export = exports.index_data_contract_excel_new = exports.index_data_contract_excel = exports.index_data_save_remark = exports.index_data_contract_outline_info_new = exports.index_data_contract_outline_info = exports.index_data_contract_outline_new = exports.index_data_contract_outline = exports.index_data_list = exports.index_data_total = exports.index_data_today = exports.enum_data_getPMCooperatesCatEnum = exports.enum_data_getPMGetMoneyCatsEnum = exports.enum_data_getTaxCatsEnum = exports.userBank_deleteUserBank = exports.bankAccount_getByAccount = undefined;
exports.bankAccount_deleteData = exports.bankAccount_saveData = exports.bankAccount_userDataPage = exports.bankNameData_getAll = exports.bankNameData_delete = exports.bankNameData_save = exports.bankNameData_get_by_id = exports.bankNameData_data = exports.zhoty_credit_pay_status = exports.all_enum_data = exports.dispatch_status_channel = exports.import_status_channel = exports.xmcom_list = exports.status_option_list = exports.find_company_nature_type = exports.find_register_platform_type = exports.flow_review = exports.getAuditObjectByBizItemId = exports.getAuditObjectByItemCode = exports.enum_data_type = exports.enum_data_get_by_catId = exports.enum_data_move = exports.enum_data_delete = exports.enum_data_disabled = exports.enum_data_save = exports.enum_data_get_by_id = exports.enum_data_page_data = exports.enum_cat_delete = exports.enum_cat_save = exports.enum_cat_get_by_id = exports.enum_cat_page_data = exports.me_change_password = exports.back_useRcm_page_data = exports.back_user_project_list = exports.back_user_pm_list = exports.back_user_cmInfo = exports.back_user_save_pm = exports.back_user_page_pm_data = exports.back_user_getAll = exports.back_user_context_data = exports.back_user_toggle_status = exports.back_user_save = exports.back_user_get_by_id = exports.back_user_page_data = exports.bill_material_uploadExcelBillMaterials_save = exports.bill_material_uploadExcelBill_check = exports.enum_data_find_insurance_labor_ins = exports.enum_data_find_insurance_labor_company = exports.wx_remove_info = exports.wx_user_info = exports.wx_auto_login = exports.wx_user_login = exports.exist_phone_account = exports.checkCaptcha = exports.captcha = exports.token_login_info = exports.scan_poll = exports.wxlogin_qrcode = exports.wx_login_code = exports.login_by_code = exports.login_code = exports.reset_pwd = exports.mock_income_test = exports.user_logout = exports.user_login = exports.enum_switchPaddles = exports.cooperation_view = exports.cooperation_del = exports.cooperation_list = exports.cooperation_type = exports.cooperation_add = exports.contractInfo_updateProjectDocDirTitle = exports.customer_getCmList = exports.projectManagement_getCmList = exports.new_upload_attach = exports.contractInfo_new_upload_attach = exports.apply_addUploadAttachAgain = exports.contractInfo_editContractRemark = exports.introducer_editIntroducer = exports.introducer_pm_noneIntroducer_page = exports.introducer_changeIntroducer = exports.projectManagement_receipt_project_export = exports.projectManagement_distribute_project_export = exports.projectManagement_receipt_project_page = exports.projectManagement_distribute_project_page = exports.projectManagement_receipt_project = exports.projectManagement_distribute_project = exports.projectManagement_updateTemplateId = exports.sys_getSelectBtnByRole = exports.back_user_back_user_export = exports.sysMeun_getSelectMeunByRole = exports.sysRole_delSysRole = exports.sysRole_getSysRoleByOrg = exports.sysMeun_meun = exports.sysRole_saveSysRole = exports.sys_getSysRole = exports.sys_roleList = exports.sysOrg_delSysOrg = exports.sysOrg_saveSysOrg = exports.sysOrg_getSysOrg = undefined;

var _EnvConfig = __webpack_require__(858);

var sysOrg_getSysOrg = exports.sysOrg_getSysOrg = _EnvConfig.app_server + '/sysOrg/getSysOrg';var sysOrg_saveSysOrg = exports.sysOrg_saveSysOrg = _EnvConfig.app_server + '/sysOrg/saveSysOrg';var sysOrg_delSysOrg = exports.sysOrg_delSysOrg = _EnvConfig.app_server + '/sysOrg/delSysOrg';var sys_roleList = exports.sys_roleList = _EnvConfig.app_server + '/sys/roleList';var sys_getSysRole = exports.sys_getSysRole = _EnvConfig.app_server + '/sys/getSysRole';
var sysRole_saveSysRole = exports.sysRole_saveSysRole = _EnvConfig.app_server + '/sysRole/saveSysRole';var sysMeun_meun = exports.sysMeun_meun = _EnvConfig.app_server + '/sysMeun/meun';var sysRole_getSysRoleByOrg = exports.sysRole_getSysRoleByOrg = _EnvConfig.app_server + '/sysRole/getSysRoleByOrg';var sysRole_delSysRole = exports.sysRole_delSysRole = _EnvConfig.app_server + '/sysRole/delSysRole';var sysMeun_getSelectMeunByRole = exports.sysMeun_getSelectMeunByRole = _EnvConfig.app_server + '/sysMeun/getSelectMeunByRole';var back_user_back_user_export = exports.back_user_back_user_export = _EnvConfig.app_server + '/back_user/back_user_export';var sys_getSelectBtnByRole = exports.sys_getSelectBtnByRole = _EnvConfig.app_server + '/sysMeun/getSelectBtnByRole';var projectManagement_updateTemplateId = exports.projectManagement_updateTemplateId = _EnvConfig.app_server + '/projectManagement/updateTemplateId';var projectManagement_distribute_project = exports.projectManagement_distribute_project = _EnvConfig.app_server + '/projectManagement/distribute_project';var projectManagement_receipt_project = exports.projectManagement_receipt_project = _EnvConfig.app_server + '/projectManagement/receipt_project';var projectManagement_distribute_project_page = exports.projectManagement_distribute_project_page = _EnvConfig.app_server + '/projectManagement/distribute_project_page';var projectManagement_receipt_project_page = exports.projectManagement_receipt_project_page = _EnvConfig.app_server + '/projectManagement/receipt_project_page';
var projectManagement_distribute_project_export = exports.projectManagement_distribute_project_export = _EnvConfig.app_server + '/projectManagement/distribute_project_export';var projectManagement_receipt_project_export = exports.projectManagement_receipt_project_export = _EnvConfig.app_server + '/projectManagement/receipt_project_export';var introducer_changeIntroducer = exports.introducer_changeIntroducer = _EnvConfig.app_server + '/introducer/changeIntroducer';var introducer_pm_noneIntroducer_page = exports.introducer_pm_noneIntroducer_page = _EnvConfig.app_server + '/introducer/pm_noneIntroducer_page';var introducer_editIntroducer = exports.introducer_editIntroducer = _EnvConfig.app_server + '/introducer/editIntroducer';var contractInfo_editContractRemark = exports.contractInfo_editContractRemark = _EnvConfig.app_server + '/contractInfo/editContractRemark';

var apply_addUploadAttachAgain = exports.apply_addUploadAttachAgain = _EnvConfig.app_server + '/apply/addUploadAttachAgain';

var contractInfo_new_upload_attach = exports.contractInfo_new_upload_attach = _EnvConfig.app_server + '/contractInfo/new_upload_attach';var new_upload_attach = exports.new_upload_attach = _EnvConfig.app_server + '/attach/new_upload_attach';var projectManagement_getCmList = exports.projectManagement_getCmList = _EnvConfig.app_server + '/projectManagement/getCmList';var customer_getCmList = exports.customer_getCmList = _EnvConfig.app_server + '/customer/getCreateUserId';var contractInfo_updateProjectDocDirTitle = exports.contractInfo_updateProjectDocDirTitle = _EnvConfig.app_server + '/contractInfo/updateProjectDocDirTitle';var cooperation_add = exports.cooperation_add = _EnvConfig.app_server + '/customerCooperation/addOrUpdate';var cooperation_type = exports.cooperation_type = _EnvConfig.app_server + '/customerCooperation/getCreateUserId';var cooperation_list = exports.cooperation_list = _EnvConfig.app_server + '/customerCooperation/getPagesUI';var cooperation_del = exports.cooperation_del = _EnvConfig.app_server + '/customerCooperation/deleteCustomerCooperationShareholder';var cooperation_view = exports.cooperation_view = _EnvConfig.app_server + '/customerCooperation/findById';var enum_switchPaddles = exports.enum_switchPaddles = _EnvConfig.app_server + '/enum_data/switchPaddles';

var user_login = exports.user_login = _EnvConfig.app_server + '/login';
var user_logout = exports.user_logout = _EnvConfig.app_server + '/logout';
var mock_income_test = exports.mock_income_test = _EnvConfig.app_server + '/project_income/mock_test';
var reset_pwd = exports.reset_pwd = _EnvConfig.app_server + '/reset_password';
var login_code = exports.login_code = _EnvConfig.app_server + '/sendLoginSmsCode';
var login_by_code = exports.login_by_code = _EnvConfig.app_server + '/loginByPhone';
var wx_login_code = exports.wx_login_code = _EnvConfig.app_server + '/wxLoginSmsCode';
var wxlogin_qrcode = exports.wxlogin_qrcode = _EnvConfig.app_server + '/wxlogin_qrcode';
var scan_poll = exports.scan_poll = _EnvConfig.app_server + '/scan_poll';
var token_login_info = exports.token_login_info = _EnvConfig.app_server + '/token_login_info';
var captcha = exports.captcha = _EnvConfig.app_server + '/captcha';
var checkCaptcha = exports.checkCaptcha = _EnvConfig.app_server + '/checkCaptcha';
var exist_phone_account = exports.exist_phone_account = _EnvConfig.app_server + '/forgotpwd/exist_phone_account';

var wx_user_login = exports.wx_user_login = _EnvConfig.app_server + '/wxPhoneLogin';
var wx_auto_login = exports.wx_auto_login = _EnvConfig.app_server + '/wxAutoLogin';
var wx_user_info = exports.wx_user_info = _EnvConfig.app_server + '/back_user/getBackUserInfo';
var wx_remove_info = exports.wx_remove_info = _EnvConfig.app_server + '/back_user/wxBindingLift';

var enum_data_find_insurance_labor_company = exports.enum_data_find_insurance_labor_company = _EnvConfig.app_server + '/customer/find_insurance_labor_labor';
var enum_data_find_insurance_labor_ins = exports.enum_data_find_insurance_labor_ins = _EnvConfig.app_server + '/customer/find_insurance_labor_ins';

var bill_material_uploadExcelBill_check = exports.bill_material_uploadExcelBill_check = _EnvConfig.app_server + '/bill_material/uploadExcelBill_check';
var bill_material_uploadExcelBillMaterials_save = exports.bill_material_uploadExcelBillMaterials_save = _EnvConfig.app_server + '/bill_material/uploadExcelBillMaterials_save';

var back_user_page_data = exports.back_user_page_data = _EnvConfig.app_server + '/back_user/page_data';
var back_user_get_by_id = exports.back_user_get_by_id = _EnvConfig.app_server + '/back_user/get';
var back_user_save = exports.back_user_save = _EnvConfig.app_server + '/back_user/save';
var back_user_toggle_status = exports.back_user_toggle_status = _EnvConfig.app_server + '/back_user/toggle_status';
var back_user_context_data = exports.back_user_context_data = _EnvConfig.app_server + '/back_user/context_data';var back_user_getAll = exports.back_user_getAll = _EnvConfig.app_server + '/back_user/getAll';
var back_user_page_pm_data = exports.back_user_page_pm_data = _EnvConfig.app_server + '/back_user/page_pm_data';var back_user_save_pm = exports.back_user_save_pm = _EnvConfig.app_server + '/back_user/save_pm';var back_user_cmInfo = exports.back_user_cmInfo = _EnvConfig.app_server + '/back_user/findCmInfo';var back_user_pm_list = exports.back_user_pm_list = _EnvConfig.app_server + '/back_user/findCmProjectManagerList';var back_user_project_list = exports.back_user_project_list = _EnvConfig.app_server + '/back_user/findCmProjectList';var back_useRcm_page_data = exports.back_useRcm_page_data = _EnvConfig.app_server + '/back_user/cm_page_data';
var me_change_password = exports.me_change_password = _EnvConfig.app_server + '/me/change_password';

var enum_cat_page_data = exports.enum_cat_page_data = _EnvConfig.app_server + '/enum_cat/page_data';
var enum_cat_get_by_id = exports.enum_cat_get_by_id = _EnvConfig.app_server + '/enum_cat/get';
var enum_cat_save = exports.enum_cat_save = _EnvConfig.app_server + '/enum_cat/save';
var enum_cat_delete = exports.enum_cat_delete = _EnvConfig.app_server + '/enum_cat/delete';

var enum_data_page_data = exports.enum_data_page_data = _EnvConfig.app_server + '/enum_data/page_data';
var enum_data_get_by_id = exports.enum_data_get_by_id = _EnvConfig.app_server + '/enum_data/get';
var enum_data_save = exports.enum_data_save = _EnvConfig.app_server + '/enum_data/save';
var enum_data_disabled = exports.enum_data_disabled = _EnvConfig.app_server + '/enum_data/disabled';
var enum_data_delete = exports.enum_data_delete = _EnvConfig.app_server + '/enum_data/delete';
var enum_data_move = exports.enum_data_move = _EnvConfig.app_server + '/enum_data/move';
var enum_data_get_by_catId = exports.enum_data_get_by_catId = _EnvConfig.app_server + '/enum_data/getEnumByCarId';
var enum_data_type = exports.enum_data_type = _EnvConfig.app_server + '/type_selection';
var getAuditObjectByItemCode = exports.getAuditObjectByItemCode = _EnvConfig.app_server + '/flow/getAuditObjectByItemCode';var getAuditObjectByBizItemId = exports.getAuditObjectByBizItemId = _EnvConfig.app_server + '/flow/getAuditObjectByBizItemId';var flow_review = exports.flow_review = _EnvConfig.app_server + '/flow/review';var find_register_platform_type = exports.find_register_platform_type = _EnvConfig.app_server + '/enum_data/find_register_platform_type';
var find_company_nature_type = exports.find_company_nature_type = _EnvConfig.app_server + '/enum_data/find_company_nature_type';
var status_option_list = exports.status_option_list = _EnvConfig.app_server + '/apply/getPaymentStatus';var xmcom_list = exports.xmcom_list = _EnvConfig.app_server + '/subsidiaryCompany/getCompanyList';var import_status_channel = exports.import_status_channel = _EnvConfig.app_server + '/applyData/getImportStatus';var dispatch_status_channel = exports.dispatch_status_channel = _EnvConfig.app_server + '/projectManagement/getDispatchType';var all_enum_data = exports.all_enum_data = _EnvConfig.app_server + '/project/getAllEnumData';var zhoty_credit_pay_status = exports.zhoty_credit_pay_status = _EnvConfig.app_server + '/credit/getZhotyCreditPayStatusCats';var bankNameData_data = exports.bankNameData_data = _EnvConfig.app_server + '/bankName_data/page_data';
var bankNameData_get_by_id = exports.bankNameData_get_by_id = _EnvConfig.app_server + '/bankName_data/get';
var bankNameData_save = exports.bankNameData_save = _EnvConfig.app_server + '/bankName_data/save';
var bankNameData_delete = exports.bankNameData_delete = _EnvConfig.app_server + '/bankName_data/delete';
var bankNameData_getAll = exports.bankNameData_getAll = _EnvConfig.app_server + '/bankName_data/getAll';
var bankAccount_userDataPage = exports.bankAccount_userDataPage = _EnvConfig.app_server + '/bankAccount/userDataPage';
var bankAccount_saveData = exports.bankAccount_saveData = _EnvConfig.app_server + '/bankAccount/saveData';
var bankAccount_deleteData = exports.bankAccount_deleteData = _EnvConfig.app_server + '/bankAccount/deleteData';
var bankAccount_getByAccount = exports.bankAccount_getByAccount = _EnvConfig.app_server + '/bankAccount/getByAccount';
var userBank_deleteUserBank = exports.userBank_deleteUserBank = _EnvConfig.app_server + '/userBank/deleteUserBank';

var enum_data_getTaxCatsEnum = exports.enum_data_getTaxCatsEnum = _EnvConfig.app_server + '/enum_data/getTaxCatsEnum';
var enum_data_getPMGetMoneyCatsEnum = exports.enum_data_getPMGetMoneyCatsEnum = _EnvConfig.app_server + '/enum_data/getPMGetMoneyCatsEnum';
var enum_data_getPMCooperatesCatEnum = exports.enum_data_getPMCooperatesCatEnum = _EnvConfig.app_server + '/enum_data/getPMCooperatesCatEnum';

var index_data_today = exports.index_data_today = _EnvConfig.app_server + '/report/project_financial_statistical_today';var index_data_total = exports.index_data_total = _EnvConfig.app_server + '/report/project_financial_statistical_total';var index_data_list = exports.index_data_list = _EnvConfig.app_server + '/report/project_financial_statistical_List';var index_data_contract_outline = exports.index_data_contract_outline = _EnvConfig.app_server + '/report/contract_outline';var index_data_contract_outline_new = exports.index_data_contract_outline_new = _EnvConfig.app_server + '/report/contract_outline_new';var index_data_contract_outline_info = exports.index_data_contract_outline_info = _EnvConfig.app_server + '/report/contract_outline_info';var index_data_contract_outline_info_new = exports.index_data_contract_outline_info_new = _EnvConfig.app_server + '/report/contract_outline_info_new';var index_data_save_remark = exports.index_data_save_remark = _EnvConfig.app_server + '/contractInfo/save_export_remarks';var index_data_contract_excel = exports.index_data_contract_excel = _EnvConfig.app_server + '/report/contract_outline_excel';var index_data_contract_excel_new = exports.index_data_contract_excel_new = _EnvConfig.app_server + '/report/contract_outline_excel_new';var customer_commission_export = exports.customer_commission_export = _EnvConfig.app_server + '/sysAllowanceDetail/exportSysAllowanceByCM';var internal_commission_by_customer_export = exports.internal_commission_by_customer_export = _EnvConfig.app_server + '/internalCommissionFile/internalCommissionByCustomer';var internal_commission_by_project_export = exports.internal_commission_by_project_export = _EnvConfig.app_server + '/internalCommissionFile/internalCommissionByProject';var index_data_finance_statistics = exports.index_data_finance_statistics = _EnvConfig.app_server + '/report/finance_statistics';var index_data_finance_statistics_excel = exports.index_data_finance_statistics_excel = _EnvConfig.app_server + '/report/finance_statistics_excel';var index_data_finance_statistics_summary_excel = exports.index_data_finance_statistics_summary_excel = _EnvConfig.app_server + '/report/finance_statistics_summary_excel';var index_data_finance_info = exports.index_data_finance_info = _EnvConfig.app_server + '/report/finance_statistics_summary_info';var index_data_finance_info_supervision = exports.index_data_finance_info_supervision = _EnvConfig.app_server + '/report/finance_statistics_summary_info_supervision';var index_data_finance_detail = exports.index_data_finance_detail = _EnvConfig.app_server + '/report/finance_statistics_detailed_info';var apply_delSettlementPayInfo = exports.apply_delSettlementPayInfo = _EnvConfig.app_server + '/apply/delSettlementPayInfo';var report_finance_statistics_summary_information = exports.report_finance_statistics_summary_information = _EnvConfig.app_server + '/report/finance_statistics_summary_information';var get_contract_attach = exports.get_contract_attach = _EnvConfig.app_server + '/sealApply/getContractApplyAttach';var index_data_summary_calculate = exports.index_data_summary_calculate = _EnvConfig.app_server + '/financial_calc/summary_calculate';var manual_deduct_calcItem = exports.manual_deduct_calcItem = _EnvConfig.app_server + '/financial_calc/manual_deduct_calcItem';var manualDeductionInfo = exports.manualDeductionInfo = _EnvConfig.app_server + '/financePay/manualDeductionInfo';var index_data_finance_detail_excel = exports.index_data_finance_detail_excel = _EnvConfig.app_server + '/report/finance_statistics_detailed_info_excel';var index_data_finance_remark = exports.index_data_finance_remark = _EnvConfig.app_server + '/report/save_project_export_remark';var finance_income_save_billing_balance = exports.finance_income_save_billing_balance = _EnvConfig.app_server + '/finance_income/save_billing_balance';var getIntroducerCommissionPage = exports.getIntroducerCommissionPage = _EnvConfig.app_server + '/commission/getIntroducerCommissionPage';var getIntroducerSearchByNameList = exports.getIntroducerSearchByNameList = _EnvConfig.app_server + '/commission/getIntroducerSearchByNameList';var exportIntroducerCommissionData = exports.exportIntroducerCommissionData = _EnvConfig.app_server + '/commission/exportIntroducerCommissionData';var getIntroducerCommissionInfo = exports.getIntroducerCommissionInfo = _EnvConfig.app_server + '/commission/getIntroducerCommissionInfo';var getIntroducerTeamDetail = exports.getIntroducerTeamDetail = _EnvConfig.app_server + '/teamCommission/getIntroducerTeamDetail';var getExceptionContractById = exports.getExceptionContractById = _EnvConfig.app_server + '/teamCommission/getExceptionContractById';var getSysAllowanceAbortContractPage = exports.getSysAllowanceAbortContractPage = _EnvConfig.app_server + '/sysAllowanceAbort/getSysAllowanceAbortContractPage';var getPMByNoCommissionList = exports.getPMByNoCommissionList = _EnvConfig.app_server + '/sysAllowanceAbort/getPMByNoCommissionList';var exportSysAllowanceAbortContractPage = exports.exportSysAllowanceAbortContractPage = _EnvConfig.app_server + '/sysAllowanceAbort/exportSysAllowanceAbortContractPage';var getNoAbortContractPage = exports.getNoAbortContractPage = _EnvConfig.app_server + '/sysAllowanceAbort/getNoAbortContractPage';var addSysAllowanceAbortProject = exports.addSysAllowanceAbortProject = _EnvConfig.app_server + '/sysAllowanceAbort/addSysAllowanceAbortProject';var terminationProject = exports.terminationProject = _EnvConfig.app_server + '/project/terminationContractInfo';var terminationProjectList = exports.terminationProjectList = _EnvConfig.app_server + '/report/terminationContractInfo';var introducer_commission_export = exports.introducer_commission_export = _EnvConfig.app_server + '/commission/exportIntroducerCommissionProjectInfo';var get_all_enum_data_map = exports.get_all_enum_data_map = _EnvConfig.app_server + '/data_cache/all_enum_data';
var get_ex_enumData = exports.get_ex_enumData = _EnvConfig.app_server + '/report/getExEnumData';
var get_projectDirDocStatusList = exports.get_projectDirDocStatusList = _EnvConfig.app_server + '/project/getProjectDirDocStatusCats';var get_getEnumDataByLabel = exports.get_getEnumDataByLabel = _EnvConfig.app_server + '/enum_data/getEnumDataByLabel';var get_financeManage = exports.get_financeManage = _EnvConfig.app_server + '/back_user/getFinanceManage';var getAllEnumData = exports.getAllEnumData = _EnvConfig.app_server + '/report/getAllEnumData';var subCom_save_data = exports.subCom_save_data = _EnvConfig.app_server + '/subsidiaryCompany/save_data';var subCom_del = exports.subCom_del = _EnvConfig.app_server + '/subsidiaryCompany/delById';var subCom_update = exports.subCom_update = _EnvConfig.app_server + '/subsidiaryCompany/updateById';var subCom_getPages = exports.subCom_getPages = _EnvConfig.app_server + '/subsidiaryCompany/getPages';var get_all_company = exports.get_all_company = _EnvConfig.app_server + '/subsidiaryCompany/getAll';
var subCom_findById = exports.subCom_findById = _EnvConfig.app_server + '/subsidiaryCompany/findById';
var subCom_subCom_add_required = exports.subCom_subCom_add_required = _EnvConfig.app_server + '/subsidiaryCompany/addSubComRequired';

var subCom_saveBankData = exports.subCom_saveBankData = _EnvConfig.app_server + '/subsidiaryCompany/saveBankData';
var subCom_getCompanyBankPage = exports.subCom_getCompanyBankPage = _EnvConfig.app_server + '/subsidiaryCompany/getCompanyBankPage';
var subCom_getBankAccountByAccount = exports.subCom_getBankAccountByAccount = _EnvConfig.app_server + '/subsidiaryCompany/getBankAccountByAccount';var subCom_getPageBankAccountByAccount = exports.subCom_getPageBankAccountByAccount = _EnvConfig.app_server + '/subsidiaryCompany/getPageBankAccountByAccount';var subCom_deleteBank = exports.subCom_deleteBank = _EnvConfig.app_server + '/subsidiaryCompany/deleteBank';

var project_save = exports.project_save = _EnvConfig.app_server + '/project/save';
var project_send_comfirm = exports.project_send_comfirm = _EnvConfig.app_server + '/project/send_confirm';
var project_get_draft_page = exports.project_get_draft_page = _EnvConfig.app_server + '/project/get_draft_page';
var project_get_processed_page = exports.project_get_processed_page = _EnvConfig.app_server + '/project/getProcessedProjectPage';
var project_get_valid_page = exports.project_get_valid_page = _EnvConfig.app_server + '/project/valid_page';
var project_get_wait_page = exports.project_get_wait_page = _EnvConfig.app_server + '/project/get_wait_page';
var project_get_duplicate_page = exports.project_get_duplicate_page = _EnvConfig.app_server + '/project/duplicate_page';
var project_get_canCashProjectDetail = exports.project_get_canCashProjectDetail = _EnvConfig.app_server + '/project/getCanCashProjectDetail';var project_get_working_page = exports.project_get_working_page = _EnvConfig.app_server + '/project/working_page';
var project_get_working_receivable_page = exports.project_get_working_receivable_page = _EnvConfig.app_server + '/project/working_receivable_page';var project_get_finish_wait_page = exports.project_get_finish_wait_page = _EnvConfig.app_server + '/project/finish_wait_page';
var project_get_finish_page = exports.project_get_finish_page = _EnvConfig.app_server + '/project/finish_page';
var project_manul_check_duplicate = exports.project_manul_check_duplicate = _EnvConfig.app_server + '/project/manul_check_duplicate';
var project_add_check_duplicate = exports.project_add_check_duplicate = _EnvConfig.app_server + '/project/add_check_duplicate';
var project_auto_check_duplicate = exports.project_auto_check_duplicate = _EnvConfig.app_server + '/project/auto_check_duplicate';
var project_query_list = exports.project_query_list = _EnvConfig.app_server + '/project/searchProjectList';var project_revised = exports.project_revised = _EnvConfig.app_server + '/project/revisedProject';var new_project_save = exports.new_project_save = _EnvConfig.app_server + '/project/saveProject';
var attachRelevanceProjectPreparation = exports.attachRelevanceProjectPreparation = _EnvConfig.app_server + '/project/attachRelevanceProjectPreparation';
var new_project_submit = exports.new_project_submit = _EnvConfig.app_server + '/project/submitProject';

var project_contract_index = exports.project_contract_index = _EnvConfig.app_server + '/project/contract_index';

var project_confirm_status = exports.project_confirm_status = _EnvConfig.app_server + '/project/confirm_status';
var project_finish_status = exports.project_finish_status = _EnvConfig.app_server + '/project/finish_status';
var project_finish_audit = exports.project_finish_audit = _EnvConfig.app_server + '/project/finishAudit';
var project_delById = exports.project_delById = _EnvConfig.app_server + '/project/delById';
var prodetailedinfo_addInfo = exports.prodetailedinfo_addInfo = _EnvConfig.app_server + '/prodetailedinfo/addInfo';
var prodetailedinfo_findByProId = exports.prodetailedinfo_findByProId = _EnvConfig.app_server + '/prodetailedinfo/findByProId';
var prodetailedinfo_fileList = exports.prodetailedinfo_fileList = _EnvConfig.app_server + '/prodetailedinfo/findByProIdAndType';
var prodetailedinfo_findById = exports.prodetailedinfo_findById = _EnvConfig.app_server + '/prodetailedinfo/findById';
var prodetailedinfo_delById = exports.prodetailedinfo_delById = _EnvConfig.app_server + '/prodetailedinfo/delById';
var project_findById = exports.project_findById = _EnvConfig.app_server + '/project/findById';
var project_findByBizItemId = exports.project_findByBizItemId = _EnvConfig.app_server + '/project/findByBizItemId';
var update_project_info = exports.update_project_info = _EnvConfig.app_server + '/project/updateProjectInfo';
var project_loss_findByBizItemId = exports.project_loss_findByBizItemId = _EnvConfig.app_server + '/project/findLoseByBizItemId';
var project_updateById = exports.project_updateById = _EnvConfig.app_server + '/project/updateById';
var project_Lightspot_list = exports.project_Lightspot_list = _EnvConfig.app_server + '/projectLightspot/getProjectLightspotByProjectId';var project_Lightspot_update = exports.project_Lightspot_update = _EnvConfig.app_server + '/projectLightspot/updateLatestByProjectId';var project_getProjectScheduleInfo = exports.project_getProjectScheduleInfo = _EnvConfig.app_server + '/project/getProjectScheduleInfo';var casualtyReport_getAllPage = exports.casualtyReport_getAllPage = _EnvConfig.app_server + '/casualtyReport/getAllPage';var casualtyReport_getProject = exports.casualtyReport_getProject = _EnvConfig.app_server + '/project/toCasualtyApply';var getCasualtyApplyInfo = exports.getCasualtyApplyInfo = _EnvConfig.app_server + '/casualtyReport/getCasualtyApplyInfo';var project_getCasualtyReportPro = exports.project_getCasualtyReportPro = _EnvConfig.app_server + '/project/getCasualtyReportPro';var casualtyReport_addCasualtyReport = exports.casualtyReport_addCasualtyReport = _EnvConfig.app_server + '/casualtyReport/addCasualtyReport';var casualtyReport_doAudit = exports.casualtyReport_doAudit = _EnvConfig.app_server + '/casualtyReport/reviewCasualtyReport';var casualtyReport_updateCasualtyRepor = exports.casualtyReport_updateCasualtyRepor = _EnvConfig.app_server + '/casualtyReport/updateCasualtyReport';var casualtyReport_addInsuranceClaim = exports.casualtyReport_addInsuranceClaim = _EnvConfig.app_server + '/insuranceClaim/addInsuranceClaim';var casualtyReport_getPMCasualtyReport = exports.casualtyReport_getPMCasualtyReport = _EnvConfig.app_server + '/casualtyReport/getPMCasualtyReport';var casualtyReport_agree = exports.casualtyReport_agree = _EnvConfig.app_server + '/casualtyReport/agreeCasualtyApply';var casualtyReport_disagree = exports.casualtyReport_disagree = _EnvConfig.app_server + '/casualtyReport/disagreeCasualtyApply';var casualtyReport_return = exports.casualtyReport_return = _EnvConfig.app_server + '/casualtyReport/returnCasualtyApply';var casualtyReport_change = exports.casualtyReport_change = _EnvConfig.app_server + '/casualtyReport/changeCasualtyApply';var casualtyReport_deal = exports.casualtyReport_deal = _EnvConfig.app_server + '/casualtyReport/dealCasualtyApply';var casualtyReport_delete = exports.casualtyReport_delete = _EnvConfig.app_server + '/casualtyReport/deleteCasualtyApply';var casualtyReport_saveCasualtyReport = exports.casualtyReport_saveCasualtyReport = _EnvConfig.app_server + '/casualtyReport/saveCasualtyReport';var casualtyReport_getInsurancePage = exports.casualtyReport_getInsurancePage = _EnvConfig.app_server + '/casualtyReport/getInsurancePage';var casualtyReport_getInsuranceClaimByProjectId = exports.casualtyReport_getInsuranceClaimByProjectId = _EnvConfig.app_server + '/casualtyReport/getInsuranceClaimByProjectId';var insurance_getPreviousInfo = exports.insurance_getPreviousInfo = _EnvConfig.app_server + '/insurance/getPreviousInfo';var get_enum_data_phase = exports.get_enum_data_phase = _EnvConfig.app_server + '/enum_data/getProjectPhase';

var casualtyReport_restartCasualtyApply = exports.casualtyReport_restartCasualtyApply = _EnvConfig.app_server + '/casualtyReport/restartCasualtyApply';var casualtyReport_deleteInsuranceClaim = exports.casualtyReport_deleteInsuranceClaim = _EnvConfig.app_server + '/casualtyReport/deleteInsuranceClaim';var project_lose_apply = exports.project_lose_apply = _EnvConfig.app_server + '/project/lose_order_apply';var project_follow_type = exports.project_follow_type = _EnvConfig.app_server + '/project_follow_type';var project_lose_order_report = exports.project_lose_order_report = _EnvConfig.app_server + '/project/lose_order_report';var processLog_findById = exports.processLog_findById = _EnvConfig.app_server + '/processlog/findById';
var processLog_updateById = exports.processLog_updateById = _EnvConfig.app_server + '/processlog/updateById';
var processLog_delById = exports.processLog_delById = _EnvConfig.app_server + '/processlog/delById';
var processLog_getAll = exports.processLog_getAll = _EnvConfig.app_server + '/processlog/getAll';
var processLog_addInfo = exports.processLog_addInfo = _EnvConfig.app_server + '/processlog/addInfo';
var update_project_status = exports.update_project_status = _EnvConfig.app_server + '/report/getUpdateProjectStatus';var getWithProjectPhase = exports.getWithProjectPhase = _EnvConfig.app_server + '/processlog/getWithProjectPhase';
var getProcessLogEcho = exports.getProcessLogEcho = _EnvConfig.app_server + '/processlog/getProcessLogEcho';
var getBuildingProjectPhase = exports.getBuildingProjectPhase = _EnvConfig.app_server + '/processlog/getBuildingProjectPhase';

var getProjectCertifiedPersonnel = exports.getProjectCertifiedPersonnel = _EnvConfig.app_server + '/certificateApply/getProjectCertifiedPersonnel';var getSealApplyListByProject = exports.getSealApplyListByProject = _EnvConfig.app_server + '/sealApply/getSealApplyListByProject';var project_restartProjectLoseApply = exports.project_restartProjectLoseApply = _EnvConfig.app_server + '/project/restartProjectLoseApply';var project_deleteLoseByBizItemId = exports.project_deleteLoseByBizItemId = _EnvConfig.app_server + '/project/deleteLoseByBizItemId';var projct_change_choose = exports.projct_change_choose = _EnvConfig.app_server + '/project/project_change_working_page';var projct_change_add = exports.projct_change_add = _EnvConfig.app_server + '/project/project_change_info';var contract_find_change_type = exports.contract_find_change_type = _EnvConfig.app_server + '/enum_data/find_change_type';var contract_getMainContractNo = exports.contract_getMainContractNo = _EnvConfig.app_server + '/contractInfo/getMainContractNo';var contract_save_draft = exports.contract_save_draft = _EnvConfig.app_server + '/contractInfo/second_save_draft';var contract_do_audit = exports.contract_do_audit = _EnvConfig.app_server + '/contractInfo/do_audit';var projct_change_CMlist = exports.projct_change_CMlist = _EnvConfig.app_server + '/contractInfo/getChildrenPages';var projct_change_commonList = exports.projct_change_commonList = _EnvConfig.app_server + '/contractInfo/children_valid_page';var contract_getChageContractAuditStatus = exports.contract_getChageContractAuditStatus = _EnvConfig.app_server + '/contractInfo/getChageContractAuditStatus';var contract_change_delete = exports.contract_change_delete = _EnvConfig.app_server + '/contractInfo/delChangeContract';var contract_getChageContractAuditStatusAndOwn = exports.contract_getChageContractAuditStatusAndOwn = _EnvConfig.app_server + '/contractInfo/getChageContractAuditStatusAndOwn';var addCustomerIntention = exports.addCustomerIntention = _EnvConfig.app_server + '/customerIntention/addCustomerIntention';var getCustomerIntentionPage = exports.getCustomerIntentionPage = _EnvConfig.app_server + '/customerIntention/getCustomerIntentionPage';var getCustomerIntentionInfoById = exports.getCustomerIntentionInfoById = _EnvConfig.app_server + '/customerIntention/getCustomerIntentionInfoById';var customerIntention_sys_cm = exports.customerIntention_sys_cm = _EnvConfig.app_server + '/data/sys_cm';var getIntentionLinkmanList = exports.getIntentionLinkmanList = _EnvConfig.app_server + '/customerIntention/getIntentionLinkmanList';var customerIntention_assigningCm = exports.customerIntention_assigningCm = _EnvConfig.app_server + '/customerIntention/assigningCm';var customerIntention_assigningPm = exports.customerIntention_assigningPm = _EnvConfig.app_server + '/customerIntention/assigningPm';var fee_application = exports.fee_application = _EnvConfig.app_server + '/costapply/addCostApply';
var fee_history = exports.fee_history = _EnvConfig.app_server + '/costapply/getPages';
var fee_edit_find = exports.fee_edit_find = _EnvConfig.app_server + '/costapply/findById';
var fee_edit_update = exports.fee_edit_update = _EnvConfig.app_server + '/costapply/updateById';
var engineerList = exports.engineerList = _EnvConfig.app_server + '/engineerCat/engineerCatData';
var engineer_updateById = exports.engineer_updateById = _EnvConfig.app_server + '/engineerCat/updateById';
var engineer_delById = exports.engineer_delById = _EnvConfig.app_server + '/engineerCat/delById';
var engineer_addEngineerCat = exports.engineer_addEngineerCat = _EnvConfig.app_server + '/engineerCat/addEngineerCat';
var districtData = exports.districtData = _EnvConfig.app_server + "/districtData/list";
var district_updateById = exports.district_updateById = _EnvConfig.app_server + "/districtData/updateById";
var district_delById = exports.district_delById = _EnvConfig.app_server + "/districtData/delById";
var district_insert = exports.district_insert = _EnvConfig.app_server + "/districtData/insert";

var get_all_project = exports.get_all_project = _EnvConfig.app_server + '/project/getAll';

var upload_file = exports.upload_file = _EnvConfig.app_server + '/upload/ossupLoadImage';
var download_file = exports.download_file = _EnvConfig.app_server + '/download/ossupLoadImage';

var receivable_upload_file = exports.receivable_upload_file = _EnvConfig.app_server + '/finance_income/uploadExcelReceivable_check';var receivable_upload_file_save = exports.receivable_upload_file_save = _EnvConfig.app_server + '/finance_income/uploadExcelReceivable_save';var common_upload_image = exports.common_upload_image = _EnvConfig.app_server + '/common/upload_image';
var common_get_attach_list = exports.common_get_attach_list = _EnvConfig.app_server + '/common/get_attach_list';
var common_delete_attach = exports.common_delete_attach = _EnvConfig.app_server + '/common/delete_attach';

var file_get_attach_list = exports.file_get_attach_list = _EnvConfig.app_server + '/attach/get_attach_list';
var file_delete_attach = exports.file_delete_attach = _EnvConfig.app_server + '/attach/delete_attach';

var cusManager_getPersonalInfo = exports.cusManager_getPersonalInfo = _EnvConfig.app_server + '/cusManager/getPersonalInfo';
var cusManager_addPersonalInfo = exports.cusManager_addPersonalInfo = _EnvConfig.app_server + '/cusManager/savePersonalInfo';
var cusManager_updateFinance = exports.cusManager_updateFinance = _EnvConfig.app_server + '/cusManager/updateFinanceIncomeById';var cusManager_findFIById = exports.cusManager_findFIById = _EnvConfig.app_server + '/cusManager/findFIById';var cusManager_getFinancePages = exports.cusManager_getFinancePages = _EnvConfig.app_server + '/cusManager/getFinanceIncomePages';var cusManager_getContractPages = exports.cusManager_getContractPages = _EnvConfig.app_server + '/cusManager/getContractPageByNailLinkPer';var cusManager_getPMPages = exports.cusManager_getPMPages = _EnvConfig.app_server + '/cusManager/getPMPageByNailLinkPer';var cusManager_blacklistsStatus = exports.cusManager_blacklistsStatus = _EnvConfig.app_server + '/proManager/blacklistsStatus';var cusManager_getPMBlacklistsPages = exports.cusManager_getPMBlacklistsPages = _EnvConfig.app_server + '/proManager/getPMBlacklistsPages';var rewardsPunish_page_data = exports.rewardsPunish_page_data = _EnvConfig.app_server + '/rewardsPunish/getRPPages';
var rewardsPunish_findRPById = exports.rewardsPunish_findRPById = _EnvConfig.app_server + '/rewardsPunish/findRPById';
var rewardsPunish_delRPById = exports.rewardsPunish_delRPById = _EnvConfig.app_server + '/rewardsPunish/delRPById';

var proManager_updatePersonalInfo = exports.proManager_updatePersonalInfo = _EnvConfig.app_server + '/proManager/updatePersonalInfo';
var proManager_getPersonalInfo = exports.proManager_getPersonalInfo = _EnvConfig.app_server + '/proManager/getPersonalInfo';
var proManager_getProjectManagerPages = exports.proManager_getProjectManagerPages = _EnvConfig.app_server + '/proManager/getPMPages';
var proManager_getAuditStatusCode = exports.proManager_getAuditStatusCode = _EnvConfig.app_server + '/proManager/getAuditStatusCode';var proManager_getPMPagesByBmAudit = exports.proManager_getPMPagesByBmAudit = _EnvConfig.app_server + '/proManager/getPMPagesByBmAudit';var getPMPagesByManage = exports.getPMPagesByManage = _EnvConfig.app_server + '/proManager/getPMPagesByManage';
var proManager_getPMPagesByCmDirectorAudit = exports.proManager_getPMPagesByCmDirectorAudit = _EnvConfig.app_server + '/proManager/getPMPagesByCmDirectorAudit';var proManager_getProjectManagerPages4UpdateApply = exports.proManager_getProjectManagerPages4UpdateApply = _EnvConfig.app_server + '/proManager/getPMPages4UpdateApply';
var proManager_getUpdateApplayProcess = exports.proManager_getUpdateApplayProcess = _EnvConfig.app_server + '/proManager/getUpdateApplayProcess';
var pm_page_data = exports.pm_page_data = _EnvConfig.app_server + '/proManager/getPageData';var get_pm_page_data = exports.get_pm_page_data = _EnvConfig.app_server + '/proManager/getPmPageData';

var proManager_projectManager_save = exports.proManager_projectManager_save = _EnvConfig.app_server + '/proManager/addProjectManager';
var proManager_projectManager_update = exports.proManager_projectManager_update = _EnvConfig.app_server + '/proManager/updateProjectManager';
var proManager_auditProjectManager = exports.proManager_auditProjectManager = _EnvConfig.app_server + '/proManager/auditProjectManager';var proManager_updateProjectManagerBusiness = exports.proManager_updateProjectManagerBusiness = _EnvConfig.app_server + '/proManager/updateProjectManagerBusiness';
var approval_add_update = exports.approval_add_update = _EnvConfig.app_server + '/projectManager/addOrUpdate';

var proManager_projectManagerStatus_change = exports.proManager_projectManagerStatus_change = _EnvConfig.app_server + '/proManager/updateStatusById';
var proManager_projectManager_findPMById = exports.proManager_projectManager_findPMById = _EnvConfig.app_server + '/proManager/findPMById';var proManager_projectManager_findPMInfoById = exports.proManager_projectManager_findPMInfoById = _EnvConfig.app_server + '/proManager/findPMInfoById';var proManager_projectManager_getMoreInfo = exports.proManager_projectManager_getMoreInfo = _EnvConfig.app_server + '/proManager/getMoreInfo';
var proManager_projectManager_updateMoreInfo = exports.proManager_projectManager_updateMoreInfo = _EnvConfig.app_server + '/proManager/updateMoreInfo';
var proManager_projectManager_updateApply = exports.proManager_projectManager_updateApply = _EnvConfig.app_server + '/proManager/updateApply';var proManager_projectManager_updateApplayAudit = exports.proManager_projectManager_updateApplayAudit = _EnvConfig.app_server + '/proManager/updateApplyAudit';var proManager_projectManager_deleteDraftPMById = exports.proManager_projectManager_deleteDraftPMById = _EnvConfig.app_server + '/proManager/deleteDraftPMById';var proManager_partyInfoFullPre = exports.proManager_partyInfoFullPre = _EnvConfig.app_server + '/proManager/partyInfoFullPre';var proManager_partyInfoFullCom = exports.proManager_partyInfoFullCom = _EnvConfig.app_server + '/proManager/partyInfoFullCom';var proManager_findByPhone = exports.proManager_findByPhone = _EnvConfig.app_server + '/proManager/findByPhone';
var proManager_saveBankData = exports.proManager_saveBankData = _EnvConfig.app_server + '/proManager/saveBankData';
var financePay_leagueDepositPage = exports.financePay_leagueDepositPage = _EnvConfig.app_server + '/financePay/leagueDepositPage';var financePay_editLeagueDeposit = exports.financePay_editLeagueDeposit = _EnvConfig.app_server + '/financePay/editLeagueDeposit';var financePay_statisticalAdvanceTaxList = exports.financePay_statisticalAdvanceTaxList = _EnvConfig.app_server + '/financePay/statisticalAdvanceTaxList';var financePay_getAdvanceTaxInfo = exports.financePay_getAdvanceTaxInfo = _EnvConfig.app_server + '/advanceTax/getAdvanceTaxInfo';var proManager_saveOrUpdateSales = exports.proManager_saveOrUpdateSales = _EnvConfig.app_server + '/salePerformance/saveOrUpdateSalePerformance';var proManager_getSalesList = exports.proManager_getSalesList = _EnvConfig.app_server + '/salePerformance/getSalePerformance';var proManager_deleteSalesList = exports.proManager_deleteSalesList = _EnvConfig.app_server + '/salePerformance/deleteSalePerformance';var addProjectManagerOfSimple = exports.addProjectManagerOfSimple = _EnvConfig.app_server + '/proManager/addProjectManagerOfSimple';var proManager_getPMBySearchCondition = exports.proManager_getPMBySearchCondition = _EnvConfig.app_server + '/proManager/getPMBySearchCondition';var proManager_addProjectManagerIssue = exports.proManager_addProjectManagerIssue = _EnvConfig.app_server + '/projectManagerIssue/addProjectManagerIssue';var proManager_deletePMIssueById = exports.proManager_deletePMIssueById = _EnvConfig.app_server + '/projectManagerIssue/deletePMIssueById';var proManager_cancelMonitorById = exports.proManager_cancelMonitorById = _EnvConfig.app_server + '/projectManagerIssue/cancelMonitorById';var proManager_saveOrUpdateByTemp = exports.proManager_saveOrUpdateByTemp = _EnvConfig.app_server + '/interview/saveOrUpdateByTemp';var proManager_getPmFreezePage = exports.proManager_getPmFreezePage = _EnvConfig.app_server + '/proManager/getPmFreezePage';var updatePmFreezeAndUnfreeze = exports.updatePmFreezeAndUnfreeze = _EnvConfig.app_server + '/proManager/updatePmFreezeAndUnfreeze';var proManager_interview_page_data = exports.proManager_interview_page_data = _EnvConfig.app_server + '/interview/page_data';var proManager_interview_findbyId = exports.proManager_interview_findbyId = _EnvConfig.app_server + '/interview/findbyId';var proManager_interview_leaderEvaluation = exports.proManager_interview_leaderEvaluation = _EnvConfig.app_server + '/interview/leaderEvaluation';var proManager_findProjectManagerByCm = exports.proManager_findProjectManagerByCm = _EnvConfig.app_server + '/proManager/findProjectManagerByCm';var proManager_interview_save = exports.proManager_interview_save = _EnvConfig.app_server + '/interview/saveOrUpdate';var proManager_interview_submit = exports.proManager_interview_submit = _EnvConfig.app_server + '/interview/submit';var proManager_interview_findbyPmId = exports.proManager_interview_findbyPmId = _EnvConfig.app_server + '/interview/findbyPmId';var proManager_interview_getDataByPM = exports.proManager_interview_getDataByPM = _EnvConfig.app_server + '/interview/getDataByPM';var proManager_getProjectManagerInfo = exports.proManager_getProjectManagerInfo = _EnvConfig.app_server + '/proManager/getProjectManagerInfo';var proManager_getProjectByPmIdAndStatus = exports.proManager_getProjectByPmIdAndStatus = _EnvConfig.app_server + '/proManager/getProjectByPmIdAndStatus';var introducer_create_new = exports.introducer_create_new = _EnvConfig.app_server + '/introducer/create_new';
var introducer_add_introducer = exports.introducer_add_introducer = _EnvConfig.app_server + '/introducer/addIntroducer';
var introducer_update_by_id = exports.introducer_update_by_id = _EnvConfig.app_server + '/introducer/updateById';
var introducer_find_by_id = exports.introducer_find_by_id = _EnvConfig.app_server + '/introducer/findById';
var introducer_findInfoById = exports.introducer_findInfoById = _EnvConfig.app_server + '/introducer/findInfoById';
var introducer_findIntroducerBriefInfoById = exports.introducer_findIntroducerBriefInfoById = _EnvConfig.app_server + '/introducer/findIntroducerBriefInfoById';
var introducer_findRelationById = exports.introducer_findRelationById = _EnvConfig.app_server + '/introducer/findRelationById';
var introducer_findRelationByIdForCommission = exports.introducer_findRelationByIdForCommission = _EnvConfig.app_server + '/introducer/findRelationByIdForCommission';
var introducer_getPage = exports.introducer_getPage = _EnvConfig.app_server + '/introducer/getIntroducerPages';
var introducer_findTeamOneById = exports.introducer_findTeamOneById = _EnvConfig.app_server + '/introducer/findTeamOneById';var introducer_findTeamTwoById = exports.introducer_findTeamTwoById = _EnvConfig.app_server + '/introducer/findTeamTwoById';var introducer_delete_by_id = exports.introducer_delete_by_id = _EnvConfig.app_server + '/introducer/delById';
var introducer_page_data = exports.introducer_page_data = _EnvConfig.app_server + '/introducer/page_data';
var introducer_getAllUserByIntroducer = exports.introducer_getAllUserByIntroducer = _EnvConfig.app_server + '/introducer/getAllUserByIntroducer';var pMSubTeam_save = exports.pMSubTeam_save = _EnvConfig.app_server + '/pMSubTeam/savePMSubTeam';var pMSubTeam_get_page = exports.pMSubTeam_get_page = _EnvConfig.app_server + '/pMSubTeam/getPMSubTeamPages';var pMSubTeam_findById = exports.pMSubTeam_findById = _EnvConfig.app_server + '/pMSubTeam/findInfoById';var pMSubTeam_delById = exports.pMSubTeam_delById = _EnvConfig.app_server + '/pMSubTeam/delById';var company_getCompanyPages = exports.company_getCompanyPages = _EnvConfig.app_server + '/company/getCompanyPages';
var company_findById = exports.company_findById = _EnvConfig.app_server + '/company/findById';
var company_findCompanyInfoById = exports.company_findCompanyInfoById = _EnvConfig.app_server + '/company/findCompanyInfoById';
var company_addCompany = exports.company_addCompany = _EnvConfig.app_server + '/company/addCompany';
var company_updateById = exports.company_updateById = _EnvConfig.app_server + '/company/updateById';
var company_delById = exports.company_delById = _EnvConfig.app_server + '/company/delById';
var company_page_data = exports.company_page_data = _EnvConfig.app_server + '/company/page_data';
var company_getAll = exports.company_getAll = _EnvConfig.app_server + '/company/getAll';

var customer_page_data = exports.customer_page_data = _EnvConfig.app_server + '/customer/getPages';
var customer_page_data_ui = exports.customer_page_data_ui = _EnvConfig.app_server + '/customer/getPagesUI';
var customer_findById = exports.customer_findById = _EnvConfig.app_server + '/customer/findById';
var customer_save = exports.customer_save = _EnvConfig.app_server + '/customer/save';
var customer_save1 = exports.customer_save1 = _EnvConfig.app_server + '/customer/save1';
var customer_delete_by_id = exports.customer_delete_by_id = _EnvConfig.app_server + '/customer/delById';
var customer_findByProjectId = exports.customer_findByProjectId = _EnvConfig.app_server + '/customer/findByProjectId';
var customer_shareholder = exports.customer_shareholder = _EnvConfig.app_server + '/customer/insertOrUpdateOrDeleteCustomerShareholder';
var insertOrUpdateCustomerMarket = exports.insertOrUpdateCustomerMarket = _EnvConfig.app_server + '/customer/insertOrUpdateCustomerMarket';
var customer_issue = exports.customer_issue = _EnvConfig.app_server + '/customer/insertOrUpdateCustomerIssue';
var customer_Contact = exports.customer_Contact = _EnvConfig.app_server + '/customer/insertOrUpdateCustomerContact';
var deleteCustomerIssue = exports.deleteCustomerIssue = _EnvConfig.app_server + '/customer/deleteCustomerIssue';
var deleteCustomerContact = exports.deleteCustomerContact = _EnvConfig.app_server + '/customer/deleteCustomerContact';
var deleteCustomerMarket = exports.deleteCustomerMarket = _EnvConfig.app_server + '/customer/deleteCustomerMarket';
var getRegisterPlatformList = exports.getRegisterPlatformList = _EnvConfig.app_server + '/customer/getRegisterPlatformList';
var addRegisterPlatform = exports.addRegisterPlatform = _EnvConfig.app_server + '/customer/addRegisterPlatform';
var getRegisterPlatformDetail = exports.getRegisterPlatformDetail = _EnvConfig.app_server + '/customer/getRegisterPlatformDetail';
var updateRegisterPlatform = exports.updateRegisterPlatform = _EnvConfig.app_server + '/customer/updateRegisterPlatform';
var customer_shiftBlack = exports.customer_shiftBlack = _EnvConfig.app_server + '/customer/shiftBlacklist';
var addRegisterPlatformReport = exports.addRegisterPlatformReport = _EnvConfig.app_server + '/customer/addRegisterPlatformReport';
var updateRegisterPlatformReport = exports.updateRegisterPlatformReport = _EnvConfig.app_server + '/customer/updateRegisterPlatformReport';
var deleteRegisterPlatformReport = exports.deleteRegisterPlatformReport = _EnvConfig.app_server + '/customer/deleteRegisterPlatformReport';

var contractInfo_getContractPages = exports.contractInfo_getContractPages = _EnvConfig.app_server + '/contractInfo/getContractPages';
var contractInfo_getPages = exports.contractInfo_getPages = _EnvConfig.app_server + '/contractInfo/getPages';
var contractInfo_valid_page = exports.contractInfo_valid_page = _EnvConfig.app_server + '/contractInfo/valid_page';
var contractInfo_all_ok_page = exports.contractInfo_all_ok_page = _EnvConfig.app_server + '/contractInfo/all_ok_page';var contractInfo_all_ok_page_type = exports.contractInfo_all_ok_page_type = _EnvConfig.app_server + '/contractInfo/all_ok_page_type';var contractInfo_updateById = exports.contractInfo_updateById = _EnvConfig.app_server + '/contractInfo/updateById';
var contractInfo_findById = exports.contractInfo_findById = _EnvConfig.app_server + '/contractInfo/findById';
var contractInfo_delById = exports.contractInfo_delById = _EnvConfig.app_server + '/contractInfo/delById';
var contractInfo_save_draft = exports.contractInfo_save_draft = _EnvConfig.app_server + '/contractInfo/save_draft';
var contractInfo_do_audit = exports.contractInfo_do_audit = _EnvConfig.app_server + '/contractInfo/do_audit';

var contractInfo_getAllMainContractionInfo = exports.contractInfo_getAllMainContractionInfo = _EnvConfig.app_server + '/contractInfo/getAllMainContractionInfo';
var contractInfo_toexamine = exports.contractInfo_toexamine = _EnvConfig.app_server + '/contractInfo/toexamine';
var contractInfo_findByContractNo = exports.contractInfo_findByContractNo = _EnvConfig.app_server + '/contractInfo/findByContractNo';
var contractInfo_getSonContractNo = exports.contractInfo_getSonContractNo = _EnvConfig.app_server + '/contractInfo/getSonContractNo';
var contractInfo_getMainContractNo = exports.contractInfo_getMainContractNo = _EnvConfig.app_server + '/contractInfo/getMainContractNo';
var contractInfo_update_operate = exports.contractInfo_update_operate = _EnvConfig.app_server + '/contractInfo/updateContractOperateData';
var contractInfo_update_finance = exports.contractInfo_update_finance = _EnvConfig.app_server + '/contractInfo/updateContractFinanceData';

var contractInfo_getInsuranceCats = exports.contractInfo_getInsuranceCats = _EnvConfig.app_server + '/contractInfo/getInsuranceCats';

var contractInfo_upload_attach = exports.contractInfo_upload_attach = _EnvConfig.app_server + '/contractInfo/upload_attach';
var contractInfo_saveInvoiceAmount = exports.contractInfo_saveInvoiceAmount = _EnvConfig.app_server + '/contractInfo/saveInvoiceAmount';
var contractInfo_getAuditStatus = exports.contractInfo_getAuditStatus = _EnvConfig.app_server + '/contractInfo/getAuditStatus';
var contractInfo_old_contractInfo = exports.contractInfo_old_contractInfo = _EnvConfig.app_server + '/contractInfo/OldContractInfo';var finance_income_check_effective = exports.finance_income_check_effective = _EnvConfig.app_server + '/finance_income/check_project_effective';var contractInfo_upload_files = exports.contractInfo_upload_files = _EnvConfig.app_server + '/contractInfo/uploadContractInfoByWorking';var contractInfo_export_Excel = exports.contractInfo_export_Excel = _EnvConfig.app_server + '/contractInfo/contractInfoExcel';var contractInfo_get_taxCatValue = exports.contractInfo_get_taxCatValue = _EnvConfig.app_server + '/contractInfo/getTaxCatValue';var projectDocDir_getProjectDocDirTitle = exports.projectDocDir_getProjectDocDirTitle = _EnvConfig.app_server + '/projectDocDir/getProjectDocDirTitle';var contractInfo_agreeContract = exports.contractInfo_agreeContract = _EnvConfig.app_server + '/contractInfo/agreeContract';var contractInfo_disagreeContract = exports.contractInfo_disagreeContract = _EnvConfig.app_server + '/contractInfo/disagreeContract';var contractInfo_returnContract = exports.contractInfo_returnContract = _EnvConfig.app_server + '/contractInfo/returnContract';var contractInfo_saveContract = exports.contractInfo_saveContract = _EnvConfig.app_server + '/contractInfo/saveContract';var contractInfo_submitContract = exports.contractInfo_submitContract = _EnvConfig.app_server + '/contractInfo/submitContract';var contractInfo_changeContract = exports.contractInfo_changeContract = _EnvConfig.app_server + '/contractInfo/changeContract';var contractInfo_secondSaveContract = exports.contractInfo_secondSaveContract = _EnvConfig.app_server + '/contractInfo/secondSaveContract';var contractInfo_secondSubmitContract = exports.contractInfo_secondSubmitContract = _EnvConfig.app_server + '/contractInfo/secondSubmitContract';var insurance_saveContractInsurance = exports.insurance_saveContractInsurance = _EnvConfig.app_server + '/insurance/saveContractInsurance';var insurance_list = exports.insurance_list = _EnvConfig.app_server + '/insurance/getContractInsurancePage';var insurance_get_CID_Page = exports.insurance_get_CID_Page = _EnvConfig.app_server + '/project/getCIDPage';var insurance_get_excel = exports.insurance_get_excel = _EnvConfig.app_server + '/insurance/contractInsuranceExcel';var insurance_delete = exports.insurance_delete = _EnvConfig.app_server + '/insurance/editInsuranceStatus';var insurance_purchaseContractInsurance = exports.insurance_purchaseContractInsurance = _EnvConfig.app_server + '/insurance/purchaseContractInsurance';var insurance_edit = exports.insurance_edit = _EnvConfig.app_server + '/insurance/editInsuranceInfo';var insurance_getInsuranceCategoryOps = exports.insurance_getInsuranceCategoryOps = _EnvConfig.app_server + '/insurance/getInsuranceCategoryOps';var insurance_getInsurancePurchaseWayOps = exports.insurance_getInsurancePurchaseWayOps = _EnvConfig.app_server + '/insurance/getInsurancePurchaseWayOps';var insurance_getInsuranceCategoryRateOps = exports.insurance_getInsuranceCategoryRateOps = _EnvConfig.app_server + '/insurance/getInsuranceCategoryRateOps';var insurance_getProjectInfo = exports.insurance_getProjectInfo = _EnvConfig.app_server + '/insurance/getProjectInfo';var insurance_getContractInsuranceDetail = exports.insurance_getContractInsuranceDetail = _EnvConfig.app_server + '/insurance/getContractInsuranceDetail';var insurance_agreeInsurance = exports.insurance_agreeInsurance = _EnvConfig.app_server + '/insurance/agreeInsurance';var insurance_disagreeInsurance = exports.insurance_disagreeInsurance = _EnvConfig.app_server + '/insurance/disagreeInsurance';var insurance_returnInsurance = exports.insurance_returnInsurance = _EnvConfig.app_server + '/insurance/returnInsurance';var insurance_changeInsurance = exports.insurance_changeInsurance = _EnvConfig.app_server + '/insurance/changeInsurance';var insurance_editInsuranceStatus = exports.insurance_editInsuranceStatus = _EnvConfig.app_server + '/insurance/editInsuranceStatus';var getInsuranceInfoByProjectId = exports.getInsuranceInfoByProjectId = _EnvConfig.app_server + '/insurance/getInsuranceInfoByProjectId';var insurance_addInsurance = exports.insurance_addInsurance = _EnvConfig.app_server + '/insurance/addInsurance';var insurance_restartInsuranceApply = exports.insurance_restartInsuranceApply = _EnvConfig.app_server + '/insurance/restartInsuranceApply';var insurance_deleteInsurance = exports.insurance_deleteInsurance = _EnvConfig.app_server + '/insurance/deleteInsurance';var insurance_deleteContractInsurance = exports.insurance_deleteContractInsurance = _EnvConfig.app_server + '/insurance/deleteContractInsurance';var project_working_project_page = exports.project_working_project_page = _EnvConfig.app_server + '/project/working_project_page';var submitSettlementApply = exports.submitSettlementApply = _EnvConfig.app_server + '/apply/submitSettlementApply';var getSettlementApplyPage = exports.getSettlementApplyPage = _EnvConfig.app_server + '/apply/getSettlementApplyPage';var settlementApplyInfo = exports.settlementApplyInfo = _EnvConfig.app_server + '/apply/settlementApplyInfo';var settlementApply_audit = exports.settlementApply_audit = _EnvConfig.app_server + '/apply/auditSettlementApply';var settlementApply_change = exports.settlementApply_change = _EnvConfig.app_server + '/apply/changeSettlementApply';var settlementApply_return = exports.settlementApply_return = _EnvConfig.app_server + '/apply/returnSettlementApply';var settlementApply_disAgree = exports.settlementApply_disAgree = _EnvConfig.app_server + '/apply/disAgreeSettlementApply';var settlementApply_complete = exports.settlementApply_complete = _EnvConfig.app_server + '/apply/completeSettlementApply';var settlementPay = exports.settlementPay = _EnvConfig.app_server + '/apply/settlementPay';var uploadSettlementApply = exports.uploadSettlementApply = _EnvConfig.app_server + '/apply/uploadSettlementApply';var cmDirector_projectManager_findPMById = exports.cmDirector_projectManager_findPMById = _EnvConfig.app_server + '/cmDirector/findPMById';
var cmDirector_projectManager_doAudit = exports.cmDirector_projectManager_doAudit = _EnvConfig.app_server + '/cmDirector/projectManager_doAudit';
var cmDirector_introducer_doAudit = exports.cmDirector_introducer_doAudit = _EnvConfig.app_server + '/cmDirector/introducer_doAudit';
var cmDirector_project_update_cm = exports.cmDirector_project_update_cm = _EnvConfig.app_server + '/cmDirector/project_update_cm';var finance_income_save_draft = exports.finance_income_save_draft = _EnvConfig.app_server + '/finance_income/save_draft';var finance_income_get_page = exports.finance_income_get_page = _EnvConfig.app_server + '/finance_income/get_page';var finance_income_get_history_page = exports.finance_income_get_history_page = _EnvConfig.app_server + '/finance_income/get_history_page';var finance_income_find_by_id = exports.finance_income_find_by_id = _EnvConfig.app_server + '/finance_income/find_by_id';var finance_income_send_confirm = exports.finance_income_send_confirm = _EnvConfig.app_server + '/finance_income/send_confirm';
var finance_income_audit_ok_by_cm = exports.finance_income_audit_ok_by_cm = _EnvConfig.app_server + '/finance_income/audit_ok_by_cm';
var finance_income_audit_ok_by_fm = exports.finance_income_audit_ok_by_fm = _EnvConfig.app_server + '/finance_income/audit_ok_by_fm';
var finance_income_do_audit = exports.finance_income_do_audit = _EnvConfig.app_server + '/finance_income/do_audit';
var finance_income_check_duplicate = exports.finance_income_check_duplicate = _EnvConfig.app_server + '/finance_income/check_duplicate_receivable';var finance_income_delete_by_id = exports.finance_income_delete_by_id = _EnvConfig.app_server + '/finance_income/delete_by_id';var finance_computing_page_number = exports.finance_computing_page_number = _EnvConfig.app_server + '/financeStat/computing_page_number';

var finance_get_auditStatus = exports.finance_get_auditStatus = _EnvConfig.app_server + '/finance_income/getAuditStatus';var finance_updateFIById = exports.finance_updateFIById = _EnvConfig.app_server + '/finance/updateFIById';var finance_findFIById = exports.finance_findFIById = _EnvConfig.app_server + '/finance/findFIById';var finance_delFIById = exports.finance_delFIById = _EnvConfig.app_server + '/finance/delFIById';var finance_sendAudit = exports.finance_sendAudit = _EnvConfig.app_server + '/finance/doAuditTO_DO';var getCompanyName = exports.getCompanyName = _EnvConfig.app_server + '/customer/getPages';
var finance_add_markContents = exports.finance_add_markContents = _EnvConfig.app_server + '/finance_income/add_income_markContent';var finance_income_relate_apply = exports.finance_income_relate_apply = _EnvConfig.app_server + '/finance_income/relate_apply';var contractInfo_claim_payment = exports.contractInfo_claim_payment = _EnvConfig.app_server + '/contractInfo/claim_payment';var income_data_all_cm = exports.income_data_all_cm = _EnvConfig.app_server + '/data/all_cm';var finManager_getPages = exports.finManager_getPages = _EnvConfig.app_server + '/finManager/getFinanceIncomePages';var finManager_findFIById = exports.finManager_findFIById = _EnvConfig.app_server + '/finManager/findFIById';var finManager_doAuditById = exports.finManager_doAuditById = _EnvConfig.app_server + '/finManager/doAuditById';var finManager_xm_company_bank = exports.finManager_xm_company_bank = _EnvConfig.app_server + '/finance_income/xm_company_bank';var finance_income_printing = exports.finance_income_printing = _EnvConfig.app_server + '/finance_income/income_printing';var finance_income__printing_prompt = exports.finance_income__printing_prompt = _EnvConfig.app_server + '/finance_income/income_printing_prompt';var finDirector_getPages = exports.finDirector_getPages = _EnvConfig.app_server + '/finDirector/getFinanceIncomePages';var finDirector_findFIById = exports.finDirector_findFIById = _EnvConfig.app_server + '/finDirector/findFIById';var finDirector_doAuditById = exports.finDirector_doAuditById = _EnvConfig.app_server + '/finDirector/doAuditById';var finDirector_project_visible = exports.finDirector_project_visible = _EnvConfig.app_server + '/financeStat/project/visible';var financeStat_project_settlement = exports.financeStat_project_settlement = _EnvConfig.app_server + '/financeStat/project/settlement';var finance_income_check_billing_balance = exports.finance_income_check_billing_balance = _EnvConfig.app_server + '/finance_income/check_billing_balance';var getMaterialTicketList = exports.getMaterialTicketList = _EnvConfig.app_server + '/financePay/materialTicketList';var getMaterialTicketPage = exports.getMaterialTicketPage = _EnvConfig.app_server + '/materialTicketInfo/getMaterialTicketPage';var getSupplierPageByProjectId = exports.getSupplierPageByProjectId = _EnvConfig.app_server + '/payRoll/getSupplierPageByProjectId';var relevanceSupplier = exports.relevanceSupplier = _EnvConfig.app_server + '/materialTicket/relevanceSupplier';var materialTicketLaborPage = exports.materialTicketLaborPage = _EnvConfig.app_server + '/financePay/materialTicketLaborPage';var project_lose_order_page = exports.project_lose_order_page = _EnvConfig.app_server + '/project/lose_order_page';var financePay_salesTicketManualList = exports.financePay_salesTicketManualList = _EnvConfig.app_server + '/financePay/salesTicketManualList';var project_lose_order_pages = exports.project_lose_order_pages = _EnvConfig.app_server + '/project/lose_order_pages';var project_lose_order_update = exports.project_lose_order_update = _EnvConfig.app_server + '/project/lose_order_update';var project_lose_order_bizItemId = exports.project_lose_order_bizItemId = _EnvConfig.app_server + '/project/findLoseByBizItemId';var submit_change_project_lose = exports.submit_change_project_lose = _EnvConfig.app_server + '/project/changeProject_lose';var submit_disagree_project_lose = exports.submit_disagree_project_lose = _EnvConfig.app_server + '/project/disagreeProject_lose';var submit_agree_project_lose = exports.submit_agree_project_lose = _EnvConfig.app_server + '/project/agreeProject_lose';var submit_return_project_lose = exports.submit_return_project_lose = _EnvConfig.app_server + '/project/returnProject_lose';var submit_complete_project_lose = exports.submit_complete_project_lose = _EnvConfig.app_server + '/project/completeProject_lose';var delete_lose_by_bizItemId = exports.delete_lose_by_bizItemId = _EnvConfig.app_server + '/project/deleteLoseByBizItemId';var boss_getPages = exports.boss_getPages = _EnvConfig.app_server + '/boss/getFinanceIncomePages';var boss_findFIById = exports.boss_findFIById = _EnvConfig.app_server + '/boss/findFIById';var boss_doAuditById = exports.boss_doAuditById = _EnvConfig.app_server + '/boss/doAuditById';var processlog_updateEnclosure = exports.processlog_updateEnclosure = _EnvConfig.app_server + '/processlog/updateEnclosure';
var ProDetailedInfo_updateEnclosure = exports.ProDetailedInfo_updateEnclosure = _EnvConfig.app_server + '/prodetailedinfo/updateEnclosure';

var bankInfo_page_data = exports.bankInfo_page_data = _EnvConfig.app_server + '/bankInfo/page_data';
var bankInfo_save = exports.bankInfo_save = _EnvConfig.app_server + '/bankInfo/save';
var bankInfo_findById = exports.bankInfo_findById = _EnvConfig.app_server + '/bankInfo/findById';
var bankInfo_findByName = exports.bankInfo_findByName = _EnvConfig.app_server + '/bankInfo/findByName';
var bankInfo_delById = exports.bankInfo_delById = _EnvConfig.app_server + '/bankInfo/delete';
var bankInfo_updateById = exports.bankInfo_updateById = _EnvConfig.app_server + '/bankInfo/updateById';
var bankInfo_findByType = exports.bankInfo_findByType = _EnvConfig.app_server + '/bankInfo/findByType';

var bankInfo_get_bank_list = exports.bankInfo_get_bank_list = _EnvConfig.app_server + '/bankInfo/get_bank_list';
var bankInfo_get_branch_list_by_parent = exports.bankInfo_get_branch_list_by_parent = _EnvConfig.app_server + '/bankInfo/get_branch_list_by_parent';
var bankInfo_save_bank_or_branch = exports.bankInfo_save_bank_or_branch = _EnvConfig.app_server + '/bankInfo/save_bank_or_branch';

var business_introducer_page_data = exports.business_introducer_page_data = _EnvConfig.app_server + '/businessIntroducer/page_data';
var business_introducer_find_by_id = exports.business_introducer_find_by_id = _EnvConfig.app_server + '/businessIntroducer/find_by_id';
var business_introducer_save = exports.business_introducer_save = _EnvConfig.app_server + '/businessIntroducer/save';

var enum_data_getEnumDataByType = exports.enum_data_getEnumDataByType = _EnvConfig.app_server + '/enum_data/getEnumDataByType';

var operationCenter_page_data = exports.operationCenter_page_data = _EnvConfig.app_server + '/operationCenter/page_data';
var operationCenter_save = exports.operationCenter_save = _EnvConfig.app_server + '/operationCenter/save';
var operationCenter_findById = exports.operationCenter_findById = _EnvConfig.app_server + '/operationCenter/findById';
var operationCenter_findBySubCompanyId = exports.operationCenter_findBySubCompanyId = _EnvConfig.app_server + '/operationCenter/findBySubCompanyId';var operationCenter_delById = exports.operationCenter_delById = _EnvConfig.app_server + '/operationCenter/delById';
var operationCenter_updateById = exports.operationCenter_updateById = _EnvConfig.app_server + '/operationCenter/updateById';
var getProjectPhase = exports.getProjectPhase = _EnvConfig.app_server + '/project/getProjectPhase';
var getProcess = exports.getProcess = _EnvConfig.app_server + '/flow/getFlowProcessProgressOps';
var getDataByLabel = exports.getDataByLabel = _EnvConfig.app_server + '/enum_data/getEnumDataByLabel';
var getLevelByLabel = exports.getLevelByLabel = _EnvConfig.app_server + '/enum_data/getLevelEnumData';
var getDataByLabelList = exports.getDataByLabelList = _EnvConfig.app_server + '/proManager/getPMPagesByExecutive';
var get_guarantee_list = exports.get_guarantee_list = _EnvConfig.app_server + '/guaranteeLetter/getGuaranteeLetterPage';
var get_agency_ops = exports.get_agency_ops = _EnvConfig.app_server + '/guaranteeLetter/getGuaranteeAgencyOps';
var get_guarantee_project_choose = exports.get_guarantee_project_choose = _EnvConfig.app_server + '/project/getGuaranteeProjectChooseList';
var get_guarantee_letter_apply = exports.get_guarantee_letter_apply = _EnvConfig.app_server + '/guaranteeLetter/queryGuaranteeLetterApply';
var get_project_info = exports.get_project_info = _EnvConfig.app_server + '/project/getChooseProjectBaseInfo';
var save_guarantee = exports.save_guarantee = _EnvConfig.app_server + '/guaranteeLetter/saveGuaranteeLetterApply';
var submit_guarantee = exports.submit_guarantee = _EnvConfig.app_server + '/guaranteeLetter/submitGuaranteeLetterApply';
var agree_guarantee = exports.agree_guarantee = _EnvConfig.app_server + '/guaranteeLetter/agreeGuaranteeLetterApply';
var disagree_guarantee = exports.disagree_guarantee = _EnvConfig.app_server + '/guaranteeLetter/disagreeGuaranteeLetterApply';
var return_flowt_guarantee = exports.return_flowt_guarantee = _EnvConfig.app_server + '/guaranteeLetter/returnFlowGuaranteeLetterApply';
var change_guarantee = exports.change_guarantee = _EnvConfig.app_server + '/guaranteeLetter/changeGuaranteeLetterApply';
var del_guarantee = exports.del_guarantee = _EnvConfig.app_server + '/guaranteeLetter/delGuaranteeLetterApply';
var buy_guarantee = exports.buy_guarantee = _EnvConfig.app_server + '/guaranteeLetter/buyGuaranteeLetter';
var add_guarantee = exports.add_guarantee = _EnvConfig.app_server + '/guaranteeLetter/addGuaranteeAgency';
var add_qualification = exports.add_qualification = _EnvConfig.app_server + '/enterpriseQualification/saveEnterpriseQualification';
var get_qualification_list = exports.get_qualification_list = _EnvConfig.app_server + '/enterpriseQualification/getEnterpriseQualificationPage';
var delete_qualification = exports.delete_qualification = _EnvConfig.app_server + '/enterpriseQualification/deleteEnterpriseQualification';
var get_project_list = exports.get_project_list = _EnvConfig.app_server + '/project/getProjectPage';
var submit_agree_project = exports.submit_agree_project = _EnvConfig.app_server + '/project/agreeProject';
var submit_disagree_project = exports.submit_disagree_project = _EnvConfig.app_server + '/project/disagreeProject';
var submit_change_project = exports.submit_change_project = _EnvConfig.app_server + '/project/changeProject';
var submit_return_project = exports.submit_return_project = _EnvConfig.app_server + '/project/returnProject';
var submit_complete_project = exports.submit_complete_project = _EnvConfig.app_server + '/project/completeProject';
var flow_getFlowDealProcessOps = exports.flow_getFlowDealProcessOps = _EnvConfig.app_server + '/flow/getFlowDealProcessOps';
var followPro_addProjectInfo = exports.followPro_addProjectInfo = _EnvConfig.app_server + '/processlog/addProjectInfo';
var del_buy_guarantee = exports.del_buy_guarantee = _EnvConfig.app_server + '/guaranteeLetter/delBuyGuaranteeLetter';
var del_process_guarantee = exports.del_process_guarantee = _EnvConfig.app_server + '/guaranteeLetter/delGuaranteeLetterProcess';
var reset_process_guarantee = exports.reset_process_guarantee = _EnvConfig.app_server + '/guaranteeLetter/resetGuaranteeLetterProcess';
var reset_process_project = exports.reset_process_project = _EnvConfig.app_server + '/project/resetDraftProjectProcess';
var all_customerIntention_data = exports.all_customerIntention_data = _EnvConfig.app_server + '/customerIntention/getAllEnumData';

var message_type = exports.message_type = _EnvConfig.app_server + '/xmMessage/getCats';var message_list = exports.message_list = _EnvConfig.app_server + '/xmMessage/getPages4MyReceive';var message_unread = exports.message_unread = _EnvConfig.app_server + '/xmMessage/getUnreadCount';var message_remarkRead = exports.message_remarkRead = _EnvConfig.app_server + '/xmMessage/read';var message_unreadMsgCount = exports.message_unreadMsgCount = _EnvConfig.app_server + '/xmMessage/unreadMsgCount';var message_unreadMsgPage = exports.message_unreadMsgPage = _EnvConfig.app_server + '/xmMessage/unreadMsgPage';var message_open_close = exports.message_open_close = _EnvConfig.app_server + '/back_user/wxUnreadMsgOpenOrClose';var message_unreadCopyMsgPage = exports.message_unreadCopyMsgPage = _EnvConfig.app_server + '/xmMessage/unreadCopyMsgPage';var message_unreadCopyMsgCount = exports.message_unreadCopyMsgCount = _EnvConfig.app_server + '/xmMessage/unreadCopyMsgCount';var danger_reset_contract_audit_status = exports.danger_reset_contract_audit_status = _EnvConfig.app_server + '/danger/reset_contract_audit_status';
var danger_reset_apply_data_audit_status = exports.danger_reset_apply_data_audit_status = _EnvConfig.app_server + '/danger/reset_apply_data_audit_status';
var danger_resetFinanceIncomeAuditStatus = exports.danger_resetFinanceIncomeAuditStatus = _EnvConfig.app_server + '/danger/resetFinanceIncomeAuditStatus';
var danger_auditIncomeList = exports.danger_auditIncomeList = _EnvConfig.app_server + '/danger/auditIncomeList';

var financePay_deductionsType = exports.financePay_deductionsType = _EnvConfig.app_server + '/financePay/deductionsType';var financePay_saveData = exports.financePay_saveData = _EnvConfig.app_server + '/financePay/saveData';
var financePay_pageData = exports.financePay_pageData = _EnvConfig.app_server + '/financePay/pageData';
var financePay_deleteById = exports.financePay_deleteById = _EnvConfig.app_server + '/financePay/deleteById';

var insurance_getProjectViewInsurancePage = exports.insurance_getProjectViewInsurancePage = _EnvConfig.app_server + '/insurance/getProjectViewInsurancePage';var financePay_manualList = exports.financePay_manualList = _EnvConfig.app_server + '/financePay/manualList';var financePay_financeItem = exports.financePay_financeItem = _EnvConfig.app_server + '/financePay/findFinanceItem';
var financePay_deduct_calcItem = exports.financePay_deduct_calcItem = _EnvConfig.app_server + '/financial_calc/manual_deduct_calcItem';
var financePay_deduction_detail = exports.financePay_deduction_detail = _EnvConfig.app_server + '/financePay/manualDeductionInfoList';var financePay_deduction_list = exports.financePay_deduction_list = _EnvConfig.app_server + '/financePay/manualDeductionList';var financePay_manualDeductionListExcel = exports.financePay_manualDeductionListExcel = _EnvConfig.app_server + '/financePay/manualDeductionListExcel';var financePay_uploadExcelFinancePay_check = exports.financePay_uploadExcelFinancePay_check = _EnvConfig.app_server + '/financePay/uploadExcelFinancePay_check';var financePay_check_xmFinanceItem = exports.financePay_check_xmFinanceItem = _EnvConfig.app_server + '/financePay/check_xmFinanceItem';var financePay_manualDeductionErrorDataExcel = exports.financePay_manualDeductionErrorDataExcel = _EnvConfig.app_server + '/financePay/manualDeductionErrorDataExcel';var financePay_uploadExcelFinancePay_save = exports.financePay_uploadExcelFinancePay_save = _EnvConfig.app_server + '/financePay/uploadExcelFinancePay_save';var advanceTax_getAdvanceTaxProjectPage = exports.advanceTax_getAdvanceTaxProjectPage = _EnvConfig.app_server + '/advanceTax/getAdvanceTaxProjectPage';var advanceTax_saveProjectAdvanceTax = exports.advanceTax_saveProjectAdvanceTax = _EnvConfig.app_server + '/advanceTax/saveProjectAdvanceTax';var advanceTax_getAdvanceTaxList = exports.advanceTax_getAdvanceTaxList = _EnvConfig.app_server + '/advanceTax/getAdvanceTaxList';var getAdvanceTaxApplyPage = exports.getAdvanceTaxApplyPage = _EnvConfig.app_server + '/advanceTaxApply/getAdvanceTaxApplyPage';var advanceTax_getApproveProjectPage = exports.advanceTax_getApproveProjectPage = _EnvConfig.app_server + '/project/getApproveProjectPage';var getAdvanceTaxProjectById = exports.getAdvanceTaxProjectById = _EnvConfig.app_server + '/advanceTax/getAdvanceTaxProjectById';var addOrUpdateAdvanceTaxApply = exports.addOrUpdateAdvanceTaxApply = _EnvConfig.app_server + '/advanceTaxApply/addOrUpdateAdvanceTaxApply';var advanceTax_getAdvanceTaxApplyInfo = exports.advanceTax_getAdvanceTaxApplyInfo = _EnvConfig.app_server + '/advanceTaxApply/getAdvanceTaxApplyInfo';var getAdvanceTaxApplyRecordPage = exports.getAdvanceTaxApplyRecordPage = _EnvConfig.app_server + '/advanceTaxApply/getAdvanceTaxApplyRecordPage';var advanceTax_auditAdvanceTaxApply = exports.advanceTax_auditAdvanceTaxApply = _EnvConfig.app_server + '/advanceTaxApply/auditAdvanceTaxApply';var delAdvanceTaxApplyById = exports.delAdvanceTaxApplyById = _EnvConfig.app_server + '/advanceTaxApply/delAdvanceTaxApplyById';var checkAdvanceTaxReceiptNo = exports.checkAdvanceTaxReceiptNo = _EnvConfig.app_server + '/advanceTax/checkAdvanceTaxReceiptNo';var advanceTaxApply_disagree = exports.advanceTaxApply_disagree = _EnvConfig.app_server + '/advanceTaxApply/disagreeAdvanceTaxApply';var advanceTaxApply_change = exports.advanceTaxApply_change = _EnvConfig.app_server + '/advanceTaxApply/changeAdvanceTaxApply';var advanceTaxApply_agree = exports.advanceTaxApply_agree = _EnvConfig.app_server + '/advanceTaxApply/agreeAdvanceTaxApply';var advanceTaxApply_return = exports.advanceTaxApply_return = _EnvConfig.app_server + '/advanceTaxApply/returnAdvanceTaxApply';var advanceTaxApply_complete = exports.advanceTaxApply_complete = _EnvConfig.app_server + '/advanceTaxApply/completeAdvanceTaxApply';var advanceTaxApply_restartAdvanceTaxById = exports.advanceTaxApply_restartAdvanceTaxById = _EnvConfig.app_server + '/advanceTaxApply/restartAdvanceTaxById';var advanceTaxApply_delAdvanceTaxById = exports.advanceTaxApply_delAdvanceTaxById = _EnvConfig.app_server + '/advanceTaxApply/delAdvanceTaxById';var advanceTaxApply_delAdvanceTaxApplyById = exports.advanceTaxApply_delAdvanceTaxApplyById = _EnvConfig.app_server + '/advanceTaxApply/delAdvanceTaxApplyById';var financeStat_project_pageData = exports.financeStat_project_pageData = _EnvConfig.app_server + '/financeStat/project/pageData';
var financeStat_project_findById = exports.financeStat_project_findById = _EnvConfig.app_server + '/financeStat/project/findById';
var financeStat_income_autoCalList = exports.financeStat_income_autoCalList = _EnvConfig.app_server + '/financeStat/income/autoCalList';
var financeStat_pm_findById = exports.financeStat_pm_findById = _EnvConfig.app_server + '/financeStat/pm/mainFinance';
var financeStat_pm_financeitemPage = exports.financeStat_pm_financeitemPage = _EnvConfig.app_server + '/financeStat/pm/financeitemPage';
var financeStat_pm_financeitemTotal = exports.financeStat_pm_financeitemTotal = _EnvConfig.app_server + '/financeStat/pm/financeitemTotal';
var financeStat_income_excel = exports.financeStat_income_excel = _EnvConfig.app_server + '/financeStat/income/autoCalListExport';var financeStat_export_project_view = exports.financeStat_export_project_view = _EnvConfig.app_server + '/financeStat/export_project_view';var applyData_getPage = exports.applyData_getPage = _EnvConfig.app_server + '/applyData/getPage';
var applyData_getCash_getPage = exports.applyData_getCash_getPage = _EnvConfig.app_server + '/apply/getCashPage';var applyData_get_dataInfo = exports.applyData_get_dataInfo = _EnvConfig.app_server + '/apply/getDataInfo';var applyData_save_stamp = exports.applyData_save_stamp = _EnvConfig.app_server + '/apply/saveStamp';var applyData_audit_stamp = exports.applyData_audit_stamp = _EnvConfig.app_server + '/apply/auditStamp';var delete_stamp = exports.delete_stamp = _EnvConfig.app_server + '/sealApply/deleteStampFile';var applyData_save_invoiceBill = exports.applyData_save_invoiceBill = _EnvConfig.app_server + '/apply/saveInvoiceBill';var applyData_audit_invoiceBill = exports.applyData_audit_invoiceBill = _EnvConfig.app_server + '/apply/auditInvoiceBill';var applyData_save_addCredit = exports.applyData_save_addCredit = _EnvConfig.app_server + '/apply/saveAddCredit';var applyData_audit_addCredit = exports.applyData_audit_addCredit = _EnvConfig.app_server + '/apply/auditAddCredit';var applyData_save_getCash = exports.applyData_save_getCash = _EnvConfig.app_server + '/apply/saveGetCash';var applyData_audit_getCash = exports.applyData_audit_getCash = _EnvConfig.app_server + '/apply/auditGetCash';var xmFinance_item_get_page = exports.xmFinance_item_get_page = _EnvConfig.app_server + '/xmFinance_item/get_page';var xmFinance_item_find_by_id = exports.xmFinance_item_find_by_id = _EnvConfig.app_server + '/xmFinance_item/find_by_id';var xmFinance_item_save_draft = exports.xmFinance_item_save_draft = _EnvConfig.app_server + '/xmFinance_item/save_draft';var xmFinance_item_audit_ok_by_finance = exports.xmFinance_item_audit_ok_by_finance = _EnvConfig.app_server + '/xmFinance_item/audit_ok_by_finance';var xmFinance_item_audit_ok_by_fm = exports.xmFinance_item_audit_ok_by_fm = _EnvConfig.app_server + '/xmFinance_item/audit_ok_by_fm';var xmFinance_item_delete_by_id = exports.xmFinance_item_delete_by_id = _EnvConfig.app_server + '/xmFinance_item/delete_by_id';var getProjectAdvanceTaxList = exports.getProjectAdvanceTaxList = _EnvConfig.app_server + '/advanceTax/getProjectAdvanceTaxList';var applyData_save_otherMall = exports.applyData_save_otherMall = _EnvConfig.app_server + '/apply/saveOtherMall';var payRoll_staging_payRollContract = exports.payRoll_staging_payRollContract = _EnvConfig.app_server + '/payRoll/staging_payRollContract';var payRoll_delete_payRollContract = exports.payRoll_delete_payRollContract = _EnvConfig.app_server + '/payRoll/delete_payRollContract';var payRoll_checkRepeatPaidMaterial = exports.payRoll_checkRepeatPaidMaterial = _EnvConfig.app_server + '/payRoll/checkRepeatPaidMaterial';var applyData_audit_otherMall = exports.applyData_audit_otherMall = _EnvConfig.app_server + '/apply/auditOtherMall';var disagreeOtherMall = exports.disagreeOtherMall = _EnvConfig.app_server + '/apply/disagreeOtherMall';var changeOtherMall = exports.changeOtherMall = _EnvConfig.app_server + '/apply/changeOtherMall';var disagreeBidBondApply = exports.disagreeBidBondApply = _EnvConfig.app_server + '/apply/disagreeBidBondApply';var changeBidBondApply = exports.changeBidBondApply = _EnvConfig.app_server + '/apply/changeBidBondApply';var disagreeTenementDepositApply = exports.disagreeTenementDepositApply = _EnvConfig.app_server + '/apply/disagreeTenementDepositApply';var changeTenementDepositApply = exports.changeTenementDepositApply = _EnvConfig.app_server + '/apply/changeTenementDepositApply';var materialTicketInfo_deleteXmFinanceItemManual = exports.materialTicketInfo_deleteXmFinanceItemManual = _EnvConfig.app_server + '/materialTicketInfo/deleteXmFinanceItemManual';
var materialTicketInfo_deleteXmFinanceItemManualBehalf = exports.materialTicketInfo_deleteXmFinanceItemManualBehalf = _EnvConfig.app_server + '/materialTicketInfo/deleteXmFinanceItemManualBehalf';

var applyData_getOtherMallPage = exports.applyData_getOtherMallPage = _EnvConfig.app_server + '/apply/getOtherMallPage';var apply_otherMallPageExport = exports.apply_otherMallPageExport = _EnvConfig.app_server + '/apply/OtherMallPageExport';var editBillMaterialByApplyId = exports.editBillMaterialByApplyId = _EnvConfig.app_server + '/bill_material/editBillMaterialByApplyId';var applyData_saveOtherMall = exports.applyData_saveOtherMall = _EnvConfig.app_server + '/payRoll/addPayRollContract';var apply_getSupplyList = exports.apply_getSupplyList = _EnvConfig.app_server + '/apply/getSupplierName';var getSupplierChooseList = exports.getSupplierChooseList = _EnvConfig.app_server + '/supplier/getSupplierChooseList';var apply_get_bankList = exports.apply_get_bankList = _EnvConfig.app_server + '/bankInfo/get_bank_list';var apply_get_branchList = exports.apply_get_branchList = _EnvConfig.app_server + '/payRoll/getSupplierBranchName';var apply_OtherMall_edit = exports.apply_OtherMall_edit = _EnvConfig.app_server + '/apply/getOtherMallEdit';var apply_OtherMall_select_pro = exports.apply_OtherMall_select_pro = _EnvConfig.app_server + '/apply/projectByOtherMall';var apply_OtherMall_print = exports.apply_OtherMall_print = _EnvConfig.app_server + '/apply/otherMallPrinting';var apply_otherMallPayment = exports.apply_otherMallPayment = _EnvConfig.app_server + '/apply/otherMallPayment';var apply_saveApplyAmount = exports.apply_saveApplyAmount = _EnvConfig.app_server + '/payRoll/saveApplyAmount';var apply_getDFOddNumbers = exports.apply_getDFOddNumbers = _EnvConfig.app_server + '/apply/getDFOddNumbers';var apply_getOtherMallCallout = exports.apply_getOtherMallCallout = _EnvConfig.app_server + '/apply/otherMallCallout';var apply_project_info = exports.apply_project_info = _EnvConfig.app_server + '/apply/projectByOtherMallInfo';
var getNoAssociatedMaterial = exports.getNoAssociatedMaterial = _EnvConfig.app_server + '/materialTicket/getNoAssociatedMaterial';var getNoDeductionMaterialPage = exports.getNoDeductionMaterialPage = _EnvConfig.app_server + '/materialTicketInfo/getNoDeductionMaterialPage';var getPaidMaterialTicket = exports.getPaidMaterialTicket = _EnvConfig.app_server + '/materialTicket/getPaidMaterialTicket';var cancelRelevanceMaterial = exports.cancelRelevanceMaterial = _EnvConfig.app_server + '/materialTicketInfo/cancelRelevanceMaterial';var relevanceMaterialTicket = exports.relevanceMaterialTicket = _EnvConfig.app_server + '/materialTicket/relevanceMaterialTicket';var getOtherMallBillMaterials = exports.getOtherMallBillMaterials = _EnvConfig.app_server + '/apply/getOtherMallBillMaterials';var del_buy_apply = exports.del_buy_apply = _EnvConfig.app_server + '/apply/delBuyApplyData';var del_process_apply = exports.del_process_apply = _EnvConfig.app_server + '/apply/delApplyDataProcess';var reset_process_apply = exports.reset_process_apply = _EnvConfig.app_server + '/apply/resetApplyDataProcess';var payRoll_contract_list = exports.payRoll_contract_list = _EnvConfig.app_server + '/payRoll/payRollContractPage';var payRoll_addPayRollContract = exports.payRoll_addPayRollContract = _EnvConfig.app_server + '/payRoll/addPayRollContract';var payRoll_savePayRollContract = exports.payRoll_savePayRollContract = _EnvConfig.app_server + '/payRoll/savePayRollContract';var payRoll_updatePayRollContract = exports.payRoll_updatePayRollContract = _EnvConfig.app_server + '/payRoll/updatePayRollContractInfo';var payRoll_getPayRollContractNo = exports.payRoll_getPayRollContractNo = _EnvConfig.app_server + '/payRoll/getPayRollContractNo';var payRoll_getSupplyList = exports.payRoll_getSupplyList = _EnvConfig.app_server + '/payRoll/getSupplierName';var addNewSupplier = exports.addNewSupplier = _EnvConfig.app_server + '/supplier/saveSupplier';var payRoll_branchName = exports.payRoll_branchName = _EnvConfig.app_server + '/payRoll/getSupplierBranchName';var payRoll_payRollContractInfo = exports.payRoll_payRollContractInfo = _EnvConfig.app_server + '/payRoll/payRollContractInfo';var payRoll_auditContract = exports.payRoll_auditContract = _EnvConfig.app_server + '/payRoll/auditContract';var payRoll_savePayRollInvoices = exports.payRoll_savePayRollInvoices = _EnvConfig.app_server + '/payRoll/savePayRollInvoices';var payRoll_getPayRollContractPageByProject = exports.payRoll_getPayRollContractPageByProject = _EnvConfig.app_server + '/payRoll/getPayRollContractPageByProject';var payRoll_savePayRollMarkContent = exports.payRoll_savePayRollMarkContent = _EnvConfig.app_server + '/payRoll/savePayRollMarkContent';var apply_seal_DataPage = exports.apply_seal_DataPage = _EnvConfig.app_server + '/applyData/getProjectSealApplyPage';var apply_seal_getProject = exports.apply_seal_getProject = _EnvConfig.app_server + '/applyData/getSealProjectPage';var apply_seal_get_detail = exports.apply_seal_get_detail = _EnvConfig.app_server + '/applyData/getProjectSealApplyInfo';var apply_seal_type = exports.apply_seal_type = _EnvConfig.app_server + '/applyData/getSealApplyType';var apply_seal_save = exports.apply_seal_save = _EnvConfig.app_server + '/applyData/saveSealApply';var exportPayRollContractPage = exports.exportPayRollContractPage = _EnvConfig.app_server + '/payRoll/exportPayRollContractPage';var apply_getLaborApplyPage = exports.apply_getLaborApplyPage = _EnvConfig.app_server + '/apply/getLaborApplyPage';var apply_getProjectByLabor = exports.apply_getProjectByLabor = _EnvConfig.app_server + '/apply/getProjectByLabor';var apply_getProjectDeductionsInfo = exports.apply_getProjectDeductionsInfo = _EnvConfig.app_server + '/apply/getProjectDeductionsInfo';var apply_laborOddNumbers = exports.apply_laborOddNumbers = _EnvConfig.app_server + '/apply/laborOddNumbers';var apply_addLaborApply = exports.apply_addLaborApply = _EnvConfig.app_server + '/apply/addLaborApply';var apply_saveLaborApply = exports.apply_saveLaborApply = _EnvConfig.app_server + '/apply/saveLaborApply';var apply_laborConfirmStatus = exports.apply_laborConfirmStatus = _EnvConfig.app_server + '/apply/laborConfirmStatus';var apply_laborApplyInfo = exports.apply_laborApplyInfo = _EnvConfig.app_server + '/apply/laborApplyInfo';var apply_addLaborPayment = exports.apply_addLaborPayment = _EnvConfig.app_server + '/apply/addLaborPayment';var apply_getProjectIncomeInfo = exports.apply_getProjectIncomeInfo = _EnvConfig.app_server + '/apply/getProjectIncomeInfo';var apply_editLaborApplyInfo = exports.apply_editLaborApplyInfo = _EnvConfig.app_server + '/apply/editLaborApplyInfo';var apply_delete_labor = exports.apply_delete_labor = _EnvConfig.app_server + '/apply/delete_labor';var disAgreeLaborApply = exports.disAgreeLaborApply = _EnvConfig.app_server + '/apply/disAgreeLaborApply';var changeLaborApply = exports.changeLaborApply = _EnvConfig.app_server + '/apply/changeLaborApply';var userBank_getDefaultUserBank = exports.userBank_getDefaultUserBank = _EnvConfig.app_server + '/userBank/getDefaultUserBank';var getSettleDefaultUserBank = exports.getSettleDefaultUserBank = _EnvConfig.app_server + '/userBank/getSettleDefaultUserBank';
var userBank_getUserBankList = exports.userBank_getUserBankList = _EnvConfig.app_server + '/userBank/getUserBankList';var userBank_saveUserBank = exports.userBank_saveUserBank = _EnvConfig.app_server + '/userBank/saveUserBank';var userBank_editBankAttach = exports.userBank_editBankAttach = _EnvConfig.app_server + '/userBank/editBankAttach';var finance_submitAudit = exports.finance_submitAudit = _EnvConfig.app_server + '/finance/submitAudit';var apply_getProjectDedOfBackRisk = exports.apply_getProjectDedOfBackRisk = _EnvConfig.app_server + '/apply/getProjectDedOfBackRisk';var advanceTax_getProjectInfo = exports.advanceTax_getProjectInfo = _EnvConfig.app_server + '/advanceTax/getProjectInfo';var finance_getApplyInfo = exports.finance_getApplyInfo = _EnvConfig.app_server + '/finance/getApplyInfo';var finance_doAudit = exports.finance_doAudit = _EnvConfig.app_server + '/finance/doAudit';var finance_modifyPayAmount = exports.finance_modifyPayAmount = _EnvConfig.app_server + '/finance/modifyPayAmount';var finance_doPay = exports.finance_doPay = _EnvConfig.app_server + '/finance/doPay';var finance_doDelete = exports.finance_doDelete = _EnvConfig.app_server + '/finance/doDelete';var editAdvanceTaxAmount = exports.editAdvanceTaxAmount = _EnvConfig.app_server + '/advanceTax/editAdvanceTaxAmount';var finance_print = exports.finance_print = _EnvConfig.app_server + '/finance/doPrint';var finance_disagreeApply = exports.finance_disagreeApply = _EnvConfig.app_server + '/finance/disagreeApply';var finance_changeApply = exports.finance_changeApply = _EnvConfig.app_server + '/finance/changeApply';var printApplyInfo = exports.printApplyInfo = _EnvConfig.app_server + '/apply/printApplyInfo';var apply_checkWorkerSalaryUploadData = exports.apply_checkWorkerSalaryUploadData = _EnvConfig.app_server + '/apply/checkWorkerSalaryUploadData';var credit_apply_list = exports.credit_apply_list = _EnvConfig.app_server + '/apply/getAddCreditPage';var credit_detail = exports.credit_detail = _EnvConfig.app_server + '/apply/getAddCreditInfo';var credit_apply_audit = exports.credit_apply_audit = _EnvConfig.app_server + '/apply/auditAddCredit';var getCreditOrderPage = exports.getCreditOrderPage = _EnvConfig.app_server + '/credit/getCreditOrderPage';var checkUserOrder = exports.checkUserOrder = _EnvConfig.app_server + '/apply/checkUserOrder';var auditCreditOrderByFM = exports.auditCreditOrderByFM = _EnvConfig.app_server + '/credit/auditCreditOrderByFM';var creditOrderPay = exports.creditOrderPay = _EnvConfig.app_server + '/credit/creditOrderPay';var getCreditOrderInfo = exports.getCreditOrderInfo = _EnvConfig.app_server + '/credit/getCreditOrderInfo';var getCreditOrderRepaymentList = exports.getCreditOrderRepaymentList = _EnvConfig.app_server + '/credit/getCreditOrderRepaymentList';var getCreditOrderGoodsList = exports.getCreditOrderGoodsList = _EnvConfig.app_server + '/credit/getCreditOrderGoodsList';var credit_pm_credit_list = exports.credit_pm_credit_list = _EnvConfig.app_server + '/credit/getPmCreditPage';var credit_pm_credit_info = exports.credit_pm_credit_info = _EnvConfig.app_server + '/credit/getPmCreditInfo';var credit_pm_credit_project_info = exports.credit_pm_credit_project_info = _EnvConfig.app_server + '/credit/getPmCreditProjectPage';var updateCreditAmount = exports.updateCreditAmount = _EnvConfig.app_server + '/apply/updateCreditAmount';var getCreditApplyPortrait = exports.getCreditApplyPortrait = _EnvConfig.app_server + '/apply/getCreditApplyPortrait';var updateCreditApplyPortrait = exports.updateCreditApplyPortrait = _EnvConfig.app_server + '/project/updateCreditProjectPortrait';var updateSysCreditApplyPortrait = exports.updateSysCreditApplyPortrait = _EnvConfig.app_server + '/project/updateSysCreditProjectPortrait';var auditCreditApplyPortrait = exports.auditCreditApplyPortrait = _EnvConfig.app_server + '/apply/auditCreditApplyPortrait';var getCreditPortraitAuditByPortraitId = exports.getCreditPortraitAuditByPortraitId = _EnvConfig.app_server + '/apply/getCreditPortraitAuditByPortraitId';var getCreditProjectPage = exports.getCreditProjectPage = _EnvConfig.app_server + '/credit/getCreditProjectPage';var getCreditApplyPortraitByProjectId = exports.getCreditApplyPortraitByProjectId = _EnvConfig.app_server + '/apply/getCreditApplyPortraitByProjectId';var get_credit_portrait = exports.get_credit_portrait = _EnvConfig.app_server + '/credit/getCreditPortrait';var creditApply_agree = exports.creditApply_agree = _EnvConfig.app_server + '/credit/agreeCreditApply';var creditApply_disagree = exports.creditApply_disagree = _EnvConfig.app_server + '/credit/disagreeCreditApply';var creditApply_return = exports.creditApply_return = _EnvConfig.app_server + '/credit/returnCreditApply';var creditApply_change = exports.creditApply_change = _EnvConfig.app_server + '/credit/changeCreditApply';var creditApply_deal = exports.creditApply_deal = _EnvConfig.app_server + '/credit/dealCreditApply';var creditApply_submit = exports.creditApply_submit = _EnvConfig.app_server + '/credit/submitCreditApply';var credit_restartCreditApply = exports.credit_restartCreditApply = _EnvConfig.app_server + '/credit/restartCreditApply';var payment_apply_list = exports.payment_apply_list = _EnvConfig.app_server + '/paymentRecords/page';var payment_apply_info = exports.payment_apply_info = _EnvConfig.app_server + '/paymentRecords/info';var common_save_attachment = exports.common_save_attachment = _EnvConfig.app_server + '/common/save_attachment';

var back_user_supervisor_list = exports.back_user_supervisor_list = _EnvConfig.app_server + '/back_user/backUser_page';var project_manage_list = exports.project_manage_list = _EnvConfig.app_server + '/projectManagement/project_management_page';var project_manage_info = exports.project_manage_info = _EnvConfig.app_server + '/projectManagement/project_management_info';var project_manage_assign_supervisor = exports.project_manage_assign_supervisor = _EnvConfig.app_server + '/projectManagement/add_project_management_supervisor';var project_manage_cancel_dispatch = exports.project_manage_cancel_dispatch = _EnvConfig.app_server + '/projectManagement/project_management_cancel_dispatch';var project_manage_cancel_audit = exports.project_manage_cancel_audit = _EnvConfig.app_server + '/projectManagement/project_management_cancel_audit';var project_manage_no_supervisors = exports.project_manage_no_supervisors = _EnvConfig.app_server + '/projectManagement/no_supervisors_to_project';var project_manage_monitoring_statistics = exports.project_manage_monitoring_statistics = _EnvConfig.app_server + '/projectManagement/project_monitoring_statistics';var project_get_play_table_list = exports.project_get_play_table_list = _EnvConfig.app_server + '/projectManagement/get_play_table_list';var project_get_play_table_list_info = exports.project_get_play_table_list_info = _EnvConfig.app_server + '/projectManagement/get_play_table';var project_monitoring_statistics_export = exports.project_monitoring_statistics_export = _EnvConfig.app_server + '/projectManagement/project_monitoring_statistics_export';var project_Guarantee_info = exports.project_Guarantee_info = _EnvConfig.app_server + '/guaranteeLetter/getGuaranteeLetterByListProject';var project_get_rollContract = exports.project_get_rollContract = _EnvConfig.app_server + '/project/getPayRollContractInfoListByProject';var project_get_billMaterials = exports.project_get_billMaterials = _EnvConfig.app_server + '/project/getBillMaterialsListByProject';var guaranteeLetter_addGuaranteeLetter = exports.guaranteeLetter_addGuaranteeLetter = _EnvConfig.app_server + '/guaranteeLetter/addGuaranteeLetter';var getCategoryId = exports.getCategoryId = _EnvConfig.app_server + '/insurance/getCategoryId';

var project_manager_monitoring_statistics = exports.project_manager_monitoring_statistics = _EnvConfig.app_server + '/projectManagement/project_manager_monitoring_statistics';var project_manager_monitoring_statistics_export = exports.project_manager_monitoring_statistics_export = _EnvConfig.app_server + '/projectManagement/project_manager_monitoring_statistics_export';var project_return_page = exports.project_return_page = _EnvConfig.app_server + '/projectManagement/project_return_page';var project_return_export = exports.project_return_export = _EnvConfig.app_server + '/projectManagement/project_return_export';var project_manage__KPI_statistics = exports.project_manage__KPI_statistics = _EnvConfig.app_server + '/projectManagement/supervisor_KPI_statistics';var project_manager_KPI_statistics_export = exports.project_manager_KPI_statistics_export = _EnvConfig.app_server + '/projectManagement/supervisor_KPI_statistics_export';var project_updateConstructionSpecification = exports.project_updateConstructionSpecification = _EnvConfig.app_server + '/contractInfo/updateConstructionSpecification';var project_getDeviceListById = exports.project_getDeviceListById = _EnvConfig.app_server + '/projectDevice/getDeviceListById';var project_addProjectMonitorSnapshot = exports.project_addProjectMonitorSnapshot = _EnvConfig.app_server + '/projectDevice/addProjectMonitorSnapshot';var project_getProjectMonitorInfoById = exports.project_getProjectMonitorInfoById = _EnvConfig.app_server + '/projectDevice/getProjectMonitorInfoById';var openEquipment = exports.openEquipment = _EnvConfig.app_server + '/projectDevice/OpenEquipment';var project_getProjectExList = exports.project_getProjectExList = _EnvConfig.app_server + '/project/getProjectExList';var projectHonor_saveProjectHonor = exports.projectHonor_saveProjectHonor = _EnvConfig.app_server + '/projectHonor/saveProjectHonor';var projectHonor_getProjectHonorByProjectId = exports.projectHonor_getProjectHonorByProjectId = _EnvConfig.app_server + '/projectHonor/getProjectHonorByProjectId';var project_getProjectMaterialList = exports.project_getProjectMaterialList = _EnvConfig.app_server + '/project/getProjectMaterialList';var project_getProjectMaterialDetail = exports.project_getProjectMaterialDetail = _EnvConfig.app_server + '/project/getProjectMaterialDetail';var project_getProjectMaterialProductPage = exports.project_getProjectMaterialProductPage = _EnvConfig.app_server + '/project/getProjectMaterialProductPage';var projectDispatchPerson_getDispatchPersonPage = exports.projectDispatchPerson_getDispatchPersonPage = _EnvConfig.app_server + '/projectDispatchPerson/getDispatchPersonPage';var projectManagement_editProjectDispatch = exports.projectManagement_editProjectDispatch = _EnvConfig.app_server + '/projectManagement/editProjectDispatch';var projectDispatchPerson_getProjectDispatchPersonInfo = exports.projectDispatchPerson_getProjectDispatchPersonInfo = _EnvConfig.app_server + '/projectDispatchPerson/getProjectDispatchPersonInfo';var projectDispatchPerson_getProjectDispatchPersonRecord = exports.projectDispatchPerson_getProjectDispatchPersonRecord = _EnvConfig.app_server + '/projectDispatchPerson/getProjectDispatchPersonRecord';var attendance_getWorkerInfoList = exports.attendance_getWorkerInfoList = _EnvConfig.app_server + '/attendance/getWorkerInfoList';var attendance_getUnitList = exports.attendance_getUnitList = _EnvConfig.app_server + '/attendance/getUnitList';var attendance_getTeamList = exports.attendance_getTeamList = _EnvConfig.app_server + '/attendance/getTeamList';var attendance_addProjectUnit = exports.attendance_addProjectUnit = _EnvConfig.app_server + '/attendance/addProjectUnit';var attendance_addProjectUnitTeam = exports.attendance_addProjectUnitTeam = _EnvConfig.app_server + '/attendance/addProjectUnitTeam';var attendance_getEditWorkerInfo = exports.attendance_getEditWorkerInfo = _EnvConfig.app_server + '/attendance/editPerson';var attendance_getPersonInfoByIdcardNo = exports.attendance_getPersonInfoByIdcardNo = _EnvConfig.app_server + '/attendance/getPersonInfoByIdcardNo';var attendance_getOccupationCategoryList = exports.attendance_getOccupationCategoryList = _EnvConfig.app_server + '/attendance/getOccupationCategoryList';var attendance_addWorker = exports.attendance_addWorker = _EnvConfig.app_server + '/attendance/addWorker';var attendance_createQrCode = exports.attendance_createQrCode = _EnvConfig.app_server + '/attendance/createQrCode';var attendance_getAttendanceRecordList = exports.attendance_getAttendanceRecordList = _EnvConfig.app_server + '/attendance/getAttendanceRecordList';var attendance_multiImport = exports.attendance_multiImport = _EnvConfig.app_server + '/attendance/submitUploadPersonInfo';var attendance_checkWorkerData = exports.attendance_checkWorkerData = _EnvConfig.app_server + '/attendance/saveUploadPersonInfo';var attendance_editGradeAndScore = exports.attendance_editGradeAndScore = _EnvConfig.app_server + '/attendance/editGradeAndScore';var attendance_getWorkerIssueList = exports.attendance_getWorkerIssueList = _EnvConfig.app_server + '/attendance/getWorkerIssueList';var attendance_addWorkerIssue = exports.attendance_addWorkerIssue = _EnvConfig.app_server + '/attendance/addWorkerIssue';var attendance_releaseWorkerIssue = exports.attendance_releaseWorkerIssue = _EnvConfig.app_server + '/attendance/releaseWorkerIssue';var attendance_editWorkerIssue = exports.attendance_editWorkerIssue = _EnvConfig.app_server + '/attendance/editWorkerIssue';var attendance_deleteWorkerIssue = exports.attendance_deleteWorkerIssue = _EnvConfig.app_server + '/attendance/deleteWorkerIssue';var attendance_updatePersonInfo = exports.attendance_updatePersonInfo = _EnvConfig.app_server + '/attendance/updatePersonInfo';var worker_salary_pageInfo = exports.worker_salary_pageInfo = _EnvConfig.app_server + '/workerSalary/getWorkerSalaryPage';var exportAttendanceRecord = exports.exportAttendanceRecord = _EnvConfig.app_server + '/attendance/exportAttendanceRecord';var getAttendanceDeviceListByProjectId = exports.getAttendanceDeviceListByProjectId = _EnvConfig.app_server + '/attendanceDevice/getAttendanceDeviceListByProjectId';var getChooseAttendanceDeviceList = exports.getChooseAttendanceDeviceList = _EnvConfig.app_server + '/attendanceDevice/getChooseAttendanceDeviceList';var stopAttendanceDeviceById = exports.stopAttendanceDeviceById = _EnvConfig.app_server + '/attendanceDevice/stopAttendanceDeviceById';var delAttendanceDeviceById = exports.delAttendanceDeviceById = _EnvConfig.app_server + '/attendanceDevice/delAttendanceDeviceById';var addAttendanceDeviceByProjectId = exports.addAttendanceDeviceByProjectId = _EnvConfig.app_server + '/attendanceDevice/addAttendanceDeviceByProjectId';

var attendance_allWorkerInfoList = exports.attendance_allWorkerInfoList = _EnvConfig.app_server + '/attendance/allWorkerInfoList';var attendance_workerDetailsInfo = exports.attendance_workerDetailsInfo = _EnvConfig.app_server + '/attendance/workerDetailsInfo';var attendance_projectExperienceList = exports.attendance_projectExperienceList = _EnvConfig.app_server + '/attendance/projectExperienceList';var getStampPage = exports.getStampPage = _EnvConfig.app_server + '/pc/stampData/getStampPage';var getDetail = exports.getDetail = _EnvConfig.app_server + '/pc/stampData/getDetail';var project_manage_export = exports.project_manage_export = _EnvConfig.app_server + '/projectManagement/project_management_page_export';var project_commission_export = exports.project_commission_export = _EnvConfig.app_server + '/sysAllowanceDetail/exportSysAllowanceBySUPV';var findInvoiceList = exports.findInvoiceList = _EnvConfig.app_server + '/apply/findInvoiceList';var exportSalesTicketList = exports.exportSalesTicketList = _EnvConfig.app_server + '/apply/exportSalesTicketList';var findProjectContractList = exports.findProjectContractList = _EnvConfig.app_server + '/project/findProjectContractList';var invoice_findBillingProjectList = exports.invoice_findBillingProjectList = _EnvConfig.app_server + '/invoice/findBillingProjectList';var invoice_findBillingProjectById = exports.invoice_findBillingProjectById = _EnvConfig.app_server + '/invoice/findBillingProjectById';var enum_data_find_invoice_content_type = exports.enum_data_find_invoice_content_type = _EnvConfig.app_server + '/enum_data/find_invoice_content_type';var invoice_saveInvoiceApply = exports.invoice_saveInvoiceApply = _EnvConfig.app_server + '/invoice/saveInvoiceApply';var invoice_getInvoiceApplyPage = exports.invoice_getInvoiceApplyPage = _EnvConfig.app_server + '/invoice/getInvoiceApplyPage';var invoice_getInvoiceApplyInfo = exports.invoice_getInvoiceApplyInfo = _EnvConfig.app_server + '/invoice/getInvoiceApplyInfo';var invoice_checkInvoiceNos = exports.invoice_checkInvoiceNos = _EnvConfig.app_server + '/invoice/checkInvoiceNos';var invoice_saveInvoiceNo = exports.invoice_saveInvoiceNo = _EnvConfig.app_server + '/invoice/saveInvoiceNo';var invoice_deleteInvoiceApply = exports.invoice_deleteInvoiceApply = _EnvConfig.app_server + '/invoice/deleteInvoiceApply';var invoice_auditInvoiceApply = exports.invoice_auditInvoiceApply = _EnvConfig.app_server + '/invoice/auditInvoiceApply';var invoice_invoiceApply_page_export = exports.invoice_invoiceApply_page_export = _EnvConfig.app_server + '/invoice/invoiceApply_page_export';var invoice_findNewestInvoiceByProjectId = exports.invoice_findNewestInvoiceByProjectId = _EnvConfig.app_server + '/invoice/findNewestInvoiceByProjectId';var invoice_agree = exports.invoice_agree = _EnvConfig.app_server + '/invoiceApplyData/agreeInvoiceApplyData';var invoice_disagree = exports.invoice_disagree = _EnvConfig.app_server + '/invoiceApplyData/disagreeInvoiceApplyData';var invoice_change = exports.invoice_change = _EnvConfig.app_server + '/invoiceApplyData/changeInvoiceApplyData';var invoice_return = exports.invoice_return = _EnvConfig.app_server + '/invoiceApplyData/returnInvoiceApplyData';var invoice_complete = exports.invoice_complete = _EnvConfig.app_server + '/invoiceApplyData/completeInvoiceApplyData';var invoice_saveVoidApply = exports.invoice_saveVoidApply = _EnvConfig.app_server + '/invoice/saveVoidApply';var invoice_saveRedPunchApply = exports.invoice_saveRedPunchApply = _EnvConfig.app_server + '/invoice/saveRedPunchApply';var invoice_getVoidApplyInfo = exports.invoice_getVoidApplyInfo = _EnvConfig.app_server + '/invoice/getVoidApplyInfo';var invoice_agree_red_rush = exports.invoice_agree_red_rush = _EnvConfig.app_server + '/invoiceApplyData/agreeInvoiceApplyDataRedRush';var invoice_disagree_red_rush = exports.invoice_disagree_red_rush = _EnvConfig.app_server + '/invoiceApplyData/disagreeInvoiceApplyDataRedRush';var invoice_return_red_rush = exports.invoice_return_red_rush = _EnvConfig.app_server + '/invoiceApplyData/returnInvoiceApplyDataRedRush';var invoice_change_red_rush = exports.invoice_change_red_rush = _EnvConfig.app_server + '/invoiceApplyData/changeInvoiceApplyDataRedRush';var invoice_complete_red_rush = exports.invoice_complete_red_rush = _EnvConfig.app_server + '/invoiceApplyData/completeInvoiceApplyDataRedRush';var invoice_restartInvoiceApplyDataBizItemId = exports.invoice_restartInvoiceApplyDataBizItemId = _EnvConfig.app_server + '/invoice/restartInvoiceApplyDataBizItemId';var invoice_deleteInvoiceApplyData = exports.invoice_deleteInvoiceApplyData = _EnvConfig.app_server + '/invoice/deleteInvoiceApplyData';var invoice_confirmVoid = exports.invoice_confirmVoid = _EnvConfig.app_server + '/invoice/confirmVoid';var invoice_agree_void = exports.invoice_agree_void = _EnvConfig.app_server + '/invoiceApplyData/agreeInvoiceApplyDataVoid';var invoice_disagree_void = exports.invoice_disagree_void = _EnvConfig.app_server + '/invoiceApplyData/disagreeInvoiceApplyDataVoid';var invoice_return_void = exports.invoice_return_void = _EnvConfig.app_server + '/invoiceApplyData/returnInvoiceApplyDataVoid';var invoice_change_void = exports.invoice_change_void = _EnvConfig.app_server + '/invoiceApplyData/changeInvoiceApplyDataVoid';var invoice_complete_void = exports.invoice_complete_void = _EnvConfig.app_server + '/invoiceApplyData/completeInvoiceApplyDataVoid';var findProjectContractInfo = exports.findProjectContractInfo = _EnvConfig.app_server + '/project/findProjectContractInfo';var checkExcelSalesTicket = exports.checkExcelSalesTicket = _EnvConfig.app_server + '/apply/checkExcelSalesTicket';var batchExportSalesTicketUnsuccessList = exports.batchExportSalesTicketUnsuccessList = _EnvConfig.app_server + '/apply/batchExportSalesTicketUnsuccessList';var batchImportSalesTicket = exports.batchImportSalesTicket = _EnvConfig.app_server + '/apply/batchImportSalesTicket';var addSalesTicket = exports.addSalesTicket = _EnvConfig.app_server + '/apply/addSalesTicket';var materialTicketList = exports.materialTicketList = _EnvConfig.app_server + '/materialTicketInfo/getMaterialTicketInfoPage';var getMaterialTicketProject = exports.getMaterialTicketProject = _EnvConfig.app_server + '/materialTicket/getMaterialTicketProject';var getMaterialTicketPurchace = exports.getMaterialTicketPurchace = _EnvConfig.app_server + '/materialTicket/getMaterialTicketPurchace';
var saveMaterialTicketApply = exports.saveMaterialTicketApply = _EnvConfig.app_server + '/materialTicket/saveMaterialTicketApply';var getMaterialTicketInfo = exports.getMaterialTicketInfo = _EnvConfig.app_server + '/materialTicketInfo/getMaterialTicketInfo';var delMaterialTicketInfo = exports.delMaterialTicketInfo = _EnvConfig.app_server + '/materialTicketInfo/delMaterialTicketInfo';var exportMaterialTicketInfoPage = exports.exportMaterialTicketInfoPage = _EnvConfig.app_server + '/materialTicketInfo/exportMaterialTicketInfoPage';var auditMaterialTicketApply = exports.auditMaterialTicketApply = _EnvConfig.app_server + '/materialTicket/auditMaterialTicketApply';var relevanceMaterial = exports.relevanceMaterial = _EnvConfig.app_server + '/materialTicket/relevanceMaterial';var materialTicket_check_upload = exports.materialTicket_check_upload = _EnvConfig.app_server + '/materialTicket/checkUploadTicketData';var materialTicket_repeat = exports.materialTicket_repeat = _EnvConfig.app_server + '/materialTicket/comparisonRepeatMaterialTicket';var materialTicket_export_errorData = exports.materialTicket_export_errorData = _EnvConfig.app_server + '/materialTicket/exportMaterialTicketErrorData';var materialTicket_saveUpload = exports.materialTicket_saveUpload = _EnvConfig.app_server + '/materialTicket/saveUploadMaterialTicket';var apply_projectByBidBond = exports.apply_projectByBidBond = _EnvConfig.app_server + '/apply/projectByBidBond';var apply_saveBidBond = exports.apply_saveBidBond = _EnvConfig.app_server + '/apply/saveBidBond';var apply_realEstate_collateral_info = exports.apply_realEstate_collateral_info = _EnvConfig.app_server + '/apply/realEstate_collateral_info';var project_getStylistPro = exports.project_getStylistPro = _EnvConfig.app_server + '/project/getStylistPro';var project_getContractInfoPro = exports.project_getContractInfoPro = _EnvConfig.app_server + '/project/getContractInfoPro';var project_stylistContractInfoExcel = exports.project_stylistContractInfoExcel = _EnvConfig.app_server + '/contractInfo/stylistContractInfoExcel';var flie_workingAndFinish = exports.flie_workingAndFinish = _EnvConfig.app_server + '/project/workingAndFinish';var flie_projectDocDir = exports.flie_projectDocDir = _EnvConfig.app_server + '/project/projectDocDir';var flie_projectDocFile = exports.flie_projectDocFile = _EnvConfig.app_server + '/project/projectDocFile';var flie_delete = exports.flie_delete = _EnvConfig.app_server + '/project/deleteProjectDocFile';var flie_saveDocFile = exports.flie_saveDocFile = _EnvConfig.app_server + '/project/saveDocFile';var find_by_idCard = exports.find_by_idCard = _EnvConfig.app_server + '/proManager/findByIdCard';var project_saveDocFileBatch = exports.project_saveDocFileBatch = _EnvConfig.app_server + '/project/saveDocFileBatch';var authorizationToAppJump = exports.authorizationToAppJump = _EnvConfig.app_server + '/authorizationToAppJump';var complaint_getComplaintTypeCats = exports.complaint_getComplaintTypeCats = _EnvConfig.app_server + '/complaint/getComplaintTypeCats';var complaint_page_date = exports.complaint_page_date = _EnvConfig.app_server + '/complaint/page_date';var proManager_getComplaintsProManagerPage = exports.proManager_getComplaintsProManagerPage = _EnvConfig.app_server + '/proManager/getComplaintsProManagerPage';var project_getComplaintProject = exports.project_getComplaintProject = _EnvConfig.app_server + '/project/getComplaintProject';var complaint_saveOrEdit = exports.complaint_saveOrEdit = _EnvConfig.app_server + '/complaint/saveOrEdit';var complaint_complainantDetail = exports.complaint_complainantDetail = _EnvConfig.app_server + '/complaint/complainantDetail';var complaint_invalid = exports.complaint_invalid = _EnvConfig.app_server + '/complaint/invalid';var complaint_dispatch = exports.complaint_dispatch = _EnvConfig.app_server + '/complaint/dispatch';var complaint_dealwithUser = exports.complaint_dealwithUser = _EnvConfig.app_server + '/complaint/dealwithUser';var complaint_dealwith = exports.complaint_dealwith = _EnvConfig.app_server + '/complaint/dealwith';var complaint_frozen = exports.complaint_frozen = _EnvConfig.app_server + '/complaint/frozen';var complaint_getPMComplaint = exports.complaint_getPMComplaint = _EnvConfig.app_server + '/complaint/getPMComplaint';var report_finance_statistics_summary_print = exports.report_finance_statistics_summary_print = _EnvConfig.app_server + '/report/finance_statistics_summary_print';var apply_addOtherAmount = exports.apply_addOtherAmount = _EnvConfig.app_server + '/apply/addOtherAmount';var complaint_saveDealWith = exports.complaint_saveDealWith = _EnvConfig.app_server + '/complaint/saveDealWith';var complaint_returnComplaint = exports.complaint_returnComplaint = _EnvConfig.app_server + '/complaint/returnComplaint';var complaint_grade = exports.complaint_grade = _EnvConfig.app_server + '/complaint/grade';var complaint_completeComplaint = exports.complaint_completeComplaint = _EnvConfig.app_server + '/complaint/completeComplaint';var complaint_agreeComplaint = exports.complaint_agreeComplaint = _EnvConfig.app_server + '/complaint/agreeComplaint';var complaint_disagreeComplaint = exports.complaint_disagreeComplaint = _EnvConfig.app_server + '/complaint/disagreeComplaint';var complaint_changeComplaint = exports.complaint_changeComplaint = _EnvConfig.app_server + '/complaint/changeComplaint';var complaint_returnComplaints = exports.complaint_returnComplaints = _EnvConfig.app_server + '/complaint/returnComplaints';var complaint_sumbitComplaint = exports.complaint_sumbitComplaint = _EnvConfig.app_server + '/complaint/sumbitComplaint';var complaint_restartComplaintApply = exports.complaint_restartComplaintApply = _EnvConfig.app_server + '/complaint/restartComplaintApply';var complaint_deleteComplaintApply = exports.complaint_deleteComplaintApply = _EnvConfig.app_server + '/complaint/deleteComplaintApply';var litigation_getProjectPage = exports.litigation_getProjectPage = _EnvConfig.app_server + '/projectLitigation/getProjectPage';var addProjectLitigation = exports.addProjectLitigation = _EnvConfig.app_server + '/projectLitigation/addProjectLitigation';var saveProjectLitigation = exports.saveProjectLitigation = _EnvConfig.app_server + '/projectLitigation/saveProjectLitigation';var getProjectLitigationPage = exports.getProjectLitigationPage = _EnvConfig.app_server + '/projectLitigation/getProjectLitigationPage';var getProjectLitigationTreatment = exports.getProjectLitigationTreatment = _EnvConfig.app_server + '/projectLitigation/getProjectLitigationTreatment';var updateLitigationHandlePerson = exports.updateLitigationHandlePerson = _EnvConfig.app_server + '/projectLitigation/updateLitigationHandlePerson';var addLitigationTreatmentScheme = exports.addLitigationTreatmentScheme = _EnvConfig.app_server + '/projectLitigation/addLitigationTreatmentScheme';var updateLitigationResult = exports.updateLitigationResult = _EnvConfig.app_server + '/projectLitigation/updateLitigationResult';var delProjectLitigation = exports.delProjectLitigation = _EnvConfig.app_server + '/projectLitigation/delProjectLitigation';var getLitigationInfo = exports.getLitigationInfo = _EnvConfig.app_server + '/projectLitigation/getLitigationInfo';var auditProjectLitigation = exports.auditProjectLitigation = _EnvConfig.app_server + '/projectLitigation/auditProjectLitigation';var casualty_grade = exports.casualty_grade = _EnvConfig.app_server + '/casualtyReport/grade';var projectLitigation_restartLitigationApply = exports.projectLitigation_restartLitigationApply = _EnvConfig.app_server + '/projectLitigation/restartLitigationApply';var projectLitigation_delProjectLitigation = exports.projectLitigation_delProjectLitigation = _EnvConfig.app_server + '/projectLitigation/delProjectLitigation';var getIssuePage = exports.getIssuePage = _EnvConfig.app_server + '/issue/getIssuePage';var issue_editIssue = exports.issue_editIssue = _EnvConfig.app_server + '/issue/editIssue';var issue_deleteIssue = exports.issue_deleteIssue = _EnvConfig.app_server + '/issue/deleteIssue';var issue_releaseIssue = exports.issue_releaseIssue = _EnvConfig.app_server + '/issue/releaseIssue';var issut_workerList = exports.issut_workerList = _EnvConfig.app_server + '/attendance/getWorkerList';var get_project_punishment_list = exports.get_project_punishment_list = _EnvConfig.app_server + '/projectPunishment/getProjectPunishmentPage';var update_punishment = exports.update_punishment = _EnvConfig.app_server + '/projectPunishment/updatePunishment';var addPunishmentTreatmentScheme = exports.addPunishmentTreatmentScheme = _EnvConfig.app_server + '/projectPunishment/addPunishmentTreatmentScheme';var add_project_punishment = exports.add_project_punishment = _EnvConfig.app_server + '/projectPunishment/addProjectPunishment';var save_project_punishment = exports.save_project_punishment = _EnvConfig.app_server + '/projectPunishment/saveProjectPunishment';var delProjectPunishment = exports.delProjectPunishment = _EnvConfig.app_server + '//projectPunishment/delProjectPunishment';var getProjectPunishmentInfo = exports.getProjectPunishmentInfo = _EnvConfig.app_server + '/projectPunishment/getProjectPunishmentInfo';var auditProjectPunishment = exports.auditProjectPunishment = _EnvConfig.app_server + '/projectPunishment/auditProjectPunishment';var feedbackList = exports.feedbackList = _EnvConfig.app_server + '/feedback/getFeedback';var updateFeedback = exports.updateFeedback = _EnvConfig.app_server + '/feedback/updateFeedback';var projectPunishment_restartPunishmentApply = exports.projectPunishment_restartPunishmentApply = _EnvConfig.app_server + '/projectPunishment/restartPunishmentApply';var projectPunishment_delProjectPunishment = exports.projectPunishment_delProjectPunishment = _EnvConfig.app_server + '/projectPunishment/delProjectPunishment';var data_all_pm = exports.data_all_pm = _EnvConfig.app_server + '/data/all_pm';var project_record = exports.project_record = _EnvConfig.app_server + '/project/record';var get_project_page = exports.get_project_page = _EnvConfig.app_server + '/projectPunishment/getProjectPage';var get_report_orgList = exports.get_report_orgList = _EnvConfig.app_server + '/reportOrg/getReportOrgList';var get_operation_report_menu = exports.get_operation_report_menu = _EnvConfig.app_server + '/reportItem/getReportItemMenu';var get_report_item = exports.get_report_item = _EnvConfig.app_server + '/reportItem/getReportItemData';var sealApplyAgreeOtherSealApply = exports.sealApplyAgreeOtherSealApply = _EnvConfig.app_server + '/sealApply/agreeOtherSealApply';var sealApplyDisagreeOtherSealApply = exports.sealApplyDisagreeOtherSealApply = _EnvConfig.app_server + '/sealApply/disagreeOtherSealApply';var sealApplyReturnCustomFlowOtherSealApply = exports.sealApplyReturnCustomFlowOtherSealApply = _EnvConfig.app_server + '/sealApply/returnCustomFlowOtherSealApply';var sealApplyChangeOtherSealApply = exports.sealApplyChangeOtherSealApply = _EnvConfig.app_server + '/sealApply/changeOtherSealApply';var sealApplyDelOtherSealApply = exports.sealApplyDelOtherSealApply = _EnvConfig.app_server + '/sealApply/delOtherSealApply';var sealApplyQueryOtherSealApply = exports.sealApplyQueryOtherSealApply = _EnvConfig.app_server + '/sealApply/queryOtherSealApply';var sealApplySubmitOtherSealApply = exports.sealApplySubmitOtherSealApply = _EnvConfig.app_server + '/sealApply/submitOtherSealApply';var sealApplySaveOtherSealApply = exports.sealApplySaveOtherSealApply = _EnvConfig.app_server + '/sealApply/saveOtherSealApply';var sealApplyGetOtherSealApplyPage = exports.sealApplyGetOtherSealApplyPage = _EnvConfig.app_server + '/sealApply/getOtherSealApplyPage';var get_sealApply_file_category = exports.get_sealApply_file_category = _EnvConfig.app_server + '/enum_data/getSealApplyFileCategory';var get_flow_node = exports.get_flow_node = _EnvConfig.app_server + '/flow/getFlowNodeOps';var get_flow_process_progress = exports.get_flow_process_progress = _EnvConfig.app_server + '/flow/getFlowProcessProgressOps';var get_sealApply_category = exports.get_sealApply_category = _EnvConfig.app_server + '/enum_data/getEnumDataByLabel';var get_approve_project = exports.get_approve_project = _EnvConfig.app_server + '/project/getApproveProjectBySignPage';var update_other_sealapply = exports.update_other_sealapply = _EnvConfig.app_server + '/sealApply/updateOtherSealApply';
var save_sealApply = exports.save_sealApply = _EnvConfig.app_server + '/sealApply/saveSealApply';var submit_sealApply = exports.submit_sealApply = _EnvConfig.app_server + '/sealApply/submitSealApply';var query_sealApply = exports.query_sealApply = _EnvConfig.app_server + '/sealApply/querySealApply';var get_sealApply_page = exports.get_sealApply_page = _EnvConfig.app_server + '/sealApply/getSealApplyPage';var get_return_list = exports.get_return_list = _EnvConfig.app_server + '/flow/getReturnNodeListByBizItemId';var get_employees_account = exports.get_employees_account = _EnvConfig.app_server + '/back_user/getEmployeesAccount';var agree_sealApply = exports.agree_sealApply = _EnvConfig.app_server + '/sealApply/agreeSealApply';var disagree_sealApply = exports.disagree_sealApply = _EnvConfig.app_server + '/sealApply/disagreeSealApply';var change_sealApply = exports.change_sealApply = _EnvConfig.app_server + '/sealApply/changeSealApply';var return_flow_sealApply = exports.return_flow_sealApply = _EnvConfig.app_server + '/sealApply/returnCustomFlowSealApply';var del_sealApply = exports.del_sealApply = _EnvConfig.app_server + '/sealApply/delSealApply';var sealApply_recycleExecute = exports.sealApply_recycleExecute = _EnvConfig.app_server + '/sealApply/recycleExecute';var disagree_project_manager = exports.disagree_project_manager = _EnvConfig.app_server + '/projectManager/disagreeProjectManager';
var agree_project_manager = exports.agree_project_manager = _EnvConfig.app_server + '/projectManager/agreeProjectManager';
var change_project_manager = exports.change_project_manager = _EnvConfig.app_server + '/projectManager/changeProjectManager';
var return_project_manager = exports.return_project_manager = _EnvConfig.app_server + '/projectManager/returnProjectManager';
var complete_project_manager = exports.complete_project_manager = _EnvConfig.app_server + '/projectManager/completeProjectManager';
var get_cm_list = exports.get_cm_list = _EnvConfig.app_server + '/proManager/backUserProjectManager_cm';
var sealApply_attaches = exports.sealApply_attaches = _EnvConfig.app_server + '/sealApply/getSealApplyAttaches';var update_pm_phone = exports.update_pm_phone = _EnvConfig.app_server + '/proManager/updatePmPhone';

var sealApply_restartSealApply = exports.sealApply_restartSealApply = _EnvConfig.app_server + '/sealApply/restartSealApply';var sealApply_deleteRecycle = exports.sealApply_deleteRecycle = _EnvConfig.app_server + '/sealApply/deleteRecycle';var addPersonInfo = exports.addPersonInfo = _EnvConfig.app_server + '/personInfo/addPersonInfo';var getPersonInfoPage = exports.getPersonInfoPage = _EnvConfig.app_server + '/personInfo/getPersonInfoPage';var getPersonInfoById = exports.getPersonInfoById = _EnvConfig.app_server + '/personInfo/getPersonInfoById';var delPersonInfoById = exports.delPersonInfoById = _EnvConfig.app_server + '/personInfo/delPersonInfoById';var addQualificationCertificate = exports.addQualificationCertificate = _EnvConfig.app_server + '/qualificationCertificate/addQualificationCertificate';var getQualificationCertificateList = exports.getQualificationCertificateList = _EnvConfig.app_server + '/qualificationCertificate/getQualificationCertificateList';var delQualificationCertificatebyId = exports.delQualificationCertificatebyId = _EnvConfig.app_server + '/qualificationCertificate/delQualificationCertificatebyId';var getCertificateApplyByPersonIdPage = exports.getCertificateApplyByPersonIdPage = _EnvConfig.app_server + '/certificateApply/getCertificateApplyByPersonIdPage';var releasedCertificateApplyById = exports.releasedCertificateApplyById = _EnvConfig.app_server + '/certificateApply/releasedCertificateApplyById';var getOverdueQualificationCertificatePage = exports.getOverdueQualificationCertificatePage = _EnvConfig.app_server + '/qualificationCertificate/getOverdueQualificationCertificatePage';var addCertificateApply = exports.addCertificateApply = _EnvConfig.app_server + '/certificateApply/addCertificateApply';var getRegisterTypeQualificationCertificateList = exports.getRegisterTypeQualificationCertificateList = _EnvConfig.app_server + '/qualificationCertificate/getRegisterTypeQualificationCertificateList';var getManageTypeQualificationCertificateList = exports.getManageTypeQualificationCertificateList = _EnvConfig.app_server + '/qualificationCertificate/getManageTypeQualificationCertificateList';var getRegisterQualificationCertificatePage = exports.getRegisterQualificationCertificatePage = _EnvConfig.app_server + '/qualificationCertificate/getRegisterQualificationCertificatePage';var getManageQualificationCertificatePage = exports.getManageQualificationCertificatePage = _EnvConfig.app_server + '/qualificationCertificate/getManageQualificationCertificatePage';var getSkillQualificationCertificatePage = exports.getSkillQualificationCertificatePage = _EnvConfig.app_server + '/qualificationCertificate/getSkillQualificationCertificatePage';var certificateApply_getProjectPage = exports.certificateApply_getProjectPage = _EnvConfig.app_server + '/certificateApply/getProjectPage';var qualificationCertificate_getManageMajorType = exports.qualificationCertificate_getManageMajorType = _EnvConfig.app_server + '/qualificationCertificate/getManageMajorType';var getSafetyTypeQualificationCertificateList = exports.getSafetyTypeQualificationCertificateList = _EnvConfig.app_server + '/qualificationCertificate/getSafetyTypeQualificationCertificateList';var getTitleTypeQualificationCertificateList = exports.getTitleTypeQualificationCertificateList = _EnvConfig.app_server + '/qualificationCertificate/getTitleTypeQualificationCertificateList';var getSafetyTypeQualificationCertificatePage = exports.getSafetyTypeQualificationCertificatePage = _EnvConfig.app_server + '/qualificationCertificate/getSafetyTypeQualificationCertificatePage';var getTitleTypeQualificationCertificatePage = exports.getTitleTypeQualificationCertificatePage = _EnvConfig.app_server + '/qualificationCertificate/getTitleTypeQualificationCertificatePage';var validation_rules = exports.validation_rules = _EnvConfig.app_server + '/apply/checkBacklogForProject';var getEchartsSyntheticReportDataByLine = exports.getEchartsSyntheticReportDataByLine = _EnvConfig.app_server + '/reportItem/getEchartsSyntheticReportDataByLine';var getEchartsProjectReportDataByLine = exports.getEchartsProjectReportDataByLine = _EnvConfig.app_server + '/reportItem/getEchartsProjectReportDataByLine';var getAuthorizeBackRole = exports.getAuthorizeBackRole = _EnvConfig.app_server + '/authorizeBackRole';var getXappReportMenuByRole = exports.getXappReportMenuByRole = _EnvConfig.app_server + '/sysMenu/getXappReportMenuByRole';
var getEchartsReportItemDataByCustomer = exports.getEchartsReportItemDataByCustomer = _EnvConfig.app_server + '/reportItem/getEchartsReportItemDataByCustomer';var getEchartsCustomerCountReportItemData = exports.getEchartsCustomerCountReportItemData = _EnvConfig.app_server + '/reportItem/getEchartsCustomerCountReportItemData';var getEchartsCustomerNatureReportItemData = exports.getEchartsCustomerNatureReportItemData = _EnvConfig.app_server + '/reportItem/getEchartsCustomerNatureReportItemData';var getEchartsCustomerIndustryReportItemData = exports.getEchartsCustomerIndustryReportItemData = _EnvConfig.app_server + '/reportItem/getEchartsCustomerIndustryReportItemData';var getEchartsRegisterReportItemData = exports.getEchartsRegisterReportItemData = _EnvConfig.app_server + '/reportItem/getEchartsRegisterReportItemData';var getEchartsStatusCountReportItemData = exports.getEchartsStatusCountReportItemData = _EnvConfig.app_server + '/reportItem/getEchartsStatusCountReportItemData';var getEchartsChargeReportItemData = exports.getEchartsChargeReportItemData = _EnvConfig.app_server + '/reportItem/getEchartsChargeReportItemData';var getEchartsReportItemDataByElite = exports.getEchartsReportItemDataByElite = _EnvConfig.app_server + '/reportItem/getEchartsReportItemDataByElite';var getEchartsTalentsCountReportItemData = exports.getEchartsTalentsCountReportItemData = _EnvConfig.app_server + '/reportItem/getEchartsTalentsCountReportItemData';var getEchartsTalentsPartnershipReportItemData = exports.getEchartsTalentsPartnershipReportItemData = _EnvConfig.app_server + '/reportItem/getEchartsTalentsPartnershipReportItemData';var getEchartsTalentsTypeReportItemData = exports.getEchartsTalentsTypeReportItemData = _EnvConfig.app_server + '/reportItem/getEchartsTalentsTypeReportItemData';var getEchartsRegisterAndManageReportItemData = exports.getEchartsRegisterAndManageReportItemData = _EnvConfig.app_server + '/reportItem/getEchartsRegisterAndManageReportItemData';var getEchartsSkillReportItemData = exports.getEchartsSkillReportItemData = _EnvConfig.app_server + '/reportItem/getEchartsSkillReportItemData';var getEchartsInitiateReportDataBySource = exports.getEchartsInitiateReportDataBySource = _EnvConfig.app_server + '/reportItem/getEchartsInitiateReportDataBySource';var getEchartsInitiateReportDataByType = exports.getEchartsInitiateReportDataByType = _EnvConfig.app_server + '/reportItem/getEchartsInitiateReportDataByType';var getEchartsInitiateReportDataByTrend = exports.getEchartsInitiateReportDataByTrend = _EnvConfig.app_server + '/reportItem/getEchartsInitiateReportDataByTrend';var getEchartsBidReportDataByTrend = exports.getEchartsBidReportDataByTrend = _EnvConfig.app_server + '/reportItem/getEchartsBidReportDataByTrend';var getEchartsBidReportDataBySource = exports.getEchartsBidReportDataBySource = _EnvConfig.app_server + '/reportItem/getEchartsBidReportDataBySource';var getEchartsBidReportDataByType = exports.getEchartsBidReportDataByType = _EnvConfig.app_server + '/reportItem/getEchartsBidReportDataByType';var getEchartsLoseReportDataByTrend = exports.getEchartsLoseReportDataByTrend = _EnvConfig.app_server + '/reportItem/getEchartsLoseReportDataByTrend';var getEchartsLoseReportDataByType = exports.getEchartsLoseReportDataByType = _EnvConfig.app_server + '/reportItem/getEchartsLoseReportDataByType';var getEchartsLoseReportDataBySource = exports.getEchartsLoseReportDataBySource = _EnvConfig.app_server + '/reportItem/getEchartsLoseReportDataBySource';var getEchartsAbnormalReportDataBySource = exports.getEchartsAbnormalReportDataBySource = _EnvConfig.app_server + '/reportItem/getEchartsAbnormalReportDataBySource';
var getEchartsAbnormalTypeReportItemData = exports.getEchartsAbnormalTypeReportItemData = _EnvConfig.app_server + '/reportItem/getEchartsAbnormalTypeReportItemData';

var getEchartsDispatchReportDataByTrend = exports.getEchartsDispatchReportDataByTrend = _EnvConfig.app_server + '/reportItem/getEchartsDispatchReportDataByTrend';
var getEchartsDispatchReportDataByRegion = exports.getEchartsDispatchReportDataByRegion = _EnvConfig.app_server + '/reportItem/getEchartsDispatchReportDataByRegion';
var getEchartsDispatchReportDataBySource = exports.getEchartsDispatchReportDataBySource = _EnvConfig.app_server + '/reportItem/getEchartsDispatchReportDataBySource';
var getEchartsDispatchReportDataByGrade = exports.getEchartsDispatchReportDataByGrade = _EnvConfig.app_server + '/reportItem/getEchartsDispatchReportDataByGrade';

var getEchartsPollingReportDataByTrend = exports.getEchartsPollingReportDataByTrend = _EnvConfig.app_server + '/reportItem/getEchartsPollingReportDataByTrend';
var getEchartsPollingReportDataByGrade = exports.getEchartsPollingReportDataByGrade = _EnvConfig.app_server + '/reportItem/getEchartsPollingReportDataByGrade';
var getEchartsPollingReportDataByProject = exports.getEchartsPollingReportDataByProject = _EnvConfig.app_server + '/reportItem/getEchartsPollingReportDataByProject';
var getEchartsPollingReportDataByRegion = exports.getEchartsPollingReportDataByRegion = _EnvConfig.app_server + '/reportItem/getEchartsPollingReportDataByRegion';
var getEchartsPollingReportDataByProjectScore = exports.getEchartsPollingReportDataByProjectScore = _EnvConfig.app_server + '/reportItem/getEchartsPollingReportDataByProjectScore';
var getEchartsPollingReportDataByDirectorScore = exports.getEchartsPollingReportDataByDirectorScore = _EnvConfig.app_server + '/reportItem/getEchartsPollingReportDataByDirectorScore';

var getEchartsDesignTypeReportItemData = exports.getEchartsDesignTypeReportItemData = _EnvConfig.app_server + '/reportItem/getEchartsDesignTypeReportItemData';
var getEchartsDesignReportDataByRegion = exports.getEchartsDesignReportDataByRegion = _EnvConfig.app_server + '/reportItem/getEchartsDesignReportDataByRegion';
var getEchartsDesignReportItemData = exports.getEchartsDesignReportItemData = _EnvConfig.app_server + '/reportItem/getEchartsDesignReportItemData';
var getEchartsDesignAbnormalTypeReportItemData = exports.getEchartsDesignAbnormalTypeReportItemData = _EnvConfig.app_server + '/reportItem/getEchartsDesignAbnormalTypeReportItemData';

var getEchartsBiddingReportDataByCount = exports.getEchartsBiddingReportDataByCount = _EnvConfig.app_server + '/reportItem/getEchartsBiddingReportDataByCount';var getEchartsBiddingReportDataByMoney = exports.getEchartsBiddingReportDataByMoney = _EnvConfig.app_server + '/reportItem/getEchartsBiddingReportDataByMoney';var getEchartsBiddingReportDataBySource = exports.getEchartsBiddingReportDataBySource = _EnvConfig.app_server + '/reportItem/getEchartsBiddingReportDataBySource';var getEchartsBiddingReportDataByType = exports.getEchartsBiddingReportDataByType = _EnvConfig.app_server + '/reportItem/getEchartsBiddingReportDataByType';var getEchartsBiddingReportDataByProjectMoney = exports.getEchartsBiddingReportDataByProjectMoney = _EnvConfig.app_server + '/reportItem/getEchartsBiddingReportDataByProjectMoney';var getEchartsBiddingReportDataByDirectorMoney = exports.getEchartsBiddingReportDataByDirectorMoney = _EnvConfig.app_server + '/reportItem/getEchartsBiddingReportDataByDirectorMoney';var getEchartsBuyingTypeReportItemData = exports.getEchartsBuyingTypeReportItemData = _EnvConfig.app_server + '/reportItem/getEchartsBuyingTypeReportItemData';
var getEchartsBuyingReportDataByRegion = exports.getEchartsBuyingReportDataByRegion = _EnvConfig.app_server + '/reportItem/getEchartsBuyingReportDataByRegion';
var getEchartsBuyingReportItemData = exports.getEchartsBuyingReportItemData = _EnvConfig.app_server + '/reportItem/getEchartsBuyingReportItemData';
var getEchartsBuyingAbnormalTypeReportItemData = exports.getEchartsBuyingAbnormalTypeReportItemData = _EnvConfig.app_server + '/reportItem/getEchartsBuyingAbnormalTypeReportItemData';

var getEchartsSummaryFinanceIncomeReportItemData = exports.getEchartsSummaryFinanceIncomeReportItemData = _EnvConfig.app_server + '/reportItem/getEchartsSummaryFinanceIncomeReportItemData';var getEchartsTrendFinanceIncomeData = exports.getEchartsTrendFinanceIncomeData = _EnvConfig.app_server + '/reportItem/getEchartsTrendFinanceIncomeData';var getEchartsSummaryFinanceIncomeTypeReportItemData = exports.getEchartsSummaryFinanceIncomeTypeReportItemData = _EnvConfig.app_server + '/reportItem/getEchartsSummaryFinanceIncomeTypeReportItemData';var getEchartsClaimedFinanceIncomeTypeReportItemData = exports.getEchartsClaimedFinanceIncomeTypeReportItemData = _EnvConfig.app_server + '/reportItem/getEchartsClaimedFinanceIncomeTypeReportItemData';var getEchartsFoldOrPostFinanceIncomeData = exports.getEchartsFoldOrPostFinanceIncomeData = _EnvConfig.app_server + '/reportItem/getEchartsFoldOrPostFinanceIncomeData';var financeReceivableSummaryReportItemData = exports.financeReceivableSummaryReportItemData = _EnvConfig.app_server + '/reportItem/financeReceivableSummaryReportItemData';var invoiceTicktReceivableReportItemData = exports.invoiceTicktReceivableReportItemData = _EnvConfig.app_server + '/reportItem/invoiceTicktReceivableReportItemData';var payableReceivableReportItemData = exports.payableReceivableReportItemData = _EnvConfig.app_server + '/reportItem/payableReceivableReportItemData';var getEchartsSettlementReportDataByProject = exports.getEchartsSettlementReportDataByProject = _EnvConfig.app_server + '/reportItem/getEchartsSettlementReportDataByProject';
var getEchartsSettlementReportDataByType = exports.getEchartsSettlementReportDataByType = _EnvConfig.app_server + '/reportItem/getEchartsSettlementReportDataByType';
var getEchartsSettlementReportDataByCooperationType = exports.getEchartsSettlementReportDataByCooperationType = _EnvConfig.app_server + '/reportItem/getEchartsSettlementReportDataByCooperationType';

var financeReturnedSummaryReportItemData = exports.financeReturnedSummaryReportItemData = _EnvConfig.app_server + '/reportItem/financeReturnedSummaryReportItemData';var payableReturnedReportItemData = exports.payableReturnedReportItemData = _EnvConfig.app_server + '/reportItem/payableReturnedReportItemData';var laborReturnedReportItemData = exports.laborReturnedReportItemData = _EnvConfig.app_server + '/reportItem/laborReturnedReportItemData';var getEchartsSignedReportDataByInfo = exports.getEchartsSignedReportDataByInfo = _EnvConfig.app_server + '/reportItem/getEchartsSignedReportDataByInfo';var getEchartsSignedReportDataByEngineeringType = exports.getEchartsSignedReportDataByEngineeringType = _EnvConfig.app_server + '/reportItem/getEchartsSignedReportDataByEngineeringType';var getEchartsSignedReportDataByProjectType = exports.getEchartsSignedReportDataByProjectType = _EnvConfig.app_server + '/reportItem/getEchartsSignedReportDataByProjectType';var getEchartsSignedReportDataByCooperationType = exports.getEchartsSignedReportDataByCooperationType = _EnvConfig.app_server + '/reportItem/getEchartsSignedReportDataByCooperationType';var getEchartsSignedReportDataByGrade = exports.getEchartsSignedReportDataByGrade = _EnvConfig.app_server + '/reportItem/getEchartsSignedReportDataByGrade';var getEchartsSignedReportDataByProjectMoney = exports.getEchartsSignedReportDataByProjectMoney = _EnvConfig.app_server + '/reportItem/getEchartsSignedReportDataByProjectMoney';var getEchartsSignedReportDataByDirectorMoney = exports.getEchartsSignedReportDataByDirectorMoney = _EnvConfig.app_server + '/reportItem/getEchartsSignedReportDataByDirectorMoney';var getEchartsSignedReportDataByProjectNumber = exports.getEchartsSignedReportDataByProjectNumber = _EnvConfig.app_server + '/reportItem/getEchartsSignedReportDataByProjectNumber';var getEchartsSignedReportDataByRegion = exports.getEchartsSignedReportDataByRegion = _EnvConfig.app_server + '/reportItem/getEchartsSignedReportDataByRegion';var getEchartsProjectOrDesignOrBuyingIsMoneyAndNumber = exports.getEchartsProjectOrDesignOrBuyingIsMoneyAndNumber = _EnvConfig.app_server + '/reportItem/getEchartsProjectOrDesignOrBuyingIsMoneyAndNumber';var getEchartsBidsReportData = exports.getEchartsBidsReportData = _EnvConfig.app_server + '/reportItem/getEchartsBidsReportData';var getEchartsBidsReportDataByTrend = exports.getEchartsBidsReportDataByTrend = _EnvConfig.app_server + '/reportItem/getEchartsBidsReportDataByTrend';
var getEchartsBidsReportDataByProvince = exports.getEchartsBidsReportDataByProvince = _EnvConfig.app_server + '/reportItem/getEchartsBidsReportDataByProvince';
var getEchartsBidsReportDataByMapOfChina = exports.getEchartsBidsReportDataByMapOfChina = _EnvConfig.app_server + '/reportItem/getEchartsBidsReportDataByMapOfChina';

var getEchartsCollectReportDataByProgressRatio = exports.getEchartsCollectReportDataByProgressRatio = _EnvConfig.app_server + '/reportItem/getEchartsCollectReportDataByProgressRatio';var getEchartsCollectReportDataByDispatchRatio = exports.getEchartsCollectReportDataByDispatchRatio = _EnvConfig.app_server + '/reportItem/getEchartsCollectReportDataByDispatchRatio';var getEchartsCollectReportDataByRegion = exports.getEchartsCollectReportDataByRegion = _EnvConfig.app_server + '/reportItem/getEchartsCollectReportDataByRegion';var getEchartsCollectReportDataBySource = exports.getEchartsCollectReportDataBySource = _EnvConfig.app_server + '/reportItem/getEchartsCollectReportDataBySource';var getEchartsCollectReportDataByGrade = exports.getEchartsCollectReportDataByGrade = _EnvConfig.app_server + '/reportItem/getEchartsCollectReportDataByGrade';var getQueryCustomerIntentionPage = exports.getQueryCustomerIntentionPage = _EnvConfig.app_server + '/customerIntention/getQueryCustomerIntentionPage';
var getPublicizePage = exports.getPublicizePage = _EnvConfig.app_server + '/publicize/getPublicizePage';
var getPublicizeProjectChooseCount = exports.getPublicizeProjectChooseCount = _EnvConfig.app_server + '/project/getPublicizeProjectChooseCount';
var addOrUpdProjectPublicize = exports.addOrUpdProjectPublicize = _EnvConfig.app_server + '/publicize/addOrUpdProjectPublicize';
var findProjectPublicizeById = exports.findProjectPublicizeById = _EnvConfig.app_server + '/publicize/findProjectPublicizeById';
var getSupplierPage = exports.getSupplierPage = _EnvConfig.app_server + '/supplier/getSupplierPage';
var findSupplierById = exports.findSupplierById = _EnvConfig.app_server + '/supplier/findSupplierById';
var findSupplierIssuePageList = exports.findSupplierIssuePageList = _EnvConfig.app_server + '/supplierIssue/findSupplierIssuePageList';
var saveSupplierIssue = exports.saveSupplierIssue = _EnvConfig.app_server + '/supplierIssue/saveSupplierIssue';
var removeSupplierIssueById = exports.removeSupplierIssueById = _EnvConfig.app_server + '/supplierIssue/removeSupplierIssueById';
var delSupplierIssueById = exports.delSupplierIssueById = _EnvConfig.app_server + '/supplierIssue/delSupplierIssueById';
var updateSupplierBlacklistsStatus = exports.updateSupplierBlacklistsStatus = _EnvConfig.app_server + '/supplier/updateSupplierBlacklistsStatus';
var getSupplierBlacklistsPageList = exports.getSupplierBlacklistsPageList = _EnvConfig.app_server + '/supplier/getSupplierBlacklistsPageList';
var saveSupplier = exports.saveSupplier = _EnvConfig.app_server + '/supplier/saveSupplier';

var WorkOrderGetWorkOrderPage = exports.WorkOrderGetWorkOrderPage = _EnvConfig.app_server + '/workOrder/getWorkOrderPage';var WorkOrderSaveWorkOrder = exports.WorkOrderSaveWorkOrder = _EnvConfig.app_server + '/workOrder/saveWorkOrder';var WorkOrderGetWorkOrderDelete = exports.WorkOrderGetWorkOrderDelete = _EnvConfig.app_server + '/workOrder/getWorkOrderDelete';var WorkOrderGetWorkOrderDetail = exports.WorkOrderGetWorkOrderDetail = _EnvConfig.app_server + '/workOrder/getWorkOrderDetail';var WorkOrderDisagreeWorkOrder = exports.WorkOrderDisagreeWorkOrder = _EnvConfig.app_server + '/workOrder/disagreeWorkOrder';var WorkOrderAgreeWorkOrder = exports.WorkOrderAgreeWorkOrder = _EnvConfig.app_server + '/workOrder/agreeWorkOrder';var WorkOrderChangeWorkOrder = exports.WorkOrderChangeWorkOrder = _EnvConfig.app_server + '/workOrder/changeWorkOrder';var WorkOrderReturnWorkOrder = exports.WorkOrderReturnWorkOrder = _EnvConfig.app_server + '/workOrder/returnWorkOrder';var WorkOrderCompleteWorkOrder = exports.WorkOrderCompleteWorkOrder = _EnvConfig.app_server + '/workOrder/completeWorkOrder';var WorkOrderGetWorkTicketsNumber = exports.WorkOrderGetWorkTicketsNumber = _EnvConfig.app_server + '/workOrder/getWorkTicketsNumber';

var eSignature = exports.eSignature = _EnvConfig.app_server + '/sign/eSignature';

var getIndexSyntheticData = exports.getIndexSyntheticData = _EnvConfig.app_server + '/dataView/getSyntheticData';
var getPmData = exports.getPmData = _EnvConfig.app_server + '/dataView/eliteInformation';
var getProjectInformation = exports.getProjectInformation = _EnvConfig.app_server + '/dataView/projectInformation';
var getCustomerData = exports.getCustomerData = _EnvConfig.app_server + '/dataView/getCustomerDataShow';

var NoticeGetSystemNoticePage = exports.NoticeGetSystemNoticePage = _EnvConfig.app_server + '/notice/getSystemNoticePage';

var workbench_data = exports.workbench_data = _EnvConfig.app_server + '/workbench_data';

/***/ }),

/***/ 1436:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1437:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1438:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1439:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1440:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1441:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1442:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1443:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1444:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1445:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1446:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1447:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1448:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1449:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1450:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1451:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1452:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1453:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1454:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1455:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1456:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1457:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1458:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1459:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1460:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1461:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1462:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1463:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1464:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1465:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1466:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1467:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1468:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1469:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1470:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1471:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1472:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1473:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1474:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1475:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1476:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1477:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1478:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1479:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1480:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1481:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1482:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1483:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1484:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1485:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1486:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1487:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1488:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1489:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1490:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1491:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1492:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1493:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1494:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1495:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1496:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1497:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1498:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1499:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1500:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1501:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1502:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1503:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1504:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1505:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1506:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1507:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1515:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 511,
	"./af.js": 511,
	"./ar": 518,
	"./ar-dz": 512,
	"./ar-dz.js": 512,
	"./ar-kw": 513,
	"./ar-kw.js": 513,
	"./ar-ly": 514,
	"./ar-ly.js": 514,
	"./ar-ma": 515,
	"./ar-ma.js": 515,
	"./ar-sa": 516,
	"./ar-sa.js": 516,
	"./ar-tn": 517,
	"./ar-tn.js": 517,
	"./ar.js": 518,
	"./az": 519,
	"./az.js": 519,
	"./be": 520,
	"./be.js": 520,
	"./bg": 521,
	"./bg.js": 521,
	"./bm": 522,
	"./bm.js": 522,
	"./bn": 524,
	"./bn-bd": 523,
	"./bn-bd.js": 523,
	"./bn.js": 524,
	"./bo": 525,
	"./bo.js": 525,
	"./br": 526,
	"./br.js": 526,
	"./bs": 527,
	"./bs.js": 527,
	"./ca": 528,
	"./ca.js": 528,
	"./cs": 529,
	"./cs.js": 529,
	"./cv": 530,
	"./cv.js": 530,
	"./cy": 531,
	"./cy.js": 531,
	"./da": 532,
	"./da.js": 532,
	"./de": 535,
	"./de-at": 533,
	"./de-at.js": 533,
	"./de-ch": 534,
	"./de-ch.js": 534,
	"./de.js": 535,
	"./dv": 536,
	"./dv.js": 536,
	"./el": 537,
	"./el.js": 537,
	"./en-au": 538,
	"./en-au.js": 538,
	"./en-ca": 539,
	"./en-ca.js": 539,
	"./en-gb": 540,
	"./en-gb.js": 540,
	"./en-ie": 541,
	"./en-ie.js": 541,
	"./en-il": 542,
	"./en-il.js": 542,
	"./en-in": 543,
	"./en-in.js": 543,
	"./en-nz": 544,
	"./en-nz.js": 544,
	"./en-sg": 545,
	"./en-sg.js": 545,
	"./eo": 546,
	"./eo.js": 546,
	"./es": 550,
	"./es-do": 547,
	"./es-do.js": 547,
	"./es-mx": 548,
	"./es-mx.js": 548,
	"./es-us": 549,
	"./es-us.js": 549,
	"./es.js": 550,
	"./et": 551,
	"./et.js": 551,
	"./eu": 552,
	"./eu.js": 552,
	"./fa": 553,
	"./fa.js": 553,
	"./fi": 554,
	"./fi.js": 554,
	"./fil": 555,
	"./fil.js": 555,
	"./fo": 556,
	"./fo.js": 556,
	"./fr": 559,
	"./fr-ca": 557,
	"./fr-ca.js": 557,
	"./fr-ch": 558,
	"./fr-ch.js": 558,
	"./fr.js": 559,
	"./fy": 560,
	"./fy.js": 560,
	"./ga": 561,
	"./ga.js": 561,
	"./gd": 562,
	"./gd.js": 562,
	"./gl": 563,
	"./gl.js": 563,
	"./gom-deva": 564,
	"./gom-deva.js": 564,
	"./gom-latn": 565,
	"./gom-latn.js": 565,
	"./gu": 566,
	"./gu.js": 566,
	"./he": 567,
	"./he.js": 567,
	"./hi": 568,
	"./hi.js": 568,
	"./hr": 569,
	"./hr.js": 569,
	"./hu": 570,
	"./hu.js": 570,
	"./hy-am": 571,
	"./hy-am.js": 571,
	"./id": 572,
	"./id.js": 572,
	"./is": 573,
	"./is.js": 573,
	"./it": 575,
	"./it-ch": 574,
	"./it-ch.js": 574,
	"./it.js": 575,
	"./ja": 576,
	"./ja.js": 576,
	"./jv": 577,
	"./jv.js": 577,
	"./ka": 578,
	"./ka.js": 578,
	"./kk": 579,
	"./kk.js": 579,
	"./km": 580,
	"./km.js": 580,
	"./kn": 581,
	"./kn.js": 581,
	"./ko": 582,
	"./ko.js": 582,
	"./ku": 583,
	"./ku.js": 583,
	"./ky": 584,
	"./ky.js": 584,
	"./lb": 585,
	"./lb.js": 585,
	"./lo": 586,
	"./lo.js": 586,
	"./lt": 587,
	"./lt.js": 587,
	"./lv": 588,
	"./lv.js": 588,
	"./me": 589,
	"./me.js": 589,
	"./mi": 590,
	"./mi.js": 590,
	"./mk": 591,
	"./mk.js": 591,
	"./ml": 592,
	"./ml.js": 592,
	"./mn": 593,
	"./mn.js": 593,
	"./mr": 594,
	"./mr.js": 594,
	"./ms": 596,
	"./ms-my": 595,
	"./ms-my.js": 595,
	"./ms.js": 596,
	"./mt": 597,
	"./mt.js": 597,
	"./my": 598,
	"./my.js": 598,
	"./nb": 599,
	"./nb.js": 599,
	"./ne": 600,
	"./ne.js": 600,
	"./nl": 602,
	"./nl-be": 601,
	"./nl-be.js": 601,
	"./nl.js": 602,
	"./nn": 603,
	"./nn.js": 603,
	"./oc-lnc": 604,
	"./oc-lnc.js": 604,
	"./pa-in": 605,
	"./pa-in.js": 605,
	"./pl": 606,
	"./pl.js": 606,
	"./pt": 608,
	"./pt-br": 607,
	"./pt-br.js": 607,
	"./pt.js": 608,
	"./ro": 609,
	"./ro.js": 609,
	"./ru": 610,
	"./ru.js": 610,
	"./sd": 611,
	"./sd.js": 611,
	"./se": 612,
	"./se.js": 612,
	"./si": 613,
	"./si.js": 613,
	"./sk": 614,
	"./sk.js": 614,
	"./sl": 615,
	"./sl.js": 615,
	"./sq": 616,
	"./sq.js": 616,
	"./sr": 618,
	"./sr-cyrl": 617,
	"./sr-cyrl.js": 617,
	"./sr.js": 618,
	"./ss": 619,
	"./ss.js": 619,
	"./sv": 620,
	"./sv.js": 620,
	"./sw": 621,
	"./sw.js": 621,
	"./ta": 622,
	"./ta.js": 622,
	"./te": 623,
	"./te.js": 623,
	"./tet": 624,
	"./tet.js": 624,
	"./tg": 625,
	"./tg.js": 625,
	"./th": 626,
	"./th.js": 626,
	"./tk": 627,
	"./tk.js": 627,
	"./tl-ph": 628,
	"./tl-ph.js": 628,
	"./tlh": 629,
	"./tlh.js": 629,
	"./tr": 630,
	"./tr.js": 630,
	"./tzl": 631,
	"./tzl.js": 631,
	"./tzm": 633,
	"./tzm-latn": 632,
	"./tzm-latn.js": 632,
	"./tzm.js": 633,
	"./ug-cn": 634,
	"./ug-cn.js": 634,
	"./uk": 635,
	"./uk.js": 635,
	"./ur": 636,
	"./ur.js": 636,
	"./uz": 638,
	"./uz-latn": 637,
	"./uz-latn.js": 637,
	"./uz.js": 638,
	"./vi": 639,
	"./vi.js": 639,
	"./x-pseudo": 640,
	"./x-pseudo.js": 640,
	"./yo": 641,
	"./yo.js": 641,
	"./zh-cn": 642,
	"./zh-cn.js": 642,
	"./zh-hk": 643,
	"./zh-hk.js": 643,
	"./zh-mo": 644,
	"./zh-mo.js": 644,
	"./zh-tw": 645,
	"./zh-tw.js": 645
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1515;

/***/ }),

/***/ 1530:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 1633:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1473)
__webpack_require__(1472)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(815),
  /* template */
  __webpack_require__(1664),
  /* scopeId */
  "data-v-447fa27e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1634:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1489)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(822),
  /* template */
  __webpack_require__(1675),
  /* scopeId */
  "data-v-6e8ba236",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1635:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1507)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(823),
  /* template */
  __webpack_require__(1688),
  /* scopeId */
  "data-v-e67c184a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1636:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1465)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(824),
  /* template */
  __webpack_require__(1660),
  /* scopeId */
  "data-v-3ae57a41",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1637:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1457)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(825),
  /* template */
  __webpack_require__(1654),
  /* scopeId */
  "data-v-2f7a6c01",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1638:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1502)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(826),
  /* template */
  __webpack_require__(1683),
  /* scopeId */
  "data-v-b52f8ccc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1639:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1459)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(828),
  /* template */
  __webpack_require__(1656),
  /* scopeId */
  "data-v-3444ba2c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1640:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1494)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(829),
  /* template */
  __webpack_require__(1678),
  /* scopeId */
  "data-v-75cb1a24",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1641:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1476)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(830),
  /* template */
  __webpack_require__(1666),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1642:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "upload"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "upload-item"
  }, [_c('a', {
    staticClass: "file",
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('input', {
    attrs: {
      "id": "file_head",
      "type": "file",
      "accept": "image/*",
      "capture": "camera"
    },
    on: {
      "change": function($event) {
        return _vm.setImagePreview()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("拍照")])])])]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "upload-item"
  }, [_c('a', {
    staticClass: "file file2",
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('input', {
    attrs: {
      "id": "file_head2",
      "type": "file"
    },
    on: {
      "change": function($event) {
        return _vm.setFilePreview()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("文件")])])])])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1643:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "bidsData"
    }
  }, [_c('HeadControl', {
    ref: "HeadControl",
    attrs: {
      "titleName": '招标数据'
    },
    on: {
      "changeVal": _vm.changeVal,
      "changDate": _vm.changDate,
      "changePicker": _vm.changePicker
    }
  }), _vm._v(" "), (_vm.aggregation[0]) ? _c('div', {
    staticClass: "topBox"
  }, [_c('div', {
    staticClass: "DataBox"
  }, [_c('div', {
    staticStyle: {
      "font-size": "0.16rem",
      "color": "#666666"
    }
  }, [_vm._v("投标个数")]), _vm._v(" "), _c('div', {
    staticClass: "smBox",
    staticStyle: {
      "margin-top": "0.1rem"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "0.26rem",
      "color": "#333333"
    }
  }, [_vm._v(_vm._s(_vm.aggregation[0].count)), _c('span', {
    staticStyle: {
      "font-size": "0.12rem"
    }
  }, [_vm._v("个")])]), _vm._v(" "), _c('div', {
    staticClass: "imgBox",
    staticStyle: {
      "width": "0.56rem",
      "height": "0.55rem"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": _vm.aggregation[0].itemIcon,
      "alt": ""
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "DataBox"
  }, [_c('div', {
    staticStyle: {
      "font-size": "0.16rem",
      "color": "#666666"
    }
  }, [_vm._v("投标人数")]), _vm._v(" "), _c('div', {
    staticClass: "smBox",
    staticStyle: {
      "margin-top": "0.1rem"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "0.26rem",
      "color": "#333333"
    }
  }, [_vm._v(_vm._s(_vm.aggregation[1].totalCount)), _c('span', {
    staticStyle: {
      "font-size": "0.12rem"
    }
  }, [_vm._v("人")])]), _vm._v(" "), _c('div', {
    staticClass: "imgBox",
    staticStyle: {
      "width": "0.56rem",
      "height": "0.55rem"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": _vm.aggregation[1].itemIcon,
      "alt": ""
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "DataBox"
  }, [_c('div', {
    staticStyle: {
      "font-size": "0.16rem",
      "color": "#666666"
    }
  }, [_vm._v("中标个数")]), _vm._v(" "), _c('div', {
    staticClass: "smBox",
    staticStyle: {
      "margin-top": "0.1rem"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "0.26rem",
      "color": "#333333"
    }
  }, [_vm._v(_vm._s(_vm.aggregation[2].count)), _c('span', {
    staticStyle: {
      "font-size": "0.12rem"
    }
  }, [_vm._v("个")])]), _vm._v(" "), _c('div', {
    staticClass: "imgBox",
    staticStyle: {
      "width": "0.56rem",
      "height": "0.55rem"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": _vm.aggregation[2].itemIcon,
      "alt": ""
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "DataBox"
  }, [_c('div', {
    staticStyle: {
      "font-size": "0.16rem",
      "color": "#666666"
    }
  }, [_vm._v("中标人数")]), _vm._v(" "), _c('div', {
    staticClass: "smBox",
    staticStyle: {
      "margin-top": "0.1rem"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "0.26rem",
      "color": "#333333"
    }
  }, [_vm._v(_vm._s(_vm.aggregation[3].totalCount)), _c('span', {
    staticStyle: {
      "font-size": "0.12rem"
    }
  }, [_vm._v("人")])]), _vm._v(" "), _c('div', {
    staticClass: "imgBox",
    staticStyle: {
      "width": "0.56rem",
      "height": "0.55rem"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": _vm.aggregation[3].itemIcon,
      "alt": ""
    }
  })])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "BigCenterBox"
  }, [_c('div', {
    staticClass: "centerBox"
  }, [_c('div', {
    ref: "bidsDataEcharts",
    attrs: {
      "id": "bidsDataEcharts"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "BigBottomBox"
  }, [_c('div', {
    staticClass: "BottomBox"
  }, [_c('div', {
    ref: "ChinaMap",
    attrs: {
      "id": "ChinaMap"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "Ranking"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "tablist"
  }, [_c('li', {
    class: {
      'active': _vm.activeProjectName === 'BID'
    },
    on: {
      "click": function($event) {
        return _vm.handleClick('BID')
      }
    }
  }, [_vm._v("投标个数排行")]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.activeProjectName === 'BIDDING'
    },
    on: {
      "click": function($event) {
        return _vm.handleClick('BIDDING')
      }
    }
  }, [_vm._v("中标个数排行")])]), _vm._v(" "), (_vm.RankingDataList.length && _vm.activeProjectName === 'BID') ? _c('div', {
    attrs: {
      "id": "S-dataSort"
    }
  }, [_c('div', {
    staticClass: "bottom-Data"
  }, [_c('table', {
    staticClass: "table-Box"
  }, [_c('tr', {
    staticClass: "herader-Box"
  }, [_c('td', {
    attrs: {
      "width": _vm.screenWidth <= 1366 ? 180 : 300
    }
  }, [_vm._v("省份")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "180",
      "align": "center"
    }
  }, [_vm._v("投标人数（人）")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": _vm.identification == 'pplet' ? 160 : 140,
      "align": "center"
    }
  }, [_vm._v("投标个数（个）")])]), _vm._v(" "), _vm._l((_vm.RankingDataList), function(item, index) {
    return _c('tr', {
      key: index,
      attrs: {
        "height": "32"
      }
    }, [_c('td', [_c('div', {
      staticClass: "dataBox"
    }, [_c('span', {
      class: {
        'red': item.serialNumber == '1',
        'orange': item.serialNumber == '2',
        'yellow': item.serialNumber == '3'
      },
      staticStyle: {
        "margin-right": "10px"
      }
    }, [_vm._v(_vm._s(item.serialNumber))]), _vm._v(_vm._s(item.province) + "\n                                  ")])]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "center"
      }
    }, [_vm._v(_vm._s(item.totalCount))]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "center"
      }
    }, [_vm._v(_vm._s(item.count))])])
  })], 2)])]) : (_vm.RankingDataList.length && _vm.activeProjectName === 'BIDDING') ? _c('div', {
    attrs: {
      "id": "S-dataSort"
    }
  }, [_c('div', {
    staticClass: "bottom-Data"
  }, [_c('table', {
    staticClass: "table-Box"
  }, [_c('tr', {
    staticClass: "herader-Box"
  }, [_c('td', {
    attrs: {
      "width": _vm.screenWidth <= 1366 ? 180 : 300
    }
  }, [_vm._v("省份")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "180",
      "align": "center"
    }
  }, [_vm._v("中标人数（人）")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": _vm.identification == 'pplet' ? 160 : 140,
      "align": "center"
    }
  }, [_vm._v("中标个数（个）")])]), _vm._v(" "), _vm._l((_vm.RankingDataList), function(item, index) {
    return _c('tr', {
      key: index,
      attrs: {
        "height": "32"
      }
    }, [_c('td', [_c('div', {
      staticClass: "dataBox"
    }, [_c('span', {
      class: {
        'red': item.serialNumber == '1',
        'orange': item.serialNumber == '2',
        'yellow': item.serialNumber == '3'
      },
      staticStyle: {
        "margin-right": "10px"
      }
    }, [_vm._v(_vm._s(item.serialNumber))]), _vm._v(_vm._s(item.province) + "\n                                  ")])]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "center"
      }
    }, [_vm._v(_vm._s(item.totalCount))]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "center"
      }
    }, [_vm._v(_vm._s(item.count))])])
  })], 2)])]) : _c('div', {
    staticClass: "nodata_box"
  }, [_c('img', {
    attrs: {
      "src": "https://xmyun.zhoty.com/xmerp/pcadmin/static/images/report_item_nodata.png"
    }
  }), _vm._v(" "), _c('span', [_vm._v("暂无数据")])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top-Name"
  }, [_c('i', {
    staticClass: "el-icon-s-data"
  }), _vm._v(" "), _c('p', {
    staticClass: "titleName"
  }, [_vm._v("TOP10 省份投/中标数量排行")])])
}]}

/***/ }),

/***/ 1644:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('HeadControl', {
    ref: "headControl",
    attrs: {
      "titleName": '结算数据',
      "showorg": false
    },
    on: {
      "changeVal": _vm.changeVal,
      "changDate": _vm.changDate,
      "changePicker": _vm.changePicker
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('div', {
    staticClass: "top_left"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": _vm.iconAndImg.itemIcon
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "total"
  }, [_vm._v("结算项目总数")]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.iconAndImg.count))]), _vm._v("个")])])]), _vm._v(" "), _c('div', {
    ref: "settlementNum",
    staticClass: "top_right"
  })]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    ref: "projectType",
    staticClass: "projectType"
  }), _vm._v(" "), (!_vm.projectTypeChartShow) ? _c('div', {
    staticClass: "nodata_box"
  }, [_c('img', {
    attrs: {
      "src": "https://xmyun.zhoty.com/xmerp/pcadmin/static/images/report_item_nodata.png"
    }
  }), _vm._v(" "), _c('span', [_vm._v("暂无数据")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    ref: "cooperationType",
    staticClass: "cooperationType"
  }), _vm._v(" "), (!_vm.cooperationChartShow) ? _c('div', {
    staticClass: "nodata_box"
  }, [_c('img', {
    attrs: {
      "src": "https://xmyun.zhoty.com/xmerp/pcadmin/static/images/report_item_nodata.png"
    }
  }), _vm._v(" "), _c('span', [_vm._v("暂无数据")])]) : _vm._e()])])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1645:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "main"
  }, [(!_vm.isCollapse && _vm.$wxOpenId) ? _c('i', {
    staticClass: "el-icon-s-fold button",
    on: {
      "click": function($event) {
        _vm.isCollapse = !_vm.isCollapse;
        _vm.toggle()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isCollapse && _vm.$wxOpenId) ? _c('i', {
    staticClass: "el-icon-s-unfold button",
    on: {
      "click": function($event) {
        _vm.isCollapse = !_vm.isCollapse;
        _vm.toggle()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$wxOpenId) ? _c('aside', {
    staticClass: "sidebar",
    class: _vm.isCollapse ? 'collapse' : ''
  }, [_c('ul', _vm._l((_vm.secendNode), function(item, index) {
    return (!item.hidden && !item.leaf) ? _c('li', {
      staticClass: "li1"
    }, [_c('div', {
      staticClass: "li1title"
    }, [_c('span', [_c('img', {
      attrs: {
        "src": item.icon
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "li1titletext"
    }, [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _c('ul', {
      staticClass: "ul2"
    }, _vm._l((item.children), function(child) {
      return (!child.hidden) ? _c('li', {
        staticClass: "li2",
        class: {
          'active': _vm.$route.path == child.path
        },
        on: {
          "click": function($event) {
            return _vm.$router.push(child.path)
          }
        }
      }, [_vm._v("\n                        " + _vm._s(child.name) + "\n                    ")]) : _vm._e()
    }), 0), _vm._v(" "), _c('div', {
      staticClass: "bootmline"
    })]) : _vm._e()
  }), 0)]) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "content-container",
    class: _vm.$wxOpenId ? "" : "wx-content-container"
  }, [_c('el-col', {
    staticClass: "breadcrumb-container",
    attrs: {
      "span": 24
    }
  }, [_c('el-breadcrumb', {
    staticClass: "breadcrumb-inner",
    attrs: {
      "separator": "/"
    }
  }, _vm._l((_vm.$route.matched), function(item) {
    return _c('el-breadcrumb-item', {
      key: item.path
    }, [_vm._v("\n                    " + _vm._s(item.name) + "\n                ")])
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    ref: "contentWrapper",
    staticClass: "content-wrapper",
    attrs: {
      "span": 24
    }
  }, [_c('router-view')], 1)], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 1646:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('HeadControl', {
    ref: "headControl",
    attrs: {
      "titleName": '异常数据'
    },
    on: {
      "changeVal": _vm.changeVal,
      "changDate": _vm.changDate,
      "changePicker": _vm.changePicker
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('div', {
    staticClass: "top_left"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": _vm.abnormalNum.itemIcon
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "total"
  }, [_vm._v("异常总数")]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.abnormalNum.count))]), _vm._v("个\n          ")])])]), _vm._v(" "), _c('div', {
    ref: "abnormalNum",
    staticClass: "top_right"
  })]), _vm._v(" "), _c('div', {
    ref: "abnormalType",
    staticClass: "bottom"
  })])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1647:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "fileh5 upload",
    attrs: {
      "element-loading-text": "正在上传"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "upload-item"
  }, [_c('a', {
    staticClass: "file",
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('input', {
    attrs: {
      "id": "file_head",
      "type": "file",
      "accept": "image/*",
      "capture": "camera"
    },
    on: {
      "change": function($event) {
        return _vm.setImagePreview()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("拍照")])])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "upload-item"
  }, [_c('a', {
    staticClass: "file file2",
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('input', {
    attrs: {
      "id": "file_head2",
      "type": "file"
    },
    on: {
      "change": function($event) {
        return _vm.setFilePreview()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("文件")])])])])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1648:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "deal-with"
  }, [_c('HeadControl', {
    ref: "HeadControl",
    attrs: {
      "titleName": '应付数据',
      "showorg": false
    },
    on: {
      "changePicker": _vm.changePicker,
      "changDate": _vm.changDate
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "inner-top"
  }, _vm._l((_vm.summaryList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "item"
    }, [_c('div', {
      staticClass: "l-box"
    }, [_c('div', {
      staticClass: "l-t"
    }, [_vm._v(_vm._s(item.itemName))]), _vm._v(" "), _c('div', {
      staticClass: "l-a"
    }, [_vm._v(_vm._s(_vm.aFormat(item.amount))), _c('span', [_vm._v("元")])]), _vm._v(" "), _c('div', {
      staticClass: "l-t"
    }, [_vm._v(_vm._s(item.count)), _c('span', [_vm._v(_vm._s(item.itemName == '众惠应付款' || item.itemName == '回款应开票' ? '个项目' : '笔'))])])]), _vm._v(" "), _c('div', {
      staticClass: "r-box"
    }, [_c('img', {
      attrs: {
        "src": item.itemIcon
      }
    })])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "inner-bottom"
  }, [_c('div', {
    staticClass: "left"
  }, _vm._l((_vm.invoiceTotal), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "left-t"
    }, [_c('div', {
      staticClass: "icon"
    }, [_c('img', {
      attrs: {
        "src": item.itemIcon
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "desc"
    }, [_c('div', {
      staticClass: "a-title"
    }, [_vm._v(_vm._s(item.itemName))]), _vm._v(" "), _c('div', {
      staticClass: "amount"
    }, [_vm._v(_vm._s(_vm.aFormat(item.amount))), _c('span', [_vm._v("元")])]), _vm._v(" "), _c('div', {
      staticClass: "a-title"
    }, [_vm._v(_vm._s(item.count) + "笔")])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    ref: "invoiceTotal",
    staticStyle: {
      "height": "100%"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "inner-bottom"
  }, [_c('div', {
    staticClass: "left"
  }, _vm._l((_vm.payableTotal), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "left-t"
    }, [_c('div', {
      staticClass: "icon"
    }, [_c('img', {
      attrs: {
        "src": item.itemIcon
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "desc"
    }, [_c('div', {
      staticClass: "a-title"
    }, [_vm._v(_vm._s(item.itemName))]), _vm._v(" "), _c('div', {
      staticClass: "amount"
    }, [_vm._v(_vm._s(_vm.aFormat(item.amount))), _c('span', [_vm._v("元")])]), _vm._v(" "), _c('div', {
      staticClass: "a-title"
    }, [_vm._v(_vm._s(item.count) + "笔")])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    ref: "payableTotal",
    staticStyle: {
      "width": "100%",
      "height": "100%"
    }
  })])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1649:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "fileh5 upload",
    attrs: {
      "element-loading-text": "正在上传"
    }
  }, [_c('el-row', [_c('div', {
    staticClass: "file-wrapper"
  }, [_c('div', {
    staticClass: "upload-item"
  }, [_c('a', {
    staticClass: "file file2",
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('input', {
    attrs: {
      "id": "file_head2",
      "type": "file"
    },
    on: {
      "change": function($event) {
        return _vm.setFilePreview()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("文件")])])])])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1650:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('HeadControl', {
    ref: "headControl",
    attrs: {
      "titleName": '购销数据'
    },
    on: {
      "changeVal": _vm.changeVal,
      "changDate": _vm.changDate,
      "changePicker": _vm.changePicker
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "top"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "chart_box"
  }, [_c('div', {
    staticClass: "chart_left"
  }, _vm._l((_vm.reportList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "left-t"
    }, [_c('div', {
      staticClass: "icon"
    }, [_c('img', {
      attrs: {
        "src": item.itemIcon
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "desc"
    }, [_c('div', {
      staticClass: "a-title"
    }, [_vm._v(_vm._s(item.itemName))]), _vm._v(" "), (item.itemName.includes('金额')) ? _c('div', {
      staticClass: "amount"
    }, [_vm._v(_vm._s(_vm.aFormat(item.amount))), _c('span', [_vm._v("元")])]) : _vm._e(), _vm._v(" "), (item.itemName.includes('数量')) ? _c('div', {
      staticClass: "amount"
    }, [_vm._v(_vm._s(item.count)), _c('span', [_vm._v("个")])]) : _vm._e()])])
  }), 0), _vm._v(" "), _c('div', {
    ref: "progressData",
    staticClass: "progressData"
  }), _vm._v(" "), _c('div', {
    staticClass: "projectArea"
  }, [_c('div', {
    staticClass: "p_title"
  }, [_vm._v("项目地区")]), _vm._v(" "), _vm._l((_vm.designRegionData), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "areaWrap"
    }, [_c('div', {
      staticClass: "item"
    }, [_c('div', {
      staticClass: "left"
    }, [_c('div', {
      staticClass: "location"
    }, [_vm._v(_vm._s(item.itemName))]), _vm._v(" "), _c('div', {
      staticClass: "number"
    }, [_c('span', {
      staticClass: "num"
    }, [_vm._v(_vm._s(item.count))]), _vm._v("个\n                ")])]), _vm._v(" "), _c('div', {
      staticClass: "right"
    }, [_c('img', {
      attrs: {
        "src": item.itemIcon
      }
    })])])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "chart_box"
  }, [_c('div', {
    staticClass: "pieChart"
  }, [_c('div', {
    staticClass: "abnormalTotal"
  }, [_c('div', {
    staticClass: "total"
  }, [_vm._v("异常总数")]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.abnormalTotal))]), _vm._v("个\n            ")])]), _vm._v(" "), _c('div', {
    ref: "abnormalData",
    staticClass: "abnormalData"
  })]), _vm._v(" "), _c('div', {
    ref: "abnormalType",
    staticClass: "abnormalType"
  })])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "partTitle_box"
  }, [_c('span', {
    staticClass: "partTitle"
  }, [_vm._v("进度数据")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "partTitle_box"
  }, [_c('div', {
    staticClass: "partTitle"
  }, [_vm._v("异常数据")])])
}]}

/***/ }),

/***/ 1651:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [(_vm.$wxOpenId) ? _c('el-row', {
    staticClass: "header"
  }, [_c('Navi'), _vm._v(" "), _c('div', {
    staticClass: "userinfo"
  }, [_c('el-popover', {
    attrs: {
      "placement": "right",
      "width": "424",
      "trigger": "click",
      "popper-class": "popover-db"
    },
    model: {
      value: (_vm.popover),
      callback: function($$v) {
        _vm.popover = $$v
      },
      expression: "popover"
    }
  }, [_c('div', {
    staticClass: "db-top"
  }, [_c('span', {
    class: _vm.msgType == 1 ? 'current' : '',
    on: {
      "click": function($event) {
        return _vm.toMsg(1)
      }
    }
  }, [_vm._v("我的待办"), (_vm.messageCount) ? _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("(" + _vm._s(_vm.messageCount) + ")")]) : _vm._e()]), _vm._v(" "), _c('span', {
    class: _vm.msgType == 2 ? 'current' : '',
    on: {
      "click": function($event) {
        return _vm.toMsg(2)
      }
    }
  }, [_vm._v("抄送我"), (_vm.messageCount2) ? _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("(" + _vm._s(_vm.messageCount2) + ")")]) : _vm._e()]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-close",
    staticStyle: {
      "float": "right",
      "margin-top": "14px",
      "font-size": "21px",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.popover = false
      }
    }
  })]), _vm._v(" "), (_vm.msgType == 1) ? _c('div', [(_vm.msgList.length) ? _c('ul', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.load),
      expression: "load"
    }, {
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "msg",
    staticClass: "infinite-list"
  }, [_vm._l((_vm.msgList), function(item) {
    return _c('li', {
      staticClass: "infinite-list-item",
      on: {
        "click": function($event) {
          return _vm.$root.gotoDetail(item)
        }
      }
    }, [_c('div', {
      staticClass: "ft"
    }, [_vm._v(_vm._s(item.initiatorName) + "提交的" + _vm._s(item.itemName))]), _vm._v(" "), _c('div', {
      staticClass: "ov"
    }, [_vm._v(_vm._s(item.bizItemName))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$root.formatDate(item.initiateTime)))])])
  }), _vm._v(" "), (_vm.pageCount == _vm.pageNo && _vm.msgList.length > 6) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("下面没有数据啦")]) : _vm._e()], 2) : _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("暂无消息")])]) : _vm._e(), _vm._v(" "), (_vm.msgType == 2) ? _c('div', [_c('el-checkbox', {
    staticStyle: {
      "padding-top": "12px"
    },
    attrs: {
      "true-label": "Y",
      "false-label": ""
    },
    on: {
      "change": _vm.awaitChange
    },
    model: {
      value: (_vm.isAwait),
      callback: function($$v) {
        _vm.isAwait = $$v
      },
      expression: "isAwait"
    }
  }, [_vm._v("未读抄送")]), _vm._v(" "), (_vm.msgList2.length) ? _c('div', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.load2),
      expression: "load2"
    }, {
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "msg2",
    staticClass: "infinite-list"
  }, [_vm._l((_vm.msgList2), function(item) {
    return _c('div', {
      staticClass: "infinite-list-item copy",
      class: item.isAwait == 'Y' ? 'unread' : '',
      on: {
        "click": function($event) {
          return _vm.$root.gotoDetail(item)
        }
      }
    }, [_c('div', {
      staticClass: "ft"
    }, [_vm._v(_vm._s(item.initiatorName) + "提交的" + _vm._s(item.itemName))]), _vm._v(" "), _c('div', {
      staticClass: "ov"
    }, [_vm._v(_vm._s(item.bizItemName))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$root.formatDate(item.initiateTime)))]), _vm._v(" "), _c('div', [(item.processProgress == 'AUDIT_WAIT') ? _c('div', {
      staticClass: "status",
      staticStyle: {
        "color": "#e6a23c"
      }
    }, [_vm._v("\n                                        办理中")]) : _vm._e(), _vm._v(" "), (item.processProgress == 'AUDIT_OK') ? _c('div', {
      staticClass: "status",
      staticStyle: {
        "color": "green"
      }
    }, [_vm._v("审核通过\n                                    ")]) : _vm._e(), _vm._v(" "), (item.processProgress == 'AUDIT_REJECTED') ? _c('div', {
      staticClass: "status",
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("\n                                        审核不通过")]) : _vm._e()])])
  }), _vm._v(" "), (_vm.pageCount2 == _vm.pageNo2 && _vm.msgList2.length > 5) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("下面没有数据啦\n                            ")]) : _vm._e()], 2) : _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("暂无消息")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "xm-message-box",
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  }, [_c('i', {
    staticClass: "el-icon-s-claim",
    staticStyle: {
      "font-size": "18px",
      "position": "relative",
      "margin-right": "15px"
    },
    attrs: {
      "title": "我的待办"
    },
    on: {
      "click": function($event) {
        return _vm.toMsg(1)
      }
    }
  }, [(_vm.messageCount != 0) ? _c('abbr', [_vm._v(_vm._s(_vm.messageCount > 99 ? '99+' : _vm.messageCount))]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "cc-pg",
    staticStyle: {
      "font-size": "18px",
      "position": "relative",
      "margin-right": "4px"
    },
    attrs: {
      "title": "抄送我"
    },
    on: {
      "click": function($event) {
        return _vm.toMsg(2)
      }
    }
  }, [(_vm.messageCount2 != 0) ? _c('abbr', [_vm._v(_vm._s(_vm.messageCount2 > 99 ? '99+' : _vm.messageCount2))]) : _vm._e()])])]), _vm._v(" "), _c('el-dropdown', {
    attrs: {
      "trigger": "hover"
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link userinfo-inner"
  }, [_c('i', {
    staticClass: "el-icon-user-solid",
    staticStyle: {
      "font-size": "18px"
    }
  }), _vm._v(" " + _vm._s(_vm.realName)), _c('i', {
    staticClass: "el-icon-caret-bottom"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.changeUser.apply(null, arguments)
      }
    }
  }, [_vm._v("切换账号")]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "divided": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toLogout.apply(null, arguments)
      }
    }
  }, [_vm._v("退出登录")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('router-view', {
    key: _vm.key
  }), _vm._v(" "), _c('ModalLoginWidget', {
    ref: "modalLogin"
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1652:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('HeadControl', {
    ref: "headControl",
    attrs: {
      "titleName": '派单数据'
    },
    on: {
      "changeVal": _vm.changeVal,
      "changDate": _vm.changDate,
      "changePicker": _vm.changePicker
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('div', {
    ref: "sendOrdersNum",
    staticClass: "sendOrdersNum"
  }), _vm._v(" "), _c('span', {
    staticClass: "sendNum"
  }, [_vm._v("\n        派单总数:"), _c('span', [_c('span', {
    staticClass: "num"
  }, [_vm._v(" " + _vm._s(_vm.count))]), _vm._v("个")])])]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('div', {
    staticClass: "b_left"
  }, [_c('div', {
    staticClass: "projectArea"
  }, [_c('div', {
    staticClass: "p_title"
  }, [_vm._v("项目地区")]), _vm._v(" "), _c('div', {
    staticClass: "areaWrap"
  }, _vm._l((_vm.projectAreaData), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "item"
    }, [_c('div', {
      staticClass: "left"
    }, [_c('div', {
      staticClass: "location"
    }, [_vm._v(_vm._s(item.itemName))]), _vm._v(" "), _c('div', {
      staticClass: "number"
    }, [_c('span', {
      staticClass: "num"
    }, [_vm._v(_vm._s(item.count))]), _vm._v("个")])]), _vm._v(" "), _c('div', {
      staticClass: "right"
    }, [_c('img', {
      attrs: {
        "src": item.itemIcon
      }
    })])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "residentWrap"
  }, [_c('div', {
    ref: "residentPer",
    staticClass: "residentPer"
  }), _vm._v(" "), _vm._l((_vm.residentNumList), function(item, index) {
    return _c('div', {
      key: index + 2,
      staticClass: "leftTitle",
      class: {
        'lastTitle': index == 1
      }
    }, [_vm._v("驻场(" + _vm._s(item) + "个)")])
  }), _vm._v(" "), _vm._l((_vm.notResidentNumList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "rightTitle"
    }, [_vm._v("不驻场(" + _vm._s(item) + "个)")])
  })], 2)]), _vm._v(" "), _c('div', {
    ref: "projectGrade",
    staticClass: "projectGrade"
  })])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1653:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "EliteDirectorDataReport"
    }
  }, [_c('div', {
    attrs: {
      "id": "right"
    }
  }, [_c('HeadControl', {
    ref: "HeadControl",
    attrs: {
      "optionsVal": true,
      "titleName": '总监数据'
    },
    on: {
      "changeVal": _vm.changeVal,
      "changDate": _vm.changDate,
      "changePicker": _vm.changePicker
    }
  }), _vm._v(" "), (_vm.headData.length) ? _c('div', {
    staticClass: "shortDes"
  }, [_c('div', {
    staticClass: "BoxLeft"
  }, [_c('div', {
    staticClass: "BoxText"
  }, [_vm._v("精英总数")]), _vm._v(" "), _c('div', {
    staticClass: "BoxData"
  }, [_c('div', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.headData[0].count)), _c('i', [_vm._v("人")])]), _vm._v(" "), _c('div', {
    staticClass: "DataImg"
  }, [_c('img', {
    attrs: {
      "src": _vm.headData[0].itemIcon,
      "alt": ""
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "BoxRight"
  }, [_c('div', {
    staticClass: "BoxText"
  }, [_vm._v("按地区")]), _vm._v(" "), _c('div', {
    staticClass: "regionData"
  }, [_c('div', {
    staticClass: "BoxData"
  }, [_c('div', {
    staticClass: "SmBoxData"
  }, [_c('div', {
    staticClass: "region"
  }, [_vm._v("国内")]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.headData[1].count)), _c('i', [_vm._v("人")])])]), _vm._v(" "), _c('div', {
    staticClass: "DataImg"
  }, [_c('img', {
    attrs: {
      "src": _vm.headData[1].itemIcon,
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "BoxData"
  }, [_c('div', {
    staticClass: "SmBoxData"
  }, [_c('div', {
    staticClass: "region"
  }, [_vm._v("广东省")]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.headData[2].count)), _c('i', [_vm._v("人")])])]), _vm._v(" "), _c('div', {
    staticClass: "DataImg"
  }, [_c('img', {
    attrs: {
      "src": _vm.headData[2].itemIcon,
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "BoxData"
  }, [_c('div', {
    staticClass: "SmBoxData"
  }, [_c('div', {
    staticClass: "region"
  }, [_vm._v("深圳市")]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.headData[3].count)), _c('i', [_vm._v("人")])])]), _vm._v(" "), _c('div', {
    staticClass: "DataImg"
  }, [_c('img', {
    attrs: {
      "src": _vm.headData[3].itemIcon,
      "alt": ""
    }
  })])])])])]) : _vm._e(), _vm._v(" "), _c('div', [_c('EliteDirectorDataEcharts', {
    attrs: {
      "dataRange": _vm.dataRange,
      "EliteNumberDataList": _vm.EliteNumberDataList,
      "CooperationDtaList": _vm.CooperationDtaList,
      "EliteTypeDataList": _vm.EliteTypeDataList
    }
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 1654:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "loseDataEcharts"
    }
  }, [_c('div', {
    ref: "progressEcharts",
    attrs: {
      "id": "progressEcharts"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "PieEchartsBox"
  }, [_c('div', {
    ref: "PieEcharts",
    attrs: {
      "id": "PieEcharts"
    }
  }), _vm._v(" "), (_vm.Judge) ? _c('div', {
    staticClass: "nodata_box"
  }, [_c('img', {
    attrs: {
      "src": "https://xmyun.zhoty.com/xmerp/pcadmin/static/images/report_item_nodata.png"
    }
  }), _vm._v(" "), _c('span', [_vm._v("暂无数据")])]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),

/***/ 1655:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "login-modal"
  }, [_c('el-form', {
    ref: "loginForm",
    staticClass: "demo-ruleForm login-container",
    attrs: {
      "model": _vm.loginForm,
      "label-position": "left",
      "label-width": "0px"
    }
  }, [_c('div', {
    staticClass: "right-top"
  }, [(_vm.isScanCode) ? _c('div', {
    staticClass: "icon-d",
    on: {
      "click": _vm.toggleLogin
    }
  }) : _c('div', {
    staticClass: "icon-e",
    on: {
      "click": _vm.toggleLogin
    }
  })]), _vm._v(" "), (!_vm.isScanCode) ? _c('div', [_c('h3', {
    staticClass: "title"
  }, [_vm._v("账号登录")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "account"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "账号",
      "readonly": _vm.evnMsg != ''
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        return _vm.doLogin.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.loginForm.account),
      callback: function($$v) {
        _vm.$set(_vm.loginForm, "account", $$v)
      },
      expression: "loginForm.account"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "密码",
      "readonly": _vm.evnMsg != ''
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        return _vm.doLogin.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.loginForm.password),
      callback: function($$v) {
        _vm.$set(_vm.loginForm, "password", $$v)
      },
      expression: "loginForm.password"
    }
  })], 1), _vm._v(" "), (_vm.evnMsg) ? _c('div', {
    staticClass: "phone-info"
  }, [_c('span', [_vm._v("当前手机号：" + _vm._s(_vm.phone))]), _vm._v(" "), _c('div', {
    staticClass: "phone-code"
  }, [_c('el-input', {
    staticStyle: {
      "width": "140px"
    },
    model: {
      value: (_vm.loginForm.userCode),
      callback: function($$v) {
        _vm.$set(_vm.loginForm, "userCode", $$v)
      },
      expression: "loginForm.userCode"
    }
  }), _vm._v(" "), (!_vm.switchFlag) ? _c('div', {
    staticClass: "code-time",
    on: {
      "click": _vm.getCode
    }
  }, [_vm._v("获取验证码")]) : _vm._e(), _vm._v(" "), (_vm.switchFlag) ? _c('div', {
    staticClass: "code-time span"
  }, [_vm._v(_vm._s(_vm.countdown) + "秒后重新获取")]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%",
      "text-align": "center"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "color": "red",
      "loading": _vm.isLoading
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.doLogin.apply(null, arguments)
      }
    }
  }, [_vm._v("登录")]), _vm._v(" "), _c('div', {
    staticClass: "f-p-text"
  }, [_c('span', {
    on: {
      "click": function($event) {
        return _vm.$router.push('/forgotPassword')
      }
    }
  }, [_vm._v("忘记密码？")])]), _vm._v(" "), _c('span', {
    staticClass: "error-text"
  }, [_vm._v(_vm._s(_vm.errorMsg))])], 1)], 1) : _c('div', {
    staticClass: "scan-code"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("微信登录")]), _vm._v(" "), _c('div', {
    staticClass: "qrcode-container"
  }, [(!_vm.isEXPIRED) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.qrcodeLoading),
      expression: "qrcodeLoading"
    }],
    staticClass: "qrcode"
  }, [(_vm.wxQrcode) ? _c('img', {
    attrs: {
      "src": _vm.wxQrcode
    }
  }) : _vm._e()]) : _c('div', {
    staticClass: "state-tips"
  }, [(_vm.loginStatus == 'EXPIRED') ? _c('div', {
    staticClass: "Refresh-tips"
  }, [_c('span', {
    staticClass: "decs"
  }, [_vm._v("二维码已失效")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://xmyun.zhoty.com/xmerp/xmfiles/2023/09/05/297e26a0-4bd3-11ee-9a53-f5a4998a3436.png"
    },
    on: {
      "click": function($event) {
        return _vm.getWxLoginQrcode()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "decs"
  }, [_vm._v("点击刷新")])]) : _vm._e(), _vm._v(" "), (_vm.loginStatus == 'SUCCEED') ? _c('div', {
    staticClass: "succ-tips"
  }, [_c('img', {
    attrs: {
      "src": "https://xmyun.zhoty.com/xmerp/xmfiles/2023/09/06/56ef4520-4c9a-11ee-b846-d13e2e9d6291.png"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "decs"
  }, [_vm._v("扫描成功!")]), _vm._v(" "), _c('span', {
    staticClass: "decs-t"
  }, [_vm._v("请勿刷新本页面")])]) : _vm._e(), _vm._v(" "), (_vm.loginStatus == 'UNIDENTIFIED') ? _c('div', {
    staticClass: "succ-tips"
  }, [_c('img', {
    attrs: {
      "src": "https://xmyun.zhoty.com/xmerp/xmfiles/2023/09/06/56ef9340-4c9a-11ee-b846-d13e2e9d6291.png"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "decs"
  }, [_vm._v("非系统人员!")]), _vm._v(" "), _c('span', {
    staticClass: "decs-t"
  }, [_vm._v("请联系管理员")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "qrcode-tips"
  }, [_c('img', {
    attrs: {
      "src": "https://xmyun.zhoty.com/xmerp/xmfiles/2023/09/05/297f1100-4bd3-11ee-9a53-f5a4998a3436.png"
    }
  }), _vm._v(" "), _c('span', [_vm._v("请使用"), _c('span', {
    staticClass: "tip"
  }, [_vm._v("微信扫描")]), _vm._v("二维码登录")])])])])], 1), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top"
  }, [_c('div', {
    staticClass: "content",
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "40px",
      "height": "40px"
    },
    attrs: {
      "src": "data:image/png;base64,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",
      "alt": ""
    }
  }), _c('span'), _vm._v("新美云平台\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_vm._v("Copyright © 2022 新美装饰建设集团 保留所有权利。"), _c('a', {
    attrs: {
      "href": "http://beian.miit.gov.cn",
      "target": "_blank"
    }
  }, [_vm._v("备案号：粤ICP备13068383号")])])
}]}

/***/ }),

/***/ 1656:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "welcomeViewApprove"
  }, [(_vm.componentsList.length) ? _c('div', _vm._l((_vm.componentsList), function(item) {
    return _c('div', {
      key: item.bizItemId,
      staticClass: "content",
      on: {
        "click": function($event) {
          return _vm.gotoDetail(item)
        }
      }
    }, [_c('div', {
      staticClass: "head",
      staticStyle: {
        "-webkit-box-orient": "vertical"
      }
    }, [_vm._v(_vm._s(item.initiatorName) + "提交的" + _vm._s(item.itemName) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "center",
      staticStyle: {
        "-webkit-box-orient": "vertical"
      }
    }, [_vm._v(_vm._s(item.bizItemName))]), _vm._v(" "), _c('div', {
      staticClass: "date"
    }, [_vm._v(_vm._s(_vm.$root.formatDate(item.initiateTime)))])])
  }), 0) : _c('div', {
    staticClass: "message"
  }, [_vm._v("暂无消息")]), _vm._v(" "), (_vm.componentsList.length >= 3) ? _c('div', {
    staticClass: "more"
  }, [_vm._v("查看更多"), _c('i', {
    staticClass: "el-icon-arrow-right"
  })]) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 1657:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "BigBox",
    attrs: {
      "id": "synthitcDataH5"
    }
  }, [_c('div', {
    staticClass: "box-top"
  }, [_c('div', {
    staticClass: "box-img",
    on: {
      "click": _vm.Optionsidebar
    }
  }, [_c('img', {
    staticClass: "iconImg",
    attrs: {
      "src": "https://xmyun.zhoty.com/xmerp/xmapp/xmapp-report-menu.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "box"
    }
  }, [_c('div', {
    attrs: {
      "id": "left-box"
    }
  }, [_c('el-menu', {
    staticClass: "el-menu-vertical-demo",
    attrs: {
      "default-active": "签约数据",
      "collapse": _vm.isCollapse,
      "unique-opened": true
    },
    on: {
      "select": _vm.selsectOpen
    }
  }, _vm._l((_vm.TreeList), function(item, index) {
    return _c('el-submenu', {
      key: index,
      staticClass: "elsubmenu",
      attrs: {
        "index": item.menuName + ''
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('span', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v(_vm._s(item.menuName))])]), _vm._v(" "), _vm._l((item.children), function(itemTow, index) {
      return _c('el-menu-item-group', {
        key: index
      }, [_c('el-menu-item', {
        attrs: {
          "index": itemTow.menuName + ''
        }
      }, [_vm._v(_vm._s(itemTow.menuName))])], 1)
    })], 2)
  }), 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "right-box"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showOption.apply(null, arguments)
      }
    }
  }, [(_vm.selsectData == '立项数据') ? _c('OperationaDataReportOne', {
    ref: "OperationaDataReportOne"
  }) : _vm._e(), _vm._v(" "), (_vm.selsectData == '招标数据') ? _c('BidsData', {
    ref: "BidsData"
  }) : _vm._e(), _vm._v(" "), (_vm.selsectData == '签约数据') ? _c('SignedData', {
    ref: "SignedData"
  }) : _vm._e(), _vm._v(" "), (_vm.selsectData == '丢单数据') ? _c('OperationaDataReportThree', {
    ref: "OperationaDataReportThree"
  }) : _vm._e(), _vm._v(" "), (_vm.selsectData == '汇总数据') ? _c('CollectData', {
    ref: "CollectData"
  }) : _vm._e(), _vm._v(" "), (_vm.selsectData == '总监数据') ? _c('EliteDirectorDataReportOne', {
    ref: "EliteDirectorDataReportOne"
  }) : _vm._e(), _vm._v(" "), (_vm.selsectData == '持证数据') ? _c('HoldCertificateData', {
    ref: "HoldCertificateData"
  }) : _vm._e(), _vm._v(" "), (_vm.selsectData == '甲方数据') ? _c('CustomerOwnerDataReportOne', {
    ref: "CustomerOwnerDataReportOne"
  }) : _vm._e(), _vm._v(" "), (_vm.selsectData == '入库备案数据') ? _c('CustomerOwnerDataReportTwo', {
    ref: "CustomerOwnerDataReportTwo"
  }) : _vm._e(), _vm._v(" "), (_vm.selsectData == '流水数据') ? _c('waterData', {
    ref: "waterData"
  }) : _vm._e(), _vm._v(" "), (_vm.selsectData == '应收数据') ? _c('receivableData', {
    ref: "receivableData"
  }) : _vm._e(), _vm._v(" "), (_vm.selsectData == '应付数据') ? _c('dealWithData', {
    ref: "dealWithData"
  }) : _vm._e(), _vm._v(" "), (_vm.selsectData == '结算数据') ? _c('closeAccountsData', {
    ref: "closeAccountsData"
  }) : _vm._e(), _vm._v(" "), (_vm.selsectData == '派单数据') ? _c('sendOrdersData', {
    ref: "sendOrdersData"
  }) : _vm._e(), _vm._v(" "), (_vm.selsectData == '巡检数据') ? _c('pollingData', {
    ref: "pollingData"
  }) : _vm._e(), _vm._v(" "), (_vm.selsectData == '异常数据') ? _c('abnormalData', {
    ref: "abnormalData"
  }) : _vm._e(), _vm._v(" "), (_vm.selsectData == '设计数据') ? _c('designData', {
    ref: "designData"
  }) : _vm._e(), _vm._v(" "), (_vm.selsectData == '购销数据') ? _c('sellingData', {
    ref: "sellingData"
  }) : _vm._e()], 1)])])
},staticRenderFns: []}

/***/ }),

/***/ 1658:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "OperationaDataReportThree"
    }
  }, [_c('div', {
    attrs: {
      "id": "right"
    }
  }, [_c('HeadControl', {
    ref: "HeadControl",
    attrs: {
      "titleName": "丢单数据"
    },
    on: {
      "changeVal": _vm.changeVal,
      "changDate": _vm.changDate,
      "changePicker": _vm.changePicker
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "centerBox"
  }, [_c('div', {
    staticClass: "leftBox"
  }, [_c('div', {
    staticClass: "numberBox"
  }, [_c('div', {
    staticClass: "numberBoxSmall"
  }, [_c('div', {
    staticClass: "imgBox"
  }, [(_vm.reportList.length) ? _c('img', {
    attrs: {
      "src": _vm.reportList[0].itemIcon,
      "alt": ""
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "dataBox"
  }, [_c('div', {
    staticClass: "ChineseBox"
  }, [_vm._v(_vm._s(_vm.legend[0]))]), _vm._v(" "), (_vm.reportList.length) ? _c('div', {
    staticClass: "numBox"
  }, [_vm._v(_vm._s(_vm.reportList[0].count)), _c('i', [_vm._v("个")])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "individualBox"
  }, [_c('div', {
    staticClass: "numberBoxSmall"
  }, [_c('div', {
    staticClass: "imgBox"
  }, [(_vm.reportList.length) ? _c('img', {
    attrs: {
      "src": _vm.reportList[1].itemIcon,
      "alt": ""
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "dataBox"
  }, [_c('div', {
    staticClass: "ChineseBox"
  }, [_vm._v(_vm._s(_vm.legend[1]))]), _vm._v(" "), (_vm.reportList.length) ? _c('div', {
    staticClass: "numBox"
  }, [_vm._v(_vm._s(_vm.reportList[1].totalCount)), _c('i', [_vm._v("人")])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "rightBox"
  }, [_c('div', {
    ref: "LoseProjectPerformanceEharts",
    attrs: {
      "id": "LoseProjectPerformanceEharts"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "bottonBox"
  }, [_c('loseDataEcharts', {
    ref: "loseDataEcharts",
    attrs: {
      "screenWidth": _vm.screenWidth,
      "LoseProjectSourceDataList": _vm.LoseProjectSourceDataList,
      "LoseProjectTypeDataList": _vm.LoseProjectTypeDataList
    }
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 1659:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-user"
  }, [_c('div', {
    staticClass: "user-header"
  }, [_c('img', {
    attrs: {
      "src": _vm.userInfo.avatarPath
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "user-info"
  }, [_c('span', {
    staticClass: "user-name"
  }, [_vm._v(_vm._s(_vm.userInfo.realName))]), _vm._v(" "), _c('span', {
    staticClass: "user-account"
  }, [_vm._v("账号：" + _vm._s(_vm.userInfo.account))])])]), _vm._v(" "), _c('div', {
    staticClass: "user-item"
  }, [_c('div', {
    staticClass: "user-tip"
  }, [_c('span', [_vm._v("手机号码")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.userInfo.phone))])]), _vm._v(" "), _c('div', {
    staticClass: "user-tip"
  }, [_c('span', [_vm._v("角色")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.userInfo.roleName))])])]), _vm._v(" "), _c('div', {
    staticClass: "remove-account",
    on: {
      "click": _vm.btn
    }
  }, [_vm._v("解除绑定")]), _vm._v(" "), _c('Nav', {
    attrs: {
      "navIndex": 2
    }
  }), _vm._v(" "), _c('van-dialog', {
    staticStyle: {
      "width": "270px"
    },
    attrs: {
      "show-cancel-button": ""
    },
    on: {
      "confirm": _vm.removeInfo
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("标题")]), _vm._v(" "), _c('div', {
    staticClass: "make"
  }, [_vm._v("解除后将不会再收到新美云待办提醒，也不能再处理新美云待办事项")])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1660:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "ProjectDataEcharts"
    }
  }, [_c('div', {
    ref: "progressEcharts",
    attrs: {
      "id": "progressEcharts"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "PieEchartsBox"
  }, [_c('div', {
    ref: "PieEcharts",
    attrs: {
      "id": "PieEcharts"
    }
  }), _vm._v(" "), (_vm.Judge) ? _c('div', {
    staticClass: "nodata_box"
  }, [_c('img', {
    attrs: {
      "src": "https://xmyun.zhoty.com/xmerp/pcadmin/static/images/report_item_nodata.png"
    }
  }), _vm._v(" "), _c('span', [_vm._v("暂无数据")])]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),

/***/ 1661:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "CustomerOwnerDataReportTwo"
    }
  }, [_c('div', {
    attrs: {
      "id": "right"
    }
  }, [_c('div', {
    staticClass: "reportView"
  }, [_c('div', {
    staticClass: "BottomBox"
  }, [_c('div', {
    ref: "OnepieChart",
    attrs: {
      "id": "OnepieChart"
    }
  }), _vm._v(" "), _c('div', {
    ref: "Twohistogram",
    attrs: {
      "id": "Twohistogram"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "histogram"
  }, [_c('div', {
    ref: "threemyChart",
    attrs: {
      "id": "threemyChart"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "otherStaffs",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('el-radio-group', {
    class: [_vm.$route.query.identification ? 'h5Position' : 'PCposition'],
    attrs: {
      "fill": "#52D2A2",
      "size": "small"
    },
    on: {
      "change": function($event) {
        return _vm.getOtherPersonnel()
      }
    },
    model: {
      value: (_vm.OtherPersonnelType),
      callback: function($$v) {
        _vm.OtherPersonnelType = $$v
      },
      expression: "OtherPersonnelType"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "CERTIFICATE_TYPE_SAFETY"
    }
  }, [_vm._v("安证人员")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "CERTIFICATE_TYPE_TITLE"
    }
  }, [_vm._v("职称人员")])], 1), _vm._v(" "), _c('div', {
    ref: "otherStaffsEchart",
    attrs: {
      "id": "otherStaffsEchart"
    }
  })], 1)])])])
},staticRenderFns: []}

/***/ }),

/***/ 1662:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "welcomeView"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('h3', [_vm._v("项目管理")]), _vm._v(" "), _c('div', {
    staticClass: "title-box"
  }, _vm._l((_vm.ProjectManagementList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "content"
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "value",
      on: {
        "click": function($event) {
          _vm.Skip(item.img.split('xmgl-')[1].split('.')[0])
        }
      }
    }, [_c('div', {
      staticClass: "number"
    }, [_vm._v(_vm._s(item.count) + "个")]), _vm._v(" "), _c('div', {
      staticClass: "icon"
    }, [_c('img', {
      attrs: {
        "src": item.img,
        "alt": ""
      }
    })])])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "title-box"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("\n            " + _vm._s(_vm.username) + " 您好，欢迎使用新美云平台！\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "date"
  }, [_vm._v("当前时间：" + _vm._s(_vm.$root.formatDate(_vm.time)))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('h3', [_vm._v("审批管理")]), _vm._v(" "), _c('div', {
    staticClass: "center-box"
  }, [_c('div', {
    staticClass: "left-box"
  }, [_c('div', {
    staticClass: "one-box"
  }, [_c('div', {
    staticClass: "notification"
  }, [_c('div', {
    staticClass: "bubble",
    on: {
      "click": function($event) {
        _vm.activeName = 'Wait'
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.Newstotal >= 100 ? "99+" : _vm.Newstotal) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "bubble1",
    on: {
      "click": function($event) {
        _vm.activeName = 'Send'
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.CopyNewtotal >= 100 ? "99+" : _vm.CopyNewtotal) + "\n            ")]), _vm._v(" "), [_c('el-tabs', {
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "待办",
      "name": "Wait"
    }
  }, [_c('welcomeViewApproveVue', {
    attrs: {
      "WaitList": _vm.NewsList
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "抄送我",
      "name": "Send"
    }
  }, [_c('welcomeViewApproveVue', {
    attrs: {
      "WaitList": _vm.CopyNewsList
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "已发起",
      "name": "initiate"
    }
  })], 1)]], 2), _vm._v(" "), _c('div', {
    staticClass: "request"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "centerBOX"
  }, _vm._l((_vm.requestList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "value",
      on: {
        "click": function($event) {
          _vm.SkipAdd(item.src.split('fqsq-')[1].split('.')[0])
        }
      }
    }, [_c('div', {
      staticClass: "centerIcon"
    }, [_c('img', {
      staticStyle: {
        "width": "100%",
        "height": "100%"
      },
      attrs: {
        "src": item.src,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "centerName"
    }, [_vm._v(_vm._s(item.name))])])
  }), 0)])]), _vm._v(" "), _c('h3', [_vm._v("我的应用")]), _vm._v(" "), _c('div', {
    staticClass: "two-box"
  }, _vm._l((_vm.SkipList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "content",
      on: {
        "click": function($event) {
          _vm.Skip(item.src.split('app-')[1].split('.')[0])
        }
      }
    }, [_c('div', {
      staticClass: "icon"
    }, [_c('img', {
      staticStyle: {
        "width": "100%",
        "height": "100%"
      },
      attrs: {
        "src": item.src,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.name))])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [
    [_c('el-tabs', {
      on: {
        "tab-click": _vm.handleClick1
      },
      model: {
        value: (_vm.activeName1),
        callback: function($$v) {
          _vm.activeName1 = $$v
        },
        expression: "activeName1"
      }
    }, [_c('el-tab-pane', {
      attrs: {
        "label": "公告通知",
        "name": "message",
        "lazy": ""
      }
    }, [_c('welcomeViewModulesVue', {
      attrs: {
        "institutionList": _vm.COMP_NOTICELIST
      }
    })], 1), _vm._v(" "), _c('el-tab-pane', {
      attrs: {
        "label": "公司新闻",
        "name": "news",
        "lazy": ""
      }
    }, [_c('welcomeViewModulesVue', {
      attrs: {
        "institutionList": _vm.COMP_NEWSLIST
      }
    })], 1), _vm._v(" "), _c('el-tab-pane', {
      attrs: {
        "label": "制度公告",
        "name": "announcement",
        "lazy": ""
      }
    }, [_c('welcomeViewModulesVue', {
      attrs: {
        "institutionList": _vm.COMP_INSTLIST
      }
    })], 1)], 1)]
  ], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "head"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": "https://xmyun.zhoty.com/xmerp/pcadmin/static/images/workbench/faqishenqing_30x30.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("发起申请")])])
}]}

/***/ }),

/***/ 1663:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "CustomerOwnerDataReport"
    }
  }, [_c('div', {
    attrs: {
      "id": "right"
    }
  }, [_c('HeadControl', {
    ref: "HeadControl",
    attrs: {
      "optionsVal": true,
      "titleName": '甲方数据'
    },
    on: {
      "changeVal": _vm.changeVal,
      "changDate": _vm.changDate,
      "changePicker": _vm.changePicker
    }
  }), _vm._v(" "), (_vm.headData.length) ? _c('div', {
    staticClass: "shortDes"
  }, [_c('div', {
    staticClass: "BoxLeft"
  }, [_c('div', {
    staticClass: "BoxText"
  }, [_vm._v("客户总数")]), _vm._v(" "), _c('div', {
    staticClass: "BoxData"
  }, [_c('div', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.headData[0].count)), _c('i', [_vm._v("个")])]), _vm._v(" "), _c('div', {
    staticClass: "DataImg"
  }, [_c('img', {
    attrs: {
      "src": _vm.headData[0].itemIcon,
      "alt": ""
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "BoxRight"
  }, [_c('div', {
    staticClass: "BoxText"
  }, [_vm._v("按地区")]), _vm._v(" "), _c('div', {
    staticClass: "regionData"
  }, [_c('div', {
    staticClass: "BoxData"
  }, [_c('div', {
    staticClass: "SmBoxData"
  }, [_c('div', {
    staticClass: "region"
  }, [_vm._v("国内")]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.headData[1].count)), _c('i', [_vm._v("个")])])]), _vm._v(" "), _c('div', {
    staticClass: "DataImg"
  }, [_c('img', {
    attrs: {
      "src": _vm.headData[1].itemIcon,
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "BoxData"
  }, [_c('div', {
    staticClass: "SmBoxData"
  }, [_c('div', {
    staticClass: "region"
  }, [_vm._v("广东省")]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.headData[2].count)), _c('i', [_vm._v("个")])])]), _vm._v(" "), _c('div', {
    staticClass: "DataImg"
  }, [_c('img', {
    attrs: {
      "src": _vm.headData[2].itemIcon,
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "BoxData"
  }, [_c('div', {
    staticClass: "SmBoxData"
  }, [_c('div', {
    staticClass: "region"
  }, [_vm._v("深圳市")]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.headData[3].count)), _c('i', [_vm._v("个")])])]), _vm._v(" "), _c('div', {
    staticClass: "DataImg"
  }, [_c('img', {
    attrs: {
      "src": _vm.headData[3].itemIcon,
      "alt": ""
    }
  })])])])])]) : _vm._e(), _vm._v(" "), _c('div', [_c('CustomerOwnerDataEcharts', {
    attrs: {
      "dataRange": _vm.dataRange,
      "CustomerDataList": _vm.CustomerDataList,
      "natureData": _vm.natureData,
      "IndustryData": _vm.IndustryData
    }
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 1664:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tree-control"
  }, [_c('div', {
    staticClass: "tree-input",
    style: ({
      width: _vm.wide + 'px'
    }),
    on: {
      "click": function($event) {
        return _vm.setShowTree(true)
      }
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "新美集团"
    },
    on: {
      "blur": _vm.hideThree
    },
    model: {
      value: (_vm.input),
      callback: function($$v) {
        _vm.input = $$v
      },
      expression: "input"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "el-icon-arrow-down",
    class: {
      'rotateZ': _vm.getShowTree
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.getShowTree),
      expression: "getShowTree"
    }],
    staticClass: "tree-box",
    style: ({
      width: (_vm.wide - 2) + 'px'
    })
  }, [_c('el-tree', {
    attrs: {
      "data": _vm.treelist,
      "default-expand-all": true
    },
    on: {
      "node-click": _vm.handleNodeClick
    }
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 1665:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "agent"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('span', [_vm._v("待处理")]), _vm._v(" "), (_vm.openWxMsgRemid == "Y") ? _c('div', {
    on: {
      "click": _vm.changeStatu
    }
  }, [_vm._v("关闭提醒")]) : _vm._e(), _vm._v(" "), (_vm.openWxMsgRemid == "N") ? _c('div', {
    staticClass: "div",
    on: {
      "click": _vm.changeStatu
    }
  }, [_vm._v("开启提醒")]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.load),
      expression: "load"
    }],
    staticClass: "tips",
    attrs: {
      "infinite-scroll-distance": "20",
      "infinite-scroll-delay": "500"
    }
  }, _vm._l((_vm.agentList), function(item) {
    return _c('div', {
      staticClass: "item",
      on: {
        "click": function($event) {
          return _vm.$root.gotoDetail(item)
        }
      }
    }, [_c('div', {
      staticClass: "user-submit"
    }, [_vm._v(_vm._s(item.initiatorName) + "提交的" + _vm._s(item.itemName))]), _vm._v(" "), _c('div', {
      staticClass: "project-name"
    }, [_vm._v(_vm._s(item.bizItemName))]), _vm._v(" "), _c('div', {
      staticClass: "submit-time"
    }, [_c('span', {
      staticClass: "status"
    }), _vm._v(" "), _c('span', {
      staticClass: "time"
    }, [_vm._v(_vm._s(item.initiateTime))])])])
  }), 0), _vm._v(" "), _c('Nav', {
    ref: "nav",
    attrs: {
      "navIndex": 0
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1666:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hl-pop-wrap"
  }, [_c('div', {
    staticClass: "hl-pop-content"
  }, [_c('div', {
    staticClass: "tips"
  }, [(_vm.title) ? _c('div', {
    staticClass: "hl-pop-title",
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isCloseIcon) ? _c('i', {
    staticClass: "el-icon-close close",
    on: {
      "click": function($event) {
        return _vm.close(1)
      }
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.title == "流程重启") ? _c('div', {
    staticClass: "form"
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "label-width": "80px",
      "label-position": "right",
      "model": _vm.ruleForm,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "原因",
      "prop": "resone"
    }
  }, [_c('el-input', {
    ref: "input",
    staticStyle: {
      "width": "330px"
    },
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 5
      },
      "maxlength": "300",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.ruleForm.resone),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "resone", $$v)
      },
      expression: "ruleForm.resone"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "12px",
      "color": "red",
      "margin-left": "80px"
    }
  }, [_vm._v("重启后，流程将回到发起申请环节，发起人可以编辑或删除。")])], 1)], 1) : _c('div', {
    staticClass: "hl-pop-detail"
  }, [_c('i', {
    staticClass: "el-icon-warning warning"
  }), _vm._v(" "), _c('div', [(_vm.message) ? _c('div', {
    staticClass: "hl-pop-message",
    domProps: {
      "innerHTML": _vm._s(_vm.message)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.subMessage) ? _c('div', {
    staticClass: "hl-pop-submessage",
    domProps: {
      "innerHTML": _vm._s(_vm.subMessage)
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "hl-alert-btn-group"
  }, [_c('el-button', {
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.ensure
    }
  }, [_vm._v(_vm._s(_vm.ensureBtnText))]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.close(2)
      }
    }
  }, [_vm._v("取消")])], 1)])])
},staticRenderFns: []}

/***/ }),

/***/ 1667:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "fileh5 upload",
    attrs: {
      "element-loading-text": "正在上传"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "upload-item"
  }, [_c('a', {
    staticClass: "file",
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('input', {
    attrs: {
      "id": "file_head",
      "type": "file",
      "accept": "image/*",
      "capture": "camera"
    },
    on: {
      "change": function($event) {
        return _vm.setImagePreview()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("拍照")])])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "upload-item"
  }, [_c('a', {
    staticClass: "file file2",
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('input', {
    attrs: {
      "id": "file_head2",
      "type": "file"
    },
    on: {
      "change": function($event) {
        return _vm.setFilePreview()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("文件")])])])])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1668:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "receivable-data"
  }, [_c('HeadControl', {
    ref: "HeadControl",
    attrs: {
      "titleName": '应收数据',
      "showorg": false
    },
    on: {
      "changePicker": _vm.changePicker,
      "changDate": _vm.changDate
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "inner-top"
  }, _vm._l((_vm.summaryList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "item"
    }, [_c('div', {
      staticClass: "l-box"
    }, [_c('div', {
      staticClass: "l-t"
    }, [_vm._v(_vm._s(item.itemName))]), _vm._v(" "), _c('div', {
      staticClass: "l-a"
    }, [_vm._v(_vm._s(_vm.aFormat(item.amount))), _c('span', [_vm._v("元")])]), _vm._v(" "), _c('div', {
      staticClass: "l-t"
    }, [_vm._v(_vm._s(item.count) + "个项目")])]), _vm._v(" "), _c('div', {
      staticClass: "r-box"
    }, [_c('img', {
      attrs: {
        "src": item.itemIcon
      }
    })])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "inner-bottom"
  }, [_c('div', {
    staticClass: "left"
  }, _vm._l((_vm.invoiceTotal), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "left-t"
    }, [_c('div', {
      staticClass: "icon"
    }, [_c('img', {
      attrs: {
        "src": item.itemIcon
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "desc"
    }, [_c('div', {
      staticClass: "a-title"
    }, [_vm._v(_vm._s(item.itemName))]), _vm._v(" "), _c('div', {
      staticClass: "amount"
    }, [_vm._v(_vm._s(_vm.aFormat(item.amount))), _c('span', [_vm._v("元")])]), _vm._v(" "), _c('div', {
      staticClass: "a-title"
    }, [_vm._v(_vm._s(item.count) + "个项目")])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    ref: "invoiceTotal",
    staticStyle: {
      "height": "100%"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "inner-bottom"
  }, [_c('div', {
    staticClass: "left"
  }, _vm._l((_vm.payableTotal), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "left-t"
    }, [_c('div', {
      staticClass: "icon"
    }, [_c('img', {
      attrs: {
        "src": item.itemIcon
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "desc"
    }, [_c('div', {
      staticClass: "a-title"
    }, [_vm._v(_vm._s(item.itemName))]), _vm._v(" "), _c('div', {
      staticClass: "amount"
    }, [_vm._v(_vm._s(_vm.aFormat(item.amount))), _c('span', [_vm._v("元")])]), _vm._v(" "), _c('div', {
      staticClass: "a-title"
    }, [_vm._v(_vm._s(item.count) + "个项目")])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    ref: "payableTotal",
    staticStyle: {
      "width": "100%",
      "height": "100%"
    }
  })])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1669:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "water-data"
  }, [_c('HeadControl', {
    ref: "HeadControl",
    attrs: {
      "titleName": '流水数据',
      "showorg": false
    },
    on: {
      "changePicker": _vm.changePicker,
      "changDate": _vm.changDate
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "inner-top"
  }, [_c('div', {
    staticClass: "left"
  }, _vm._l((_vm.summaryList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "left-t"
    }, [_c('div', {
      staticClass: "icon"
    }, [_c('img', {
      attrs: {
        "src": item.itemIcon
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "desc"
    }, [_c('div', {
      staticClass: "a-title"
    }, [_vm._v(_vm._s(item.itemName))]), _vm._v(" "), _c('div', {
      staticClass: "amount"
    }, [_vm._v(_vm._s(_vm.aFormat(item.amount))), _c('span', [_vm._v("元")])])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    ref: "currentTrend",
    staticStyle: {
      "height": "100%"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "inner-bottom"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "left-t"
  }, [_c('div', {
    staticClass: "a-titel"
  }, [_vm._v("收款类型")]), _vm._v(" "), _c('div', {
    staticClass: "count"
  }, _vm._l((_vm.summaryTypeList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "count-inner"
    }, [_c('div', {
      staticClass: "l-box"
    }, [_c('div', {
      staticClass: "l-t"
    }, [_vm._v(_vm._s(item.itemName))]), _vm._v(" "), _c('div', {
      staticClass: "l-a"
    }, [_vm._v(_vm._s(_vm.aFormat(item.amount))), _c('span', [_vm._v("元")])]), _vm._v(" "), _c('div', {
      staticClass: "l-t"
    }, [_vm._v(_vm._s(item.count) + "笔")])]), _vm._v(" "), _c('div', {
      staticClass: "r-box"
    }, [_c('img', {
      attrs: {
        "src": item.itemIcon
      }
    })])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "left-b"
  }, [_c('div', {
    ref: "proportion",
    staticStyle: {
      "height": "100%"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    ref: "paymenttype",
    staticStyle: {
      "height": "100%"
    }
  })])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1670:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('HeadControl', {
    ref: "headControl",
    attrs: {
      "titleName": '设计数据'
    },
    on: {
      "changeVal": _vm.changeVal,
      "changDate": _vm.changDate,
      "changePicker": _vm.changePicker
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "top"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "chart_box"
  }, [_c('div', {
    staticClass: "chart_left"
  }, _vm._l((_vm.reportList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "left-t"
    }, [_c('div', {
      staticClass: "icon"
    }, [_c('img', {
      attrs: {
        "src": item.itemIcon
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "desc"
    }, [_c('div', {
      staticClass: "a-title"
    }, [_vm._v(_vm._s(item.itemName))]), _vm._v(" "), (item.itemName.includes('金额')) ? _c('div', {
      staticClass: "amount"
    }, [_vm._v(_vm._s(_vm.aFormat(item.amount))), _c('span', [_vm._v("元")])]) : _vm._e(), _vm._v(" "), (item.itemName.includes('数量')) ? _c('div', {
      staticClass: "amount"
    }, [_vm._v(_vm._s(item.count)), _c('span', [_vm._v("个")])]) : _vm._e()])])
  }), 0), _vm._v(" "), _c('div', {
    ref: "progressData",
    staticClass: "progressData"
  }), _vm._v(" "), _c('div', {
    staticClass: "projectArea"
  }, [_c('div', {
    staticClass: "p_title"
  }, [_vm._v("项目地区")]), _vm._v(" "), _vm._l((_vm.designRegionData), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "areaWrap"
    }, [_c('div', {
      staticClass: "item"
    }, [_c('div', {
      staticClass: "left"
    }, [_c('div', {
      staticClass: "location"
    }, [_vm._v(_vm._s(item.itemName))]), _vm._v(" "), _c('div', {
      staticClass: "number"
    }, [_c('span', {
      staticClass: "num"
    }, [_vm._v(_vm._s(item.count))]), _vm._v("个\n                ")])]), _vm._v(" "), _c('div', {
      staticClass: "right"
    }, [_c('img', {
      attrs: {
        "src": item.itemIcon
      }
    })])])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "chart_box"
  }, [_c('div', {
    staticClass: "pieChart"
  }, [_c('div', {
    staticClass: "abnormalTotal"
  }, [_c('div', {
    staticClass: "total"
  }, [_vm._v("异常总数")]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.abnormalTotal))]), _vm._v("个")])]), _vm._v(" "), _c('div', {
    ref: "abnormalData",
    staticClass: "abnormalData"
  })]), _vm._v(" "), _c('div', {
    ref: "abnormalType",
    staticClass: "abnormalType"
  })])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "partTitle_box"
  }, [_c('span', {
    staticClass: "partTitle"
  }, [_vm._v("进度数据")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "partTitle_box"
  }, [_c('div', {
    staticClass: "partTitle"
  }, [_vm._v("异常数据")])])
}]}

/***/ }),

/***/ 1671:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "CustomerOwnerDataReportTwo"
    }
  }, [_c('div', {
    attrs: {
      "id": "right"
    }
  }, [_c('HeadControl', {
    ref: "HeadControl",
    attrs: {
      "optionsVal": true,
      "titleName": '入库备案数据',
      "showorg": false
    },
    on: {
      "changeVal": _vm.changeVal,
      "changDate": _vm.changDate,
      "changePicker": _vm.changePicker
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "reportView"
  }, [_c('div', {
    staticClass: "histogram"
  }, [_c('div', {
    ref: "BigThreemyCharts",
    attrs: {
      "id": "BigThreemyCharts"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "BottomBox"
  }, [_c('div', {
    ref: "OnepieChart",
    attrs: {
      "id": "OnepieChart"
    }
  }), _vm._v(" "), _c('div', {
    ref: "Twohistogram",
    attrs: {
      "id": "Twohistogram"
    }
  })])])], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 1672:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('div', [_c('keep-alive', [(_vm.$route.meta.keepAlive) ? _c('router-view') : _vm._e()], 1), _vm._v(" "), (!_vm.$route.meta.keepAlive) ? _c('router-view') : _vm._e()], 1)])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1673:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.content) ? void 0 : (_vm.num == '3') ? [(_vm.content.length < _vm.width / 14 * _vm.num) ? _c('div', [_vm._v(_vm._s(_vm.content))]) : _c('el-popover', {
    attrs: {
      "trigger": "hover",
      "placement": "top",
      "width": "500"
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.content))]), _vm._v(" "), _c('div', {
    staticClass: "overflow-3",
    staticStyle: {
      "height": "67px"
    },
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  }, [_vm._v("\n                " + _vm._s(_vm.content) + "\n            ")])])] : (_vm.num == '2') ? [(_vm.content.length < _vm.width / 14 * _vm.num) ? _c('div', [_vm._v(_vm._s(_vm.content))]) : _c('el-popover', {
    attrs: {
      "trigger": "hover",
      "placement": "top",
      "width": "500"
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.content))]), _vm._v(" "), _c('div', {
    staticClass: "overflow-2",
    staticStyle: {
      "height": "47px"
    },
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  }, [_vm._v("\n                " + _vm._s(_vm.content) + "\n            ")])])] : (_vm.num == '1') ? [(_vm.content.length < _vm.width / 14 * _vm.num) ? _c('div', [_vm._v(_vm._s(_vm.content))]) : _c('el-popover', {
    attrs: {
      "trigger": "hover",
      "placement": "top",
      "width": "400"
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.content))]), _vm._v(" "), _c('div', {
    staticClass: "overflow-1",
    staticStyle: {
      "height": "24px"
    },
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  }, [_vm._v("\n                " + _vm._s(_vm.content) + "\n            ")])])] : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),

/***/ 1674:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navi"
  }, [_c('el-row', {
    staticClass: "top-nav"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1530)
    }
  }), _vm._v(" "), (_vm.isProd == 'N') ? _c('span', {
    staticClass: "name",
    staticStyle: {
      "line-height": "15px",
      "padding-top": "7px"
    }
  }, [_vm._v("新美云平台\n            "), _c('p', {
    staticStyle: {
      "font-size": "10px",
      "text-align": "center",
      "color": "red"
    }
  }, [_vm._v("[ 测 试 版 ]")])]) : _c('span', {
    staticClass: "name",
    staticStyle: {
      "line-height": "15px",
      "padding-top": "10px"
    }
  }, [_vm._v("新美云平台\n            "), _c('p', {
    staticStyle: {
      "font-size": "10px",
      "text-align": "center",
      "color": "red"
    }
  })]), _vm._v(" "), _c('ul', _vm._l((_vm.nodes), function(item) {
    return (item.component == 'HomeView') ? _c('li', {
      class: {
        'active': _vm.$route.matched[0].name == item.name,
        'disable': item.disable
      },
      on: {
        "click": function($event) {
          return _vm.pushHandle(item.disable, item.path)
        }
      }
    }, [_vm._v(_vm._s(item.name))]) : _vm._e()
  }), 0)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "提示",
      "visible": _vm.isShowNoPass,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.isShowNoPass = $event
      }
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("您没有此项目菜单查看权限！")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.isShowNoPass = false
      }
    }
  }, [_vm._v("确 定")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1675:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "CustomerOwnerDataEcharts"
    }
  }, [_c('div', {
    staticClass: "lineChart"
  }, [_c('div', {
    ref: "engineeringNum",
    attrs: {
      "id": "engineeringNum"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "BottomBox"
  }, [_c('div', {
    ref: "Onehistogram",
    staticClass: "Onehistogram"
  }), _vm._v(" "), _c('div', {
    staticClass: "TwohistogramBox"
  }, [_c('div', {
    ref: "Twohistogram",
    attrs: {
      "id": "Twohistogram"
    }
  }), _vm._v(" "), (_vm.showTips) ? _c('span', {
    staticClass: "showTips",
    style: ({
      left: _vm.x + 'px',
      top: _vm.y + 'px'
    })
  }, [_vm._v(_vm._s(_vm.tipsName))]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.IndustryData.series && !_vm.IndustryData.series[0].data.length),
      expression: "IndustryData.series && !IndustryData.series[0].data.length"
    }],
    staticClass: "nodata_box"
  }, [_c('img', {
    attrs: {
      "src": "https://xmyun.zhoty.com/xmerp/pcadmin/static/images/report_item_nodata.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("暂无数据")])])])])])
},staticRenderFns: []}

/***/ }),

/***/ 1676:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "collectData"
    }
  }, [_c('HeadControl', {
    ref: "headControl",
    attrs: {
      "titleName": '汇总数据'
    },
    on: {
      "changeVal": _vm.changeVal,
      "changDate": _vm.changDate,
      "changePicker": _vm.changePicker
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "top-Box"
  }, [_c('div', {
    staticClass: "left"
  }, _vm._l((_vm.reportList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "left-t"
    }, [_c('div', {
      staticClass: "icon"
    }, [_c('img', {
      attrs: {
        "src": item.itemIcon
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "desc"
    }, [_c('div', {
      staticClass: "a-title"
    }, [_vm._v(_vm._s(item.itemName))]), _vm._v(" "), (item.itemName.includes('金额')) ? _c('div', {
      staticClass: "amount"
    }, [_vm._v(_vm._s(_vm.aFormat(item.amount))), _c('span', [_vm._v("元")])]) : _vm._e(), _vm._v(" "), (item.itemName.includes('数量')) ? _c('div', {
      staticClass: "amount"
    }, [_vm._v(_vm._s(item.count)), _c('span', [_vm._v("个")])]) : _vm._e()])])
  }), 0), _vm._v(" "), _c('div', {
    ref: "ProgressProportion",
    staticClass: "Progress"
  }), _vm._v(" "), _c('div', {
    staticClass: "sendOrdersBox"
  }, [_c('div', {
    ref: "SendOrders",
    staticClass: "sendOrders"
  }), _vm._v(" "), (_vm.Judge) ? _c('div', {
    staticClass: "nodata_box"
  }, [_c('img', {
    attrs: {
      "src": "https://xmyun.zhoty.com/xmerp/pcadmin/static/images/report_item_nodata.png"
    }
  }), _vm._v(" "), _c('span', [_vm._v("暂无数据")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "bottom-Box"
  }, [_c('div', {
    staticClass: "left-Box"
  }, [_c('div', {
    staticClass: "lOne-box"
  }, [_c('div', {
    staticClass: "BoxText"
  }, [_vm._v("项目地区")]), _vm._v(" "), _c('div', {
    staticClass: "regionData"
  }, _vm._l((_vm.RegionDataList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "BoxData"
    }, [_c('div', {
      staticClass: "SmBoxData"
    }, [_c('div', {
      staticClass: "region"
    }, [_vm._v(_vm._s(item.itemName))]), _vm._v(" "), _c('div', {
      staticClass: "number"
    }, [_vm._v(_vm._s(item.count)), _c('i', [_vm._v("个")])])]), _vm._v(" "), _c('div', {
      staticClass: "DataImg"
    }, [_c('img', {
      attrs: {
        "src": item.itemIcon,
        "alt": ""
      }
    })])])
  }), 0)]), _vm._v(" "), _c('div', {
    ref: "schedule",
    staticClass: "schedule"
  })]), _vm._v(" "), _c('div', {
    ref: "ProjectLevel",
    staticClass: "right-Box"
  })])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1677:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "initiateData"
    }
  }, [_c('div', {
    attrs: {
      "id": "right"
    }
  }, [_c('HeadControl', {
    ref: "HeadControl",
    attrs: {
      "titleName": '立项数据'
    },
    on: {
      "changeVal": _vm.changeVal,
      "changDate": _vm.changDate,
      "changePicker": _vm.changePicker
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "centerBox"
  }, [_c('div', {
    staticClass: "leftBox"
  }, [_c('div', {
    staticClass: "numberBox"
  }, [_c('div', {
    staticClass: "numberBoxSmall"
  }, [_c('div', {
    staticClass: "imgBox"
  }, [(_vm.reportList.length) ? _c('img', {
    attrs: {
      "src": _vm.reportList[0].itemIcon,
      "alt": ""
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "dataBox"
  }, [_c('div', {
    staticClass: "ChineseBox"
  }, [_vm._v(_vm._s(_vm.legend[0]))]), _vm._v(" "), (_vm.reportList.length) ? _c('div', {
    staticClass: "numBox"
  }, [_vm._v(_vm._s(_vm.reportList[0].count)), _c('i', [_vm._v("个")])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "individualBox"
  }, [_c('div', {
    staticClass: "numberBoxSmall"
  }, [_c('div', {
    staticClass: "imgBox"
  }, [(_vm.reportList.length) ? _c('img', {
    attrs: {
      "src": _vm.reportList[1].itemIcon,
      "alt": ""
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "dataBox"
  }, [_c('div', {
    staticClass: "ChineseBox"
  }, [_vm._v(_vm._s(_vm.legend[1]))]), _vm._v(" "), (_vm.reportList.length) ? _c('div', {
    staticClass: "numBox"
  }, [_vm._v(_vm._s(_vm.reportList[1].totalCount)), _c('i', [_vm._v("人")])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "rightBox"
  }, [_c('div', {
    ref: "ProjectPerformanceEharts",
    attrs: {
      "id": "ProjectPerformanceEharts"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "bottonBox"
  }, [_c('ProjectDataEcharts', {
    attrs: {
      "screenWidth": _vm.screenWidth,
      "ProjectSourceDataList": _vm.ProjectSourceDataList,
      "ProjectTypeDataList": _vm.ProjectTypeDataList
    }
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 1678:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "welcomeViewModulesVue"
  }, _vm._l((_vm.componentsList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "news"
    }, [_c('div', {
      staticClass: "img"
    }, [_c('img', {
      staticStyle: {
        "width": "100%",
        "height": "100%",
        "border-radius": "9px"
      },
      attrs: {
        "src": item.noticeThumbnail,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "value"
    }, [_c('div', {
      staticClass: "head",
      staticStyle: {
        "-webkit-box-orient": "vertical"
      }
    }, [_vm._v(_vm._s(item.noticeTitle))]), _vm._v(" "), _c('div', {
      staticClass: "content",
      staticStyle: {
        "-webkit-box-orient": "vertical"
      }
    }, [_vm._v("\n                " + _vm._s(item.noticeContent) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "date"
    }, [_vm._v(_vm._s(_vm.$root.formatDate(item.noticeDate)))])])])
  }), 0)
},staticRenderFns: []}

/***/ }),

/***/ 1679:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "queryCondition"
  }, [_c('div', {
    staticClass: "innerCondition"
  }, [_c('div', {
    attrs: {
      "id": "navTitle"
    }
  }, [_vm._v(_vm._s(_vm.titleName))]), _vm._v(" "), (_vm.showorg) ? _c('div', {
    attrs: {
      "id": "company"
    }
  }, [_c('OrganizationalStructure', {
    attrs: {
      "treelist": _vm.list,
      "wide": 200
    },
    on: {
      "changeVal": _vm.changeVal
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "range-separator": "-",
      "value-format": "yyyy-MM-dd",
      "size": "small",
      "clear-icon": ""
    },
    on: {
      "change": _vm.changeDate
    },
    model: {
      value: (_vm.dataRange),
      callback: function($$v) {
        _vm.dataRange = $$v
      },
      expression: "dataRange"
    }
  }), _vm._v(" "), _c('el-select', {
    staticClass: "selectDate",
    on: {
      "change": _vm.getDatas
    },
    model: {
      value: (_vm.valueDate),
      callback: function($$v) {
        _vm.valueDate = $$v
      },
      expression: "valueDate"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.label,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 1680:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "请重新登录",
      "visible": _vm.isShow,
      "before-close": _vm.hide
    },
    on: {
      "update:visible": function($event) {
        _vm.isShow = $event
      }
    }
  }, [_c('el-form', {
    ref: "loginForm",
    staticClass: "demo-ruleForm login-container",
    attrs: {
      "model": _vm.loginForm,
      "label-position": "left",
      "label-width": "0px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "account"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "账号"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        return _vm.doLogin.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.loginForm.account),
      callback: function($$v) {
        _vm.$set(_vm.loginForm, "account", $$v)
      },
      expression: "loginForm.account"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "密码"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        return _vm.doLogin.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.loginForm.password),
      callback: function($$v) {
        _vm.$set(_vm.loginForm, "password", $$v)
      },
      expression: "loginForm.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.isLoading
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.doLogin.apply(null, arguments)
      }
    }
  }, [_vm._v("登录")]), _vm._v(" "), _c('span', {
    staticClass: "error-text"
  }, [_vm._v(_vm._s(_vm.errorMsg))])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1681:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "signedData"
    }
  }, [_c('div', {
    attrs: {
      "id": "right"
    }
  }, [_c('HeadControl', {
    ref: "HeadControl",
    attrs: {
      "titleName": "签约数据"
    },
    on: {
      "changeVal": _vm.changeVal,
      "changDate": _vm.changDate,
      "changePicker": _vm.changePicker
    }
  }), _vm._v(" "), (_vm.ContractInformation) ? _c('div', {
    staticClass: "inner-top"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "l-box"
  }, [_c('div', {
    staticClass: "l-t"
  }, [_vm._v("签约合同额")]), _vm._v(" "), _c('div', {
    staticClass: "l-a"
  }, [_vm._v(_vm._s(_vm.AmountFormat(_vm.ContractInformation[0].amount))), _c('span', [_vm._v("元")])])]), _vm._v(" "), _c('div', {
    staticClass: "r-box"
  }, [_c('img', {
    attrs: {
      "src": _vm.ContractInformation[0].itemIcon
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "l-box"
  }, [_c('div', {
    staticClass: "l-t"
  }, [_vm._v("合同回款额")]), _vm._v(" "), _c('div', {
    staticClass: "l-a"
  }, [_vm._v(_vm._s(_vm.AmountFormat(_vm.ContractInformation[1].amount))), _c('span', [_vm._v("元")])])]), _vm._v(" "), _c('div', {
    staticClass: "r-box"
  }, [_c('img', {
    attrs: {
      "src": _vm.ContractInformation[1].itemIcon
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "l-box"
  }, [_c('div', {
    staticClass: "l-t"
  }, [_vm._v("签约合同个数")]), _vm._v(" "), _c('div', {
    staticClass: "l-a"
  }, [_vm._v(_vm._s(_vm.ContractInformation[2].count)), _c('span', [_vm._v("个")])])]), _vm._v(" "), _c('div', {
    staticClass: "r-box"
  }, [_c('img', {
    attrs: {
      "src": _vm.ContractInformation[2].itemIcon
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "l-box"
  }, [_c('div', {
    staticClass: "l-t"
  }, [_vm._v("签约合同人数")]), _vm._v(" "), _c('div', {
    staticClass: "l-a"
  }, [_vm._v(_vm._s(_vm.ContractInformation[3].count)), _c('span', [_vm._v("人")])])]), _vm._v(" "), _c('div', {
    staticClass: "r-box"
  }, [_c('img', {
    attrs: {
      "src": _vm.ContractInformation[3].itemIcon
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ceter-Box"
  }, [_c('div', {
    ref: "ContractAmount",
    staticClass: "left-Box"
  }), _vm._v(" "), _c('div', {
    ref: "ContractNumber",
    staticClass: "right-Box"
  })]), _vm._v(" "), _c('signedDataEcharts', {
    attrs: {
      "screenWidth": _vm.screenWidth,
      "ProjectAreaList": _vm.ProjectAreaList,
      "DirectorRankingList": _vm.DirectorRankingList,
      "RankingProjectAmountList": _vm.RankingProjectAmountList,
      "ProjectTypeList": _vm.ProjectTypeList,
      "PieprojectTypeList": _vm.PieprojectTypeList,
      "CooperationTypeList": _vm.CooperationTypeList,
      "ProjectLevelList": _vm.ProjectLevelList
    },
    on: {
      "getDirectorRanking": _vm.getDirectorRanking
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 1682:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "appLogin"
  }, [_c('div', {
    staticClass: "login-modal"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("请登录")]), _vm._v(" "), _c('div', {
    staticClass: "explain"
  }, [_vm._v("登录即可处理新美云待办事项。首次登录成功，系统会自动将您的微信账户与新美云绑定。")]), _vm._v(" "), _c('div', {
    staticClass: "login-phone"
  }, [_c('div', {
    staticClass: "phone-left",
    class: _vm.userPhone ? "" : "phone-left-none"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userPhone),
      expression: "userPhone"
    }],
    attrs: {
      "placeholder": "手机号",
      "type": "text",
      "disabled": _vm.switchFlag ? true : false,
      "onkeyup": "this.value=this.value.replace(/[^\\d\\s]/ig,'')",
      "maxlength": "13"
    },
    domProps: {
      "value": (_vm.userPhone)
    },
    on: {
      "focus": function($event) {
        _vm.userPhoneFocus = true
      },
      "blur": function($event) {
        return _vm.userPhoneBlur('userPhoneFocus')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userPhone = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userPhone && _vm.userPhoneFocus),
      expression: "userPhone && userPhoneFocus"
    }],
    attrs: {
      "icon": "close"
    },
    on: {
      "click": function($event) {
        _vm.userPhone = ""
      }
    }
  })]), _vm._v(" "), (!_vm.switchFlag) ? _c('div', {
    staticClass: "phone-right",
    class: _vm.phoneCodeFlag ? "" : "code-disabled",
    on: {
      "click": _vm.getCode
    }
  }, [_vm._v("\n                " + _vm._s(_vm.btnName))]) : _vm._e(), _vm._v(" "), (_vm.switchFlag) ? _c('div', {
    staticClass: "phone-right"
  }, [_vm._v("已发送(" + _vm._s(_vm.countdown) + "s)")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "login-code",
    class: _vm.borderNone ? "login-code-border" : ""
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userCode),
      expression: "userCode"
    }],
    attrs: {
      "placeholder": "验证码",
      "type": "text",
      "onkeyup": "this.value=this.value.replace(/\\D/g,'')",
      "maxlength": "6"
    },
    domProps: {
      "value": (_vm.userCode)
    },
    on: {
      "focus": function($event) {
        _vm.userCodeFocus = true
      },
      "blur": function($event) {
        return _vm.userPhoneBlur('userCodeFocus')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userCode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userCode && _vm.userCodeFocus),
      expression: "userCode && userCodeFocus"
    }],
    attrs: {
      "icon": "clear"
    },
    on: {
      "click": function($event) {
        _vm.userCode = ""
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "btn",
    class: !_vm.userPhone || !_vm.userCode ? "btn-disabled" : "",
    on: {
      "click": _vm.login
    }
  }, [_vm._v("登录")])])
},staticRenderFns: []}

/***/ }),

/***/ 1683:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "signedDataEcharts"
    }
  }, [_c('div', {
    staticClass: "center-DataBox"
  }, [_c('div', {
    staticClass: "left-DataBox"
  }, [_c('div', {
    attrs: {
      "id": "lOne-box"
    }
  }, [_c('div', {
    staticClass: "BoxText"
  }, [_vm._v("项目地区")]), _vm._v(" "), _c('div', {
    staticClass: "regionData"
  }, _vm._l((_vm.ProjectAreaList.reportList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "BoxData"
    }, [_c('div', {
      staticClass: "SmBoxData"
    }, [_c('div', {
      staticClass: "region"
    }, [_vm._v(_vm._s(item.itemName))]), _vm._v(" "), _c('div', {
      staticClass: "number"
    }, [_vm._v(_vm._s(_vm.AmountFormat(item.amount))), _c('i', [_vm._v("元")])]), _vm._v(" "), _c('div', {
      staticClass: "regionB"
    }, [_vm._v(_vm._s(item.count)), _c('i', [_vm._v("个")])])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.screenWidth <= 1366 ? false : true),
        expression: "screenWidth <=1366 ? false : true"
      }],
      staticClass: "DataImg"
    }, [_c('img', {
      attrs: {
        "src": item.itemIcon,
        "alt": ""
      }
    })])])
  }), 0)]), _vm._v(" "), _c('div', {
    ref: "progressBar",
    attrs: {
      "id": "progress-bar"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "right-DataBox"
  }, [_c('div', {
    staticClass: "pieOneBox"
  }, [_c('div', {
    ref: "pieOne",
    attrs: {
      "id": "echartsBox"
    }
  }), _vm._v(" "), (_vm.Judge) ? _c('div', {
    staticClass: "nodata_box"
  }, [_c('img', {
    attrs: {
      "src": "https://xmyun.zhoty.com/xmerp/pcadmin/static/images/report_item_nodata.png"
    }
  }), _vm._v(" "), _c('span', [_vm._v("暂无数据")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "pieTwoBox"
  }, [_c('div', {
    ref: "pieTwo",
    attrs: {
      "id": "echarts-Box"
    }
  }), _vm._v(" "), (_vm.CooperationTypeJudge) ? _c('div', {
    staticClass: "nodata_box"
  }, [_c('img', {
    attrs: {
      "src": "https://xmyun.zhoty.com/xmerp/pcadmin/static/images/report_item_nodata.png"
    }
  }), _vm._v(" "), _c('span', [_vm._v("暂无数据")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    ref: "pieThree",
    attrs: {
      "id": "echarts"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "bottom-DataBox"
  }, [_c('div', {
    staticClass: "dataSortBox"
  }, [_vm._m(0), _vm._v(" "), (_vm.RankingProjectAmountList.length) ? _c('div', {
    attrs: {
      "id": "dataSort"
    }
  }, [_c('div', {
    staticClass: "bottom-Data"
  }, [_c('table', {
    staticClass: "table-Box",
    staticStyle: {
      "table-layout": "fixed"
    }
  }, [_c('tr', {
    staticClass: "herader-Box"
  }, [_c('td', {
    class: {
      'tdName': _vm.screenWidth == 1920
    },
    attrs: {
      "width": _vm.screenWidth <= 1366 ? 200 : (_vm.screenWidth <= 1536 ? 380 : 530)
    }
  }, [_vm._v("项目名称")]), _vm._v(" "), _c('td', {
    staticClass: "tdMoney",
    attrs: {
      "width": _vm.screenWidth >= 1536 ? 140 : 120,
      "align": "right"
    }
  }, [_vm._v("签约金额(元)")])]), _vm._v(" "), _vm._l((_vm.RankingProjectAmountList), function(item, index) {
    return _c('tr', {
      key: index,
      attrs: {
        "height": _vm.screenWidth <= 768 ? 30 : (_vm.screenWidth <= 1366 ? 42 : 42)
      }
    }, [_c('td', [_c('div', {
      class: {
        'smallBox': _vm.screenWidth == 1920,
        'TdWidth': _vm.screenWidth == 1536,
        'dataBox': _vm.screenWidth == 1366,
      },
      staticStyle: {
        "display": "flex"
      }
    }, [(_vm.TextShow && _vm.actived == index) ? _c('span', {
      staticClass: "showTips",
      style: ({
        left: _vm.x + 'px'
      })
    }, [_vm._v(_vm._s(item.name))]) : _vm._e(), _vm._v(" "), _c('span', {
      class: {
        'red': item.serialNumber == '1',
        'orange': item.serialNumber == '2',
        'yellow': item.serialNumber == '3'
      },
      staticStyle: {
        "margin-right": "10px"
      }
    }, [_vm._v(_vm._s(item.serialNumber))]), _vm._v(" "), _c('span', {
      staticClass: "pro_name",
      on: {
        "mouseover": function($event) {
          $event.stopPropagation();
          _vm.getText($event, item.name);
          _vm.actived = index
        },
        "mouseout": function($event) {
          $event.stopPropagation();
          _vm.TextShow = false
        }
      }
    }, [_vm._v("\n                                      " + _vm._s(item.name) + "\n                                      ")])])]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [_vm._v(_vm._s(_vm.AmountFormat(item.amount)))])])
  })], 2)])]) : _c('div', {
    staticClass: "nodata_box"
  }, [_c('img', {
    attrs: {
      "src": "https://xmyun.zhoty.com/xmerp/pcadmin/static/images/report_item_nodata.png"
    }
  }), _vm._v(" "), _c('span', [_vm._v("暂无数据")])])]), _vm._v(" "), _c('div', {
    staticClass: "S-dataSortBox"
  }, [_vm._m(1), _vm._v(" "), _c('ul', {
    staticClass: "tablist"
  }, [_c('li', {
    class: {
      'active': _vm.activeProjectName === 'AMOUNT'
    },
    on: {
      "click": function($event) {
        return _vm.handleClick('AMOUNT')
      }
    }
  }, [_vm._v("签约金额")]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.activeProjectName === 'QUANTITY'
    },
    on: {
      "click": function($event) {
        return _vm.handleClick('QUANTITY')
      }
    }
  }, [_vm._v("签约数量")])]), _vm._v(" "), (_vm.DirectorRankingList.length && _vm.activeProjectName === 'AMOUNT') ? _c('div', {
    attrs: {
      "id": "S-dataSort"
    }
  }, [_c('div', {
    staticClass: "bottom-Data"
  }, [_c('table', {
    staticClass: "table-Box"
  }, [_c('tr', {
    staticClass: "herader-Box"
  }, [_c('td', {
    attrs: {
      "width": _vm.screenWidth <= 1366 ? 200 : 300
    }
  }, [_vm._v("项目总监")]), _vm._v(" "), _c('td', {
    class: {
      'show': _vm.screenWidth <= 768
    },
    attrs: {
      "width": "150",
      "align": "center"
    }
  }, [_vm._v("签约总数(个)")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "140",
      "align": "right"
    }
  }, [_vm._v("签约金额(元)")])]), _vm._v(" "), _vm._l((_vm.DirectorRankingList), function(item, index) {
    return _c('tr', {
      key: index,
      attrs: {
        "height": _vm.screenWidth <= 768 ? 30 : (_vm.screenWidth <= 1366 ? 38 : 38)
      }
    }, [_c('td', [_c('div', {
      staticClass: "dataBox"
    }, [_c('span', {
      class: {
        'red': item.serialNumber == '1',
        'orange': item.serialNumber == '2',
        'yellow': item.serialNumber == '3'
      },
      staticStyle: {
        "margin-right": "10px"
      }
    }, [_vm._v(_vm._s(item.serialNumber))]), _vm._v(_vm._s(item.pmName) + " " + _vm._s(item.phone) + "\n                                  ")])]), _vm._v(" "), _c('td', {
      class: {
        'show': _vm.screenWidth <= 768
      },
      attrs: {
        "align": "center"
      }
    }, [_vm._v(_vm._s(item.count))]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [_vm._v(_vm._s(_vm.AmountFormat(item.amount)))])])
  })], 2)])]) : (_vm.DirectorRankingList.length && _vm.activeProjectName === 'QUANTITY') ? _c('div', {
    attrs: {
      "id": "S-dataSort"
    }
  }, [_c('div', {
    staticClass: "bottom-Data"
  }, [_c('table', {
    staticClass: "table-Box"
  }, [_c('tr', {
    staticClass: "herader-Box"
  }, [_c('td', {
    attrs: {
      "width": _vm.screenWidth <= 1366 ? 200 : 500
    }
  }, [_vm._v("项目总监")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "100",
      "align": "center"
    }
  }, [_vm._v("签约总数(个)")])]), _vm._v(" "), _vm._l((_vm.DirectorRankingList), function(item, index) {
    return _c('tr', {
      key: index,
      attrs: {
        "height": _vm.screenWidth <= 768 ? 30 : (_vm.screenWidth <= 1366 ? 38 : 38)
      }
    }, [_c('td', [_c('div', {
      staticClass: "dataBox"
    }, [_c('span', {
      class: {
        'red': item.serialNumber == '1',
        'orange': item.serialNumber == '2',
        'yellow': item.serialNumber == '3'
      },
      staticStyle: {
        "margin-right": "10px"
      }
    }, [_vm._v(_vm._s(item.serialNumber))]), _vm._v(_vm._s(item.pmName) + " " + _vm._s(item.phone) + "\n                                  ")])]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "center"
      }
    }, [_vm._v(_vm._s(item.count))])])
  })], 2)])]) : _c('div', {
    staticClass: "nodata_box"
  }, [_c('img', {
    attrs: {
      "src": "https://xmyun.zhoty.com/xmerp/pcadmin/static/images/report_item_nodata.png"
    }
  }), _vm._v(" "), _c('span', [_vm._v("暂无数据")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top-Name"
  }, [_c('i', {
    staticClass: "el-icon-s-data"
  }), _vm._v(" "), _c('p', {
    staticClass: "titleName"
  }, [_vm._v("项目签约金额排行")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top-Name"
  }, [_c('i', {
    staticClass: "el-icon-s-data"
  }), _vm._v(" "), _c('p', {
    staticClass: "titleName"
  }, [_vm._v("项目总监签约排行")])])
}]}

/***/ }),

/***/ 1684:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "copy"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('span', [_vm._v("抄送我")]), _vm._v(" "), (_vm.openWxMsgRemid == "Y") ? _c('div', {
    on: {
      "click": _vm.changeStatu
    }
  }, [_vm._v("关闭提醒")]) : _vm._e(), _vm._v(" "), (_vm.openWxMsgRemid == "N") ? _c('div', {
    staticClass: "div",
    on: {
      "click": _vm.changeStatu
    }
  }, [_vm._v("开启提醒")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "check"
  }, [_c('van-checkbox', {
    attrs: {
      "checked-color": "#ee0a24",
      "shape": "square",
      "icon-size": ".15rem",
      "label-disabled": ""
    },
    on: {
      "change": function($event) {
        _vm.pageNo = 1;
        _vm.getCopytList()
      }
    },
    model: {
      value: (_vm.checked),
      callback: function($$v) {
        _vm.checked = $$v
      },
      expression: "checked"
    }
  }, [_vm._v("仅未读/未批阅")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.load),
      expression: "load"
    }],
    staticClass: "tips",
    attrs: {
      "infinite-scroll-distance": "20",
      "infinite-scroll-delay": "500"
    }
  }, _vm._l((_vm.copytList), function(item) {
    return _c('div', {
      staticClass: "item item-first",
      on: {
        "click": function($event) {
          return _vm.$root.gotoDetail(item)
        }
      }
    }, [_c('div', {
      staticClass: "user-submit"
    }, [_vm._v(_vm._s(item.initiatorName) + "提交的" + _vm._s(item.itemName)), (item.isAwait == "Y") ? _c('span') : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "project-name"
    }, [_vm._v(_vm._s(item.bizItemName))]), _vm._v(" "), _c('div', {
      staticClass: "submit-time"
    }, [(item.processProgress == "AUDIT_WAIT") ? _c('span', {
      staticClass: "status"
    }, [_vm._v("审批中")]) : _vm._e(), _vm._v(" "), (item.processProgress == "AUDIT_OK") ? _c('span', {
      staticClass: "status agree"
    }, [_vm._v("审批通过")]) : _vm._e(), _vm._v(" "), (item.processProgress == "AUDIT_REJECTED") ? _c('span', {
      staticClass: "status disagree"
    }, [_vm._v("审批不通过")]) : _vm._e(), _vm._v(" "), (!item.processProgress) ? _c('span', {
      staticClass: "status disagree"
    }) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "time"
    }, [_vm._v(_vm._s(item.initiateTime))])])])
  }), 0), _vm._v(" "), _c('Nav', {
    ref: "nav",
    attrs: {
      "navIndex": 1
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1685:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('HeadControl', {
    ref: "headControl",
    attrs: {
      "titleName": '巡检数据'
    },
    on: {
      "changeVal": _vm.changeVal,
      "changDate": _vm.changDate,
      "changePicker": _vm.changePicker
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('div', {
    staticClass: "t_left"
  }, _vm._l((_vm.checkProjectData.reportList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "checkWrap"
    }, [_c('div', {
      staticClass: "image"
    }, [_c('img', {
      attrs: {
        "src": item.itemIcon
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "info"
    }, [_c('div', {
      staticClass: "total"
    }, [_vm._v(_vm._s(item.itemName))]), _vm._v(" "), _c('div', {
      staticClass: "number"
    }, [_c('span', {
      staticClass: "num"
    }, [_vm._v(_vm._s(item.count))]), _vm._v("个\n            ")])])])
  }), 0), _vm._v(" "), _c('div', {
    ref: "checkProject",
    staticClass: "checkProject"
  })]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('div', {
    staticClass: "c_left"
  }, [_c('div', {
    staticClass: "left_top"
  }, _vm._l((_vm.projectDataList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "itemWrap"
    }, [_c('div', {
      staticClass: "item"
    }, [_c('div', {
      staticClass: "total"
    }, [_vm._v(_vm._s(item.itemName))]), _vm._v(" "), _c('div', {
      staticClass: "number"
    }, [_c('span', {
      staticClass: "num"
    }, [_vm._v(_vm._s(item.count))]), _vm._v("个\n              ")])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "left_bottom"
  }, [_c('div', {
    staticClass: "p_title"
  }, [_vm._v("项目地区")]), _vm._v(" "), _vm._l((_vm.regionDataList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "areaWrap"
    }, [_c('div', {
      staticClass: "item"
    }, [_c('div', {
      staticClass: "left"
    }, [_c('div', {
      staticClass: "location"
    }, [_vm._v(_vm._s(item.itemName))]), _vm._v(" "), _c('div', {
      staticClass: "number"
    }, [_c('span', {
      staticClass: "num"
    }, [_vm._v(_vm._s(item.count))]), _vm._v("个\n                ")])]), _vm._v(" "), _c('div', {
      staticClass: "right"
    }, [_c('img', {
      attrs: {
        "src": item.itemIcon
      }
    })])])])
  })], 2)]), _vm._v(" "), _c('div', {
    ref: "projectLevel",
    staticClass: "projectGrade"
  })]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('div', {
    staticClass: "projectRank"
  }, [_vm._m(0), _vm._v(" "), (!_vm.projectRankList.length) ? _c('div', {
    staticClass: "nodata_box"
  }, [_c('img', {
    attrs: {
      "src": "https://xmyun.zhoty.com/xmerp/pcadmin/static/images/report_item_nodata.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("暂无数据")])]) : _c('div', [_c('ul', {
    staticClass: "tablist"
  }, [_c('li', {
    class: {
      'active': _vm.activeProjectName === 'ALL'
    },
    on: {
      "click": function($event) {
        return _vm.handleClick('ALL')
      }
    }
  }, [_vm._v("总平均分")]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.activeProjectName === 'SECURITY'
    },
    on: {
      "click": function($event) {
        return _vm.handleClick('SECURITY')
      }
    }
  }, [_vm._v("安全评分")]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.activeProjectName === 'QUALITY'
    },
    on: {
      "click": function($event) {
        return _vm.handleClick('QUALITY')
      }
    }
  }, [_vm._v("质量评分")])]), _vm._v(" "), _c('table', {
    staticClass: "tablewrap"
  }, [_c('tr', {
    staticClass: "table_title"
  }, [_c('td', {
    staticClass: "first"
  }, [_vm._v("项目名称")]), _vm._v(" "), (!_vm.$route.query.identification) ? _c('td', [_vm._v("项目总监")]) : _vm._e(), _vm._v(" "), (!_vm.$route.query.identification) ? _c('td', [_vm._v("检查总次数")]) : _vm._e(), _vm._v(" "), _c('td', {
    staticClass: "last"
  }, [_vm._v("总平均分")])]), _vm._v(" "), _vm._l((_vm.projectRankList), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      class: {
        'first': _vm.$route.query.identification
      }
    }, [_c('span', {
      staticClass: "content",
      staticStyle: {
        "display": "inline-block",
        "width": "85%",
        "overflow": "hidden",
        "white-space": "nowrap",
        "text-overflow": "ellipsis"
      }
    }, [_c('span', {
      class: {
        one: item.serialNumber === 1,
        second: item.serialNumber === 2,
        third: item.serialNumber === 3
      }
    }, [_vm._v(_vm._s(item.serialNumber))]), _vm._v(" "), (_vm.TextShow && _vm.actived == index) ? _c('span', {
      staticClass: "showTips",
      style: ({
        'left': _vm.x + 'px'
      })
    }, [_vm._v(_vm._s(item.name))]) : _vm._e(), _vm._v(" "), _c('span', {
      on: {
        "mouseover": function($event) {
          $event.stopPropagation();
          _vm.getText($event, item.name);
          _vm.actived = index
        },
        "mouseout": function($event) {
          $event.stopPropagation();
          _vm.TextShow = false
        }
      }
    }, [_vm._v("\n                    " + _vm._s(item.name) + "\n                  ")])])]), _vm._v(" "), (!_vm.$route.query.identification) ? _c('td', {
      staticClass: "BigshowTips"
    }, [_c('span', {
      staticStyle: {
        "display": "inline-block",
        "width": "100%",
        "overflow": "hidden",
        "white-space": "nowrap",
        "text-overflow": "ellipsis"
      }
    }, [_c('span', [_vm._v("\n                    " + _vm._s(item.pmName) + " " + _vm._s(item.phone) + "\n                  ")])])]) : _vm._e(), _vm._v(" "), (!_vm.$route.query.identification) ? _c('td', [_c('span', {
      staticStyle: {
        "display": "inline-block",
        "width": "60%",
        "text-align": "center"
      }
    }, [_vm._v("\n                  " + _vm._s(item.count) + "\n                ")])]) : _vm._e(), _vm._v(" "), _c('td', {
      class: {
        'last': _vm.$route.query.identification
      },
      staticStyle: {
        "position": "relative"
      }
    }, [_c('span', {
      staticStyle: {
        "position": "absolute",
        "left": "50%",
        "top": "0"
      }
    }, [_vm._v("\n                  " + _vm._s(item.avgScore) + "\n                ")])])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "directorRank"
  }, [_vm._m(1), _vm._v(" "), (!_vm.directorScoreList.length) ? _c('div', {
    staticClass: "nodata_box"
  }, [_c('img', {
    attrs: {
      "src": "https://xmyun.zhoty.com/xmerp/pcadmin/static/images/report_item_nodata.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("暂无数据")])]) : _c('div', [_c('ul', {
    staticClass: "tablist"
  }, [_c('li', {
    class: {
      'active': _vm.activeDirectorName === 'ALL'
    },
    on: {
      "click": function($event) {
        return _vm.handleClick2('ALL')
      }
    }
  }, [_vm._v("总平均分")]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.activeDirectorName === 'SECURITY'
    },
    on: {
      "click": function($event) {
        return _vm.handleClick2('SECURITY')
      }
    }
  }, [_vm._v("安全评分")]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.activeDirectorName === 'QUALITY'
    },
    on: {
      "click": function($event) {
        return _vm.handleClick2('QUALITY')
      }
    }
  }, [_vm._v("质量评分")])]), _vm._v(" "), _c('table', {
    staticClass: "tablewrap directorTable"
  }, [_c('tr', {
    staticClass: "table_title"
  }, [_c('td', {
    staticClass: "first"
  }, [_vm._v("项目总监")]), _vm._v(" "), (!_vm.$route.query.identification) ? _c('td', [_vm._v("工地个数")]) : _vm._e(), _vm._v(" "), (!_vm.$route.query.identification) ? _c('td', [_vm._v("检查总次数")]) : _vm._e(), _vm._v(" "), _c('td', {
    staticClass: "last"
  }, [_vm._v("总平均分")])]), _vm._v(" "), _vm._l((_vm.directorScoreList), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      class: {
        'first': _vm.$route.query.identification
      }
    }, [_c('span', {
      staticClass: "content",
      staticStyle: {
        "display": "inline-block",
        "width": "85%",
        "overflow": "hidden",
        "white-space": "nowrap",
        "text-overflow": "ellipsis"
      }
    }, [_c('span', {
      class: {
        one: item.serialNumber === 1,
        second: item.serialNumber === 2,
        third: item.serialNumber === 3
      }
    }, [_vm._v(_vm._s(item.serialNumber))]), _vm._v(" "), _c('span', {
      staticClass: "numberBox"
    }, [_vm._v("\n                    " + _vm._s(item.pmName) + " " + _vm._s(item.phone) + "\n                  ")])])]), _vm._v(" "), (!_vm.$route.query.identification) ? _c('td', [_c('span', {
      staticStyle: {
        "display": "inline-block",
        "width": "60%",
        "text-align": "center"
      }
    }, [_vm._v("\n                  " + _vm._s(item.totalCount) + "\n                ")])]) : _vm._e(), _vm._v(" "), (!_vm.$route.query.identification) ? _c('td', [_c('span', {
      staticStyle: {
        "display": "inline-block",
        "width": "60%",
        "text-align": "center"
      }
    }, [_vm._v("\n                  " + _vm._s(item.count) + "\n                ")])]) : _vm._e(), _vm._v(" "), _c('td', {
      class: {
        'last': _vm.$route.query.identification
      },
      staticStyle: {
        "position": "relative"
      }
    }, [_c('span', {
      staticClass: "numberBox"
    }, [_vm._v("\n                  " + _vm._s(item.avgScore) + "\n                ")])])])
  })], 2)])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p_title"
  }, [_c('i', {
    staticClass: "el-icon-s-data"
  }), _vm._v("\n          项目评分排行\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p_title"
  }, [_c('i', {
    staticClass: "el-icon-s-data"
  }), _vm._v("\n          总监评分排行\n        ")])
}]}

/***/ }),

/***/ 1686:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "page-container"
  }, [_vm._v("404 page not found")])
},staticRenderFns: []}

/***/ }),

/***/ 1687:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav"
  }, [_c('div', {
    on: {
      "click": function($event) {
        return _vm.goRout(0)
      }
    }
  }, [_c('span', {
    staticClass: "span span0",
    class: _vm.navIndex == 0 ? "checked-span0" : ""
  }, [(_vm.messageCount != 0 && _vm.messageCount != "undefined") ? _c('i', [_vm._v(_vm._s(_vm.messageCount))]) : _vm._e()]), _c('span', {
    class: _vm.navIndex == 0 ? "checked" : ""
  }, [_vm._v("待处理")])]), _vm._v(" "), _c('div', {
    on: {
      "click": function($event) {
        return _vm.goRout(1)
      }
    }
  }, [_c('span', {
    staticClass: "span span1",
    class: _vm.navIndex == 1 ? "checked-span1" : ""
  }, [(_vm.messageCount2 != 0 && _vm.messageCount2 != "undefined") ? _c('i', [_vm._v(_vm._s(_vm.messageCount2))]) : _vm._e()]), _c('span', {
    class: _vm.navIndex == 1 ? "checked" : ""
  }, [_vm._v("抄送我")])]), _vm._v(" "), _c('div', {
    on: {
      "click": function($event) {
        return _vm.goRout(2)
      }
    }
  }, [_c('span', {
    staticClass: "span span2",
    class: _vm.navIndex == 2 ? "checked-span2" : ""
  }), _c('span', {
    class: _vm.navIndex == 2 ? "checked" : ""
  }, [_vm._v("我的")])])])
},staticRenderFns: []}

/***/ }),

/***/ 1688:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "EliteDirectorDataEcharts"
    }
  }, [_c('div', {
    staticClass: "reportView"
  }, [_c('div', {
    staticClass: "histogram"
  }, [_c('div', {
    ref: "threemyChart",
    attrs: {
      "id": "threemyChart"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "BottomBox"
  }, [_c('div', {
    ref: "OnepieChart",
    attrs: {
      "id": "OnepieChart"
    }
  }), _vm._v(" "), _c('div', {
    ref: "Twohistogram",
    attrs: {
      "id": "Twohistogram"
    }
  })])])])
},staticRenderFns: []}

/***/ }),

/***/ 17:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.loadScript = undefined;

var _regenerator = __webpack_require__(170);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = __webpack_require__(263);

var _promise2 = _interopRequireDefault(_promise);

var _asyncToGenerator2 = __webpack_require__(169);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _typeof2 = __webpack_require__(140);

var _typeof3 = _interopRequireDefault(_typeof2);

var _slicedToArray2 = __webpack_require__(898);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var loadScript = exports.loadScript = function () {
    var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(url, id) {
        return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        return _context.abrupt('return', new _promise2.default(function (resolve, reject) {
                            if (document.querySelector('#' + id)) {
                                resolve('');
                                return;
                            }
                            var script = document.createElement('script');
                            script.id = id || '' + Date.now();
                            script.onload = function () {
                                return resolve('');
                            };
                            script.onerror = function () {
                                script.parentNode.removeChild(script);
                                reject();
                            };
                            script.src = url;
                            document.body.appendChild(script);
                        }));

                    case 1:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    return function loadScript(_x, _x2) {
        return _ref.apply(this, arguments);
    };
}();

exports.getItemById = getItemById;
exports.getIndexOfItem = getIndexOfItem;
exports.getItemActive = getItemActive;
exports.setItemActive = setItemActive;
exports.makeSearchParams = makeSearchParams;
exports.format_now_to_hhmmss = format_now_to_hhmmss;
exports.format_date_1 = format_date_1;
exports.dateTimeFormat = dateTimeFormat;
exports.dateTimeFormatL = dateTimeFormatL;
exports.dateFormat = dateFormat;
exports.formatDate = formatDate;
exports.EchartsformatDate = EchartsformatDate;
exports.formatDataYYYYmmdd = formatDataYYYYmmdd;
exports.formatStringToYYYYmmddhhmm = formatStringToYYYYmmddhhmm;
exports.get_today_str = get_today_str;
exports.isMouseInObject = isMouseInObject;
exports.batchSetProp = batchSetProp;
exports.getItemBy = getItemBy;
exports.cloneList = cloneList;
exports.getIdList = getIdList;
exports.setPropValueToEmpty = setPropValueToEmpty;
exports.isFunction = isFunction;
exports.convertCurrency = convertCurrency;
exports.floatAdd = floatAdd;
exports.floatSub = floatSub;
exports.floatMul = floatMul;
exports.floatDiv = floatDiv;
exports.getAgeByBirthday = getAgeByBirthday;
exports.amountFormat = amountFormat;
exports.checkDay = checkDay;
exports.subStringNum = subStringNum;
exports.floatWidth = floatWidth;
exports.uploadBase64 = uploadBase64;

var _aliOss = __webpack_require__(168);

var _aliOss2 = _interopRequireDefault(_aliOss);

var _vueUuid = __webpack_require__(744);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getItemById(items, itemId) {
    for (var i = 0; i < items.length; i++) {
        if (items[i].id == itemId) {
            return items[i];
        }
    }
}

function getIndexOfItem(items, itemId) {

    for (var i = 0; i < items.length; i++) {
        if (items[i].id == itemId) {
            return i;
        }
    }
}

function getItemActive(items) {

    for (var i = 0; i < items.length; i++) {
        if (items[i].active) {
            return items[i];
        }
    }
}

function setItemActive(items, itemId) {

    for (var i = 0; i < items.length; i++) {
        if (items[i].id == itemId) {
            items[i].active = true;
        } else {
            items[i].active = false;
        }
    }
}

function makeSearchParams(params) {

    var urlParams = new URLSearchParams();
    if (params instanceof Object) {
        for (var p in params) {
            urlParams.append(p, params[p]);
        }
    } else {
        urlParams = params;
    }
    return urlParams;
}

function format_now_to_hhmmss() {
    var datetime = new Date();

    var hour = datetime.getHours() < 10 ? "0" + datetime.getHours() : datetime.getHours();
    var minute = datetime.getMinutes() < 10 ? "0" + datetime.getMinutes() : datetime.getMinutes();
    var second = datetime.getSeconds() < 10 ? "0" + datetime.getSeconds() : datetime.getSeconds();
    return hour + ":" + minute + ":" + second;
}

function format_date_1(date) {

    if (date == undefined) {
        return "";
    }
    var d = new Date(date);

    return dateTimeFormat(d);
}

function dateTimeFormat(time) {
    if (time) {
        time = new Date(time);
        var y = time.getFullYear();
        var m = time.getMonth() + 1;
        m = m < 10 ? '0' + m : m;
        var d = time.getDate();
        d = d < 10 ? '0' + d : d;
        var h = time.getHours();
        h = h < 10 ? '0' + h : h;
        var mm = time.getMinutes();
        mm = mm < 10 ? '0' + mm : mm;
        var s = time.getSeconds();
        s = s < 10 ? '0' + s : s;

        return y + '-' + m + '-' + d + ' ' + h + ':' + mm + ':' + s;
    } else {
        return '';
    }
}
function dateTimeFormatL(time) {
    if (time) {
        time = new Date(time);
        var y = time.getFullYear();
        var m = time.getMonth() + 1;
        m = m < 10 ? '0' + m : m;
        var d = time.getDate();
        d = d < 10 ? '0' + d : d;
        var h = time.getHours();
        h = h < 10 ? '0' + h : h;
        var mm = time.getMinutes();
        mm = mm < 10 ? '0' + mm : mm;
        var s = time.getSeconds();
        s = s < 10 ? '0' + s : s;

        return y + '/' + m + '/' + d + ' ' + h + ':' + mm + ':' + s;
    } else {
        return '';
    }
}

function dateFormat(time) {
    var y = time.getFullYear();
    var m = time.getMonth() + 1;
    m = m < 10 ? '0' + m : m;
    var d = time.getDate();
    d = d < 10 ? '0' + d : d;

    return y + '-' + m + '-' + d;
}
function formatDate(time) {
    if (time) {
        var date = new Date(time);
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        m = m < 10 ? '0' + m : m;
        var d = date.getDate();
        d = d < 10 ? '0' + d : d;
        return y + '-' + m + '-' + d;
    } else {
        return '';
    }
}

function EchartsformatDate(time) {
    if (time) {
        var date = new Date(time);
        var m = date.getMonth() + 1;

        var d = date.getDate();
        d = d < 10 ? '0' + d : d;
        return m + '月' + d + '日';
    } else {
        return '';
    }
}

function formatDataYYYYmmdd(date) {

    if (date == undefined) {
        return "";
    }
    var d = new Date(date);
    return d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
}

function formatStringToYYYYmmddhhmm(date) {

    if (date == undefined) {
        return "";
    }
    var d = new Date(date);
    return dateTimeFormat(d);
}

function get_today_str() {

    var date = new Date();

    var year = date.getFullYear();

    var month = (1 + date.getMonth()).toString();
    month = month.length > 1 ? month : '0' + month;

    var day = date.getDate().toString();
    day = day.length > 1 ? day : '0' + day;

    return year + '-' + month + '-' + day;
}

function isMouseInObject(event, checkDiv) {

    var X = event.clientX;
    var Y = event.clientY;
    var isIn = false;
    var checkDistance = 5;

    var offsetLeft = checkDiv.offsetLeft;
    var offsetTop = checkDiv.offsetTop;
    var offsetWidth = checkDiv.offsetWidth;
    var offsetHeight = checkDiv.offsetHeight;

    if (Y < offsetTop || Y > offsetTop + offsetHeight) {
        isIn = false;
    } else {

        if (X < offsetLeft || X > offsetLeft + offsetWidth) {
            isIn = false;
        } else {
            isIn = true;
        }
    }

    return isIn;
}

function batchSetProp(items, prop, value) {

    for (var i = 0; i < items.length; i++) {
        items[i][prop] = value;
    }
}

function getItemBy(items, propName, propValue) {
    for (var i = 0; i < items.length; i++) {
        if (items[i][propName] == propValue) {
            return items[i];
        }
    }
}

function cloneList(dataList, clone_func) {
    var newlist = [];
    for (var i = 0; i < dataList.length; i++) {
        var from = dataList[i];
        var to = {};

        if (clone_func) {
            clone_func(from, to);
        } else {
            for (var x in from) {
                to[x] = from[x];
            }
        }
        newlist.push(to);
    }
    return newlist;
}

function getIdList(dataList) {
    var newlist = [];
    for (var i = 0; i < dataList.length; i++) {
        var from = dataList[i];
        newlist.push(from.id);
    }
    return newlist;
}

function setPropValueToEmpty(obj) {

    if (!obj) return;

    for (var p in obj) {
        obj[p] = '';
    }
}

function isFunction(obj) {

    if (!obj) return false;

    return typeof obj == 'function';
}

function convertCurrency(money) {
    var cnNums = new Array('零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖');

    var cnIntRadice = new Array('', '拾', '佰', '仟');

    var cnIntUnits = new Array('', '万', '亿', '兆');

    var cnDecUnits = new Array('角', '分', '毫', '厘');

    var cnInteger = '整';

    var cnIntLast = '元';

    var maxNum = 999999999999999.9999;

    var integerNum;

    var decimalNum;

    var chineseStr = '';

    var parts;
    if (money === '') {
        return '';
    }
    money = parseFloat(money);
    if (money >= maxNum) {
        return '';
    }
    if (money == 0) {
        chineseStr = cnNums[0] + cnIntLast + cnInteger;
        return chineseStr;
    }

    money = money.toString();
    if (money.indexOf('.') == -1) {
        integerNum = money;
        decimalNum = '';
    } else {
        parts = money.split('.');
        integerNum = parts[0];
        decimalNum = parts[1].substr(0, 4);
    }

    if (parseInt(integerNum, 10) > 0) {
        var zeroCount = 0;
        var IntLen = integerNum.length;
        for (var i = 0; i < IntLen; i++) {
            var n = integerNum.substr(i, 1);
            var p = IntLen - i - 1;
            var q = p / 4;
            var m = p % 4;
            if (n == '0') {
                zeroCount++;
            } else {
                if (zeroCount > 0) {
                    chineseStr += cnNums[0];
                }

                zeroCount = 0;
                chineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
            }
            if (m == 0 && zeroCount < 4) {
                chineseStr += cnIntUnits[q];
            }
        }
        chineseStr += cnIntLast;
    }

    if (decimalNum != '') {
        var decLen = decimalNum.length;
        for (var i = 0; i < decLen; i++) {
            var n = decimalNum.substr(i, 1);
            if (n != '0') {
                chineseStr += cnNums[Number(n)] + cnDecUnits[i];
            }
        }
    }
    if (chineseStr == '') {
        chineseStr += cnNums[0] + cnIntLast + cnInteger;
    } else if (decimalNum == '') {
        chineseStr += cnInteger;
    }
    return chineseStr;
}

function floatAdd(arg1, arg2) {
    var r1, r2, m;
    try {
        r1 = arg1.toString().split(".")[1].length;
    } catch (e) {
        r1 = 0;
    }
    try {
        r2 = arg2.toString().split(".")[1].length;
    } catch (e) {
        r2 = 0;
    }
    m = Math.pow(10, Math.max(r1, r2));
    return (arg1 * m + arg2 * m) / m;
}

function floatSub(arg1, arg2) {
    var r1, r2, m, n;
    try {
        r1 = arg1.toString().split(".")[1].length;
    } catch (e) {
        r1 = 0;
    }
    try {
        r2 = arg2.toString().split(".")[1].length;
    } catch (e) {
        r2 = 0;
    }
    m = Math.pow(10, Math.max(r1, r2));

    n = r1 >= r2 ? r1 : r2;
    return ((arg1 * m - arg2 * m) / m).toFixed(n);
}

function floatMul(arg1, arg2) {
    var m = 0,
        s1 = arg1.toString(),
        s2 = arg2.toString();
    try {
        m += s1.split(".")[1].length;
    } catch (e) {}
    try {
        m += s2.split(".")[1].length;
    } catch (e) {}
    return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m);
}

function floatDiv(arg1, arg2) {
    var t1 = 0,
        t2 = 0,
        r1,
        r2;
    try {
        t1 = arg1.toString().split(".")[1].length;
    } catch (e) {}
    try {
        t2 = arg2.toString().split(".")[1].length;
    } catch (e) {}

    r1 = Number(arg1.toString().replace(".", ""));

    r2 = Number(arg2.toString().replace(".", ""));
    return r1 / r2 * Math.pow(10, t2 - t1);
}

function getAgeByBirthday(strBirthday) {
    var returnAge,
        strBirthdayArr = strBirthday.split("-"),
        birthYear = strBirthdayArr[0],
        birthMonth = strBirthdayArr[1],
        birthDay = strBirthdayArr[2],
        d = new Date(),
        nowYear = d.getFullYear(),
        nowMonth = d.getMonth() + 1,
        nowDay = d.getDate();
    if (nowYear == birthYear) {
        returnAge = 0;
    } else {
        var ageDiff = nowYear - birthYear;
        if (ageDiff > 0) {
            if (nowMonth == birthMonth) {
                var dayDiff = nowDay - birthDay;
                if (dayDiff < 0) {
                    returnAge = ageDiff - 1;
                } else {
                    returnAge = ageDiff;
                }
            } else {
                var monthDiff = nowMonth - birthMonth;
                if (monthDiff < 0) {
                    returnAge = ageDiff - 1;
                } else {
                    returnAge = ageDiff;
                }
            }
        } else {
            returnAge = -1;
        }
    }
    return returnAge;
}

function amountFormat(value) {
    if (!value) return '0.00';
    var result = 0;
    if (typeof value == 'string') {
        result = parseFloat(value).toFixed(2);
    } else {
        result = value.toFixed(2);
    }

    var value2Array = result.split(".");
    var intPart = value2Array[0];
    var intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
    var floatPart = ".00";
    floatPart = value2Array[1];
    return intPartFormat + '.' + floatPart;
}

function checkDay(date) {
    var _date2 = (0, _slicedToArray3.default)(date, 2),
        t1 = _date2[0],
        t2 = _date2[1];

    var startTime = new Date(t1);
    var endTime = new Date(t2);
    var days = endTime.getTime() - startTime.getTime();
    var day = parseInt(days / (1000 * 60 * 60 * 24));
    return day;
}

function subStringNum(a, num) {
    var a_type = typeof a === 'undefined' ? 'undefined' : (0, _typeof3.default)(a);
    if (a_type == "number") {
        var aStr = a.toString();
        var aArr = aStr.split('.');
    } else if (a_type == "string") {
        var aArr = a.split('.');
    }

    if (aArr.length > 1) {
        a = aArr[0] + "." + aArr[1].substr(0, num);
    }
    return a;
}

function floatWidth(val, width) {
    var res = subStringNum(floatDiv(val, 10000), 2).toString().length;
    return res * width < 40 ? 40 : res * width;
}

function dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
}

function uploadBase64(base64, filename, cb) {
    var putObject = function () {
        var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
            var result;
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.prev = 0;
                            _context2.next = 3;
                            return client.put(fileDir, content);

                        case 3:
                            result = _context2.sent;

                            cb(result);
                            _context2.next = 10;
                            break;

                        case 7:
                            _context2.prev = 7;
                            _context2.t0 = _context2['catch'](0);

                            console.log(_context2.t0);

                        case 10:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this, [[0, 7]]);
        }));

        return function putObject() {
            return _ref2.apply(this, arguments);
        };
    }();

    var content = dataURLtoFile(base64, filename);
    console.log(content);

    var client = new _aliOss2.default({
        region: 'oss-cn-shenzhen',
        accessKeyId: 'LTAI4GGHb3kkSnv9MdPdPb4Y',
        accessKeySecret: 'yEOrbRYDSIJpgjGiZk9yTsuSAyava9',
        bucket: 'xmoty',
        timeout: 600000
    });

    var nowDate = new Date();
    var date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        date: nowDate.getDate()
    };

    var _month = date.month < 10 ? '0' + date.month : date.month;
    var _date = date.date < 10 ? '0' + date.date : date.date;
    var rnum = _vueUuid.uuid.v1();
    var fileName = rnum;

    var fileType = content.name.slice(content.name.lastIndexOf('.') + 1, content.name.length);
    var fileDir = 'xmerp/xmfiles/' + date.year + '/' + _month + '/' + _date + '/' + fileName + '.' + fileType;

    putObject();
}

/***/ }),

/***/ 171:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _menuDevtest = __webpack_require__(869);

var _menuDevtest2 = _interopRequireDefault(_menuDevtest);

var _menuAdmin = __webpack_require__(861);

var _menuAdmin2 = _interopRequireDefault(_menuAdmin);

var _menuCm = __webpack_require__(866);

var _menuCm2 = _interopRequireDefault(_menuCm);

var _menuCmDirector = __webpack_require__(867);

var _menuCmDirector2 = _interopRequireDefault(_menuCmDirector);

var _menuFinance = __webpack_require__(871);

var _menuFinance2 = _interopRequireDefault(_menuFinance);

var _menuFinanceManager = __webpack_require__(873);

var _menuFinanceManager2 = _interopRequireDefault(_menuFinanceManager);

var _menuFinanceDirector = __webpack_require__(872);

var _menuFinanceDirector2 = _interopRequireDefault(_menuFinanceDirector);

var _menuCommonAccounting = __webpack_require__(868);

var _menuCommonAccounting2 = _interopRequireDefault(_menuCommonAccounting);

var _menuLaw = __webpack_require__(878);

var _menuLaw2 = _interopRequireDefault(_menuLaw);

var _menuMallFinance = __webpack_require__(879);

var _menuMallFinance2 = _interopRequireDefault(_menuMallFinance);

var _menuBoss = __webpack_require__(862);

var _menuBoss2 = _interopRequireDefault(_menuBoss);

var _menuGeneralManager = __webpack_require__(874);

var _menuGeneralManager2 = _interopRequireDefault(_menuGeneralManager);

var _menuGm = __webpack_require__(875);

var _menuGm2 = _interopRequireDefault(_menuGm);

var _menuBusinessManager = __webpack_require__(864);

var _menuBusinessManager2 = _interopRequireDefault(_menuBusinessManager);

var _menuBusinessAttache = __webpack_require__(863);

var _menuBusinessAttache2 = _interopRequireDefault(_menuBusinessAttache);

var _menuSupervisor = __webpack_require__(886);

var _menuSupervisor2 = _interopRequireDefault(_menuSupervisor);

var _menuChiefQualityOfficer = __webpack_require__(865);

var _menuChiefQualityOfficer2 = _interopRequireDefault(_menuChiefQualityOfficer);

var _menuProductionManager = __webpack_require__(883);

var _menuProductionManager2 = _interopRequireDefault(_menuProductionManager);

var _menuProjectSupervisor = __webpack_require__(884);

var _menuProjectSupervisor2 = _interopRequireDefault(_menuProjectSupervisor);

var _menuInsCommissioner = __webpack_require__(876);

var _menuInsCommissioner2 = _interopRequireDefault(_menuInsCommissioner);

var _MenuExecutiveDean = __webpack_require__(860);

var _MenuExecutiveDean2 = _interopRequireDefault(_MenuExecutiveDean);

var _menuMallMaterialManager = __webpack_require__(880);

var _menuMallMaterialManager2 = _interopRequireDefault(_menuMallMaterialManager);

var _menuInvoice = __webpack_require__(877);

var _menuInvoice2 = _interopRequireDefault(_menuInvoice);

var _menuYxbfzc = __webpack_require__(888);

var _menuYxbfzc2 = _interopRequireDefault(_menuYxbfzc);

var _menuMarketingManager = __webpack_require__(881);

var _menuMarketingManager2 = _interopRequireDefault(_menuMarketingManager);

var _menuSettlementsAccounting = __webpack_require__(885);

var _menuSettlementsAccounting2 = _interopRequireDefault(_menuSettlementsAccounting);

var _menuTaxAccounting = __webpack_require__(887);

var _menuTaxAccounting2 = _interopRequireDefault(_menuTaxAccounting);

var _menuPaymentDocumenter = __webpack_require__(882);

var _menuPaymentDocumenter2 = _interopRequireDefault(_menuPaymentDocumenter);

var _menuDxmbzjl = __webpack_require__(870);

var _menuDxmbzjl2 = _interopRequireDefault(_menuDxmbzjl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var allMenu = {
    'complyDean': _MenuExecutiveDean2.default,
    'devtest': _menuDevtest2.default,
    'admin': _menuAdmin2.default,
    'cm': _menuCm2.default,
    'cmDirector': _menuCmDirector2.default,
    'finance': _menuFinance2.default,
    'financeManager': _menuFinanceManager2.default,
    'financeDirector': _menuFinanceDirector2.default,
    'commonAccounting': _menuCommonAccounting2.default,
    'law': _menuLaw2.default,
    'mallFinance': _menuMallFinance2.default,


    'boss': _menuBoss2.default,

    'businessAttache': _menuBusinessAttache2.default,
    'businessManager': _menuBusinessManager2.default,

    'generalManager': _menuGeneralManager2.default,
    'GM': _menuGm2.default,
    'supervisor': _menuSupervisor2.default,
    'chiefQualityOfficer': _menuChiefQualityOfficer2.default,
    'productionManager': _menuProductionManager2.default,
    'projectSupervisor': _menuProjectSupervisor2.default,
    'insCommissioner': _menuInsCommissioner2.default,
    'mallMaterialManager': _menuMallMaterialManager2.default,

    'busienssDepartmentVP': _menuYxbfzc2.default,
    'marketingManager': _menuMarketingManager2.default,
    'billingCommissioner': _menuInvoice2.default,
    'settlementAccounting': _menuSettlementsAccounting2.default,
    'taxAccounting': _menuTaxAccounting2.default,
    'paymentDocumenter': _menuPaymentDocumenter2.default,
    'POGeneralManager': _menuDxmbzjl2.default
};

exports.default = allMenu;

/***/ }),

/***/ 172:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});


var commonMenu = [{
    path: '/p0',
    component: "HomeView",
    name: '营销管理',
    redirect: '/common/injuriesList',
    parent: true,
    menuId: 2,
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "派单管理",
        menuId: 152,
        children: [{
            pageAddress: "commonPage/customerIntentionAdd",
            path: "/commonPage/customerIntentionAdd",
            hidden: true,
            name: "新增客户意向"
        }, {
            pageAddress: "commonPage/customerIntentionDetail",
            path: "/commonPage/customerIntentionDetail",
            hidden: true,
            name: "客户意向详情"
        }]
    }, {
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "案例宣传",
        menuId: 153,
        children: [{
            pageAddress: "casePublicize/PropagandaDetails",
            path: "/casePublicize/PropagandaDetails",
            hidden: true,
            name: "宣传详情"
        }]
    }, {
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "合同管理",
        menuId: 85,
        children: [{
            pageAddress: "CommonContractModifyDetail",
            path: "/common/contractModify/CommonContractModifyDetail",
            hidden: true,
            name: "变更合同详情"
        }, {
            pageAddress: "commonPage/dataReport/contractDataInfo",
            path: "/common/contractDataInfo",
            component: "contractDataInfo",
            hidden: true,
            name: "合同详情"
        }]
    }, {
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "公关管理",
        menuId: 11,
        children: [{
            pageAddress: "commonPage/projectManage/injuriesDetail",
            path: "/common/injuriesDetail",
            component: "injuriesDetail",
            name: "事故详情",
            hidden: true
        }, {
            pageAddress: "commonPage/projectManage/injuriesAdd",
            path: "/common/injuriesAdd",
            component: "injuriesAdd",
            name: "添加伤亡事故",
            hidden: true
        }, {
            pageAddress: "commonPage/projectManage/injuriesModify",
            path: "/common/injuriesModify",
            component: "injuriesModify",
            name: "编辑事故详情",
            hidden: true
        }, {
            pageAddress: "commonPage/complaintManage/addComplainList",
            path: "/common/addComplainList",
            hidden: true,
            name: "添加投诉"
        }, {
            pageAddress: "commonPage/complaintManage/complainEdit",
            path: "/common/complainEdit",
            hidden: true,
            name: "编辑投诉"
        }, {
            pageAddress: "commonPage/complaintManage/complaintDetail",
            path: "/common/complaintDetail",
            hidden: true,
            name: "投诉详情"
        }, {
            pageAddress: "commonPage/projectManage/adminSanctionAdd",
            path: "/common/adminSanctionAdd",
            hidden: true,
            name: "添加整改单"
        }, {
            pageAddress: "commonPage/projectManage/adminSanctionEdit",
            path: "/common/adminSanctionEdit",
            hidden: true,
            name: "编辑整改单"
        }, {
            pageAddress: "commonPage/projectManage/adminSanctionDetail",
            path: "/common/adminSanctionDetail",
            hidden: true,
            name: "整改单详情"
        }, {
            pageAddress: "commonPage/complaintManage/addLitigation",
            path: "/common/addLitigation",
            hidden: true,
            name: "添加诉讼"
        }, {
            pageAddress: "commonPage/complaintManage/editLitigation",
            path: "/common/editLitigation",
            hidden: true,
            name: "编辑诉讼"
        }, {
            pageAddress: "commonPage/complaintManage/litigationDetail",
            path: "/common/litigationDetail",
            hidden: true,
            name: "诉讼详情"
        }]
    }, {
        parent: true,
        component: "Navigation",
        redirect: '/common/problemFeedbackList',
        path: "/home",
        name: "反馈管理",
        menuId: 12,
        children: [{
            path: "/common/problemFeedbackDetail",
            hidden: true,
            component: "ProblemFeedbackDetailView",
            name: "问题反馈详情"
        }]
    }]
}, {
    path: '/p1',
    redirect: '/common/projectPreparation',
    component: "HomeView",
    name: '运营管理',
    parent: true,
    menuId: 3,
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "运营数据",
        menuId: 110,
        children: []
    }, {
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "项目进度",
        menuId: 14,
        children: [{
            pageAddress: "cm/CMTempProjectReadView",
            path: "/cm/temp_project/read_view",
            hidden: true,
            name: "在跟项目详情"
        }, {
            pageAddress: "cm/CMRunningProjectEditView",
            path: "/cm/project/track",
            hidden: true,
            name: "项目详情"
        }, {
            pageAddress: "cm/CMFinishedAccountApply",
            path: "/cm/CMFinishedAccountApply",
            hidden: true,
            name: "完工结算申请"
        }, {
            pageAddress: "commonPage/projectManage/editProjectInformation",
            path: "/common/editProjectInformation",
            hidden: true,
            name: "编辑项目信息"
        }, {
            pageAddress: "commonPage/projectManage/fileDetail",
            path: "/common/fileDetail",
            component: "fileDetail",
            hidden: true,
            name: "项目资料详情"
        }, {
            pageAddress: "commonPage/enginnerManage/securityScoreTable",
            path: "/common/securityScoreTable",
            component: "securityScoreTable",
            hidden: true,
            name: "工地安全文明施工记录表"
        }, {
            pageAddress: "commonPage/enginnerManage/qualityScoreTable",
            path: "/common/qualityScoreTable",
            component: "qualityScoreTable",
            hidden: true,
            name: "工地现场质量监察记录表"
        }, {
            pageAddress: "commonPage/enginnerManage/projectFinishedTable",
            path: "/common/projectFinishedTable",
            component: "projectFinishedTable",
            hidden: true,
            name: "工程竣工验收记录表"
        }]
    }, {
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "用印管理",
        menuId: 16,
        children: [{
            pageAddress: "fm/FMSealDetail",
            path: "/fm/FMSealDetail",
            name: "用章详情",
            hidden: true
        }, {
            pageAddress: "cm/cmApplySealDetail",
            path: "/cm/cmApplySealDetail",
            name: "盖章申请详情",
            hidden: true
        }, {
            pageAddress: "cm/cmApplySealEdit",
            path: "/cm/cmApplySealEdit",
            name: "盖章申请",
            hidden: true
        }, {
            pageAddress: "cm/sealApply/sealApplicationAdd",
            path: "/cm/sealApplicationAdd",
            name: "新增用印申请",
            hidden: true
        }, {
            pageAddress: "cm/sealApply/sealApplicationEdit",
            path: "/cm/sealApplicationEdit",
            name: "编辑用印申请",
            hidden: true
        }, {
            pageAddress: "cm/sealApply/sealApplicationDetail",
            path: "/cm/sealApplicationDetail",
            name: "审批详情",
            hidden: true
        }, {
            pageAddress: "cm/sealApply/sealApplicationUpload",
            path: "/cm/sealApplicationUpload",
            name: "上传盖章文件",
            hidden: true
        }, {
            pageAddress: "cm/sealApply/sealApplicationOtheradd",
            path: "/cm/sealApplicationOtheradd",
            name: "新增用印申请",
            hidden: true
        }, {
            pageAddress: "cm/sealApply/sealApplicationOtherDetail",
            path: "/cm/sealApplicationOtherDetail",
            name: "审批详情",
            hidden: true
        }, {
            pageAddress: "cm/sealApply/sealApplicationOtherEdit",
            path: "/cm/sealApplicationOtherEdit",
            name: "编辑用印申请",
            hidden: true
        }]
    }, {
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "资质证书",
        menuId: 121,
        children: [{
            pageAddress: "commonPage/projectManage/editEmployeeCertificate",
            path: "/common/editEmployeeCertificate",
            name: "编辑员工证书",
            hidden: true
        }, {
            pageAddress: "commonPage/projectManage/employeeCertificateDetail",
            path: "/common/employeeCertificateDetail",
            name: "员工证书详情",
            hidden: true
        }]
    }, {
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "立项管理",
        menuId: 13,
        children: [{
            pageAddress: "commonPage/projectManage/proPreparationModify",
            path: "/common/proPreparationModify",
            component: "proPreparationModify",
            hidden: true,
            name: "编辑立项申请"
        }, {
            pageAddress: "commonPage/projectManage/proPreparationRevise",
            path: "/common/proPreparationRevise",
            component: "proPreparationRevise",
            hidden: true,
            name: "编辑项目报备"
        }, {
            pageAddress: "commonPage/projectManage/proPreparationAdd",
            path: "/common/proPreparationAdd",
            component: "proPreparationAdd",
            hidden: true,
            name: "新增立项申请"
        }, {
            pageAddress: "commonPage/projectManage/proPreparationDetail",
            path: "/common/proPreparationDetail",
            hidden: true,
            name: "立项申请详情"
        }, {
            pageAddress: "cd/CDProjectInfo",
            path: "/cd/project/track",
            name: "项目信息",
            hidden: true
        }, {
            pageAddress: "cm/CMTempProjectReadView",
            path: "/cm/temp_project/read_view",
            hidden: true,
            name: "在跟项目详情"
        }, {
            pageAddress: "commonPage/projectManage/conflictProject",
            path: "/common/conflictProject",
            component: "conflictProject",
            hidden: true,
            name: "撞单项目详情"
        }, {
            pageAddress: "commonPage/projectManage/losingDetailNew",
            path: "/commonPage/projectManage/losingDetailNew",
            component: "losingDetailNew",
            hidden: true,
            name: "丢单详情"
        }, {
            pageAddress: "commonPage/projectManage/losingApply",
            path: "/commonPage/projectManage/losingApplyBid",
            component: "losingApply",
            hidden: true,
            name: "丢单申请"
        }, {
            pageAddress: "commonPage/projectManage/guaranteeEdit",
            path: "/commonPage/projectManage/guaranteeEditBid",
            component: "guaranteeEdit",
            hidden: true,
            name: "保函申请"
        }, {
            pageAddress: "commonPage/projectManage/guaranteeEdit",
            path: "/commonPage/projectManage/guaranteeEditPerformance",
            component: "guaranteeEdit",
            hidden: true,
            name: "保函申请"
        }, {
            pageAddress: "commonPage/projectManage/guaranteeDetail",
            path: "/commonPage/projectManage/guaranteeDetail",
            component: "guaranteeDetail",
            hidden: true,
            name: "保函详情"
        }]
    }, {
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "授信管理",
        menuId: 23,
        children: [{
            pageAddress: "commonPage/CreditDetail",
            path: "/common/creditDetail",
            hidden: true,
            name: "项目授信申请详情"
        }, {
            pageAddress: "commonPage/CreditorDetail",
            path: "/common/creditorDetail",
            hidden: true,
            name: "授信人员详情"
        }, {
            pageAddress: "commonPage/creditOrderDetail",
            path: "/common/creditOrderDetail",
            hidden: true,
            name: "授信订单详情"
        }]
    }]

}, {
    path: '/p2',
    redirect: '/common/CMcontractData',
    component: "HomeView",
    name: '合同管理',
    menuId: 4,
    parent: true,
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "合同管理",
        menuId: 15,
        children: [{
            pageAddress: "commonPage/dataReport/contractDataInfo",
            path: "/common/contractDataInfo",
            hidden: true,
            name: "合同总纲详情"
        }, {
            pageAddress: "cm/CMContractReformEdit",
            path: "/cm/project/CMContractReformAdd",
            hidden: true,
            name: "添加变更合同"
        }, {
            pageAddress: "CommonContractReadView",
            path: "/cm/contract/read_view",
            hidden: true,
            name: "合同详情"
        }, {
            pageAddress: "CommonContractReadView0",
            path: "/cm/contract/read_view0",
            hidden: true,
            name: "待校对合同详情"
        }, {
            pageAddress: "cm/CMContractEditView0",
            path: "/cm/project/CMContractEditView0",
            hidden: true,
            name: "签约"
        }, {
            pageAddress: "cm/CMContractEditViewNew",
            path: "/cm/project/CMContractEditViewNew",
            hidden: true,
            name: "编辑合约"
        }, {
            pageAddress: "cm/CMContractReformEdit",
            path: "/cm/project/CMContractReformEdit",
            hidden: true,
            name: "编辑变更合同"
        }, {
            pageAddress: "CommonContractModifyDetail",
            path: "/common/contractModify/CommonContractModifyDetail",
            hidden: true,
            name: "变更合同详情"
        }, {
            pageAddress: "cd/CDTermOfContract",
            path: "/cd/project/CDTermOfContract",
            hidden: true,
            name: "终止合同"
        }, {
            pageAddress: "commonPage/dataReport/contractDataInfo",
            path: "/common/termContractDataInfo",
            hidden: true,
            name: "终止合同详情"
        }]
    }]

}, {
    path: '/p3',
    component: "HomeView",
    name: '工程管理',
    menuId: 5,
    redirect: '/common/engineerList0',
    parent: true,
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "质监管理",
        menuId: 17,
        children: [{
            pageAddress: "commonPage/enginnerManage/engineerDetail",
            path: "/common/engineerDetail",
            hidden: true,
            component: "engineerDetail",
            name: "工程详情"
        }, {
            pageAddress: "commonPage/enginnerManage/constructionScoreDetail",
            path: "/common/constructionScoreDetail",
            component: "constructionScoreDetail",
            hidden: true,
            name: "派单详情"
        }, {
            pageAddress: "commonPage/enginnerManage/securityScoreTable",
            path: "/common/securityScoreTable",
            component: "securityScoreTable",
            hidden: true,
            name: "工地安全文明施工记录表"
        }, {
            pageAddress: "commonPage/enginnerManage/qualityScoreTable",
            path: "/common/qualityScoreTable",
            component: "qualityScoreTable",
            hidden: true,
            name: "工地现场质量监察记录表"
        }, {
            pageAddress: "commonPage/enginnerManage/projectFinishedTable",
            path: "/common/projectFinishedTable",
            component: "projectFinishedTable",
            hidden: true,
            name: "工程竣工验收记录表"
        }]
    }, {
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "公关管理",
        menuId: 84,
        children: [{
            pageAddress: "commonPage/projectManage/injuriesDetail",
            path: "/common/injuriesDetail",
            component: "injuriesDetail",
            name: "事故详情",
            hidden: true
        }, {
            pageAddress: "commonPage/projectManage/injuriesModify",
            path: "/common/injuriesModify",
            component: "injuriesModify",
            name: "编辑事故详情",
            hidden: true
        }, {
            pageAddress: "commonPage/complaintManage/addComplainList",
            path: "/common/addComplainList",
            hidden: true,
            component: "addComplainList",
            name: "添加投诉"
        }, {
            pageAddress: "commonPage/complaintManage/complaintDetail",
            path: "/common/complaintDetail",
            hidden: true,
            component: "complaintDetail",
            name: "投诉详情"
        }]
    }]
}, {
    path: '/p4',
    redirect: '/common/materialList',
    component: "HomeView",
    name: '材料管理',
    menuId: 6,
    parent: true,
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "代付材料",
        menuId: 18,
        children: [{
            pageAddress: "commonPage/financeManage/materialDetail",
            path: "/common/materialDetail",
            hidden: true,
            name: "代付材料申请详情"
        }, {
            pageAddress: "commonPage/financeManage/materialApply",
            path: "/common/materialApply",
            hidden: true,
            name: "编辑代付材料申请"
        }, {
            pageAddress: "commonPage/financeManage/editMargin",
            path: "/common/editMargin",
            hidden: true,
            name: "编辑代付投标保证金申请"
        }, {
            pageAddress: "commonPage/financeManage/editDeposit",
            path: "/common/editDeposit",
            hidden: true,
            name: "编辑代付物业押金"
        }, {
            pageAddress: "commonPage/financeManage/addMargin",
            path: "/common/addMargin",
            hidden: true,
            name: "新增代付投标保证金申请"
        }, {
            pageAddress: "commonPage/financeManage/deposit",
            path: "/common/deposit",
            hidden: true,
            name: "新增代付物业押金"
        }, {
            pageAddress: "commonPage/financeManage/marginDetail",
            path: "/common/marginDetail",
            hidden: true,
            name: "代付投标保证金申请详情"
        }, {
            pageAddress: "commonPage/financeManage/depositDetail",
            path: "/common/depositDetail",
            hidden: true,
            name: "代付物业押金申请详情"
        }, {
            pageAddress: "commonPage/financeManage/purchaseDetail",
            path: "/common/purchaseDetail",
            hidden: true,
            name: "材料购销合同详情"
        }, {
            pageAddress: "commonPage/financeManage/purchaseEdit",
            path: "/common/purchaseEdit",
            hidden: true,
            name: "编辑材料购销合同"
        }, {
            pageAddress: "commonPage/financeManage/purchaseApply",
            path: "/common/purchaseApply",
            hidden: true,
            name: "新增材料购销合同"
        }]
    }, {
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "众惠材料",
        menuId: 19,
        children: []
    }]

}, {
    path: '/p5',
    redirect: '/fm/FMStatProjectIndexView',
    component: "HomeView",
    name: '财务管理',
    menuId: 7,
    parent: true,
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "总表视图",
        menuId: 20,
        children: [{
            pageAddress: "commonPage/dataReport/financeDataInfo",
            path: "/common/financeDataInfo",
            component: "financeDataInfo",
            hidden: true,
            name: "财务数据详情"
        }, {
            pageAddress: "fm/FMStatProjectReadView",
            path: "/fm/FMStatProjectReadView",
            hidden: true,
            name: "项目细节"
        }, {
            pageAddress: "fm/FMStatProjectReadView2",
            path: "/fm/FMStatProjectReadView2",
            hidden: true,
            name: "项目细节"
        }, {
            pageAddress: "fm/FMContractEditView",
            path: "/fm/FMContractEditView",
            hidden: true,
            name: "编辑合约"
        }, {
            pageAddress: "cm/CMFinishedAccountDetail",
            path: "/cm/CMFinishedAccountDetail",
            hidden: true,
            name: "结算详情"
        }]
    }, {
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "资金管理",
        menuId: 21,
        children: [{
            pageAddress: "fm/FMFinanceIncomeReadView",
            path: "/fm/financeIncome/read",
            hidden: true,
            name: "流水信息"
        }, {
            pageAddress: "cm/CMFinanceIncomeEditView",
            path: "/cm/financeIncome/edit",
            hidden: true,
            name: "认领收款流水"
        }, {
            pageAddress: "process/CommonFinanceIncomeReadView",
            path: "/cm/common/finance_income/read_view",
            hidden: true,
            name: "收款流水细节"
        }, {
            pageAddress: "finance/FinanceFinanceIncomeEditView",
            path: "/finance/financeIncome/edit",
            hidden: true,
            name: "编辑收款流水"
        }, {
            pageAddress: "finance/insuranceAdd",
            path: "/finance/insuranceAdd",
            hidden: true,
            name: "添加保险"
        }, {
            pageAddress: "finance/insuranceDetail",
            path: "/finance/insuranceDetail",
            hidden: true,
            name: "保险详情"
        }, {
            pageAddress: "commonPage/financeManage/servicePayDetail",
            path: "/common/servicePayDetail",
            hidden: true,
            name: "劳务支付详情"
        }, {
            pageAddress: "commonPage/financeManage/servicePayApply",
            path: "/common/servicePayApply",
            hidden: true,
            name: "新增劳务支付"
        }, {
            pageAddress: "commonPage/financeManage/servicePayEdit",
            path: "/common/servicePayEdit",
            hidden: true,
            name: "编辑劳务支付"
        }, {
            pageAddress: "commonPage/financeManage/refundTaxesApply",
            path: "/common/refundTaxesApply",
            hidden: true,
            name: "退预缴税费申请"
        }, {
            pageAddress: "commonPage/financeManage/refundTaxesDetails",
            path: "/common/refundTaxesDetails",
            hidden: true,
            name: "退预缴税费申请详情"
        }, {
            pageAddress: "commonPage/financeManage/RiskRefund",
            path: "/common/RiskRefund",
            hidden: true,
            name: "退风险金"
        }, {
            pageAddress: "commonPage/financeManage/RiskFundDetails",
            path: "/common/RiskFundDetails",
            hidden: true,
            name: "退风险金详情"
        }, {
            pageAddress: "fm/FMAddDeduction",
            path: "/fm/FMAddDeduction",
            hidden: true,
            name: "添加手动扣款"
        }, {
            pageAddress: "fm/FMDeductionDetail",
            path: "/fm/FMDeductionDetail",
            hidden: true,
            name: "手动扣款详情"
        }, {
            pageAddress: "commonPage/financeManage/applyPaymentDetail",
            path: "/common/applyPaymentDetail",
            hidden: true,
            name: "用款申请详情"
        }, {
            pageAddress: "commonPage/financeManage/systemCommissionDetail",
            path: "/common/systemCommissionDetail",
            hidden: true,
            name: "系统提成详情"
        }]
    }, {
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "发票管理",
        menuId: 22,
        children: [{
            pageAddress: "fm/FmOutPutTicketDetail",
            path: "/fm/FmOutPutTicketDetail",
            hidden: true,
            name: "开票详情"
        }, {
            pageAddress: "fm/FmAddOutPutTicket",
            path: "/fm/FmAddOutPutTicket",
            hidden: true,
            name: "新增开票申请"
        }, {
            pageAddress: "fm/FmEditOutPutTicket",
            path: "/fm/FmEditOutPutTicket",
            hidden: true,
            name: "编辑开票申请"
        }, {
            pageAddress: "fm/FmRedPunch",
            path: "/fm/FmRedPunch",
            hidden: true,
            name: "发票红冲申请"
        }, {
            pageAddress: "fm/FMVoidRecordDetail",
            path: "/fm/FMVoidRecordDetail",
            hidden: true,
            name: "销项票作废记录详情"
        }, {
            pageAddress: "fm/FmEntryTicketDetail",
            path: "/fm/FmEntryTicketDetail",
            hidden: true,
            name: "进项票详情"
        }, {
            pageAddress: "fm/FmAddEntryTicket",
            path: "/fm/FmAddEntryTicket",
            hidden: true,
            name: "新增进项票"
        }, {
            pageAddress: "fm/prepaidTaxForm",
            path: "/fm/prepaidTaxForm",
            hidden: true,
            name: "预缴税费申请"
        }, {
            pageAddress: "fm/prepaidTaxDetail",
            path: "/fm/prepaidTaxDetail",
            hidden: true,
            name: "预缴税费详情"
        }, {
            pageAddress: "cm/ApplyData/ApplyDataEditView01",
            path: "/cm/applyData/edit01",
            hidden: true,
            name: "盖章申请"
        }, {

            pageAddress: "cm/ApplyData/ApplyDataEditView02",
            path: "/cm/applyData/edit02",
            hidden: true,
            name: "发票申请"
        }, {
            pageAddress: "cm/ApplyData/ApplyDataEditView03",
            path: "/cm/applyData/edit03",
            hidden: true,
            name: "提现申请"
        }, {
            pageAddress: "cm/ApplyData/ApplyDataEditView04",
            path: "/cm/applyData/edit04",
            hidden: true,
            name: "代付材料申请"
        }, {
            pageAddress: "cm/ApplyData/ApplyDataEditView05",
            path: "/cm/applyData/edit05",
            hidden: true,
            name: "授信提额申请"
        }]
    }]
}, {
    path: '/p6',
    component: "HomeView",
    name: '精英库管理',
    menuId: 8,

    parent: true,
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "人员管理",
        menuId: 24,
        children: [{
            pageAddress: "ba/BAProjectManagerAddView",
            path: "/ba/pm/add",
            name: "新增项目总监",
            hidden: true
        }, {
            pageAddress: "ba/BAProjectManagerEditViewNew",
            path: "/ba/pm/edit",
            hidden: true,
            name: "编辑人员"
        }, {
            pageAddress: "cd/CDProjectManagerEditViewNew",
            path: "/cd/pm/edit",
            hidden: true,
            name: "人员详情"
        }, {
            pageAddress: "bm/BMProjectManagerReadView",
            path: "/ba/pm/read_view",
            hidden: true,
            name: "人员详情"
        }, {
            pageAddress: "cd/CDprojectDirector",
            path: "/cm/pm/projectDirector",
            hidden: true,
            name: "查看人员"
        }, {
            pageAddress: "cd/CDinterviewRecord",
            path: "/cm/pm/interviewRecord",
            hidden: true,
            name: "人员管理---访谈记录"
        }, {
            pageAddress: "cd/CDprojectInformation",
            path: "/cd/pm/projectInformation",
            hidden: true,
            name: "查看人员项目信息"
        }, {
            pageAddress: "pm/pmComplaintList",
            path: "/pm/pmComplaintList",
            hidden: true,
            name: "投诉处理"
        }, {
            pageAddress: "cd/CDProjectManagerEditViewNew",
            path: "/cd/pm/edit",
            hidden: true,
            name: "冻结名单详情"
        }, {
            pageAddress: "cd/pmBlackDetail",
            path: "/cd/pm/pmBlackDetail",
            name: "人员详情",
            hidden: true
        }, {
            pageAddress: "ExecutiveProjectManagerView",
            path: "/insCommissioner/ExecutiveProjectManagerView",
            name: "人员总表",
            hidden: true
        }]
    }, {
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "工人管理",
        menuId: 124,
        children: [{
            pageAddress: "pm/workerManage/workerDetail",
            path: "/pm/workerDetail",
            hidden: true,
            name: "工人详情"
        }, {
            pageAddress: "pm/workerManage/workerEdit",
            path: "/pm/workerEdit",
            hidden: true,
            name: "编辑工人"
        }]
    }, {
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "业务管理",
        menuId: 91,
        children: [{
            pageAddress: "cm/CMIntroducerInfo",
            path: "/cm/introducer/infor",
            hidden: true,
            name: "项目总监关系管理详情"
        }, {
            pageAddress: "cm/CMIntroducerAddView",
            path: "/cm/introducer/edit",
            hidden: true,
            component: "CMIntroducerAddView",
            name: "介绍人编辑"
        }, {
            pageAddress: "commonPage/pmManage/pmInterviewDetail",
            path: "/common/pmInterviewDetail",
            component: "pmInterviewDetail",
            hidden: true,
            name: "访谈记录详情"
        }, {
            pageAddress: "commonPage/pmManage/pmInterviewAdd",
            path: "/common/pmInterviewAdd",
            component: "pmInterviewAdd",
            hidden: true,
            name: "添加访谈记录"
        }]
    }]
}, {
    path: '/p7',
    redirect: '/cm/customer/index',
    component: "HomeView",
    name: '客户管理',
    menuId: 9,
    parent: true,
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "客户管理",
        menuId: 25,
        children: [{
            pageAddress: "cm/CMCustomerAddOrEditView",
            path: "/cm/customer/addoredit",
            hidden: true,
            name: "编辑甲方公司"
        }, {
            pageAddress: "cm/CMCustomerDetail",
            path: "/cm/customer/detail",
            hidden: true,
            name: "甲方公司详情"
        }, {
            pageAddress: "cm/beRecordDetail",
            path: "/cm/beRecordDetail",
            hidden: true,
            name: "入库详情"
        }, {
            pageAddress: "cm/beRecordAdd",
            path: "/cm/beRecordAdd",
            name: "添加信息",
            hidden: true
        }, {
            pageAddress: "cm/beRecordEdit",
            path: "/cm/beRecordEdit",
            hidden: true,
            name: "编辑信息"
        }]
    }, {
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "供应商管理",
        menuId: 158,
        children: [{
            pageAddress: "customer/supplierDetails",
            path: "/customer/supplierDetails",
            hidden: true,
            name: "供应商详情"
        }, {
            pageAddress: "customer/supplierEdit",
            path: "/customer/supplierEdit",
            hidden: true,
            name: "编辑供应商"
        }]
    }, {
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "合作公司管理",
        menuId: 121,
        children: [{
            pageAddress: "cm/CooperativeCompany",
            path: "/cm/customer/CooperativeCompany",
            name: "合作公司"
        }]
    }]

}, {
    path: '/p8',
    redirect: '/user/index',
    component: "HomeView",
    name: '系统管理',
    menuId: 10,
    parent: true,
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "工单管理",
        menuId: 175,
        children: [{
            pageAddress: "admin/WorkOrderAdd",
            path: "/admin/WorkOrderAdd",
            hidden: true,
            name: "新增工单"
        }, {
            pageAddress: "admin/WorkOrderDetail",
            path: "/admin/WorkOrderDetail",
            hidden: true,
            name: "工单详情"
        }, {
            pageAddress: "admin/WorkOrderEdit",
            path: "/admin/WorkOrderEdit",
            hidden: true,
            name: "编辑工单"
        }]
    }, {
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "账户设置",
        menuId: 26,
        children: [{
            pageAddress: "commonPage/AccountDetail",
            path: "/UserIndexView/detail",
            hidden: true,
            name: "员工账号详情"
        }]
    }, {
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "通用设置",
        menuId: 27,
        children: [{
            path: '/admin/SubCompanyInfo',
            component: "SubCompanyInfo",
            hidden: true,
            name: '新美子公司详情'
        }, {
            path: '/admin/SubCompanyEditView',
            component: "SubCompanyEditView",
            hidden: true,
            name: '编辑子公司'
        }]
    }, {
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "个人设置",
        menuId: 28,
        children: []
    }]

}, {
    pageAddress: "commonPage/enginnerManage/returnVisitTable",
    path: "/common/returnVisitTable",
    component: "returnVisitTable",
    hidden: true
}, {
    pageAddress: "commonPage/enginnerManage/finishProjectTable",
    path: "/common/finishProjectTable",
    component: "finishProjectTable",
    hidden: true
}, {
    pageAddress: "commonPage/enginnerManage/startProjectTable",
    path: "/common/startProjectTable",
    component: "startProjectTable",
    hidden: true
}, {
    pageAddress: "commonPage/financeManage/materialPrint",
    path: "/common/materialPrint",
    hidden: true,
    name: "打印付款申请单"
}, {
    pageAddress: "commonPage/financeManage/marginPrint",
    path: "/common/marginPrint",
    hidden: true,
    name: "打印代付投标保证金"
}, {
    pageAddress: "commonPage/financeManage/depositPrint",
    path: "/common/depositPrint",
    hidden: true,
    name: "打印物业押金"
}, {
    pageAddress: "commonPage/dataReport/printSettleForm",
    path: "/common/printSettleForm",
    component: "printSettleForm",
    hidden: true,
    name: "打印结算表"
}, {
    pageAddress: "fm/receiptConfirmation",
    path: "/fm/financeIncome/receiptConfirmation",
    hidden: true,
    name: "打印收款流水"
}, {
    pageAddress: "commonPage/financeManage/serviceFeePrint",
    path: "/common/serviceFeePrint",
    hidden: true,
    name: "打印劳务支付"
}, {
    pageAddress: "commonPage/financeManage/refundTaxesPrint",
    path: "/common/refundTaxesPrint",
    hidden: true,
    name: "打印退预缴税费申请表"
}, {
    pageAddress: "commonPage/financeManage/riskRefundPrint",
    path: "/common/riskRefundPrint",
    hidden: true,
    name: "打印退风险金申请表"
}, {
    pageAddress: "fm/printOutPutTicket",
    path: "/common/printOutPutTicket",
    component: "printOutPutTicket",
    hidden: true,
    name: "打印销项票"
}, {
    pageAddress: "commonPage/enginnerManage/monitors",
    path: "/common/monitors",
    hidden: true,
    name: "视频监控"
}, {
    pageAddress: "fm/prepaidTaxPrint",
    path: "/common/prepaidTaxPrint",
    hidden: true,
    name: "打印预缴税费申请"
}];

exports.default = commonMenu;

/***/ }),

/***/ 1722:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./404View.vue": [
		685
	],
	"./AppLogin.vue": [
		686
	],
	"./BAProjectManagerView.vue": [
		1739,
		80
	],
	"./BAProjectManagerView2.vue": [
		1740,
		71
	],
	"./BMProjectManagerView.vue": [
		1741,
		70
	],
	"./BankNameDataView.vue": [
		1742,
		429
	],
	"./CDProjectManagerView.vue": [
		1743,
		69
	],
	"./CMProjectManagerAddView.vue": [
		1744,
		57
	],
	"./CMProjectManagerEditView.vue": [
		1745,
		56
	],
	"./CMProjectManagerView.vue": [
		1746,
		79
	],
	"./CMProjectManagerView2.vue": [
		1747,
		68
	],
	"./ChangePasswordView.vue": [
		1748,
		428
	],
	"./CommonApplyDataAuditView03.vue": [
		1749,
		174
	],
	"./CommonApplyGetCashDataIndexView.vue": [
		1750,
		427
	],
	"./CommonContractAuditView.vue": [
		1751,
		121
	],
	"./CommonContractIndexView.vue": [
		1752,
		426
	],
	"./CommonContractModifyCheck.vue": [
		1753,
		238
	],
	"./CommonContractModifyDetail.vue": [
		1754,
		173
	],
	"./CommonContractReadView.vue": [
		1755,
		120
	],
	"./CommonContractReadView0.vue": [
		1756,
		43
	],
	"./CommonProjectReadView.vue": [
		1757,
		82
	],
	"./CommonStatIncomeAutoCalListReadView.vue": [
		1727,
		425
	],
	"./CommonStatIncomePayListReadView.vue": [
		1728,
		424
	],
	"./CommonUploadH5.vue": [
		687
	],
	"./DangerResetIncomeAuditIndexView.vue": [
		1758,
		221
	],
	"./DistrictIndexView.vue": [
		1759,
		244
	],
	"./EngineeringIndex.vue": [
		1732,
		316
	],
	"./EnumCat.vue": [
		1760,
		430
	],
	"./EnumCatView.vue": [
		1761,
		315
	],
	"./EnumDataIndexView.vue": [
		1762,
		49
	],
	"./ExecutiveProjectManagerView.vue": [
		1763,
		423
	],
	"./ForgotPassword.vue": [
		760,
		6
	],
	"./GzCategoryIndexView.vue": [
		1764,
		158
	],
	"./H5Upload.vue": [
		688
	],
	"./HomeView.vue": [
		373
	],
	"./IndexView.vue": [
		1765,
		314
	],
	"./IntroducerAddView.vue": [
		1766,
		137
	],
	"./IntroducerIndexView.vue": [
		1767,
		313
	],
	"./JournalFileh5.vue": [
		689
	],
	"./LoginView.vue": [
		690
	],
	"./MainView.vue": [
		1768,
		422
	],
	"./Navi.vue": [
		264
	],
	"./Navigation.vue": [
		374
	],
	"./Navigation2.vue": [
		1733,
		421
	],
	"./OperationCenterView.vue": [
		1769,
		420
	],
	"./OrganizationalManagement.vue": [
		1770,
		37
	],
	"./PmAddView.vue": [
		1771,
		100
	],
	"./PmIndexView.vue": [
		1772,
		157
	],
	"./ProblemFeedbackDetailView.vue": [
		1773,
		419
	],
	"./ProblemFeedbackView.vue": [
		1774,
		418
	],
	"./ProjectManagerListView.vue": [
		1775,
		78
	],
	"./ProvincialUrbanIndex.vue": [
		1776,
		258
	],
	"./RoleIndexView.vue": [
		1777,
		246
	],
	"./RoleManagement.vue": [
		1778,
		417
	],
	"./SubCompanyEditView.vue": [
		1779,
		143
	],
	"./SubCompanyIndexView.vue": [
		1780,
		166
	],
	"./SubCompanyInfo.vue": [
		1781,
		237
	],
	"./UserDirectorAccount.vue": [
		1782,
		243
	],
	"./UserManage.vue": [
		1783,
		31
	],
	"./admin/WorkOrderAdd.vue": [
		1785,
		130
	],
	"./admin/WorkOrderDetail.vue": [
		1786,
		172
	],
	"./admin/WorkOrderEdit.vue": [
		1787,
		129
	],
	"./adminWorkOrderView.vue": [
		1784,
		416
	],
	"./app/agent.vue": [
		691
	],
	"./app/appNav.vue": [
		249
	],
	"./app/appUserInfo.vue": [
		692
	],
	"./app/copy.vue": [
		693
	],
	"./ba/BAProjectManagerAddView.vue": [
		1788,
		18
	],
	"./ba/BAProjectManagerEditMoreView.vue": [
		1789,
		210
	],
	"./ba/BAProjectManagerEditView.vue": [
		1790,
		14
	],
	"./ba/BAProjectManagerEditViewNew.vue": [
		1791,
		15
	],
	"./ba/BAProjectManagerReadView.vue": [
		1792,
		118
	],
	"./bm/BMProjectManagerEditMoreView.vue": [
		1793,
		209
	],
	"./bm/BMProjectManagerEditView.vue": [
		1794,
		26
	],
	"./bm/BMProjectManagerReadView.vue": [
		1795,
		126
	],
	"./bm/BMProjectManagerUpdateApplyView.vue": [
		1796,
		98
	],
	"./bm/BMProjectManagerView.vue": [
		1797,
		97
	],
	"./bs/BSAddTurnoverView.vue": [
		1798,
		415
	],
	"./bs/BSTurnoverClaimView.vue": [
		1799,
		468
	],
	"./businessInfo/index.vue": [
		761,
		9
	],
	"./casePublicize/PropagandaDetails.vue": [
		1800,
		83
	],
	"./casePublicize/projectPublicize.vue": [
		1801,
		185
	],
	"./cd/CDIntroducerIndexView.vue": [
		1802,
		414
	],
	"./cd/CDIntroducerInfoView.vue": [
		1803,
		153
	],
	"./cd/CDProjectInfo.vue": [
		1804,
		161
	],
	"./cd/CDProjectManagerEditMoreView.vue": [
		1805,
		208
	],
	"./cd/CDProjectManagerEditView.vue": [
		1806,
		125
	],
	"./cd/CDProjectManagerEditViewNew.vue": [
		1807,
		76
	],
	"./cd/CDProjectManagerUpdateApplyView.vue": [
		1808,
		116
	],
	"./cd/CDProjectManagerView.vue": [
		1809,
		67
	],
	"./cd/CDRunningProjectIndexView.vue": [
		1810,
		413
	],
	"./cd/CDTempProjectConfirmView.vue": [
		1811,
		160
	],
	"./cd/CDTempProjectIndexView.vue": [
		1812,
		467
	],
	"./cd/CDTermOfContract.vue": [
		1813,
		312
	],
	"./cd/CDValidProjectIndexView.vue": [
		1814,
		412
	],
	"./cd/CDinterviewRecord.vue": [
		1815,
		411
	],
	"./cd/CDprojectDirector.vue": [
		1816,
		410
	],
	"./cd/CDprojectInformation.vue": [
		1817,
		409
	],
	"./cd/pmBlackDetail.vue": [
		1818,
		124
	],
	"./cd/pmBlackList.vue": [
		1819,
		311
	],
	"./cm/ApplyData/ApplyDataEditView01.vue": [
		1820,
		265
	],
	"./cm/ApplyData/ApplyDataEditView02.vue": [
		1821,
		264
	],
	"./cm/ApplyData/ApplyDataEditView03.vue": [
		1822,
		236
	],
	"./cm/ApplyData/ApplyDataEditView04.vue": [
		1823,
		263
	],
	"./cm/ApplyData/ApplyDataEditView05.vue": [
		1824,
		262
	],
	"./cm/ApplyData/ApplyDataReadView03.vue": [
		1825,
		261
	],
	"./cm/CMAddTurnoverView.vue": [
		1826,
		408
	],
	"./cm/CMAddandedit.vue": [
		1827,
		163
	],
	"./cm/CMAllianceIntroducerView.vue": [
		1828,
		310
	],
	"./cm/CMApplyDataIndexView.vue": [
		1829,
		407
	],
	"./cm/CMApplyGETCASHIndexView.vue": [
		1830,
		406
	],
	"./cm/CMChangePWView.vue": [
		1831,
		405
	],
	"./cm/CMCompanyAddView.vue": [
		1832,
		204
	],
	"./cm/CMCompanyIndexView.vue": [
		1833,
		404
	],
	"./cm/CMConflictProject.vue": [
		1834,
		309
	],
	"./cm/CMContractDetailInfo.vue": [
		1835,
		216
	],
	"./cm/CMContractEditView.vue": [
		1836,
		28
	],
	"./cm/CMContractEditView0.vue": [
		1837,
		22
	],
	"./cm/CMContractEditViewNew.vue": [
		1838,
		20
	],
	"./cm/CMContractIndexView.vue": [
		1839,
		403
	],
	"./cm/CMContractList.vue": [
		1840,
		10
	],
	"./cm/CMContractReformDetail.vue": [
		1841,
		469
	],
	"./cm/CMContractReformEdit.vue": [
		1842,
		133
	],
	"./cm/CMCustomerAddOrEditView.vue": [
		1843,
		203
	],
	"./cm/CMCustomerDetail.vue": [
		1844,
		242
	],
	"./cm/CMCustomerIndexView.vue": [
		1845,
		402
	],
	"./cm/CMFeeApplicationView24.vue": [
		1846,
		466
	],
	"./cm/CMFeeHistoryView.vue": [
		1847,
		465
	],
	"./cm/CMFeeIndexView.vue": [
		1848,
		401
	],
	"./cm/CMFinanceIncomeEditView.vue": [
		1849,
		65
	],
	"./cm/CMFinanceIncomeIndexView.vue": [
		1850,
		308
	],
	"./cm/CMFinishedAccountApply.vue": [
		1851,
		112
	],
	"./cm/CMFinishedAccountDetail.vue": [
		1852,
		103
	],
	"./cm/CMFinishedIndexView.vue": [
		1853,
		400
	],
	"./cm/CMFollowUpIndexView.vue": [
		1854,
		399
	],
	"./cm/CMInfoSecondteamView.vue": [
		1855,
		464
	],
	"./cm/CMIntroducerAddView.vue": [
		1856,
		32
	],
	"./cm/CMIntroducerIndexView.vue": [
		1857,
		146
	],
	"./cm/CMIntroducerInfo.vue": [
		1858,
		307
	],
	"./cm/CMIntroducerInfoView.vue": [
		1859,
		152
	],
	"./cm/CMPersonalDataView.vue": [
		1860,
		241
	],
	"./cm/CMPreparation.vue": [
		1861,
		306
	],
	"./cm/CMProjectHistoryView.vue": [
		1862,
		305
	],
	"./cm/CMProjectManagerEditMoreView.vue": [
		1863,
		207
	],
	"./cm/CMProjectManagerEditView.vue": [
		1864,
		25
	],
	"./cm/CMProjectManagerReadView.vue": [
		1865,
		117
	],
	"./cm/CMProjectModifyList.vue": [
		1866,
		222
	],
	"./cm/CMProvincialAddView.vue": [
		1867,
		99
	],
	"./cm/CMRewardsPunishDetailView.vue": [
		1868,
		154
	],
	"./cm/CMRewardsPunishView.vue": [
		1869,
		122
	],
	"./cm/CMRunningProjectEditView.vue": [
		1734,
		11
	],
	"./cm/CMRunningProjectIndexView.vue": [
		1870,
		398
	],
	"./cm/CMStatisticsView.vue": [
		1871,
		397
	],
	"./cm/CMSubTeamEditView.vue": [
		1872,
		251
	],
	"./cm/CMSubTeamView.vue": [
		1873,
		396
	],
	"./cm/CMTempProjectEditView.vue": [
		1874,
		27
	],
	"./cm/CMTempProjectIndexView.vue": [
		1875,
		395
	],
	"./cm/CMTempProjectReadView.vue": [
		1876,
		13
	],
	"./cm/CMTrackView.vue": [
		1877,
		113
	],
	"./cm/CMTurnoverClaimView.vue": [
		1878,
		463
	],
	"./cm/CMUploadMainContractView.vue": [
		1879,
		50
	],
	"./cm/CMUploadSonContractView.vue": [
		1880,
		77
	],
	"./cm/CMValidProjectIndexView.vue": [
		1881,
		394
	],
	"./cm/CMcontractData.vue": [
		1882,
		175
	],
	"./cm/CooperativeCompany.vue": [
		1883,
		142
	],
	"./cm/applySeal.vue": [
		1884,
		393
	],
	"./cm/beRecordAdd.vue": [
		1885,
		392
	],
	"./cm/beRecordDetail.vue": [
		1886,
		240
	],
	"./cm/beRecordEdit.vue": [
		1887,
		391
	],
	"./cm/beRecordList.vue": [
		1888,
		390
	],
	"./cm/cmApplySealDetail.vue": [
		1889,
		235
	],
	"./cm/cmApplySealEdit.vue": [
		1890,
		217
	],
	"./cm/customerIntentionList.vue": [
		1891,
		200
	],
	"./cm/sealApply/sealApplicationAdd.vue": [
		1892,
		61
	],
	"./cm/sealApply/sealApplicationDetail.vue": [
		1893,
		75
	],
	"./cm/sealApply/sealApplicationEdit.vue": [
		1894,
		60
	],
	"./cm/sealApply/sealApplicationIndexView.vue": [
		1895,
		389
	],
	"./cm/sealApply/sealApplicationOtherDetail.vue": [
		1896,
		171
	],
	"./cm/sealApply/sealApplicationOtherEdit.vue": [
		1897,
		128
	],
	"./cm/sealApply/sealApplicationOtherView.vue": [
		1898,
		388
	],
	"./cm/sealApply/sealApplicationOtheradd.vue": [
		1899,
		127
	],
	"./cm/sealApply/sealApplicationUpload.vue": [
		1900,
		186
	],
	"./cm/toBeImprovedCustomer.vue": [
		1901,
		387
	],
	"./commonPage/AccountDetail.vue": [
		1902,
		255
	],
	"./commonPage/CreditDetail.vue": [
		1903,
		52
	],
	"./commonPage/CreditList.vue": [
		1904,
		386
	],
	"./commonPage/CreditProjectList.vue": [
		1905,
		385
	],
	"./commonPage/CreditorDetail.vue": [
		1906,
		384
	],
	"./commonPage/CreditorList.vue": [
		1907,
		383
	],
	"./commonPage/UserIndexView.vue": [
		1908,
		202
	],
	"./commonPage/broadHeading/AllocationOfItems.vue": [
		1909,
		36
	],
	"./commonPage/broadHeading/LargeProject.vue": [
		1910,
		35
	],
	"./commonPage/broadHeading/littleProject.vue": [
		1911,
		34
	],
	"./commonPage/broadHeading/nomalProject.vue": [
		1729,
		33
	],
	"./commonPage/broadHeading/routineProject.vue": [
		1912,
		30
	],
	"./commonPage/broadHeading/smallProject.vue": [
		1913,
		29
	],
	"./commonPage/complaintManage/addComplainList.vue": [
		1914,
		132
	],
	"./commonPage/complaintManage/addLitigation.vue": [
		1915,
		59
	],
	"./commonPage/complaintManage/complainEdit.vue": [
		1916,
		64
	],
	"./commonPage/complaintManage/complaintDetail.vue": [
		1917,
		170
	],
	"./commonPage/complaintManage/complaintList.vue": [
		1918,
		199
	],
	"./commonPage/complaintManage/editLitigation.vue": [
		1919,
		58
	],
	"./commonPage/complaintManage/litigationDetail.vue": [
		1920,
		131
	],
	"./commonPage/complaintManage/litigationList.vue": [
		1921,
		382
	],
	"./commonPage/creditOrder.vue": [
		1922,
		179
	],
	"./commonPage/creditOrderDetail.vue": [
		1923,
		198
	],
	"./commonPage/customerIntentionAdd.vue": [
		1924,
		147
	],
	"./commonPage/customerIntentionDetail.vue": [
		1925,
		381
	],
	"./commonPage/customerIntentionList.vue": [
		1926,
		197
	],
	"./commonPage/dataReport/AScontractData.vue": [
		1927,
		304
	],
	"./commonPage/dataReport/contractData.vue": [
		1928,
		303
	],
	"./commonPage/dataReport/contractDataInfo.vue": [
		1929,
		169
	],
	"./commonPage/dataReport/financeData.vue": [
		1930,
		302
	],
	"./commonPage/dataReport/financeDataInfo.vue": [
		1931,
		176
	],
	"./commonPage/dataReport/printSettleForm.vue": [
		1932,
		380
	],
	"./commonPage/enginnerManage/FmOutPutTicket.vue": [
		1933,
		379
	],
	"./commonPage/enginnerManage/commanScoreTable.vue": [
		1730,
		378
	],
	"./commonPage/enginnerManage/constructionScoreDetail.vue": [
		1934,
		301
	],
	"./commonPage/enginnerManage/constructionScoreList.vue": [
		1935,
		377
	],
	"./commonPage/enginnerManage/engineerDetail.vue": [
		1936,
		12
	],
	"./commonPage/enginnerManage/engineerList.vue": [
		1937,
		257
	],
	"./commonPage/enginnerManage/engineerList0.vue": [
		1938,
		256
	],
	"./commonPage/enginnerManage/finishProjectTable.vue": [
		1939,
		234
	],
	"./commonPage/enginnerManage/monitors.vue": [
		1940,
		376
	],
	"./commonPage/enginnerManage/pmAllGradeList.vue": [
		1941,
		375
	],
	"./commonPage/enginnerManage/projectFinishedTable.vue": [
		1942,
		374
	],
	"./commonPage/enginnerManage/qualityScoreTable.vue": [
		1943,
		215
	],
	"./commonPage/enginnerManage/returnVisit.vue": [
		1944,
		300
	],
	"./commonPage/enginnerManage/returnVisitTable.vue": [
		1945,
		233
	],
	"./commonPage/enginnerManage/securityScoreTable.vue": [
		1946,
		214
	],
	"./commonPage/enginnerManage/startProjectTable.vue": [
		1947,
		373
	],
	"./commonPage/enginnerManage/supervisorExamList.vue": [
		1948,
		299
	],
	"./commonPage/financeManage/NewXiangmushitu.vue": [
		1949,
		372
	],
	"./commonPage/financeManage/RiskFundDetails.vue": [
		1950,
		91
	],
	"./commonPage/financeManage/RiskRefund.vue": [
		1951,
		62
	],
	"./commonPage/financeManage/addMargin.vue": [
		1952,
		94
	],
	"./commonPage/financeManage/applyPaymentDetail.vue": [
		1953,
		298
	],
	"./commonPage/financeManage/applyPaymentList.vue": [
		1954,
		297
	],
	"./commonPage/financeManage/deposit.vue": [
		1955,
		93
	],
	"./commonPage/financeManage/depositDetail.vue": [
		1956,
		90
	],
	"./commonPage/financeManage/depositPrint.vue": [
		1957,
		371
	],
	"./commonPage/financeManage/editDeposit.vue": [
		1958,
		66
	],
	"./commonPage/financeManage/editMargin.vue": [
		1959,
		92
	],
	"./commonPage/financeManage/marginDetail.vue": [
		1960,
		89
	],
	"./commonPage/financeManage/marginPrint.vue": [
		1961,
		370
	],
	"./commonPage/financeManage/materialApply.vue": [
		1962,
		53
	],
	"./commonPage/financeManage/materialDetail.vue": [
		1963,
		88
	],
	"./commonPage/financeManage/materialList.vue": [
		1964,
		296
	],
	"./commonPage/financeManage/materialList2.vue": [
		1965,
		295
	],
	"./commonPage/financeManage/materialPrint.vue": [
		1966,
		369
	],
	"./commonPage/financeManage/purchaseApply.vue": [
		1967,
		196
	],
	"./commonPage/financeManage/purchaseDetail.vue": [
		1968,
		141
	],
	"./commonPage/financeManage/purchaseEdit.vue": [
		1969,
		195
	],
	"./commonPage/financeManage/purchaseList.vue": [
		1970,
		184
	],
	"./commonPage/financeManage/refundTaxesApply.vue": [
		1971,
		46
	],
	"./commonPage/financeManage/refundTaxesDetails.vue": [
		1972,
		87
	],
	"./commonPage/financeManage/refundTaxesPrint.vue": [
		1973,
		368
	],
	"./commonPage/financeManage/riskRefundPrint.vue": [
		1974,
		367
	],
	"./commonPage/financeManage/serviceFeePrint.vue": [
		1975,
		366
	],
	"./commonPage/financeManage/servicePayApply.vue": [
		1976,
		48
	],
	"./commonPage/financeManage/servicePayDetail.vue": [
		1977,
		86
	],
	"./commonPage/financeManage/servicePayEdit.vue": [
		1978,
		47
	],
	"./commonPage/financeManage/servicePayList.vue": [
		1979,
		294
	],
	"./commonPage/financeManage/servicePayList2.vue": [
		1980,
		293
	],
	"./commonPage/financeManage/systemCommissionDetail.vue": [
		1981,
		365
	],
	"./commonPage/financeManage/systemCommissionList.vue": [
		1982,
		292
	],
	"./commonPage/financeManage/zhotyImportList.vue": [
		1983,
		291
	],
	"./commonPage/otherAnomalies/otherAnomaliesList.vue": [
		1984,
		145
	],
	"./commonPage/pmManage/pmInterviewAdd.vue": [
		1985,
		290
	],
	"./commonPage/pmManage/pmInterviewDetail.vue": [
		1986,
		364
	],
	"./commonPage/pmManage/pmInterviewList.vue": [
		1987,
		363
	],
	"./commonPage/projectManage/adminSanctionAdd.vue": [
		1988,
		110
	],
	"./commonPage/projectManage/adminSanctionDetail.vue": [
		1989,
		109
	],
	"./commonPage/projectManage/adminSanctionEdit.vue": [
		1990,
		72
	],
	"./commonPage/projectManage/adminSanctionList.vue": [
		1991,
		194
	],
	"./commonPage/projectManage/companyQualification.vue": [
		1992,
		193
	],
	"./commonPage/projectManage/conflictProject.vue": [
		1993,
		362
	],
	"./commonPage/projectManage/editEmployeeCertificate.vue": [
		1994,
		159
	],
	"./commonPage/projectManage/editProjectInformation.vue": [
		1995,
		24
	],
	"./commonPage/projectManage/employeeCertificate.vue": [
		1996,
		192
	],
	"./commonPage/projectManage/employeeCertificateDetail.vue": [
		1997,
		228
	],
	"./commonPage/projectManage/fileDetail.vue": [
		1998,
		177
	],
	"./commonPage/projectManage/fileList.vue": [
		1999,
		232
	],
	"./commonPage/projectManage/guaranteeDetail.vue": [
		2000,
		111
	],
	"./commonPage/projectManage/guaranteeEdit.vue": [
		2001,
		73
	],
	"./commonPage/projectManage/guaranteeList.vue": [
		2002,
		191
	],
	"./commonPage/projectManage/guaranteeListApply.vue": [
		2003,
		190
	],
	"./commonPage/projectManage/injuriesAdd.vue": [
		2004,
		108
	],
	"./commonPage/projectManage/injuriesDetail.vue": [
		2005,
		134
	],
	"./commonPage/projectManage/injuriesList.vue": [
		2006,
		189
	],
	"./commonPage/projectManage/injuriesModify.vue": [
		2007,
		107
	],
	"./commonPage/projectManage/losingApply.vue": [
		2008,
		106
	],
	"./commonPage/projectManage/losingDetail.vue": [
		2009,
		231
	],
	"./commonPage/projectManage/losingDetailNew.vue": [
		2010,
		23
	],
	"./commonPage/projectManage/losingList.vue": [
		2011,
		289
	],
	"./commonPage/projectManage/proPreparationAdd.vue": [
		2012,
		17
	],
	"./commonPage/projectManage/proPreparationDetail.vue": [
		2013,
		42
	],
	"./commonPage/projectManage/proPreparationModify.vue": [
		2014,
		16
	],
	"./commonPage/projectManage/proPreparationRevise.vue": [
		2015,
		21
	],
	"./commonPage/projectManage/projectPreparation.vue": [
		2016,
		188
	],
	"./commonPage/projectManage/projectQueryList.vue": [
		2017,
		361
	],
	"./commonProjectModifyList.vue": [
		2018,
		183
	],
	"./customer/supplierBlackList.vue": [
		2021,
		358
	],
	"./customer/supplierDetails.vue": [
		2022,
		357
	],
	"./customer/supplierEdit.vue": [
		2023,
		144
	],
	"./customer/supplierList.vue": [
		2024,
		356
	],
	"./customerData/beRecordData.vue": [
		2019,
		360
	],
	"./customerData/partyAdata.vue": [
		2020,
		359
	],
	"./datav/biz.vue": [
		762,
		8
	],
	"./datav/index.vue": [
		763,
		7
	],
	"./dataview/bizCompasition.vue": [
		764,
		0
	],
	"./dataview/customer.vue": [
		749,
		4
	],
	"./dataview/index.vue": [
		765,
		1
	],
	"./dataview/pm.vue": [
		750,
		3
	],
	"./dataview/project-index.vue": [
		751,
		2
	],
	"./designData/designData.vue": [
		694
	],
	"./devtest/ProtoMessageBox.vue": [
		2025,
		355
	],
	"./devtest/ProtoSelectBank.vue": [
		2026,
		354
	],
	"./devtest/ProtoSelectCompanyAndOperations.vue": [
		2027,
		353
	],
	"./devtest/ProtoUploadIdCard.vue": [
		1735,
		352
	],
	"./devtest/TestBackUserSelectWidget.vue": [
		2028,
		254
	],
	"./devtest/TestBankInfoSelectOrCreateWidget.vue": [
		2029,
		165
	],
	"./devtest/TestBranchSelectOrCreateWidget.vue": [
		2030,
		253
	],
	"./devtest/TestBusinessIntroducerSelectOrCreateWidget.vue": [
		2031,
		252
	],
	"./devtest/TestChiefInspSelectWidget.vue": [
		2032,
		250
	],
	"./devtest/TestCompanySelectWidget.vue": [
		2033,
		249
	],
	"./devtest/TestContractSelectWidget.vue": [
		2034,
		206
	],
	"./devtest/TestCustomerSelectOrCreateWidget.vue": [
		2035,
		248
	],
	"./devtest/TestDColumnAmount.vue": [
		2036,
		267
	],
	"./devtest/TestDColumnChooseXmCompany.vue": [
		2037,
		247
	],
	"./devtest/TestDColumnDatePicker.vue": [
		2038,
		266
	],
	"./devtest/TestDModal.vue": [
		2039,
		245
	],
	"./devtest/TestDistrictIndex.vue": [
		2040,
		239
	],
	"./devtest/TestEngineering.vue": [
		2041,
		178
	],
	"./devtest/TestFileAttachUpload.vue": [
		2042,
		201
	],
	"./devtest/TestFileUploadWidget.vue": [
		2043,
		230
	],
	"./devtest/TestIntroducerRelationView.vue": [
		2044,
		212
	],
	"./devtest/TestManContractSelectWidget.vue": [
		2045,
		227
	],
	"./devtest/TestNewSelectOperationWidget.vue": [
		2046,
		226
	],
	"./devtest/TestNewSelectOrCreateBankWidget.vue": [
		2047,
		225
	],
	"./devtest/TestOperationCenterSelectOrCreateWidget.vue": [
		2048,
		224
	],
	"./devtest/TestProjectSelectWidget.vue": [
		2049,
		220
	],
	"./devtest/TestUploadIdCard.vue": [
		2050,
		213
	],
	"./ed/EDContractList.vue": [
		2051,
		288
	],
	"./ed/stylist.vue": [
		2052,
		287
	],
	"./eliteData/directorData.vue": [
		2053,
		351
	],
	"./eliteData/holdCertificateData.vue": [
		2054,
		350
	],
	"./engineeringData/abnormalData.vue": [
		695
	],
	"./engineeringData/collectData.vue": [
		696
	],
	"./engineeringData/pollingData.vue": [
		697
	],
	"./engineeringData/sendOrdersData.vue": [
		698
	],
	"./enumPage/dicContent.vue": [
		1736,
		114
	],
	"./enumPage/dicSearch.vue": [
		1737,
		349
	],
	"./enumPage/talentType.vue": [
		1738,
		348
	],
	"./fd/FDAddTurnoverView.vue": [
		2055,
		347
	],
	"./fd/FDTurnoverClaimView.vue": [
		2056,
		462
	],
	"./fee/FeeApplicationView01.vue": [
		2057,
		461
	],
	"./fee/FeeApplicationView02.vue": [
		2058,
		460
	],
	"./fee/FeeApplicationView03.vue": [
		2059,
		459
	],
	"./fee/FeeApplicationView04.vue": [
		2060,
		458
	],
	"./fee/FeeApplicationView05.vue": [
		2061,
		457
	],
	"./fee/FeeApplicationView06.vue": [
		2062,
		456
	],
	"./fee/FeeApplicationView07.vue": [
		2063,
		455
	],
	"./fee/FeeApplicationView08.vue": [
		2064,
		454
	],
	"./fee/FeeApplicationView09.vue": [
		2065,
		453
	],
	"./fee/FeeApplicationView10.vue": [
		2066,
		452
	],
	"./fee/FeeApplicationView11.vue": [
		2067,
		451
	],
	"./fee/FeeApplicationView12.vue": [
		2068,
		450
	],
	"./fee/FeeApplicationView13.vue": [
		2069,
		449
	],
	"./fee/FeeApplicationView14.vue": [
		2070,
		448
	],
	"./fee/FeeApplicationView15.vue": [
		2071,
		447
	],
	"./fee/FeeApplicationView16.vue": [
		2072,
		446
	],
	"./fee/FeeApplicationView17.vue": [
		2073,
		445
	],
	"./fee/FeeApplicationView18.vue": [
		2074,
		444
	],
	"./fee/FeeApplicationView19.vue": [
		2075,
		443
	],
	"./fee/FeeApplicationView20.vue": [
		2076,
		442
	],
	"./fee/FeeApplicationView21.vue": [
		2077,
		441
	],
	"./fee/FeeApplicationView22.vue": [
		2078,
		440
	],
	"./fee/FeeApplicationView23.vue": [
		2079,
		439
	],
	"./fileh5.vue": [
		699
	],
	"./finance/FinanceFinanceIncomeEditView.vue": [
		2086,
		123
	],
	"./finance/FinanceFinanceIncomeIndexView.vue": [
		2087,
		286
	],
	"./finance/FinanceInvoiceEditView.vue": [
		2088,
		205
	],
	"./finance/FinanceXmFinanceItemEditView.vue": [
		2089,
		149
	],
	"./finance/FinanceXmFinanceItemIndexView.vue": [
		2090,
		341
	],
	"./finance/insuranceAdd.vue": [
		2091,
		105
	],
	"./finance/insuranceDetail.vue": [
		2092,
		151
	],
	"./finance/insuranceList.vue": [
		2093,
		140
	],
	"./finance/insuranceList2.vue": [
		2094,
		139
	],
	"./financeD/FinanceDXMFeeDesignEditView.vue": [
		2080,
		346
	],
	"./financeD/FinanceDXMFeeDesignIndexView.vue": [
		2081,
		115
	],
	"./financeD/FinanceDXMIncomeCal1View.vue": [
		2082,
		345
	],
	"./financeD/FinanceDXMIncomeCal2View.vue": [
		2083,
		344
	],
	"./financeD/FinanceDXMIncomeCal3View.vue": [
		2084,
		343
	],
	"./financeD/FinanceDXMIncomeCal4View.vue": [
		2085,
		342
	],
	"./financialData/closeAccountsData.vue": [
		700
	],
	"./financialData/dealWithData.vue": [
		701
	],
	"./financialData/receivableData.vue": [
		702
	],
	"./financialData/waterData.vue": [
		703
	],
	"./fm/FMAddDeduction.vue": [
		2095,
		340
	],
	"./fm/FMAddTurnoverView.vue": [
		2096,
		339
	],
	"./fm/FMContractEditView.vue": [
		2097,
		19
	],
	"./fm/FMDeductionDetail.vue": [
		2098,
		285
	],
	"./fm/FMDeductionList.vue": [
		2099,
		284
	],
	"./fm/FMDeductionList2.vue": [
		2100,
		283
	],
	"./fm/FMFinanceIncomeEditView.vue": [
		2101,
		41
	],
	"./fm/FMFinanceIncomeIndexView.vue": [
		2102,
		338
	],
	"./fm/FMFinanceIncomeIndexView2.vue": [
		2103,
		337
	],
	"./fm/FMFinanceIncomeReadView.vue": [
		2104,
		40
	],
	"./fm/FMPayEditView.vue": [
		2105,
		38
	],
	"./fm/FMPayIndexView.vue": [
		2106,
		219
	],
	"./fm/FMSealDetail.vue": [
		2107,
		282
	],
	"./fm/FMSealList.vue": [
		2108,
		182
	],
	"./fm/FMStatPmReadView.vue": [
		2109,
		63
	],
	"./fm/FMStatProjectIndexView.vue": [
		2110,
		181
	],
	"./fm/FMStatProjectReadView.vue": [
		2111,
		55
	],
	"./fm/FMStatProjectReadView2.vue": [
		2112,
		54
	],
	"./fm/FMTurnoverClaimView.vue": [
		2113,
		438
	],
	"./fm/FMVoidRecord.vue": [
		2114,
		281
	],
	"./fm/FMVoidRecordDetail.vue": [
		2115,
		168
	],
	"./fm/FMXmFinanceItemEditView.vue": [
		2116,
		148
	],
	"./fm/FMXmFinanceItemIndexView.vue": [
		2117,
		336
	],
	"./fm/FMcontractData.vue": [
		2118,
		280
	],
	"./fm/FinishProjectIndexView.vue": [
		2119,
		279
	],
	"./fm/FmAddEntryTicket.vue": [
		2120,
		335
	],
	"./fm/FmAddOutPutTicket.vue": [
		2121,
		45
	],
	"./fm/FmDelOutPutTIcketList.vue": [
		2122,
		278
	],
	"./fm/FmEditOutPutTicket.vue": [
		2123,
		44
	],
	"./fm/FmEntryTicket.vue": [
		2124,
		334
	],
	"./fm/FmEntryTicketDetail.vue": [
		2125,
		277
	],
	"./fm/FmOutPutTicket.vue": [
		2126,
		276
	],
	"./fm/FmOutPutTicket2.vue": [
		2127,
		275
	],
	"./fm/FmOutPutTicketDetail.vue": [
		2128,
		167
	],
	"./fm/FmRedPunch.vue": [
		2129,
		104
	],
	"./fm/PlatformMaterials.vue": [
		1731,
		333
	],
	"./fm/TransferOutIndexView.vue": [
		2130,
		164
	],
	"./fm/prepaidTax.vue": [
		2131,
		332
	],
	"./fm/prepaidTaxDetail.vue": [
		2132,
		150
	],
	"./fm/prepaidTaxForm.vue": [
		2133,
		74
	],
	"./fm/prepaidTaxPrint.vue": [
		2134,
		331
	],
	"./fm/printOutPutTicket.vue": [
		2135,
		330
	],
	"./fm/receiptConfirmation.vue": [
		2136,
		329
	],
	"./information/DataManageView.vue": [
		2137,
		274
	],
	"./information/InfoIntroducemanView.vue": [
		2138,
		273
	],
	"./information/InfoMainteamView.vue": [
		2139,
		437
	],
	"./information/InfoSecondteamView.vue": [
		2140,
		436
	],
	"./information/InfoTeamView.vue": [
		2141,
		156
	],
	"./information/IntroducerAddView.vue": [
		2142,
		136
	],
	"./information/ProjectHistoryView.vue": [
		2143,
		328
	],
	"./information/RewardsPunishView.vue": [
		2144,
		272
	],
	"./information/TeamEditView.vue": [
		2145,
		162
	],
	"./information/TrackView.vue": [
		2146,
		211
	],
	"./mm/MMcontractData.vue": [
		2147,
		271
	],
	"./operation/ProjectDataReport.vue": [
		2154,
		223
	],
	"./operation/SyntheticData.vue": [
		2155,
		218
	],
	"./operation/operationStatisticsIndexView.vue": [
		2156,
		101
	],
	"./operationData/biddingData.vue": [
		2148,
		180
	],
	"./operationData/bidsData.vue": [
		705
	],
	"./operationData/initiateData.vue": [
		2149,
		327
	],
	"./operationData/loseData.vue": [
		2150,
		326
	],
	"./operationData/projectData.vue": [
		2151,
		135
	],
	"./operationData/signedData.vue": [
		706
	],
	"./operationData/syntheticData.vue": [
		2152,
		81
	],
	"./operationData/tenderData.vue": [
		2153,
		138
	],
	"./operationDataH5/syntheticDataH5.vue": [
		704
	],
	"./pdfView/index.vue": [
		766,
		5
	],
	"./personaldata/CMPersonalDataView.vue": [
		2157,
		85
	],
	"./personaldata/PmPersonalDataView.vue": [
		2158,
		84
	],
	"./pm/PMAddandeditView.vue": [
		2159,
		39
	],
	"./pm/PMChangePasswordView.vue": [
		2160,
		325
	],
	"./pm/PMConstructingProjectsView.vue": [
		2161,
		324
	],
	"./pm/PMFeeHistoryView.vue": [
		2162,
		435
	],
	"./pm/PMFeeIndexView.vue": [
		2163,
		323
	],
	"./pm/PMMessageView.vue": [
		2164,
		270
	],
	"./pm/PMPersonalDataView.vue": [
		2165,
		51
	],
	"./pm/PMPreparationView.vue": [
		2166,
		434
	],
	"./pm/PMRewardsPunishView.vue": [
		2167,
		269
	],
	"./pm/PMStatisticsView.vue": [
		2168,
		322
	],
	"./pm/PMTurnoverClaimView.vue": [
		2169,
		433
	],
	"./pm/frozenList.vue": [
		2170,
		268
	],
	"./pm/pmComplaintList.vue": [
		2171,
		321
	],
	"./pm/pmInjuriesList.vue": [
		2172,
		320
	],
	"./pm/workerManage/workerDetail.vue": [
		2173,
		229
	],
	"./pm/workerManage/workerEdit.vue": [
		2174,
		119
	],
	"./pm/workerManage/workerList.vue": [
		2175,
		187
	],
	"./process/CommonFinanceIncomeReadView.vue": [
		2176,
		102
	],
	"./process/ProcessGetMoneyFromBankReadView.vue": [
		2177,
		319
	],
	"./process/ProjectManagerAuditView.vue": [
		2178,
		96
	],
	"./process/ProjectManagerReadView.vue": [
		2179,
		95
	],
	"./projectManagerView.vue": [
		2180,
		155
	],
	"./sellingData/sellingData.vue": [
		707
	],
	"./sendOrders/sendOrdersQuery.vue": [
		2181,
		318
	],
	"./springboot/adminConsoleView.vue": [
		2182,
		431
	],
	"./supervisor/supervisorContractIndex.vue": [
		2183,
		317
	],
	"./welcomeView.vue": [
		708
	],
	"./zhotyFinance/ZFApplyOtherMallEditView.vue": [
		2184,
		260
	],
	"./zhotyFinance/ZFApplyOtherMallIndexView.vue": [
		2185,
		432
	],
	"./zhotyFinance/ZFApplyOtherMallReadView.vue": [
		2186,
		259
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = 1722;

/***/ }),

/***/ 1723:
/***/ (function(module, exports) {

module.exports = {"type":"FeatureCollection","features":[{"type":"Feature","id":"710000","properties":{"id":"710000","cp":[121.509062,24.044332],"name":"台湾","childNum":6},"geometry":{"type":"MultiPolygon","coordinates":[["@@°Ü¯Û"],["@@ƛĴÕƊÉɼģºðʀ\\ƎsÆNŌÔĚänÜƤɊĂǀĆĴĤǊŨxĚĮǂƺòƌâÔ®ĮXŦţƸZûÐƕƑGđ¨ĭMó·ęcëƝɉlÝƯֹÅŃ^Ó·śŃǋƏďíåɛGɉ¿@ăƑ¥ĘWǬÏĶŁâ"],["@@\\p|WoYG¿¥Ij@¢"],["@@¡@V^RqBbAnTXeRz¤L«³I"],["@@ÆEEkWqë @"],["@@fced"],["@@¯ɜÄèaì¯ØǓIġĽ"],["@@çûĖëĄhòř "]],"encodeOffsets":[[[122886,24033]],[[123335,22980]],[[122375,24193]],[[122518,24117]],[[124427,22618]],[[124862,26043]],[[126259,26318]],[[127671,26683]]]}},{"type":"Feature","id":"130000","properties":{"id":"130000","cp":[114.502461,38.045474],"name":"河北","childNum":3},"geometry":{"type":"MultiPolygon","coordinates":[["@@o~Z]ªrºc_ħ²G¼s`jÎŸnüsÂłNX_M`Ç½ÓnUKĜēs¤­©yrý§uģcJe"],["@@U`Ts¿mÂ"],["@@oºƋÄdeVDJj£J|ÅdzÂFt~KŨ¸IÆv|¢r}èonb}`RÎÄn°ÒdÞ²^®lnÐèĄlðÓ×]ªÆ}LiĂ±Ö`^°Ç¶p®đDcŋ`ZÔ¶êqvFÆN®ĆTH®¦O¾IbÐã´BĐɢŴÆíȦpĐÞXR·nndO¤OÀĈƒ­QgµFo|gȒęSWb©osx|hYhgŃfmÖĩnºTÌSp¢dYĤ¶UĈjlǐpäìë|³kÛfw²Xjz~ÂqbTÑěŨ@|oMzv¢ZrÃVw¬ŧĖ¸f°ÐTªqs{S¯r æÝlNd®²Ğ ǆiGĘJ¼lr}~K¨ŸƐÌWöÆzR¤lêmĞLÎ@¡|q]SvKÑcwpÏÏĿćènĪWlĄkT}J¤~ÈTdpddʾĬBVtEÀ¢ôPĎƗè@~kü\\rÊĔÖæW_§¼F´©òDòjYÈrbĞāøŀG{ƀ|¦ðrb|ÀH`pʞkvGpuARhÞÆǶgĘTǼƹS£¨¡ù³ŘÍ]¿ÂyôEP xX¶¹ÜO¡gÚ¡IwÃé¦ÅBÏ|Ç°N«úmH¯âDùyŜŲIÄuĐ¨D¸dɂFOhđ©OiÃ`ww^ÌkÑH«ƇǤŗĺtFu{Z}Ö@U´ʚLg®¯Oı°Ãw ^VbÉsmAê]]w§RRl£ȭµu¯b{ÍDěïÿȧuT£ġěŗƃĝQ¨fVƋƅn­a@³@ďyÃ½IĹÊKŭfċŰóxV@tƯJ]eR¾fe|rHA|h~Ėƍl§ÏlTíb ØoÅbbx³^zÃĶ¶Sj®AyÂhðk`«PËµEFÛ¬Y¨Ļrõqi¼Wi°§Ð±´°^[À|ĠO@ÆxO\\ta\\tĕtû{ġȧXýĪÓjùÎRb^ÎfK[ÝděYfíÙTyuUSyŌŏů@Oi½éŅ­aVcř§ax¹XŻácWU£ôãºQ¨÷Ñws¥qEHÙ|šYQoŕÇyáĂ£MÃ°oťÊP¡mWO¡v{ôvîēÜISpÌhp¨ jdeŔQÖjX³àĈ[n`Yp@UcM`RKhEbpŞlNut®EtqnsÁgAiúoHqCXhfgu~ÏWP½¢G^}¯ÅīGCÑ^ãziMáļMTÃƘrMc|O_¯Ŏ´|morDkO\\mĆJfl@cĢ¬¢aĦtRıÒ¾ùƀ^juųœK­UFyƝīÛ÷ąV×qƥV¿aȉd³BqPBmaËđŻģmÅ®V¹d^KKonYg¯XhqaLdu¥Ípǅ¡KąÅkĝęěhq}HyÃ]¹ǧ£Í÷¿qáµ§g¤o^á¾ZE¤i`ĳ{nOl»WÝĔįhgF[¿¡ßkOüš_ūiǱàUtėGyl}ÓM}jpEC~¡FtoQiHkk{Ãmï"]],"encodeOffsets":[[[119712,40641]],[[121616,39981]],[[116462,37237]]]}},{"type":"Feature","id":"140000","properties":{"id":"140000","cp":[111.849248,36.857014],"name":"山西","childNum":1},"geometry":{"type":"Polygon","coordinates":["@@ÞĩÒSra}ÁyWix±Üe´lèßÓǏokćiµVZģ¡coTSË¹ĪmnÕńehZg{gtwªpXaĚThȑp{¶Eh®RćƑP¿£Pmc¸mQÝWďȥoÅîɡųAďä³aÏJ½¥PG­ąSM­EÅruµéYÓŌ_dĒCo­Èµ]¯_²ÕjāK~©ÅØ^ÔkïçămÏk]­±cÝ¯ÑÃmQÍ~_apm~ç¡qu{JÅŧ·Ls}EyÁÆcI{¤IiCfUcƌÃp§]ě«vD@¡SÀµMÅwuYY¡DbÑc¡h×]nkoQdaMç~eDÛtT©±@¥ù@É¡ZcW|WqOJmĩl«ħşvOÓ«IqăV¥D[mI~Ó¢cehiÍ]Ɠ~ĥqX·eƷn±}v[ěďŕ]_œ`¹§ÕōIo©b­s^}Ét±ū«³p£ÿ·Wµ|¡¥ăFÏs×¥ŅxÊdÒ{ºvĴÎêÌɊ²¶ü¨|ÞƸµȲLLúÉƎ¤ϊęĔV`_bªS^|dzY|dz¥pZbÆ£¶ÒK}tĦÔņƠPYznÍvX¶Ěn ĠÔzý¦ª÷ÑĸÙUȌ¸dòÜJð´ìúNM¬XZ´¤ŊǸ_tldI{¦ƀðĠȤ¥NehXnYGR° ƬDj¬¸|CĞKqºfƐiĺ©ª~ĆOQª ¤@ìǦɌ²æBÊTŸʂōĖĴŞȀÆÿȄlŤĒötÎ½î¼ĨXh|ªM¤Ðz"],"encodeOffsets":[[116874,41716]]}},{"type":"Feature","id":"150000","properties":{"id":"150000","cp":[111.670801,41.818311],"name":"内蒙古","childNum":2},"geometry":{"type":"MultiPolygon","coordinates":[["@@¯PqFB|S³C|kñHdiÄ¥sŉÅPóÑÑE^ÅPpy_YtShQ·aHwsOnŉÃs©iqjUSiº]ïW«gW¡ARë¥_sgÁnUI«m]jvV¼euhwqAaW_µj»çjioQR¹ēÃßt@r³[ÛlćË^ÍÉáGOUÛOB±XkÅ¹£k|e]olkVÍ¼ÕqtaÏõjgÁ£§U^RLËnX°ÇBz^~wfvypV ¯ƫĉ˭ȫƗŷɿÿĿƑ˃ĝÿÃǃßËőó©ǐȍŒĖM×ÍEyxþp]ÉvïèvƀnÂĴÖ@V~Ĉv¦wĖtējyÄDXÄxGQuv_i¦aBçw˛wD©{tāmQ{EJ§KPśƘƿ¥@sCTÉ}ɃwƇy±gÑ}T[÷kÐç¦«SÒ¥¸ëBX½HáÅµÀğtSÝÂa[ƣ°¯¦Pï¡]£ġÒk®G²èQ°óMq}EóƐÇ\\@áügQÍu¥FTÕ¿Jû]|mvāÎYua^WoÀa·­ząÒot×¶CLƗi¯¤mƎHǊ¤îìɾŊìTdåwsRÖgĒųúÍġäÕ}Q¶¿A[¡{d×uQAMxVvMOmăl«ct[wº_ÇÊjbÂ£ĦS_éQZ_lwgOiýe`YYLq§IÁǳ£ÙË[ÕªuƏ³ÍTs·bÁĽäė[b[ŗfãcn¥îC¿÷µ[ŏÀQ­ōĉm¿Á^£mJVmL[{Ï_£F¥Ö{ŹA}×Wu©ÅaųĳƳhB{·TQqÙIķËZđ©Yc|M¡LeVUóK_QWk_ĥ¿ãZ»X\\ĴuUèlG®ěłTĠğDŃOrÍdÆÍz]±ŭ©Å]ÅÐ}UË¥©TċïxgckfWgi\\ÏĒ¥HkµEë{»ÏetcG±ahUiñiWsɁ·cCÕk]wȑ|ća}wVaĚá G°ùnM¬¯{ÈÐÆA¥ÄêJxÙ¢hP¢ÛºµwWOóFÁz^ÀŗÎú´§¢T¤ǻƺSėǵhÝÅQgvBHouʝl_o¿Ga{ïq{¥|ſĿHĂ÷aĝÇqZñiñC³ª»E`¨åXēÕqÉû[l}ç@čƘóO¿¡FUsAʽīccocÇS}£IS~ălkĩXçmĈŀÐoÐdxÒuL^T{r@¢ÍĝKén£kQyÅõËXŷƏL§~}kq»IHėǅjĝ»ÑÞoå°qTt|r©ÏS¯·eŨĕx«È[eM¿yupN~¹ÏyN£{©għWí»Í¾səšǅ_ÃĀɗ±ąĳĉʍŌŷSÉA±åǥɋ@ë£R©ąP©}ĹªƏj¹erLDĝ·{i«ƫC£µsKCGS|úþXgp{ÁX¿ć{ƱȏñZáĔyoÁhA}ŅĆfdŉ_¹Y°ėǩÑ¡H¯¶oMQqð¡Ë|Ñ`ƭŁX½·óÛxğįÅcQs«tȋǅFù^it«Č¯[hAi©á¥ÇĚ×l|¹y¯YȵƓñǙµïċĻ|Düȭ¶¡oŽäÕG\\ÄT¿Òõr¯LguÏYęRƩɷŌO\\İÐ¢æ^Ŋ ĲȶȆbÜGĝ¬¿ĚVĎgª^íu½jÿĕęjık@Ľ]ėl¥ËĭûÁėéV©±ćn©­ȇÍq¯½YÃÔŉÉNÑÅÝy¹NqáʅDǡËñ­ƁYÅy̱os§ȋµʽǘǏƬɱàưN¢ƔÊuľýľώȪƺɂļxZĈ}ÌŉŪĺœĭFЛĽ̅ȣͽÒŵìƩÇϋÿȮǡŏçƑůĕ~Ç¼ȳÐUfdIxÿ\\G zâɏÙOº·pqy£@qþ@Ǟ˽IBäƣzsÂZÁàĻdñ°ŕzéØűzșCìDȐĴĺf®Àľưø@ɜÖÞKĊŇƄ§͑těï͡VAġÑÑ»d³öǍÝXĉĕÖ{þĉu¸ËʅğU̎éhɹƆ̗̮ȘǊ֥ड़ࡰţાíϲäʮW¬®ҌeרūȠkɬɻ̼ãüfƠSצɩςåȈHϚÎKǳͲOðÏȆƘ¼CϚǚ࢚˼ФÔ¤ƌĞ̪Qʤ´¼mȠJˀƲÀɠmǐnǔĎȆÞǠN~ʢĜ¶ƌĆĘźʆȬ˪ĚĒ¸ĞGȖƴƀj`ĢçĶāàŃºēĢĖćYÀŎüôQÐÂŎŞǆŞêƖoˆDĤÕºÑǘÛˤ³̀gńƘĔÀ^ªƂ`ªt¾äƚêĦĀ¼ÐĔǎ¨Ȕ»͠^ˮÊȦƤøxRrŜH¤¸ÂxDÄ|ø˂˜ƮÐ¬ɚwɲFjĔ²Äw°ǆdÀÉ_ĸdîàŎjÊêTĞªŌŜWÈ|tqĢUB~´°ÎFCU¼pĀēƄN¦¾O¶łKĊOjĚj´ĜYp{¦SĚÍ\\T×ªV÷Ší¨ÅDK°ßtŇĔK¨ǵÂcḷ̌ĚǣȄĽFlġUĵŇȣFʉɁMğįʏƶɷØŭOǽ«ƽū¹Ʊő̝Ȩ§ȞʘĖiɜɶʦ}¨֪ࠜ̀ƇǬ¹ǨE˦ĥªÔêFxúQEr´Wrh¤Ɛ \\talĈDJÜ|[Pll̚¸ƎGú´P¬W¦^¦H]prRn|or¾wLVnÇIujkmon£cX^Bh`¥V¦U¤¸}xRj[^xN[~ªxQ[`ªHÆÂExx^wN¶Ê|¨ìMrdYpoRzNyÀDs~bcfÌ`L¾n|¾T°c¨È¢ar¤`[|òDŞĔöxElÖdHÀI`Ď\\Àì~ÆR¼tf¦^¢ķ¶eÐÚMptgjɡČÅyġLûŇV®ÄÈƀĎ°P|ªVVªj¬ĚÒêp¬E|ŬÂc|ÀtƐK f{ĘFĒƌXƲąo½Ę\\¥o}Ûu£ç­kX{uĩ«āíÓUŅßŢqŤ¥lyň[oi{¦LńðFȪȖĒL¿Ìf£K£ʺoqNwğc`uetOj×°KJ±qÆġmĚŗos¬qehqsuH{¸kH¡ÊRǪÇƌbȆ¢´äÜ¢NìÉʖ¦â©Ġu¦öČ^â£ĂhĖMÈÄw\\fŦ°W ¢¾luŸDw\\̀ʉÌÛMĀ[bÓEn}¶Vcês"]],"encodeOffsets":[[[129102,52189]]]}},{"type":"Feature","id":"210000","properties":{"id":"210000","cp":[123.429096,41.796767],"name":"辽宁","childNum":16},"geometry":{"type":"MultiPolygon","coordinates":[["@@L@@sa"],["@@MnNm"],["@@dc"],["@@eÀC@b"],["@@fXwkbrÄ`qg"],["@@^jtWQ"],["@@~ Y]c"],["@@G`ĔN^_¿ZÃM"],["@@iX¶BY"],["@@YZ"],["@@L_{Epf"],["@@^WqCT\\"],["@@\\[§t|¤_"],["@@m`n_"],["@@Ïxǌ{q_×^Giip"],["@@@é^BntaÊU]x ¯ÄPĲ­°hʙK³VÕ@Y~|EvĹsÇ¦­L^pÃ²ŸÒG Ël]xxÄ_fT¤Ď¤cPC¨¸TVjbgH²sdÎdHt`B²¬GJję¶[ÐhjeXdlwhðSČ¦ªVÊÏÆZÆŶ®²^ÎyÅÎcPqńĚDMħĜŁH­kçvV[ĳ¼WYÀäĦ`XlR`ôLUVfK¢{NZdĒªYĸÌÚJRr¸SA|ƴgŴĴÆbvªØX~źB|¦ÕE¤Ð`\\|KUnnI]¤ÀÂĊnŎR®Ő¿¶\\ÀøíDm¦ÎbŨabaĘ\\ľãÂ¸atÎSƐ´©v\\ÖÚÌǴ¤Â¨JKrZ_ZfjþhPkx`YRIjJcVf~sCN¤ EhæmsHy¨SðÑÌ\\\\ĐRZk°IS§fqŒßýáĞÙÉÖ[^¯ǤŲê´\\¦¬ĆPM¯£»uïpùzExanµyoluqe¦W^£ÊL}ñrkqWňûPUP¡ôJoo·U}£[·¨@XĸDXm­ÛÝºGUCÁª½{íĂ^cjk¶Ã[q¤LÉö³cux«zZf²BWÇ®Yß½ve±ÃCý£W{Ú^q^sÑ·¨ÍOt¹·C¥GDrí@wÕKţÃ«V·i}xËÍ÷i©ĝɝǡ]{c±OW³Ya±_ç©HĕoƫŇqr³Lys[ñ³¯OSďOMisZ±ÅFC¥Pq{Ã[Pg}\\¿ghćOk^ģÁFıĉĥM­oEqqZûěŉ³F¦oĵhÕP{¯~TÍlªNßYÐ{Ps{ÃVUeĎwk±ŉVÓ½ŽJãÇÇ»Jm°dhcÀffdF~ĀeĖd`sx² ®EżĀdQÂd^~ăÔH¦\\LKpĄVez¤NP ǹÓRÆąJSh­a[¦´ÂghwmBÐ¨źhI|VV|p] Â¼èNä¶ÜBÖ¼L`¼bØæKVpoúNZÞÒKxpw|ÊEMnzEQIZZNBčÚFÜçmĩWĪñtÞĵÇñZ«uD±|Əlĳ¥ãn·±PmÍada CLǑkùó¡³Ï«QaċÏOÃ¥ÕđQȥċƭy³ÃA"]],"encodeOffsets":[[[123686,41445]],[[126019,40435]],[[124393,40128]],[[126117,39963]],[[125322,40140]],[[126686,40700]],[[126041,40374]],[[125584,40168]],[[125453,40165]],[[125362,40214]],[[125280,40291]],[[125774,39997]],[[125976,40496]],[[125822,39993]],[[125509,40217]],[[122731,40949]]]}},{"type":"Feature","id":"220000","properties":{"id":"220000","cp":[125.3245,43.886841],"name":"吉林","childNum":1},"geometry":{"type":"Polygon","coordinates":["@@pä³PClFbbÍzwBGĭZÅi»lY­ċ²SgkÇ£^Sqd¯R©é£¯S\\cZ¹iűƏCuƍÓXoR}M^o£R}oªU­FuuXHlEÅÏ©¤ÛmTþ¤D²ÄufàÀ­XXÈ±AeyYw¬dvõ´KÊ£\\rµÄlidā]|î©¾DÂVH¹Þ®ÜWnCķ W§@\\¸~¤Vp¸póIO¢VOŇürXql~òÉK]¤¥Xrfkvzpm¶bwyFoúvð¼¤ N°ąO¥«³[éǡű_°Õ\\ÚÊĝþâőàerR¨­JYlďQ[ ÏYëÐ§TGztnß¡gFkMāGÁ¤ia ÉÈ¹`\\xs¬dĆkNnuNUuP@vRY¾\\¢GªóĄ~RãÖÎĢùđŴÕhQxtcæëSɽŉíëǉ£ƍG£nj°KƘµDsØÑpyĆ¸®¿bXp]vbÍZuĂ{n^IüÀSÖ¦EvRÎûh@â[ƏÈô~FNr¯ôçR±­HÑlĢ^¤¢OðævxsŒ]ÞÁTĠs¶¿âÆGW¾ìA¦·TÑ¬è¥ÏÐJ¨¼ÒÖ¼ƦɄxÊ~StD@Ă¼Ŵ¡jlºWvÐzƦZÐ²CH AxiukdGgetqmcÛ£Ozy¥cE}|¾cZk¿uŐã[oxGikfeäT@SUwpiÚFM©£è^Ú`@v¶eňf heP¶täOlÃUgÞzŸU`l}ÔÆUvØ_Ō¬Öi^ĉi§²ÃB~¡ĈÚEgc|DC_Ȧm²rBx¼MÔ¦ŮdĨÃâYxƘDVÇĺĿg¿cwÅ\\¹¥Yĭl¤OvLjM_a W`zļMž·\\swqÝSAqŚĳ¯°kRē°wx^ĐkǂÒ\\]nrĂ}²ĊŲÒøãh·M{yMzysěnĒġV·°G³¼XÀ¤¹i´o¤ŃÈ`ÌǲÄUĞd\\iÖmÈBĤÜɲDEh LG¾ƀÄ¾{WaYÍÈĢĘÔRîĐj}ÇccjoUb½{h§Ǿ{KƖµÎ÷GĀÖŠåưÎs­lyiē«`å§H¥Ae^§GK}iã\\c]v©ģZmÃ|[M}ģTɟĵÂÂ`ÀçmFK¥ÚíÁbX³ÌQÒHof{]ept·GŋĜYünĎųVY^ydõkÅZW«WUa~U·SbwGçǑiW^qFuNĝ·EwUtW·Ýďæ©PuqEzwAVXRãQ`­©GMehccďÏd©ÑW_ÏYƅ»é\\ɹ~ǙG³mØ©BšuT§Ĥ½¢Ã_Ã½L¡ýqT^rme\\PpZZbyuybQefµ]UhĿDCmûvaÙNSkCwncćfv~YÇG"],"encodeOffsets":[[130196,42528]]}},{"type":"Feature","id":"230000","properties":{"id":"230000","cp":[128.642464,46.756967],"name":"黑龙江","childNum":2},"geometry":{"type":"MultiPolygon","coordinates":[["@@UµNÿ¥īèçHÍøƕ¶Lǽ|g¨|a¾pVidd~ÈiíďÓQġėÇZÎXb½|ſÃH½KFgɱCģÛÇAnjÕc[VĝǱÃËÇ_ £ń³pj£º¿»WH´¯U¸đĢmtĜyzzNN|g¸÷äűÑ±ĉā~mq^[ǁÑďlw]¯xQĔ¯l°řĴrBÞTxr[tŽ¸ĻN_yX`biNKuP£kZĮ¦[ºxÆÀdhĹŀUÈƗCwáZħÄŭcÓ¥»NAw±qȥnD`{ChdÙFć}¢A±Äj¨]ĊÕjŋ«×`VuÓÅ~_kŷVÝyhVkÄãPsOµfgeŇµf@u_Ù ÙcªNªÙEojVxT@ãSefjlwH\\pŏäÀvlY½d{F~¦dyz¤PÜndsrhfHcvlwjF£G±DÏƥYyÏu¹XikĿ¦ÏqƗǀOŜ¨LI|FRĂn sª|C˜zxAè¥bfudTrFWÁ¹Am|ĔĕsķÆF´N}ćUÕ@Áĳſmuçuð^ÊýowFzØÎĕNőǏȎôªÌŒǄàĀÄ˄ĞŀƒʀĀƘŸˮȬƬĊ°Uzouxe]}AyÈW¯ÌmKQ]Īºif¸ÄX|sZt|½ÚUÎ lk^p{f¤lºlÆW A²PVÜPHÊâ]ÎĈÌÜk´\\@qàsĔÄQºpRij¼èi`¶bXrBgxfv»uUi^v~J¬mVp´£´VWrnP½ì¢BX¬hðX¹^TjVriªjtŊÄmtPGx¸bgRsT`ZozÆO]ÒFôÒOÆŊvÅpcGêsx´DR{AEOr°x|íb³Wm~DVjºéNNËÜ˛ɶ­GxŷCSt}]ûōSmtuÇÃĕNāg»íT«u}ç½BĵÞʣ¥ëÊ¡MÛ³ãȅ¡ƋaǩÈÉQG¢·lG|tvgrrf«ptęŘnÅĢrI²¯LiØsPf_vĠdxM prʹL¤¤eËÀđKïÙVY§]Ióáĥ]ķK¥j|pŇ\\kzţ¦šnņäÔVĂîĪ¬|vW®l¤èØrxm¶ă~lÄƯĄ̈́öȄEÔ¤ØQĄĄ»ƢjȦOǺ¨ìSŖÆƬyQv`cwZSÌ®ü±Ǆ]ŀç¬B¬©ńzƺŷɄeeOĨSfm ĊƀP̎ēz©ĊÄÕÊmgÇsJ¥ƔŊśæÎÑqv¿íUOµªÂnĦÁ_½ä@êí£P}Ġ[@gġ}gɊ×ûÏWXá¢užƻÌsNÍ½ƎÁ§čŐAēeL³àydl¦ĘVçŁpśǆĽĺſÊQíÜçÛġÔsĕ¬Ǹ¯YßċġHµ ¡eå`ļrĉŘóƢFìĎWøxÊkƈdƬv|I|·©NqńRŀ¤éeŊŀàŀU²ŕƀBQ£Ď}L¹Îk@©ĈuǰųǨÚ§ƈnTËÇéƟÊcfčŤ^XmHĊĕË«W·ċëx³ǔķÐċJāwİ_ĸȀ^ôWr­°oú¬ĦŨK~ȰCĐ´Ƕ£fNÎèâw¢XnŮeÂÆĶ¾¾xäLĴĘlļO¤ÒĨA¢Êɚ¨®ØCÔ ŬGƠƦYĜĘÜƬDJg_ͥœ@čŅĻA¶¯@wÎqC½Ĉ»NăëKďÍQÙƫ[«ÃígßÔÇOÝáWñuZ¯ĥŕā¡ÑķJu¤E å¯°WKÉ±_d_}}vyõu¬ï¹ÓU±½@gÏ¿rÃ½DgCdµ°MFYxw¿CG£Rƛ½Õ{]L§{qqą¿BÇƻğëܭǊË|c²}Fµ}ÙRsÓpg±QNqǫŋRwŕnéÑÉK«SeYRŋ@{¤SJ}D Ûǖ֍]gr¡µŷjqWÛham³~S«Þ]"]],"encodeOffsets":[[[134456,44547]]]}},{"type":"Feature","id":"320000","properties":{"id":"320000","cp":[119.767413,33.041544],"name":"江苏","childNum":1},"geometry":{"type":"Polygon","coordinates":["@@cþÅPi`ZRu¥É\\]~°Y`µÓ^phÁbnÀşúòaĬºTÖŒbe¦¦{¸ZâćNp©Hr|^mjhSEb\\afv`sz^lkljÄtg¤D­¾X¿À|ĐiZȀåB·î}GL¢õcßjayBFµÏC^ĭcÙt¿sğH]j{s©HM¢QnDÀ©DaÜÞ·jgàiDbPufjDk`dPOîhw¡ĥ¥GP²ĐobºrYî¶aHŢ´ ]´rılw³r_{£DB_Ûdåuk|Ũ¯F Cºyr{XFye³Þċ¿ÂkĭB¿MvÛpm`rÚã@Ę¹hågËÖƿxnlč¶Åì½Ot¾dJlVJĂǀŞqvnO^JZż·Q}êÍÅmµÒ]ƍ¦Dq}¬R^èĂ´ŀĻĊIÔtĲyQŐĠMNtR®òLhĚs©»}OÓGZz¶A\\jĨFäOĤHYJvÞHNiÜaĎÉnFQlNM¤B´ĄNöɂtpŬdfåqm¿QûùŞÚb¤uŃJŴu»¹ĄlȖħŴw̌ŵ²ǹǠ͛hĭłƕrçü±Yxcitğ®jű¢KOķCoy`å®VTa­_Ā]ŐÝɞï²ʯÊ^]afYǸÃĆēĪȣJđ͍ôƋÄÄÍīçÛɈǥ£­ÛmY`ó£Z«§°Ó³QafusNıǅ_k}¢m[ÝóDµ¡RLčiXyÅNïă¡¸iĔÏNÌŕoēdōîåŤûHcs}~Ûwbù¹£¦ÓCtOPrE^ÒogĉIµÛÅʹK¤½phMü`oæŀ"],"encodeOffsets":[[121740,32276]]}},{"type":"Feature","id":"330000","properties":{"id":"330000","cp":[120.153576,29.287459],"name":"浙江","childNum":45},"geometry":{"type":"MultiPolygon","coordinates":[["@@E^dQ]K"],["@@jX^j"],["@@sfbU"],["@@qP\\xz[ck"],["@@R¢FX}°[s_"],["@@Cb\\}"],["@@e|v\\la{u"],["@@v~u}"],["@@QxÂF¯}"],["@@¹nvÞs¯o"],["@@rSkUEj"],["@@bi­ZP"],["@@p[}INf"],["@@À¿"],["@@¹dnb"],["@@rSBnR"],["@@g~h}"],["@@FlEk"],["@@OdPc"],["@@v[u\\"],["@@FjâL~wyoo~sµL\\"],["@@¬e¹aN"],["@@\\nÔ¡q]L³ë\\ÿ®QÖ"],["@@ÊA­©[¬"],["@@Kxv­"],["@@@hlIk]"],["@@pW{o||j"],["@@Md|_mC"],["@@¢X£ÏylD¼XtH"],["@@hlÜ[LykAvyfw^E¤"],["@@fp¤MusR"],["@@®_ma~LÁ¬Z"],["@@iMxZ"],["@@ZcYd"],["@@Z~dOSo|A¿qZv"],["@@@`EN¡v"],["@@|TY{"],["@@@n@m"],["@@XWkCT\\"],["@@ºwZRkĕWO¢"],["@@X®±GrÆª\\ÔáXq{"],["@@ůTG°ĄLHm°UC"],["@@¤aÜx~}dtüGæţŎíĔcŖpMËÐjē¢·ðĄÆMzjWKĎ¢Q¶À_ê_Bıi«pZgf¤Nrq]§ĂN®«H±yƳí¾×ŸīàLłčŴǝĂíÀBŖÕªÁŖHŗŉåqûõi¨hÜ·ñt»¹ýv_[«¸mYL¯QªmĉÅdMgÇjcº«ę¬­K­´B«Âącoċ\\xKd¡gěŧ«®á[~ıxu·ÅKsËÉc¢Ù\\ĭƛëbf¹­ģSĜkáƉÔ­ĈZB{aMµfzŉfåÂŧįƋǝÊĕġć£g³ne­ą»@­¦S®\\ßðChiqªĭiAuA­µ_W¥ƣO\\lċĢttC¨£t`PZäuXßBsĻyekOđġĵHuXBµ]×­­\\°®¬F¢¾pµ¼kŘó¬Wät¸|@L¨¸µrºù³Ù~§WIZW®±Ð¨ÒÉx`²pĜrOògtÁZ}þÙ]¡FKwsPlU[}¦Rvn`hq¬\\nQ´ĘRWb_ rtČFIÖkĦPJ¶ÖÀÖJĈĄTĚòC ²@PúØz©Pî¢£CÈÚĒ±hŖl¬â~nm¨f©iļ«mntuÖZÜÄjL®EÌFª²iÊxØ¨IÈhhst"],["@@o\\VzRZ}y"],["@@@°¡mÛGĕ¨§Ianá[ýƤjfæØLäGr"]],"encodeOffsets":[[[125592,31553]],[[125785,31436]],[[125729,31431]],[[125513,31380]],[[125223,30438]],[[125115,30114]],[[124815,29155]],[[124419,28746]],[[124095,28635]],[[124005,28609]],[[125000,30713]],[[125111,30698]],[[125078,30682]],[[125150,30684]],[[124014,28103]],[[125008,31331]],[[125411,31468]],[[125329,31479]],[[125626,30916]],[[125417,30956]],[[125254,30976]],[[125199,30997]],[[125095,31058]],[[125083,30915]],[[124885,31015]],[[125218,30798]],[[124867,30838]],[[124755,30788]],[[124802,30809]],[[125267,30657]],[[125218,30578]],[[125200,30562]],[[124968,30474]],[[125167,30396]],[[124955,29879]],[[124714,29781]],[[124762,29462]],[[124325,28754]],[[123990,28459]],[[125366,31477]],[[125115,30363]],[[125369,31139]],[[122495,31878]],[[125329,30690]],[[125192,30787]]]}},{"type":"Feature","id":"340000","properties":{"id":"340000","cp":[117.283042,31.26119],"name":"安徽","childNum":3},"geometry":{"type":"MultiPolygon","coordinates":[["@@^iuLX^"],["@@e©Ehl"],["@@°ZÆëĎµmkǀwÌÕæhºgBĝâqÙĊzÖgņtÀÁĂÆáhEz|WzqD¹°Eŧl{ævÜcA`¤C`|´qxĲkq^³³GšµbíZ¹qpa±ď OH¦Ħx¢gPícOl_iCveaOjChß¸iÝbÛªCC¿mRV§¢A|t^iĠGÀtÚsd]ĮÐDE¶zAb àiödK¡~H¸íæAǿYj{ď¿À½W®£ChÃsikkly]_teu[bFaTign{]GqªoĈMYá|·¥f¥őaSÕėNµñĞ«Im_m¿Âa]uĜp Z_§{Cäg¤°r[_YjÆOdý[I[á·¥Q_nùgL¾mvˊBÜÆ¶ĊJhpc¹O]iŠ]¥ jtsggJÇ§w×jÉ©±EFË­KiÛÃÕYvsm¬njĻª§emná}k«ŕgđ²ÙDÇ¤í¡ªOy×Où±@DñSęćăÕIÕ¿IµĥOjNÕËT¡¿tNæŇàåyķrĕq§ÄĩsWÆßF¶X®¿mwRIÞfßoG³¾©uyHį{Ɓħ¯AFnuPÍÔzVdàôº^Ðæd´oG¤{S¬ćxã}ŧ×Kǥĩ«ÕOEÐ·ÖdÖsƘÑ¨[Û^Xr¢¼§xvÄÆµ`K§ tÒ´Cvlo¸fzŨð¾NY´ı~ÉĔēßúLÃÃ_ÈÏ|]ÂÏFlg`ben¾¢pUh~ƴĖ¶_r sĄ~cƈ]|r c~`¼{À{ȒiJjz`îÀT¥Û³]u}fïQl{skloNdjäËzDvčoQďHI¦rbtHĔ~BmlRV_ħTLnñH±DL¼Lªl§Ťa¸ĚlK²\\RòvDcÎJbt[¤D@®hh~kt°ǾzÖ@¾ªdbYhüóZ ň¶vHrľ\\ÊJuxAT|dmÀO[ÃÔG·ĚąĐlŪÚpSJ¨ĸLvÞcPæķŨ®mÐálwKhïgA¢ųÆ©Þ¤OÈm°K´"]],"encodeOffsets":[[[121722,32278]],[[119475,30423]],[[119168,35472]]]}},{"type":"Feature","id":"350000","properties":{"id":"350000","cp":[118.306239,26.075302],"name":"福建","childNum":18},"geometry":{"type":"MultiPolygon","coordinates":[["@@zht´]"],["@@aj^~ĆG©O"],["@@ed¨C}}i"],["@@@vPGsQ"],["@@sBzddW]Q"],["@@S¨Q{"],["@@NVucW"],["@@qptBAq"],["@@¸[mu"],["@@Q\\pD]_"],["@@jSwUadpF"],["@@eXª~"],["@@AjvFso"],["@@fT_Çí\\v|ba¦jZÆy°"],["@@IjJi"],["@@wJIx«¼AoNe{M­"],["@@K±¡ÓČäeZ"],["@@k¡¹Eh~c®wBkUplÀ¡I~Māe£bN¨gZý¡a±Öcp©PhI¢QqÇGj|¥U g[Ky¬ŏv@OptÉEF\\@ åA¬V{XģĐBycpě¼³Ăp·¤¥ohqqÚ¡ŅLs^Ã¡§qlÀhH¨MCe»åÇGD¥zPO£čÙkJA¼ßėuĕeûÒiÁŧSW¥Qûŗ½ùěcÝ§SùĩąSWó«íęACµeRåǃRCÒÇZÍ¢ź±^dlstjD¸ZpuÔâÃH¾oLUêÃÔjjēò´ĄWƛ^Ñ¥Ħ@ÇòmOw¡õyJyD}¢ďÑÈġfZda©º²z£NjD°Ötj¶¬ZSÎ~¾c°¶ÐmxO¸¢Pl´SL|¥AȪĖMņĲg®áIJČĒü` QF¬h|ĂJ@zµ |ê³È ¸UÖŬŬÀEttĸr]ðM¤ĶĲHtÏ AĬkvsq^aÎbvdfÊòSD´Z^xPsĂrvƞŀjJd×ŘÉ ®AÎ¦ĤdxĆqAZRÀMźnĊ»İÐZ YXæJyĊ²·¶q§·K@·{sXãô«lŗ¶»o½E¡­«¢±¨Y®Ø¶^AvWĶGĒĢPlzfļtàAvWYãO_¤sD§ssČġ[kƤPX¦`¶®BBvĪjv©jx[L¥àï[F¼ÍË»ğV`«Ip}ccÅĥZEãoP´B@D¸m±z«Ƴ¿å³BRØ¶Wlâþäą`]Z£Tc ĹGµ¶Hm@_©k¾xĨôȉðX«½đCIbćqK³ÁÄš¬OAwã»aLŉËĥW[ÂGIÂNxĳ¤D¢îĎÎB§°_JGs¥E@¤ućPåcuMuw¢BI¿]zG¹guĮck\\_"]],"encodeOffsets":[[[123250,27563]],[[122541,27268]],[[123020,27189]],[[122916,27125]],[[122887,26845]],[[122808,26762]],[[122568,25912]],[[122778,26197]],[[122515,26757]],[[122816,26587]],[[123388,27005]],[[122450,26243]],[[122578,25962]],[[121255,25103]],[[120987,24903]],[[122339,25802]],[[121042,25093]],[[122439,26024]]]}},{"type":"Feature","id":"360000","properties":{"id":"360000","cp":[115.592151,27.676493],"name":"江西","childNum":1},"geometry":{"type":"Polygon","coordinates":["@@ĢĨƐgļ¼ÂMD~ņªe^\\^§ý©j×cZØ¨zdÒa¶lÒJìõ`oz÷@¤uŞ¸´ôęöY¼HČƶajlÞƩ¥éZ[|h}^U  ¥pĄžƦO lt¸Æ Q\\aÆ|CnÂOjt­ĚĤdÈF`¶@Ðë ¦ōÒ¨SêvHĢûXD®QgÄWiØPÞìºr¤ǆNĠ¢lĄtZoCƞÔºCxrpĠV®Ê{f_Y`_eq®Aot`@oDXfkp¨|s¬\\DÄSfè©Hn¬^DhÆyøJhØxĢĀLÊƠPżċĄwȠĚ¦G®ǒĤäTŠÆ~Ħw«|TF¡nc³Ïå¹]ĉđxe{ÎÓvOEm°BƂĨİ|Gvz½ª´HàpeJÝQxnÀW­EµàXÅĪt¨ÃĖrÄwÀFÎ|ňÓMå¼ibµ¯»åDT±m[r«_gmQu~¥V\\OkxtL E¢Ú^~ýêPóqoě±_Êw§ÑªåƗā¼mĉŹ¿NQYBąrwģcÍ¥B­ŗÊcØiIƝĿuqtāwO]³YCñTeÉcaubÍ]trluīBÐGsĵıN£ï^ķqss¿FūūVÕ·´Ç{éĈýÿOER_đûIċâJh­ŅıNȩĕB¦K{Tk³¡OP·wnµÏd¯}½TÍ«YiµÕsC¯iM¤­¦¯P|ÿUHvhe¥oFTuõ\\OSsMòđƇiaºćXĊĵà·çhƃ÷Ç{ígu^đgm[×zkKN¶Õ»lčÓ{XSÆv©_ÈëJbVkĔVÀ¤P¾ºÈMÖxlò~ªÚàGĂ¢B±ÌKyáV¼Ã~­`gsÙfIƋlę¹e|~udjuTlXµf`¿Jd[\\L²"],"encodeOffsets":[[116689,26234]]}},{"type":"Feature","id":"370000","properties":{"id":"370000","cp":[118.000923,36.275807],"name":"山东","childNum":13},"geometry":{"type":"MultiPolygon","coordinates":[["@@Xjd]{K"],["@@itbFHy"],["@@HlGk"],["@@TGy"],["@@K¬U"],["@@WdXc"],["@@PtOs"],["@@LnXhc"],["@@ppVu]Or"],["@@cdzAUa"],["@@udRhnCI"],["@@oIpR"],["@@Ľč{fzƤîKÎMĮ]ZF½Y]â£ph¶¨râøÀÎǨ¤^ºÄGz~grĚĜlĞÆLĆǆ¢Îo¦cvKbgr°WhmZp L]LºcUÆ­nżĤÌĒbAnrOA´ȊcÀbƦUØrĆUÜøĬƞEzVL®öØBkŖÝĐĖ¹ŧ̄±ÀbÎÉnb²ĦhņBĖįĦåXćì@L¯´ywƕCéÃµė ƿ¸lµ¾Z|ZWyFY¨Mf~C¿`à_RÇzwƌfQnny´INoƬèôº|sTJULîVjǎ¾ĒØDz²XPn±ŴPè¸ŔLƔÜƺ_TüÃĤBBċÈöA´faM¨{«M`¶d¡ôÖ°mȰBÔjj´PM|c^d¤u¤Û´ä«ƢfPk¶Môl]Lb}su^ke{lCMrDÇ­]NÑFsmoõľHyGă{{çrnÓEƕZGª¹Fj¢ïWuøCǷë¡ąuhÛ¡^KxC`C\\bÅxì²ĝÝ¿_NīCȽĿåB¥¢·IŖÕy\\¹kxÃ£Č×GDyÃ¤ÁçFQ¡KtŵƋ]CgÏAùSedcÚźuYfyMmhUWpSyGwMPqŀÁ¼zK¶G­Y§Ë@´śÇµƕBm@IogZ¯uTMx}CVKï{éƵP_K«pÛÙqċtkkù]gTğwoɁsMõ³ăAN£MRkmEÊčÛbMjÝGuIZGPģãħE[iµBEuDPÔ~ª¼ęt]ûG§¡QMsğNPŏįzs£Ug{đJĿļā³]ç«Qr~¥CƎÑ^n¶ÆéÎR~Ż¸YI] PumŝrƿIā[xeÇ³L¯v¯s¬ÁY~}ťuŁgƋpÝĄ_ņī¶ÏSR´ÁP~¿Cyċßdwk´SsX|t`Ä ÈðAªìÎT°¦Dda^lĎDĶÚY°`ĪŴǒàŠv\\ebZHŖR¬ŢƱùęOÑM­³FÛWp["]],"encodeOffsets":[[[123806,39303]],[[123821,39266]],[[123742,39256]],[[123702,39203]],[[123649,39066]],[[123847,38933]],[[123580,38839]],[[123894,37288]],[[123043,36624]],[[123344,38676]],[[123522,38857]],[[123628,38858]],[[118260,36742]]]}},{"type":"Feature","id":"410000","properties":{"id":"410000","cp":[113.665412,33.757975],"name":"河南","childNum":1},"geometry":{"type":"Polygon","coordinates":["@@ýLùµP³swIÓxcŢĞð´E®ÚPtĴXØxÂ¶@«ŕŕQGYfa[şußǩđš_X³ĳÕčC]kbc¥CS¯ëÍB©÷³­Si_}mYTt³xlàcČzÀD}ÂOQ³ÐTĨ¯ƗòËŖ[hłŦv~}ÂZ«¤lPÇ£ªÝŴÅR§ØnhctâknÏ­ľŹUÓÝdKuķI§oTũÙďkęĆH¸Ó\\Ä¿PcnS{wBIvÉĽ[GqµuŇôYgûZca©@½Õǽys¯}lgg@­C\\£asIdÍuCQñ[L±ęk·ţb¨©kK»KC²òGKmĨS`UQnk}AGēsqaJ¥ĐGRĎpCuÌy ã iMcplk|tRkðev~^´¦ÜSí¿_iyjI|ȑ|¿_»d}q^{Ƈdă}tqµ`Ƴĕg}V¡om½faÇo³TTj¥tĠRyK{ùÓjuµ{t}uËRivGçJFjµÍyqÎàQÂFewixGw½Yŷpµú³XU½ġyłåkÚwZX·l¢Á¢KzOÎÎjc¼htoDHr|­J½}JZ_¯iPq{tę½ĕ¦Zpĵø«kQĹ¤]MÛfaQpě±ǽ¾]u­Fu÷nčÄ¯ADp}AjmcEÇaª³o³ÆÍSƇĈÙDIzËčľ^KLiÞñ[aA²zzÌ÷D|[íÄ³gfÕÞd®|`Ć~oĠƑô³ŊD×°¯CsøÀ«ìUMhTº¨¸ǡîSÔDruÂÇZÖEvPZW~ØÐtĄE¢¦Ðy¸bô´oŬ¬²Ês~]®tªapŎJ¨Öº_Ŕ`Ŗ^Đ\\Ĝu~m²Ƹ¸fWĦrƔ}Î^gjdfÔ¡J}\\n C¦þWxªJRÔŠu¬ĨĨmFdM{\\d\\YÊ¢ú@@¦ª²SÜsC}fNècbpRmlØ^gd¢aÒ¢CZZxvÆ¶N¿¢T@uC¬^ĊðÄn|lGlRjsp¢ED}Fio~ÔN~zkĘHVsǲßjŬŢ`Pûàl¢\\ÀEhİgÞē X¼Pk|m"],"encodeOffsets":[[118256,37017]]}},{"type":"Feature","id":"420000","properties":{"id":"420000","cp":[113.298572,30.684355],"name":"湖北","childNum":3},"geometry":{"type":"MultiPolygon","coordinates":[["@@AB"],["@@lskt"],["@@¾«}{ra®pîÃ\\{øCËyyB±b\\òÝjKL ]ĎĽÌJyÚCƈćÎT´Å´pb©ÈdFin~BCo°BĎÃømv®E^vǾ½Ĝ²RobÜeN^ĺ£R¬lĶ÷YoĖ¥Ě¾|sOr°jY`~I¾®I{GqpCgyl{£ÍÍyPLÂ¡¡¸kWxYlÙæŁĢz¾V´W¶ùŸo¾ZHxjwfxGNÁ³Xéæl¶EièIH ujÌQ~v|sv¶Ôi|ú¢FhQsğ¦SiŠBgÐE^ÁÐ{čnOÂÈUÎóĔÊēĲ}Z³½Mŧïeyp·uk³DsÑ¨L¶_ÅuÃ¨w»¡WqÜ]\\Ò§tƗcÕ¸ÕFÏǝĉăxŻČƟOKÉġÿ×wg÷IÅzCg]m«ªGeçÃTC«[t§{loWeC@ps_Bp­rf_``Z|ei¡oċMqow¹DƝÓDYpûsYkıǃ}s¥ç³[§cY§HK«Qy]¢wwö¸ïx¼ņ¾Xv®ÇÀµRĠÐHM±cÏdƒǍũȅȷ±DSyúĝ£ŤĀàtÖÿï[îb\\}pĭÉI±Ñy¿³x¯No|¹HÏÛmjúË~TuęjCöAwě¬Rđl¯ Ñb­ŇTĿ_[IčĄʿnM¦ğ\\É[T·k¹©oĕ@A¾wya¥Y\\¥Âaz¯ãÁ¡k¥ne£ÛwE©Êō¶˓uoj_U¡cF¹­[WvP©whuÕyBF`RqJUw\\i¡{jEPïÿ½fćQÑÀQ{°fLÔ~wXgītêÝ¾ĺHd³fJd]HJ²EoU¥HhwQsƐ»Xmg±çve]DmÍPoCc¾_hhøYrŊU¶eD°Č_N~øĹĚ·`z]Äþp¼äÌQv\\rCé¾TnkžŐÚÜa¼ÝƆĢ¶ÛodĔňÐ¢JqPb ¾|J¾fXƐîĨ_Z¯À}úƲN_ĒÄ^ĈaŐyp»CÇÄKñL³ġM²wrIÒŭxjb[n«øæà ^²­h¯ÚŐªÞ¸Y²ĒVø}Ā^İ´LÚm¥ÀJÞ{JVųÞŃx×sxxƈē ģMřÚðòIfĊŒ\\Ʈ±ŒdÊ§ĘDvČ_Àæ~Dċ´A®µ¨ØLV¦êHÒ¤"]],"encodeOffsets":[[[113712,34000]],[[115612,30507]],[[113649,34054]]]}},{"type":"Feature","id":"430000","properties":{"id":"430000","cp":[111.782279,28.09409],"name":"湖南","childNum":3},"geometry":{"type":"MultiPolygon","coordinates":[["@@nFTs"],["@@ßÅÆá½ÔXrCOËRïÿĩ­TooQyÓ[ŅBE¬ÎÓXaį§Ã¸G °ITxpúxÚĳ¥ÏĢ¾edÄ©ĸGàGhM¤Â_U}Ċ}¢pczfþg¤ÇòAVM"],["@@©KA·³CQ±Á«³BUƑ¹AtćOwD]JiØSm¯b£ylXHËÑ±H«C^õľAÅ§¤É¥ïyuǙuA¢^{ÌC´­¦ŷJ£^[ª¿ĕ~ƇN skóā¹¿ï]ă~÷O§­@Vm¡Qđ¦¢Ĥ{ºjÔª¥nf´~Õo×ÛąMąıuZmZcÒ ĲĪ²SÊǄŶ¨ƚCÖŎªQØ¼rŭ­«}NÏürÊ¬mjr@ĘrTW ­SsdHzƓ^ÇÂyUi¯DÅYlŹu{hT}mĉ¹¥ěDÿë©ıÓ[Oº£¥ótł¹MÕƪ`PDiÛU¾ÅâìUñBÈ£ýhedy¡oċ`pfmjP~kZaZsÐd°wj§@Ĵ®w~^kÀÅKvNmX\\¨aŃqvíó¿F¤¡@ũÑVw}S@j}¾«pĂrªg àÀ²NJ¶¶DôK|^ª°LX¾ŴäPĪ±£EXd^¶ĲÞÜ~u¸ǔMRhsRe`ÄofIÔ\\Ø  ićymnú¨cj ¢»GČìƊÿÐ¨XeĈĀ¾Oð Fi ¢|[jVxrIQ_EzAN¦zLU`cªxOTu RLÄ¢dVi`p˔vŎµªÉF~Ød¢ºgİàw¸Áb[¦Zb¦z½xBĖ@ªpºlS¸Ö\\Ĕ[N¥ˀmĎăJ\\ŀ`ňSÚĖÁĐiOĜ«BxDõĚivSÌ}iùÜnÐºG{p°M´wÀÒzJ²ò¨ oTçüöoÛÿñőĞ¤ùTz²CȆȸǎŪƑÐc°dPÎğË¶[È½u¯½WM¡­ÉB·rínZÒ `¨GA¾\\pēXhÃRC­üWGġuTé§ŎÑ©ò³I±³}_EÃħg®ęisÁPDmÅ{b[RÅs·kPŽƥóRoOV~]{g\\êYƪ¦kÝbiċƵGZ»Ěõó·³vŝ£ø@pyö_ëIkÑµbcÑ§y×dYØªiþ¨[]f]Ņ©C}ÁN»hĻħƏĩ"]],"encodeOffsets":[[[115640,30489]],[[112543,27312]],[[116690,26230]]]}},{"type":"Feature","id":"440000","properties":{"id":"440000","cp":[113.280637,23.125178],"name":"广东","childNum":24},"geometry":{"type":"MultiPolygon","coordinates":[["@@QdAua"],["@@lxDLo"],["@@sbhNLo"],["@@Ă ā"],["@@WltO[["],["@@Kr]S"],["@@eI]y"],["@@I|Mym"],["@@Û³LS¼Y"],["@@nvºBëui©`¾"],["@@zdÛJw®"],["@@°¯"],["@@a yAª¸ËJIxØ@ĀHAmÃV¡ofuo"],["@@sŗÃÔėAƁZÄ ~°ČPäh"],["@@¶ÝÌvmĞh­ıQ"],["@@HdSjĒ¢D}waru«ZqadYM"],["@@el\\LqqU"],["@@~rMo\\"],["@@f^C"],["@@øPªoj÷ÍÝħXČx°Q¨ıXNv"],["@@gÇƳo[~tly"],["@@EÆC¿"],["@@OP"],["@@wđógĝ[³¡VÙæÅöMÌ³¹pÁaËýý©D©ÜJŹƕģGą¤{ÙūÇO²«BƱéAÒĥ¡«BhlmtÃPµyU¯ucd·w_bŝcīímGO|KPȏŹãŝIŕŭŕ@Óoo¿ē±ß}ŭĲWÈCőâUâǙIğŉ©IĳE×Á³AówXJþ±ÌÜÓĨ£L]ĈÙƺZǾĆĖMĸĤfÎĵlŨnÈĐtFFĤêk¶^k°f¶g}®Faf`vXŲxl¦ÔÁ²¬Ð¦pqÊÌ²iXØRDÎ}Ä@ZĠsx®AR~®ETtĄZƈfŠŠHâÒÐAµ\\S¸^wĖkRzalŜ|E¨ÈNĀňZTpBh£\\ĎƀuXĖtKL¶G|»ĺEļĞ~ÜĢÛĊrOÙîvd]n¬VÊĜ°RÖpMƂªFbwEÀ©\\¤]ŸI®¥D³|Ë]CöAŤ¦æ´¥¸Lv¼¢ĽBaôF~®²GÌÒEYzk¤°ahlVÕI^CxĈPsBƒºV¸@¾ªR²ĨN]´_eavSivc}p}Đ¼ƌkJÚe th_¸ ºx±ò_xNË²@ă¡ßH©Ùñ}wkNÕ¹ÇO½¿£ĕ]ly_WìIÇª`uTÅxYĒÖ¼kÖµMjJÚwn\\hĒv]îh|ÈƄøèg¸Ķß ĉĈWb¹ƀdéĘNTtP[öSvrCZaGubo´ŖÒÇĐ~¡zCIözx¢PnÈñ @ĥÒ¦]ƞV}³ăĔñiiÄÓVépKG½ÄÓávYoC·sitiaÀyŧÎ¡ÈYDÑům}ý|m[węõĉZÅxUO}÷N¹³ĉo_qtăqwµŁYÙǝŕ¹tïÛUÃ¯mRCºĭ|µÕÊK½Rē ó]GªęAx»HO£|ām¡diď×YïYWªŉOeÚtĐ«zđ¹TāúEá²\\ķÍ}jYàÙÆſ¿Çdğ·ùTßÇţʄ¡XgWÀǇğ·¿ÃOj YÇ÷Qěi"]],"encodeOffsets":[[[117381,22988]],[[116552,22934]],[[116790,22617]],[[116973,22545]],[[116444,22536]],[[116931,22515]],[[116496,22490]],[[116453,22449]],[[113301,21439]],[[118726,21604]],[[118709,21486]],[[113210,20816]],[[115482,22082]],[[113171,21585]],[[113199,21590]],[[115232,22102]],[[115739,22373]],[[115134,22184]],[[113056,21175]],[[119573,21271]],[[119957,24020]],[[115859,22356]],[[116561,22649]],[[116285,22746]]]}},{"type":"Feature","id":"450000","properties":{"id":"450000","cp":[108.320004,22.82402],"name":"广西","childNum":2},"geometry":{"type":"MultiPolygon","coordinates":[["@@H TQ§A"],["@@ĨÊªLƊDÎĹĐCǦė¸zÚGn£¾rªŀÜt¬@ÖÚSx~øOŒŶÐÂæȠ\\ÈÜObĖw^oÞLf¬°bI lTØBÌF£Ć¹gñĤaYt¿¤VSñK¸¤nM¼JE±½¸ñoÜCƆæĪ^ĚQÖ¦^f´QüÜÊz¯lzUĺš@ìp¶n]sxtx¶@~ÒĂJb©gk{°~c°`Ô¬rV\\la¼¤ôá`¯¹LCÆbxEræOv[H­[~|aB£ÖsºdAĐzNÂðsÞÆĤªbab`ho¡³F«èVlo¤ÔRzpp®SĪº¨ÖºNĳd`a¦¤F³ºDÎńĀìCĜº¦Ċ~nS|gźvZkCÆj°zVÈÁƔ]LÊFZgčP­kini«qÇczÍY®¬Ů»qR×ō©DÕ§ƙǃŵTÉĩ±ıdÑnYYĲvNĆĆØÜ Öp}e³¦m©iÓ|¹ħņ|ª¦QF¢Â¬ʖovg¿em^ucà÷gÕuíÙćĝ}FĻ¼Ĺ{µHKsLSđƃrč¤[AgoSŇYMÿ§Ç{FśbkylQxĕ]T·¶[BÑÏGáşşƇeăYSs­FQ}­BwtYğÃ@~CÍQ ×WjË±rÉ¥oÏ ±«ÓÂ¥kwWűmcih³K~µh¯e]lµélEģEďsmÇŧē`ãògK_ÛsUʝćğ¶höO¤Ǜn³c`¡y¦CezYwa[ďĵűMę§]XÎ_íÛ]éÛUćİÕBƣ±dy¹T^dûÅÑŦ·PĻþÙ`K¦¢ÍeĥR¿³£[~äu¼dltW¸oRM¢ď\\z}Æzdvň{ÎXF¶°Â_ÒÂÏL©ÖTmu¼ãlīkiqéfA·Êµ\\őDc¥ÝFyÔćcűH_hLÜêĺĐ¨c}rn`½Ì@¸¶ªVLhŒ\\Ţĺk~Ġið°|gtTĭĸ^xvKVGréAébUuMJVÃO¡qĂXËSģãlýà_juYÛÒBG^éÖ¶§EGÅzěƯ¤EkN[kdåucé¬dnYpAyČ{`]þ¯TbÜÈk¡ĠvàhÂƄ¢Jî¶²"]],"encodeOffsets":[[[111707,21520]],[[107619,25527]]]}},{"type":"Feature","id":"460000","properties":{"id":"460000","cp":[109.83119,19.031971],"name":"海南","childNum":1},"geometry":{"type":"Polygon","coordinates":["@@¦Ŝil¢XƦƞòïè§ŞCêɕrŧůÇąĻõ·ĉ³œ̅kÇm@ċȧŧĥĽʉ­ƅſȓÒË¦ŝE}ºƑ[ÍĜȋ gÎfǐÏĤ¨êƺ\\Ɔ¸ĠĎvʄȀÐ¾jNðĀÒRZǆzÐŘÎ°H¨Ƣb²_Ġ "],"encodeOffsets":[[112750,20508]]}},{"type":"Feature","id":"510000","properties":{"id":"510000","cp":[104.065735,30.659462],"name":"四川","childNum":2},"geometry":{"type":"MultiPolygon","coordinates":[["@@LqKr"],["@@[ĻéV£_ţġñpG réÏ·~ąSfy×Í·ºſƽiÍıƣıĻmHH}siaX@iÇ°ÁÃ×t«­T¤JJJyJÈ`Ohß¦¡uËhIyCjmÿwZGTiSsOB²fNmsPa{M{õE^Hj}gYpaeu¯oáwHjÁ½M¡pMuåmni{fk\\oÎqCwEZ¼KĝAy{m÷LwO×SimRI¯rKõBS«sFe]fµ¢óY_ÆPRcue°Cbo×bd£ŌIHgtrnyPt¦foaXďxlBowz_{ÊéWiêEGhÜ¸ºuFĈIxf®Y½ĀǙ]¤EyF²ċw¸¿@g¢§RGv»áW`ÃĵJwi]t¥wO­½a[×]`Ãi­üL¦LabbTÀåc}ÍhÆh®BHî|îºÉk­¤Sy£ia©taį·Ɖ`ō¥UhOĝLk}©Fos´JmµlŁuønÑJWÎªYÀïAetTŅÓGË«bo{ıwodƟ½OġÜÂµxàNÖ¾P²§HKv¾]|BÆåoZ`¡Ø`ÀmºĠ~ÌÐ§nÇ¿¤]wğ@srğu~Io[é±¹ ¿ſđÓ@qg¹zƱřaí°KtÇ¤V»Ã[ĩǭƑ^ÇÓ@áťsZÏÅĭƋěpwDóÖáŻneQËq·GCœýS]x·ýq³OÕ¶Qzßti{řáÍÇWŝŭñzÇWpç¿JXĩè½cFÂLiVjx}\\NŇĖ¥GeJA¼ÄHfÈu~¸Æ«dE³ÉMA|bÒćhG¬CMõƤąAvüVéŀ_VÌ³ĐwQj´·ZeÈÁ¨X´Æ¡Qu·»ÕZ³ġqDoy`L¬gdp°şp¦ėìÅĮZ°Iähzĵf²å ĚÑKpIN|Ñz]ń·FU×é»R³MÉ»GM«kiér}Ã`¹ăÞmÈnÁîRǀ³ĜoİzŔwǶVÚ£À]ɜ»ĆlƂ²ĠþTº·àUȞÏʦ¶I«dĽĢdĬ¿»Ĕ×h\\c¬ä²GêëĤł¥ÀǿżÃÆMº}BÕĢyFVvwxBèĻĒ©ĈtCĢɽŠȣ¦āæ·HĽîôNÔ~^¤Ɗu^s¼{TA¼ø°¢İªDè¾Ň¶ÝJ®Z´ğ~Sn|ªWÚ©òzPOȸbð¢|øĞŒQìÛÐ@ĞǎRS¤Á§di´ezÝúØã]HqkIþËQÇ¦ÃsÇ¤[E¬ÉŪÍxXƒ·ÖƁİlƞ¹ª¹|XÊwnÆƄmÀêErĒtD®ċæcQE®³^ĭ¥©l}äQtoŖÜqÆkµªÔĻĴ¡@Ċ°B²Èw^^RsºTĀ£ŚæQPJvÄz^Đ¹Æ¯fLà´GC²dt­ĀRt¼¤ĦOðğfÔðDŨŁĞƘïPÈ®âbMüÀXZ ¸£@Å»»QÉ­]dsÖ×_Í_ÌêŮPrĔĐÕGĂeZÜîĘqBhtO ¤tE[h|YÔZśÎs´xº±Uñt|OĩĠºNbgþJy^dÂY Į]Řz¦gC³R`Āz¢Aj¸CL¤RÆ»@­Ŏk\\Ç´£YW}z@Z}Ã¶oû¶]´^NÒ}èNªPÍy¹`S°´ATeVamdUĐwʄvĮÕ\\uÆŗ¨Yp¹àZÂmWh{á}WØǍÉüwga§áCNęÎ[ĀÕĪgÖÉªXøx¬½Ů¦¦[NÎLÜUÖ´òrÙŠxR^JkĳnDX{U~ET{ļº¦PZcjF²Ė@pg¨B{u¨ŦyhoÚD®¯¢ WòàFÎ¤¨GDäz¦kŮPġqË¥À]eâÚ´ªKxīPÖ|æ[xÃ¤JÞĥsNÖ½I¬nĨY´®ÐƐmDŝuäđđEbee_v¡}ìęǊē}qÉåT¯µRs¡M@}ůaa­¯wvƉåZw\\Z{åû^"]],"encodeOffsets":[[[108815,30935]],[[110617,31811]]]}},{"type":"Feature","id":"520000","properties":{"id":"520000","cp":[106.713478,26.578343],"name":"贵州","childNum":3},"geometry":{"type":"MultiPolygon","coordinates":[["@@G\\lY£in"],["@@q|mc¯tÏVSÎ"],["@@hÑ£IsNgßHHªķÃh_¹¡ĝÄ§ń¦uÙùgS¯JH|sÝÅtÁïyMDč»eÕtA¤{b\\}G®u\\åPFqwÅaDK°ºâ_£ùbµmÁÛĹM[q|hlaªāI}Ñµ@swtwm^oµDéĽŠyVky°ÉûÛR³e¥]RÕěħ[ƅåÛDpJiVÂF²I»mN·£LbÒYbWsÀbpkiTZĄă¶Hq`ĥ_J¯ae«KpÝx]aĕÛPÇȟ[ÁåŵÏő÷Pw}TÙ@Õs«ĿÛq©½m¤ÙH·yǥĘĉBµĨÕnđ]K©œáGçş§ÕßgǗĦTèƤƺ{¶ÉHÎd¾ŚÊ·OÐjXWrãLyzÉAL¾ę¢bĶėy_qMĔąro¼hĊw¶øV¤w²Ĉ]ÊKx|`ź¦ÂÈdrcÈbe¸`I¼čTF´¼Óýȃr¹ÍJ©k_șl³´_pĐ`oÒh¶pa^ÓĔ}D»^Xy`d[KvJPhèhCrĂĚÂ^Êƌ wZL­Ġ£ÁbrzOIlMMĪŐžËr×ÎeŦtw|¢mKjSǘňĂStÎŦEtqFT¾Eì¬¬ôxÌO¢ K³ŀºäYPVgŎ¦ŊmŞ¼VZwVlz¤£Tl®ctĽÚó{G­AÇge~Îd¿æaSba¥KKûj®_Ä^\\Ø¾bP®¦x^sxjĶI_Ä Xâ¼Hu¨Qh¡À@Ëô}±GNìĎlT¸`V~R°tbÕĊ`¸úÛtÏFDu[MfqGH·¥yAztMFe|R_GkChZeÚ°tov`xbDnÐ{E}ZèxNEÞREn[Pv@{~rĆAB§EO¿|UZ~ìUf¨J²ĂÝÆsªB`s¶fvö¦Õ~dÔq¨¸º»uù[[§´sb¤¢zþF¢ÆÀhÂW\\ıËIÝo±ĭŠ£þÊs}¡R]ěDg´VG¢j±®èºÃmpU[Áëº°rÜbNu¸}º¼`niºÔXĄ¤¼ÔdaµÁ_ÃftQQgR·Ǔv}Ý×ĵ]µWc¤F²OĩųãW½¯K©]{LóµCIµ±Mß¿h©āq¬o½~@i~TUxŪÒ¢@£ÀEîôruńb[§nWuMÆLl¿]x}ĳ­½"]],"encodeOffsets":[[[112158,27383]],[[112105,27474]],[[112095,27476]]]}},{"type":"Feature","id":"530000","properties":{"id":"530000","cp":[101.512251,24.740609],"name":"云南","childNum":1},"geometry":{"type":"Polygon","coordinates":["@@[ùx½}ÑRHYīĺûsÍniEoã½Ya²ė{c¬ĝgĂsAØÅwďõzFjw}«Dx¿}Uũlê@HÅ­F¨ÇoJ´Ónũuą¡Ã¢pÒÅØ TF²xa²ËXcÊlHîAßËŁkŻƑŷÉ©hW­æßUËs¡¦}teèÆ¶StÇÇ}Fd£jĈZĆÆ¤Tč\\D}O÷£U§~ŃGåŃDĝ¸Tsd¶¶Bª¤u¢ŌĎo~t¾ÍŶÒtD¦ÚiôözØX²ghįh½Û±¯ÿm·zR¦Ɵ`ªŊÃh¢rOÔ´£Ym¼èêf¯ŪĽncÚbw\\zlvWªâ ¦gmĿBĹ£¢ƹřbĥkǫßeeZkÙIKueT»sVesbaĕ  ¶®dNĄÄpªy¼³BE®lGŭCǶwêżĔÂepÍÀQƞpC¼ŲÈ­AÎô¶RäQ^Øu¬°_Èôc´¹ò¨PÎ¢hlĎ¦´ĦÆ´sâÇŲPnÊD^¯°Upv}®BPÌªjǬxSöwlfòªvqĸ|`H­viļndĜ­Ćhňem·FyÞqóSį¯³X_ĞçêtryvL¤§z¦c¦¥jnŞklD¤øz½ĜàĂŧMÅ|áƆàÊcðÂFÜáŢ¥\\\\ºİøÒÐJĴîD¦zK²ǏÎEh~CD­hMn^ÌöÄ©ČZÀaüfɭyœpį´ěFűk]Ôě¢qlÅĆÙa¶~ÄqêljN¬¼HÊNQ´ê¼VØ¸E^ŃÒyM{JLoÒęæe±Ķygã¯JYÆĭĘëo¥Šo¯hcK«z_prC´ĢÖY¼ v¸¢RÅW³Â§fÇ¸Yi³xR´ďUË`êĿUûuĆBƣöNDH«ĈgÑaB{ÊNF´¬c·Åv}eÇÃGB»If¦HňĕM~[iwjUÁKE¾dĪçWIèÀoÈXòyŞŮÈXâÎŚj|àsRyµÖPr´þ ¸^wþTDŔHr¸RÌmfżÕâCôoxĜƌÆĮÐYtâŦÔ@]ÈǮƒ\\Ī¼Ä£UsÈ¯LbîƲŚºyhr@ĒÔƀÀ²º\\êpJ}ĠvqtĠ@^xÀ£È¨mËÏğ}n¹_¿¢×Y_æpÅA^{½Lu¨GO±Õ½ßM¶wÁĢÛPƢ¼pcĲx|apÌ¬HÐŊSfsðBZ¿©XÏÒKk÷Eû¿SrEFsÕūkóVǥŉiTL¡n{uxţÏhôŝ¬ğōNNJkyPaqÂğ¤K®YxÉƋÁ]āęDqçgOgILu\\_gz]W¼~CÔē]bµogpÑ_oď`´³Țkl`IªºÎȄqÔþ»E³ĎSJ»_f·adÇqÇc¥Á_Źw{L^É±ćxU£µ÷xgĉp»ĆqNē`rĘzaĵĚ¡K½ÊBzyäKXqiWPÏÉ¸½řÍcÊG|µƕƣGË÷k°_^ý|_zċBZocmø¯hhcæ\\lMFlư£ĜÆyHF¨µêÕ]HAàÓ^it `þßäkĤÎT~Wlÿ¨ÔPzUCNVv [jâôDôď[}z¿msSh¯{jïğl}šĹ[őgK©U·µË@¾m_~q¡f¹ÅË^»f³ø}Q¡ÖË³gÍ±^Ç\\ëÃA_¿bWÏ[¶ƛé£F{īZgm@|kHǭƁć¦UĔť×ë}ǝeďºȡȘÏíBÉ£āĘPªĳ¶ŉÿy©nď£G¹¡I±LÉĺÑdĉÜW¥}gÁ{aqÃ¥aıęÏZï`"],"encodeOffsets":[[104636,22969]]}},{"type":"Feature","id":"540000","properties":{"id":"540000","cp":[89.132212,30.860361],"name":"西藏","childNum":1},"geometry":{"type":"Polygon","coordinates":["@@ÂhľxŖxÒVºÅâAĪÝȆµę¯Ňa±r_w~uSÕňqOj]ɄQ£ZUDûoY»©M[L¼qãË{VÍçWVi]ë©Ä÷àyƛhÚU°adcQ~Mx¥cc¡ÙaSyFÖk­uRýq¿ÔµQĽ³aG{¿FµëªéĜÿª@¬·K·àariĕĀ«V»ŶĴūgèLǴŇƶaftèBŚ£^âǐÝ®M¦ÁǞÿ¬LhJ¾óƾÆºcxwf]Y´¦|QLn°adĊ\\¨oǀÍŎ´ĩĀd`tÊQŞŕ|¨C^©Ĉ¦¦ÎJĊ{ëĎjª²rÐl`¼Ą[t|¦Stè¾PÜK¸dƄı]s¤î_v¹ÎVòŦj£Əsc¬_Ğ´|Ł¦Av¦w`ăaÝaa­¢e¤ı²©ªSªÈMĄwÉØŔì@T¤Ę\\õª@þo´­xA sÂtŎKzó´ÇĊµ¢r^nĊ­Æ¬×üG¢³ {âĊ]G~bÀgVjzlhǶfOfdªB]pjTOtĊn¤}®¦Č¥d¢¼»ddY¼t¢eȤJ¤}Ǿ¡°§¤AÐlc@ĝsªćļđAçwxUuzEÖġ~AN¹ÄÅȀŻ¦¿ģŁéì±Hãd«g[Ø¼ēÀcīľġ¬cJµÐʥVȝ¸ßS¹ý±ğkƁ¼ą^ɛ¤Ûÿb[}¬ōõÃ]ËNm®g@Bg}ÍF±ǐyL¥íCIĳÏ÷Ñį[¹¦[âšEÛïÁÉdƅß{âNÆāŨß¾ě÷yC£k­´ÓH@Â¹TZ¥¢į·ÌAÐ§®Zcv½Z­¹|ÅWZqgW|ieZÅYVÓqdqbc²R@c¥Rã»GeeƃīQ}J[ÒK¬Ə|oėjġĠÑN¡ð¯EBčnwôɍėª²CλŹġǝʅįĭạ̃ūȹ]ΓͧgšsgȽóϧµǛęgſ¶ҍć`ĘąŌJÞä¤rÅň¥ÖÁUětęuůÞiĊÄÀ\\Æs¦ÓRb|Â^řÌkÄŷ¶½÷f±iMÝ@ĥ°G¬ÃM¥n£Øąğ¯ß§aëbéüÑOčk£{\\eµª×MÉfm«Ƒ{Å×Gŏǩãy³©WÑăû··Qòı}¯ãIéÕÂZ¨īès¶ZÈsæĔTŘvgÌsN@îá¾ó@ÙwU±ÉTå»£TđWxq¹Zobs[×¯cĩvėŧ³BM|¹kªħ¥TzNYnÝßpęrñĠĉRS~½ěVVµõ«M££µBĉ¥áºae~³AuĐh`Ü³ç@BÛïĿa©|z²Ý¼D£àč²ŸIûI āóK¥}rÝ_Á´éMaň¨~ªSĈ½½KÙóĿeƃÆB·¬ën×W|Uº}LJrƳlŒµ`bÔ`QÐÓ@s¬ñIÍ@ûws¡åQÑßÁ`ŋĴ{ĪTÚÅTSÄ³Yo|Ç[Ç¾µMW¢ĭiÕØ¿@MhpÕ]jéò¿OƇĆƇpêĉâlØwěsǩĵ¸cbU¹ř¨WavquSMzeo_^gsÏ·¥Ó@~¯¿RiīB\\qTGªÇĜçPoÿfñòą¦óQīÈáPābß{ZŗĸIæÅhnszÁCËìñÏ·ąĚÝUm®ó­L·ăUÈíoù´Êj°ŁŤ_uµ^°ìÇ@tĶĒ¡ÆM³Ģ«İĨÅ®ğRāðggheÆ¢zÊ©Ô\\°ÝĎz~ź¤PnMĪÖB£kné§żćĆKĒ°¼L¶èâz¨u¦¥LDĘz¬ýÎmĘd¾ßFzhg²Fy¦ĝ¤ċņbÎ@yĄæm°NĮZRÖíJ²öLĸÒ¨Y®ƌÐVàtt_ÚÂyĠz]ŢhzĎ{ÂĢXc|ÐqfO¢¤ögÌHNPKŖUú´xx[xvĐCûĀìÖT¬¸^}Ìsòd´_KgžLĴÀBon|H@Êx¦BpŰŌ¿fµƌA¾zǈRx¶FkĄźRzŀ~¶[´HnªVƞuĒ­È¨ƎcƽÌm¸ÁÈM¦x͊ëÀxǆBú^´W£dkɾĬpw˂ØɦļĬIŚÊnŔa¸~J°îlɌxĤÊÈðhÌ®gT´øàCÀ^ªerrƘd¢İP|Ė ŸWªĦ^¶´ÂLaT±üWƜǀRÂŶUńĖ[QhlLüAÜ\\qRĄ©"],"encodeOffsets":[[90849,37210]]}},{"type":"Feature","id":"610000","properties":{"id":"610000","cp":[108.948024,34.263161],"name":"陕西","childNum":1},"geometry":{"type":"Polygon","coordinates":["@@p¢ȮµûGĦ}Ħðǚ¶òƄjɂz°{ºØkÈęâ¦jªBg\\ċ°s¬]jú EȌǆ¬stRÆdĠİwÜ¸ôW¾ƮłÒ_{Ìû¼jº¹¢GǪÒ¯ĘZ`ºŊecņą~BÂgzpâēòYǠȰÌTÎ¨ÂW|fcă§uF@N¢XLRMº[ğȣſï|¥Jkc`sŉǷY¹W@µ÷Kãï³ÛIcñ·VȋÚÒķø©þ¥yÓğęmWµÎumZyOŅƟĥÓ~sÑL¤µaÅY¦ocyZ{y c]{Ta©`U_Ěē£ωÊƍKùK¶ȱÝƷ§{û»ÅÁȹÍéuĳ|¹cÑdìUYOuFÕÈYvÁCqÓTǢí§·S¹NgV¬ë÷Át°DØ¯C´ŉƒópģ}ċcEËFéGU¥×K§­¶³BČ}C¿åċ`wġB·¤őcƭ²ő[Å^axwQOÿEËßŚĤNĔwƇÄńwĪ­o[_KÓª³ÙnKÇěÿ]ďă_d©·©Ýŏ°Ù®g]±ßå¬÷m\\iaǑkěX{¢|ZKlçhLtŇîŵœè[É@ƉĄEtƇÏ³­ħZ«mJ×¾MtÝĦ£IwÄå\\Õ{OwĬ©LÙ³ÙgBƕŀrÌĢŭO¥lãyC§HÍ£ßEñX¡­°ÙCgpťzb`wIvA|§hoĕ@E±iYd¥OĻ¹S|}F@¾oAO²{tfÜ¢FǂÒW²°BĤh^Wx{@¬­F¸¡ķn£P|ªĴ@^ĠĈæbÔc¶lYi^MicĎ°Â[ävï¶gv@ÀĬ·lJ¸sn|¼u~a]ÆÈtŌºJpþ£KKf~¦UbyäIĺãnÔ¿^­ŵMThĠÜ¤ko¼Ŏìąǜh`[tRd²Ĳ_XPrɲlXiL§à¹H°Ȧqº®QCbAŌJ¸ĕÚ³ĺ§ `d¨YjiZvRĺ±öVKkjGȊÄePĞZmļKÀ[`ösìhïÎoĬdtKÞ{¬èÒÒBÔpĲÇĬJŊ¦±J«Y§@·pHµàåVKepWftsAÅqC·¬ko«pHÆuK@oHĆÛķhxenS³àǍrqƶRbzy¸ËÐl¼EºpĤ¼x¼½~Ğà@ÚüdK^mÌSj"],"encodeOffsets":[[110234,38774]]}},{"type":"Feature","id":"620000","properties":{"id":"620000","cp":[103.823557,36.058039],"name":"甘肃","childNum":2},"geometry":{"type":"MultiPolygon","coordinates":[["@@VuUv"],["@@ũEĠtt~nkh`Q¦ÅÄÜdwAb×ĠąJ¤DüègĺqBqj°lI¡ĨÒ¤úSHbjÎB°aZ¢KJO[|A£Dx}NĂ¬HUnrk kp¼Y kMJn[aGáÚÏ[½rc}aQxOgsPMnUsncZsKúvAtÞġ£®ĀYKdnFw¢JE°Latf`¼h¬we|Æbj}GA·~W`¢MC¤tL©Ĳ°qdfObÞĬ¹ttu`^ZúE`[@Æsîz®¡CƳƜG²R¢RmfwĸgÜą G@pzJM½mhVy¸uÈÔO±¨{LfæU¶ßGĂq\\ª¬²I¥IŉÈīoıÓÑAçÑ|«LÝcspīðÍgtë_õ\\ĉñLYnĝgRǡÁiHLlõUĹ²uQjYi§Z_c¨´ĹĖÙ·ŋIaBD­R¹ȥr¯GºßK¨jWkɱOqWĳ\\a­Q\\sg_ĆǛōëp»£lğÛgSŶN®À]ÓämĹãJaz¥V}Le¤Lýo¹IsŋÅÇ^bz³tmEÁ´a¹cčecÇNĊãÁ\\č¯dNj]jZµkÓdaćå]ğĳ@ ©O{¤ĸm¢E·®«|@Xwg]Aģ±¯XǁÑǳªcwQÚŝñsÕ³ÛV_ý¥\\ů¥©¾÷w©WÕÊĩhÿÖÁRo¸V¬âDb¨hûxÊ×ǌ~Zâg|XÁnßYoº§ZÅŘv[ĭÖʃuďxcVbnUSfB¯³_TzºÎO©çMÑ~M³]µ^püµÄY~y@X~¤Z³[Èōl@®Å¼£QK·Di¡ByÿQ_´D¥hŗy^ĭÁZ]cIzýah¹MĪğPs{ò²Vw¹t³ŜË[Ñ}X\\gsF£sPAgěp×ëfYHāďÖqēŭOÏëdLü\\it^c®RÊº¶¢H°mrY£B¹čIoľu¶uI]vģSQ{UŻÅ}QÂ|Ì°ƅ¤ĩŪU ęĄÌZÒ\\v²PĔ»ƢNHĂyAmƂwVm`]ÈbH`Ì¢²ILvĜH®¤Dlt_¢JJÄämèÔDëþgºƫaʎÌrêYi~ Îİ¤NpÀA¾Ĕ¼bð÷®üszMzÖĖQdȨýv§Tè|ªHÃ¾a¸|Ð ƒwKĢx¦ivr^ÿ ¸l öæfƟĴ·PJv}n\\h¹¶v·À|\\ƁĚN´ĜçèÁz]ġ¤²¨QÒŨTIlªťØ}¼˗ƦvÄùØEÂ«FïËIqōTvāÜŏíÛßÛVj³âwGăÂíNOPìyV³ŉĖýZso§HÑiYw[ß\\X¦¥c]ÔƩÜ·«jÐqvÁ¦m^ċ±R¦΋ƈťĚgÀ»IïĨʗƮ°ƝĻþÍAƉſ±tÍEÕÞāNUÍ¡\\ſčåÒʻĘm ƭÌŹöʥëQ¤µ­ÇcƕªoIýIÉ_mkl³ăƓ¦j¡YzŇi}Msßõīʋ }ÁVm_[n}eı­Uĥ¼ªI{Î§DÓƻėojqYhĹT©oūĶ£]ďxĩǑMĝq`B´ƃ˺Чç~²ņj@¥@đ´ί}ĥtPńÇ¾V¬ufÓÉCtÓ̻¹£G³]ƖƾŎĪŪĘ̖¨ʈĢƂlɘ۪üºňUðǜȢƢż̌ȦǼĤŊɲĖÂ­Kq´ï¦ºĒǲņɾªǀÞĈĂD½ĄĎÌŗĞrôñnN¼â¾ʄľԆ|Ǆ֦ज़ȗǉ̘̭ɺƅêgV̍ʆĠ·ÌĊv|ýĖÕWĊǎÞ´õ¼cÒÒBĢ͢UĜð͒s¨ňƃLĉÕÝ@ɛƯ÷¿Ľ­ĹeȏĳëCȚDŲyê×Ŗyò¯ļcÂßYtÁƤyAã˾J@ǝrý@¤rz¸oP¹ɐÚyáHĀ[JwcVeȴÏ»ÈĖ}ƒŰŐèȭǢόĀƪÈŶë;Ñ̆ȤМľĮEŔĹŊũ~ËUă{ĻƹɁύȩþĽvĽƓÉ@ēĽɲßǐƫʾǗĒpäWÐxnsÀ^ƆwW©¦cÅ¡Ji§vúF¶¨c~c¼īeXǚ\\đ¾JwÀďksãAfÕ¦L}waoZD½Ml«]eÒÅaÉ²áo½FõÛ]ĻÒ¡wYR£¢rvÓ®y®LFLzĈôe]gx}|KK}xklL]c¦£fRtív¦PĤoH{tK"]],"encodeOffsets":[[[108619,36299]],[[108589,36341]]]}},{"type":"Feature","id":"630000","properties":{"id":"630000","cp":[96.778916,35.623178],"name":"青海","childNum":2},"geometry":{"type":"MultiPolygon","coordinates":[["@@InJm"],["@@CÆ½OŃĦsΰ~Ē³¦@@Ņi±è}ШƄ˹A³r_ĞǒNĪĐw¤^ŬĵªpĺSZgrpiƼĘÔ¨C|ÍJ©Ħ»®VĲ~f\\m `UnÂ~ʌĬàöNt~ňjy¢ZiƔ¥Ąk´nl`JÊJþ©pdƖ®È£¶ìRʦźõƮËnʼėæÑƀĎ[¢VÎĂMÖÝÎF²sƊƀÎBļýƞ¯ʘƭðħ¼Jh¿ŦęΌƇ¥²Q]Č¥nuÂÏri¸¬ƪÛ^Ó¦d¥[Wàx\\ZjÒ¨GtpþYŊĕ´zUOëPîMĄÁxH´áiÜUàîÜŐĂÛSuŎrJðÌ¬EFÁú×uÃÎkrĒ{V}İ«O_ÌËĬ©ÓŧSRÑ±§Ģ£^ÂyèçěM³Ƃę{[¸¿uºµ[gt£¸OƤĿéYõ·kĀq]juw¥DĩƍõÇPéÄ½G©ã¤GuȧþRcÕĕNyyût­øï»a½ē¿BMoį£Íj}éZËqbʍƬh¹ìÿÓAçãnIÃ¡I`ks£CG­ěUy×Cy@¶ʡÊBnāzGơMē¼±O÷õJËĚăVĪũƆ£¯{ËL½ÌzżVR|ĠTbuvJvµhĻĖHAëáa­OÇðñęNwœľ·LmI±íĠĩPÉ×®ÿscB³±JKßĊ«`ađ»·QAmOVţéÿ¤¹SQt]]Çx±¯A@ĉĳ¢Óļ©l¶ÅÛrŕspãRk~¦ª]Į­´FRåd­ČsCqđéFn¿ÅƃmÉx{W©ºƝºįkÕƂƑ¸wWūÐ©ÈF£\\tÈ¥ÄRÈýÌJ lGr^×äùyÞ³fjc¨£ÂZ|ǓMĝÏ@ëÜőRĝ÷¡{aïȷPu°ËXÙ{©TmĠ}Y³­ÞIňµç½©C¡į÷¯B»|St»]vųs»}MÓ ÿʪƟǭA¡fs»PY¼c¡»¦cċ­¥£~msĉPSi^o©AecPeǵkgyUi¿h}aHĉ^|á´¡HØûÅ«ĉ®]m¡qĉ¶³ÈyôōLÁstB®wn±ă¥HSòė£Së@×œÊăxÇN©©T±ª£Ĳ¡fb®Þbb_Ą¥xu¥B{łĝ³«`dƐt¤ťiñÍUuºí`£^tƃĲc·ÛLO½sç¥Ts{ă\\_»kÏ±q©čiìĉ|ÍI¥ć¥]ª§D{ŝŖÉR_sÿc³ĪōƿÎ§p[ĉc¯bKmR¥{³Ze^wx¹dƽÅ½ôIg §Mĕ ƹĴ¿ǣÜÍ]Ý]snåA{eƭ`ǻŊĿ\\ĳŬűYÂÿ¬jĖqßb¸L«¸©@ěĀ©ê¶ìÀEH|´bRľÓ¶rÀQþvl®ÕETzÜdb hw¤{LRdcb¯ÙVgƜßzÃôì®^jUèXÎ|UäÌ»rK\\ªN¼pZCüVY¤ɃRi^rPŇTÖ}|br°qňbĚ°ªiƶGQ¾²x¦PmlŜ[Ĥ¡ΞsĦÔÏâ\\ªÚŒU\\f¢N²§x|¤§xĔsZPòʛ²SÐqF`ªVÞŜĶƨVZÌL`¢dŐIqr\\oäõFÎ·¤»Ŷ×h¹]ClÙ\\¦ďÌį¬řtTӺƙgQÇÓHţĒ´ÃbEÄlbʔC|CŮkƮ[ʼ¬ň´KŮÈΰÌĪ¶ƶlðļATUvdTGº̼ÔsÊDÔveOg"]],"encodeOffsets":[[[105308,37219]],[[95370,40081]]]}},{"type":"Feature","id":"640000","properties":{"id":"640000","cp":[106.278179,37.26637],"name":"宁夏","childNum":2},"geometry":{"type":"MultiPolygon","coordinates":[["@@KëÀęĞ«Oęȿȕı]ŉ¡åįÕÔ«ǴõƪĚQÐZhv K°öqÀÑS[ÃÖHƖčËnL]ûcÙß@ĝ¾}w»»oģF¹»kÌÏ·{zP§B­¢íyÅt@@á]Yv_ssģ¼ißĻL¾ġsKD£¡N_X¸}B~HaiÅf{«x»ge_bsKF¯¡IxmELcÿZ¤­ĢÝsuBLùtYdmVtNmtOPhRw~bd¾qÐ\\âÙH\\bImlNZ»loqlVmGā§~QCw¤{A\\PKNY¯bFkC¥sks_Ã\\ă«¢ħkJi¯rrAhĹûç£CUĕĊ_ÔBixÅÙĄnªÑaM~ħpOu¥sîeQ¥¤^dkKwlL~{L~hw^ófćKyE­K­zuÔ¡qQ¤xZÑ¢^ļöÜ¾Ep±âbÊÑÆ^fk¬NC¾YpxbK~¥eÖäBlt¿Đx½I[ĒǙWf»Ĭ}d§dµùEuj¨IÆ¢¥dXªƅx¿]mtÏwßRĶX¢͎vÆzƂZò®ǢÌʆCrâºMÞzÆMÒÊÓŊZÄ¾r°Î®Ȉmª²ĈUªĚîøºĮ¦ÌĘk^FłĬhĚiĀĖ¾iİbjÕ"],["@@mfwěwMrŢªv@G"]],"encodeOffsets":[[[109366,40242]],[[108600,36303]]]}},{"type":"Feature","id":"650000","properties":{"id":"650000","cp":[85.617733,40.792818],"name":"新疆","childNum":1},"geometry":{"type":"Polygon","coordinates":["@@QØĔ²X¨~ǘBºjʐßØvKƔX¨vĊOÃ·¢i@~cĝe_«E}QxgɪëÏÃ@sÅyXoŖ{ô«ŸuXêÎf`C¹ÂÿÐGĮÕĞXŪōŸMźÈƺQèĽôe|¿ƸJR¤ĘEjcUóº¯Ĩ_ŘÁMª÷Ð¥OéÈ¿ÖğǤǷÂFÒzÉx[]­Ĥĝœ¦EP}ûƥé¿İƷTėƫœŕƅƱB»Đ±ēO¦E}`cȺrĦáŖuÒª«ĲπdƺÏØZƴwʄ¤ĖGĐǂZĶèH¶}ÚZצʥĪï|ÇĦMŔ»İĝǈì¥Βba­¯¥ǕǚkĆŵĦɑĺƯxūД̵nơʃĽá½M»òmqóŘĝčË¾ăCćāƿÝɽ©ǱŅ¹đ¥³ðLrÁ®ɱĕģŉǻ̋ȥơŻǛȡVï¹Ň۩ûkɗġƁ§ʇė̕ĩũƽō^ƕUv£ƁQïƵkŏ½ΉÃŭÇ³LŇʻ«ƭ\\lŭD{ʓDkaFÃÄa³ŤđÔGRÈƚhSӹŚsİ«ĐË[¥ÚDkº^Øg¼ŵ¸£EÍöůŉT¡c_ËKYƧUśĵÝU_©rETÏʜ±OñtYwē¨{£¨uM³x½şL©Ùá[ÓÐĥ Νtģ¢\\śnkOw¥±T»ƷFɯàĩÞáB¹ÆÑUwŕĽw[mG½Èå~Æ÷QyěCFmĭZīŵVÁƿQƛûXS²b½KÏ½ĉS©ŷXĕ{ĕK·¥Ɨcqq©f¿]ßDõU³h­gËÇïģÉɋwk¯í}I·œbmÉřīJɥĻˁ×xoɹīlc¤³Xù]ǅA¿w͉ì¥wÇN·ÂËnƾƍdÇ§đ®ƝvUm©³G\\}µĿQyŹlăµEwǇQ½yƋBe¶ŋÀůo¥AÉw@{Gpm¿AĳŽKLh³`ñcËtW±»ÕSëüÿďDu\\wwwù³VLŕOMËGh£õP¡erÏd{ġWÁč|yšg^ğyÁzÙs`s|ÉåªÇ}m¢Ń¨`x¥ù^}Ì¥H«YªƅAÐ¹n~ź¯f¤áÀzgÇDIÔ´AňĀÒ¶ûEYospõD[{ù°]uJqU|Soċxţ[õÔĥkŋÞŭZËºóYËüċrw ÞkrťË¿XGÉbřaDü·Ē÷AÃª[ÄäIÂ®BÕĐÞ_¢āĠpÛÄȉĖġDKwbmÄNôfƫVÉviǳHQµâFù­Âœ³¦{YGd¢ĚÜO {Ö¦ÞÍÀP^bƾl[vt×ĈÍEË¨¡Đ~´î¸ùÎhuè`¸HÕŔVºwĠââWò@{ÙNÝ´ə²ȕn{¿¥{l÷eé^eďXj©î\\ªÑòÜìc\\üqÕ[Č¡xoÂċªbØ­ø|¶ȴZdÆÂońéG\\¼C°ÌÆn´nxÊOĨŪƴĸ¢¸òTxÊǪMīĞÖŲÃɎOvʦƢ~FRěò¿ġ~åŊúN¸qĘ[Ĕ¶ÂćnÒPĒÜvúĀÊbÖ{Äî¸~Ŕünp¤ÂH¾ĄYÒ©ÊfºmÔĘcDoĬMŬS¤s²ʘÚžȂVŦ èW°ªB|ĲXŔþÈJĦÆæFĚêYĂªĂ]øªŖNÞüAfɨJ¯ÎrDDĤ`mz\\§~D¬{vJÂ«lµĂb¤pŌŰNĄ¨ĊXW|ų ¿¾ɄĦƐMTòP÷fØĶK¢ȝ˔Sô¹òEð­`Ɩ½ǒÂň×äı§ĤƝ§C~¡hlåǺŦŞkâ~}FøàĲaĞfƠ¥Ŕd®U¸źXv¢aƆúŪtŠųƠjdƺƺÅìnrh\\ĺ¯äɝĦ]èpĄ¦´LƞĬ´ƤǬ˼Ēɸ¤rºǼ²¨zÌPðŀbþ¹ļD¢¹\\ĜÑŚ¶ZƄ³àjĨoâȴLÊȮĐ­ĚăÀêZǚŐ¤qȂ\\L¢ŌİfÆs|zºeªÙæ§΢{Ā´ƐÚ¬¨Ĵà²łhʺKÞºÖTiƢ¾ªì°`öøu®Ê¾ãØ"],"encodeOffsets":[[88824,50096]]}},{"type":"Feature","id":"110000","properties":{"id":"110000","cp":[116.405285,39.9988],"name":"北京","childNum":1},"geometry":{"type":"Polygon","coordinates":["@@ĽOÁûtŷmiÍt_H»Ĩ±d`¹­{bwYr³S]§§o¹qGtm_SŧoaFLgQN_dV@Zom_ć\\ßcÂ±x¯oœRcfe£o§ËgToÛJíĔóu|wP¤XnO¢ÉŦ¯rNÄā¤zâŖÈRpŢZÚ{GrFt¦Òx§ø¹RóäV¤XdżâºWbwŚ¨Ud®bêņ¾jnŎGŃŶnzÚSeîĜZczî¾i]ÍQaúÍÔiþĩȨWĢü|Ėu[qb[swP@ÅğP¿{\\¥A¨ÏÑ¨j¯X\\¯MKpA³[Hīu}}"],"encodeOffsets":[[120023,41045]]}},{"type":"Feature","id":"120000","properties":{"id":"120000","cp":[117.190182,39.125596],"name":"天津","childNum":1},"geometry":{"type":"Polygon","coordinates":["@@ŬgX§Ü«E¶FÌ¬O_ïlÁgz±AXeµÄĵ{¶]gitgIj·¥îakS¨ÐƎk}ĕ{gBqGf{¿aU^fIư³õ{YıëNĿk©ïËZŏR§òoY×Ógcĥs¡bġ«@dekąI[nlPqCnp{ō³°`{PNdƗqSÄĻNNâyj]äÒD ĬH°Æ]~¡HO¾X}ÐxgpgWrDGpù^LrzWxZ^¨´T\\|~@IzbĤjeĊªz£®ĔvěLmV¾Ô_ÈNW~zbĬvG²ZmDM~~"],"encodeOffsets":[[120237,41215]]}},{"type":"Feature","id":"310000","properties":{"id":"310000","cp":[121.472644,31.231706],"name":"上海","childNum":6},"geometry":{"type":"MultiPolygon","coordinates":[["@@ɧư¬EpƸÁxc"],["@@©ª"],["@@MA"],["@@QpİE§ÉC¾"],["@@bŝÕÕEȣÚƥêImɇǦèÜĠÚÃƌÃ͎ó"],["@@ǜûȬɋŭ×^sYɍDŋŽąñCG²«ªč@h_p¯A{oloY¬j@Ĳ`gQÚhr|ǀ^MĲvtbe´R¯Ô¬¨Yô¤r]ìƬį"]],"encodeOffsets":[[[124702,32062]],[[124547,32200]],[[124808,31991]],[[124726,32110]],[[124903,32376]],[[124438,32149]]]}},{"type":"Feature","id":"500000","properties":{"id":"500000","cp":[107.304962,29.533155],"name":"重庆","childNum":2},"geometry":{"type":"MultiPolygon","coordinates":[["@@vjG~nGŘŬĶȂƀƾ¹¸ØÎezĆT¸}êÐqHðqĖä¥^CÆIj²p\\_ æüY|[YxƊæu°xb®Űb@~¢NQt°¶Sæ Ê~rǉĔëĚ¢~uf`faĔJåĊnÖ]jƎćÊ@£¾a®£Ű{ŶĕFègLk{Y|¡ĜWƔtƬJÑxq±ĢN´òKLÈÃ¼D|s`ŋć]Ã`đMûƱ½~Y°ħ`ƏíW½eI½{aOIrÏ¡ĕŇapµÜƅġ^ÖÛbÙŽŏml½SêqDu[RãË»ÿw`»y¸_ĺę}÷`M¯ċfCVµqŉ÷Zgg`d½pDOÎCn^uf²ènh¼WtƏxRGg¦pVFI±G^Ic´ecGĹÞ½sëĬhxW}KÓe­XsbkF¦LØgTkïƵNï¶}Gyw\\oñ¡nmĈzj@Óc£»Wă¹Ój_m»¹·~MvÛaq»­ê\\ÂoVnÓØÍ²«bq¿efE Ĝ^Q~ Évýş¤²ĮpEİ}zcĺL½¿gÅ¡ýE¡ya£³t\\¨\\vú»¼§·Ñr_oÒý¥u_n»_At©ÞÅ±ā§IVeëY}{VPÀFA¨ąB}q@|Ou\\FmQFÝMwå}]|FmÏCawu_p¯sfÙgYDHl`{QEfNysB¦zG¸rHeN\\CvEsÐùÜ_·ÖĉsaQ¯}_UxÃđqNH¬Äd^ÝŰR¬ã°wećJE·vÝ·HgéFXjÉê`|ypxkAwWĐpb¥eOsmzwqChóUQl¥F^lafanòsrEvfQdÁUVfÎvÜ^eftET¬ôA\\¢sJnQTjPØxøK|nBzĞ»LYFDxÓvr[ehľvN¢o¾NiÂxGpâ¬zbfZo~hGi]öF||NbtOMn eA±tPTLjpYQ|SHYĀxinzDJÌg¢và¥Pg_ÇzIIII£®S¬ØsÎ¼£N"],["@@ifjN@s"]],"encodeOffsets":[[[109628,30765]],[[111725,31320]]]}},{"type":"Feature","id":"810000","properties":{"id":"810000","cp":[115.5,22.320048],"name":"香港","childNum":5},"geometry":{"type":"MultiPolygon","coordinates":[["@@AlBk"],["@@mn"],["@@EpFo"],["@@ea¢pl¸Eõ¹hj[]ÔCÎ@lj¡uBX´AI¹[yDU]W`çwZkmcMpÅv}IoJlcafŃK°ä¬XJmÐ đhI®æÔtSHnEÒrÈc"],["@@rMUwAS®e"]],"encodeOffsets":[[[117111,23002]],[[117072,22876]],[[117045,22887]],[[116975,23082]],[[116882,22747]]]}},{"type":"Feature","id":"820000","properties":{"id":"820000","cp":[113.54909,21.198951],"name":"澳门","childNum":1},"geometry":{"type":"Polygon","coordinates":["@@kÊd°å§s"],"encodeOffsets":[[116279,22639]]}}],"UTF8Encoding":true}

/***/ }),

/***/ 1724:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1726:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(743)();
// imports


// module
exports.push([module.i, ".table{border:1px solid #eee;width:80%;border-collapse:collapse}.table .label{border:1px solid #aaa;padding:5px;text-align:left}.comlabel,.label,.label2,.right_table{height:24px!important}.fa.fa-remove{font-size:24px!important}.table .tableTitle{border:1px solid #aaa;color:#000;font-weight:bolder;padding:5px;text-align:left}.el-table{color:#333}.el-table td,.el-table th{padding:0}.el-table th>.cell{line-height:20px;padding:0;padding-right:5px;min-height:40px;display:flex;align-items:center}.el-table th.is-center>.cell{justify-content:center}.el-table td>.cell,.el-table th>.cell{padding-left:5px;font-size:14px}.btn{border:none;background:none;outline:none;padding:1px;cursor:pointer}.btn-blue{color:#409eff}.btn-red{color:#f56c6c}.blue-bg-btn{width:132px;height:40px;color:#fff;font-size:13px;background-image:linear-gradient(#41a0eb,#07c);border-radius:4px;border:none;outline:none}.blue-bg-btn:hover{color:#fff}.My_button{width:132px;height:40px;background:linear-gradient(0deg,#07c,#41a0eb);border:1px solid #07c;border-radius:4px;font-size:13px}.new_button{background:#eee;color:#000;border:1px solid #eee;border-radius:4px;font-size:13px}.overflow-2{-webkit-line-clamp:2}.overflow-2,.overflow-3{display:-webkit-box!important;overflow:hidden;text-overflow:ellipsis;word-break:break-all;-webkit-box-orient:vertical}.overflow-3{-webkit-line-clamp:3}.headlines{font-family:PingFang-M;font-weight:700;border-bottom:1px solid #eee;height:50px;line-height:5px;color:#000;line-height:50px;font-size:20px;margin-top:0}.el-tabs__nav-wrap:after{height:1px}.el-tabs__header{margin:0 0 20px}.el-tabs__item{height:32px;line-height:20px;padding:0 10px}.el-tabs__active-bar{height:1px}.toolbar{background:#fff;padding:10px;margin:10px 0}.title{height:50px;line-height:50px;text-align:left;border-bottom:1px solid #eee;margin-top:10px}.title .text{font-size:20px;margin-left:10px;font-family:PingFang-SC-Bold}th{font-weight:400}.el-form-item__label{text-align:left}.el-form-item__content,.el-form-item__label{font-size: 13px;color:#000}.el-table .cell{padding-left:0}.el-popper[x-placement^=bottom]{margin-top:0}.el-popper[x-placement^=top]{margin-bottom:0}.yy-style .el-col:before,.yy-style .el-form-item__label:before{content:\"*\";color:red;margin-right:3px}.btn-custom-cancel{float:right;margin-left:10px}.headlines,.title{position:relative}.headlines .seal,.title .seal{display:inline-block;width:82px;height:74px;position:absolute;bottom:-30px;right:0}.loading-custom{font-size:40px;z-index:999999999!important;height:100%!important;position:fixed}.el-dialog__body .search{width:250px}.default-btn,.el-dialog__body .default-btn,.el-dialog__footer .default-btn{width:100px}.el-dialog__body textarea{height:148px}.el-dialog__footer{text-align:center}.el-dialog__body .el-table th{padding:0}.s-page{padding:15px 5px}.zj-table .el-dialog__body{padding:10px 20px}.sp-table .el-dialog__body{padding:10px 20px 60px}.sp-table .el-pagination{padding:15px 5px}", "", {"version":3,"sources":["D:/work/xinmei_erp_v4.7_Complete/web-pcadmin/src/assets/css/common.css"],"names":[],"mappings":"AACA,OACI,sBAAsB,AAAC,UAAW,AAClC,wBAAwB,CAC3B,AAED,cACK,sBAAsB,AAAC,YAAa,eAAiB,CACzD,AACD,sCAAsC,qBAAsB,CAAC,AAC7D,cAAc,wBAA2B,CAAC,AAC1C,mBACI,sBAAsB,AAAC,WAAa,AAAC,mBAAoB,AAAC,YAAa,eAAiB,CAC3F,AAGD,UACI,UAAY,CACf,AACD,0BACC,SAAe,CACf,AACD,mBACI,iBAAkB,AAClB,UAAW,AACX,kBAAmB,AACnB,gBAAiB,AACjB,aAAc,AACd,kBAAoB,CACvB,AACD,6BACI,sBAAwB,CAC3B,AAED,sCACC,iBAAkB,AACf,cAAgB,CACnB,AAGD,KACI,YAAY,AACZ,gBAAiB,AACjB,aAAc,AACd,YAAY,AACZ,cAAgB,CACnB,AACD,UACI,aAAc,CACjB,AACD,SACI,aAAc,CACjB,AAED,aACI,YAAY,AACZ,YAAY,AACZ,WAAW,AACX,eAAgB,AAChB,+CAAoD,AACpD,kBAAmB,AACnB,YAAY,AACZ,YAAc,CACjB,AACD,mBACG,UAAW,CACb,AAED,WACI,YAAY,AACZ,YAAY,AACZ,8CAAsE,AACtE,sBAAmC,AACnC,kBAAkB,AAClB,cAAgB,CACnB,AACD,YACI,gBAAiB,AACjB,WAAY,AACZ,sBAAqC,AACrC,kBAAkB,AAClB,cAAgB,CACnB,AAGD,YAMI,oBAAqB,CACxB,AACD,wBAPI,8BAAgC,AAChC,gBAAgB,AAChB,uBAAuB,AACvB,qBAAqB,AACrB,2BAA4B,CAU/B,AAPD,YAMI,oBAAqB,CACxB,AACD,WAEI,uBAA0B,AAC1B,gBAAkB,AAClB,6BAA8B,AAC9B,YAAY,AACZ,gBAAiB,AACjB,WAAW,AACX,iBAAkB,AAClB,eAAgB,AAChB,YAAgB,CACnB,AAGD,yBACI,UAAY,CACf,AACD,iBACI,eAAiB,CACpB,AACD,eACI,YAAa,AACb,iBAAkB,AAClB,cAAe,CAClB,AACD,qBACI,UAAY,CACf,AAID,SACC,gBAAiB,AACjB,aAAc,AACd,aAAiB,CAEjB,AAGD,OACI,YAAa,AACb,iBAAkB,AAClB,gBAAiB,AACjB,6BAA8B,AAC9B,eAAiB,CACpB,AACD,aACI,eAAgB,AAChB,iBAAkB,AAClB,4BAA8B,CACjC,AAGD,GACC,eAAoB,CACpB,AAED,qBAGI,eAAiB,CACpB,AACD,4CAJC,gBAAgB,AAChB,UAAY,CAMZ,AAED,gBACI,cAAgB,CACnB,AAGD,gCACI,YAAc,CACjB,AACD,6BACI,eAAiB,CACpB,AAQD,+DACI,YAAa,AACb,UAAU,AACV,gBAAkB,CACrB,AAGD,mBACI,YAAa,AACb,gBAAkB,CACrB,AAGD,kBACI,iBAAmB,CACtB,AACD,8BACI,qBAAsB,AACtB,WAAY,AACZ,YAAa,AACb,kBAAmB,AACnB,aAAc,AACd,OAAS,CACZ,AAGD,gBACI,eAAgB,AAChB,4BAA8B,AAC9B,sBAAwB,AACxB,cAAgB,CACnB,AAGD,yBACI,WAAa,CAChB,AACD,2EACI,WAAa,CAChB,AACD,0BACI,YAAc,CACjB,AACD,mBACI,iBAAmB,CACtB,AACD,8BACI,SAAiB,CACpB,AACD,QACI,gBAAkB,CACrB,AACD,2BACI,iBAAmB,CACtB,AACD,2BACI,sBAAwB,CAC3B,AACD,yBACI,gBAAkB,CACrB","file":"common.css","sourcesContent":["/* 表格样式 */\r\n.table{\r\n    border:1px solid #eee; width: 80%; \r\n    border-collapse:collapse  \r\n} \r\n/*1.5rem修改 没微信端html的font-size没设置时候1rem=16px 兼容移动pc端把pc端rem改成px*/\r\n.table .label{\r\n     border:1px solid #aaa; padding: 5px;text-align: left;\r\n}\r\n.label2,.label,.comlabel,.right_table{height:24px !important}\r\n.fa.fa-remove{font-size: 24px !important;}\r\n.table .tableTitle{\r\n    border:1px solid #aaa; color:black ; font-weight: bolder; padding: 5px;text-align: left;\r\n}\r\n\r\n/* elementui--table样式 */\r\n.el-table{\r\n    color: #333;\r\n}\r\n.el-table td, .el-table th{\r\n\tpadding: 0px 0;\r\n}\r\n.el-table th>.cell{\r\n    line-height: 20px;\r\n    padding: 0;\r\n    padding-right: 5px;\r\n    min-height: 40px;/* ui优化适配 */\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n.el-table th.is-center>.cell{\r\n    justify-content: center;\r\n}\r\n/* ui优化适配 */\r\n.el-table td>.cell, .el-table th>.cell{\r\n\tpadding-left: 5px;\r\n    font-size: 14px;\r\n}\r\n\r\n/* 按钮 */\r\n.btn{\r\n    border:none;\r\n    background: none;\r\n    outline: none;\r\n    padding:1px;\r\n    cursor: pointer;\r\n}\r\n.btn-blue{\r\n    color:#409EFF;\r\n}\r\n.btn-red{\r\n    color:#f56c6c;\r\n}\r\n\r\n.blue-bg-btn{\r\n    width:132px;\r\n    height:40px;\r\n    color:#fff;\r\n    font-size: 13px;\r\n    background-image: linear-gradient(#41A0EB, #0077CC);\r\n    border-radius: 4px;\r\n    border:none;\r\n    outline: none;\r\n}\r\n.blue-bg-btn:hover{\r\n   color:#fff;\r\n}\r\n/*查询按钮*/\r\n.My_button{\r\n    width:132px;\r\n    height:40px;\r\n    background:linear-gradient(0deg,rgba(0,119,204,1),rgba(65,160,235,1));\r\n    border:1px solid rgba(0,119,204,1);\r\n    border-radius:4px;\r\n    font-size: 13px;\r\n}\r\n.new_button{\r\n    background: #eee;\r\n    color: #000;\r\n    border:1px solid rgba(238,238,238,1);\r\n    border-radius:4px;\r\n    font-size: 13px;\r\n}\r\n\r\n\r\n.overflow-2{\r\n    display: -webkit-box !important;\r\n    overflow:hidden;\r\n    text-overflow:ellipsis;\r\n    word-break:break-all;\r\n    -webkit-box-orient:vertical;\r\n    -webkit-line-clamp:2;   /*(数字2表示隐藏两行)*/\r\n}\r\n.overflow-3{\r\n    display: -webkit-box !important;\r\n    overflow:hidden;\r\n    text-overflow:ellipsis;\r\n    word-break:break-all;\r\n    -webkit-box-orient:vertical;\r\n    -webkit-line-clamp:3;   /*(数字2表示隐藏两行)*/\r\n}\r\n.headlines{\r\n    /* font-family: PingFang-SC-Bold; */\r\n    font-family: 'PingFang-M';\r\n    font-weight: bold;\r\n    border-bottom: 1px solid #eee;\r\n    height:50px;\r\n    line-height: 5px;\r\n    color:#000;\r\n    line-height: 50px;\r\n    font-size: 20px;\r\n    margin-top: 0px;/* ui优化适配 */\r\n}\r\n\r\n/* tab栏样式 */\r\n.el-tabs__nav-wrap::after{\r\n    height: 1px;\r\n}\r\n.el-tabs__header{\r\n    margin: 0 0 20px;\r\n}\r\n.el-tabs__item{\r\n    height: 32px;\r\n    line-height: 20px;\r\n    padding:0 10px;\r\n}\r\n.el-tabs__active-bar{\r\n    height: 1px;\r\n}\r\n\r\n\r\n/* 分页样式 */\r\n.toolbar {\r\n\tbackground: #fff;\r\n\tpadding: 10px;\r\n\tmargin: 10px 0px;\r\n\t\r\n}\r\n\r\n\r\n.title {\r\n    height: 50px;\r\n    line-height: 50px;\r\n    text-align: left;\r\n    border-bottom: 1px solid #eee;\r\n    margin-top: 10px;\r\n}\r\n.title .text {\r\n    font-size: 20px;\r\n    margin-left: 10px;\r\n    font-family: PingFang-SC-Bold;\r\n}\r\n\r\n\r\nth{\r\n\tfont-weight: normal;\r\n} \r\n\r\n.el-form-item__label{\r\n\tfont-size: 13px;\r\n\tcolor: #000;\r\n    text-align: left;\r\n}\r\n.el-form-item__content{\r\n\tfont-size: 13px;\r\n\tcolor: #000;\r\n}\r\n\r\n.el-table .cell{\r\n    padding-left: 0;\r\n}\r\n\r\n\r\n.el-popper[x-placement^=bottom]{\r\n    margin-top: 0;\r\n}\r\n.el-popper[x-placement^=top] {\r\n    margin-bottom: 0;\r\n}\r\n\r\n\r\n.yy-style .el-col:before{\r\n    content: '*';\r\n    color:red;\r\n    margin-right: 3px;\r\n}\r\n.yy-style .el-form-item__label:before{\r\n    content: '*';\r\n    color:red;\r\n    margin-right: 3px;\r\n}\r\n\r\n/* 设置comfirm弹框的确定按钮在左边，取消按钮在右边，只需设置cancelButtonClass:'btn-custom-cancel' */\r\n.btn-custom-cancel{\r\n    float: right;\r\n    margin-left: 10px;\r\n}\r\n\r\n/* 审批印章样式 */\r\n.headlines, .title{\r\n    position: relative;\r\n}\r\n.headlines .seal, .title .seal{\r\n    display: inline-block;\r\n    width: 82px;\r\n    height: 74px;\r\n    position: absolute;\r\n    bottom: -30px;\r\n    right: 0;\r\n}\r\n\r\n/* 全屏loading效果 */\r\n.loading-custom{\r\n    font-size: 40px;\r\n    z-index: 999999999 !important;\r\n    height: 100% !important;\r\n    position: fixed;\r\n}\r\n\r\n/* ui优化适配 */\r\n.el-dialog__body .search{\r\n    width: 250px;\r\n}\r\n.el-dialog__body .default-btn, .el-dialog__footer .default-btn, .default-btn{\r\n    width: 100px;\r\n}\r\n.el-dialog__body textarea{\r\n    height: 148px;\r\n}\r\n.el-dialog__footer{\r\n    text-align: center;\r\n}\r\n.el-dialog__body .el-table th {\r\n    padding: 0px 0px;\r\n}\r\n.s-page{\r\n    padding: 15px 5px;\r\n}\r\n.zj-table .el-dialog__body {\r\n    padding: 10px 20px;\r\n}\r\n.sp-table .el-dialog__body {\r\n    padding: 10px 20px 60px;\r\n}\r\n.sp-table .el-pagination {\r\n    padding: 15px 5px;\r\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var GLOBAL_USER_NOT_LOGIN = exports.GLOBAL_USER_NOT_LOGIN = 'GLOBAL_USER_NOT_LOGIN';

var TOP_TOOLBAR_DO_QUERY = exports.TOP_TOOLBAR_DO_QUERY = 'TOP_TOOLBAR_DO_QUERY';
var TOP_TOOLBAR_DO_ADD = exports.TOP_TOOLBAR_DO_ADD = 'TOP_TOOLBAR_DO_ADD';

var CONTRACT_AUDIT_STATUS_RESET_OK = exports.CONTRACT_AUDIT_STATUS_RESET_OK = 'CONTRACT_AUDIT_STATUS_RESET_OK';

/***/ }),

/***/ 249:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1506)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(840),
  /* template */
  __webpack_require__(1687),
  /* scopeId */
  "data-v-dbfdcf54",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 264:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1488)
__webpack_require__(1487)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(837),
  /* template */
  __webpack_require__(1674),
  /* scopeId */
  "data-v-6cb4f8ac",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 366:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _defineProperty = __webpack_require__(367);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _iterator = __webpack_require__(369);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(368);

var _symbol2 = _interopRequireDefault(_symbol);

var _getPrototypeOf = __webpack_require__(747);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _typeof2 = __webpack_require__(140);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

!function (e, t) {
  "use strict";
  "object" == ( false ? "undefined" : (0, _typeof3.default)(module)) && "object" == (0, _typeof3.default)(module.exports) ? module.exports = e.document ? t(e, !0) : function (e) {
    if (!e.document) throw new Error("jQuery requires a window with a document");return t(e);
  } : t(e);
}("undefined" != typeof window ? window : undefined, function (e, t) {
  "use strict";
  var n = [],
      r = e.document,
      i = _getPrototypeOf2.default,
      o = n.slice,
      a = n.concat,
      u = n.push,
      s = n.indexOf,
      l = {},
      c = l.toString,
      f = l.hasOwnProperty,
      d = f.toString,
      p = d.call(Object),
      h = {},
      g = function e(t) {
    return "function" == typeof t && "number" != typeof t.nodeType;
  },
      v = function e(t) {
    return null != t && t === t.window;
  },
      y = { type: !0, src: !0, noModule: !0 };function m(e, t, n) {
    var i,
        o = (t = t || r).createElement("script");if (o.text = e, n) for (i in y) {
      n[i] && (o[i] = n[i]);
    }t.head.appendChild(o).parentNode.removeChild(o);
  }function b(e) {
    return null == e ? e + "" : "object" == (typeof e === "undefined" ? "undefined" : (0, _typeof3.default)(e)) || "function" == typeof e ? l[c.call(e)] || "object" : typeof e === "undefined" ? "undefined" : (0, _typeof3.default)(e);
  }var x = "3.3.1 -ajax,-ajax/jsonp,-ajax/load,-ajax/parseXML,-ajax/script,-ajax/var/location,-ajax/var/nonce,-ajax/var/rquery,-ajax/xhr,-manipulation/_evalUrl,-event/ajax,-effects,-effects/Tween,-effects/animatedSelector",
      w = function w(e, t) {
    return new w.fn.init(e, t);
  },
      C = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;w.fn = w.prototype = { jquery: x, constructor: w, length: 0, toArray: function toArray() {
      return o.call(this);
    }, get: function get(e) {
      return null == e ? o.call(this) : e < 0 ? this[e + this.length] : this[e];
    }, pushStack: function pushStack(e) {
      var t = w.merge(this.constructor(), e);return t.prevObject = this, t;
    }, each: function each(e) {
      return w.each(this, e);
    }, map: function map(e) {
      return this.pushStack(w.map(this, function (t, n) {
        return e.call(t, n, t);
      }));
    }, slice: function slice() {
      return this.pushStack(o.apply(this, arguments));
    }, first: function first() {
      return this.eq(0);
    }, last: function last() {
      return this.eq(-1);
    }, eq: function eq(e) {
      var t = this.length,
          n = +e + (e < 0 ? t : 0);return this.pushStack(n >= 0 && n < t ? [this[n]] : []);
    }, end: function end() {
      return this.prevObject || this.constructor();
    }, push: u, sort: n.sort, splice: n.splice }, w.extend = w.fn.extend = function () {
    var e,
        t,
        n,
        r,
        i,
        o,
        a = arguments[0] || {},
        u = 1,
        s = arguments.length,
        l = !1;for ("boolean" == typeof a && (l = a, a = arguments[u] || {}, u++), "object" == (typeof a === "undefined" ? "undefined" : (0, _typeof3.default)(a)) || g(a) || (a = {}), u === s && (a = this, u--); u < s; u++) {
      if (null != (e = arguments[u])) for (t in e) {
        n = a[t], a !== (r = e[t]) && (l && r && (w.isPlainObject(r) || (i = Array.isArray(r))) ? (i ? (i = !1, o = n && Array.isArray(n) ? n : []) : o = n && w.isPlainObject(n) ? n : {}, a[t] = w.extend(l, o, r)) : void 0 !== r && (a[t] = r));
      }
    }return a;
  }, w.extend({ expando: "jQuery" + (x + Math.random()).replace(/\D/g, ""), isReady: !0, error: function error(e) {
      throw new Error(e);
    }, noop: function noop() {}, isPlainObject: function isPlainObject(e) {
      var t, n;return !(!e || "[object Object]" !== c.call(e)) && (!(t = i(e)) || "function" == typeof (n = f.call(t, "constructor") && t.constructor) && d.call(n) === p);
    }, isEmptyObject: function isEmptyObject(e) {
      var t;for (t in e) {
        return !1;
      }return !0;
    }, globalEval: function globalEval(e) {
      m(e);
    }, each: function each(e, t) {
      var n,
          r = 0;if (T(e)) {
        for (n = e.length; r < n; r++) {
          if (!1 === t.call(e[r], r, e[r])) break;
        }
      } else for (r in e) {
        if (!1 === t.call(e[r], r, e[r])) break;
      }return e;
    }, trim: function trim(e) {
      return null == e ? "" : (e + "").replace(C, "");
    }, makeArray: function makeArray(e, t) {
      var n = t || [];return null != e && (T(Object(e)) ? w.merge(n, "string" == typeof e ? [e] : e) : u.call(n, e)), n;
    }, inArray: function inArray(e, t, n) {
      return null == t ? -1 : s.call(t, e, n);
    }, merge: function merge(e, t) {
      for (var n = +t.length, r = 0, i = e.length; r < n; r++) {
        e[i++] = t[r];
      }return e.length = i, e;
    }, grep: function grep(e, t, n) {
      for (var r, i = [], o = 0, a = e.length, u = !n; o < a; o++) {
        (r = !t(e[o], o)) !== u && i.push(e[o]);
      }return i;
    }, map: function map(e, t, n) {
      var r,
          i,
          o = 0,
          u = [];if (T(e)) for (r = e.length; o < r; o++) {
        null != (i = t(e[o], o, n)) && u.push(i);
      } else for (o in e) {
        null != (i = t(e[o], o, n)) && u.push(i);
      }return a.apply([], u);
    }, guid: 1, support: h }), "function" == typeof _symbol2.default && (w.fn[_iterator2.default] = n[_iterator2.default]), w.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function (e, t) {
    l["[object " + t + "]"] = t.toLowerCase();
  });function T(e) {
    var t = !!e && "length" in e && e.length,
        n = b(e);return !g(e) && !v(e) && ("array" === n || 0 === t || "number" == typeof t && t > 0 && t - 1 in e);
  }var E = function (e) {
    var t,
        n,
        r,
        i,
        o,
        a,
        u,
        s,
        l,
        c,
        f,
        d,
        p,
        h,
        g,
        v,
        y,
        m,
        b,
        x = "sizzle" + 1 * new Date(),
        w = e.document,
        C = 0,
        T = 0,
        E = ae(),
        N = ae(),
        k = ae(),
        A = function A(e, t) {
      return e === t && (f = !0), 0;
    },
        D = {}.hasOwnProperty,
        S = [],
        L = S.pop,
        j = S.push,
        q = S.push,
        O = S.slice,
        P = function P(e, t) {
      for (var n = 0, r = e.length; n < r; n++) {
        if (e[n] === t) return n;
      }return -1;
    },
        H = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
        I = "[\\x20\\t\\r\\n\\f]",
        R = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",
        B = "\\[" + I + "*(" + R + ")(?:" + I + "*([*^$|!~]?=)" + I + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + R + "))|)" + I + "*\\]",
        M = ":(" + R + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + B + ")*)|.*)\\)|)",
        W = new RegExp(I + "+", "g"),
        $ = new RegExp("^" + I + "+|((?:^|[^\\\\])(?:\\\\.)*)" + I + "+$", "g"),
        F = new RegExp("^" + I + "*," + I + "*"),
        z = new RegExp("^" + I + "*([>+~]|" + I + ")" + I + "*"),
        _ = new RegExp("=" + I + "*([^\\]'\"]*?)" + I + "*\\]", "g"),
        U = new RegExp(M),
        V = new RegExp("^" + R + "$"),
        X = { ID: new RegExp("^#(" + R + ")"), CLASS: new RegExp("^\\.(" + R + ")"), TAG: new RegExp("^(" + R + "|[*])"), ATTR: new RegExp("^" + B), PSEUDO: new RegExp("^" + M), CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + I + "*(even|odd|(([+-]|)(\\d*)n|)" + I + "*(?:([+-]|)" + I + "*(\\d+)|))" + I + "*\\)|)", "i"), bool: new RegExp("^(?:" + H + ")$", "i"), needsContext: new RegExp("^" + I + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + I + "*((?:-\\d)?\\d*)" + I + "*\\)|)(?=[^-]|$)", "i") },
        Q = /^(?:input|select|textarea|button)$/i,
        Y = /^h\d$/i,
        G = /^[^{]+\{\s*\[native \w/,
        K = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
        J = /[+~]/,
        Z = new RegExp("\\\\([\\da-f]{1,6}" + I + "?|(" + I + ")|.)", "ig"),
        ee = function ee(e, t, n) {
      var r = "0x" + t - 65536;return r !== r || n ? t : r < 0 ? String.fromCharCode(r + 65536) : String.fromCharCode(r >> 10 | 55296, 1023 & r | 56320);
    },
        te = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
        ne = function ne(e, t) {
      return t ? "\0" === e ? "\uFFFD" : e.slice(0, -1) + "\\" + e.charCodeAt(e.length - 1).toString(16) + " " : "\\" + e;
    },
        re = function re() {
      d();
    },
        ie = me(function (e) {
      return !0 === e.disabled && ("form" in e || "label" in e);
    }, { dir: "parentNode", next: "legend" });try {
      q.apply(S = O.call(w.childNodes), w.childNodes), S[w.childNodes.length].nodeType;
    } catch (e) {
      q = { apply: S.length ? function (e, t) {
          j.apply(e, O.call(t));
        } : function (e, t) {
          var n = e.length,
              r = 0;while (e[n++] = t[r++]) {}e.length = n - 1;
        } };
    }function oe(e, t, r, i) {
      var o,
          u,
          l,
          c,
          f,
          h,
          y,
          m = t && t.ownerDocument,
          C = t ? t.nodeType : 9;if (r = r || [], "string" != typeof e || !e || 1 !== C && 9 !== C && 11 !== C) return r;if (!i && ((t ? t.ownerDocument || t : w) !== p && d(t), t = t || p, g)) {
        if (11 !== C && (f = K.exec(e))) if (o = f[1]) {
          if (9 === C) {
            if (!(l = t.getElementById(o))) return r;if (l.id === o) return r.push(l), r;
          } else if (m && (l = m.getElementById(o)) && b(t, l) && l.id === o) return r.push(l), r;
        } else {
          if (f[2]) return q.apply(r, t.getElementsByTagName(e)), r;if ((o = f[3]) && n.getElementsByClassName && t.getElementsByClassName) return q.apply(r, t.getElementsByClassName(o)), r;
        }if (n.qsa && !k[e + " "] && (!v || !v.test(e))) {
          if (1 !== C) m = t, y = e;else if ("object" !== t.nodeName.toLowerCase()) {
            (c = t.getAttribute("id")) ? c = c.replace(te, ne) : t.setAttribute("id", c = x), u = (h = a(e)).length;while (u--) {
              h[u] = "#" + c + " " + ye(h[u]);
            }y = h.join(","), m = J.test(e) && ge(t.parentNode) || t;
          }if (y) try {
            return q.apply(r, m.querySelectorAll(y)), r;
          } catch (e) {} finally {
            c === x && t.removeAttribute("id");
          }
        }
      }return s(e.replace($, "$1"), t, r, i);
    }function ae() {
      var e = [];function t(n, i) {
        return e.push(n + " ") > r.cacheLength && delete t[e.shift()], t[n + " "] = i;
      }return t;
    }function ue(e) {
      return e[x] = !0, e;
    }function se(e) {
      var t = p.createElement("fieldset");try {
        return !!e(t);
      } catch (e) {
        return !1;
      } finally {
        t.parentNode && t.parentNode.removeChild(t), t = null;
      }
    }function le(e, t) {
      var n = e.split("|"),
          i = n.length;while (i--) {
        r.attrHandle[n[i]] = t;
      }
    }function ce(e, t) {
      var n = t && e,
          r = n && 1 === e.nodeType && 1 === t.nodeType && e.sourceIndex - t.sourceIndex;if (r) return r;if (n) while (n = n.nextSibling) {
        if (n === t) return -1;
      }return e ? 1 : -1;
    }function fe(e) {
      return function (t) {
        return "input" === t.nodeName.toLowerCase() && t.type === e;
      };
    }function de(e) {
      return function (t) {
        var n = t.nodeName.toLowerCase();return ("input" === n || "button" === n) && t.type === e;
      };
    }function pe(e) {
      return function (t) {
        return "form" in t ? t.parentNode && !1 === t.disabled ? "label" in t ? "label" in t.parentNode ? t.parentNode.disabled === e : t.disabled === e : t.isDisabled === e || t.isDisabled !== !e && ie(t) === e : t.disabled === e : "label" in t && t.disabled === e;
      };
    }function he(e) {
      return ue(function (t) {
        return t = +t, ue(function (n, r) {
          var i,
              o = e([], n.length, t),
              a = o.length;while (a--) {
            n[i = o[a]] && (n[i] = !(r[i] = n[i]));
          }
        });
      });
    }function ge(e) {
      return e && "undefined" != typeof e.getElementsByTagName && e;
    }n = oe.support = {}, o = oe.isXML = function (e) {
      var t = e && (e.ownerDocument || e).documentElement;return !!t && "HTML" !== t.nodeName;
    }, d = oe.setDocument = function (e) {
      var t,
          i,
          a = e ? e.ownerDocument || e : w;return a !== p && 9 === a.nodeType && a.documentElement ? (p = a, h = p.documentElement, g = !o(p), w !== p && (i = p.defaultView) && i.top !== i && (i.addEventListener ? i.addEventListener("unload", re, !1) : i.attachEvent && i.attachEvent("onunload", re)), n.attributes = se(function (e) {
        return e.className = "i", !e.getAttribute("className");
      }), n.getElementsByTagName = se(function (e) {
        return e.appendChild(p.createComment("")), !e.getElementsByTagName("*").length;
      }), n.getElementsByClassName = G.test(p.getElementsByClassName), n.getById = se(function (e) {
        return h.appendChild(e).id = x, !p.getElementsByName || !p.getElementsByName(x).length;
      }), n.getById ? (r.filter.ID = function (e) {
        var t = e.replace(Z, ee);return function (e) {
          return e.getAttribute("id") === t;
        };
      }, r.find.ID = function (e, t) {
        if ("undefined" != typeof t.getElementById && g) {
          var n = t.getElementById(e);return n ? [n] : [];
        }
      }) : (r.filter.ID = function (e) {
        var t = e.replace(Z, ee);return function (e) {
          var n = "undefined" != typeof e.getAttributeNode && e.getAttributeNode("id");return n && n.value === t;
        };
      }, r.find.ID = function (e, t) {
        if ("undefined" != typeof t.getElementById && g) {
          var n,
              r,
              i,
              o = t.getElementById(e);if (o) {
            if ((n = o.getAttributeNode("id")) && n.value === e) return [o];i = t.getElementsByName(e), r = 0;while (o = i[r++]) {
              if ((n = o.getAttributeNode("id")) && n.value === e) return [o];
            }
          }return [];
        }
      }), r.find.TAG = n.getElementsByTagName ? function (e, t) {
        return "undefined" != typeof t.getElementsByTagName ? t.getElementsByTagName(e) : n.qsa ? t.querySelectorAll(e) : void 0;
      } : function (e, t) {
        var n,
            r = [],
            i = 0,
            o = t.getElementsByTagName(e);if ("*" === e) {
          while (n = o[i++]) {
            1 === n.nodeType && r.push(n);
          }return r;
        }return o;
      }, r.find.CLASS = n.getElementsByClassName && function (e, t) {
        if ("undefined" != typeof t.getElementsByClassName && g) return t.getElementsByClassName(e);
      }, y = [], v = [], (n.qsa = G.test(p.querySelectorAll)) && (se(function (e) {
        h.appendChild(e).innerHTML = "<a id='" + x + "'></a><select id='" + x + "-\r\\' msallowcapture=''><option selected=''></option></select>", e.querySelectorAll("[msallowcapture^='']").length && v.push("[*^$]=" + I + "*(?:''|\"\")"), e.querySelectorAll("[selected]").length || v.push("\\[" + I + "*(?:value|" + H + ")"), e.querySelectorAll("[id~=" + x + "-]").length || v.push("~="), e.querySelectorAll(":checked").length || v.push(":checked"), e.querySelectorAll("a#" + x + "+*").length || v.push(".#.+[+~]");
      }), se(function (e) {
        e.innerHTML = "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";var t = p.createElement("input");t.setAttribute("type", "hidden"), e.appendChild(t).setAttribute("name", "D"), e.querySelectorAll("[name=d]").length && v.push("name" + I + "*[*^$|!~]?="), 2 !== e.querySelectorAll(":enabled").length && v.push(":enabled", ":disabled"), h.appendChild(e).disabled = !0, 2 !== e.querySelectorAll(":disabled").length && v.push(":enabled", ":disabled"), e.querySelectorAll("*,:x"), v.push(",.*:");
      })), (n.matchesSelector = G.test(m = h.matches || h.webkitMatchesSelector || h.mozMatchesSelector || h.oMatchesSelector || h.msMatchesSelector)) && se(function (e) {
        n.disconnectedMatch = m.call(e, "*"), m.call(e, "[s!='']:x"), y.push("!=", M);
      }), v = v.length && new RegExp(v.join("|")), y = y.length && new RegExp(y.join("|")), t = G.test(h.compareDocumentPosition), b = t || G.test(h.contains) ? function (e, t) {
        var n = 9 === e.nodeType ? e.documentElement : e,
            r = t && t.parentNode;return e === r || !(!r || 1 !== r.nodeType || !(n.contains ? n.contains(r) : e.compareDocumentPosition && 16 & e.compareDocumentPosition(r)));
      } : function (e, t) {
        if (t) while (t = t.parentNode) {
          if (t === e) return !0;
        }return !1;
      }, A = t ? function (e, t) {
        if (e === t) return f = !0, 0;var r = !e.compareDocumentPosition - !t.compareDocumentPosition;return r || (1 & (r = (e.ownerDocument || e) === (t.ownerDocument || t) ? e.compareDocumentPosition(t) : 1) || !n.sortDetached && t.compareDocumentPosition(e) === r ? e === p || e.ownerDocument === w && b(w, e) ? -1 : t === p || t.ownerDocument === w && b(w, t) ? 1 : c ? P(c, e) - P(c, t) : 0 : 4 & r ? -1 : 1);
      } : function (e, t) {
        if (e === t) return f = !0, 0;var n,
            r = 0,
            i = e.parentNode,
            o = t.parentNode,
            a = [e],
            u = [t];if (!i || !o) return e === p ? -1 : t === p ? 1 : i ? -1 : o ? 1 : c ? P(c, e) - P(c, t) : 0;if (i === o) return ce(e, t);n = e;while (n = n.parentNode) {
          a.unshift(n);
        }n = t;while (n = n.parentNode) {
          u.unshift(n);
        }while (a[r] === u[r]) {
          r++;
        }return r ? ce(a[r], u[r]) : a[r] === w ? -1 : u[r] === w ? 1 : 0;
      }, p) : p;
    }, oe.matches = function (e, t) {
      return oe(e, null, null, t);
    }, oe.matchesSelector = function (e, t) {
      if ((e.ownerDocument || e) !== p && d(e), t = t.replace(_, "='$1']"), n.matchesSelector && g && !k[t + " "] && (!y || !y.test(t)) && (!v || !v.test(t))) try {
        var r = m.call(e, t);if (r || n.disconnectedMatch || e.document && 11 !== e.document.nodeType) return r;
      } catch (e) {}return oe(t, p, null, [e]).length > 0;
    }, oe.contains = function (e, t) {
      return (e.ownerDocument || e) !== p && d(e), b(e, t);
    }, oe.attr = function (e, t) {
      (e.ownerDocument || e) !== p && d(e);var i = r.attrHandle[t.toLowerCase()],
          o = i && D.call(r.attrHandle, t.toLowerCase()) ? i(e, t, !g) : void 0;return void 0 !== o ? o : n.attributes || !g ? e.getAttribute(t) : (o = e.getAttributeNode(t)) && o.specified ? o.value : null;
    }, oe.escape = function (e) {
      return (e + "").replace(te, ne);
    }, oe.error = function (e) {
      throw new Error("Syntax error, unrecognized expression: " + e);
    }, oe.uniqueSort = function (e) {
      var t,
          r = [],
          i = 0,
          o = 0;if (f = !n.detectDuplicates, c = !n.sortStable && e.slice(0), e.sort(A), f) {
        while (t = e[o++]) {
          t === e[o] && (i = r.push(o));
        }while (i--) {
          e.splice(r[i], 1);
        }
      }return c = null, e;
    }, i = oe.getText = function (e) {
      var t,
          n = "",
          r = 0,
          o = e.nodeType;if (o) {
        if (1 === o || 9 === o || 11 === o) {
          if ("string" == typeof e.textContent) return e.textContent;for (e = e.firstChild; e; e = e.nextSibling) {
            n += i(e);
          }
        } else if (3 === o || 4 === o) return e.nodeValue;
      } else while (t = e[r++]) {
        n += i(t);
      }return n;
    }, (r = oe.selectors = { cacheLength: 50, createPseudo: ue, match: X, attrHandle: {}, find: {}, relative: { ">": { dir: "parentNode", first: !0 }, " ": { dir: "parentNode" }, "+": { dir: "previousSibling", first: !0 }, "~": { dir: "previousSibling" } }, preFilter: { ATTR: function ATTR(e) {
          return e[1] = e[1].replace(Z, ee), e[3] = (e[3] || e[4] || e[5] || "").replace(Z, ee), "~=" === e[2] && (e[3] = " " + e[3] + " "), e.slice(0, 4);
        }, CHILD: function CHILD(e) {
          return e[1] = e[1].toLowerCase(), "nth" === e[1].slice(0, 3) ? (e[3] || oe.error(e[0]), e[4] = +(e[4] ? e[5] + (e[6] || 1) : 2 * ("even" === e[3] || "odd" === e[3])), e[5] = +(e[7] + e[8] || "odd" === e[3])) : e[3] && oe.error(e[0]), e;
        }, PSEUDO: function PSEUDO(e) {
          var t,
              n = !e[6] && e[2];return X.CHILD.test(e[0]) ? null : (e[3] ? e[2] = e[4] || e[5] || "" : n && U.test(n) && (t = a(n, !0)) && (t = n.indexOf(")", n.length - t) - n.length) && (e[0] = e[0].slice(0, t), e[2] = n.slice(0, t)), e.slice(0, 3));
        } }, filter: { TAG: function TAG(e) {
          var t = e.replace(Z, ee).toLowerCase();return "*" === e ? function () {
            return !0;
          } : function (e) {
            return e.nodeName && e.nodeName.toLowerCase() === t;
          };
        }, CLASS: function CLASS(e) {
          var t = E[e + " "];return t || (t = new RegExp("(^|" + I + ")" + e + "(" + I + "|$)")) && E(e, function (e) {
            return t.test("string" == typeof e.className && e.className || "undefined" != typeof e.getAttribute && e.getAttribute("class") || "");
          });
        }, ATTR: function ATTR(e, t, n) {
          return function (r) {
            var i = oe.attr(r, e);return null == i ? "!=" === t : !t || (i += "", "=" === t ? i === n : "!=" === t ? i !== n : "^=" === t ? n && 0 === i.indexOf(n) : "*=" === t ? n && i.indexOf(n) > -1 : "$=" === t ? n && i.slice(-n.length) === n : "~=" === t ? (" " + i.replace(W, " ") + " ").indexOf(n) > -1 : "|=" === t && (i === n || i.slice(0, n.length + 1) === n + "-"));
          };
        }, CHILD: function CHILD(e, t, n, r, i) {
          var o = "nth" !== e.slice(0, 3),
              a = "last" !== e.slice(-4),
              u = "of-type" === t;return 1 === r && 0 === i ? function (e) {
            return !!e.parentNode;
          } : function (t, n, s) {
            var l,
                c,
                f,
                d,
                p,
                h,
                g = o !== a ? "nextSibling" : "previousSibling",
                v = t.parentNode,
                y = u && t.nodeName.toLowerCase(),
                m = !s && !u,
                b = !1;if (v) {
              if (o) {
                while (g) {
                  d = t;while (d = d[g]) {
                    if (u ? d.nodeName.toLowerCase() === y : 1 === d.nodeType) return !1;
                  }h = g = "only" === e && !h && "nextSibling";
                }return !0;
              }if (h = [a ? v.firstChild : v.lastChild], a && m) {
                b = (p = (l = (c = (f = (d = v)[x] || (d[x] = {}))[d.uniqueID] || (f[d.uniqueID] = {}))[e] || [])[0] === C && l[1]) && l[2], d = p && v.childNodes[p];while (d = ++p && d && d[g] || (b = p = 0) || h.pop()) {
                  if (1 === d.nodeType && ++b && d === t) {
                    c[e] = [C, p, b];break;
                  }
                }
              } else if (m && (b = p = (l = (c = (f = (d = t)[x] || (d[x] = {}))[d.uniqueID] || (f[d.uniqueID] = {}))[e] || [])[0] === C && l[1]), !1 === b) while (d = ++p && d && d[g] || (b = p = 0) || h.pop()) {
                if ((u ? d.nodeName.toLowerCase() === y : 1 === d.nodeType) && ++b && (m && ((c = (f = d[x] || (d[x] = {}))[d.uniqueID] || (f[d.uniqueID] = {}))[e] = [C, b]), d === t)) break;
              }return (b -= i) === r || b % r == 0 && b / r >= 0;
            }
          };
        }, PSEUDO: function PSEUDO(e, t) {
          var n,
              i = r.pseudos[e] || r.setFilters[e.toLowerCase()] || oe.error("unsupported pseudo: " + e);return i[x] ? i(t) : i.length > 1 ? (n = [e, e, "", t], r.setFilters.hasOwnProperty(e.toLowerCase()) ? ue(function (e, n) {
            var r,
                o = i(e, t),
                a = o.length;while (a--) {
              e[r = P(e, o[a])] = !(n[r] = o[a]);
            }
          }) : function (e) {
            return i(e, 0, n);
          }) : i;
        } }, pseudos: { not: ue(function (e) {
          var t = [],
              n = [],
              r = u(e.replace($, "$1"));return r[x] ? ue(function (e, t, n, i) {
            var o,
                a = r(e, null, i, []),
                u = e.length;while (u--) {
              (o = a[u]) && (e[u] = !(t[u] = o));
            }
          }) : function (e, i, o) {
            return t[0] = e, r(t, null, o, n), t[0] = null, !n.pop();
          };
        }), has: ue(function (e) {
          return function (t) {
            return oe(e, t).length > 0;
          };
        }), contains: ue(function (e) {
          return e = e.replace(Z, ee), function (t) {
            return (t.textContent || t.innerText || i(t)).indexOf(e) > -1;
          };
        }), lang: ue(function (e) {
          return V.test(e || "") || oe.error("unsupported lang: " + e), e = e.replace(Z, ee).toLowerCase(), function (t) {
            var n;do {
              if (n = g ? t.lang : t.getAttribute("xml:lang") || t.getAttribute("lang")) return (n = n.toLowerCase()) === e || 0 === n.indexOf(e + "-");
            } while ((t = t.parentNode) && 1 === t.nodeType);return !1;
          };
        }), target: function target(t) {
          var n = e.location && e.location.hash;return n && n.slice(1) === t.id;
        }, root: function root(e) {
          return e === h;
        }, focus: function focus(e) {
          return e === p.activeElement && (!p.hasFocus || p.hasFocus()) && !!(e.type || e.href || ~e.tabIndex);
        }, enabled: pe(!1), disabled: pe(!0), checked: function checked(e) {
          var t = e.nodeName.toLowerCase();return "input" === t && !!e.checked || "option" === t && !!e.selected;
        }, selected: function selected(e) {
          return e.parentNode && e.parentNode.selectedIndex, !0 === e.selected;
        }, empty: function empty(e) {
          for (e = e.firstChild; e; e = e.nextSibling) {
            if (e.nodeType < 6) return !1;
          }return !0;
        }, parent: function parent(e) {
          return !r.pseudos.empty(e);
        }, header: function header(e) {
          return Y.test(e.nodeName);
        }, input: function input(e) {
          return Q.test(e.nodeName);
        }, button: function button(e) {
          var t = e.nodeName.toLowerCase();return "input" === t && "button" === e.type || "button" === t;
        }, text: function text(e) {
          var t;return "input" === e.nodeName.toLowerCase() && "text" === e.type && (null == (t = e.getAttribute("type")) || "text" === t.toLowerCase());
        }, first: he(function () {
          return [0];
        }), last: he(function (e, t) {
          return [t - 1];
        }), eq: he(function (e, t, n) {
          return [n < 0 ? n + t : n];
        }), even: he(function (e, t) {
          for (var n = 0; n < t; n += 2) {
            e.push(n);
          }return e;
        }), odd: he(function (e, t) {
          for (var n = 1; n < t; n += 2) {
            e.push(n);
          }return e;
        }), lt: he(function (e, t, n) {
          for (var r = n < 0 ? n + t : n; --r >= 0;) {
            e.push(r);
          }return e;
        }), gt: he(function (e, t, n) {
          for (var r = n < 0 ? n + t : n; ++r < t;) {
            e.push(r);
          }return e;
        }) } }).pseudos.nth = r.pseudos.eq;for (t in { radio: !0, checkbox: !0, file: !0, password: !0, image: !0 }) {
      r.pseudos[t] = fe(t);
    }for (t in { submit: !0, reset: !0 }) {
      r.pseudos[t] = de(t);
    }function ve() {}ve.prototype = r.filters = r.pseudos, r.setFilters = new ve(), a = oe.tokenize = function (e, t) {
      var n,
          i,
          o,
          a,
          u,
          s,
          l,
          c = N[e + " "];if (c) return t ? 0 : c.slice(0);u = e, s = [], l = r.preFilter;while (u) {
        n && !(i = F.exec(u)) || (i && (u = u.slice(i[0].length) || u), s.push(o = [])), n = !1, (i = z.exec(u)) && (n = i.shift(), o.push({ value: n, type: i[0].replace($, " ") }), u = u.slice(n.length));for (a in r.filter) {
          !(i = X[a].exec(u)) || l[a] && !(i = l[a](i)) || (n = i.shift(), o.push({ value: n, type: a, matches: i }), u = u.slice(n.length));
        }if (!n) break;
      }return t ? u.length : u ? oe.error(e) : N(e, s).slice(0);
    };function ye(e) {
      for (var t = 0, n = e.length, r = ""; t < n; t++) {
        r += e[t].value;
      }return r;
    }function me(e, t, n) {
      var r = t.dir,
          i = t.next,
          o = i || r,
          a = n && "parentNode" === o,
          u = T++;return t.first ? function (t, n, i) {
        while (t = t[r]) {
          if (1 === t.nodeType || a) return e(t, n, i);
        }return !1;
      } : function (t, n, s) {
        var l,
            c,
            f,
            d = [C, u];if (s) {
          while (t = t[r]) {
            if ((1 === t.nodeType || a) && e(t, n, s)) return !0;
          }
        } else while (t = t[r]) {
          if (1 === t.nodeType || a) if (f = t[x] || (t[x] = {}), c = f[t.uniqueID] || (f[t.uniqueID] = {}), i && i === t.nodeName.toLowerCase()) t = t[r] || t;else {
            if ((l = c[o]) && l[0] === C && l[1] === u) return d[2] = l[2];if (c[o] = d, d[2] = e(t, n, s)) return !0;
          }
        }return !1;
      };
    }function be(e) {
      return e.length > 1 ? function (t, n, r) {
        var i = e.length;while (i--) {
          if (!e[i](t, n, r)) return !1;
        }return !0;
      } : e[0];
    }function xe(e, t, n) {
      for (var r = 0, i = t.length; r < i; r++) {
        oe(e, t[r], n);
      }return n;
    }function we(e, t, n, r, i) {
      for (var o, a = [], u = 0, s = e.length, l = null != t; u < s; u++) {
        (o = e[u]) && (n && !n(o, r, i) || (a.push(o), l && t.push(u)));
      }return a;
    }function Ce(e, t, n, r, i, o) {
      return r && !r[x] && (r = Ce(r)), i && !i[x] && (i = Ce(i, o)), ue(function (o, a, u, s) {
        var l,
            c,
            f,
            d = [],
            p = [],
            h = a.length,
            g = o || xe(t || "*", u.nodeType ? [u] : u, []),
            v = !e || !o && t ? g : we(g, d, e, u, s),
            y = n ? i || (o ? e : h || r) ? [] : a : v;if (n && n(v, y, u, s), r) {
          l = we(y, p), r(l, [], u, s), c = l.length;while (c--) {
            (f = l[c]) && (y[p[c]] = !(v[p[c]] = f));
          }
        }if (o) {
          if (i || e) {
            if (i) {
              l = [], c = y.length;while (c--) {
                (f = y[c]) && l.push(v[c] = f);
              }i(null, y = [], l, s);
            }c = y.length;while (c--) {
              (f = y[c]) && (l = i ? P(o, f) : d[c]) > -1 && (o[l] = !(a[l] = f));
            }
          }
        } else y = we(y === a ? y.splice(h, y.length) : y), i ? i(null, a, y, s) : q.apply(a, y);
      });
    }function Te(e) {
      for (var t, n, i, o = e.length, a = r.relative[e[0].type], u = a || r.relative[" "], s = a ? 1 : 0, c = me(function (e) {
        return e === t;
      }, u, !0), f = me(function (e) {
        return P(t, e) > -1;
      }, u, !0), d = [function (e, n, r) {
        var i = !a && (r || n !== l) || ((t = n).nodeType ? c(e, n, r) : f(e, n, r));return t = null, i;
      }]; s < o; s++) {
        if (n = r.relative[e[s].type]) d = [me(be(d), n)];else {
          if ((n = r.filter[e[s].type].apply(null, e[s].matches))[x]) {
            for (i = ++s; i < o; i++) {
              if (r.relative[e[i].type]) break;
            }return Ce(s > 1 && be(d), s > 1 && ye(e.slice(0, s - 1).concat({ value: " " === e[s - 2].type ? "*" : "" })).replace($, "$1"), n, s < i && Te(e.slice(s, i)), i < o && Te(e = e.slice(i)), i < o && ye(e));
          }d.push(n);
        }
      }return be(d);
    }function Ee(e, t) {
      var n = t.length > 0,
          i = e.length > 0,
          o = function o(_o, a, u, s, c) {
        var f,
            h,
            v,
            y = 0,
            m = "0",
            b = _o && [],
            x = [],
            w = l,
            T = _o || i && r.find.TAG("*", c),
            E = C += null == w ? 1 : Math.random() || .1,
            N = T.length;for (c && (l = a === p || a || c); m !== N && null != (f = T[m]); m++) {
          if (i && f) {
            h = 0, a || f.ownerDocument === p || (d(f), u = !g);while (v = e[h++]) {
              if (v(f, a || p, u)) {
                s.push(f);break;
              }
            }c && (C = E);
          }n && ((f = !v && f) && y--, _o && b.push(f));
        }if (y += m, n && m !== y) {
          h = 0;while (v = t[h++]) {
            v(b, x, a, u);
          }if (_o) {
            if (y > 0) while (m--) {
              b[m] || x[m] || (x[m] = L.call(s));
            }x = we(x);
          }q.apply(s, x), c && !_o && x.length > 0 && y + t.length > 1 && oe.uniqueSort(s);
        }return c && (C = E, l = w), b;
      };return n ? ue(o) : o;
    }return u = oe.compile = function (e, t) {
      var n,
          r = [],
          i = [],
          o = k[e + " "];if (!o) {
        t || (t = a(e)), n = t.length;while (n--) {
          (o = Te(t[n]))[x] ? r.push(o) : i.push(o);
        }(o = k(e, Ee(i, r))).selector = e;
      }return o;
    }, s = oe.select = function (e, t, n, i) {
      var o,
          s,
          l,
          c,
          f,
          d = "function" == typeof e && e,
          p = !i && a(e = d.selector || e);if (n = n || [], 1 === p.length) {
        if ((s = p[0] = p[0].slice(0)).length > 2 && "ID" === (l = s[0]).type && 9 === t.nodeType && g && r.relative[s[1].type]) {
          if (!(t = (r.find.ID(l.matches[0].replace(Z, ee), t) || [])[0])) return n;d && (t = t.parentNode), e = e.slice(s.shift().value.length);
        }o = X.needsContext.test(e) ? 0 : s.length;while (o--) {
          if (l = s[o], r.relative[c = l.type]) break;if ((f = r.find[c]) && (i = f(l.matches[0].replace(Z, ee), J.test(s[0].type) && ge(t.parentNode) || t))) {
            if (s.splice(o, 1), !(e = i.length && ye(s))) return q.apply(n, i), n;break;
          }
        }
      }return (d || u(e, p))(i, t, !g, n, !t || J.test(e) && ge(t.parentNode) || t), n;
    }, n.sortStable = x.split("").sort(A).join("") === x, n.detectDuplicates = !!f, d(), n.sortDetached = se(function (e) {
      return 1 & e.compareDocumentPosition(p.createElement("fieldset"));
    }), se(function (e) {
      return e.innerHTML = "<a href='#'></a>", "#" === e.firstChild.getAttribute("href");
    }) || le("type|href|height|width", function (e, t, n) {
      if (!n) return e.getAttribute(t, "type" === t.toLowerCase() ? 1 : 2);
    }), n.attributes && se(function (e) {
      return e.innerHTML = "<input/>", e.firstChild.setAttribute("value", ""), "" === e.firstChild.getAttribute("value");
    }) || le("value", function (e, t, n) {
      if (!n && "input" === e.nodeName.toLowerCase()) return e.defaultValue;
    }), se(function (e) {
      return null == e.getAttribute("disabled");
    }) || le(H, function (e, t, n) {
      var r;if (!n) return !0 === e[t] ? t.toLowerCase() : (r = e.getAttributeNode(t)) && r.specified ? r.value : null;
    }), oe;
  }(e);w.find = E, w.expr = E.selectors, w.expr[":"] = w.expr.pseudos, w.uniqueSort = w.unique = E.uniqueSort, w.text = E.getText, w.isXMLDoc = E.isXML, w.contains = E.contains, w.escapeSelector = E.escape;var N = function N(e, t, n) {
    var r = [],
        i = void 0 !== n;while ((e = e[t]) && 9 !== e.nodeType) {
      if (1 === e.nodeType) {
        if (i && w(e).is(n)) break;r.push(e);
      }
    }return r;
  },
      k = function k(e, t) {
    for (var n = []; e; e = e.nextSibling) {
      1 === e.nodeType && e !== t && n.push(e);
    }return n;
  },
      A = w.expr.match.needsContext;function D(e, t) {
    return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase();
  }var S = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;function L(e, t, n) {
    return g(t) ? w.grep(e, function (e, r) {
      return !!t.call(e, r, e) !== n;
    }) : t.nodeType ? w.grep(e, function (e) {
      return e === t !== n;
    }) : "string" != typeof t ? w.grep(e, function (e) {
      return s.call(t, e) > -1 !== n;
    }) : w.filter(t, e, n);
  }w.filter = function (e, t, n) {
    var r = t[0];return n && (e = ":not(" + e + ")"), 1 === t.length && 1 === r.nodeType ? w.find.matchesSelector(r, e) ? [r] : [] : w.find.matches(e, w.grep(t, function (e) {
      return 1 === e.nodeType;
    }));
  }, w.fn.extend({ find: function find(e) {
      var t,
          n,
          r = this.length,
          i = this;if ("string" != typeof e) return this.pushStack(w(e).filter(function () {
        for (t = 0; t < r; t++) {
          if (w.contains(i[t], this)) return !0;
        }
      }));for (n = this.pushStack([]), t = 0; t < r; t++) {
        w.find(e, i[t], n);
      }return r > 1 ? w.uniqueSort(n) : n;
    }, filter: function filter(e) {
      return this.pushStack(L(this, e || [], !1));
    }, not: function not(e) {
      return this.pushStack(L(this, e || [], !0));
    }, is: function is(e) {
      return !!L(this, "string" == typeof e && A.test(e) ? w(e) : e || [], !1).length;
    } });var j,
      q = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;(w.fn.init = function (e, t, n) {
    var i, o;if (!e) return this;if (n = n || j, "string" == typeof e) {
      if (!(i = "<" === e[0] && ">" === e[e.length - 1] && e.length >= 3 ? [null, e, null] : q.exec(e)) || !i[1] && t) return !t || t.jquery ? (t || n).find(e) : this.constructor(t).find(e);if (i[1]) {
        if (t = t instanceof w ? t[0] : t, w.merge(this, w.parseHTML(i[1], t && t.nodeType ? t.ownerDocument || t : r, !0)), S.test(i[1]) && w.isPlainObject(t)) for (i in t) {
          g(this[i]) ? this[i](t[i]) : this.attr(i, t[i]);
        }return this;
      }return (o = r.getElementById(i[2])) && (this[0] = o, this.length = 1), this;
    }return e.nodeType ? (this[0] = e, this.length = 1, this) : g(e) ? void 0 !== n.ready ? n.ready(e) : e(w) : w.makeArray(e, this);
  }).prototype = w.fn, j = w(r);var O = /^(?:parents|prev(?:Until|All))/,
      P = { children: !0, contents: !0, next: !0, prev: !0 };w.fn.extend({ has: function has(e) {
      var t = w(e, this),
          n = t.length;return this.filter(function () {
        for (var e = 0; e < n; e++) {
          if (w.contains(this, t[e])) return !0;
        }
      });
    }, closest: function closest(e, t) {
      var n,
          r = 0,
          i = this.length,
          o = [],
          a = "string" != typeof e && w(e);if (!A.test(e)) for (; r < i; r++) {
        for (n = this[r]; n && n !== t; n = n.parentNode) {
          if (n.nodeType < 11 && (a ? a.index(n) > -1 : 1 === n.nodeType && w.find.matchesSelector(n, e))) {
            o.push(n);break;
          }
        }
      }return this.pushStack(o.length > 1 ? w.uniqueSort(o) : o);
    }, index: function index(e) {
      return e ? "string" == typeof e ? s.call(w(e), this[0]) : s.call(this, e.jquery ? e[0] : e) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
    }, add: function add(e, t) {
      return this.pushStack(w.uniqueSort(w.merge(this.get(), w(e, t))));
    }, addBack: function addBack(e) {
      return this.add(null == e ? this.prevObject : this.prevObject.filter(e));
    } });function H(e, t) {
    while ((e = e[t]) && 1 !== e.nodeType) {}return e;
  }w.each({ parent: function parent(e) {
      var t = e.parentNode;return t && 11 !== t.nodeType ? t : null;
    }, parents: function parents(e) {
      return N(e, "parentNode");
    }, parentsUntil: function parentsUntil(e, t, n) {
      return N(e, "parentNode", n);
    }, next: function next(e) {
      return H(e, "nextSibling");
    }, prev: function prev(e) {
      return H(e, "previousSibling");
    }, nextAll: function nextAll(e) {
      return N(e, "nextSibling");
    }, prevAll: function prevAll(e) {
      return N(e, "previousSibling");
    }, nextUntil: function nextUntil(e, t, n) {
      return N(e, "nextSibling", n);
    }, prevUntil: function prevUntil(e, t, n) {
      return N(e, "previousSibling", n);
    }, siblings: function siblings(e) {
      return k((e.parentNode || {}).firstChild, e);
    }, children: function children(e) {
      return k(e.firstChild);
    }, contents: function contents(e) {
      return D(e, "iframe") ? e.contentDocument : (D(e, "template") && (e = e.content || e), w.merge([], e.childNodes));
    } }, function (e, t) {
    w.fn[e] = function (n, r) {
      var i = w.map(this, t, n);return "Until" !== e.slice(-5) && (r = n), r && "string" == typeof r && (i = w.filter(r, i)), this.length > 1 && (P[e] || w.uniqueSort(i), O.test(e) && i.reverse()), this.pushStack(i);
    };
  });var I = /[^\x20\t\r\n\f]+/g;function R(e) {
    var t = {};return w.each(e.match(I) || [], function (e, n) {
      t[n] = !0;
    }), t;
  }w.Callbacks = function (e) {
    e = "string" == typeof e ? R(e) : w.extend({}, e);var t,
        n,
        r,
        i,
        o = [],
        a = [],
        u = -1,
        s = function s() {
      for (i = i || e.once, r = t = !0; a.length; u = -1) {
        n = a.shift();while (++u < o.length) {
          !1 === o[u].apply(n[0], n[1]) && e.stopOnFalse && (u = o.length, n = !1);
        }
      }e.memory || (n = !1), t = !1, i && (o = n ? [] : "");
    },
        l = { add: function add() {
        return o && (n && !t && (u = o.length - 1, a.push(n)), function t(n) {
          w.each(n, function (n, r) {
            g(r) ? e.unique && l.has(r) || o.push(r) : r && r.length && "string" !== b(r) && t(r);
          });
        }(arguments), n && !t && s()), this;
      }, remove: function remove() {
        return w.each(arguments, function (e, t) {
          var n;while ((n = w.inArray(t, o, n)) > -1) {
            o.splice(n, 1), n <= u && u--;
          }
        }), this;
      }, has: function has(e) {
        return e ? w.inArray(e, o) > -1 : o.length > 0;
      }, empty: function empty() {
        return o && (o = []), this;
      }, disable: function disable() {
        return i = a = [], o = n = "", this;
      }, disabled: function disabled() {
        return !o;
      }, lock: function lock() {
        return i = a = [], n || t || (o = n = ""), this;
      }, locked: function locked() {
        return !!i;
      }, fireWith: function fireWith(e, n) {
        return i || (n = [e, (n = n || []).slice ? n.slice() : n], a.push(n), t || s()), this;
      }, fire: function fire() {
        return l.fireWith(this, arguments), this;
      }, fired: function fired() {
        return !!r;
      } };return l;
  };function B(e) {
    return e;
  }function M(e) {
    throw e;
  }function W(e, t, n, r) {
    var i;try {
      e && g(i = e.promise) ? i.call(e).done(t).fail(n) : e && g(i = e.then) ? i.call(e, t, n) : t.apply(void 0, [e].slice(r));
    } catch (e) {
      n.apply(void 0, [e]);
    }
  }w.extend({ Deferred: function Deferred(t) {
      var n = [["notify", "progress", w.Callbacks("memory"), w.Callbacks("memory"), 2], ["resolve", "done", w.Callbacks("once memory"), w.Callbacks("once memory"), 0, "resolved"], ["reject", "fail", w.Callbacks("once memory"), w.Callbacks("once memory"), 1, "rejected"]],
          r = "pending",
          i = { state: function state() {
          return r;
        }, always: function always() {
          return o.done(arguments).fail(arguments), this;
        }, "catch": function _catch(e) {
          return i.then(null, e);
        }, pipe: function pipe() {
          var e = arguments;return w.Deferred(function (t) {
            w.each(n, function (n, r) {
              var i = g(e[r[4]]) && e[r[4]];o[r[1]](function () {
                var e = i && i.apply(this, arguments);e && g(e.promise) ? e.promise().progress(t.notify).done(t.resolve).fail(t.reject) : t[r[0] + "With"](this, i ? [e] : arguments);
              });
            }), e = null;
          }).promise();
        }, then: function then(t, r, i) {
          var o = 0;function a(t, n, r, i) {
            return function () {
              var u = this,
                  s = arguments,
                  l = function l() {
                var e, l;if (!(t < o)) {
                  if ((e = r.apply(u, s)) === n.promise()) throw new TypeError("Thenable self-resolution");l = e && ("object" == (typeof e === "undefined" ? "undefined" : (0, _typeof3.default)(e)) || "function" == typeof e) && e.then, g(l) ? i ? l.call(e, a(o, n, B, i), a(o, n, M, i)) : (o++, l.call(e, a(o, n, B, i), a(o, n, M, i), a(o, n, B, n.notifyWith))) : (r !== B && (u = void 0, s = [e]), (i || n.resolveWith)(u, s));
                }
              },
                  c = i ? l : function () {
                try {
                  l();
                } catch (e) {
                  w.Deferred.exceptionHook && w.Deferred.exceptionHook(e, c.stackTrace), t + 1 >= o && (r !== M && (u = void 0, s = [e]), n.rejectWith(u, s));
                }
              };t ? c() : (w.Deferred.getStackHook && (c.stackTrace = w.Deferred.getStackHook()), e.setTimeout(c));
            };
          }return w.Deferred(function (e) {
            n[0][3].add(a(0, e, g(i) ? i : B, e.notifyWith)), n[1][3].add(a(0, e, g(t) ? t : B)), n[2][3].add(a(0, e, g(r) ? r : M));
          }).promise();
        }, promise: function promise(e) {
          return null != e ? w.extend(e, i) : i;
        } },
          o = {};return w.each(n, function (e, t) {
        var a = t[2],
            u = t[5];i[t[1]] = a.add, u && a.add(function () {
          r = u;
        }, n[3 - e][2].disable, n[3 - e][3].disable, n[0][2].lock, n[0][3].lock), a.add(t[3].fire), o[t[0]] = function () {
          return o[t[0] + "With"](this === o ? void 0 : this, arguments), this;
        }, o[t[0] + "With"] = a.fireWith;
      }), i.promise(o), t && t.call(o, o), o;
    }, when: function when(e) {
      var t = arguments.length,
          n = t,
          r = Array(n),
          i = o.call(arguments),
          a = w.Deferred(),
          u = function u(e) {
        return function (n) {
          r[e] = this, i[e] = arguments.length > 1 ? o.call(arguments) : n, --t || a.resolveWith(r, i);
        };
      };if (t <= 1 && (W(e, a.done(u(n)).resolve, a.reject, !t), "pending" === a.state() || g(i[n] && i[n].then))) return a.then();while (n--) {
        W(i[n], u(n), a.reject);
      }return a.promise();
    } });var $ = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;w.Deferred.exceptionHook = function (t, n) {
    e.console && e.console.warn && t && $.test(t.name) && e.console.warn("jQuery.Deferred exception: " + t.message, t.stack, n);
  }, w.readyException = function (t) {
    e.setTimeout(function () {
      throw t;
    });
  };var F = w.Deferred();w.fn.ready = function (e) {
    return F.then(e)["catch"](function (e) {
      w.readyException(e);
    }), this;
  }, w.extend({ isReady: !1, readyWait: 1, ready: function ready(e) {
      (!0 === e ? --w.readyWait : w.isReady) || (w.isReady = !0, !0 !== e && --w.readyWait > 0 || F.resolveWith(r, [w]));
    } }), w.ready.then = F.then;function z() {
    r.removeEventListener("DOMContentLoaded", z), e.removeEventListener("load", z), w.ready();
  }"complete" === r.readyState || "loading" !== r.readyState && !r.documentElement.doScroll ? e.setTimeout(w.ready) : (r.addEventListener("DOMContentLoaded", z), e.addEventListener("load", z));var _ = function _(e, t, n, r, i, o, a) {
    var u = 0,
        s = e.length,
        l = null == n;if ("object" === b(n)) {
      i = !0;for (u in n) {
        _(e, t, u, n[u], !0, o, a);
      }
    } else if (void 0 !== r && (i = !0, g(r) || (a = !0), l && (a ? (t.call(e, r), t = null) : (l = t, t = function t(e, _t, n) {
      return l.call(w(e), n);
    })), t)) for (; u < s; u++) {
      t(e[u], n, a ? r : r.call(e[u], u, t(e[u], n)));
    }return i ? e : l ? t.call(e) : s ? t(e[0], n) : o;
  },
      U = /^-ms-/,
      V = /-([a-z])/g;function X(e, t) {
    return t.toUpperCase();
  }function Q(e) {
    return e.replace(U, "ms-").replace(V, X);
  }var Y = function Y(e) {
    return 1 === e.nodeType || 9 === e.nodeType || !+e.nodeType;
  };function G() {
    this.expando = w.expando + G.uid++;
  }G.uid = 1, G.prototype = { cache: function cache(e) {
      var t = e[this.expando];return t || (t = {}, Y(e) && (e.nodeType ? e[this.expando] = t : (0, _defineProperty2.default)(e, this.expando, { value: t, configurable: !0 }))), t;
    }, set: function set(e, t, n) {
      var r,
          i = this.cache(e);if ("string" == typeof t) i[Q(t)] = n;else for (r in t) {
        i[Q(r)] = t[r];
      }return i;
    }, get: function get(e, t) {
      return void 0 === t ? this.cache(e) : e[this.expando] && e[this.expando][Q(t)];
    }, access: function access(e, t, n) {
      return void 0 === t || t && "string" == typeof t && void 0 === n ? this.get(e, t) : (this.set(e, t, n), void 0 !== n ? n : t);
    }, remove: function remove(e, t) {
      var n,
          r = e[this.expando];if (void 0 !== r) {
        if (void 0 !== t) {
          n = (t = Array.isArray(t) ? t.map(Q) : (t = Q(t)) in r ? [t] : t.match(I) || []).length;while (n--) {
            delete r[t[n]];
          }
        }(void 0 === t || w.isEmptyObject(r)) && (e.nodeType ? e[this.expando] = void 0 : delete e[this.expando]);
      }
    }, hasData: function hasData(e) {
      var t = e[this.expando];return void 0 !== t && !w.isEmptyObject(t);
    } };var K = new G(),
      J = new G(),
      Z = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
      ee = /[A-Z]/g;function te(e) {
    return "true" === e || "false" !== e && ("null" === e ? null : e === +e + "" ? +e : Z.test(e) ? JSON.parse(e) : e);
  }function ne(e, t, n) {
    var r;if (void 0 === n && 1 === e.nodeType) if (r = "data-" + t.replace(ee, "-$&").toLowerCase(), "string" == typeof (n = e.getAttribute(r))) {
      try {
        n = te(n);
      } catch (e) {}J.set(e, t, n);
    } else n = void 0;return n;
  }w.extend({ hasData: function hasData(e) {
      return J.hasData(e) || K.hasData(e);
    }, data: function data(e, t, n) {
      return J.access(e, t, n);
    }, removeData: function removeData(e, t) {
      J.remove(e, t);
    }, _data: function _data(e, t, n) {
      return K.access(e, t, n);
    }, _removeData: function _removeData(e, t) {
      K.remove(e, t);
    } }), w.fn.extend({ data: function data(e, t) {
      var n,
          r,
          i,
          o = this[0],
          a = o && o.attributes;if (void 0 === e) {
        if (this.length && (i = J.get(o), 1 === o.nodeType && !K.get(o, "hasDataAttrs"))) {
          n = a.length;while (n--) {
            a[n] && 0 === (r = a[n].name).indexOf("data-") && (r = Q(r.slice(5)), ne(o, r, i[r]));
          }K.set(o, "hasDataAttrs", !0);
        }return i;
      }return "object" == (typeof e === "undefined" ? "undefined" : (0, _typeof3.default)(e)) ? this.each(function () {
        J.set(this, e);
      }) : _(this, function (t) {
        var n;if (o && void 0 === t) {
          if (void 0 !== (n = J.get(o, e))) return n;if (void 0 !== (n = ne(o, e))) return n;
        } else this.each(function () {
          J.set(this, e, t);
        });
      }, null, t, arguments.length > 1, null, !0);
    }, removeData: function removeData(e) {
      return this.each(function () {
        J.remove(this, e);
      });
    } }), w.extend({ queue: function queue(e, t, n) {
      var r;if (e) return t = (t || "fx") + "queue", r = K.get(e, t), n && (!r || Array.isArray(n) ? r = K.access(e, t, w.makeArray(n)) : r.push(n)), r || [];
    }, dequeue: function dequeue(e, t) {
      t = t || "fx";var n = w.queue(e, t),
          r = n.length,
          i = n.shift(),
          o = w._queueHooks(e, t),
          a = function a() {
        w.dequeue(e, t);
      };"inprogress" === i && (i = n.shift(), r--), i && ("fx" === t && n.unshift("inprogress"), delete o.stop, i.call(e, a, o)), !r && o && o.empty.fire();
    }, _queueHooks: function _queueHooks(e, t) {
      var n = t + "queueHooks";return K.get(e, n) || K.access(e, n, { empty: w.Callbacks("once memory").add(function () {
          K.remove(e, [t + "queue", n]);
        }) });
    } }), w.fn.extend({ queue: function queue(e, t) {
      var n = 2;return "string" != typeof e && (t = e, e = "fx", n--), arguments.length < n ? w.queue(this[0], e) : void 0 === t ? this : this.each(function () {
        var n = w.queue(this, e, t);w._queueHooks(this, e), "fx" === e && "inprogress" !== n[0] && w.dequeue(this, e);
      });
    }, dequeue: function dequeue(e) {
      return this.each(function () {
        w.dequeue(this, e);
      });
    }, clearQueue: function clearQueue(e) {
      return this.queue(e || "fx", []);
    }, promise: function promise(e, t) {
      var n,
          r = 1,
          i = w.Deferred(),
          o = this,
          a = this.length,
          u = function u() {
        --r || i.resolveWith(o, [o]);
      };"string" != typeof e && (t = e, e = void 0), e = e || "fx";while (a--) {
        (n = K.get(o[a], e + "queueHooks")) && n.empty && (r++, n.empty.add(u));
      }return u(), i.promise(t);
    } });var re = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
      ie = new RegExp("^(?:([+-])=|)(" + re + ")([a-z%]*)$", "i"),
      oe = ["Top", "Right", "Bottom", "Left"],
      ae = function ae(e, t) {
    return "none" === (e = t || e).style.display || "" === e.style.display && w.contains(e.ownerDocument, e) && "none" === w.css(e, "display");
  },
      ue = function ue(e, t, n, r) {
    var i,
        o,
        a = {};for (o in t) {
      a[o] = e.style[o], e.style[o] = t[o];
    }i = n.apply(e, r || []);for (o in t) {
      e.style[o] = a[o];
    }return i;
  };function se(e, t, n, r) {
    var i,
        o,
        a = 20,
        u = r ? function () {
      return r.cur();
    } : function () {
      return w.css(e, t, "");
    },
        s = u(),
        l = n && n[3] || (w.cssNumber[t] ? "" : "px"),
        c = (w.cssNumber[t] || "px" !== l && +s) && ie.exec(w.css(e, t));if (c && c[3] !== l) {
      s /= 2, l = l || c[3], c = +s || 1;while (a--) {
        w.style(e, t, c + l), (1 - o) * (1 - (o = u() / s || .5)) <= 0 && (a = 0), c /= o;
      }c *= 2, w.style(e, t, c + l), n = n || [];
    }return n && (c = +c || +s || 0, i = n[1] ? c + (n[1] + 1) * n[2] : +n[2], r && (r.unit = l, r.start = c, r.end = i)), i;
  }var le = {};function ce(e) {
    var t,
        n = e.ownerDocument,
        r = e.nodeName,
        i = le[r];return i || (t = n.body.appendChild(n.createElement(r)), i = w.css(t, "display"), t.parentNode.removeChild(t), "none" === i && (i = "block"), le[r] = i, i);
  }function fe(e, t) {
    for (var n, r, i = [], o = 0, a = e.length; o < a; o++) {
      (r = e[o]).style && (n = r.style.display, t ? ("none" === n && (i[o] = K.get(r, "display") || null, i[o] || (r.style.display = "")), "" === r.style.display && ae(r) && (i[o] = ce(r))) : "none" !== n && (i[o] = "none", K.set(r, "display", n)));
    }for (o = 0; o < a; o++) {
      null != i[o] && (e[o].style.display = i[o]);
    }return e;
  }w.fn.extend({ show: function show() {
      return fe(this, !0);
    }, hide: function hide() {
      return fe(this);
    }, toggle: function toggle(e) {
      return "boolean" == typeof e ? e ? this.show() : this.hide() : this.each(function () {
        ae(this) ? w(this).show() : w(this).hide();
      });
    } });var de = /^(?:checkbox|radio)$/i,
      pe = /<([a-z][^\/\0>\x20\t\r\n\f]+)/i,
      he = /^$|^module$|\/(?:java|ecma)script/i,
      ge = { option: [1, "<select multiple='multiple'>", "</select>"], thead: [1, "<table>", "</table>"], col: [2, "<table><colgroup>", "</colgroup></table>"], tr: [2, "<table><tbody>", "</tbody></table>"], td: [3, "<table><tbody><tr>", "</tr></tbody></table>"], _default: [0, "", ""] };ge.optgroup = ge.option, ge.tbody = ge.tfoot = ge.colgroup = ge.caption = ge.thead, ge.th = ge.td;function ve(e, t) {
    var n;return n = "undefined" != typeof e.getElementsByTagName ? e.getElementsByTagName(t || "*") : "undefined" != typeof e.querySelectorAll ? e.querySelectorAll(t || "*") : [], void 0 === t || t && D(e, t) ? w.merge([e], n) : n;
  }function ye(e, t) {
    for (var n = 0, r = e.length; n < r; n++) {
      K.set(e[n], "globalEval", !t || K.get(t[n], "globalEval"));
    }
  }var me = /<|&#?\w+;/;function be(e, t, n, r, i) {
    for (var o, a, u, s, l, c, f = t.createDocumentFragment(), d = [], p = 0, h = e.length; p < h; p++) {
      if ((o = e[p]) || 0 === o) if ("object" === b(o)) w.merge(d, o.nodeType ? [o] : o);else if (me.test(o)) {
        a = a || f.appendChild(t.createElement("div")), u = (pe.exec(o) || ["", ""])[1].toLowerCase(), s = ge[u] || ge._default, a.innerHTML = s[1] + w.htmlPrefilter(o) + s[2], c = s[0];while (c--) {
          a = a.lastChild;
        }w.merge(d, a.childNodes), (a = f.firstChild).textContent = "";
      } else d.push(t.createTextNode(o));
    }f.textContent = "", p = 0;while (o = d[p++]) {
      if (r && w.inArray(o, r) > -1) i && i.push(o);else if (l = w.contains(o.ownerDocument, o), a = ve(f.appendChild(o), "script"), l && ye(a), n) {
        c = 0;while (o = a[c++]) {
          he.test(o.type || "") && n.push(o);
        }
      }
    }return f;
  }!function () {
    var e = r.createDocumentFragment().appendChild(r.createElement("div")),
        t = r.createElement("input");t.setAttribute("type", "radio"), t.setAttribute("checked", "checked"), t.setAttribute("name", "t"), e.appendChild(t), h.checkClone = e.cloneNode(!0).cloneNode(!0).lastChild.checked, e.innerHTML = "<textarea>x</textarea>", h.noCloneChecked = !!e.cloneNode(!0).lastChild.defaultValue;
  }();var xe = r.documentElement,
      we = /^key/,
      Ce = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
      Te = /^([^.]*)(?:\.(.+)|)/;function Ee() {
    return !0;
  }function Ne() {
    return !1;
  }function ke() {
    try {
      return r.activeElement;
    } catch (e) {}
  }function Ae(e, t, n, r, i, o) {
    var a, u;if ("object" == (typeof t === "undefined" ? "undefined" : (0, _typeof3.default)(t))) {
      "string" != typeof n && (r = r || n, n = void 0);for (u in t) {
        Ae(e, u, n, r, t[u], o);
      }return e;
    }if (null == r && null == i ? (i = n, r = n = void 0) : null == i && ("string" == typeof n ? (i = r, r = void 0) : (i = r, r = n, n = void 0)), !1 === i) i = Ne;else if (!i) return e;return 1 === o && (a = i, (i = function i(e) {
      return w().off(e), a.apply(this, arguments);
    }).guid = a.guid || (a.guid = w.guid++)), e.each(function () {
      w.event.add(this, t, i, r, n);
    });
  }w.event = { global: {}, add: function add(e, t, n, r, i) {
      var o,
          a,
          u,
          s,
          l,
          c,
          f,
          d,
          p,
          h,
          g,
          v = K.get(e);if (v) {
        n.handler && (n = (o = n).handler, i = o.selector), i && w.find.matchesSelector(xe, i), n.guid || (n.guid = w.guid++), (s = v.events) || (s = v.events = {}), (a = v.handle) || (a = v.handle = function (t) {
          return "undefined" != typeof w && w.event.triggered !== t.type ? w.event.dispatch.apply(e, arguments) : void 0;
        }), l = (t = (t || "").match(I) || [""]).length;while (l--) {
          p = g = (u = Te.exec(t[l]) || [])[1], h = (u[2] || "").split(".").sort(), p && (f = w.event.special[p] || {}, p = (i ? f.delegateType : f.bindType) || p, f = w.event.special[p] || {}, c = w.extend({ type: p, origType: g, data: r, handler: n, guid: n.guid, selector: i, needsContext: i && w.expr.match.needsContext.test(i), namespace: h.join(".") }, o), (d = s[p]) || ((d = s[p] = []).delegateCount = 0, f.setup && !1 !== f.setup.call(e, r, h, a) || e.addEventListener && e.addEventListener(p, a)), f.add && (f.add.call(e, c), c.handler.guid || (c.handler.guid = n.guid)), i ? d.splice(d.delegateCount++, 0, c) : d.push(c), w.event.global[p] = !0);
        }
      }
    }, remove: function remove(e, t, n, r, i) {
      var o,
          a,
          u,
          s,
          l,
          c,
          f,
          d,
          p,
          h,
          g,
          v = K.hasData(e) && K.get(e);if (v && (s = v.events)) {
        l = (t = (t || "").match(I) || [""]).length;while (l--) {
          if (u = Te.exec(t[l]) || [], p = g = u[1], h = (u[2] || "").split(".").sort(), p) {
            f = w.event.special[p] || {}, d = s[p = (r ? f.delegateType : f.bindType) || p] || [], u = u[2] && new RegExp("(^|\\.)" + h.join("\\.(?:.*\\.|)") + "(\\.|$)"), a = o = d.length;while (o--) {
              c = d[o], !i && g !== c.origType || n && n.guid !== c.guid || u && !u.test(c.namespace) || r && r !== c.selector && ("**" !== r || !c.selector) || (d.splice(o, 1), c.selector && d.delegateCount--, f.remove && f.remove.call(e, c));
            }a && !d.length && (f.teardown && !1 !== f.teardown.call(e, h, v.handle) || w.removeEvent(e, p, v.handle), delete s[p]);
          } else for (p in s) {
            w.event.remove(e, p + t[l], n, r, !0);
          }
        }w.isEmptyObject(s) && K.remove(e, "handle events");
      }
    }, dispatch: function dispatch(e) {
      var t = w.event.fix(e),
          n,
          r,
          i,
          o,
          a,
          u,
          s = new Array(arguments.length),
          l = (K.get(this, "events") || {})[t.type] || [],
          c = w.event.special[t.type] || {};for (s[0] = t, n = 1; n < arguments.length; n++) {
        s[n] = arguments[n];
      }if (t.delegateTarget = this, !c.preDispatch || !1 !== c.preDispatch.call(this, t)) {
        u = w.event.handlers.call(this, t, l), n = 0;while ((o = u[n++]) && !t.isPropagationStopped()) {
          t.currentTarget = o.elem, r = 0;while ((a = o.handlers[r++]) && !t.isImmediatePropagationStopped()) {
            t.rnamespace && !t.rnamespace.test(a.namespace) || (t.handleObj = a, t.data = a.data, void 0 !== (i = ((w.event.special[a.origType] || {}).handle || a.handler).apply(o.elem, s)) && !1 === (t.result = i) && (t.preventDefault(), t.stopPropagation()));
          }
        }return c.postDispatch && c.postDispatch.call(this, t), t.result;
      }
    }, handlers: function handlers(e, t) {
      var n,
          r,
          i,
          o,
          a,
          u = [],
          s = t.delegateCount,
          l = e.target;if (s && l.nodeType && !("click" === e.type && e.button >= 1)) for (; l !== this; l = l.parentNode || this) {
        if (1 === l.nodeType && ("click" !== e.type || !0 !== l.disabled)) {
          for (o = [], a = {}, n = 0; n < s; n++) {
            void 0 === a[i = (r = t[n]).selector + " "] && (a[i] = r.needsContext ? w(i, this).index(l) > -1 : w.find(i, this, null, [l]).length), a[i] && o.push(r);
          }o.length && u.push({ elem: l, handlers: o });
        }
      }return l = this, s < t.length && u.push({ elem: l, handlers: t.slice(s) }), u;
    }, addProp: function addProp(e, t) {
      (0, _defineProperty2.default)(w.Event.prototype, e, { enumerable: !0, configurable: !0, get: g(t) ? function () {
          if (this.originalEvent) return t(this.originalEvent);
        } : function () {
          if (this.originalEvent) return this.originalEvent[e];
        }, set: function set(t) {
          (0, _defineProperty2.default)(this, e, { enumerable: !0, configurable: !0, writable: !0, value: t });
        } });
    }, fix: function fix(e) {
      return e[w.expando] ? e : new w.Event(e);
    }, special: { load: { noBubble: !0 }, focus: { trigger: function trigger() {
          if (this !== ke() && this.focus) return this.focus(), !1;
        }, delegateType: "focusin" }, blur: { trigger: function trigger() {
          if (this === ke() && this.blur) return this.blur(), !1;
        }, delegateType: "focusout" }, click: { trigger: function trigger() {
          if ("checkbox" === this.type && this.click && D(this, "input")) return this.click(), !1;
        }, _default: function _default(e) {
          return D(e.target, "a");
        } }, beforeunload: { postDispatch: function postDispatch(e) {
          void 0 !== e.result && e.originalEvent && (e.originalEvent.returnValue = e.result);
        } } } }, w.removeEvent = function (e, t, n) {
    e.removeEventListener && e.removeEventListener(t, n);
  }, w.Event = function (e, t) {
    if (!(this instanceof w.Event)) return new w.Event(e, t);e && e.type ? (this.originalEvent = e, this.type = e.type, this.isDefaultPrevented = e.defaultPrevented || void 0 === e.defaultPrevented && !1 === e.returnValue ? Ee : Ne, this.target = e.target && 3 === e.target.nodeType ? e.target.parentNode : e.target, this.currentTarget = e.currentTarget, this.relatedTarget = e.relatedTarget) : this.type = e, t && w.extend(this, t), this.timeStamp = e && e.timeStamp || Date.now(), this[w.expando] = !0;
  }, w.Event.prototype = { constructor: w.Event, isDefaultPrevented: Ne, isPropagationStopped: Ne, isImmediatePropagationStopped: Ne, isSimulated: !1, preventDefault: function preventDefault() {
      var e = this.originalEvent;this.isDefaultPrevented = Ee, e && !this.isSimulated && e.preventDefault();
    }, stopPropagation: function stopPropagation() {
      var e = this.originalEvent;this.isPropagationStopped = Ee, e && !this.isSimulated && e.stopPropagation();
    }, stopImmediatePropagation: function stopImmediatePropagation() {
      var e = this.originalEvent;this.isImmediatePropagationStopped = Ee, e && !this.isSimulated && e.stopImmediatePropagation(), this.stopPropagation();
    } }, w.each({ altKey: !0, bubbles: !0, cancelable: !0, changedTouches: !0, ctrlKey: !0, detail: !0, eventPhase: !0, metaKey: !0, pageX: !0, pageY: !0, shiftKey: !0, view: !0, "char": !0, charCode: !0, key: !0, keyCode: !0, button: !0, buttons: !0, clientX: !0, clientY: !0, offsetX: !0, offsetY: !0, pointerId: !0, pointerType: !0, screenX: !0, screenY: !0, targetTouches: !0, toElement: !0, touches: !0, which: function which(e) {
      var t = e.button;return null == e.which && we.test(e.type) ? null != e.charCode ? e.charCode : e.keyCode : !e.which && void 0 !== t && Ce.test(e.type) ? 1 & t ? 1 : 2 & t ? 3 : 4 & t ? 2 : 0 : e.which;
    } }, w.event.addProp), w.each({ mouseenter: "mouseover", mouseleave: "mouseout", pointerenter: "pointerover", pointerleave: "pointerout" }, function (e, t) {
    w.event.special[e] = { delegateType: t, bindType: t, handle: function handle(e) {
        var n,
            r = this,
            i = e.relatedTarget,
            o = e.handleObj;return i && (i === r || w.contains(r, i)) || (e.type = o.origType, n = o.handler.apply(this, arguments), e.type = t), n;
      } };
  }), w.fn.extend({ on: function on(e, t, n, r) {
      return Ae(this, e, t, n, r);
    }, one: function one(e, t, n, r) {
      return Ae(this, e, t, n, r, 1);
    }, off: function off(e, t, n) {
      var r, i;if (e && e.preventDefault && e.handleObj) return r = e.handleObj, w(e.delegateTarget).off(r.namespace ? r.origType + "." + r.namespace : r.origType, r.selector, r.handler), this;if ("object" == (typeof e === "undefined" ? "undefined" : (0, _typeof3.default)(e))) {
        for (i in e) {
          this.off(i, t, e[i]);
        }return this;
      }return !1 !== t && "function" != typeof t || (n = t, t = void 0), !1 === n && (n = Ne), this.each(function () {
        w.event.remove(this, e, n, t);
      });
    } });var De = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,
      Se = /<script|<style|<link/i,
      Le = /checked\s*(?:[^=]|=\s*.checked.)/i,
      je = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;function qe(e, t) {
    return D(e, "table") && D(11 !== t.nodeType ? t : t.firstChild, "tr") ? w(e).children("tbody")[0] || e : e;
  }function Oe(e) {
    return e.type = (null !== e.getAttribute("type")) + "/" + e.type, e;
  }function Pe(e) {
    return "true/" === (e.type || "").slice(0, 5) ? e.type = e.type.slice(5) : e.removeAttribute("type"), e;
  }function He(e, t) {
    var n, r, i, o, a, u, s, l;if (1 === t.nodeType) {
      if (K.hasData(e) && (o = K.access(e), a = K.set(t, o), l = o.events)) {
        delete a.handle, a.events = {};for (i in l) {
          for (n = 0, r = l[i].length; n < r; n++) {
            w.event.add(t, i, l[i][n]);
          }
        }
      }J.hasData(e) && (u = J.access(e), s = w.extend({}, u), J.set(t, s));
    }
  }function Ie(e, t) {
    var n = t.nodeName.toLowerCase();"input" === n && de.test(e.type) ? t.checked = e.checked : "input" !== n && "textarea" !== n || (t.defaultValue = e.defaultValue);
  }function Re(e, t, n, r) {
    t = a.apply([], t);var i,
        o,
        u,
        s,
        l,
        c,
        f = 0,
        d = e.length,
        p = d - 1,
        v = t[0],
        y = g(v);if (y || d > 1 && "string" == typeof v && !h.checkClone && Le.test(v)) return e.each(function (i) {
      var o = e.eq(i);y && (t[0] = v.call(this, i, o.html())), Re(o, t, n, r);
    });if (d && (i = be(t, e[0].ownerDocument, !1, e, r), o = i.firstChild, 1 === i.childNodes.length && (i = o), o || r)) {
      for (s = (u = w.map(ve(i, "script"), Oe)).length; f < d; f++) {
        l = i, f !== p && (l = w.clone(l, !0, !0), s && w.merge(u, ve(l, "script"))), n.call(e[f], l, f);
      }if (s) for (c = u[u.length - 1].ownerDocument, w.map(u, Pe), f = 0; f < s; f++) {
        l = u[f], he.test(l.type || "") && !K.access(l, "globalEval") && w.contains(c, l) && (l.src && "module" !== (l.type || "").toLowerCase() ? w._evalUrl && w._evalUrl(l.src) : m(l.textContent.replace(je, ""), c, l));
      }
    }return e;
  }function Be(e, t, n) {
    for (var r, i = t ? w.filter(t, e) : e, o = 0; null != (r = i[o]); o++) {
      n || 1 !== r.nodeType || w.cleanData(ve(r)), r.parentNode && (n && w.contains(r.ownerDocument, r) && ye(ve(r, "script")), r.parentNode.removeChild(r));
    }return e;
  }w.extend({ htmlPrefilter: function htmlPrefilter(e) {
      return e.replace(De, "<$1></$2>");
    }, clone: function clone(e, t, n) {
      var r,
          i,
          o,
          a,
          u = e.cloneNode(!0),
          s = w.contains(e.ownerDocument, e);if (!(h.noCloneChecked || 1 !== e.nodeType && 11 !== e.nodeType || w.isXMLDoc(e))) for (a = ve(u), r = 0, i = (o = ve(e)).length; r < i; r++) {
        Ie(o[r], a[r]);
      }if (t) if (n) for (o = o || ve(e), a = a || ve(u), r = 0, i = o.length; r < i; r++) {
        He(o[r], a[r]);
      } else He(e, u);return (a = ve(u, "script")).length > 0 && ye(a, !s && ve(e, "script")), u;
    }, cleanData: function cleanData(e) {
      for (var t, n, r, i = w.event.special, o = 0; void 0 !== (n = e[o]); o++) {
        if (Y(n)) {
          if (t = n[K.expando]) {
            if (t.events) for (r in t.events) {
              i[r] ? w.event.remove(n, r) : w.removeEvent(n, r, t.handle);
            }n[K.expando] = void 0;
          }n[J.expando] && (n[J.expando] = void 0);
        }
      }
    } }), w.fn.extend({ detach: function detach(e) {
      return Be(this, e, !0);
    }, remove: function remove(e) {
      return Be(this, e);
    }, text: function text(e) {
      return _(this, function (e) {
        return void 0 === e ? w.text(this) : this.empty().each(function () {
          1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || (this.textContent = e);
        });
      }, null, e, arguments.length);
    }, append: function append() {
      return Re(this, arguments, function (e) {
        1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || qe(this, e).appendChild(e);
      });
    }, prepend: function prepend() {
      return Re(this, arguments, function (e) {
        if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
          var t = qe(this, e);t.insertBefore(e, t.firstChild);
        }
      });
    }, before: function before() {
      return Re(this, arguments, function (e) {
        this.parentNode && this.parentNode.insertBefore(e, this);
      });
    }, after: function after() {
      return Re(this, arguments, function (e) {
        this.parentNode && this.parentNode.insertBefore(e, this.nextSibling);
      });
    }, empty: function empty() {
      for (var e, t = 0; null != (e = this[t]); t++) {
        1 === e.nodeType && (w.cleanData(ve(e, !1)), e.textContent = "");
      }return this;
    }, clone: function clone(e, t) {
      return e = null != e && e, t = null == t ? e : t, this.map(function () {
        return w.clone(this, e, t);
      });
    }, html: function html(e) {
      return _(this, function (e) {
        var t = this[0] || {},
            n = 0,
            r = this.length;if (void 0 === e && 1 === t.nodeType) return t.innerHTML;if ("string" == typeof e && !Se.test(e) && !ge[(pe.exec(e) || ["", ""])[1].toLowerCase()]) {
          e = w.htmlPrefilter(e);try {
            for (; n < r; n++) {
              1 === (t = this[n] || {}).nodeType && (w.cleanData(ve(t, !1)), t.innerHTML = e);
            }t = 0;
          } catch (e) {}
        }t && this.empty().append(e);
      }, null, e, arguments.length);
    }, replaceWith: function replaceWith() {
      var e = [];return Re(this, arguments, function (t) {
        var n = this.parentNode;w.inArray(this, e) < 0 && (w.cleanData(ve(this)), n && n.replaceChild(t, this));
      }, e);
    } }), w.each({ appendTo: "append", prependTo: "prepend", insertBefore: "before", insertAfter: "after", replaceAll: "replaceWith" }, function (e, t) {
    w.fn[e] = function (e) {
      for (var n, r = [], i = w(e), o = i.length - 1, a = 0; a <= o; a++) {
        n = a === o ? this : this.clone(!0), w(i[a])[t](n), u.apply(r, n.get());
      }return this.pushStack(r);
    };
  });var Me = new RegExp("^(" + re + ")(?!px)[a-z%]+$", "i"),
      We = function We(t) {
    var n = t.ownerDocument.defaultView;return n && n.opener || (n = e), n.getComputedStyle(t);
  },
      $e = new RegExp(oe.join("|"), "i");!function () {
    function t() {
      if (c) {
        l.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0", c.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%", xe.appendChild(l).appendChild(c);var t = e.getComputedStyle(c);i = "1%" !== t.top, s = 12 === n(t.marginLeft), c.style.right = "60%", u = 36 === n(t.right), o = 36 === n(t.width), c.style.position = "absolute", a = 36 === c.offsetWidth || "absolute", xe.removeChild(l), c = null;
      }
    }function n(e) {
      return Math.round(parseFloat(e));
    }var i,
        o,
        a,
        u,
        s,
        l = r.createElement("div"),
        c = r.createElement("div");c.style && (c.style.backgroundClip = "content-box", c.cloneNode(!0).style.backgroundClip = "", h.clearCloneStyle = "content-box" === c.style.backgroundClip, w.extend(h, { boxSizingReliable: function boxSizingReliable() {
        return t(), o;
      }, pixelBoxStyles: function pixelBoxStyles() {
        return t(), u;
      }, pixelPosition: function pixelPosition() {
        return t(), i;
      }, reliableMarginLeft: function reliableMarginLeft() {
        return t(), s;
      }, scrollboxSize: function scrollboxSize() {
        return t(), a;
      } }));
  }();function Fe(e, t, n) {
    var r,
        i,
        o,
        a,
        u = e.style;return (n = n || We(e)) && ("" !== (a = n.getPropertyValue(t) || n[t]) || w.contains(e.ownerDocument, e) || (a = w.style(e, t)), !h.pixelBoxStyles() && Me.test(a) && $e.test(t) && (r = u.width, i = u.minWidth, o = u.maxWidth, u.minWidth = u.maxWidth = u.width = a, a = n.width, u.width = r, u.minWidth = i, u.maxWidth = o)), void 0 !== a ? a + "" : a;
  }function ze(e, t) {
    return { get: function get() {
        if (!e()) return (this.get = t).apply(this, arguments);delete this.get;
      } };
  }var _e = /^(none|table(?!-c[ea]).+)/,
      Ue = /^--/,
      Ve = { position: "absolute", visibility: "hidden", display: "block" },
      Xe = { letterSpacing: "0", fontWeight: "400" },
      Qe = ["Webkit", "Moz", "ms"],
      Ye = r.createElement("div").style;function Ge(e) {
    if (e in Ye) return e;var t = e[0].toUpperCase() + e.slice(1),
        n = Qe.length;while (n--) {
      if ((e = Qe[n] + t) in Ye) return e;
    }
  }function Ke(e) {
    var t = w.cssProps[e];return t || (t = w.cssProps[e] = Ge(e) || e), t;
  }function Je(e, t, n) {
    var r = ie.exec(t);return r ? Math.max(0, r[2] - (n || 0)) + (r[3] || "px") : t;
  }function Ze(e, t, n, r, i, o) {
    var a = "width" === t ? 1 : 0,
        u = 0,
        s = 0;if (n === (r ? "border" : "content")) return 0;for (; a < 4; a += 2) {
      "margin" === n && (s += w.css(e, n + oe[a], !0, i)), r ? ("content" === n && (s -= w.css(e, "padding" + oe[a], !0, i)), "margin" !== n && (s -= w.css(e, "border" + oe[a] + "Width", !0, i))) : (s += w.css(e, "padding" + oe[a], !0, i), "padding" !== n ? s += w.css(e, "border" + oe[a] + "Width", !0, i) : u += w.css(e, "border" + oe[a] + "Width", !0, i));
    }return !r && o >= 0 && (s += Math.max(0, Math.ceil(e["offset" + t[0].toUpperCase() + t.slice(1)] - o - s - u - .5))), s;
  }function et(e, t, n) {
    var r = We(e),
        i = Fe(e, t, r),
        o = "border-box" === w.css(e, "boxSizing", !1, r),
        a = o;if (Me.test(i)) {
      if (!n) return i;i = "auto";
    }return a = a && (h.boxSizingReliable() || i === e.style[t]), ("auto" === i || !parseFloat(i) && "inline" === w.css(e, "display", !1, r)) && (i = e["offset" + t[0].toUpperCase() + t.slice(1)], a = !0), (i = parseFloat(i) || 0) + Ze(e, t, n || (o ? "border" : "content"), a, r, i) + "px";
  }w.extend({ cssHooks: { opacity: { get: function get(e, t) {
          if (t) {
            var n = Fe(e, "opacity");return "" === n ? "1" : n;
          }
        } } }, cssNumber: { animationIterationCount: !0, columnCount: !0, fillOpacity: !0, flexGrow: !0, flexShrink: !0, fontWeight: !0, lineHeight: !0, opacity: !0, order: !0, orphans: !0, widows: !0, zIndex: !0, zoom: !0 }, cssProps: {}, style: function style(e, t, n, r) {
      if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
        var i,
            o,
            a,
            u = Q(t),
            s = Ue.test(t),
            l = e.style;if (s || (t = Ke(u)), a = w.cssHooks[t] || w.cssHooks[u], void 0 === n) return a && "get" in a && void 0 !== (i = a.get(e, !1, r)) ? i : l[t];"string" == (o = typeof n === "undefined" ? "undefined" : (0, _typeof3.default)(n)) && (i = ie.exec(n)) && i[1] && (n = se(e, t, i), o = "number"), null != n && n === n && ("number" === o && (n += i && i[3] || (w.cssNumber[u] ? "" : "px")), h.clearCloneStyle || "" !== n || 0 !== t.indexOf("background") || (l[t] = "inherit"), a && "set" in a && void 0 === (n = a.set(e, n, r)) || (s ? l.setProperty(t, n) : l[t] = n));
      }
    }, css: function css(e, t, n, r) {
      var i,
          o,
          a,
          u = Q(t);return Ue.test(t) || (t = Ke(u)), (a = w.cssHooks[t] || w.cssHooks[u]) && "get" in a && (i = a.get(e, !0, n)), void 0 === i && (i = Fe(e, t, r)), "normal" === i && t in Xe && (i = Xe[t]), "" === n || n ? (o = parseFloat(i), !0 === n || isFinite(o) ? o || 0 : i) : i;
    } }), w.each(["height", "width"], function (e, t) {
    w.cssHooks[t] = { get: function get(e, n, r) {
        if (n) return !_e.test(w.css(e, "display")) || e.getClientRects().length && e.getBoundingClientRect().width ? et(e, t, r) : ue(e, Ve, function () {
          return et(e, t, r);
        });
      }, set: function set(e, n, r) {
        var i,
            o = We(e),
            a = "border-box" === w.css(e, "boxSizing", !1, o),
            u = r && Ze(e, t, r, a, o);return a && h.scrollboxSize() === o.position && (u -= Math.ceil(e["offset" + t[0].toUpperCase() + t.slice(1)] - parseFloat(o[t]) - Ze(e, t, "border", !1, o) - .5)), u && (i = ie.exec(n)) && "px" !== (i[3] || "px") && (e.style[t] = n, n = w.css(e, t)), Je(e, n, u);
      } };
  }), w.cssHooks.marginLeft = ze(h.reliableMarginLeft, function (e, t) {
    if (t) return (parseFloat(Fe(e, "marginLeft")) || e.getBoundingClientRect().left - ue(e, { marginLeft: 0 }, function () {
      return e.getBoundingClientRect().left;
    })) + "px";
  }), w.each({ margin: "", padding: "", border: "Width" }, function (e, t) {
    w.cssHooks[e + t] = { expand: function expand(n) {
        for (var r = 0, i = {}, o = "string" == typeof n ? n.split(" ") : [n]; r < 4; r++) {
          i[e + oe[r] + t] = o[r] || o[r - 2] || o[0];
        }return i;
      } }, "margin" !== e && (w.cssHooks[e + t].set = Je);
  }), w.fn.extend({ css: function css(e, t) {
      return _(this, function (e, t, n) {
        var r,
            i,
            o = {},
            a = 0;if (Array.isArray(t)) {
          for (r = We(e), i = t.length; a < i; a++) {
            o[t[a]] = w.css(e, t[a], !1, r);
          }return o;
        }return void 0 !== n ? w.style(e, t, n) : w.css(e, t);
      }, e, t, arguments.length > 1);
    } }), w.fn.delay = function (t, n) {
    return t = w.fx ? w.fx.speeds[t] || t : t, n = n || "fx", this.queue(n, function (n, r) {
      var i = e.setTimeout(n, t);r.stop = function () {
        e.clearTimeout(i);
      };
    });
  }, function () {
    var e = r.createElement("input"),
        t = r.createElement("select").appendChild(r.createElement("option"));e.type = "checkbox", h.checkOn = "" !== e.value, h.optSelected = t.selected, (e = r.createElement("input")).value = "t", e.type = "radio", h.radioValue = "t" === e.value;
  }();var tt,
      nt = w.expr.attrHandle;w.fn.extend({ attr: function attr(e, t) {
      return _(this, w.attr, e, t, arguments.length > 1);
    }, removeAttr: function removeAttr(e) {
      return this.each(function () {
        w.removeAttr(this, e);
      });
    } }), w.extend({ attr: function attr(e, t, n) {
      var r,
          i,
          o = e.nodeType;if (3 !== o && 8 !== o && 2 !== o) return "undefined" == typeof e.getAttribute ? w.prop(e, t, n) : (1 === o && w.isXMLDoc(e) || (i = w.attrHooks[t.toLowerCase()] || (w.expr.match.bool.test(t) ? tt : void 0)), void 0 !== n ? null === n ? void w.removeAttr(e, t) : i && "set" in i && void 0 !== (r = i.set(e, n, t)) ? r : (e.setAttribute(t, n + ""), n) : i && "get" in i && null !== (r = i.get(e, t)) ? r : null == (r = w.find.attr(e, t)) ? void 0 : r);
    }, attrHooks: { type: { set: function set(e, t) {
          if (!h.radioValue && "radio" === t && D(e, "input")) {
            var n = e.value;return e.setAttribute("type", t), n && (e.value = n), t;
          }
        } } }, removeAttr: function removeAttr(e, t) {
      var n,
          r = 0,
          i = t && t.match(I);if (i && 1 === e.nodeType) while (n = i[r++]) {
        e.removeAttribute(n);
      }
    } }), tt = { set: function set(e, t, n) {
      return !1 === t ? w.removeAttr(e, n) : e.setAttribute(n, n), n;
    } }, w.each(w.expr.match.bool.source.match(/\w+/g), function (e, t) {
    var n = nt[t] || w.find.attr;nt[t] = function (e, t, r) {
      var i,
          o,
          a = t.toLowerCase();return r || (o = nt[a], nt[a] = i, i = null != n(e, t, r) ? a : null, nt[a] = o), i;
    };
  });var rt = /^(?:input|select|textarea|button)$/i,
      it = /^(?:a|area)$/i;w.fn.extend({ prop: function prop(e, t) {
      return _(this, w.prop, e, t, arguments.length > 1);
    }, removeProp: function removeProp(e) {
      return this.each(function () {
        delete this[w.propFix[e] || e];
      });
    } }), w.extend({ prop: function prop(e, t, n) {
      var r,
          i,
          o = e.nodeType;if (3 !== o && 8 !== o && 2 !== o) return 1 === o && w.isXMLDoc(e) || (t = w.propFix[t] || t, i = w.propHooks[t]), void 0 !== n ? i && "set" in i && void 0 !== (r = i.set(e, n, t)) ? r : e[t] = n : i && "get" in i && null !== (r = i.get(e, t)) ? r : e[t];
    }, propHooks: { tabIndex: { get: function get(e) {
          var t = w.find.attr(e, "tabindex");return t ? parseInt(t, 10) : rt.test(e.nodeName) || it.test(e.nodeName) && e.href ? 0 : -1;
        } } }, propFix: { "for": "htmlFor", "class": "className" } }), h.optSelected || (w.propHooks.selected = { get: function get(e) {
      var t = e.parentNode;return t && t.parentNode && t.parentNode.selectedIndex, null;
    }, set: function set(e) {
      var t = e.parentNode;t && (t.selectedIndex, t.parentNode && t.parentNode.selectedIndex);
    } }), w.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function () {
    w.propFix[this.toLowerCase()] = this;
  });function ot(e) {
    return (e.match(I) || []).join(" ");
  }function at(e) {
    return e.getAttribute && e.getAttribute("class") || "";
  }function ut(e) {
    return Array.isArray(e) ? e : "string" == typeof e ? e.match(I) || [] : [];
  }w.fn.extend({ addClass: function addClass(e) {
      var t,
          n,
          r,
          i,
          o,
          a,
          u,
          s = 0;if (g(e)) return this.each(function (t) {
        w(this).addClass(e.call(this, t, at(this)));
      });if ((t = ut(e)).length) while (n = this[s++]) {
        if (i = at(n), r = 1 === n.nodeType && " " + ot(i) + " ") {
          a = 0;while (o = t[a++]) {
            r.indexOf(" " + o + " ") < 0 && (r += o + " ");
          }i !== (u = ot(r)) && n.setAttribute("class", u);
        }
      }return this;
    }, removeClass: function removeClass(e) {
      var t,
          n,
          r,
          i,
          o,
          a,
          u,
          s = 0;if (g(e)) return this.each(function (t) {
        w(this).removeClass(e.call(this, t, at(this)));
      });if (!arguments.length) return this.attr("class", "");if ((t = ut(e)).length) while (n = this[s++]) {
        if (i = at(n), r = 1 === n.nodeType && " " + ot(i) + " ") {
          a = 0;while (o = t[a++]) {
            while (r.indexOf(" " + o + " ") > -1) {
              r = r.replace(" " + o + " ", " ");
            }
          }i !== (u = ot(r)) && n.setAttribute("class", u);
        }
      }return this;
    }, toggleClass: function toggleClass(e, t) {
      var n = typeof e === "undefined" ? "undefined" : (0, _typeof3.default)(e),
          r = "string" === n || Array.isArray(e);return "boolean" == typeof t && r ? t ? this.addClass(e) : this.removeClass(e) : g(e) ? this.each(function (n) {
        w(this).toggleClass(e.call(this, n, at(this), t), t);
      }) : this.each(function () {
        var t, i, o, a;if (r) {
          i = 0, o = w(this), a = ut(e);while (t = a[i++]) {
            o.hasClass(t) ? o.removeClass(t) : o.addClass(t);
          }
        } else void 0 !== e && "boolean" !== n || ((t = at(this)) && K.set(this, "__className__", t), this.setAttribute && this.setAttribute("class", t || !1 === e ? "" : K.get(this, "__className__") || ""));
      });
    }, hasClass: function hasClass(e) {
      var t,
          n,
          r = 0;t = " " + e + " ";while (n = this[r++]) {
        if (1 === n.nodeType && (" " + ot(at(n)) + " ").indexOf(t) > -1) return !0;
      }return !1;
    } });var st = /\r/g;w.fn.extend({ val: function val(e) {
      var t,
          n,
          r,
          i = this[0];{
        if (arguments.length) return r = g(e), this.each(function (n) {
          var i;1 === this.nodeType && (null == (i = r ? e.call(this, n, w(this).val()) : e) ? i = "" : "number" == typeof i ? i += "" : Array.isArray(i) && (i = w.map(i, function (e) {
            return null == e ? "" : e + "";
          })), (t = w.valHooks[this.type] || w.valHooks[this.nodeName.toLowerCase()]) && "set" in t && void 0 !== t.set(this, i, "value") || (this.value = i));
        });if (i) return (t = w.valHooks[i.type] || w.valHooks[i.nodeName.toLowerCase()]) && "get" in t && void 0 !== (n = t.get(i, "value")) ? n : "string" == typeof (n = i.value) ? n.replace(st, "") : null == n ? "" : n;
      }
    } }), w.extend({ valHooks: { option: { get: function get(e) {
          var t = w.find.attr(e, "value");return null != t ? t : ot(w.text(e));
        } }, select: { get: function get(e) {
          var t,
              n,
              r,
              i = e.options,
              o = e.selectedIndex,
              a = "select-one" === e.type,
              u = a ? null : [],
              s = a ? o + 1 : i.length;for (r = o < 0 ? s : a ? o : 0; r < s; r++) {
            if (((n = i[r]).selected || r === o) && !n.disabled && (!n.parentNode.disabled || !D(n.parentNode, "optgroup"))) {
              if (t = w(n).val(), a) return t;u.push(t);
            }
          }return u;
        }, set: function set(e, t) {
          var n,
              r,
              i = e.options,
              o = w.makeArray(t),
              a = i.length;while (a--) {
            ((r = i[a]).selected = w.inArray(w.valHooks.option.get(r), o) > -1) && (n = !0);
          }return n || (e.selectedIndex = -1), o;
        } } } }), w.each(["radio", "checkbox"], function () {
    w.valHooks[this] = { set: function set(e, t) {
        if (Array.isArray(t)) return e.checked = w.inArray(w(e).val(), t) > -1;
      } }, h.checkOn || (w.valHooks[this].get = function (e) {
      return null === e.getAttribute("value") ? "on" : e.value;
    });
  }), h.focusin = "onfocusin" in e;var lt = /^(?:focusinfocus|focusoutblur)$/,
      ct = function ct(e) {
    e.stopPropagation();
  };w.extend(w.event, { trigger: function trigger(t, n, i, o) {
      var a,
          u,
          s,
          l,
          c,
          d,
          p,
          h,
          y = [i || r],
          m = f.call(t, "type") ? t.type : t,
          b = f.call(t, "namespace") ? t.namespace.split(".") : [];if (u = h = s = i = i || r, 3 !== i.nodeType && 8 !== i.nodeType && !lt.test(m + w.event.triggered) && (m.indexOf(".") > -1 && (m = (b = m.split(".")).shift(), b.sort()), c = m.indexOf(":") < 0 && "on" + m, t = t[w.expando] ? t : new w.Event(m, "object" == (typeof t === "undefined" ? "undefined" : (0, _typeof3.default)(t)) && t), t.isTrigger = o ? 2 : 3, t.namespace = b.join("."), t.rnamespace = t.namespace ? new RegExp("(^|\\.)" + b.join("\\.(?:.*\\.|)") + "(\\.|$)") : null, t.result = void 0, t.target || (t.target = i), n = null == n ? [t] : w.makeArray(n, [t]), p = w.event.special[m] || {}, o || !p.trigger || !1 !== p.trigger.apply(i, n))) {
        if (!o && !p.noBubble && !v(i)) {
          for (l = p.delegateType || m, lt.test(l + m) || (u = u.parentNode); u; u = u.parentNode) {
            y.push(u), s = u;
          }s === (i.ownerDocument || r) && y.push(s.defaultView || s.parentWindow || e);
        }a = 0;while ((u = y[a++]) && !t.isPropagationStopped()) {
          h = u, t.type = a > 1 ? l : p.bindType || m, (d = (K.get(u, "events") || {})[t.type] && K.get(u, "handle")) && d.apply(u, n), (d = c && u[c]) && d.apply && Y(u) && (t.result = d.apply(u, n), !1 === t.result && t.preventDefault());
        }return t.type = m, o || t.isDefaultPrevented() || p._default && !1 !== p._default.apply(y.pop(), n) || !Y(i) || c && g(i[m]) && !v(i) && ((s = i[c]) && (i[c] = null), w.event.triggered = m, t.isPropagationStopped() && h.addEventListener(m, ct), i[m](), t.isPropagationStopped() && h.removeEventListener(m, ct), w.event.triggered = void 0, s && (i[c] = s)), t.result;
      }
    }, simulate: function simulate(e, t, n) {
      var r = w.extend(new w.Event(), n, { type: e, isSimulated: !0 });w.event.trigger(r, null, t);
    } }), w.fn.extend({ trigger: function trigger(e, t) {
      return this.each(function () {
        w.event.trigger(e, t, this);
      });
    }, triggerHandler: function triggerHandler(e, t) {
      var n = this[0];if (n) return w.event.trigger(e, t, n, !0);
    } }), h.focusin || w.each({ focus: "focusin", blur: "focusout" }, function (e, t) {
    var n = function n(e) {
      w.event.simulate(t, e.target, w.event.fix(e));
    };w.event.special[t] = { setup: function setup() {
        var r = this.ownerDocument || this,
            i = K.access(r, t);i || r.addEventListener(e, n, !0), K.access(r, t, (i || 0) + 1);
      }, teardown: function teardown() {
        var r = this.ownerDocument || this,
            i = K.access(r, t) - 1;i ? K.access(r, t, i) : (r.removeEventListener(e, n, !0), K.remove(r, t));
      } };
  });var ft = /\[\]$/,
      dt = /\r?\n/g,
      pt = /^(?:submit|button|image|reset|file)$/i,
      ht = /^(?:input|select|textarea|keygen)/i;function gt(e, t, n, r) {
    var i;if (Array.isArray(t)) w.each(t, function (t, i) {
      n || ft.test(e) ? r(e, i) : gt(e + "[" + ("object" == (typeof i === "undefined" ? "undefined" : (0, _typeof3.default)(i)) && null != i ? t : "") + "]", i, n, r);
    });else if (n || "object" !== b(t)) r(e, t);else for (i in t) {
      gt(e + "[" + i + "]", t[i], n, r);
    }
  }w.param = function (e, t) {
    var n,
        r = [],
        i = function i(e, t) {
      var n = g(t) ? t() : t;r[r.length] = encodeURIComponent(e) + "=" + encodeURIComponent(null == n ? "" : n);
    };if (Array.isArray(e) || e.jquery && !w.isPlainObject(e)) w.each(e, function () {
      i(this.name, this.value);
    });else for (n in e) {
      gt(n, e[n], t, i);
    }return r.join("&");
  }, w.fn.extend({ serialize: function serialize() {
      return w.param(this.serializeArray());
    }, serializeArray: function serializeArray() {
      return this.map(function () {
        var e = w.prop(this, "elements");return e ? w.makeArray(e) : this;
      }).filter(function () {
        var e = this.type;return this.name && !w(this).is(":disabled") && ht.test(this.nodeName) && !pt.test(e) && (this.checked || !de.test(e));
      }).map(function (e, t) {
        var n = w(this).val();return null == n ? null : Array.isArray(n) ? w.map(n, function (e) {
          return { name: t.name, value: e.replace(dt, "\r\n") };
        }) : { name: t.name, value: n.replace(dt, "\r\n") };
      }).get();
    } }), w.fn.extend({ wrapAll: function wrapAll(e) {
      var t;return this[0] && (g(e) && (e = e.call(this[0])), t = w(e, this[0].ownerDocument).eq(0).clone(!0), this[0].parentNode && t.insertBefore(this[0]), t.map(function () {
        var e = this;while (e.firstElementChild) {
          e = e.firstElementChild;
        }return e;
      }).append(this)), this;
    }, wrapInner: function wrapInner(e) {
      return g(e) ? this.each(function (t) {
        w(this).wrapInner(e.call(this, t));
      }) : this.each(function () {
        var t = w(this),
            n = t.contents();n.length ? n.wrapAll(e) : t.append(e);
      });
    }, wrap: function wrap(e) {
      var t = g(e);return this.each(function (n) {
        w(this).wrapAll(t ? e.call(this, n) : e);
      });
    }, unwrap: function unwrap(e) {
      return this.parent(e).not("body").each(function () {
        w(this).replaceWith(this.childNodes);
      }), this;
    } }), w.expr.pseudos.hidden = function (e) {
    return !w.expr.pseudos.visible(e);
  }, w.expr.pseudos.visible = function (e) {
    return !!(e.offsetWidth || e.offsetHeight || e.getClientRects().length);
  }, h.createHTMLDocument = function () {
    var e = r.implementation.createHTMLDocument("").body;return e.innerHTML = "<form></form><form></form>", 2 === e.childNodes.length;
  }(), w.parseHTML = function (e, t, n) {
    if ("string" != typeof e) return [];"boolean" == typeof t && (n = t, t = !1);var i, o, a;return t || (h.createHTMLDocument ? ((i = (t = r.implementation.createHTMLDocument("")).createElement("base")).href = r.location.href, t.head.appendChild(i)) : t = r), o = S.exec(e), a = !n && [], o ? [t.createElement(o[1])] : (o = be([e], t, a), a && a.length && w(a).remove(), w.merge([], o.childNodes));
  }, w.offset = { setOffset: function setOffset(e, t, n) {
      var r,
          i,
          o,
          a,
          u,
          s,
          l,
          c = w.css(e, "position"),
          f = w(e),
          d = {};"static" === c && (e.style.position = "relative"), u = f.offset(), o = w.css(e, "top"), s = w.css(e, "left"), (l = ("absolute" === c || "fixed" === c) && (o + s).indexOf("auto") > -1) ? (a = (r = f.position()).top, i = r.left) : (a = parseFloat(o) || 0, i = parseFloat(s) || 0), g(t) && (t = t.call(e, n, w.extend({}, u))), null != t.top && (d.top = t.top - u.top + a), null != t.left && (d.left = t.left - u.left + i), "using" in t ? t.using.call(e, d) : f.css(d);
    } }, w.fn.extend({ offset: function offset(e) {
      if (arguments.length) return void 0 === e ? this : this.each(function (t) {
        w.offset.setOffset(this, e, t);
      });var t,
          n,
          r = this[0];if (r) return r.getClientRects().length ? (t = r.getBoundingClientRect(), n = r.ownerDocument.defaultView, { top: t.top + n.pageYOffset, left: t.left + n.pageXOffset }) : { top: 0, left: 0 };
    }, position: function position() {
      if (this[0]) {
        var e,
            t,
            n,
            r = this[0],
            i = { top: 0, left: 0 };if ("fixed" === w.css(r, "position")) t = r.getBoundingClientRect();else {
          t = this.offset(), n = r.ownerDocument, e = r.offsetParent || n.documentElement;while (e && (e === n.body || e === n.documentElement) && "static" === w.css(e, "position")) {
            e = e.parentNode;
          }e && e !== r && 1 === e.nodeType && ((i = w(e).offset()).top += w.css(e, "borderTopWidth", !0), i.left += w.css(e, "borderLeftWidth", !0));
        }return { top: t.top - i.top - w.css(r, "marginTop", !0), left: t.left - i.left - w.css(r, "marginLeft", !0) };
      }
    }, offsetParent: function offsetParent() {
      return this.map(function () {
        var e = this.offsetParent;while (e && "static" === w.css(e, "position")) {
          e = e.offsetParent;
        }return e || xe;
      });
    } }), w.each({ scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function (e, t) {
    var n = "pageYOffset" === t;w.fn[e] = function (r) {
      return _(this, function (e, r, i) {
        var o;if (v(e) ? o = e : 9 === e.nodeType && (o = e.defaultView), void 0 === i) return o ? o[t] : e[r];o ? o.scrollTo(n ? o.pageXOffset : i, n ? i : o.pageYOffset) : e[r] = i;
      }, e, r, arguments.length);
    };
  }), w.each(["top", "left"], function (e, t) {
    w.cssHooks[t] = ze(h.pixelPosition, function (e, n) {
      if (n) return n = Fe(e, t), Me.test(n) ? w(e).position()[t] + "px" : n;
    });
  }), w.each({ Height: "height", Width: "width" }, function (e, t) {
    w.each({ padding: "inner" + e, content: t, "": "outer" + e }, function (n, r) {
      w.fn[r] = function (i, o) {
        var a = arguments.length && (n || "boolean" != typeof i),
            u = n || (!0 === i || !0 === o ? "margin" : "border");return _(this, function (t, n, i) {
          var o;return v(t) ? 0 === r.indexOf("outer") ? t["inner" + e] : t.document.documentElement["client" + e] : 9 === t.nodeType ? (o = t.documentElement, Math.max(t.body["scroll" + e], o["scroll" + e], t.body["offset" + e], o["offset" + e], o["client" + e])) : void 0 === i ? w.css(t, n, u) : w.style(t, n, i, u);
        }, t, a ? i : void 0, a);
      };
    });
  }), w.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function (e, t) {
    w.fn[t] = function (e, n) {
      return arguments.length > 0 ? this.on(t, null, e, n) : this.trigger(t);
    };
  }), w.fn.extend({ hover: function hover(e, t) {
      return this.mouseenter(e).mouseleave(t || e);
    } }), w.fn.extend({ bind: function bind(e, t, n) {
      return this.on(e, null, t, n);
    }, unbind: function unbind(e, t) {
      return this.off(e, null, t);
    }, delegate: function delegate(e, t, n, r) {
      return this.on(t, e, n, r);
    }, undelegate: function undelegate(e, t, n) {
      return 1 === arguments.length ? this.off(e, "**") : this.off(t, e || "**", n);
    } }), w.proxy = function (e, t) {
    var n, r, i;if ("string" == typeof t && (n = e[t], t = e, e = n), g(e)) return r = o.call(arguments, 2), i = function i() {
      return e.apply(t || this, r.concat(o.call(arguments)));
    }, i.guid = e.guid = e.guid || w.guid++, i;
  }, w.holdReady = function (e) {
    e ? w.readyWait++ : w.ready(!0);
  }, w.isArray = Array.isArray, w.parseJSON = JSON.parse, w.nodeName = D, w.isFunction = g, w.isWindow = v, w.camelCase = Q, w.type = b, w.now = Date.now, w.isNumeric = function (e) {
    var t = w.type(e);return ("number" === t || "string" === t) && !isNaN(e - parseFloat(e));
  }, "function" == "function" && __webpack_require__(748) && !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
    return w;
  }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));var vt = e.jQuery,
      yt = e.$;return w.noConflict = function (t) {
    return e.$ === w && (e.$ = yt), t && e.jQuery === w && (e.jQuery = vt), w;
  }, t || (e.jQuery = e.$ = w), w;
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(372)(module)))

/***/ }),

/***/ 373:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1453)
__webpack_require__(1452)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(834),
  /* template */
  __webpack_require__(1651),
  /* scopeId */
  "data-v-22e6c32a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 374:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1442)
__webpack_require__(1441)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(838),
  /* template */
  __webpack_require__(1645),
  /* scopeId */
  "data-v-13ce559a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 43:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1496)
__webpack_require__(1495)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(813),
  /* template */
  __webpack_require__(1679),
  /* scopeId */
  "data-v-869554ae",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 685:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1505)

var Component = __webpack_require__(8)(
  /* script */
  null,
  /* template */
  __webpack_require__(1686),
  /* scopeId */
  "data-v-c97697f2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 686:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1501)
__webpack_require__(1500)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(831),
  /* template */
  __webpack_require__(1682),
  /* scopeId */
  "data-v-b4ba3264",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 687:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1479)
__webpack_require__(1477)
__webpack_require__(1478)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(832),
  /* template */
  __webpack_require__(1667),
  /* scopeId */
  "data-v-5477d7bf",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 688:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1437)
__webpack_require__(1436)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(833),
  /* template */
  __webpack_require__(1642),
  /* scopeId */
  "data-v-02048b34",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 689:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1446)
__webpack_require__(1444)
__webpack_require__(1445)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(835),
  /* template */
  __webpack_require__(1647),
  /* scopeId */
  "data-v-18c64b6c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 690:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1458)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(836),
  /* template */
  __webpack_require__(1655),
  /* scopeId */
  "data-v-31411498",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 691:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1475)
__webpack_require__(1474)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(839),
  /* template */
  __webpack_require__(1665),
  /* scopeId */
  "data-v-472bac21",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 692:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1464)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(841),
  /* template */
  __webpack_require__(1659),
  /* scopeId */
  "data-v-37f2f7f6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 693:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1503)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(842),
  /* template */
  __webpack_require__(1684),
  /* scopeId */
  "data-v-b570a3ee",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 694:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1482)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(843),
  /* template */
  __webpack_require__(1670),
  /* scopeId */
  "data-v-5b31a80e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 695:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1443)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(844),
  /* template */
  __webpack_require__(1646),
  /* scopeId */
  "data-v-16e37b6a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 696:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1491)
__webpack_require__(1490)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(845),
  /* template */
  __webpack_require__(1676),
  /* scopeId */
  "data-v-70d36a68",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 697:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1504)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(846),
  /* template */
  __webpack_require__(1685),
  /* scopeId */
  "data-v-ba089736",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 698:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1454)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(847),
  /* template */
  __webpack_require__(1652),
  /* scopeId */
  "data-v-246c3aa2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 699:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1450)
__webpack_require__(1448)
__webpack_require__(1449)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(848),
  /* template */
  __webpack_require__(1649),
  /* scopeId */
  "data-v-1940072f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 700:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1440)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(849),
  /* template */
  __webpack_require__(1644),
  /* scopeId */
  "data-v-0f50e616",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 701:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1447)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(850),
  /* template */
  __webpack_require__(1648),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 702:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1480)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(851),
  /* template */
  __webpack_require__(1668),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 703:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1481)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(852),
  /* template */
  __webpack_require__(1669),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 704:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1461)
__webpack_require__(1460)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(853),
  /* template */
  __webpack_require__(1657),
  /* scopeId */
  "data-v-34d0bb15",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 705:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1439)
__webpack_require__(1438)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(854),
  /* template */
  __webpack_require__(1643),
  /* scopeId */
  "data-v-0d208be4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 706:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1499)
__webpack_require__(1498)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(855),
  /* template */
  __webpack_require__(1681),
  /* scopeId */
  "data-v-a886722c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 707:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1451)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(856),
  /* template */
  __webpack_require__(1650),
  /* scopeId */
  "data-v-1be1bbaf",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 708:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1469)
__webpack_require__(1468)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(857),
  /* template */
  __webpack_require__(1662),
  /* scopeId */
  "data-v-3e507331",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 729:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);

var  theHeader = ''


// 添加请求拦截器
__WEBPACK_IMPORTED_MODULE_0_axios___default.a.interceptors.request.use(function (config) {
    
    // if(theHeader != ''){
    //     config.headers.authorization = theHeader
    // }
    if(sessionStorage.getItem('token')){
        config.headers.Authorization = sessionStorage.getItem('token');
    }
　　return config

}, function (error) {
　　// 对请求错误做些什么
    return Promise.reject(error)
});

// 添加响应拦截器
__WEBPACK_IMPORTED_MODULE_0_axios___default.a.interceptors.response.use(function (response) {
  
    const status = response.status
    if(status === 200){

    }else if(status === 403){
        this.$router.push({ path:'/loging'})
    }
    
    // if(theHeader != response.headers.authorization){
    //     theHeader = response.headers.authorization
    // }
    if(sessionStorage.getItem('token') != response.headers.authorization && response.headers.authorization){
        sessionStorage.setItem('token',response.headers.authorization)
    }

　　// 对响应数据做点什么
　　return response
}, function (error) {
　　// 对响应错误做点什么
　　return Promise.reject(error)
});



/***/ }),

/***/ 731:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(21);

var _vue2 = _interopRequireDefault(_vue);

var _XmDialog = __webpack_require__(1641);

var _XmDialog2 = _interopRequireDefault(_XmDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_XmDialog2.default.install = function (ensureHanlder, options, cancelHandler) {
  if (!ensureHanlder) {
    ensureHanlder = function ensureHanlder() {};
  }
  if (!cancelHandler) {
    cancelHandler = function cancelHandler() {};
  }

  if (!options) {
    options = {};
  }
  options['message'] = options.message ? options.message : '确认删除此数据？';
  options['title'] = options.title ? options.title : '提示';
  options['subMessage'] = options.subMessage ? options.subMessage : '删除后不可恢复，请谨慎操作！';
  options['isCloseIcon'] = options.isCloseIcon || true;
  options['ensureBtnText'] = options.ensureBtnText ? options.ensureBtnText : '确认';
  var MyHlAlert = _vue2.default.extend(_XmDialog2.default);

  var currentComponent = new MyHlAlert({
    data: options,
    methods: {
      ensureHanlder: ensureHanlder,
      cancelHandler: cancelHandler }
  }).$mount();
  document.querySelector('body').appendChild(currentComponent.$el);
};

exports.default = _XmDialog2.default;

/***/ }),

/***/ 732:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(21);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.directive('dialogDrag', {
    bind: function bind(el, binding, vnode, oldVnode) {
        setTimeout(function () {
            var dialogHeaderEl = document.getElementById("message-box");
            var dragDom = document.getElementById("message-header");
            dialogHeaderEl.style.cursor = 'move';

            var sty = dragDom.currentStyle || window.getComputedStyle(dragDom, null);

            dialogHeaderEl.onmousedown = function (e) {
                var disX = e.clientX - dialogHeaderEl.offsetLeft;
                var disY = e.clientY - dialogHeaderEl.offsetTop;

                var styL = void 0,
                    styT = void 0;

                if (sty.left.includes('%')) {
                    styL = +document.body.clientWidth * (+sty.left.replace(/\%/g, '') / 100);
                    styT = +document.body.clientHeight * (+sty.top.replace(/\%/g, '') / 100);
                } else {
                    styL = +sty.left.replace(/\px/g, '');
                    styT = +sty.top.replace(/\px/g, '');
                }
                ;

                document.onmousemove = function (e) {
                    var l = e.clientX - disX;
                    var t = e.clientY - disY;

                    dialogHeaderEl.style.left = l + styL + 'px';
                    dialogHeaderEl.style.top = t + styT + 'px';
                };

                document.onmouseup = function (e) {
                    document.onmousemove = null;
                    document.onmouseup = null;
                };
            };
        }, 1);
    }
});

_vue2.default.directive('dialogDragWidth', {
    bind: function bind(el, binding, vnode, oldVnode) {
        var dragDom = binding.value.$el.querySelector('.el-dialog');

        el.onmousedown = function (e) {
            var disX = e.clientX - el.offsetLeft;

            document.onmousemove = function (e) {
                e.preventDefault();
                var l = e.clientX - disX;
                dragDom.style.width = l + 'px';
            };

            document.onmouseup = function (e) {
                document.onmousemove = null;
                document.onmouseup = null;
            };
        };
    }
});

_vue2.default.directive('btn', {
    inserted: function inserted(el, binding, vnode) {
        var btnGroup = JSON.parse(sessionStorage.getItem("user")).buttons;
        var btnPermissionsStr = btnGroup.map(function (item) {
            return item.btnValue;
        }).filter(Boolean);
        if (btnPermissionsStr.includes(binding.value)) {
            el.innerHTML = btnGroup.filter(function (item) {
                return item.btnValue == binding.value;
            })[0].btnName;
        } else {
            if (el.parentNode !== null) {
                el.parentNode.removeChild(el);
            }
        }
    }
});

/***/ }),

/***/ 733:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _LoginView = __webpack_require__(690);

var _LoginView2 = _interopRequireDefault(_LoginView);

var _View = __webpack_require__(685);

var _View2 = _interopRequireDefault(_View);

var _HomeView = __webpack_require__(373);

var _HomeView2 = _interopRequireDefault(_HomeView);

var _Navigation = __webpack_require__(374);

var _Navigation2 = _interopRequireDefault(_Navigation);

var _welcomeView = __webpack_require__(708);

var _welcomeView2 = _interopRequireDefault(_welcomeView);

var _AppLogin = __webpack_require__(686);

var _AppLogin2 = _interopRequireDefault(_AppLogin);

var _agent = __webpack_require__(691);

var _agent2 = _interopRequireDefault(_agent);

var _copy = __webpack_require__(693);

var _copy2 = _interopRequireDefault(_copy);

var _appUserInfo = __webpack_require__(692);

var _appUserInfo2 = _interopRequireDefault(_appUserInfo);

var _fileh = __webpack_require__(699);

var _fileh2 = _interopRequireDefault(_fileh);

var _H5Upload = __webpack_require__(688);

var _H5Upload2 = _interopRequireDefault(_H5Upload);

var _JournalFileh = __webpack_require__(689);

var _JournalFileh2 = _interopRequireDefault(_JournalFileh);

var _CommonUploadH = __webpack_require__(687);

var _CommonUploadH2 = _interopRequireDefault(_CommonUploadH);

var _syntheticDataH = __webpack_require__(704);

var _syntheticDataH2 = _interopRequireDefault(_syntheticDataH);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = [{
    path: '/login',
    component: _LoginView2.default,
    name: '',
    leaf: false,
    hidden: true
}, {
    path: '/appLogin',
    component: _AppLogin2.default,
    name: '',
    leaf: false,
    hidden: true
}, {
    path: '/appLogin/agent',
    component: _agent2.default,
    name: '',
    leaf: false,
    hidden: true
}, {
    path: '/appLogin/copy',
    component: _copy2.default,
    name: '',
    leaf: false,
    hidden: true
}, {
    path: '/appLogin/appUserInfo',
    component: _appUserInfo2.default,
    name: '',
    leaf: false,
    hidden: true
}, {
    path: '/fileh5',
    component: _fileh2.default,
    name: '',
    leaf: false,
    hidden: true
}, {
    path: '/h5upload',
    component: _H5Upload2.default,
    name: '',
    leaf: false,
    hidden: true
}, {
    path: '/JournalFileh5',
    component: _JournalFileh2.default,
    name: '',
    leaf: false,
    hidden: true
}, {
    path: '/CommonUploadH5',
    component: _CommonUploadH2.default,
    name: '',
    leaf: false,
    hidden: true
}, {
    path: '/404',
    component: _View2.default,
    name: '',
    leaf: false,
    hidden: true
}, {
    path: '*',
    hidden: true,
    leaf: false,
    redirect: { path: '/404' }
}, {
    path: '/operationDataH5',
    component: _syntheticDataH2.default,
    name: '',
    leaf: false,
    hidden: true
}, {
    path: '/pdfViewH5',
    component: function component() {
        return __webpack_require__.e/* import() */(5/* duplicate */).then(__webpack_require__.bind(null, 766));
    },
    name: 'pdfViewH5',
    leaf: false,
    hidden: true
}, {
    path: '/businessInfoH5',
    component: function component() {
        return __webpack_require__.e/* import() */(9/* duplicate */).then(__webpack_require__.bind(null, 761));
    },
    name: 'businessInfo',
    leaf: false,
    hidden: true
}, {
    path: '/datav/index',
    component: function component() {
        return __webpack_require__.e/* import() */(7/* duplicate */).then(__webpack_require__.bind(null, 763));
    },
    leaf: false,
    hidden: true
}, {
    path: '/datav/pm',
    component: function component() {
        return __webpack_require__.e/* import() */(3/* duplicate */).then(__webpack_require__.bind(null, 750));
    },
    leaf: false,
    hidden: true
}, {
    path: '/datav/project',
    component: function component() {
        return __webpack_require__.e/* import() */(2/* duplicate */).then(__webpack_require__.bind(null, 751));
    },
    leaf: false,
    hidden: true
}, {
    path: '/datav/customer',
    component: function component() {
        return __webpack_require__.e/* import() */(4/* duplicate */).then(__webpack_require__.bind(null, 749));
    },
    leaf: false,
    hidden: true
}, {
    path: '/datavIndex',
    component: function component() {
        return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 765));
    },
    leaf: false,
    hidden: true
}, {
    path: '/bizCompasition',
    component: function component() {
        return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 764));
    },
    leaf: false,
    hidden: true
}, {
    path: '/datav/biz',
    component: function component() {
        return __webpack_require__.e/* import() */(8/* duplicate */).then(__webpack_require__.bind(null, 762));
    },
    leaf: false,
    hidden: true
}, {
    path: '/forgotPassword',
    component: function component() {
        return __webpack_require__.e/* import() */(6/* duplicate */).then(__webpack_require__.bind(null, 760));
    },
    leaf: false,
    hidden: true
}, {
    path: '/',
    component: _HomeView2.default,
    name: '首页',
    redirect: '/home/welcomeView',
    children: [{
        component: _Navigation2.default,
        path: "/home",
        name: "工作视窗",
        children: [{
            component: _welcomeView2.default,
            path: "/home/welcomeView",
            hidden: true,
            name: "工作台"
        }]
    }]
}];

exports.default = routes;

/***/ }),

/***/ 734:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var setFontSize = function setFontSize() {
    var minFontSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 12;
    var maxFontSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 16;

    var deviceWidth = document.documentElement.clientWidth;

    if (deviceWidth > 750) {
        deviceWidth = 750;
        deviceWidth = 7.5 * 50;
    }
    document.documentElement.style.fontSize = deviceWidth / 3.75 + 'px';

    document.documentElement.addEventListener('touchstart', function (event) {
        if (event.touches.length > 1) {
            event.preventDefault();
        }
    }, false);
    var lastTouchEnd = 0;
    document.documentElement.addEventListener('touchend', function (event) {
        var now = Date.now();
        if (now - lastTouchEnd <= 300) {
            event.preventDefault();
        }
        lastTouchEnd = now;
    }, false);
};
exports.default = {
    setFontSize: setFontSize
};

/***/ }),

/***/ 735:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(21);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(205);

var _vuex2 = _interopRequireDefault(_vuex);

var _actions = __webpack_require__(890);

var actions = _interopRequireWildcard(_actions);

var _getters = __webpack_require__(891);

var getters = _interopRequireWildcard(_getters);

var _modules = __webpack_require__(892);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

var state = {
    count: 10,
    row: {}
};

var mutations = {
    INCREMENT: function INCREMENT(state) {
        state.count++;
    },
    DECREMENT: function DECREMENT(state) {
        state.count--;
    },
    addRow: function addRow(state, data) {
        state.row = data;
    }
};

exports.default = new _vuex2.default.Store({
    actions: actions,
    getters: getters,
    state: state,
    mutations: mutations,
    modules: {
        treeState: _modules.treeState,
        benchParam: _modules.benchParam,
        showState: _modules.showState,
        projectInfo: _modules.projectInfo
    }
});

/***/ }),

/***/ 738:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 739:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 740:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 741:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1485)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(812),
  /* template */
  __webpack_require__(1672),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 745:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1486)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(827),
  /* template */
  __webpack_require__(1673),
  /* scopeId */
  "data-v-67b15251",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 753:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1497)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(814),
  /* template */
  __webpack_require__(1680),
  /* scopeId */
  "data-v-88ffe1f8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 754:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1471)
__webpack_require__(1470)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(816),
  /* template */
  __webpack_require__(1663),
  /* scopeId */
  "data-v-445413ae",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 755:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1484)
__webpack_require__(1483)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(817),
  /* template */
  __webpack_require__(1671),
  /* scopeId */
  "data-v-5cbbc494",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 756:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1467)
__webpack_require__(1466)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(818),
  /* template */
  __webpack_require__(1661),
  /* scopeId */
  "data-v-3c2279ff",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 757:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1456)
__webpack_require__(1455)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(819),
  /* template */
  __webpack_require__(1653),
  /* scopeId */
  "data-v-257e7324",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 758:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1493)
__webpack_require__(1492)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(820),
  /* template */
  __webpack_require__(1677),
  /* scopeId */
  "data-v-71d9bac3",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 759:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1463)
__webpack_require__(1462)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(821),
  /* template */
  __webpack_require__(1658),
  /* scopeId */
  "data-v-363d8e8a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 810:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.offsetModifier = exports.createPopper = undefined;

var _assign = __webpack_require__(261);

var _assign2 = _interopRequireDefault(_assign);

var _keys = __webpack_require__(746);

var _keys2 = _interopRequireDefault(_keys);

var _promise = __webpack_require__(263);

var _promise2 = _interopRequireDefault(_promise);

var _set = __webpack_require__(897);

var _set2 = _interopRequireDefault(_set);

var _map = __webpack_require__(896);

var _map2 = _interopRequireDefault(_map);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getWindow(node) {
  if (node == null) {
    return window;
  }
  if (node.toString() !== "[object Window]") {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }
  return node;
}

function isElement(node) {
  var OwnElement = getWindow(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}
function isHTMLElement(node) {
  var OwnElement = getWindow(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}
function isShadowRoot(node) {
  if (typeof ShadowRoot === "undefined") {
    return false;
  }
  var OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}

var round = Math.round;

function getUAString() {
  var uaData = navigator.userAgentData;
  if (uaData != null && uaData.brands) {
    return uaData.brands.map(function (item) {
      return item.brand + "/" + item.version;
    }).join(" ");
  }
  return navigator.userAgent;
}

function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}

function getBoundingClientRect(element, includeScale, isFixedStrategy) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  var clientRect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;
  if (includeScale && isHTMLElement(element)) {
    scaleX = element.offsetWidth > 0 ? round(clientRect.width) / element.offsetWidth || 1 : 1;
    scaleY = element.offsetHeight > 0 ? round(clientRect.height) / element.offsetHeight || 1 : 1;
  }
  var _ref = isElement(element) ? getWindow(element) : window,
      visualViewport = _ref.visualViewport;
  var addVisualOffsets = !isLayoutViewport() && isFixedStrategy;
  var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
  var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
  var width = clientRect.width / scaleX;
  var height = clientRect.height / scaleY;
  return {
    width: width,
    height: height,
    top: y,
    right: x + width,
    bottom: y + height,
    left: x,
    x: x,
    y: y
  };
}

function getWindowScroll(node) {
  var win = getWindow(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}

function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}

function getNodeScroll(node) {
  if (node === getWindow(node) || !isHTMLElement(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}

function getNodeName(element) {
  return element ? (element.nodeName || "").toLowerCase() : null;
}

function getDocumentElement(element) {
  return ((isElement(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

function getWindowScrollBarX(element) {
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}

function getComputedStyle(element) {
  return getWindow(element).getComputedStyle(element);
}

function isScrollParent(element) {
  var _getComputedStyle = getComputedStyle(element),
      overflow = _getComputedStyle.overflow,
      overflowX = _getComputedStyle.overflowX,
      overflowY = _getComputedStyle.overflowY;
  return (/auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX)
  );
}

function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = round(rect.width) / element.offsetWidth || 1;
  var scaleY = round(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
}
function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  var isOffsetParentAnElement = isHTMLElement(offsetParent);
  var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled, isFixed);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== "body" || isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isHTMLElement(offsetParent)) {
      offsets = getBoundingClientRect(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }
  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}

function getLayoutRect(element) {
  var clientRect = getBoundingClientRect(element);
  var width = element.offsetWidth;
  var height = element.offsetHeight;
  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }
  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }
  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: width,
    height: height
  };
}

function getParentNode(element) {
  if (getNodeName(element) === "html") {
    return element;
  }
  return element.assignedSlot || element.parentNode || (isShadowRoot(element) ? element.host : null) || getDocumentElement(element);
}

function getScrollParent(node) {
  if (["html", "body", "#document"].indexOf(getNodeName(node)) >= 0) {
    return node.ownerDocument.body;
  }
  if (isHTMLElement(node) && isScrollParent(node)) {
    return node;
  }
  return getScrollParent(getParentNode(node));
}

function listScrollParents(element, list) {
  var _element$ownerDocumen;
  if (list === void 0) {
    list = [];
  }
  var scrollParent = getScrollParent(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : updatedList.concat(listScrollParents(getParentNode(target)));
}

function isTableElement(element) {
  return ["table", "td", "th"].indexOf(getNodeName(element)) >= 0;
}

function getTrueOffsetParent(element) {
  if (!isHTMLElement(element) || getComputedStyle(element).position === "fixed") {
    return null;
  }
  return element.offsetParent;
}
function getContainingBlock(element) {
  var isFirefox = /firefox/i.test(getUAString());
  var isIE = /Trident/i.test(getUAString());
  if (isIE && isHTMLElement(element)) {
    var elementCss = getComputedStyle(element);
    if (elementCss.position === "fixed") {
      return null;
    }
  }
  var currentNode = getParentNode(element);
  if (isShadowRoot(currentNode)) {
    currentNode = currentNode.host;
  }
  while (isHTMLElement(currentNode) && ["html", "body"].indexOf(getNodeName(currentNode)) < 0) {
    var css = getComputedStyle(currentNode);
    if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || ["transform", "perspective"].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }
  return null;
}
function getOffsetParent(element) {
  var window2 = getWindow(element);
  var offsetParent = getTrueOffsetParent(element);
  while (offsetParent && isTableElement(offsetParent) && getComputedStyle(offsetParent).position === "static") {
    offsetParent = getTrueOffsetParent(offsetParent);
  }
  if (offsetParent && (getNodeName(offsetParent) === "html" || getNodeName(offsetParent) === "body" && getComputedStyle(offsetParent).position === "static")) {
    return window2;
  }
  return offsetParent || getContainingBlock(element) || window2;
}

var top = "top";
var bottom = "bottom";
var right = "right";
var left = "left";
var auto = "auto";
var basePlacements = [top, bottom, right, left];
var start = "start";
var end = "end";
var placements = [].concat(basePlacements, [auto]).reduce(function (acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []);
var beforeRead = "beforeRead";
var read = "read";
var afterRead = "afterRead";
var beforeMain = "beforeMain";
var main = "main";
var afterMain = "afterMain";
var beforeWrite = "beforeWrite";
var write = "write";
var afterWrite = "afterWrite";
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];

function order(modifiers) {
  var map = new _map2.default();
  var visited = new _set2.default();
  var result = [];
  modifiers.forEach(function (modifier) {
    map.set(modifier.name, modifier);
  });
  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function (dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);
        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }
  modifiers.forEach(function (modifier) {
    if (!visited.has(modifier.name)) {
      sort(modifier);
    }
  });
  return result;
}
function orderModifiers(modifiers) {
  var orderedModifiers = order(modifiers);
  return modifierPhases.reduce(function (acc, phase) {
    return acc.concat(orderedModifiers.filter(function (modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}

function debounce(fn2) {
  var pending;
  return function () {
    if (!pending) {
      pending = new _promise2.default(function (resolve) {
        _promise2.default.resolve().then(function () {
          pending = void 0;
          resolve(fn2());
        });
      });
    }
    return pending;
  };
}

function format(str) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  return [].concat(args).reduce(function (p, c) {
    return p.replace(/%s/, c);
  }, str);
}

var INVALID_MODIFIER_ERROR = 'Popper: modifier "%s" provided an invalid %s property, expected %s but got %s';
var MISSING_DEPENDENCY_ERROR = 'Popper: modifier "%s" requires "%s", but "%s" modifier is not available';
var VALID_PROPERTIES = ["name", "enabled", "phase", "fn", "effect", "requires", "options"];
function validateModifiers(modifiers) {
  modifiers.forEach(function (modifier) {
    [].concat((0, _keys2.default)(modifier), VALID_PROPERTIES).filter(function (value, index, self) {
      return self.indexOf(value) === index;
    }).forEach(function (key) {
      switch (key) {
        case "name":
          if (typeof modifier.name !== "string") {
            console.error(format(INVALID_MODIFIER_ERROR, String(modifier.name), '"name"', '"string"', '"' + String(modifier.name) + '"'));
          }
          break;
        case "enabled":
          if (typeof modifier.enabled !== "boolean") {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"enabled"', '"boolean"', '"' + String(modifier.enabled) + '"'));
          }
          break;
        case "phase":
          if (modifierPhases.indexOf(modifier.phase) < 0) {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"phase"', "either " + modifierPhases.join(", "), '"' + String(modifier.phase) + '"'));
          }
          break;
        case "fn":
          if (typeof modifier.fn !== "function") {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"fn"', '"function"', '"' + String(modifier.fn) + '"'));
          }
          break;
        case "effect":
          if (modifier.effect != null && typeof modifier.effect !== "function") {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"effect"', '"function"', '"' + String(modifier.fn) + '"'));
          }
          break;
        case "requires":
          if (modifier.requires != null && !Array.isArray(modifier.requires)) {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"requires"', '"array"', '"' + String(modifier.requires) + '"'));
          }
          break;
        case "requiresIfExists":
          if (!Array.isArray(modifier.requiresIfExists)) {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"requiresIfExists"', '"array"', '"' + String(modifier.requiresIfExists) + '"'));
          }
          break;
        case "options":
        case "data":
          break;
        default:
          console.error('PopperJS: an invalid property has been provided to the "' + modifier.name + '" modifier, valid properties are ' + VALID_PROPERTIES.map(function (s) {
            return '"' + s + '"';
          }).join(", ") + '; but "' + key + '" was provided.');
      }
      modifier.requires && modifier.requires.forEach(function (requirement) {
        if (modifiers.find(function (mod) {
          return mod.name === requirement;
        }) == null) {
          console.error(format(MISSING_DEPENDENCY_ERROR, String(modifier.name), requirement, requirement));
        }
      });
    });
  });
}

function uniqueBy(arr, fn2) {
  var identifiers = new _set2.default();
  return arr.filter(function (item) {
    var identifier = fn2(item);
    if (!identifiers.has(identifier)) {
      identifiers.add(identifier);
      return true;
    }
  });
}

function getBasePlacement(placement) {
  return placement.split("-")[0];
}

function mergeByName(modifiers) {
  var merged = modifiers.reduce(function (merged2, current) {
    var existing = merged2[current.name];
    merged2[current.name] = existing ? (0, _assign2.default)({}, existing, current, {
      options: (0, _assign2.default)({}, existing.options, current.options),
      data: (0, _assign2.default)({}, existing.data, current.data)
    }) : current;
    return merged2;
  }, {});
  return (0, _keys2.default)(merged).map(function (key) {
    return merged[key];
  });
}

function getVariation(placement) {
  return placement.split("-")[1];
}

function getMainAxisFromPlacement(placement) {
  return ["top", "bottom"].indexOf(placement) >= 0 ? "x" : "y";
}

function computeOffsets(_ref) {
  var reference = _ref.reference,
      element = _ref.element,
      placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference.x + reference.width / 2 - element.width / 2;
  var commonY = reference.y + reference.height / 2 - element.height / 2;
  var offsets;
  switch (basePlacement) {
    case top:
      offsets = {
        x: commonX,
        y: reference.y - element.height
      };
      break;
    case bottom:
      offsets = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;
    case right:
      offsets = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;
    case left:
      offsets = {
        x: reference.x - element.width,
        y: commonY
      };
      break;
    default:
      offsets = {
        x: reference.x,
        y: reference.y
      };
  }
  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;
  if (mainAxis != null) {
    var len = mainAxis === "y" ? "height" : "width";
    switch (variation) {
      case start:
        offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
        break;
      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
        break;
      default:
    }
  }
  return offsets;
}

var INVALID_ELEMENT_ERROR = "Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.";
var INFINITE_LOOP_ERROR = "Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.";
var DEFAULT_OPTIONS = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return !args.some(function (element) {
    return !(element && typeof element.getBoundingClientRect === "function");
  });
}
function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }
  var _generatorOptions = generatorOptions,
      _generatorOptions$def = _generatorOptions.defaultModifiers,
      defaultModifiers2 = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
      _generatorOptions$def2 = _generatorOptions.defaultOptions,
      defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper2(reference, popper, options) {
    if (options === void 0) {
      options = defaultOptions;
    }
    var state = {
      placement: "bottom",
      orderedModifiers: [],
      options: (0, _assign2.default)({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference,
        popper: popper
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state: state,
      setOptions: function setOptions(setOptionsAction) {
        var options2 = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = (0, _assign2.default)({}, defaultOptions, state.options, options2);
        state.scrollParents = {
          reference: isElement(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
          popper: listScrollParents(popper)
        };
        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers2, state.options.modifiers)));
        state.orderedModifiers = orderedModifiers.filter(function (m) {
          return m.enabled;
        });
        if (true) {
          var modifiers = uniqueBy([].concat(orderedModifiers, state.options.modifiers), function (_ref) {
            var name = _ref.name;
            return name;
          });
          validateModifiers(modifiers);
          if (getBasePlacement(state.options.placement) === auto) {
            var flipModifier = state.orderedModifiers.find(function (_ref2) {
              var name = _ref2.name;
              return name === "flip";
            });
            if (!flipModifier) {
              console.error(['Popper: "auto" placements require the "flip" modifier be', "present and enabled to work."].join(" "));
            }
          }
          var _getComputedStyle = getComputedStyle(popper),
              marginTop = _getComputedStyle.marginTop,
              marginRight = _getComputedStyle.marginRight,
              marginBottom = _getComputedStyle.marginBottom,
              marginLeft = _getComputedStyle.marginLeft;
          if ([marginTop, marginRight, marginBottom, marginLeft].some(function (margin) {
            return parseFloat(margin);
          })) {
            console.warn(['Popper: CSS "margin" styles cannot be used to apply padding', "between the popper and its reference element or boundary.", "To replicate margin, use the `offset` modifier, as well as", "the `padding` option in the `preventOverflow` and `flip`", "modifiers."].join(" "));
          }
        }
        runModifierEffects();
        return instance.update();
      },
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }
        var _state$elements = state.elements,
            reference2 = _state$elements.reference,
            popper2 = _state$elements.popper;
        if (!areValidElements(reference2, popper2)) {
          if (true) {
            console.error(INVALID_ELEMENT_ERROR);
          }
          return;
        }
        state.rects = {
          reference: getCompositeRect(reference2, getOffsetParent(popper2), state.options.strategy === "fixed"),
          popper: getLayoutRect(popper2)
        };
        state.reset = false;
        state.placement = state.options.placement;
        state.orderedModifiers.forEach(function (modifier) {
          return state.modifiersData[modifier.name] = (0, _assign2.default)({}, modifier.data);
        });
        var __debug_loops__ = 0;
        for (var index = 0; index < state.orderedModifiers.length; index++) {
          if (true) {
            __debug_loops__ += 1;
            if (__debug_loops__ > 100) {
              console.error(INFINITE_LOOP_ERROR);
              break;
            }
          }
          if (state.reset === true) {
            state.reset = false;
            index = -1;
            continue;
          }
          var _state$orderedModifie = state.orderedModifiers[index],
              fn2 = _state$orderedModifie.fn,
              _state$orderedModifie2 = _state$orderedModifie.options,
              _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
              name = _state$orderedModifie.name;
          if (typeof fn2 === "function") {
            state = fn2({
              state: state,
              options: _options,
              name: name,
              instance: instance
            }) || state;
          }
        }
      },
      update: debounce(function () {
        return new _promise2.default(function (resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };
    if (!areValidElements(reference, popper)) {
      if (true) {
        console.error(INVALID_ELEMENT_ERROR);
      }
      return instance;
    }
    instance.setOptions(options).then(function (state2) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state2);
      }
    });
    function runModifierEffects() {
      state.orderedModifiers.forEach(function (_ref3) {
        var name = _ref3.name,
            _ref3$options = _ref3.options,
            options2 = _ref3$options === void 0 ? {} : _ref3$options,
            effect3 = _ref3.effect;
        if (typeof effect3 === "function") {
          var cleanupFn = effect3({
            state: state,
            name: name,
            instance: instance,
            options: options2
          });
          var noopFn = function noopFn2() {};
          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }
    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function (fn2) {
        return fn2();
      });
      effectCleanupFns = [];
    }
    return instance;
  };
}

var passive = {
  passive: true
};
function effect(_ref) {
  var state = _ref.state,
      instance = _ref.instance,
      options = _ref.options;
  var _options$scroll = options.scroll,
      scroll = _options$scroll === void 0 ? true : _options$scroll,
      _options$resize = options.resize,
      resize = _options$resize === void 0 ? true : _options$resize;
  var window2 = getWindow(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
  if (scroll) {
    scrollParents.forEach(function (scrollParent) {
      scrollParent.addEventListener("scroll", instance.update, passive);
    });
  }
  if (resize) {
    window2.addEventListener("resize", instance.update, passive);
  }
  return function () {
    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener("scroll", instance.update, passive);
      });
    }
    if (resize) {
      window2.removeEventListener("resize", instance.update, passive);
    }
  };
}
var eventListeners_default = {
  name: "eventListeners",
  enabled: true,
  phase: "write",
  fn: function fn() {},
  effect: effect,
  data: {}
};

function popperOffsets(_ref) {
  var state = _ref.state,
      name = _ref.name;
  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: "absolute",
    placement: state.placement
  });
}
var popperOffsets_default = {
  name: "popperOffsets",
  enabled: true,
  phase: "read",
  fn: popperOffsets,
  data: {}
};

var unsetSides = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function roundOffsetsByDPR(_ref) {
  var x = _ref.x,
      y = _ref.y;
  var win = window;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round(x * dpr) / dpr || 0,
    y: round(y * dpr) / dpr || 0
  };
}
function mapToStyles(_ref2) {
  var _Object$assign2;
  var popper = _ref2.popper,
      popperRect = _ref2.popperRect,
      placement = _ref2.placement,
      variation = _ref2.variation,
      offsets = _ref2.offsets,
      position = _ref2.position,
      gpuAcceleration = _ref2.gpuAcceleration,
      adaptive = _ref2.adaptive,
      roundOffsets = _ref2.roundOffsets,
      isFixed = _ref2.isFixed;
  var _offsets$x = offsets.x,
      x = _offsets$x === void 0 ? 0 : _offsets$x,
      _offsets$y = offsets.y,
      y = _offsets$y === void 0 ? 0 : _offsets$y;
  var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };
  x = _ref3.x;
  y = _ref3.y;
  var hasX = offsets.hasOwnProperty("x");
  var hasY = offsets.hasOwnProperty("y");
  var sideX = left;
  var sideY = top;
  var win = window;
  if (adaptive) {
    var offsetParent = getOffsetParent(popper);
    var heightProp = "clientHeight";
    var widthProp = "clientWidth";
    if (offsetParent === getWindow(popper)) {
      offsetParent = getDocumentElement(popper);
      if (getComputedStyle(offsetParent).position !== "static" && position === "absolute") {
        heightProp = "scrollHeight";
        widthProp = "scrollWidth";
      }
    }
    offsetParent = offsetParent;
    if (placement === top || (placement === left || placement === right) && variation === end) {
      sideY = bottom;
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
      y -= offsetY - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }
    if (placement === left || (placement === top || placement === bottom) && variation === end) {
      sideX = right;
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
      x -= offsetX - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }
  var commonStyles = (0, _assign2.default)({
    position: position
  }, adaptive && unsetSides);
  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };
  x = _ref4.x;
  y = _ref4.y;
  if (gpuAcceleration) {
    var _Object$assign;
    return (0, _assign2.default)({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }
  return (0, _assign2.default)({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function computeStyles(_ref5) {
  var state = _ref5.state,
      options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration,
      gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
      _options$adaptive = options.adaptive,
      adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
      _options$roundOffsets = options.roundOffsets,
      roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
  if (true) {
    var transitionProperty = getComputedStyle(state.elements.popper).transitionProperty || "";
    if (adaptive && ["transform", "top", "right", "bottom", "left"].some(function (property) {
      return transitionProperty.indexOf(property) >= 0;
    })) {
      console.warn(["Popper: Detected CSS transitions on at least one of the following", 'CSS properties: "transform", "top", "right", "bottom", "left".', "\n\n", 'Disable the "computeStyles" modifier\'s `adaptive` option to allow', "for smooth transitions, or remove these properties from the CSS", "transition declaration on the popper element if only transitioning", "opacity or background-color for example.", "\n\n", "We recommend using the popper element as a wrapper around an inner", "element that can have any CSS property transitioned for animations."].join(" "));
    }
  }
  var commonStyles = {
    placement: getBasePlacement(state.placement),
    variation: getVariation(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration: gpuAcceleration,
    isFixed: state.options.strategy === "fixed"
  };
  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = (0, _assign2.default)({}, state.styles.popper, mapToStyles((0, _assign2.default)({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive: adaptive,
      roundOffsets: roundOffsets
    })));
  }
  if (state.modifiersData.arrow != null) {
    state.styles.arrow = (0, _assign2.default)({}, state.styles.arrow, mapToStyles((0, _assign2.default)({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: "absolute",
      adaptive: false,
      roundOffsets: roundOffsets
    })));
  }
  state.attributes.popper = (0, _assign2.default)({}, state.attributes.popper, {
    "data-popper-placement": state.placement
  });
}
var computeStyles_default = {
  name: "computeStyles",
  enabled: true,
  phase: "beforeWrite",
  fn: computeStyles,
  data: {}
};

function applyStyles(_ref) {
  var state = _ref.state;
  (0, _keys2.default)(state.elements).forEach(function (name) {
    var style = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name];
    if (!isHTMLElement(element) || !getNodeName(element)) {
      return;
    }
    (0, _assign2.default)(element.style, style);
    (0, _keys2.default)(attributes).forEach(function (name2) {
      var value = attributes[name2];
      if (value === false) {
        element.removeAttribute(name2);
      } else {
        element.setAttribute(name2, value === true ? "" : value);
      }
    });
  });
}
function effect2(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  (0, _assign2.default)(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;
  if (state.elements.arrow) {
    (0, _assign2.default)(state.elements.arrow.style, initialStyles.arrow);
  }
  return function () {
    (0, _keys2.default)(state.elements).forEach(function (name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = (0, _keys2.default)(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]);
      var style = styleProperties.reduce(function (style2, property) {
        style2[property] = "";
        return style2;
      }, {});
      if (!isHTMLElement(element) || !getNodeName(element)) {
        return;
      }
      (0, _assign2.default)(element.style, style);
      (0, _keys2.default)(attributes).forEach(function (attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
}
var applyStyles_default = {
  name: "applyStyles",
  enabled: true,
  phase: "write",
  fn: applyStyles,
  effect: effect2,
  requires: ["computeStyles"]
};

var defaultModifiers = [eventListeners_default, popperOffsets_default, computeStyles_default, applyStyles_default];
var createPopper = popperGenerator({
  defaultModifiers: defaultModifiers
});

function distanceAndSkiddingToXY(placement, rects, offset2) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left, top].indexOf(basePlacement) >= 0 ? -1 : 1;
  var _ref = typeof offset2 === "function" ? offset2((0, _assign2.default)({}, rects, {
    placement: placement
  })) : offset2,
      skidding = _ref[0],
      distance = _ref[1];
  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}
function offset(_ref2) {
  var state = _ref2.state,
      options = _ref2.options,
      name = _ref2.name;
  var _options$offset = options.offset,
      offset2 = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = placements.reduce(function (acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset2);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement],
      x = _data$state$placement.x,
      y = _data$state$placement.y;
  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }
  state.modifiersData[name] = data;
}
var offset_default = {
  name: "offset",
  enabled: true,
  phase: "main",
  requires: ["popperOffsets"],
  fn: offset
};
exports.createPopper = createPopper;
exports.offsetModifier = offset_default;

/***/ }),

/***/ 812:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	name: 'app',
	data: function data() {
		return {
			isLogin: false
		};
	},
	mounted: function mounted() {
		var user = sessionStorage.getItem('user');
	},

	methods: {}
};

/***/ }),

/***/ 813:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _OrganizationalStructure = __webpack_require__(1633);

var _OrganizationalStructure2 = _interopRequireDefault(_OrganizationalStructure);

var _Urls = __webpack_require__(12);

var Urls = _interopRequireWildcard(_Urls);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        OrganizationalStructure: _OrganizationalStructure2.default
    },
    props: {
        showorg: {
            type: Boolean,
            default: true
        },
        titleName: {
            type: String,
            default: ''
        },
        optionsVal: {
            Type: Boolean,
            default: false
        }
    },
    data: function data() {
        return {
            dataRange: [],
            activeDay: '',
            valueDate: 'month',
            options: [{
                value: 'month',
                label: '本月'
            }, {
                value: 'prev',
                label: '本周'
            }, {
                value: 'all',
                label: '本年'
            }],
            list: [] };
    },

    methods: {
        changeVal: function changeVal(val) {
            this.$emit('changeVal', val);
        },
        getSysOrg: function getSysOrg() {
            var _this = this;
            var url = Urls.get_report_orgList;
            var params = '';
            this.$root.doPost(url, params, function (server_data) {
                var data = server_data.data;
                data.forEach(function (item) {
                    item.label = item.orgName;
                    item.children.forEach(function (item2) {
                        item2.label = item2.orgName;
                        if (item2.children) {
                            item2.children.forEach(function (item3) {
                                item3.label = item3.orgName;
                            });
                        }
                    });
                });
                _this.list = data;
            });
        },
        getDatas: function getDatas(day) {
            var start = new Date();
            var end = new Date();
            switch (day) {
                case 'all':
                    var num = start.getFullYear();
                    this.dataRange = [this.$root.formatDay(new Date(num + '/1/1').toLocaleDateString()), this.$root.formatDay(start.toLocaleDateString())];
                    this.activeDay = day;
                    this.$emit('changDate', this.dataRange);
                    break;
                case 'month':
                    start.setDate(1);
                    start.setHours(0);
                    start.setSeconds(0);
                    start.setMinutes(0);
                    start.setTime(start.getTime());
                    this.dataRange = [this.$root.formatDay(start), this.$root.formatDay(end)];
                    this.activeDay = day;
                    this.$emit('changDate', this.dataRange);
                    break;
                case 'prev':
                    var nowTime = start.getDay() ? start.getDay() - 1 : 6;
                    var twoTime = start.getTime() - nowTime * 1000 * 60 * 60 * 24;
                    this.dataRange = [this.$root.formatDay(new Date(twoTime).toLocaleDateString()), this.$root.formatDay(start.toLocaleDateString())];
                    this.activeDay = day;
                    this.$emit('changDate', this.dataRange);
                    break;
                case '':
                    this.dataRange = [];
                    this.activeDay = day;
                    this.$emit('changDate', this.dataRange);
                    break;
            }
        },
        changeDate: function changeDate(val) {
            this.$emit('changePicker', val);
        }
    },
    mounted: function mounted() {
        if (this.$route.query.identification) {
            var start = new Date();
            var end = new Date();
            start.setDate(1);
            start.setHours(0);
            start.setSeconds(0);
            start.setMinutes(0);
            start.setTime(start.getTime());
            this.dataRange = [this.$root.formatDay(start), this.$root.formatDay(end)];
            if (this.optionsVal) {
                this.options.unshift({
                    value: '',
                    label: '全部'
                });
                this.valueDate = '';
                this.getDatas('');
            }
        } else {
            this.getSysOrg();
            if (this.optionsVal) {
                this.options.unshift({
                    value: '',
                    label: '全部'
                });
                this.valueDate = '';
                this.getDatas('');
            } else {
                this.getDatas('month');
            }
        }
    }
};

/***/ }),

/***/ 814:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(92);

var _stringify2 = _interopRequireDefault(_stringify);

var _Urls = __webpack_require__(12);

var Urls = _interopRequireWildcard(_Urls);

var _VueHelper = __webpack_require__(17);

var VueHelper = _interopRequireWildcard(_VueHelper);

var _axios = __webpack_require__(94);

var _axios2 = _interopRequireDefault(_axios);

var _allMenu = __webpack_require__(171);

var _allMenu2 = _interopRequireDefault(_allMenu);

var _menu = __webpack_require__(172);

var _menu2 = _interopRequireDefault(_menu);

var _MenuUtils = __webpack_require__(91);

var _MenuUtils2 = _interopRequireDefault(_MenuUtils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            isShow: false,
            isLoading: false,
            loginForm: {
                account: '',
                password: ''
            },
            errorMsg: ''
        };
    },
    mounted: function mounted() {},

    methods: {
        show: function show() {
            this.isShow = true;
        },
        hide: function hide() {
            this.isShow = false;
        },
        doLogin: function doLogin() {

            var inst = this;
            inst.isLoading = true;

            var url = Urls.user_login;
            var params = VueHelper.makeSearchParams({
                account: this.loginForm.account,
                password: this.loginForm.password,
                from_global_modal: 'N'
            });

            _axios2.default.post(url, params).then(function (response) {
                inst.isLoading = false;

                var server_data = response.data;
                if (server_data.error) {
                    inst.errorMsg = server_data.error;
                    return;
                }
                inst.errorMsg = '';
                sessionStorage.setItem('user', (0, _stringify2.default)(server_data.data));

                var role = server_data.data.roleValue;
                console.log("role:" + role);

                var menu = _menu2.default;

                var roleMeun = server_data.data.roleMeun;
                var menuData = [];

                roleMeun.forEach(function (element, index) {
                    if (!element.children.length && element.workBenchList.length) {
                        menuData.push({
                            path: '/p' + index,
                            component: "HomeView",
                            redirect: element.workBenchList[0].benchPath,
                            name: element.menuName,
                            parent: true,
                            children: [{
                                pageAddress: element.workBenchList[0].benchComponent,
                                path: element.workBenchList[0].benchPath,
                                name: element.menuName
                            }]
                        });
                    } else if (!element.children[0].children.length) {
                        var data = {
                            path: '/p' + index,
                            redirect: '',
                            component: "HomeView",
                            name: element.menuName,
                            icon: element.menuIcon,
                            parent: true,
                            children: []
                        };
                        element.children.forEach(function (element2, index2) {
                            if (!element2.workBenchList.length) return;
                            data.children.push({
                                pageAddress: element2.workBenchList[0].benchComponent,
                                path: element2.workBenchList[0].benchPath,
                                name: element2.menuName,
                                icon: element2.menuIcon
                            });
                            if (index2 === 0) {
                                data.redirect = element2.workBenchList[0].benchPath;
                            }
                        });

                        menuData.push(data);
                    } else {
                        var _data = {
                            path: '/p' + index,
                            redirect: '',
                            component: "HomeView",
                            name: element.menuName,
                            icon: element.menuIcon,
                            parent: true,
                            children: []
                        };
                        element.children.forEach(function (element2, index2) {
                            var data2 = {
                                parent: true,
                                component: "Navigation",
                                path: "/home",
                                name: element2.menuName,
                                icon: element2.menuIcon,
                                children: []
                            };
                            element2.children.forEach(function (element3, index3) {
                                if (!element3.workBenchList.length) return;
                                data2.children.push({
                                    pageAddress: element3.workBenchList[0].benchComponent,
                                    path: element3.workBenchList[0].benchPath,
                                    name: element3.menuName,
                                    icon: element3.menuIcon
                                });
                                if (index2 === 0 && index3 === 0) {
                                    _data.redirect = element3.workBenchList[0].benchPath;
                                }

                                for (var i = 0; i < menu.length; i++) {
                                    var obj = menu[i];
                                    if (obj.menuId == element.menuId) {
                                        for (var j = 0; j < obj.children.length; j++) {
                                            var obj2 = obj.children[j];
                                            if (obj2.menuId == element2.menuId) {
                                                data2.children = data2.children.concat(obj2.children);
                                                break;
                                            }
                                        }
                                    }
                                }
                            });
                            _data.children.push(data2);
                        });
                        menuData.push(_data);
                    }
                });

                if (menuData.length) {
                    menuData[0].path = '/';
                }

                menu.forEach(function (element, index) {
                    if (element.hidden && !element.redirect) {
                        menuData = menuData.concat(element);
                    }
                });

                window.sessionStorage.setItem('userPre', (0, _stringify2.default)(menuData));
                var routes = [];
                (0, _MenuUtils2.default)(routes, menuData);
                console.log('routes', routes);

                sessionStorage.token = server_data.data.token;

                inst.$router.addRoutes(routes);

                inst.hide();

                inst.$router.push('/');

                window.location.reload();
            }).catch(function (error) {
                console.log(error);
                inst.$message({
                    message: '似乎网络不可用',
                    type: 'error'
                });
            });
        }
    }
};

/***/ }),

/***/ 815:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(262);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(205);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            showTree: false,
            input: ''
        };
    },

    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['getShowTree'])),
    props: ['treelist', 'wide'],
    watch: {
        input: function input() {
            if (this.input == '') {
                this.$emit('changeVal', '');
            }
        }
    },
    methods: (0, _extends3.default)({}, (0, _vuex.mapMutations)(['setShowTree']), {
        handleNodeClick: function handleNodeClick(data) {
            this.input = data.label;
            this.setShowTree(false);
            this.$emit('changeVal', data.orgCode);
        },
        hideThree: function hideThree() {
            var _this = this;

            setTimeout(function () {
                _this.setShowTree(false);
            }, 200);
        }
    }),
    mounted: function mounted() {}
};

/***/ }),

/***/ 816:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _CustomerOwnerDataEcharts = __webpack_require__(1634);

var _CustomerOwnerDataEcharts2 = _interopRequireDefault(_CustomerOwnerDataEcharts);

var _HeadControl = __webpack_require__(43);

var _HeadControl2 = _interopRequireDefault(_HeadControl);

var _Urls = __webpack_require__(12);

var Urls = _interopRequireWildcard(_Urls);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        CustomerOwnerDataEcharts: _CustomerOwnerDataEcharts2.default,
        HeadControl: _HeadControl2.default
    },
    data: function data() {
        return {
            orgCode: '',
            dataRange: [],
            headData: [],
            CustomerDataList: [],
            natureData: [],
            IndustryData: [] };
    },
    mounted: function mounted() {},

    methods: {
        init: function init() {
            this.$refs.HeadControl.getDatas('');
            this.$refs.HeadControl.getSysOrg();
        },
        changeVal: function changeVal(val) {
            this.orgCode = val;
            this.getHeadData();
            this.getCustomerData();
            this.getNature();
            this.getIndustry();
        },
        changDate: function changDate(val) {
            this.dataRange = val;
            this.getHeadData();
            this.getCustomerData();
            this.getNature();
            this.getIndustry();
        },
        getHeadData: function getHeadData() {
            var _this = this;
            var url = Urls.getEchartsReportItemDataByCustomer;
            var params = {
                orgCode: this.orgCode || '',
                startTime: this.dataRange.length ? this.dataRange[0] : '',
                endTime: this.dataRange.length ? this.dataRange[1] : '',
                itemCode: 'CUSTOMER_DISTRICT'
            };
            this.$root.doPost(url, params, function (server_data) {
                if (!_this.$root.isUserLogin(server_data)) {
                    return;
                }

                if (server_data.error) {
                    _this.$root.showGlobalError(server_data.error);
                    return;
                }
                _this.headData = server_data.data.reportList;
            });
        },
        getCustomerData: function getCustomerData() {
            var _this = this;
            var url = Urls.getEchartsCustomerCountReportItemData;
            var params = {
                orgCode: this.orgCode || '',
                startTime: this.dataRange.length ? this.dataRange[0] : '',
                endTime: this.dataRange.length ? this.dataRange[1] : '',
                itemCode: 'CUSTOMER_ACC_DATA'
            };
            this.$root.doPost(url, params, function (server_data) {
                if (!_this.$root.isUserLogin(server_data)) {
                    return;
                }

                if (server_data.error) {
                    _this.$root.showGlobalError(server_data.error);
                    return;
                }
                _this.CustomerDataList = server_data.data;
            });
        },
        getNature: function getNature() {
            var _this = this;
            var url = Urls.getEchartsCustomerNatureReportItemData;
            var params = {
                orgCode: this.orgCode || '',
                startTime: this.dataRange.length ? this.dataRange[0] : '',
                endTime: this.dataRange.length ? this.dataRange[1] : '',
                itemCode: 'CUSTOMER_NATURE'
            };
            this.$root.doPost(url, params, function (server_data) {
                if (!_this.$root.isUserLogin(server_data)) {
                    return;
                }

                if (server_data.error) {
                    _this.$root.showGlobalError(server_data.error);
                    return;
                }
                _this.natureData = server_data.data;
            });
        },
        getIndustry: function getIndustry() {
            var _this = this;
            var url = Urls.getEchartsCustomerIndustryReportItemData;
            var params = {
                orgCode: this.orgCode || '',
                startTime: this.dataRange.length ? this.dataRange[0] : '',
                endTime: this.dataRange.length ? this.dataRange[1] : '',
                itemCode: 'CUSTOMER_INDUSTRY'
            };
            this.$root.doPost(url, params, function (server_data) {
                if (!_this.$root.isUserLogin(server_data)) {
                    return;
                }

                if (server_data.error) {
                    _this.$root.showGlobalError(server_data.error);
                    return;
                }
                _this.IndustryData = server_data.data;
            });
        },
        changePicker: function changePicker(val) {
            this.dataRange = val;
            this.getHeadData();
            this.getCustomerData();
            this.getNature();
            this.getIndustry();
        },
        getOrgCode: function getOrgCode() {
            this.$refs.HeadControl.getSysOrg();
        }
    }
};

/***/ }),

/***/ 817:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(93);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _toConsumableArray2 = __webpack_require__(31);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _Urls = __webpack_require__(12);

var Urls = _interopRequireWildcard(_Urls);

var _HeadControl = __webpack_require__(43);

var _HeadControl2 = _interopRequireDefault(_HeadControl);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    HeadControl: _HeadControl2.default
  },
  data: function data() {
    return {
      screenWidth: document.body.clientWidth,
      orgCode: '',
      dataRange: [],
      StorageRecordDataList: '',
      natureDataList: '',
      PieChartData: [],
      seriesArr: [],
      colors: [['#5bbbff', '#CACACA'], ['#FFB96E', '#CACACA']],
      recordPercent: '',
      recordEntries: '',
      statePercent: '',
      stateEntries: ''
    };
  },
  created: function created() {},
  mounted: function mounted() {
    var _this = this;
    window.onresize = function () {
      return function () {
        window.screenWidth = document.body.clientWidth + 17;
        _this.screenWidth = window.screenWidth;
      }();
    };
  },

  methods: {
    init: function init() {
      this.$refs.HeadControl.getDatas('');
      this.$refs.HeadControl.getSysOrg();
    },
    changeVal: function changeVal(val) {
      this.orgCode = val;
      this.getStorageRecordData();
      this.getNature();
      this.getCharge();
    },
    changDate: function changDate(val) {
      this.dataRange = val;
      this.getStorageRecordData();
      this.getNature();
      this.getCharge();
    },
    changePicker: function changePicker(val) {
      this.dataRange = val;
      this.getStorageRecordData();
      this.getNature();
      this.getCharge();
    },
    getOrgCode: function getOrgCode() {
      this.$refs.HeadControl.getSysOrg();
    },
    initChart1: function initChart1() {
      var _this2 = this;

      var Chart1 = this.$echarts.getInstanceByDom(this.$refs.BigThreemyCharts);
      if (Chart1 == null) {
        this.myChart1 = this.$echarts.init(this.$refs.BigThreemyCharts);
      }
      var option = {
        textStyle: {
          fontFamily: 'PingFang-M'
        },
        title: {
          text: '入库备案',
          top: '24',
          left: this.$route.query.identification ? '20' : '30',
          textStyle: {
            fontWeight: 500
          }
        },
        grid: {
          left: this.$route.query.identification ? '30' : '46px',
          right: this.$route.query.identification ? '15%' : '3%',
          bottom: '20px',
          top: '100px',
          containLabel: true
        },
        opacity: 0.1,
        tooltip: {
          trigger: 'axis',
          formatter: function formatter(params) {
            var h = '<div>';
            params.reverse().forEach(function (item) {
              if (item.seriesIndex == 1) {
                h += '<div>' + item.axisValue + '\uFF1A' + item.data + '\u4E2A</div>';
              } else {
                h += '<div>\u5360\u6BD4\uFF1A' + item.data + '%</div></div>';
              }
            });
            return h;
          }
        },
        legend: {
          data: this.StorageRecordDataList.legend,
          itemWidth: 40,
          itemHeight: 8,
          itemGap: 20,
          left: this.$route.query.identification ? '110' : '180',
          top: '24'
        },
        xAxis: [(0, _defineProperty3.default)({
          type: 'category',
          offset: 5,
          data: this.StorageRecordDataList.xAxis.data,
          axisPointer: {
            type: 'shadow'
          },

          splitLine: {
            show: Math.max.apply(Math, (0, _toConsumableArray3.default)(this.StorageRecordDataList.series[0].data).concat((0, _toConsumableArray3.default)(this.StorageRecordDataList.series[1].data))) == 0 ? false : true,
            lineStyle: {
              color: '#DDDDDD'
            }
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#DDDDDD'
            }
          },
          axisLabel: {
            color: '#666666'
          }
        }, 'axisPointer', {
          type: 'none'
        })],
        yAxis: [{
          offset: 5,
          type: 'value',
          name: '百分比',
          show: Math.max.apply(Math, (0, _toConsumableArray3.default)(this.StorageRecordDataList.series[0].data)) == 0 ? false : true,
          min: 0,
          max: this.recordPercent,
          splitNumber: 5,
          interval: this.recordPercent / 5,
          axisLabel: {
            formatter: '{value}%',
            textStyle: {
              color: '#666666'
            }
          },

          splitLine: {
            show: true,
            lineStyle: {
              color: '#DDDDDD'
            }
          },

          nameTextStyle: {
            align: 'left',
            padding: this.$route.query.identification ? [0, 35, 0, 0] : [0, 40, 0, 0],
            color: '#666666'
          },
          axisTick: false,
          axisLine: {
            show: false }
        }, {
          type: 'value',
          name: '数量（个）',
          show: Math.max.apply(Math, (0, _toConsumableArray3.default)(this.StorageRecordDataList.series[1].data)) == 0 ? false : true,
          min: 0,
          max: this.recordEntries,

          splitNumber: 5,
          interval: this.recordEntries / 5,
          axisLabel: {
            formatter: function formatter(params) {
              return parseInt(params);
            },
            textStyle: {
              color: '#666666'
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#DDDDDD'
            }
          },

          nameTextStyle: {
            padding: this.$route.query.identification ? [0, 0, 0, 20] : [0, 0, 0, 38],
            color: '#666666'
          },
          axisTick: false,
          axisLine: {
            show: false }
        }],
        series: [{
          name: this.StorageRecordDataList.series[0].name,
          type: 'bar',
          barWidth: this.$route.query.identification ? 50 : 80,
          yAxisIndex: 0,
          data: this.StorageRecordDataList.series[0].data,
          itemStyle: {
            normal: {
              color: 'rgba(87,185,255,0.35)',

              borderColor: Math.max.apply(Math, (0, _toConsumableArray3.default)(this.StorageRecordDataList.series[0].data)) == 0 ? 'rgba(87,185,255,0)' : 'rgba(87,185,255,1)'
            }
          }
        }, {
          name: this.StorageRecordDataList.series[1].name,
          type: 'line',
          symbol: 'rect',
          symbolSize: 9,
          hoverAnimation: false,
          yAxisIndex: 1,
          data: this.StorageRecordDataList.series[1].data,
          itemStyle: {
            normal: {
              color: '#72d8c0',
              opacity: Math.max.apply(Math, (0, _toConsumableArray3.default)(this.StorageRecordDataList.series[1].data)) == 0 ? 0 : 1
            },
            emphasis: {
              borderWidth: 3,
              borderColor: '#61d9ac',
              color: '#61d9ac'
            }
          },
          lineStyle: {
            normal: {
              opacity: Math.max.apply(Math, (0, _toConsumableArray3.default)(this.StorageRecordDataList.series[1].data)) == 0 ? 0 : 1
            }
          }
        }]
      };
      this.myChart1.setOption(option);
      window.addEventListener("resize", function () {
        if (_this2.$route.query.identification) {
          var resize = {
            width: _this2.screenWidth - 21
          };
          _this2.myChart1.resize(resize);
        } else {
          _this2.myChart1.resize();
        }
      });
    },
    getStorageRecordData: function getStorageRecordData() {
      var _this = this;
      var url = Urls.getEchartsRegisterReportItemData;
      var params = {
        orgCode: this.orgCode,
        startTime: this.dataRange.length ? this.dataRange[0] : '',
        endTime: this.dataRange.length ? this.dataRange[1] : '',
        itemCode: 'ENGINEERING_TYPE'
      };
      this.$root.doPost(url, params, function (server_data) {
        if (!_this.$root.isUserLogin(server_data)) {
          return;
        }

        if (server_data.error) {
          _this.$root.showGlobalError(server_data.error);
          return;
        }

        _this.StorageRecordDataList = server_data.data;
      });
    },
    initChart2: function initChart2() {
      var _this3 = this;

      var Chart2 = this.$echarts.getInstanceByDom(this.$refs.Twohistogram);
      if (Chart2 == null) {
        this.myChart2 = this.$echarts.init(this.$refs.Twohistogram);
      }
      var option = {
        textStyle: {
          fontFamily: 'PingFang-M'
        },
        title: {
          text: '按状态',
          top: '24',
          left: this.$route.query.identification ? '20' : '30',
          textStyle: {
            fontWeight: 500
          }
        },
        grid: {
          left: this.$route.query.identification ? '36' : '46',
          right: this.$route.query.identification ? '15%' : '3%',
          bottom: '5%',
          top: '28%',
          containLabel: true
        },
        opacity: 0.1,
        tooltip: {
          trigger: 'axis',
          formatter: function formatter(params) {
            var h = '<div>';
            params.reverse().forEach(function (item) {
              if (item.seriesIndex == 1) {
                h += '<div>' + item.axisValue + '\uFF1A' + item.data + '\u4E2A</div>';
              } else {
                h += '<div>\u5360\u6BD4\uFF1A' + item.data + '%</div></div>';
              }
            });
            return h;
          }
        },
        legend: {
          data: this.natureDataList.legend,
          itemWidth: 40,
          itemHeight: 8,
          itemGap: 20,
          left: this.$route.query.identification ? '110' : '180',
          top: '24'
        },
        xAxis: [(0, _defineProperty3.default)({
          type: 'category',
          offset: 5,
          data: this.natureDataList.xAxis.data,
          axisPointer: {
            type: 'shadow'
          },

          splitLine: {
            show: Math.max.apply(Math, (0, _toConsumableArray3.default)(this.natureDataList.series[0].data).concat((0, _toConsumableArray3.default)(this.natureDataList.series[1].data))) == 0 ? false : true,
            lineStyle: {
              color: '#DDDDDD'
            }
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#DDDDDD'
            }
          },
          axisLabel: {
            color: '#666666'
          }
        }, 'axisPointer', {
          type: 'none'
        })],
        yAxis: [{
          offset: 5,
          type: 'value',
          name: '百分比',
          show: Math.max.apply(Math, (0, _toConsumableArray3.default)(this.natureDataList.series[0].data)) == 0 ? false : true,
          min: 0,
          max: this.statePercent,
          splitNumber: 5,
          interval: this.statePercent / 5,
          axisLabel: {
            formatter: '{value}%',
            textStyle: {
              color: '#666666'
            }
          },

          splitLine: {
            show: true,
            color: '#DDDDDD'
          },

          nameTextStyle: {
            padding: this.$route.query.identification ? [0, 35, 0, 0] : [0, 40, 0, 0],
            color: '#666666'
          },
          axisTick: false,
          axisLine: {
            show: false }
        }, {
          type: 'value',
          name: '数量（个）',
          show: Math.max.apply(Math, (0, _toConsumableArray3.default)(this.natureDataList.series[1].data)) == 0 ? false : true,
          min: 0,
          max: this.stateEntries,

          splitNumber: 5,
          interval: this.stateEntries / 5,
          axisLabel: {
            formatter: function formatter(params) {
              return parseInt(params);
            },
            textStyle: {
              color: '#666666'
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#DDDDDD'
            }
          },

          nameTextStyle: {
            padding: [0, 20, 0, 38],
            color: '#666666'
          },
          axisTick: false,
          axisLine: {
            show: false }
        }],
        series: [{
          name: this.natureDataList.series[0].name,
          type: 'bar',
          barWidth: this.$route.query.identification ? 50 : 80,
          data: this.natureDataList.series[0].data,
          itemStyle: {
            normal: {
              color: 'rgba(87,185,255,0.35)',
              borderColor: Math.max.apply(Math, (0, _toConsumableArray3.default)(this.natureDataList.series[0].data)) == 0 ? 'rgba(87,185,255,0)' : 'rgba(87,185,255,1)'
            }
          }
        }, {
          name: this.natureDataList.series[1].name,
          type: 'line',
          symbol: 'rect',
          symbolSize: 9,
          hoverAnimation: false,
          yAxisIndex: "1",
          data: this.natureDataList.series[1].data,
          itemStyle: {
            normal: {
              color: '#72d8c0',
              opacity: Math.max.apply(Math, (0, _toConsumableArray3.default)(this.natureDataList.series[1].data)) == 0 ? 0 : 1
            },
            emphasis: {
              borderWidth: 3,
              borderColor: '#61d9ac',
              color: '#61d9ac'
            }
          },
          lineStyle: {
            normal: {
              opacity: Math.max.apply(Math, (0, _toConsumableArray3.default)(this.natureDataList.series[1].data)) == 0 ? 0 : 1
            }
          }
        }]
      };
      this.myChart2.setOption(option);
      window.addEventListener("resize", function () {
        if (_this3.$route.query.identification) {
          var resize = {
            width: _this3.screenWidth - 21
          };
          _this3.myChart2.resize(resize);
        } else {
          _this3.myChart2.resize();
        }
      });
    },
    getNature: function getNature() {
      var _this = this;
      var url = Urls.getEchartsStatusCountReportItemData;
      var params = {
        orgCode: this.orgCode,
        startTime: this.dataRange.length ? this.dataRange[0] : '',
        endTime: this.dataRange.length ? this.dataRange[1] : '',
        itemCode: 'NATURE_TYPE'
      };
      this.$root.doPost(url, params, function (server_data) {
        if (!_this.$root.isUserLogin(server_data)) {
          return;
        }

        if (server_data.error) {
          _this.$root.showGlobalError(server_data.error);
          return;
        }
        _this.statePercent = Math.ceil(Math.max.apply(Math, (0, _toConsumableArray3.default)(server_data.data.series[0].data)) / 10) * 10;
        _this.stateEntries = Math.ceil(Math.max.apply(Math, (0, _toConsumableArray3.default)(server_data.data.series[1].data)) / 10) * 10;
        _this.natureDataList = server_data.data;
      });
    },
    initChart3: function initChart3() {
      var _this4 = this;

      var piePercent = '';
      var Chart3 = this.$echarts.getInstanceByDom(this.$refs.OnepieChart);
      if (Chart3 == null) {
        this.myChart3 = this.$echarts.init(this.$refs.OnepieChart);
      }
      var option = {
        textStyle: {
          fontFamily: 'PingFang-M'
        },
        title: {
          text: '按收费',
          top: '24',
          left: '30',
          textStyle: {
            fontWeight: 500
          }
        },
        color: ["#57B9FF", "#FFB96E", "#E5E5E5"],
        series: [{
          name: this.PieChartData[0].name,
          type: "pie",
          startAngle: 180,
          center: ["25%", "50%"],
          radius: this.$route.query.identification ? ["40%", "44%"] : this.screenWidth <= 1366 ? ["47%", "50%"] : ["50%", "54%"],
          avoidLabelOverlap: false,
          hoverAnimation: false,
          selectedOffset: 0,
          label: {
            normal: {
              show: false,
              position: "center",

              formatter: function formatter(params) {
                piePercent = params.percent.toFixed();
                var str = '{a|' + params.name + '}\n{b|' + params.value + '}{a|\u4E2A}\n{c|' + piePercent + '%}';
                return str;
              },
              textStyle: {
                rich: {
                  a: {
                    color: "#666",
                    fontSize: 14,
                    lineHeight: 25
                  },
                  b: {
                    color: "#333",
                    fontSize: 26,
                    fontWeight: 500,
                    lineHeight: 40
                  },
                  c: {
                    fontSize: 14,
                    lineHeight: 30
                  }
                }
              }
            }
          },
          labelLine: {
            show: false
          },
          data: [{
            value: this.PieChartData[0].value,
            name: this.PieChartData[0].name,
            selected: true,
            label: {
              normal: {
                show: true,
                fontSize: "20",
                color: "#57B9FF"
              }
            }
          }, {
            value: this.PieChartData[0].value === 0 ? 10 : this.PieChartData[1].value,
            name: this.PieChartData[0].name,
            itemStyle: {
              normal: { color: "#e5e5e5" },
              emphasis: { color: "#e5e5e5" }
            }
          }]
        }, {
          name: this.PieChartData[1].name,
          type: "pie",
          startAngle: this.startAngle,

          center: this.$route.query.identification ? ["70%", "50%"] : ["70%", "50%"],
          radius: this.$route.query.identification ? ["40%", "44%"] : this.screenWidth <= 1366 ? ["47%", "50%"] : ["50%", "54%"],
          avoidLabelOverlap: false,
          hoverAnimation: false,
          selectedOffset: 0,
          label: {
            normal: {
              show: false,
              position: "center",
              formatter: function formatter(params) {
                var str = '{a|' + params.name + '}\n{b|' + params.value + '}{a|\u4E2A}\n{c|' + (piePercent == 0 ? 0 : 100 - piePercent) + '%}';
                return str;
              },
              textStyle: {
                rich: {
                  a: {
                    color: "#666",
                    fontSize: 14,
                    lineHeight: 25
                  },
                  b: {
                    color: "#333",
                    fontSize: 26,
                    fontWeight: 500,
                    lineHeight: 40
                  },
                  c: {
                    fontSize: 14,
                    lineHeight: 30
                  }
                }
              }
            }
          },
          labelLine: {
            show: false
          },
          data: [{
            value: this.PieChartData[1].value,
            name: this.PieChartData[1].name,
            selected: true,
            label: {
              normal: {
                show: true,
                fontSize: "20",
                color: "#FFB96E"
              }
            }
          }, {
            value: this.PieChartData[1].value === 0 ? 10 : this.PieChartData[0].value,
            name: this.PieChartData[1].name,
            itemStyle: {
              normal: { color: "#e5e5e5" },
              emphasis: { color: "#e5e5e5" }
            }
          }]
        }]
      };
      this.myChart3.setOption(option);
      window.addEventListener("resize", function () {
        if (_this4.$route.query.identification) {
          var resize = {
            width: _this4.screenWidth - 21
          };
          _this4.myChart3.resize(resize);
        } else {
          _this4.myChart3.resize();
        }
      });
    },
    getCharge: function getCharge() {
      var _this = this;
      var url = Urls.getEchartsChargeReportItemData;
      var params = {
        orgCode: this.orgCode,
        startTime: this.dataRange.length ? this.dataRange[0] : '',
        endTime: this.dataRange.length ? this.dataRange[1] : '',
        itemCode: 'CHARGE_TYPE'
      };
      this.$root.doPost(url, params, function (server_data) {
        if (!_this.$root.isUserLogin(server_data)) {
          return;
        }

        if (server_data.error) {
          _this.$root.showGlobalError(server_data.error);
          return;
        }
        _this.PieChartData = server_data.data;
      });
    },
    changeDate: function changeDate(val) {
      this.dataRange = val;
      this.getStorageRecordData();
      this.getNature();
      this.getCharge();
    }
  },
  watch: {
    StorageRecordDataList: function StorageRecordDataList(val) {
      if (val) {
        this.recordPercent = Math.ceil(Math.max.apply(Math, (0, _toConsumableArray3.default)(val.series[0].data)) / 10) * 10;
        this.recordEntries = Math.ceil(Math.max.apply(Math, (0, _toConsumableArray3.default)(val.series[1].data)) / 10) * 10;
        this.$nextTick(function () {
          var myEvent = new Event('resize');
          window.dispatchEvent(myEvent);
        });
        this.initChart1();
      }
    },
    natureDataList: function natureDataList() {
      this.$nextTick(function () {
        var myEvent = new Event('resize');
        window.dispatchEvent(myEvent);
      });
      this.initChart2();
    },
    PieChartData: function PieChartData() {
      this.$nextTick(function () {
        var myEvent = new Event('resize');
        window.dispatchEvent(myEvent);
      });
      this.initChart3();
    }
  },
  computed: {
    startAngle: function startAngle() {
      var total = this.PieChartData[0].value + this.PieChartData[1].value;
      if (total === 0) {
        return 180;
      } else {
        var res = this.PieChartData[0].value / total * 360;
        if (res > 180) {
          return 360 + (180 - res);
        } else {
          return 180 - res;
        }
      }
    }
  }
};

/***/ }),

/***/ 818:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(31);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _defineProperty2 = __webpack_require__(93);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _Urls = __webpack_require__(12);

var Urls = _interopRequireWildcard(_Urls);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {},
  data: function data() {
    return {
      screenWidth: document.body.clientWidth,
      RegisteredPersonnelDataList: '',
      ManagerDataList: '',
      SkilledWorkersDataList: '',
      SkilledworkersEntries: '',
      SkilledworkersPercent: '',
      managerEntries: '',
      managerPercent: '',
      registeredEntries: '',
      registeredPercent: '',
      OtherPersonnelList: '',
      OtherPersonnelType: 'CERTIFICATE_TYPE_TITLE'
    };
  },
  created: function created() {},
  mounted: function mounted() {
    var _this = this;
    window.onresize = function () {
      return function () {
        window.screenWidth = document.body.clientWidth + 17;
        _this.screenWidth = window.screenWidth;
      }();
    };
    if (!this.$route.query.identification) {
      this.init();
    }
  },

  methods: {
    getOrgCode: function getOrgCode() {
      this.$refs.HeadControl.getSysOrg();
    },
    initChart4: function initChart4() {
      var _this2 = this;

      var widthPx = this.screenWidth;
      var Chart4 = this.$echarts.getInstanceByDom(this.$refs.otherStaffsEchart);
      if (Chart4 == null) {
        this.myChart4 = this.$echarts.init(this.$refs.otherStaffsEchart);
      }
      var option = {
        textStyle: {
          fontFamily: 'PingFang-M'
        },
        title: {
          text: '其他人员',
          top: '24',
          left: this.$route.query.identification ? '20' : '30',
          textStyle: {
            fontWeight: 500
          }
        },
        grid: {
          left: this.$route.query.identification ? '15' : this.screenWidth <= 1366 ? '4%' : '3%',
          right: this.$route.query.identification ? '30' : '3%',
          bottom: '20px',
          top: this.$route.query.identification ? '130' : '90px',
          containLabel: true
        },
        opacity: 0.1,
        tooltip: {
          trigger: 'axis',
          formatter: function formatter(params) {
            var h = '<div>';
            params.reverse().forEach(function (item) {
              if (item.seriesIndex == 1) {
                h += '<div>' + item.axisValue + '\uFF1A' + item.data + '\u4E2A</div>';
              } else {
                h += '<div>\u5360\u6BD4\uFF1A' + item.data + '%</div></div>';
              }
            });
            return h;
          }
        },
        legend: {
          data: this.OtherPersonnelList.legend,
          itemWidth: 40,
          itemHeight: 8,
          itemGap: 20,
          left: this.$route.query.identification ? '110' : '350',
          top: '24',
          textStyle: {
            fontSize: '13',
            height: 10,
            rich: {
              a: {
                verticalAlign: 'middle'
              }
            }
          }
        },
        xAxis: [(0, _defineProperty3.default)({
          type: 'category',
          offset: 5,
          data: this.OtherPersonnelList.xAxis.data,
          axisPointer: {
            type: 'shadow'
          },

          splitLine: {
            show: true,
            lineStyle: {
              color: '#DDDDDD'
            }
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#DDDDDD'
            }
          },
          axisLabel: {
            show: this.$route.query.identification ? false : true,

            formatter: function formatter(params, index) {
              if (params.length >= 5) {
                var newParamsName = "";
                var paramsNameNumber = params.length;
                var provideNumber = 5;
                var rowNumber = Math.ceil(paramsNameNumber / provideNumber);
                if (paramsNameNumber > provideNumber) {
                  for (var p = 0; p < rowNumber; p++) {
                    var tempStr = "";
                    var start = p * provideNumber;
                    var end = start + provideNumber;
                    if (p == rowNumber - 1) {
                      tempStr = params.substring(start, paramsNameNumber);
                    } else {
                      tempStr = params.substring(start, end) + "\n";
                    }
                    newParamsName += tempStr;
                  }
                } else {
                  newParamsName = params;
                }
                return newParamsName;
              } else {
                return params;
              }
            },
            textStyle: {
              color: '#666666'
            }
          }
        }, 'axisPointer', {
          type: 'none'
        })],
        yAxis: [{
          offset: 5,
          type: 'value',
          name: '百分比',
          min: 0,
          max: this.OtherPersonnelPercent,

          splitNumber: 5,
          interval: this.OtherPersonnelPercent / 5,
          axisLabel: {
            formatter: '{value}%',
            textStyle: {
              color: '#666666'
            }
          },

          splitLine: {
            show: true,
            lineStyle: {
              color: '#DDDDDD'
            }
          },

          nameTextStyle: {
            color: '#666666',
            padding: this.$route.query.identification ? [0, 28, 0, 0] : [0, 35, 0, 0]
          },
          axisTick: false,
          axisLine: {
            show: false }
        }, {
          type: 'value',
          name: '证书数（个）',
          min: 0,
          max: this.OtherPersonnelEntries,

          splitNumber: 5,
          interval: this.OtherPersonnelEntries / 5,
          axisLabel: {
            formatter: function formatter(params) {
              return parseInt(params);
            },
            textStyle: {
              color: '#666666'
            }
          },

          nameTextStyle: {
            color: '#666666',
            padding: this.$route.query.identification ? [0, 10, 0, 0] : [0, 0, 0, 0]
          },
          axisTick: false,
          axisLine: {
            show: false },
          splitLine: {
            show: false
          }
        }],
        series: [{
          name: this.OtherPersonnelList.series[0].name,
          type: 'bar',
          barWidth: '30%',
          data: this.OtherPersonnelList.series[0].data,
          itemStyle: {
            normal: {
              color: 'rgba(97,217,172,0.35)',
              borderColor: Math.max.apply(Math, (0, _toConsumableArray3.default)(this.OtherPersonnelList.series[0].data)) == 0 ? 'rgba(87,185,255,0)' : 'rgba(97,217,172,1)'
            }
          }
        }, {
          name: this.OtherPersonnelList.series[1].name,
          type: 'line',
          yAxisIndex: 1,
          symbol: 'rect',
          symbolSize: 9,
          hoverAnimation: false,
          data: this.OtherPersonnelList.series[1].data,
          itemStyle: {
            normal: {
              color: 'rgba(87,185,255,1)',
              opacity: Math.max.apply(Math, (0, _toConsumableArray3.default)(this.OtherPersonnelList.series[1].data)) == 0 ? 0 : 1
            },
            emphasis: {
              borderWidth: 3,
              borderColor: 'rgba(87,185,255,1)',
              color: 'rgba(87,185,255,1)'
            }
          },
          lineStyle: {
            normal: {
              opacity: Math.max.apply(Math, (0, _toConsumableArray3.default)(this.OtherPersonnelList.series[1].data)) == 0 ? 0 : 1
            }
          }
        }]
      };
      this.myChart4.setOption(option);
      window.addEventListener("resize", function () {
        if (_this2.$route.query.identification) {
          var resize = {
            width: _this2.screenWidth - 21
          };
          _this2.myChart4.resize(resize);
        } else {
          _this2.myChart4.resize();
        }
      });
    },
    getOtherPersonnel: function getOtherPersonnel() {
      var _this = this;
      var url = Urls.getEchartsSkillReportItemData;
      var params = {
        itemCode: this.OtherPersonnelType
      };
      this.$root.doPost(url, params, function (server_data) {
        if (!_this.$root.isUserLogin(server_data)) {
          return;
        }

        if (server_data.error) {
          _this.$root.showGlobalError(server_data.error);
          return;
        }
        _this.OtherPersonnelList = server_data.data;
      });
    },
    initChart3: function initChart3() {
      var _this3 = this;

      var widthPx = this.screenWidth;
      var Chart3 = this.$echarts.getInstanceByDom(this.$refs.threemyChart);
      if (Chart3 == null) {
        this.myChart3 = this.$echarts.init(this.$refs.threemyChart);
      }
      var option = {
        textStyle: {
          fontFamily: 'PingFang-M'
        },
        title: {
          text: '技术工人',
          top: '24',
          left: this.$route.query.identification ? '20' : '30',
          textStyle: {
            fontWeight: 500
          }
        },
        grid: {
          left: this.$route.query.identification ? '15' : this.screenWidth <= 1366 ? '4%' : '3%',
          right: this.$route.query.identification ? '30' : '3%',
          bottom: '20px',
          top: '90px',
          containLabel: true
        },
        opacity: 0.1,
        tooltip: {
          trigger: 'axis',
          formatter: function formatter(params) {
            var h = '<div>';
            params.reverse().forEach(function (item) {
              if (item.seriesIndex == 1) {
                h += '<div>' + item.axisValue + '\uFF1A' + item.data + '\u4E2A</div>';
              } else {
                h += '<div>\u5360\u6BD4\uFF1A' + item.data + '%</div></div>';
              }
            });
            return h;
          }
        },
        legend: {
          data: this.SkilledWorkersDataList.legend,
          itemWidth: 40,
          itemHeight: 8,
          itemGap: 20,
          left: this.$route.query.identification ? '110' : '200',
          top: '24',
          textStyle: {
            fontSize: '13',
            height: 10,
            rich: {
              a: {
                verticalAlign: 'middle'
              }
            }
          }
        },
        xAxis: [(0, _defineProperty3.default)({
          type: 'category',
          offset: 5,
          data: this.SkilledWorkersDataList.xAxis.data,
          axisPointer: {
            type: 'shadow'
          },

          splitLine: {
            show: true,
            lineStyle: {
              color: '#DDDDDD'
            }
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#DDDDDD'
            }
          },
          axisLabel: {
            show: this.$route.query.identification ? false : true,
            formatter: function formatter(params) {
              if (widthPx <= 1366) {
                var newParamsName = "";
                var paramsNameNumber = params.length;
                var provideNumber = 5;
                var rowNumber = Math.ceil(paramsNameNumber / provideNumber);
                if (paramsNameNumber > provideNumber) {
                  for (var p = 0; p < rowNumber; p++) {
                    var tempStr = "";
                    var start = p * provideNumber;
                    var end = start + provideNumber;
                    if (p == rowNumber - 1) {
                      tempStr = params.substring(start, paramsNameNumber);
                    } else {
                      tempStr = params.substring(start, end) + "\n";
                    }
                    newParamsName += tempStr;
                  }
                } else {
                  newParamsName = params;
                }
                return newParamsName;
              } else {
                return params;
              }
            },
            textStyle: {
              color: '#666666'
            }
          }
        }, 'axisPointer', {
          type: 'none'
        })],
        yAxis: [{
          offset: 5,
          type: 'value',
          name: '百分比',
          min: 0,
          max: this.SkilledworkersPercent,

          splitNumber: 5,
          interval: this.SkilledworkersPercent / 5,
          axisLabel: {
            formatter: '{value}%',
            textStyle: {
              color: '#666666'
            }
          },

          splitLine: {
            show: true,
            lineStyle: {
              color: '#DDDDDD'
            }
          },

          nameTextStyle: {
            color: '#666666',
            padding: this.$route.query.identification ? [0, 28, 0, 0] : [0, 35, 0, 0]
          },
          axisTick: false,
          axisLine: {
            show: false }
        }, {
          type: 'value',
          name: '证书数（个）',
          min: 0,
          max: this.SkilledworkersEntries,

          splitNumber: 5,
          interval: this.SkilledworkersEntries / 5,
          axisLabel: {
            formatter: function formatter(params) {
              return parseInt(params);
            },
            textStyle: {
              color: '#666666'
            }
          },

          nameTextStyle: {
            color: '#666666',
            padding: this.$route.query.identification ? [0, 10, 0, 0] : [0, 0, 0, 0]
          },
          axisTick: false,
          axisLine: {
            show: false },
          splitLine: {
            show: false
          }
        }],
        series: [{
          name: this.SkilledWorkersDataList.series[0].name,
          type: 'bar',
          barWidth: '50%',
          data: this.SkilledWorkersDataList.series[0].data,
          itemStyle: {
            normal: {
              color: 'rgba(97,217,172,0.35)',
              borderColor: Math.max.apply(Math, (0, _toConsumableArray3.default)(this.SkilledWorkersDataList.series[0].data)) == 0 ? 'rgba(87,185,255,0)' : 'rgba(97,217,172,1)'
            }
          }
        }, {
          name: this.SkilledWorkersDataList.series[1].name,
          type: 'line',
          yAxisIndex: 1,
          symbol: 'rect',
          symbolSize: 9,
          hoverAnimation: false,
          data: this.SkilledWorkersDataList.series[1].data,
          itemStyle: {
            normal: {
              color: 'rgba(87,185,255,1)',
              opacity: Math.max.apply(Math, (0, _toConsumableArray3.default)(this.SkilledWorkersDataList.series[1].data)) == 0 ? 0 : 1
            },
            emphasis: {
              borderWidth: 3,
              borderColor: 'rgba(87,185,255,1)',
              color: 'rgba(87,185,255,1)'
            }
          },
          lineStyle: {
            normal: {
              opacity: Math.max.apply(Math, (0, _toConsumableArray3.default)(this.SkilledWorkersDataList.series[1].data)) == 0 ? 0 : 1
            }
          }
        }]
      };
      this.myChart3.setOption(option);
      window.addEventListener("resize", function () {
        if (_this3.$route.query.identification) {
          var resize = {
            width: _this3.screenWidth - 21
          };
          _this3.myChart3.resize(resize);
        } else {
          _this3.myChart3.resize();
        }
      });
    },
    getSkilledWorkersData: function getSkilledWorkersData() {
      var _this = this;
      var url = Urls.getEchartsSkillReportItemData;
      var params = {
        itemCode: 'CERTIFICATE_TYPE_SKILL'
      };
      this.$root.doPost(url, params, function (server_data) {
        if (!_this.$root.isUserLogin(server_data)) {
          return;
        }

        if (server_data.error) {
          _this.$root.showGlobalError(server_data.error);
          return;
        }
        _this.SkilledWorkersDataList = server_data.data;
      });
    },
    initChart2: function initChart2() {
      var _this4 = this;

      var widthPx = this.screenWidth;
      var Chart2 = this.$echarts.getInstanceByDom(this.$refs.Twohistogram);
      if (Chart2 == null) {
        this.myChart2 = this.$echarts.init(this.$refs.Twohistogram);
      }
      var option = {
        textStyle: {
          fontFamily: 'PingFang-M'
        },
        title: {
          text: '管理人员 ',
          top: '24',
          left: this.$route.query.identification ? '20' : '30',
          textStyle: {
            fontWeight: 500
          }
        },

        grid: {
          left: this.$route.query.identification ? '15' : this.screenWidth <= 1366 ? '4%' : '3%',
          right: this.$route.query.identification ? '30' : this.screenWidth <= 1366 ? '6.5%' : '4.5%',
          bottom: this.$route.query.identification ? 40 : '20px',
          top: '90px',
          containLabel: true
        },
        opacity: 0.1,
        tooltip: {
          trigger: 'axis',
          formatter: function formatter(params) {
            var h = '<div>';
            params.forEach(function (item) {
              if (item.seriesIndex == 1) {
                h += '<div>' + item.seriesName + '\uFF1A' + item.data + '\u4E2A</div>';
              } else {
                h += '<div>' + item.seriesName + '\uFF1A' + item.data + '\u4E2A</div>';
              }
            });
            return h;
          }
        },
        legend: {
          data: this.ManagerDataList.legend,
          itemWidth: 40,
          itemHeight: 8,
          itemGap: 20,
          left: this.$route.query.identification ? '110' : '200',
          top: '24',
          textStyle: {
            fontSize: '13',
            height: 10,
            rich: {
              a: {
                verticalAlign: 'middle'
              }
            }
          }
        },
        xAxis: [(0, _defineProperty3.default)({
          type: 'category',
          offset: 5,
          data: this.ManagerDataList.xAxis.data,
          axisPointer: {
            type: 'shadow'
          },

          splitLine: {
            show: true,
            lineStyle: {
              color: '#DDDDDD'
            }
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#DDDDDD'
            }
          },
          axisLabel: {
            color: '#666666',
            formatter: function formatter(params, index) {
              if (params.length >= 4) {
                var newParamsName = "";
                var paramsNameNumber = params.length;
                var provideNumber = 3;
                var rowNumber = Math.ceil(paramsNameNumber / provideNumber);
                if (paramsNameNumber > provideNumber) {
                  for (var p = 0; p < rowNumber; p++) {
                    var tempStr = "";
                    var start = p * provideNumber;
                    var end = start + provideNumber;
                    if (p == rowNumber - 1) {
                      tempStr = params.substring(start, paramsNameNumber);
                    } else {
                      tempStr = params.substring(start, end) + "\n";
                    }
                    newParamsName += tempStr;
                  }
                } else {
                  newParamsName = params;
                }
                return newParamsName;
              } else {
                return params;
              }
            }
          }
        }, 'axisPointer', {
          type: 'none'
        })],
        yAxis: [{
          offset: 5,
          type: 'value',
          name: '证书数（个）',
          min: 0,
          max: this.managerPercent,
          splitNumber: 5,
          interval: this.managerPercent / 5,
          axisLabel: {
            formatter: '{value}',
            textStyle: {
              color: '#666666'
            }
          },

          splitLine: {
            show: true,
            lineStyle: {
              color: '#dddddd'
            }
          },

          nameTextStyle: {
            color: '#666666',
            padding: this.$route.query.identification ? [0, 0, 0, 25] : [0, 0, 0, 17]
          },
          axisTick: false,
          axisLine: {
            show: false }
        }, {
          type: 'value',
          name: '锁证数（个）',
          min: 0,
          max: this.managerEntries,

          splitNumber: 5,
          interval: this.managerEntries / 5,
          axisLabel: {
            formatter: function formatter(params) {
              return parseInt(params);
            },
            textStyle: {
              color: '#666666'
            }
          },

          nameTextStyle: {
            color: '#666666',
            padding: this.$route.query.identification ? [0, 20, 0, 0] : [0, 0, 0, 0]
          },
          axisTick: false,
          axisLine: {
            show: false }
        }],
        series: [{
          name: this.ManagerDataList.series[0].name,
          type: 'bar',
          barWidth: '60%',
          data: this.ManagerDataList.series[0].data,
          itemStyle: {
            normal: {
              color: 'rgba(87,185,255,0.35)',
              borderColor: Math.max.apply(Math, (0, _toConsumableArray3.default)(this.ManagerDataList.series[0].data)) == 0 ? 'rgba(87,185,255,0)' : 'rgba(87,185,255,1)'
            }
          }
        }, {
          name: this.ManagerDataList.series[1].name,
          type: 'line',
          symbol: 'rect',
          symbolSize: 10,
          hoverAnimation: false,
          data: this.ManagerDataList.series[1].data,
          itemStyle: {
            normal: {
              color: '#72d8c0',
              opacity: Math.max.apply(Math, (0, _toConsumableArray3.default)(this.ManagerDataList.series[1].data)) == 0 ? 0 : 1
            },
            emphasis: {
              borderWidth: 3,
              borderColor: '#61d9ac',
              color: '#61d9ac'
            }
          },
          lineStyle: {
            normal: {
              opacity: Math.max.apply(Math, (0, _toConsumableArray3.default)(this.ManagerDataList.series[1].data)) == 0 ? 0 : 1
            }
          }
        }]
      };
      if (this.$route.query.identification) {
        option.dataZoom = [{
          type: 'slider',
          show: this.$route.query.identification ? true : false,
          xAxisIndex: [0],
          left: '9%',
          bottom: 10,
          start: 15,
          end: 0,
          zoomLock: true,
          height: 20,

          borderRadius: 5,

          showDataShadow: false,
          showDetail: false,
          realtime: true,
          filterMode: 'filter'
        }];
      }
      this.myChart2.setOption(option);
      window.addEventListener("resize", function () {
        if (_this4.$route.query.identification) {
          var resize = {
            width: _this4.screenWidth - 21
          };
          _this4.myChart2.resize(resize);
        } else {
          _this4.myChart2.resize();
        }
      });
    },
    getManagerData: function getManagerData() {
      var _this = this;
      var url = Urls.getEchartsRegisterAndManageReportItemData;
      var params = {
        itemCode: 'CERTIFICATE_TYPE_MANAGE'
      };
      this.$root.doPost(url, params, function (server_data) {
        if (!_this.$root.isUserLogin(server_data)) {
          return;
        }

        if (server_data.error) {
          _this.$root.showGlobalError(server_data.error);
          return;
        }
        _this.ManagerDataList = server_data.data;
      });
    },
    initChart1: function initChart1() {
      var _this5 = this;

      var identification = this.$route.query.identification;
      var legend = this.RegisteredPersonnelDataList.legend;
      var xAxisList = this.RegisteredPersonnelDataList.xAxis.data;
      var Chart1 = this.$echarts.getInstanceByDom(this.$refs.OnepieChart);
      var widthPx = this.screenWidth;
      if (Chart1 == null) {
        this.myChart1 = this.$echarts.init(this.$refs.OnepieChart);
      }
      var option = {
        textStyle: {
          fontFamily: 'PingFang-M'
        },
        title: {
          text: '注册人员',
          top: '24',
          left: this.$route.query.identification ? '20' : '30',
          textStyle: {
            fontWeight: 500
          }
        },
        grid: {
          left: this.$route.query.identification ? '15' : this.screenWidth <= 1366 ? '4%' : '3%',
          right: this.$route.query.identification ? '30' : this.screenWidth <= 1366 ? '7%' : '4.5%',
          bottom: this.$route.query.identification ? 40 : '20px',
          top: '90px',
          containLabel: true
        },
        opacity: 0.1,
        tooltip: {
          trigger: 'axis',
          formatter: function formatter(params) {
            var h = '<div>';
            params.forEach(function (item) {
              if (item.seriesIndex == 1) {
                h += '<div>' + item.seriesName + '\uFF1A' + item.data + '\u4E2A</div>';
              } else {
                h += '<div>' + item.seriesName + '\uFF1A' + item.data + '\u4E2A</div>';
              }
            });
            return h;
          }
        },
        legend: {
          data: legend,
          itemWidth: 40,
          itemHeight: 8,
          itemGap: 20,
          left: this.$route.query.identification ? '110' : '200',
          top: '24',
          textStyle: {
            fontSize: '13',
            height: 10,
            rich: {
              a: {
                verticalAlign: 'middle'
              }
            }
          }
        },
        xAxis: [(0, _defineProperty3.default)({
          type: 'category',
          offset: 5,
          data: this.RegisteredPersonnelDataList.xAxis.data,
          axisPointer: {
            type: 'shadow'
          },

          splitLine: {
            show: true,
            lineStyle: {
              color: '#DDDDDD'
            }
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#DDDDDD'
            }
          },
          axisLabel: {
            color: '#A1A7B3',
            formatter: function formatter(params, index) {
              if (xAxisList.length >= 8) {
                var newParamsName = "";
                var paramsNameNumber = params.length;
                var provideNumber = identification ? 5 : 5;
                var rowNumber = Math.ceil(paramsNameNumber / provideNumber);
                if (paramsNameNumber > provideNumber) {
                  for (var p = 0; p < rowNumber; p++) {
                    var tempStr = "";
                    var start = p * provideNumber;
                    var end = start + provideNumber;
                    if (p == rowNumber - 1) {
                      tempStr = params.substring(start, paramsNameNumber);
                    } else {
                      tempStr = params.substring(start, end) + "\n";
                    }
                    newParamsName += tempStr;
                  }
                } else {
                  newParamsName = params;
                }
                return newParamsName;
              } else {
                return params;
              }
            },
            textStyle: {
              color: '#666666'
            }
          }
        }, 'axisPointer', {
          type: 'none'
        })],
        yAxis: [{
          offset: 5,
          type: 'value',
          name: '证书数（个）',
          min: 0,
          max: this.registeredPercent,
          splitNumber: 5,
          interval: this.registeredPercent / 5,
          axisLabel: {
            formatter: '{value}',
            textStyle: {
              color: '#666666'
            }
          },

          splitLine: {
            show: true,
            lineStyle: {
              color: '#dddddd'
            }
          },

          nameTextStyle: {
            color: '#666666',
            padding: this.$route.query.identification ? [0, 0, 0, 25] : [0, 0, 0, 17]
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: false }
        }, {
          type: 'value',
          name: '锁证数（个）',
          min: 0,
          max: this.registeredEntries,
          splitNumber: 5,
          interval: this.registeredEntries / 5,
          axisLabel: {
            formatter: function formatter(params) {
              return parseInt(params);
            },
            textStyle: {
              color: '#666666'
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#dddddd'
            }
          },

          nameTextStyle: {
            padding: [0, 0, 0, 0],
            color: '#666666'
          },
          axisTick: false,
          axisLine: {
            show: false }
        }],
        series: [{
          name: this.RegisteredPersonnelDataList.series[0].name,
          type: 'bar',
          barWidth: '70%',
          data: this.RegisteredPersonnelDataList.series[0].data,
          itemStyle: {
            normal: {
              color: 'rgba(87,185,255,0.35)',

              borderColor: Math.max.apply(Math, (0, _toConsumableArray3.default)(this.RegisteredPersonnelDataList.series[0].data)) == 0 ? 'rgba(87,185,255,0)' : 'rgba(87,185,255,1)'
            }
          }
        }, {
          name: this.RegisteredPersonnelDataList.series[1].name,
          type: 'line',
          symbol: 'rect',
          symbolSize: 9,
          hoverAnimation: false,
          data: this.RegisteredPersonnelDataList.series[1].data,
          itemStyle: {
            normal: {
              color: '#72d8c0',
              opacity: Math.max.apply(Math, (0, _toConsumableArray3.default)(this.RegisteredPersonnelDataList.series[1].data)) == 0 ? 0 : 1
            },
            emphasis: {
              borderWidth: 3,
              borderColor: '#61d9ac',
              color: '#61d9ac'
            }
          },
          lineStyle: {
            normal: {
              opacity: Math.max.apply(Math, (0, _toConsumableArray3.default)(this.RegisteredPersonnelDataList.series[1].data)) == 0 ? 0 : 1
            }
          }
        }]
      };
      if (this.$route.query.identification) {
        option.dataZoom = [{
          type: 'slider',
          show: this.$route.query.identification ? true : false,
          xAxisIndex: [0],
          left: '9%',
          bottom: 10,
          start: 25,
          end: 0,
          zoomLock: true,
          height: 20,

          borderRadius: 5,

          showDataShadow: false,
          showDetail: false,
          realtime: true,
          filterMode: 'filter'
        }];
      }
      this.myChart1.setOption(option);
      window.addEventListener("resize", function () {
        if (_this5.$route.query.identification) {
          var resize = {
            width: _this5.screenWidth - 21
          };
          _this5.myChart1.resize(resize);
        } else {
          _this5.myChart1.resize();
        }
      });
    },
    getRegisteredPersonnelData: function getRegisteredPersonnelData() {
      var _this = this;
      var url = Urls.getEchartsRegisterAndManageReportItemData;
      var params = {
        itemCode: 'CERTIFICATE_TYPE_REGISTER'
      };
      this.$root.doPost(url, params, function (server_data) {
        if (!_this.$root.isUserLogin(server_data)) {
          return;
        }

        if (server_data.error) {
          _this.$root.showGlobalError(server_data.error);
          return;
        }

        _this.RegisteredPersonnelDataList = server_data.data;
      });
    },
    init: function init() {
      if (this.$route.query.identification) {
        this.getRegisteredPersonnelData();
        this.getManagerData();
        this.getSkilledWorkersData();
        this.getOtherPersonnel('CERTIFICATE_TYPE_SAFETY');
        return;
      }

      this.getRegisteredPersonnelData();
      this.getManagerData();
      this.getSkilledWorkersData();
      this.getOtherPersonnel('CERTIFICATE_TYPE_SAFETY');
    }
  },
  watch: {
    RegisteredPersonnelDataList: function RegisteredPersonnelDataList(val) {
      this.registeredEntries = Math.ceil(Math.max.apply(Math, (0, _toConsumableArray3.default)(val.series[1].data)) / 10) * 10;
      this.registeredPercent = Math.ceil(Math.max.apply(Math, (0, _toConsumableArray3.default)(val.series[0].data)) / 10) * 10;
      this.$nextTick(function () {
        var myEvent = new Event('resize');
        window.dispatchEvent(myEvent);
      });
      this.initChart1();
    },
    ManagerDataList: function ManagerDataList(val) {
      this.managerEntries = Math.ceil(Math.max.apply(Math, (0, _toConsumableArray3.default)(val.series[1].data)) / 10) * 10;
      this.managerPercent = Math.ceil(Math.max.apply(Math, (0, _toConsumableArray3.default)(val.series[0].data)) / 10) * 10;
      this.$nextTick(function () {
        var myEvent = new Event('resize');
        window.dispatchEvent(myEvent);
      });
      this.initChart2();
    },
    SkilledWorkersDataList: function SkilledWorkersDataList(val) {
      this.SkilledworkersEntries = Math.ceil(Math.max.apply(Math, (0, _toConsumableArray3.default)(val.series[1].data)) / 10) * 10;
      this.SkilledworkersPercent = Math.ceil(Math.max.apply(Math, (0, _toConsumableArray3.default)(val.series[0].data)) / 10) * 10;
      this.$nextTick(function () {
        var myEvent = new Event('resize');
        window.dispatchEvent(myEvent);
      });
      this.initChart3();
    },
    OtherPersonnelList: function OtherPersonnelList(val) {
      this.OtherPersonnelEntries = Math.ceil(Math.max.apply(Math, (0, _toConsumableArray3.default)(val.series[1].data)) / 10) * 10;
      this.OtherPersonnelPercent = Math.ceil(Math.max.apply(Math, (0, _toConsumableArray3.default)(val.series[0].data)) / 10) * 10;
      this.$nextTick(function () {
        var myEvent = new Event('resize');
        window.dispatchEvent(myEvent);
      });

      this.OtherPersonnelList = val;
      console.log(this.OtherPersonnelList, '123123');
      this.initChart4();
    }
  }
};

/***/ }),

/***/ 819:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _HeadControl = __webpack_require__(43);

var _HeadControl2 = _interopRequireDefault(_HeadControl);

var _EliteDirectorDataEcharts = __webpack_require__(1635);

var _EliteDirectorDataEcharts2 = _interopRequireDefault(_EliteDirectorDataEcharts);

var _Urls = __webpack_require__(12);

var Urls = _interopRequireWildcard(_Urls);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        HeadControl: _HeadControl2.default,
        EliteDirectorDataEcharts: _EliteDirectorDataEcharts2.default
    },
    data: function data() {
        return {
            orgCode: '',
            dataRange: [],
            headData: [],
            EliteNumberDataList: '',
            CooperationDtaList: '',
            EliteTypeDataList: '' };
    },

    methods: {
        init: function init() {
            this.$refs.HeadControl.getDatas('');
            this.$refs.HeadControl.getSysOrg();
        },
        changeVal: function changeVal(val) {
            this.orgCode = val;
            this.getHeadData();
            this.getEliteNumber();
            this.getCooperation();
            this.getEliteType();
        },
        changDate: function changDate(val) {
            this.dataRange = val;
            this.getHeadData();
            this.getEliteNumber();
            this.getCooperation();
            this.getEliteType();
        },
        changePicker: function changePicker(val) {
            this.dataRange = val;
            this.getHeadData();
            this.getEliteNumber();
            this.getCooperation();
            this.getEliteType();
        },
        getOrgCode: function getOrgCode() {
            this.$refs.HeadControl.getSysOrg();
        },
        getHeadData: function getHeadData() {
            var _this = this;
            var url = Urls.getEchartsReportItemDataByElite;
            var params = {
                orgCode: this.orgCode,
                startTime: this.dataRange.length ? this.dataRange[0] : '',
                endTime: this.dataRange.length ? this.dataRange[1] : '',
                itemCode: 'TOTALDATA-TYPE'
            };
            this.$root.doPost(url, params, function (server_data) {
                if (!_this.$root.isUserLogin(server_data)) {
                    return;
                }

                if (server_data.error) {
                    _this.$root.showGlobalError(server_data.error);
                    return;
                }
                _this.headData = server_data.data.reportList;
            });
        },
        getEliteNumber: function getEliteNumber() {
            var _this = this;
            var url = Urls.getEchartsTalentsCountReportItemData;
            var params = {
                orgCode: this.orgCode,
                startTime: this.dataRange.length ? this.dataRange[0] : '',
                endTime: this.dataRange.length ? this.dataRange[1] : '',
                itemCode: 'TALENTS_ACC_DATA'
            };
            this.$root.doPost(url, params, function (server_data) {
                if (!_this.$root.isUserLogin(server_data)) {
                    return;
                }

                if (server_data.error) {
                    _this.$root.showGlobalError(server_data.error);
                    return;
                }
                _this.EliteNumberDataList = server_data.data;
            });
        },
        getCooperation: function getCooperation() {
            var _this = this;
            var url = Urls.getEchartsTalentsPartnershipReportItemData;
            var params = {
                orgCode: this.orgCode,
                startTime: this.dataRange.length ? this.dataRange[0] : '',
                endTime: this.dataRange.length ? this.dataRange[1] : '',
                itemCode: 'TALENTS_PARTNERSHIP'
            };
            this.$root.doPost(url, params, function (server_data) {
                if (!_this.$root.isUserLogin(server_data)) {
                    return;
                }

                if (server_data.error) {
                    _this.$root.showGlobalError(server_data.error);
                    return;
                }
                _this.CooperationDtaList = server_data.data;
            });
        },
        getEliteType: function getEliteType() {
            var _this = this;
            var url = Urls.getEchartsTalentsTypeReportItemData;
            var params = {
                orgCode: this.orgCode,
                startTime: this.dataRange.length ? this.dataRange[0] : '',
                endTime: this.dataRange.length ? this.dataRange[1] : '',
                itemCode: 'TALENTS_TYPE'
            };
            this.$root.doPost(url, params, function (server_data) {
                if (!_this.$root.isUserLogin(server_data)) {
                    return;
                }

                if (server_data.error) {
                    _this.$root.showGlobalError(server_data.error);
                    return;
                }
                _this.EliteTypeDataList = server_data.data;
            });
        },
        changeDate: function changeDate(val) {
            this.dataRange = val;
            this.getHeadData();
            this.getEliteNumber();
            this.getCooperation();
            this.getEliteType();
        }
    }
};

/***/ }),

/***/ 820:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(31);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _HeadControl = __webpack_require__(43);

var _HeadControl2 = _interopRequireDefault(_HeadControl);

var _ProjectDataEcharts = __webpack_require__(1636);

var _ProjectDataEcharts2 = _interopRequireDefault(_ProjectDataEcharts);

var _Urls = __webpack_require__(12);

var Urls = _interopRequireWildcard(_Urls);

var _VueHelper = __webpack_require__(17);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    HeadControl: _HeadControl2.default,
    ProjectDataEcharts: _ProjectDataEcharts2.default
  },
  data: function data() {
    return {
      screenWidth: document.body.clientWidth,
      orgCode: '',
      dataRange: [],
      ProjectSourceDataList: '',
      ProjectTypeDataList: '',
      ProjectPerformanceDataList: '',
      reportList: '',
      legend: ''
    };
  },
  mounted: function mounted() {
    var _this = this;
    window.onresize = function () {
      return function () {
        window.screenWidth = document.body.clientWidth;
        _this.screenWidth = window.screenWidth;
      }();
    };
  },

  methods: {
    init: function init() {
      this.$refs.HeadControl.getDatas('month');
      this.$refs.HeadControl.getSysOrg();
    },
    changeVal: function changeVal(val) {
      this.orgCode = val;
      this.getProjectSourceData();
      this.getProjectTypeData();
      this.getProjectPerformanceData();
    },
    changDate: function changDate(val) {
      this.dataRange = val;
      this.getProjectSourceData();
      this.getProjectTypeData();
      this.getProjectPerformanceData();
    },
    changePicker: function changePicker(val) {
      this.dataRange = val;
      this.getProjectSourceData();
      this.getProjectTypeData();
      this.getProjectPerformanceData();
    },
    getOrgCode: function getOrgCode() {
      this.$refs.HeadControl.getSysOrg();
    },
    getProjectSourceData: function getProjectSourceData() {
      var _this = this;
      var url = Urls.getEchartsInitiateReportDataBySource;
      var params = {
        orgCode: this.orgCode,
        startTime: this.dataRange.length ? this.dataRange[0] : '',
        endTime: this.dataRange.length ? this.dataRange[1] : '',
        itemCode: 'PROJECT-TYPE'
      };
      this.$root.doPost(url, params, function (server_data) {
        if (!_this.$root.isUserLogin(server_data)) {
          return;
        }

        if (server_data.error) {
          _this.$root.showGlobalError(server_data.error);
          return;
        }
        _this.ProjectSourceDataList = server_data.data;
      });
    },
    getProjectTypeData: function getProjectTypeData() {
      var _this = this;
      var url = Urls.getEchartsInitiateReportDataByType;
      var params = {
        orgCode: this.orgCode,
        startTime: this.dataRange.length ? this.dataRange[0] : '',
        endTime: this.dataRange.length ? this.dataRange[1] : '',
        itemCode: 'PROJECT-TYPE'
      };
      this.$root.doPost(url, params, function (server_data) {
        if (!_this.$root.isUserLogin(server_data)) {
          return;
        }

        if (server_data.error) {
          _this.$root.showGlobalError(server_data.error);
          return;
        }
        _this.ProjectTypeDataList = server_data.data;
      });
    },
    getProjectPerformanceData: function getProjectPerformanceData() {
      var _this = this;
      var url = Urls.getEchartsInitiateReportDataByTrend;
      var params = {
        orgCode: this.orgCode,
        startTime: this.dataRange.length ? this.dataRange[0] : '',
        endTime: this.dataRange.length ? this.dataRange[1] : '',
        itemCode: 'PROJECT-TYPE'
      };
      this.$root.doPost(url, params, function (server_data) {
        if (!_this.$root.isUserLogin(server_data)) {
          return;
        }

        if (server_data.error) {
          _this.$root.showGlobalError(server_data.error);
          return;
        }
        _this.ProjectPerformanceDataList = server_data.data;
        _this.reportList = server_data.data.reportList;
        _this.legend = server_data.data.legend;
      });
    },
    initChart: function initChart() {
      var _this2 = this;

      var WidthPx = this.screenWidth;
      var Chart1 = this.$echarts.getInstanceByDom(this.$refs.ProjectPerformanceEharts);
      if (Chart1 == null) {
        this.myChart1 = this.$echarts.init(this.$refs.ProjectPerformanceEharts);
      }
      var option = {
        textStyle: {
          fontFamily: 'PingFang-M'
        },
        title: {
          text: '立项走势',
          top: '24',
          left: this.$route.query.identification ? '20' : '30',
          textStyle: {
            fontWeight: 500
          }
        },
        grid: {
          left: this.$route.query.identification ? '52' : WidthPx <= 1366 ? '65' : '65',
          right: this.$route.query.identification ? '48' : '50',
          top: this.$route.query.identification ? '100' : '100',
          bottom: this.$route.query.identification ? '25' : WidthPx <= 1366 ? '50' : '50'
        },
        tooltip: {
          show: true,
          trigger: "axis",
          formatter: function formatter(params) {
            var h = '<div>';
            params.forEach(function (item) {
              if (item.seriesIndex == 0) {
                h += '<div >' + (0, _VueHelper.EchartsformatDate)(item.axisValue) + '</div>\n                                <div><div>' + item.marker + item.seriesName + '\uFF1A' + item.value + '\u4E2A</div>\n                              ';
              } else {
                if (params.length == 1) {
                  h += '<div >' + (0, _VueHelper.EchartsformatDate)(item.axisValue) + '</div>';
                }
                h += '<div>' + item.marker + item.seriesName + '\uFF1A' + item.value + '\u4EBA</div></div>';
              }
            });
            return h;
          },
          axisPointer: {
            lineStyle: {
              color: '#DDDDDD',
              type: 'solid'
            }
          }
        },
        legend: {
          show: true,
          x: this.$route.query.identification ? '140' : '200',
          y: '26',
          icon: 'circle',
          itemGap: 25,
          itemWidth: 8,
          itemHeight: 7,
          textStyle: {
            color: '#666666',
            height: 10,
            rich: {
              a: {
                verticalAlign: 'middle'
              }
            }
          },
          data: this.ProjectPerformanceDataList.legend
        },
        xAxis: [{
          type: 'category',
          boundaryGap: 0,
          axisLine: {
            show: Math.max.apply(Math, (0, _toConsumableArray3.default)(this.ProjectPerformanceDataList.series[0].data).concat((0, _toConsumableArray3.default)(this.ProjectPerformanceDataList.series[1].data))) == 0 ? true : false,
            lineStyle: {
              color: '#DDDDDD'
            }
          },
          axisLabel: {
            show: this.$route.query.identification ? false : true,
            color: '#666666',
            interval: WidthPx <= 1366 || (0, _VueHelper.checkDay)(this.dataRange) < 30 ? 'auto' : Math.ceil(this.ProjectPerformanceDataList.xAxis.data.length / 10)
          },
          splitLine: {
            show: Math.max.apply(Math, (0, _toConsumableArray3.default)(this.ProjectPerformanceDataList.series[0].data).concat((0, _toConsumableArray3.default)(this.ProjectPerformanceDataList.series[1].data))) == 0 ? false : true,
            lineStyle: {
              color: '#DDDDDD',
              type: 'solid'
            }
          },
          axisTick: {
            show: false
          },
          data: this.ProjectPerformanceDataList.xAxis.data
        }],
        yAxis: [{
          type: 'value',
          name: '数量(个)',
          minInterval: 1,
          show: Math.max.apply(Math, (0, _toConsumableArray3.default)(this.ProjectPerformanceDataList.series[0].data).concat((0, _toConsumableArray3.default)(this.ProjectPerformanceDataList.series[1].data))) == 0 ? false : true,
          splitLine: {
            show: Math.max.apply(Math, (0, _toConsumableArray3.default)(this.ProjectPerformanceDataList.series[0].data).concat((0, _toConsumableArray3.default)(this.ProjectPerformanceDataList.series[1].data))) == 0 ? false : true,
            lineStyle: {
              color: '#DDDDDD',
              type: 'solid'
            }
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            show: true,

            textStyle: {
              color: '#666666'
            }
          },
          axisTick: {
            show: false
          },

          nameTextStyle: {
            padding: [0, 15, 0, 0],
            color: '#666666'
          }
        }],
        series: [{
          name: this.ProjectPerformanceDataList.series[0].name,
          type: 'line',
          smooth: true,
          symbolSize: 2,
          showSymbol: false,
          itemStyle: {
            normal: {
              opacity: Math.max.apply(Math, (0, _toConsumableArray3.default)(this.ProjectPerformanceDataList.series[0].data)) == 0 ? 0 : 1,
              color: '#5ebbff',
              lineStyle: {
                color: "#5ebbff",
                width: 2,
                opacity: Math.max.apply(Math, (0, _toConsumableArray3.default)(this.ProjectPerformanceDataList.series[0].data)) == 0 ? 0 : 1
              }
            }
          },
          areaStyle: {
            normal: {
              color: '#e6f5ff'
            }
          },
          data: this.ProjectPerformanceDataList.series[0].data
        }, {
          name: this.ProjectPerformanceDataList.series[1].name,
          type: 'line',
          smooth: true,
          stack: '总量',
          symbolSize: 2,
          showSymbol: false,
          itemStyle: {
            normal: {
              opacity: Math.max.apply(Math, (0, _toConsumableArray3.default)(this.ProjectPerformanceDataList.series[1].data)) == 0 ? 0 : 1,
              color: '#72d8c0',
              lineStyle: {
                color: "#72d8c0",
                width: 2,
                opacity: Math.max.apply(Math, (0, _toConsumableArray3.default)(this.ProjectPerformanceDataList.series[1].data)) == 0 ? 0 : 1
              }
            }
          },
          areaStyle: {
            normal: {
              color: '#cdedf2'
            }
          },
          data: this.ProjectPerformanceDataList.series[1].data
        }]
      };
      this.myChart1.setOption(option);
      window.addEventListener("resize", function () {
        if (_this2.$route.query.identification) {
          var resize = {
            width: _this2.screenWidth - 21
          };
          _this2.myChart1.resize(resize);
        } else {
          _this2.myChart1.resize();
        }
      });
    }
  },
  watch: {
    ProjectPerformanceDataList: function ProjectPerformanceDataList() {
      this.$nextTick(function () {
        var myEvent = new Event('resize');
        window.dispatchEvent(myEvent);
      });
      this.initChart();
    }
  }
};

/***/ }),

/***/ 821:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(31);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _HeadControl = __webpack_require__(43);

var _HeadControl2 = _interopRequireDefault(_HeadControl);

var _Urls = __webpack_require__(12);

var Urls = _interopRequireWildcard(_Urls);

var _VueHelper = __webpack_require__(17);

var _loseDataEcharts = __webpack_require__(1637);

var _loseDataEcharts2 = _interopRequireDefault(_loseDataEcharts);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    loseDataEcharts: _loseDataEcharts2.default,
    HeadControl: _HeadControl2.default
  },
  data: function data() {
    return {
      screenWidth: document.body.clientWidth,
      orgCode: '',
      dataRange: [],
      LoseProjectSourceDataList: '',
      LoseProjectTypeDataList: '',
      LoseProjectPerformanceDataList: '',
      reportList: '',
      legend: ''
    };
  },
  mounted: function mounted() {
    var start = new Date();
    var end = new Date();
    start.setDate(1);
    start.setHours(0);
    start.setSeconds(0);
    start.setMinutes(0);
    start.setTime(start.getTime());
    this.dataRange = [this.$root.formatDay(start), this.$root.formatDay(end)];
    var _this = this;
    window.onresize = function () {
      return function () {
        window.screenWidth = document.body.clientWidth;
        _this.screenWidth = window.screenWidth;
      }();
    };
  },

  methods: {
    init: function init() {
      this.$refs.HeadControl.getDatas('month');
      this.$refs.HeadControl.getSysOrg();
    },
    changeVal: function changeVal(val) {
      this.orgCode = val;
      this.getProjectSourceData();
      this.getProjectTypeData();
      this.getProjectPerformanceData();
    },
    changDate: function changDate(val) {
      this.dataRange = val;
      this.getProjectSourceData();
      this.getProjectTypeData();
      this.getProjectPerformanceData();
    },
    changePicker: function changePicker(val) {
      this.dataRange = val;
      this.getProjectSourceData();
      this.getProjectTypeData();
      this.getProjectPerformanceData();
    },
    getOrgCode: function getOrgCode() {
      this.$refs.HeadControl.getSysOrg();
    },
    getProjectSourceData: function getProjectSourceData() {
      var _this = this;
      var url = Urls.getEchartsLoseReportDataBySource;
      var params = {
        orgCode: this.orgCode,
        startTime: this.dataRange.length ? this.dataRange[0] : '',
        endTime: this.dataRange.length ? this.dataRange[1] : '',
        itemCode: 'LOSEPROJECT-TYPE'
      };
      this.$root.doPost(url, params, function (server_data) {
        if (!_this.$root.isUserLogin(server_data)) {
          return;
        }

        if (server_data.error) {
          _this.$root.showGlobalError(server_data.error);
          return;
        }
        _this.LoseProjectSourceDataList = server_data.data;
      });
    },
    getProjectTypeData: function getProjectTypeData() {
      var _this = this;
      var url = Urls.getEchartsLoseReportDataByType;
      var params = {
        orgCode: this.orgCode,
        startTime: this.dataRange.length ? this.dataRange[0] : '',
        endTime: this.dataRange.length ? this.dataRange[1] : '',
        itemCode: 'LOSEPROJECT-TYPE'
      };
      this.$root.doPost(url, params, function (server_data) {
        if (!_this.$root.isUserLogin(server_data)) {
          return;
        }

        if (server_data.error) {
          _this.$root.showGlobalError(server_data.error);
          return;
        }
        _this.LoseProjectTypeDataList = server_data.data;
      });
    },
    getProjectPerformanceData: function getProjectPerformanceData() {
      var _this = this;
      var url = Urls.getEchartsLoseReportDataByTrend;
      var params = {
        orgCode: this.orgCode,
        startTime: this.dataRange.length ? this.dataRange[0] : '',
        endTime: this.dataRange.length ? this.dataRange[1] : '',
        itemCode: 'LOSEPROJECT-TYPE'
      };
      this.$root.doPost(url, params, function (server_data) {
        if (!_this.$root.isUserLogin(server_data)) {
          return;
        }

        if (server_data.error) {
          _this.$root.showGlobalError(server_data.error);
          return;
        }
        _this.LoseProjectPerformanceDataList = server_data.data;
        _this.reportList = server_data.data.reportList;
        _this.legend = server_data.data.legend;
      });
    },
    initChart: function initChart() {
      var _this2 = this;

      var Chart = this.$echarts.getInstanceByDom(this.$refs.LoseProjectPerformanceEharts);
      if (Chart == null) {
        this.myChart = this.$echarts.init(this.$refs.LoseProjectPerformanceEharts);
      }
      var option = {
        textStyle: {
          fontFamily: 'PingFang-M'
        },
        title: {
          text: '丢单走势',
          top: '24',
          left: this.$route.query.identification ? '20' : '30',
          textStyle: {
            fontWeight: 500
          }
        },
        grid: {
          left: this.$route.query.identification ? '52' : '65',
          right: this.$route.query.identification ? '48' : '50',
          top: this.$route.query.identification ? '100' : '100',
          bottom: this.$route.query.identification ? '25' : '50'
        },
        tooltip: {
          show: true,
          trigger: "axis",
          formatter: function formatter(params) {
            var h = '<div>';
            params.forEach(function (item) {
              if (item.seriesIndex == 0) {
                h += '<div >' + (0, _VueHelper.EchartsformatDate)(item.axisValue) + '</div>\n                                    <div>' + item.marker + item.seriesName + '\uFF1A' + item.value + '\u4E2A</div>\n                                  ';
              } else {
                if (params.length == 1) {
                  h += '<div >' + (0, _VueHelper.EchartsformatDate)(item.axisValue) + '</div>';
                }
                h += '<div>' + item.marker + item.seriesName + '\uFF1A' + item.value + '\u4EBA</div></div>';
              }
            });
            return h;
          },
          axisPointer: {
            lineStyle: {
              color: '#DDDDDD',
              type: 'solid'
            }
          }
        },
        legend: {
          show: true,
          x: this.$route.query.identification ? '140' : '200',
          y: '26',
          icon: 'circle',
          itemGap: 25,
          itemWidth: 8,
          itemHeight: 7,
          textStyle: {
            color: '#666666',
            height: 10,
            rich: {
              a: {
                verticalAlign: 'middle'
              }
            }
          },
          data: this.LoseProjectPerformanceDataList.legend
        },
        xAxis: [{
          type: 'category',
          boundaryGap: 0,
          axisLine: {
            show: Math.max.apply(Math, (0, _toConsumableArray3.default)(this.LoseProjectPerformanceDataList.series[0].data).concat((0, _toConsumableArray3.default)(this.LoseProjectPerformanceDataList.series[1].data))) == 0 ? true : false,
            lineStyle: {
              color: '#DDDDDD'
            }
          },
          axisLabel: {
            show: this.$route.query.identification ? false : true,
            color: '#666666',
            interval: this.screenWidth <= 1366 || (0, _VueHelper.checkDay)(this.dataRange) < 30 ? "auto" : Math.ceil(this.LoseProjectPerformanceDataList.xAxis.data.length / 10),
            padding: [8, 0, 0, 0],
            fontSize: this.screenWidth <= 1366 ? 10 : 12
          },
          splitLine: {
            show: Math.max.apply(Math, (0, _toConsumableArray3.default)(this.LoseProjectPerformanceDataList.series[0].data).concat((0, _toConsumableArray3.default)(this.LoseProjectPerformanceDataList.series[1].data))) == 0 ? false : true,
            lineStyle: {
              color: '#DDDDDD',
              type: 'solid'
            }
          },
          axisTick: {
            show: false
          },

          data: this.LoseProjectPerformanceDataList.xAxis.data
        }],
        yAxis: [{
          type: 'value',
          name: '数量(个)',
          minInterval: 1,
          show: Math.max.apply(Math, (0, _toConsumableArray3.default)(this.LoseProjectPerformanceDataList.series[0].data).concat((0, _toConsumableArray3.default)(this.LoseProjectPerformanceDataList.series[1].data))) == 0 ? false : true,
          splitLine: {
            show: Math.max.apply(Math, (0, _toConsumableArray3.default)(this.LoseProjectPerformanceDataList.series[0].data).concat((0, _toConsumableArray3.default)(this.LoseProjectPerformanceDataList.series[1].data))) == 0 ? false : true,
            lineStyle: {
              color: '#DDDDDD',
              type: 'solid'
            }
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            show: true,

            textStyle: {
              color: '#666666'

            }
          },
          axisTick: {
            show: false
          },

          nameTextStyle: {
            padding: [0, 15, 0, 0],
            color: '#666666'
          }
        }],
        series: [{
          name: this.LoseProjectPerformanceDataList.series[0].name,
          type: 'line',
          smooth: true,
          symbolSize: 5,
          showSymbol: false,
          itemStyle: {
            normal: {
              opacity: Math.max.apply(Math, (0, _toConsumableArray3.default)(this.LoseProjectPerformanceDataList.series[0].data)) == 0 ? 0 : 1,
              color: '#5ebbff',
              lineStyle: {
                color: "#5ebbff",
                width: 2,
                opacity: Math.max.apply(Math, (0, _toConsumableArray3.default)(this.LoseProjectPerformanceDataList.series[0].data)) == 0 ? 0 : 1
              }
            }
          },
          areaStyle: {
            normal: {
              offset: 0.03,
              color: '#e6f5ff'
            }
          },
          data: this.LoseProjectPerformanceDataList.series[0].data
        }, {
          name: this.LoseProjectPerformanceDataList.series[1].name,
          type: 'line',
          smooth: true,
          stack: '总量',
          symbolSize: 5,
          showSymbol: false,
          itemStyle: {
            normal: {
              opacity: Math.max.apply(Math, (0, _toConsumableArray3.default)(this.LoseProjectPerformanceDataList.series[1].data)) == 0 ? 0 : 1,
              color: '#72d8c0',
              lineStyle: {
                color: "#72d8c0",
                width: 2,
                opacity: Math.max.apply(Math, (0, _toConsumableArray3.default)(this.LoseProjectPerformanceDataList.series[1].data)) == 0 ? 0 : 1
              }
            }
          },
          areaStyle: {
            normal: {
              offset: 0.05,
              color: '#cdedf2'
            }
          },
          data: this.LoseProjectPerformanceDataList.series[1].data
        }]
      };
      this.myChart.setOption(option);
      window.addEventListener("resize", function () {
        if (_this2.$route.query.identification) {
          var resize = {
            width: _this2.screenWidth - 21
          };
          _this2.myChart.resize(resize);
        } else {
          _this2.myChart.resize();
        }
      });
    }
  },
  watch: {
    LoseProjectPerformanceDataList: function LoseProjectPerformanceDataList(val) {
      this.$nextTick(function () {
        var myEvent = new Event('resize');
        window.dispatchEvent(myEvent);
      });
      this.initChart();
    }
  },
  screenWidth: function screenWidth() {
    this.initChart();
  }
};

/***/ }),

/***/ 822:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(31);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _VueHelper = __webpack_require__(17);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: ['CustomerDataList', 'natureData', 'IndustryData', 'dataRange'],
  data: function data() {
    return {
      screenWidth: document.body.clientWidth,
      natureDataList: [],
      IndustryDataList: [],
      Juage: '',
      x: 0,
      y: 0,
      showTips: false,
      tipsName: ''
    };
  },

  methods: {
    initChart1: function initChart1() {
      var _this2 = this;

      var chart1 = this.$echarts.getInstanceByDom(this.$refs.engineeringNum);
      if (chart1 == null) {
        this.myChart1 = this.$echarts.init(this.$refs.engineeringNum);
      }
      var option = {
        textStyle: {
          fontFamily: 'PingFang-M'
        },
        title: {
          text: "客户数量",
          top: '24',
          left: this.$route.query.identification ? '20' : '30',
          textStyle: {
            fontWeight: 500
          }
        },
        xAxis: [{
          type: "category",
          boundaryGap: false,
          data: this.CustomerDataList.xAxis.data,
          axisLabel: {
            align: 'center',
            padding: [10, 0, 0, 0],
            show: this.$route.query.identification ? false : true,
            interval: this.screenWidth >= 1366 || (0, _VueHelper.checkDay)(this.dataRange) ? 'auto' : Math.ceil(this.CustomerDataList.xAxis.data.length / 10),
            color: '#666666'
          },
          axisTick: {
            show: false
          },
          splitLine: {
            show: Math.max.apply(Math, (0, _toConsumableArray3.default)(this.CustomerDataList.series[0].data)) == 0 ? false : true,
            lineStyle: {
              color: '#DDDDDD'
            }
          },
          axisLine: {
            show: Math.max.apply(Math, (0, _toConsumableArray3.default)(this.CustomerDataList.series[0].data)) == 0 ? true : false,
            lineStyle: {
              color: '#DDDDDD'
            }
          }
        }],
        yAxis: [{
          type: "value",
          name: '数量(个)',
          minInterval: 1,
          show: Math.max.apply(Math, (0, _toConsumableArray3.default)(this.CustomerDataList.series[0].data)) == 0 ? false : true,
          axisLabel: {
            color: '#666666'
          },
          axisTick: false,
          splitLine: {
            show: Math.max.apply(Math, (0, _toConsumableArray3.default)(this.CustomerDataList.series[0].data)) == 0 ? false : true,
            lineStyle: {
              color: '#DDDDDD',
              type: 'solid'
            }
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#DDDDDD'
            }
          },
          nameTextStyle: {
            padding: [0, 10, 0, 0],
            color: '#666666'
          }
        }],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            lineStyle: {
              color: '#DDDDDD',
              type: 'solid'
            }
          },
          formatter: function formatter(params) {
            var str = '<div style="margin:3px 9px;" >' + (0, _VueHelper.EchartsformatDate)(params[0].axisValue) + '</div>\n                     <div style="margin:3px 10px;">\n                      <div>\u5BA2\u6237\u6570\u91CF\uFF1A' + params[0].data + '\u4E2A</div>\n                     </div>';
            return str;
          }
        },
        series: [{
          data: this.CustomerDataList.series[0].data,
          type: "line",
          smooth: true,
          showSymbol: false,
          symbolSize: 5,
          lineStyle: {
            normal: {
              color: '#6ac1ff',
              opacity: Math.max.apply(Math, (0, _toConsumableArray3.default)(this.CustomerDataList.series[0].data)) == 0 ? false : true
            }
          },
          itemStyle: {
            normal: {
              color: '#6ea6ff',
              opacity: Math.max.apply(Math, (0, _toConsumableArray3.default)(this.CustomerDataList.series[0].data)) == 0 ? false : true
            }
          },
          areaStyle: {
            normal: {
              color: '#e6f5ff'
            }
          }
        }],
        grid: {
          top: this.$route.query.identification ? '100' : "100",
          left: this.$route.query.identification ? '54' : this.screenWidth <= 1366 ? '65' : '65',
          right: this.$route.query.identification ? '48' : "50",
          bottom: this.$route.query.identification ? '25' : "60"
        }
      };
      this.myChart1.setOption(option);
      window.addEventListener("resize", function () {
        if (_this2.$route.query.identification) {
          var resize = {
            width: _this2.screenWidth - 21
          };
          _this2.myChart1.resize(resize);
        } else {
          _this2.myChart1.resize();
        }
      });
    },
    initChart2: function initChart2() {
      var _this3 = this;

      var series = this.natureData.series;

      var chart2 = this.$echarts.getInstanceByDom(this.$refs.Onehistogram);
      if (chart2 == null) {
        this.myChart2 = this.$echarts.init(this.$refs.Onehistogram);
      }
      var option = {
        textStyle: {
          fontFamily: 'PingFang-M'
        },
        title: {
          text: '按性质',
          top: '24',
          left: this.$route.query.identification ? '20' : '30',
          textStyle: {
            fontWeight: 500
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'none'
          },
          formatter: function formatter(params) {
            var str = '<div style="margin:3px 10px;">\u5360\u6BD4\uFF1A' + params[0].value + '%</div>\n                               <div style="margin:3px 10px;">\u4E2A\u6570\uFF1A' + series[0].data[params[0].dataIndex] + '\u4E2A</div>';
            return str;
          }
        },
        grid: {
          left: this.$route.query.identification ? '2' : '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [{
          position: 'top',
          type: 'value',
          boundaryGap: [0, 0.01],
          splitLine: {
            show: true,
            lineStyle: {
              color: '#DDDDDD',
              type: 'dashed'
            }
          },
          axisTick: false,
          axisLine: {
            show: false },
          axisLabel: {
            formatter: '{value}%',
            color: '#666666',
            padding: this.$route.query.identification ? [0, 10, 0, 0] : [0, 0, 0, 0]
          }
        }],
        yAxis: [{
          type: 'category',
          inverse: true,
          axisLabel: {
            formatter: function formatter(val, index) {
              var res = '';
              _this3.natureDataList.forEach(function (item, i) {
                if (i == index) {
                  res = item;
                }
              });
              return val + ('(' + res + '\u4E2A)');
            },
            textStyle: {
              color: '#666666'
            }
          },
          data: this.natureData.yAxis.data,
          splitLine: {
            show: true,
            lineStyle: {
              color: '#DDDDDD',
              type: 'dashed'
            }
          },
          axisTick: false,
          axisLine: {
            show: false }
        }],
        series: [{
          type: 'bar',
          data: this.natureData.series[0].percent,
          barWidth: 20,
          itemStyle: {
            normal: {
              color: '#57b9ff',
              label: {
                show: true,
                position: this.$route.query.identification ? ['0%', '25%'] : 'right',
                textStyle: {
                  color: '#666666'
                },
                formatter: function formatter(value, index) {
                  return value.value + '%';
                }
              }
            }
          }
        }]
      };
      this.myChart2.setOption(option);
      window.addEventListener("resize", function () {
        if (_this3.$route.query.identification) {
          var resize = {
            width: _this3.screenWidth - 21
          };
          _this3.myChart2.resize(resize);
        } else {
          _this3.myChart2.resize();
        }
      });
    },
    initChart3: function initChart3() {
      var _this4 = this;

      var series = this.IndustryData.series;

      var chart3 = this.$echarts.getInstanceByDom(this.$refs.Twohistogram);
      if (chart3 == null) {
        this.myChart3 = this.$echarts.init(this.$refs.Twohistogram);
      }
      var option = {
        textStyle: {
          fontFamily: 'PingFang-M'
        },
        title: {
          show: series[0].data.length ? true : true,
          text: '按行业',
          top: '24',
          left: this.$route.query.identification ? '20' : '30',
          textStyle: {
            fontWeight: 500
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'none'
          },
          formatter: function formatter(params) {
            var str = '<div style="margin:3px 10px;">\u5360\u6BD4\uFF1A' + params[0].data + '%</div>\n                               <div style="margin:3px 10px;">\u4E2A\u6570\uFF1A' + series[0].data[params[0].dataIndex] + '\u4E2A</div>';
            return str;
          }
        },
        legend: {},
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [{
          position: 'top',
          type: 'value',
          boundaryGap: [0, 0.01],
          splitLine: {
            show: true,
            lineStyle: {
              color: '#dddddd',
              type: 'dashed'
            }
          },
          axisTick: false,
          axisLine: {
            show: false },
          axisLabel: {
            formatter: '{value}%',
            color: '#666666',
            padding: this.$route.query.identification ? [0, 10, 0, 0] : [0, 0, 0, 0]
          }
        }],
        yAxis: [{
          type: 'category',
          inverse: true,
          axisLabel: {
            formatter: function formatter(val, index) {
              var res = '';
              _this4.IndustryDataList.forEach(function (item, i) {
                if (i == index) {
                  res = item;
                }
              });
              if (_this4.$route.query.identification == 'pplet' || _this4.screenWidth <= 1366) {
                var params = '';
                if (val.length > 5) {
                  params = val.substr(0, 5) + '...';
                  return params + ('(' + res + '\u4E2A)');
                } else {
                  return val + ('(' + res + '\u4E2A)');
                }
              } else {
                return val + ('(' + res + '\u4E2A)');
              }
            },
            textStyle: {
              color: '#666666'
            }
          },
          data: this.IndustryData.yAxis.data,
          triggerEvent: true,
          splitLine: {
            show: true,
            lineStyle: {
              color: '#dddddd',
              type: 'dashed'
            }
          },
          axisTick: false,
          axisLine: {
            show: false }
        }],
        series: [{
          name: '2011',
          type: 'bar',
          data: this.IndustryData.series[0].percent,
          barWidth: 20,
          itemStyle: {
            normal: {
              color: '#ffb96e',
              label: {
                show: true,
                position: this.$route.query.identification ? ['0%', '25%'] : 'right',
                textStyle: {
                  color: '#666666'
                },
                formatter: function formatter(value) {
                  return value.value + '%';
                }
              }
            }
          }
        }]
      };
      this.myChart3.setOption(option);
      window.addEventListener("resize", function () {
        if (_this4.$route.query.identification) {
          var resize = {
            width: _this4.screenWidth - 21
          };
          _this4.myChart3.resize(resize);
        } else {
          _this4.myChart3.resize();
        }
      });
      this.myChart3.on('mouseover', function (params) {
        if (params.componentType == "yAxis") {
          if (params.event.target.eventData.value.length > 5 && _this4.screenWidth <= 1366) {
            _this4.showTips = true;
            _this4.x = params.event.offsetX + 20;
            _this4.y = params.event.offsetY;
            _this4.tipsName = params.event.target.eventData.value;
          }
        } else {
          _this4.showTips = false;
        }
      });
      this.myChart3.on('mouseout', function (params) {
        _this4.showTips = false;
      });
    }
  },
  mounted: function mounted() {
    var _this = this;
    window.onresize = function () {
      return function () {
        window.screenWidth = document.body.clientWidth;
        _this.screenWidth = window.screenWidth;
      }();
    };
  },

  watch: {
    CustomerDataList: function CustomerDataList(val) {
      this.$nextTick(function () {
        var myEvent = new Event('resize');
        window.dispatchEvent(myEvent);
      });
      this.initChart1();
    },
    natureData: function natureData() {
      this.natureDataList = this.natureData.series[0].data;
      this.$nextTick(function () {
        var myEvent = new Event('resize');
        window.dispatchEvent(myEvent);
      });
      this.initChart2();
    },
    IndustryData: function IndustryData(val) {
      this.IndustryDataList = this.IndustryData.series[0].data;
      this.$nextTick(function () {
        var myEvent = new Event('resize');
        window.dispatchEvent(myEvent);
      });
      this.initChart3();
    }
  }
};

/***/ }),

/***/ 823:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(93);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _toConsumableArray2 = __webpack_require__(31);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _VueHelper = __webpack_require__(17);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: ['EliteNumberDataList', 'CooperationDtaList', 'EliteTypeDataList', 'dataRange'],
  data: function data() {
    return {
      screenWidth: document.body.clientWidth,
      seriesArr: [],
      colors: [['#5bbbff', '#CACACA'], ['#ffb96e', '#CACACA']],
      maxNum: 0,
      maxPercent: 0 };
  },
  mounted: function mounted() {
    var _this = this;
    window.onresize = function () {
      return function () {
        window.screenWidth = document.body.clientWidth + 17;
        _this.screenWidth = window.screenWidth;
      }();
    };
  },

  methods: {
    initChart1: function initChart1() {
      var _this2 = this;

      var chart1 = this.$echarts.getInstanceByDom(this.$refs.threemyChart);
      if (chart1 == null) {
        this.myChart1 = this.$echarts.init(this.$refs.threemyChart);
      }
      var option = {
        textStyle: {
          fontFamily: 'PingFang-M'
        },
        title: {
          text: "精英数量",
          top: '24',
          left: this.$route.query.identification ? '20' : '30',
          textStyle: {
            fontWeight: 500
          }
        },
        xAxis: [{
          type: "category",
          boundaryGap: false,
          data: this.EliteNumberDataList.xAxis.data,
          axisLabel: {
            color: '#666666',
            padding: [10, 0, 0, 0],
            show: this.$route.query.identification ? false : true,
            interval: this.screenWidth <= 1366 || (0, _VueHelper.checkDay)(this.dataRange) < 30 ? 'auto' : Math.ceil(this.EliteNumberDataList.xAxis.data.length / 10)
          },
          axisTick: {
            show: false
          },
          splitLine: {
            show: Math.max.apply(Math, (0, _toConsumableArray3.default)(this.EliteNumberDataList.series[0].data)) == 0 ? false : true,
            lineStyle: {
              color: '#DDDDDD'
            }
          },
          axisLine: {
            show: Math.max.apply(Math, (0, _toConsumableArray3.default)(this.EliteNumberDataList.series[0].data)) == 0 ? true : false,
            lineStyle: {
              color: '#DDDDDD'
            }
          }
        }],
        yAxis: [{
          type: "value",
          name: '数量(人)',
          minInterval: 1,
          axisTick: false,
          show: Math.max.apply(Math, (0, _toConsumableArray3.default)(this.EliteNumberDataList.series[0].data)) == 0 ? false : true,
          splitLine: {
            show: Math.max.apply(Math, (0, _toConsumableArray3.default)(this.EliteNumberDataList.series[0].data)) == 0 ? false : true,
            lineStyle: {
              color: '#DDDDDD',
              type: 'solid'
            }
          },
          axisLabel: {
            color: '#666666'
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#DDDDDD'
            }
          },
          nameTextStyle: {
            align: 'left',
            padding: [0, 23, 0, 5],
            color: '#666666'
          }
        }],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            lineStyle: {
              color: '#DDDDDD',
              type: 'solid'
            }
          },
          formatter: function formatter(params) {
            var str = '<div style="margin:3px 9px;" >' + (0, _VueHelper.EchartsformatDate)(params[0].axisValue) + '</div>\n                     <div style="margin:3px 10px;">\n                      <div>\u7CBE\u82F1\u6570\u91CF\uFF1A' + params[0].data + '\u4EBA</div>\n                     </div>';
            return str;
          }
        },
        series: [{
          data: this.EliteNumberDataList.series[0].data,
          type: "line",
          smooth: true,
          showSymbol: false,
          symbolSize: 5,
          lineStyle: {
            normal: {
              opacity: Math.max.apply(Math, (0, _toConsumableArray3.default)(this.EliteNumberDataList.series[0].data)) == 0 ? false : true,
              color: '#6ac1ff'
            }
          },
          itemStyle: {
            normal: {
              opacity: Math.max.apply(Math, (0, _toConsumableArray3.default)(this.EliteNumberDataList.series[0].data)) == 0 ? false : true,
              color: '#6ea6ff'
            }
          },
          areaStyle: {
            normal: {
              color: '#e6f5ff'
            }
          }
        }],
        grid: {
          top: this.$route.query.identification ? '100' : "100",
          left: this.$route.query.identification ? '54' : this.screenWidth <= 1366 ? '65' : '65',
          right: this.$route.query.identification ? '48' : "50",
          bottom: this.$route.query.identification ? '25' : "60"
        }
      };
      this.myChart1.setOption(option);
      window.addEventListener("resize", function () {
        if (_this2.$route.query.identification) {
          var resize = {
            width: _this2.screenWidth - 21
          };
          _this2.myChart1.resize(resize);
        } else {
          _this2.myChart1.resize();
        }
      });
    },
    initChart2: function initChart2() {
      var _this3 = this;

      var piePercent = '';
      var chart2 = this.$echarts.getInstanceByDom(this.$refs.OnepieChart);
      if (chart2 == null) {
        this.myChart2 = this.$echarts.init(this.$refs.OnepieChart);
      }
      var option = {
        textStyle: {
          fontFamily: 'PingFang-M'
        },
        title: {
          text: '按合作',
          top: '24',
          left: this.$route.query.identification ? '20' : '30',
          textStyle: {
            fontWeight: 500
          }
        },
        color: ["#57B9FF", "#FFB96E", "#E5E5E5"],
        series: [{
          name: this.CooperationDtaList[0].name,
          type: "pie",
          startAngle: 180,
          center: ["25%", "50%"],
          radius: this.$route.query.identification ? ["40%", "44%"] : this.screenWidth <= 1366 ? ["47%", "50%"] : ["50%", "54%"],
          avoidLabelOverlap: false,
          hoverAnimation: false,
          selectedOffset: 0,
          label: {
            normal: {
              show: false,
              position: "center",

              formatter: function formatter(params) {
                piePercent = params.percent.toFixed();
                var str = '{a|' + params.name + '}\n{b|' + params.value + '}{a|\u4E2A}\n{c|' + piePercent + '%}';
                return str;
              },
              textStyle: {
                rich: {
                  a: {
                    color: "#666",
                    fontSize: 14,
                    lineHeight: 25
                  },
                  b: {
                    color: "#333",
                    fontSize: 26,
                    fontWeight: 500,
                    lineHeight: 40
                  },
                  c: {
                    fontSize: 14,
                    lineHeight: 30
                  }
                }
              }
            }
          },
          labelLine: {
            show: false
          },
          data: [{
            value: this.CooperationDtaList[0].value,
            name: this.CooperationDtaList[0].name,
            selected: true,
            label: {
              normal: {
                show: true,
                fontSize: "20",
                color: "#57B9FF"
              }
            }
          }, {
            value: this.CooperationDtaList[0].value === 0 ? 10 : this.CooperationDtaList[1].value,
            name: this.CooperationDtaList[0].name,
            itemStyle: {
              normal: { color: "#e5e5e5" },
              emphasis: { color: "#e5e5e5" }
            }
          }]
        }, {
          name: this.CooperationDtaList[1].name,
          type: "pie",
          startAngle: this.startAngle,

          center: this.$route.query.identification ? ["70%", "50%"] : ["70%", "50%"],
          radius: this.$route.query.identification ? ["40%", "44%"] : this.screenWidth <= 1366 ? ["47%", "50%"] : ["50%", "54%"],
          avoidLabelOverlap: false,
          hoverAnimation: false,
          selectedOffset: 0,
          label: {
            normal: {
              show: false,
              position: "center",
              formatter: function formatter(params) {
                var str = '{a|' + params.name + '}\n{b|' + params.value + '}{a|\u4E2A}\n{c|' + (piePercent == 0 ? 0 : 100 - piePercent) + '%}';
                return str;
              },
              textStyle: {
                rich: {
                  a: {
                    color: "#666",
                    fontSize: 14,
                    lineHeight: 25
                  },
                  b: {
                    color: "#333",
                    fontSize: 26,
                    fontWeight: 500,
                    lineHeight: 40
                  },
                  c: {
                    fontSize: 14,
                    lineHeight: 30
                  }
                }
              }
            }
          },
          labelLine: {
            show: false
          },
          data: [{
            value: this.CooperationDtaList[1].value,
            name: this.CooperationDtaList[1].name,
            selected: true,
            label: {
              normal: {
                show: true,
                fontSize: "20",
                color: "#FFB96E"
              }
            }
          }, {
            value: this.CooperationDtaList[1].value === 0 ? 10 : this.CooperationDtaList[0].value,
            name: this.CooperationDtaList[1].name,
            itemStyle: {
              normal: { color: "#e5e5e5" },
              emphasis: { color: "#e5e5e5" }
            }
          }]
        }]
      };
      this.myChart2.setOption(option);
      window.addEventListener("resize", function () {
        if (_this3.$route.query.identification) {
          var resize = {
            width: _this3.screenWidth - 21
          };
          _this3.myChart2.resize(resize);
        } else {
          _this3.myChart2.resize();
        }
      });
    },
    initChart3: function initChart3() {
      var _this4 = this;

      var chart3 = this.$echarts.getInstanceByDom(this.$refs.Twohistogram);
      if (chart3 == null) {
        this.myChart3 = this.$echarts.init(this.$refs.Twohistogram);
      }
      var option = {
        textStyle: {
          fontFamily: 'PingFang-M'
        },
        title: {
          text: '精英类型',
          top: '24',
          left: this.$route.query.identification ? '20' : '30',
          textStyle: {
            fontWeight: 500
          }
        },
        grid: {
          left: this.$route.query.identification ? '25' : '46',
          right: this.$route.query.identification ? '10%' : this.screenWidth <= 1366 ? '5%' : '3%',
          bottom: '5%',
          top: this.$route.query.identification ? '30%' : '28%',
          containLabel: true
        },
        opacity: 0.1,
        tooltip: {
          trigger: 'axis',
          formatter: function formatter(params) {
            var h = '<div>';
            params.reverse().forEach(function (item) {
              if (item.seriesIndex == 1) {
                h += '<div style="margin:3px 10px;">' + item.axisValue + '\uFF1A' + item.data + '\u4EBA</div>';
              } else {
                h += '<div style="margin:3px 10px;">\u5360\u6BD4\uFF1A' + item.data + '%</div></div>';
              }
            });
            return h;
          }
        },
        legend: {
          data: this.EliteTypeDataList.legend,
          itemWidth: 40,
          itemHeight: 8,
          itemGap: 20,
          left: this.$route.query.identification ? '110' : '180',
          top: '24'
        },
        xAxis: [(0, _defineProperty3.default)({
          type: 'category',
          offset: 5,
          data: this.EliteTypeDataList.xAxis.data,
          axisPointer: {
            type: 'shadow'
          },

          splitLine: {
            show: Math.max.apply(Math, (0, _toConsumableArray3.default)(this.EliteTypeDataList.series[0].data).concat((0, _toConsumableArray3.default)(this.EliteTypeDataList.series[1].data))) == 0 ? false : true,
            lineStyle: {
              color: '#DDDDDD'
            }
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#DDDDDD'
            }
          },
          axisLabel: {
            color: '#666666'
          }
        }, 'axisPointer', {
          type: 'none'
        })],
        yAxis: [{
          offset: 5,
          type: 'value',
          show: Math.max.apply(Math, (0, _toConsumableArray3.default)(this.EliteTypeDataList.series[0].data)) == 0 ? false : true,
          name: '百分比',
          min: 0,
          max: this.maxPercent,
          splitNumber: 5,
          interval: this.maxPercent / 5,
          axisLabel: {
            formatter: '{value}%',
            color: '#666666'
          },

          splitLine: {
            show: true,
            lineStyle: {
              color: '#DDDDDD'
            }
          },

          nameTextStyle: {
            color: '#666666',
            padding: this.$route.query.identification ? [0, 35, 0, 0] : [0, 48, 0, 0]
          },
          axisTick: false,
          axisLine: {
            show: false }
        }, {
          type: 'value',
          name: '数量(人)',
          show: Math.max.apply(Math, (0, _toConsumableArray3.default)(this.EliteTypeDataList.series[1].data)) == 0 ? false : true,
          min: 0,
          max: this.maxNum,

          splitNumber: 5,
          interval: this.maxNum / 5,
          axisLabel: {
            formatter: function formatter(value) {
              return parseInt(value) + '个';
            },
            textStyle: {
              color: '#666666'
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#DDDDDD'
            }
          },

          nameTextStyle: {
            color: '#666666',
            padding: [0, 0, 0, 35]
          },
          axisTick: false,
          axisLine: {
            show: false }
        }],
        series: [{
          name: this.EliteTypeDataList.series[0].name,
          type: 'bar',
          barWidth: this.$route.query.identification ? 50 : 80,
          data: this.EliteTypeDataList.series[0].data,
          itemStyle: {
            normal: {
              color: 'rgba(87,185,255,0.35)',
              borderColor: Math.max.apply(Math, (0, _toConsumableArray3.default)(this.EliteTypeDataList.series[0].data)) == 0 ? 'rgba(87,185,255,0)' : 'rgba(87,185,255,1)'
            }
          },
          yAxisIndex: 0
        }, {
          name: this.EliteTypeDataList.series[1].name,
          type: 'line',
          symbol: 'rect',
          symbolSize: 9,
          hoverAnimation: false,
          data: this.EliteTypeDataList.series[1].data,
          itemStyle: {
            normal: {
              color: '#72d8c0',
              opacity: Math.max.apply(Math, (0, _toConsumableArray3.default)(this.EliteTypeDataList.series[1].data)) == 0 ? 0 : 1
            },
            emphasis: {
              borderWidth: 3,
              borderColor: '#61d9ac',
              color: '#61d9ac'
            }
          },
          lineStyle: {
            normal: {
              opacity: Math.max.apply(Math, (0, _toConsumableArray3.default)(this.EliteTypeDataList.series[1].data)) == 0 ? 0 : 1
            }
          },
          yAxisIndex: 1
        }]
      };
      this.myChart3.setOption(option);
      window.addEventListener("resize", function () {
        if (_this4.$route.query.identification) {
          var resize = {
            width: _this4.screenWidth - 21
          };
          _this4.myChart3.resize(resize);
        } else {
          _this4.myChart3.resize();
        }
      });
    }
  },
  watch: {
    EliteNumberDataList: function EliteNumberDataList(val) {
      this.$nextTick(function () {
        var myEvent = new Event('resize');
        window.dispatchEvent(myEvent);
      });
      this.initChart1();
    },
    CooperationDtaList: function CooperationDtaList(val) {
      this.$nextTick(function () {
        var myEvent = new Event('resize');
        window.dispatchEvent(myEvent);
      });
      this.initChart2();
    },
    EliteTypeDataList: function EliteTypeDataList(val) {
      this.maxNum = Math.ceil(Math.max.apply(Math, (0, _toConsumableArray3.default)(val.series[1].data)) / 10) * 10;
      this.maxPercent = Math.ceil(Math.max.apply(Math, (0, _toConsumableArray3.default)(val.series[0].data)) / 10) * 10;
      this.$nextTick(function () {
        var myEvent = new Event('resize');
        window.dispatchEvent(myEvent);
      });
      this.initChart3();
    }
  },
  computed: {
    startAngle: function startAngle() {
      var total = this.CooperationDtaList[0].value + this.CooperationDtaList[1].value;
      if (total === 0) {
        return 180;
      } else {
        var res = this.CooperationDtaList[0].value / total * 360;
        if (res > 180) {
          return 360 + (180 - res);
        } else {
          return 180 - res;
        }
      }
    }
  }
};

/***/ }),

/***/ 824:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _VueHelper = __webpack_require__(17);

exports.default = {
  props: ['ProjectSourceDataList', 'ProjectTypeDataList', 'screenWidth'],
  data: function data() {
    return {
      ProgressData: '',
      progressLsit: [],
      Judge: '',
      PieprojectArr: []
    };
  },
  mounted: function mounted() {},

  methods: {
    initChart2: function initChart2() {
      var _this = this;

      var Chart1 = this.$echarts.getInstanceByDom(this.$refs.progressEcharts);
      if (Chart1 == null) {
        this.myChart1 = this.$echarts.init(this.$refs.progressEcharts);
      }
      var option = {
        textStyle: {
          fontFamily: 'PingFang-M'
        },
        title: {
          text: '项目来源',
          top: '24',
          left: this.$route.query.identification ? '20' : '30',
          textStyle: {
            fontWeight: 500
          }
        },
        tooltip: {
          show: true,
          trigger: 'item',
          formatter: function formatter(params) {
            var string = '<div style="padding:4px;">\n                              <div>' + params.name + '\uFF1A' + _this.ProgressData[params.dataIndex] + '\u4E2A</div>\n                              <div>\u5360\u6BD4\uFF1A' + params.value + '%</div>\n                            </div>\n                          ';
            return string;
          }
        },
        grid: {
          left: this.$route.query.identification ? '25' : '40',
          right: this.$route.query.identification ? '15' : '46',
          bottom: this.$route.query.identification ? '18' : '35',
          top: this.$route.query.identification ? '55' : '55'
        },
        xAxis: {
          show: false,
          type: 'value'
        },
        yAxis: [{
          type: 'category',
          inverse: true,
          axisLabel: {
            formatter: function formatter(val, index) {
              var res = '';
              _this.ProgressData.forEach(function (item, i) {
                if (i == index) {
                  res = item;
                }
              });
              return val + ('\uFF08' + res + '\u4E2A\uFF09');
            },
            textStyle: {
              color: '#666666',
              fontSize: '14',
              lineHeight: 20
            },
            padding: [0, 0, 35, 10],
            align: 'left',
            rich: {}
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          data: this.ProjectSourceDataList.yAxis.data
        }, {
          type: 'category',
          inverse: true,
          axisTick: 'none',
          axisLine: 'none',
          position: 'left',
          show: true,
          axisLabel: {
            textStyle: {
              color: '#57b9ff',
              fontSize: '14'
            },
            padding: [0, 0, -45, 10],
            formatter: '{value}%',
            align: 'left',
            rich: {}
          },
          data: this.ProjectSourceDataList.series[0].percent
        }],
        series: [{
          type: 'bar',
          zlevel: 1,
          itemStyle: {
            normal: {
              barBorderRadius: 10,
              color: '#57b9ff'
            }
          },
          barWidth: 10,
          data: this.ProjectSourceDataList.series[0].percent
        }, {
          type: 'bar',
          silent: true,
          barWidth: 10,
          barGap: '-100%',
          data: this.progressLsit,
          itemStyle: {
            normal: {
              color: '#eeeeee',
              barBorderRadius: 10
            }
          }
        }]
      };
      this.myChart1.setOption(option);
      window.addEventListener("resize", function () {
        if (_this.$route.query.identification) {
          var resize = {
            width: _this.screenWidth - 21
          };
          _this.myChart1.resize(resize);
        } else {
          _this.myChart1.resize();
        }
      });
    },
    initChart3: function initChart3() {
      var _this2 = this;

      var JudgeConditions = this.$route.query.identification;
      var Chart2 = this.$echarts.getInstanceByDom(this.$refs.PieEcharts);
      if (Chart2 == null) {
        this.myChart2 = this.$echarts.init(this.$refs.PieEcharts);
      }
      var option = {
        textStyle: {
          fontFamily: 'PingFang-M'
        },
        title: {
          text: '项目类型',
          top: '24',
          left: this.$route.query.identification ? '20' : '30',
          textStyle: {
            fontWeight: 500
          }
        },
        tooltip: {
          show: this.$route.query.identification ? true : this.screenWidth <= 1366 ? true : false,
          trigger: 'item',
          formatter: function formatter(params) {
            return '<div style="font-size:14px; padding:4px;">\n                                  <div>' + params.name + '\uFF1A' + params.data.value + '\u4E2A</div>\n                                  <div>\u5360\u6BD4\uFF1A' + params.data.percent + '%</div>\n                              </div>';
          }
        },
        color: ["#59b9fe", "#62d8ae", "#ffb971"],
        legend: {
          orient: this.$route.query.identification ? "horizontal" : "vertical",
          x: this.$route.query.identification ? '120' : '35',
          y: this.$route.query.identification ? '24' : '70',
          itemGap: this.$route.query.identification ? 30 : 14,
          itemWidth: 10,
          itemHeight: 11,
          data: this.ProjectTypeDataList,
          formatter: function formatter(name) {
            return '{a|' + name + '}';
          },
          textStyle: {
            color: '#666666',
            height: 10,
            rich: {
              a: {
                lineHeight: 14
              }
            }
          }
        },
        series: [{
          name: '项目类型',
          type: 'pie',
          stillShowZeroSum: false,
          radius: this.$route.query.identification ? ['40%', '60%'] : this.screenWidth <= 1366 ? ['40%', '60%'] : ['45%', '60%'],
          center: this.$route.query.identification ? ['50%', '55%'] : this.screenWidth <= 1366 ? ['55%', '50%'] : ['50%', '50%'],
          silent: this.$route.query.identification ? false : this.screenWidth <= 1366 ? false : true,
          itemStyle: {
            align: 'left',
            normal: {
              borderWidthLeft: this.$route.query.identification ? 'none' : this.screenWidth <= 1366 ? 'none' : 1,
              borderColor: this.$route.query.identification ? 'none' : this.screenWidth <= 1366 ? 'none' : '#fff',
              label: {
                show: this.Judge ? false : true,
                align: 'left',
                position: this.$route.query.identification ? 'inside' : this.screenWidth <= 1366 ? 'inside' : 'outside',
                padding: [15, 0, 0, 0],
                fontSize: this.$route.query.identification ? 15 : 12,
                formatter: function formatter(params) {
                  if (JudgeConditions == 'pplet' || _this2.screenWidth <= 1366) {
                    return params.data.percent == 0 ? '' : params.data.percent + '%';
                  } else {
                    return '{left|\n' + params.data.name + '\uFF1A' + params.data.value + '\u4E2A\n\u5360\u6BD4\uFF1A' + params.data.percent + '%\n}';
                  }
                },
                rich: {
                  left: {
                    align: 'left',
                    lineHeight: 15,
                    color: '#666666'
                  }
                }
              }
            }

          },
          labelLine: {
            normal: {
              show: this.Judge ? false : true,
              length: this.$route.query.identification ? 5 : this.screenWidth <= 1366 ? 10 : 20,
              length2: this.$route.query.identification ? 20 : this.screenWidth <= 1366 ? 30 : 45
            }
          },
          data: this.ProjectTypeDataList
        }]
      };
      this.myChart2.setOption(option);
      window.addEventListener("resize", function () {
        if (_this2.$route.query.identification) {
          var resize = {
            width: _this2.screenWidth - 21
          };
          _this2.myChart2.resize(resize);
        } else {
          _this2.myChart2.resize();
        }
      });
    }
  },
  watch: {
    ProjectSourceDataList: function ProjectSourceDataList(val) {

      for (var i = 0; i < val.series[0].data.length; i++) {
        this.progressLsit.push(100);
      }
      this.ProgressData = val.series[0].data;
      this.$nextTick(function () {
        var myEvent = new Event('resize');
        window.dispatchEvent(myEvent);
      });
      this.initChart2();
    },
    ProjectTypeDataList: function ProjectTypeDataList(val) {
      var res = val.every(function (item) {
        if (item.value == 0) return true;else false;
      });
      this.Judge = res;
      this.$nextTick(function () {
        var myEvent = new Event('resize');
        window.dispatchEvent(myEvent);
      });
      this.initChart3();
    }
  }
};

/***/ }),

/***/ 825:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: ['LoseProjectSourceDataList', 'LoseProjectTypeDataList', 'screenWidth'],
  data: function data() {
    return {
      ProgressData: '',
      progressLsit: [],
      Judge: ''
    };
  },
  mounted: function mounted() {},

  methods: {
    initChart2: function initChart2() {
      var _this = this;

      var Chart1 = this.$echarts.getInstanceByDom(this.$refs.progressEcharts);
      if (Chart1 == null) {
        this.myChart1 = this.$echarts.init(this.$refs.progressEcharts);
      }
      var option = {
        textStyle: {
          fontFamily: 'PingFang-M'
        },
        title: {
          text: '项目来源',
          top: '24',
          left: this.$route.query.identification ? '20' : '30',
          textStyle: {
            fontWeight: 500
          }
        },
        tooltip: {
          show: true,
          trigger: 'item',
          formatter: function formatter(params) {
            var string = '<div style="padding:4px;">\n                              <div>' + params.name + '\uFF1A' + _this.ProgressData[params.dataIndex] + '\u4E2A</div>\n                              <div>\u5360\u6BD4\uFF1A' + params.value + '%</div>\n                            </div>\n                          ';
            return string;
          }
        },
        grid: {
          left: this.$route.query.identification ? '25' : '40',
          right: this.$route.query.identification ? '15' : '46',
          bottom: this.$route.query.identification ? '18' : '35',
          top: this.$route.query.identification ? '55' : '55'
        },
        xAxis: {
          show: false,
          type: 'value'
        },
        yAxis: [{
          type: 'category',
          inverse: true,
          axisLabel: {
            formatter: function formatter(val, index) {
              var res = '';
              _this.ProgressData.forEach(function (item, i) {
                if (i == index) {
                  res = item;
                }
              });
              return val + ('\uFF08' + res + '\u4E2A\uFF09');
            },
            textStyle: {
              color: '#666666',
              fontSize: '14',
              lineHeight: 20
            },
            padding: [0, 0, 35, 10],
            align: 'left',
            rich: {}
          },
          splitLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          data: this.LoseProjectSourceDataList.yAxis.data
        }, {
          type: 'category',
          inverse: true,
          axisTick: 'none',
          axisLine: 'none',
          position: 'left',
          show: true,
          axisLabel: {
            textStyle: {
              color: '#57b9ff',
              fontSize: '14'
            },
            padding: [0, 0, -45, 10],
            formatter: '{value}%',
            align: 'left',
            rich: {}
          },
          data: this.LoseProjectSourceDataList.series[0].percent
        }],
        series: [{
          type: 'bar',
          zlevel: 1,
          itemStyle: {
            normal: {
              barBorderRadius: 10,
              color: '#57b9ff'
            }
          },
          barWidth: 10,
          data: this.LoseProjectSourceDataList.series[0].percent
        }, {
          name: '背景',
          type: 'bar',
          silent: true,
          barWidth: 10,
          barGap: '-100%',
          data: this.progressLsit,
          itemStyle: {
            normal: {
              color: '#eeeeee',
              barBorderRadius: 10
            }
          }
        }]
      };
      this.myChart1.setOption(option);
      window.addEventListener("resize", function () {
        if (_this.$route.query.identification) {
          var resize = {
            width: _this.screenWidth - 21
          };
          _this.myChart1.resize(resize);
        } else {
          _this.myChart1.resize();
        }
      });
    },
    initChart3: function initChart3() {
      var _this2 = this;

      var JudgeConditions = this.$route.query.identification;
      var Chart2 = this.$echarts.getInstanceByDom(this.$refs.PieEcharts);
      if (Chart2 == null) {
        this.myChart2 = this.$echarts.init(this.$refs.PieEcharts);
      }
      var option = {
        textStyle: {
          fontFamily: 'PingFang-M'
        },
        title: {
          text: '项目类型',
          top: '24',
          left: this.$route.query.identification ? '20' : '30',
          textStyle: {
            fontWeight: 500
          }
        },
        tooltip: {
          show: this.$route.query.identification ? true : this.screenWidth <= 1366 ? true : false,
          trigger: 'item',
          formatter: function formatter(params) {
            return '<div style="font-size:14px; padding:4px;">\n                                  <div>' + params.name + '\uFF1A' + params.data.value + '\u4E2A</div>\n                                  <div>\u5360\u6BD4\uFF1A' + params.data.percent + '%</div>\n                              </div>';
          }
        },
        color: ["#59b9fe", "#62d8ae", "#ffb971"],
        legend: {
          orient: this.$route.query.identification ? "horizontal" : "vertical",
          x: this.$route.query.identification ? '120' : '35',
          y: this.$route.query.identification ? '24' : '70',
          itemGap: this.$route.query.identification ? 30 : 14,
          itemWidth: 10,
          itemHeight: 11,
          data: this.LoseProjectTypeDataList,
          formatter: function formatter(name) {
            return name;
          },
          textStyle: {
            color: '#646464',
            height: 10,
            rich: {
              a: {
                verticalAlign: 'middle'
              }
            }
          }
        },
        series: [{
          name: '项目类型',
          type: 'pie',
          stillShowZeroSum: false,
          radius: this.$route.query.identification ? ['40%', '60%'] : this.screenWidth <= 1366 ? ['40%', '60%'] : ['45%', '60%'],
          center: this.$route.query.identification ? ['50%', '55%'] : this.screenWidth <= 1366 ? ['55%', '50%'] : ['50%', '50%'],
          silent: this.$route.query.identification ? false : this.screenWidth <= 1366 ? false : true,
          itemStyle: {
            align: 'left',
            normal: {
              borderWidthLeft: this.$route.query.identification ? 'none' : this.screenWidth <= 1366 ? 'none' : 1,
              borderColor: this.$route.query.identification ? 'none' : this.screenWidth <= 1366 ? 'none' : '#fff',
              label: {
                show: this.Judge ? false : true,
                align: 'left',
                position: this.$route.query.identification ? 'inside' : this.screenWidth <= 1366 ? 'inside' : 'outside',
                padding: [15, 0, 0, 0],
                fontSize: this.$route.query.identification ? 15 : 12,
                formatter: function formatter(params) {
                  if (JudgeConditions == 'pplet' || _this2.screenWidth <= 1366) {
                    return params.data.percent == 0 ? '' : params.data.percent + '%';
                  } else {
                    return '{left|\n' + params.data.name + '\uFF1A' + params.data.value + '\u4E2A\n\u5360\u6BD4\uFF1A' + params.data.percent + '%\n}';
                  }
                },
                rich: {
                  left: {
                    align: 'left',
                    lineHeight: 15,
                    color: '#666666'
                  }
                }
              }
            }

          },
          labelLine: {
            normal: {
              show: this.Judge ? false : true,
              length: this.$route.query.identification ? 5 : this.screenWidth <= 1366 ? 10 : 20,
              length2: this.$route.query.identification ? 20 : this.screenWidth <= 1366 ? 30 : 45
            }
          },
          data: this.LoseProjectTypeDataList
        }]
      };
      this.myChart2.setOption(option);
      window.addEventListener("resize", function () {
        if (_this2.$route.query.identification) {
          var resize = {
            width: _this2.screenWidth - 21
          };
          _this2.myChart2.resize(resize);
        } else {
          _this2.myChart2.resize();
        }
      });
    }
  },
  watch: {
    LoseProjectSourceDataList: function LoseProjectSourceDataList(val) {
      for (var i = 0; i < val.series[0].data.length; i++) {
        this.progressLsit.push(100);
      }
      this.ProgressData = val.series[0].data;
      this.$nextTick(function () {
        var myEvent = new Event('resize');
        window.dispatchEvent(myEvent);
      });
      this.initChart2();
    },
    LoseProjectTypeDataList: function LoseProjectTypeDataList(val) {
      var res = val.every(function (item) {
        if (item.value == 0) return true;
      });
      this.Judge = res;
      this.$nextTick(function () {
        var myEvent = new Event('resize');
        window.dispatchEvent(myEvent);
      });
      this.initChart3();
    }
  }
};

/***/ }),

/***/ 826:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(93);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _toConsumableArray2 = __webpack_require__(31);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _VueHelper = __webpack_require__(17);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ['ProjectTypeList', 'PieprojectTypeList', 'CooperationTypeList', 'ProjectLevelList', 'RankingProjectAmountList', 'DirectorRankingList', 'ProjectAreaList', 'screenWidth'],
    data: function data() {
        return {
            progressLsit: [],
            Judge: '',
            CooperationTypeJudge: '',
            CopperationArr: [],
            PieprojectArr: [],
            x: 0,
            y: 0,
            ClickText: '',
            TextShow: false,
            actived: 0,
            activeProjectName: 'AMOUNT'
        };
    },

    methods: {
        handleClick: function handleClick(type) {
            if (type !== this.activeProjectName) {
                this.activeProjectName = type;
                this.$emit('getDirectorRanking', this.activeProjectName);
            }
        },
        AmountFormat: function AmountFormat(val) {
            return (0, _VueHelper.amountFormat)(val);
        },
        initChart2: function initChart2() {
            var _this = this;

            var _ProjectTypeList = this.ProjectTypeList,
                series = _ProjectTypeList.series,
                yAxis = _ProjectTypeList.yAxis;

            var chart2 = this.$echarts.getInstanceByDom(this.$refs.progressBar);
            if (chart2 == null) {
                this.myChart2 = this.$echarts.init(this.$refs.progressBar);
            }
            var option = {
                textStyle: {
                    fontFamily: 'PingFang-M'
                },
                title: {
                    text: '工程类型',
                    top: '24',
                    left: this.$route.query.identification ? '20' : '30',
                    textStyle: {
                        fontWeight: 500
                    }
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    },
                    formatter: function formatter(params) {
                        var str = '\n                                <div style="margin:3px 10px;">\u91D1\u989D\uFF1A' + (0, _VueHelper.amountFormat)(series[0].money[params[0].dataIndex]) + '\u5143</div>\n                                <div style="margin:3px 10px;">\u5360\u6BD4\uFF1A' + params[0].value + '%</div>\n                                <div style="margin:3px 10px;">\u4E2A\u6570\uFF1A' + series[0].data[params[0].dataIndex] + '\u4E2A</div>\n                                ';
                        return str;
                    }
                },
                grid: {
                    left: this.$route.query.identification ? '2' : '3%',
                    right: this.$route.query.identification ? '10%' : '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: [{
                    position: 'top',
                    type: 'value',
                    min: 0,
                    max: this.$route.query.identification ? Math.ceil(Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].percent)) / 10) * 10 : 100,
                    splitNumber: this.$route.query.identification ? 5 : 10,

                    boundaryGap: [0, 0.01],
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: '#DDDDDD',
                            type: 'dashed'
                        }
                    },
                    axisTick: false,
                    axisLine: {
                        show: false },
                    axisLabel: {
                        interval: 1,
                        formatter: '{value}%'
                    }
                }],
                yAxis: [{
                    type: 'category',
                    inverse: true,
                    axisLabel: {
                        formatter: function formatter(val, index) {
                            var res = '';
                            series[0].data.forEach(function (item, i) {
                                if (i == index) {
                                    res = item;
                                }
                            });
                            return val + ('(' + res + '\u4E2A)');
                        }
                    },
                    data: yAxis.data,
                    splitLine: {
                        show: false,
                        lineStyle: {
                            color: '#DDDDDD',
                            type: 'dashed'
                        }
                    },
                    axisTick: false,
                    axisLine: {
                        show: false },
                    axisPointer: {
                        type: 'none'
                    }
                }],
                series: [{
                    type: 'bar',
                    data: series[0].percent,
                    barWidth: 20,
                    itemStyle: {
                        normal: {
                            color: '#57b9ff',
                            label: {
                                show: true,
                                position: ["0%", "25%"],
                                textStyle: {
                                    color: '#666666'
                                },
                                formatter: function formatter(value) {
                                    return value.value + ' % \uFF08' + (0, _VueHelper.amountFormat)(series[0].money[value.dataIndex]) + '\u5143\uFF09 ';
                                }
                            }
                        }
                    }
                }, {
                    type: 'bar',
                    barWidth: 20,
                    silent: true,
                    zlevel: -1,
                    barGap: '-100%',
                    data: this.progressLsit,
                    itemStyle: {
                        normal: {
                            color: '#eeeeee'
                        }
                    }
                }]
            };
            this.myChart2.setOption(option);
            window.addEventListener("resize", function () {
                if (_this.$route.query.identification) {
                    var resize = {
                        width: _this.screenWidth - 21
                    };
                    _this.myChart2.resize(resize);
                } else {
                    _this.myChart2.resize();
                }
            });
        },
        initChart3: function initChart3() {
            var _this2 = this;

            var PieprojectArrList = this.PieprojectTypeList;
            var JudgeConditions = this.$route.query.identification;
            var Chart3 = this.$echarts.getInstanceByDom(this.$refs.pieOne);
            if (Chart3 == null) {
                this.myChart3 = this.$echarts.init(this.$refs.pieOne);
            }
            var option = {
                textStyle: {
                    fontFamily: 'PingFang-M'
                },
                title: {
                    text: "项目类型",
                    top: '24',
                    left: this.$route.query.identification ? '20' : '30',
                    textStyle: {
                        fontWeight: 500
                    }
                },
                tooltip: {
                    show: JudgeConditions ? true : this.screenWidth <= 1366 ? true : this.screenWidth == 1536 ? true : false,
                    trigger: 'item',
                    formatter: function formatter(params) {
                        return '<div style="font-size:10px;">\n                <div>' + params.data.name + '\uFF1A' + (0, _VueHelper.amountFormat)(PieprojectArrList[params.dataIndex].money) + '\u5143</div>\n                <div>\u5360\u6BD4\uFF1A' + params.data.value + '%</div>\n                <div>\u6570\u91CF\uFF1A' + PieprojectArrList[params.dataIndex].value + '\u4E2A</div>\n            </div>';
                    }
                },
                color: ["#59b9fe", "#62d8ae", "#ffb971"],
                legend: {
                    orient: this.$route.query.identification ? "horizontal" : "vertical",
                    x: this.$route.query.identification ? '120' : "35",
                    y: this.$route.query.identification ? "24" : '70',
                    itemGap: this.$route.query.identification ? 30 : 14,
                    itemWidth: 10,
                    itemHeight: 11,
                    data: this.PieprojectTypeList,
                    formatter: function formatter(name) {
                        return '{a|' + name + '}';
                    },
                    textStyle: {
                        fontSize: '13',
                        height: 10,
                        rich: {
                            a: {
                                lineHeight: 14
                            }
                        }
                    }
                },
                series: [{
                    name: "项目类型",
                    type: "pie",
                    stillShowZeroSum: false,
                    radius: JudgeConditions ? ['45%', '70%'] : this.screenWidth <= 1366 ? ['40%', '60%'] : this.screenWidth == 1536 ? ['40%', '60%'] : ['45%', '60%'],
                    center: JudgeConditions ? ['50%', '58%'] : this.screenWidth <= 1366 ? ['55%', '55%'] : this.screenWidth == 1536 ? ['55%', '55%'] : ['55%', '57%'],
                    silent: this.$route.query.identification ? false : this.screenWidth <= 1366 ? false : this.screenWidth == 1536 ? false : true,
                    itemStyle: {
                        align: "left",
                        normal: {
                            borderWidthLeft: this.$route.query.identification ? 'none' : this.screenWidth <= 1366 ? 'none' : this.screenWidth == 1536 ? 'none' : 1,
                            borderColor: this.$route.query.identification ? 'none' : this.screenWidth <= 1366 ? 'none' : this.screenWidth == 1536 ? 'none' : '#fff',

                            label: {
                                position: this.$route.query.identification ? 'inside' : this.screenWidth <= 1366 ? 'inside' : this.screenWidth == 1536 ? 'inside' : 'outside',
                                show: this.Judge ? false : true,
                                align: "left",
                                padding: JudgeConditions ? [0, 0, 0, 0] : this.screenWidth <= 1366 ? [0, 0, 0, 0] : this.screenWidth == 1536 ? [0, 0, 0, 0] : [25, 0, 0, 0],
                                color: "#fff",
                                fontSize: this.$route.query.identification ? 15 : 12,
                                formatter: function formatter(params) {
                                    if (JudgeConditions == 'pplet' || _this2.screenWidth <= 1366 || _this2.screenWidth == 1536) {
                                        return params.data.value == 0 ? '' : params.data.value + '%';
                                    } else {
                                        return '{left|\n' + params.data.name + '\uFF1A' + (0, _VueHelper.amountFormat)(PieprojectArrList[params.dataIndex].money) + '\u5143\n\u5360\u6BD4\uFF1A' + params.data.value + '%\n\u6570\u91CF\uFF1A' + PieprojectArrList[params.dataIndex].value + '\u4E2A\n}';
                                    }
                                },
                                rich: {
                                    left: {
                                        align: "left",
                                        lineHeight: this.$route.query.identification ? 5 : this.screenWidth <= 1366 ? 10 : this.screenWidth == 1536 ? 10 : 20,
                                        color: "#666666"
                                    }
                                }
                            }
                        }
                    },
                    labelLine: {
                        normal: {
                            show: this.Judge ? false : true,
                            length: 20,
                            length2: 25
                        }
                    },
                    data: this.PieprojectArr
                }]
            };
            this.myChart3.setOption(option);
            window.addEventListener("resize", function () {
                if (_this2.$route.query.identification) {
                    var resize = {
                        width: _this2.screenWidth - 21
                    };
                    _this2.myChart3.resize(resize);
                } else {
                    _this2.myChart3.resize();
                }
            });
        },
        initChart4: function initChart4() {
            var _this3 = this;

            var CopperationArrList = this.CooperationTypeList;
            var Chart4 = this.$echarts.getInstanceByDom(this.$refs.pieTwo);
            if (Chart4 == null) {
                this.myChart4 = this.$echarts.init(this.$refs.pieTwo);
            }
            var option = {
                textStyle: {
                    fontFamily: 'PingFang-M'
                },
                title: {
                    text: "合作类型",
                    top: '24',
                    left: this.$route.query.identification ? '20' : '30',
                    textStyle: {
                        fontWeight: 500
                    }
                },
                tooltip: {
                    show: this.$route.query.identification ? true : this.screenWidth <= 1366 ? true : this.screenWidth == 1536 ? true : false,
                    trigger: 'item',
                    formatter: function formatter(params) {
                        return '<div style="font-size:12px; padding:2px;">\n                <div>' + params.data.name + '\uFF1A' + (0, _VueHelper.amountFormat)(CopperationArrList[params.dataIndex].money) + '\u5143</div>\n                <div>\u5360\u6BD4\uFF1A' + params.data.value + '%</div>\n                <div>\u6570\u91CF\uFF1A' + CopperationArrList[params.dataIndex].value + '\u4E2A</div>\n            </div>';
                    }
                },
                color: ["#59b9fe", "#62d8ae", "#ffb971"],
                legend: {
                    orient: this.$route.query.identification ? "horizontal" : "vertical",
                    x: this.$route.query.identification ? '120' : "35",
                    y: this.$route.query.identification ? "24" : '70',
                    itemGap: this.$route.query.identification ? 30 : 14,
                    itemWidth: 10,
                    itemHeight: 11,
                    data: this.CooperationTypeList,
                    formatter: function formatter(name) {
                        return '{a|' + name + '}';
                    },
                    textStyle: {
                        fontSize: '13',
                        height: 10,
                        rich: {
                            a: {
                                lineHeight: 14
                            }
                        }
                    }
                },
                series: [{
                    name: "项目类型",
                    type: "pie",
                    stillShowZeroSum: false,
                    radius: this.$route.query.identification ? ['45%', '70%'] : this.screenWidth <= 1366 ? ['0%', '60%'] : ['0%', '60%'],
                    center: this.$route.query.identification ? ['50%', '58%'] : this.screenWidth <= 1366 ? ['55%', '55%'] : ['50%', '55%'],
                    silent: this.$route.query.identification ? false : this.screenWidth <= 1366 ? false : this.screenWidth == 1536 ? false : true,
                    itemStyle: {
                        align: "left",
                        normal: {
                            borderWidthLeft: this.$route.query.identification ? 'none' : this.screenWidth <= 1366 ? 'none' : this.screenWidth == 1536 ? 'none' : 1,
                            borderColor: this.$route.query.identification ? 'none' : this.screenWidth <= 1366 ? 'none' : this.screenWidth == 1536 ? 'none' : '#fff',
                            label: {
                                show: this.CooperationTypeJudge ? false : true,
                                align: "left",
                                position: this.$route.query.identification ? 'inside' : this.screenWidth <= 1366 ? 'inside' : this.screenWidth == 1536 ? 'inside' : 'outside',
                                padding: this.$route.query.identification ? [0, 0, 0, 0] : this.screenWidth <= 1366 ? [0, 0, 0, 0] : this.screenWidth == 1536 ? [0, 0, 0, 0] : [25, 0, 0, 0],
                                color: "#fff",
                                formatter: function formatter(params) {
                                    if (_this3.$route.query.identification == 'pplet' || _this3.screenWidth <= 1366 || _this3.screenWidth == 1536) {
                                        return params.data.value == 0 ? '' : params.data.value + '%';
                                    } else {
                                        return '{left|\n' + params.data.name + '\uFF1A' + (0, _VueHelper.amountFormat)(CopperationArrList[params.dataIndex].money) + '\u5143\n\u5360\u6BD4\uFF1A' + params.data.value + '%\n\u6570\u91CF\uFF1A' + CopperationArrList[params.dataIndex].value + '\u4E2A\n}';
                                    }
                                },
                                rich: {
                                    left: {
                                        align: "left",
                                        lineHeight: 15,
                                        color: "#666666"
                                    }
                                }
                            }
                        }
                    },
                    labelLine: {
                        normal: {
                            show: this.CooperationTypeJudge ? false : true,
                            length: 15,
                            length2: 20
                        }
                    },
                    data: this.CopperationArr
                }]
            };
            this.myChart4.setOption(option);
            window.addEventListener("resize", function () {
                if (_this3.$route.query.identification) {
                    var resize = {
                        width: _this3.screenWidth - 21
                    };
                    _this3.myChart4.resize(resize);
                } else {
                    _this3.myChart4.resize();
                }
            });
        },
        initChart5: function initChart5() {
            var _ref,
                _this4 = this;

            var _ProjectLevelList = this.ProjectLevelList,
                legend = _ProjectLevelList.legend,
                series = _ProjectLevelList.series,
                xAxis = _ProjectLevelList.xAxis;

            var maxPercent = Math.ceil(Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].percent)) / 10) * 10;
            var maxAmount = Math.ceil(Math.max.apply(Math, (0, _toConsumableArray3.default)(series[1].data)) / 10) * 10;

            var chart5 = this.$echarts.getInstanceByDom(this.$refs.pieThree);
            if (chart5 == null) {
                this.myChart5 = this.$echarts.init(this.$refs.pieThree);
            }
            var option = {
                textStyle: {
                    fontFamily: 'PingFang-M'
                },
                title: {
                    text: '项目等级',
                    top: '24',
                    left: this.$route.query.identification ? '20' : '30',
                    textStyle: {
                        fontWeight: 500
                    }
                },
                grid: {
                    left: this.$route.query.identification ? '36' : '46px',
                    right: this.$route.query.identification ? '10%' : '3%',
                    bottom: '5%',
                    top: this.$route.query.identification ? '30%' : '28%',
                    containLabel: true
                },
                opacity: 0.1,
                tooltip: {
                    trigger: 'axis',
                    formatter: function formatter(params) {
                        var h = '<div>';
                        params.reverse().forEach(function (item, index) {
                            if (item.seriesIndex == 1) {
                                h += '<div style="margin:3px 10px;">' + item.axisValue + '\uFF1A' + (0, _VueHelper.amountFormat)(item.data) + '\u5143</div>\n                                    <div style="margin:3px 10px;">\u4E2A\u6570\uFF1A' + series[1].value[series[1].data.findIndex(function (e) {
                                    return e == item.data;
                                })] + '\u4E2A</div>';
                            } else {
                                h += '<div style="margin:3px 10px;">\u5360\u6BD4\uFF1A' + item.data + '%</div>\n                                        </div>';
                            }
                        });

                        return h;
                    }
                },
                legend: {
                    data: legend,
                    itemWidth: 40,
                    itemHeight: 8,
                    itemGap: 20,
                    top: '24',
                    left: this.$route.query.identification ? '110' : '180'
                },
                xAxis: [(_ref = {
                    type: 'category',
                    offset: 5,
                    data: xAxis.data,
                    axisPointer: {
                        type: 'shadow'
                    },

                    splitLine: {
                        show: Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].percent).concat((0, _toConsumableArray3.default)(series[1].data))) == 0 ? false : true,
                        lineStyle: {
                            color: '#DDDDDD'
                        }
                    },
                    axisTick: {
                        show: false
                    },
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: '#DDDDDD'
                        }
                    }
                }, (0, _defineProperty3.default)(_ref, 'axisPointer', {
                    type: 'none'
                }), (0, _defineProperty3.default)(_ref, 'axisLabel', {
                    textStyle: {
                        color: '#666666'
                    }
                }), _ref)],
                yAxis: [{
                    offset: 5,
                    type: 'value',
                    show: Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].percent)) == 0 ? false : true,
                    name: '百分比',
                    min: 0,
                    max: maxPercent,
                    interval: 10,
                    axisLabel: {
                        formatter: '{value}%',
                        textStyle: {
                            color: '#666666'
                        }
                    },

                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: '#DDDDDD'
                        }
                    },

                    nameTextStyle: {
                        align: 'left',
                        padding: [0, 48, -5, 0],
                        color: '#666666'
                    },
                    axisTick: false,
                    axisLine: {
                        show: false }
                }, {
                    type: 'value',
                    name: '金额（万）',
                    show: Math.max.apply(Math, (0, _toConsumableArray3.default)(series[1].data)) == 0 ? false : true,
                    min: 0,
                    max: maxAmount,
                    interval: maxAmount == 0 ? 1 : maxAmount / (maxPercent / 10),
                    axisLabel: {
                        formatter: function formatter(value) {
                            return Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].percent).concat((0, _toConsumableArray3.default)(series[1].data))) == 0 ? value : Math.ceil(value / 10000);
                        },
                        textStyle: {
                            color: '#666666'
                        }
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: '#DDDDDD'
                        }
                    },

                    nameTextStyle: {
                        padding: [0, 0, -5, 35],
                        color: '#666666'
                    },
                    axisTick: false,
                    axisLine: {
                        show: false }
                }],
                series: [{
                    name: series[0].name,
                    type: 'bar',
                    barWidth: this.$route.query.identification ? 30 : '60%',
                    data: series[0].percent,
                    itemStyle: {
                        normal: {
                            color: 'rgba(87,185,255,0.35)',

                            borderColor: Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].percent)) == 0 ? 'rgba(87,185,255,0)' : 'rgba(87,185,255,1)'
                        }
                    },
                    yAxisIndex: 0
                }, {
                    name: series[1].name,
                    type: 'line',
                    symbol: 'rect',
                    symbolSize: 9,
                    hoverAnimation: false,
                    data: series[1].data,
                    itemStyle: {
                        normal: {
                            color: '#72d8c0',
                            opacity: series[1].data.reduce(function (a, b) {
                                return a + b;
                            }) === 0 ? 0 : 1
                        },
                        emphasis: {
                            borderWidth: 3,
                            borderColor: '#61d9ac',
                            color: '#61d9ac'
                        }
                    },
                    lineStyle: {
                        normal: {
                            opacity: series[1].data.reduce(function (a, b) {
                                return a + b;
                            }) === 0 ? 0 : 1
                        }
                    },
                    yAxisIndex: 1
                }]
            };
            this.myChart5.setOption(option);
            window.addEventListener("resize", function () {
                if (_this4.$route.query.identification) {
                    var resize = {
                        width: _this4.screenWidth - 21
                    };
                    _this4.myChart5.resize(resize);
                } else {
                    _this4.myChart5.resize();
                }
            });
        },
        getText: function getText(e, val) {
            var identification = this.$route.query.identification;
            this.x = e.layerX + 40;
            this.TextShow = true;
        }
    },
    watch: {
        ProjectTypeList: function ProjectTypeList(val) {
            this.progressLsit = [];
            for (var i = 0; i < val.series[0].data.length; i++) {
                if (this.$route.query.identification) {
                    var n = Math.ceil(Math.max.apply(Math, (0, _toConsumableArray3.default)(val.series[0].percent)) / 10) * 10;
                    this.progressLsit.push(n);
                } else {
                    this.progressLsit.push(100);
                }
            }
            this.$nextTick(function () {
                var myEvent = new Event('resize');
                window.dispatchEvent(myEvent);
            });
            this.initChart2();
        },
        PieprojectTypeList: function PieprojectTypeList(val) {
            var _this5 = this;

            this.PieprojectArr = [];
            val.forEach(function (item) {
                _this5.PieprojectArr.push({
                    value: item.percent,
                    name: item.name
                });
            });
            var res = val.every(function (item) {
                if (item.value == 0) return true;else false;
            });
            this.Judge = res;
            this.$nextTick(function () {
                var myEvent = new Event('resize');
                window.dispatchEvent(myEvent);
            });
            this.initChart3();
        },
        CooperationTypeList: function CooperationTypeList(val) {
            var _this6 = this;

            this.CopperationArr = [];
            val.forEach(function (item) {
                _this6.CopperationArr.push({
                    value: item.percent,
                    name: item.name
                });
            });
            var res = val.every(function (item) {
                if (item.value == 0) return true;else false;
            });
            this.CooperationTypeJudge = res;
            this.$nextTick(function () {
                var myEvent = new Event('resize');
                window.dispatchEvent(myEvent);
            });
            this.initChart4();
        },
        ProjectLevelList: function ProjectLevelList(val) {
            this.$nextTick(function () {
                var myEvent = new Event('resize');
                window.dispatchEvent(myEvent);
            });
            this.initChart5();
        },
        RankingProjectAmountList: function RankingProjectAmountList(val) {},
        DirectorRankingList: function DirectorRankingList(val) {},
        ProjectAreaList: function ProjectAreaList(val) {},
        screenWidth: function screenWidth(val) {
            console.log(val);
        }
    }

};

/***/ }),

/***/ 827:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        content: { type: String, default: '' },
        num: { type: Number, required: false, default: 2 },
        width: { type: Number, required: false, default: 200 }
    },
    components: {},
    data: function data() {
        return {};
    },
    created: function created() {},

    methods: {},
    mounted: function mounted() {},


    computed: {}
};

/***/ }),

/***/ 828:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        WaitList: {
            type: Array,
            default: function _default() {
                return [];
            }
        }
    },
    data: function data() {
        return {
            componentsList: []
        };
    },

    methods: {
        gotoDetail: function gotoDetail(item) {
            var path = '';
            var query = { bizItemId: item.bizItemId };
            switch (item.itemCat) {
                case 'LABOR_APPLY':
                    path = '/common/servicePayDetail';
                    break;
                case 'RISK_ FUND_APPLY':
                    path = '/common/RiskFundDetails';
                    break;
                case 'ADVANCE_TAX_APPLY':
                    path = '/common/refundTaxesDetails';
                    break;
                case 'PAID_MATERIAL_APPLY':
                    path = '/common/materialDetail';
                    break;
                case 'PROPERTY_MANAGEMENT_APPLY':
                    path = '/common/depositDetail';
                    break;
                case 'BID_BOND_APPLY':
                    path = '/common/marginDetail';
                    break;
                case 'SEAL_APPLY':
                    path = '/cm/sealApplicationDetail';
                    break;
                case 'CONTRACT_APPLY':
                    path = '/cm/contract/read_view0';
                    break;
                case 'GUARANTEE_LETTER_APPLY':
                    path = '/commonPage/projectManage/guaranteeDetail';
                    break;
                case 'INSURANCE_APPLY':
                    path = '/finance/insuranceDetail';
                    break;
                case 'PUNISHMENT_APPLY':
                    path = '/common/adminSanctionDetail';
                    break;
                case 'LITIGATION_APPLY':
                    path = '/common/litigationDetail';
                    break;
                case 'COMPLAINT_APPLY':
                    path = '/common/complaintDetail';
                    break;
                case 'PROJECT_APPLY':
                    path = '/common/proPreparationDetail';
                    break;
                case 'CASUALTY_APPLY':
                    path = '/common/injuriesDetail';
                    break;
                case 'CREDIT_APPLY':
                    path = '/common/creditDetail';
                    break;
                case 'PROJECT_LOSE_SINGLE':
                    path = '/commonPage/projectManage/losingDetailNew';
                    break;
                case 'PROJECTMANAGER_APPLY':
                    path = '/cd/pm/edit';
                    break;
                case 'ADVANCETAXAPPLY_APPLY':
                    path = '/fm/prepaidTaxDetail';
                    break;
                case 'INVOICEAPPLYDATA_APPLY':
                    path = '/fm/FmOutPutTicketDetail';
                    break;
                case 'INVOICEAPPLYDATA_VOID':
                    path = '/fm/FMVoidRecordDetail';
                    break;
                case 'INVOICEAPPLYDATA_REDRUSH':
                    path = '/fm/FMVoidRecordDetail';
                    query = { bizItemId: item.bizItemId, type: 3, applyType: 3 };
                    break;
                case 'COMPLETION_SETTLE_APPLY':
                    path = '/cm/CMFinishedAccountDetail';
                    query = { bizItemId: item.bizItemId };
                    break;
                case 'OTHER_SEAL_APPLY':
                    path = '/cm/sealApplicationOtherDetail';
                    query = { bizItemId: item.bizItemId };
                    break;
                case 'TICKET_RECORDS':
                    path = '/admin/WorkOrderDetail';
                    query = { bizItemId: item.bizItemId };
                    break;
            }
            if (!path) return;
            this.$router.push({ path: path, query: query });
        }
    },
    watch: {
        WaitList: function WaitList(value) {
            this.componentsList = value;
            console.log(value);
        }
    }
};

/***/ }),

/***/ 829:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        institutionList: {
            type: Array,
            default: function _default() {
                return [];
            }
        }
    },
    data: function data() {
        return {
            componentsList: []
        };
    },

    watch: {
        institutionList: function institutionList(value) {
            this.componentsList = value;
            console.log(value, 'value');
        }
    }
};

/***/ }),

/***/ 830:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      message: '',
      ruleForm: {
        resone: ''
      },
      rules: {
        resone: [{ required: true, message: '请输入原因', trigger: 'blur' }]
      }
    };
  },
  created: function created() {
    var _this = this;

    this.$nextTick(function () {
      _this.$refs.input && _this.$refs.input.resizeTextarea();
    });
  },

  methods: {
    ensure: function ensure() {
      var _this2 = this;

      if (this.title == '流程重启') {
        this.$refs.ruleForm.validate(function (valid) {
          if (valid) {
            _this2.ensureHanlder(_this2.ruleForm.resone);
            _this2.$el.parentNode.removeChild(_this2.$el);
          }
        });
      } else {
        this.ensureHanlder();
        this.$el.parentNode.removeChild(this.$el);
      }
    },
    close: function close(mode) {
      mode === 2 && this.cancelHandler();
      this.$el.parentNode.removeChild(this.$el);
    }
  }
};

/***/ }),

/***/ 831:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(92);

var _stringify2 = _interopRequireDefault(_stringify);

var _vant = __webpack_require__(83);

var _Urls = __webpack_require__(12);

var Urls = _interopRequireWildcard(_Urls);

var _MenuUtils = __webpack_require__(91);

var _MenuUtils2 = _interopRequireDefault(_MenuUtils);

var _allMenu = __webpack_require__(171);

var _allMenu2 = _interopRequireDefault(_allMenu);

var _menu = __webpack_require__(172);

var _menu2 = _interopRequireDefault(_menu);

var _VueHelper = __webpack_require__(17);

var VueHelper = _interopRequireWildcard(_VueHelper);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            userPhone: '',
            userCode: '',
            userPhoneFocus: false,
            userCodeFocus: false,
            switchFlag: false,
            phoneCodeFlag: false,
            reg: /^[1][3,4,5,7,8,9][0-9]{9}$/,
            data: {
                phoneInfo: '',
                codeInfo: ''
            },
            countdown: 60,
            countDownSet: null,
            borderNone: true,
            btnName: '获取验证码',
            code: ''
        };
    },

    components: {
        Toast: _vant.Toast, Dialog: _vant.Dialog
    },
    created: function created() {
        var wxOpenId = sessionStorage.getItem('wxOpenId');
        if (!wxOpenId || wxOpenId == 'undefined') {
            this.$router.push('/appLogin/agent');
        }
    },

    watch: {
        userPhone: function userPhone(val, old) {
            this.data.phoneInfo = val;
            this.phoneCodeFlag = this.reg.test(val.replace(/\s*/g, "")) ? true : false;
            if (val.length == 13 && !this.reg.test(val.replace(/\s*/g, ""))) {
                (0, _vant.Toast)('手机号有误');
            }
            if (val.length > old.length) {
                if (val.length === 3 || val.length === 8) {
                    this.userPhone += ' ';
                }
            } else {
                if (val.length === 9 || val.length === 4) {
                    this.userPhone = this.userPhone.trim();
                }
            }
            var arr = val.split('');
            if (arr[3] && arr[3] != ' ') {
                arr.splice(3, 0, ' ');
            }
            if (arr[8] && arr[8] != ' ') {
                arr.splice(8, 0, ' ');
            }
            this.userPhone = arr.join('');
        },
        userCode: function userCode(val, old) {
            this.data.codeInfo = val;
        }
    },
    methods: {
        getCode: function getCode() {
            var inst = this;
            var url = Urls.wx_login_code;
            var params = {
                phone: this.userPhone.replace(/\s/g, '')
            };
            this.$root.doGet(url, params, function (server_data) {
                inst.countdown = 60;
                inst.switchFlag = true;
                inst.btnName = '重新获取';
                inst.countDownSet = setInterval(function () {
                    if (inst.countdown > 0) {
                        inst.countdown--;
                    } else {
                        inst.switchFlag = false;
                        clearInterval(inst.countDownSet);
                    }
                }, 1000);
            });
        },
        userPhoneBlur: function userPhoneBlur(type) {
            var _this = this;

            setTimeout(function () {
                _this[type] = false;
                if (type == 'userPhoneFocus' && !_this.reg.test(_this.userPhone.replace(/\s*/g, ""))) {
                    _this.userPhone.replace(/\s*/g, "") == '' ? '' : (0, _vant.Toast)('手机号有误');
                }
            }, 100);
        },
        login: function login() {
            var inst = this;
            var openId = sessionStorage.getItem('wxOpenId');
            var url = Urls.wx_user_login;
            var params = {
                phone: this.userPhone.replace(/\s/g, ''),
                smsCode: this.userCode,
                openId: openId || ''
            };
            this.$root.doPost(url, params, function (server_data) {
                if (server_data.error) {
                    (0, _vant.Toast)(server_data.error);
                    return;
                }
                sessionStorage.setItem('user', (0, _stringify2.default)(server_data.data));
                var role = server_data.data.roleValue;
                console.log("role:" + role);

                var menu = _menu2.default;

                var roleMeun = server_data.data.roleMeun;
                var menuData = [];

                roleMeun.forEach(function (element, index) {
                    if (!element.children.length && element.workBenchList.length) {
                        menuData.push({
                            path: '/p' + index,
                            component: "HomeView",
                            redirect: element.workBenchList[0].benchPath,
                            name: element.menuName,
                            parent: true,
                            children: [{
                                pageAddress: element.workBenchList[0].benchComponent,
                                path: element.workBenchList[0].benchPath,
                                name: element.menuName
                            }]
                        });
                    } else if (!element.children[0].children.length) {
                        var data = {
                            path: '/p' + index,
                            redirect: '',
                            component: "HomeView",
                            name: element.menuName,
                            icon: element.menuIcon,
                            parent: true,
                            children: []
                        };
                        element.children.forEach(function (element2, index2) {
                            if (!element2.workBenchList.length) return;
                            data.children.push({
                                pageAddress: element2.workBenchList[0].benchComponent,
                                path: element2.workBenchList[0].benchPath,
                                name: element2.menuName,
                                icon: element2.menuIcon
                            });
                            if (index2 === 0) {
                                data.redirect = element2.workBenchList[0].benchPath;
                            }
                        });

                        menuData.push(data);
                    } else {
                        var _data = {
                            path: '/p' + index,
                            redirect: '',
                            component: "HomeView",
                            name: element.menuName,
                            icon: element.menuIcon,
                            parent: true,
                            children: []
                        };
                        element.children.forEach(function (element2, index2) {
                            var data2 = {
                                parent: true,
                                component: "Navigation",
                                path: "/home",
                                name: element2.menuName,
                                icon: element2.menuIcon,
                                children: []
                            };
                            element2.children.forEach(function (element3, index3) {
                                if (!element3.workBenchList.length) return;
                                data2.children.push({
                                    pageAddress: element3.workBenchList[0].benchComponent,
                                    path: element3.workBenchList[0].benchPath,
                                    name: element3.menuName,
                                    icon: element3.menuIcon
                                });
                                if (index2 === 0 && index3 === 0) {
                                    _data.redirect = element3.workBenchList[0].benchPath;
                                }

                                for (var i = 0; i < menu.length; i++) {
                                    var obj = menu[i];
                                    if (obj.menuId == element.menuCode) {
                                        for (var j = 0; j < obj.children.length; j++) {
                                            var obj2 = obj.children[j];
                                            if (obj2.menuId == element2.menuCode) {
                                                data2.children = data2.children.concat(obj2.children);
                                                break;
                                            }
                                        }
                                    }
                                }
                            });
                            _data.children.push(data2);
                        });
                        menuData.push(_data);
                    }
                });

                if (menuData.length) {
                    menuData[0].path = '/';
                }

                menu.forEach(function (element, index) {
                    if (element.hidden && !element.redirect) {
                        menuData = menuData.concat(element);
                    }
                });

                window.sessionStorage.setItem('userPre', (0, _stringify2.default)(menuData));
                var routes = [];
                (0, _MenuUtils2.default)(routes, menuData);
                console.log("登录routes", routes);
                inst.$router.addRoutes(routes);
                sessionStorage.token = server_data.data.token;
                inst.$router.push('/appLogin/agent');
            });
        },
        GetUrlParame: function GetUrlParame(parameName) {
            var parames = window.location.search;
            if (parames.indexOf(parameName) > -1) {
                var parameValue = "";
                parameValue = parames.substring(parames.indexOf(parameName), parames.length);
                if (parameValue.indexOf("&") > -1) {
                    parameValue = parameValue.substring(0, parameValue.indexOf("&"));
                    parameValue = parameValue.replace(parameName + "=", "");
                    return parameValue;
                }
                return "";
            }
        }
    },
    beforeDestroy: function beforeDestroy() {
        clearInterval(this.countDownSet);
    },
    destroyed: function destroyed() {
        clearInterval(this.countDownSet);
    }
};

/***/ }),

/***/ 832:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(170);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(169);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _stringify = __webpack_require__(92);

var _stringify2 = _interopRequireDefault(_stringify);

var _Urls = __webpack_require__(12);

var Urls = _interopRequireWildcard(_Urls);

var _VueHelper = __webpack_require__(17);

var VueHelper = _interopRequireWildcard(_VueHelper);

var _axios = __webpack_require__(94);

var _axios2 = _interopRequireDefault(_axios);

var _aliOss = __webpack_require__(168);

var _aliOss2 = _interopRequireDefault(_aliOss);

var _weixinJsSdk = __webpack_require__(250);

var _weixinJsSdk2 = _interopRequireDefault(_weixinJsSdk);

var _vant = __webpack_require__(83);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        fileExt: { type: String, default: "jpg,jpeg,png,bmp,gif,pdf,doc,docx,xls,xlsx,zip,rar" }
    },
    data: function data() {
        return {
            client: new _aliOss2.default({
                region: 'oss-cn-shenzhen',
                accessKeyId: 'LTAI4GGHb3kkSnv9MdPdPb4Y',
                accessKeySecret: 'yEOrbRYDSIJpgjGiZk9yTsuSAyava9',
                bucket: 'xmoty',
                timeout: 600000
            }),
            url: '',
            name: 'files',
            dataList: [],
            dialogVisible: false,
            delId: '',
            fileList: [],
            num: 0,
            loading: false,
            Journal: '',
            proId: '',
            content: '',
            list: [],
            ext: ['jpg', 'jpeg', 'png', 'bmp', 'gif', 'pdf', 'doc', 'docx', 'xls', 'xlsx', 'zip', 'rar'],
            dataForm: {}
        };
    },
    mounted: function mounted() {
        this.redirectUrl = this.$route.query.redirectUrl;
        this.dataForm = this.$route.query.dataForm;
        console.log(this.dataForm);

        this.list = JSON.parse(this.$route.query.dataList);
        console.log(this.list);
    },

    methods: {
        changeURLArg: function changeURLArg(url, arg, arg_val) {
            var pattern = arg + '=([^&]*)';
            var replaceText = arg + '=' + arg_val;
            if (url.match(pattern)) {
                var tmp = '/(' + arg + '=)([^&]*)/gi';
                tmp = url.replace(eval(tmp), replaceText);
                return tmp;
            } else {
                if (url.match('[\?]')) {
                    return url + '&' + replaceText;
                } else {
                    return url + '?' + replaceText;
                }
            }
            return url + '\n' + arg + '\n' + arg_val;
        },
        getUrlParam: function getUrlParam(name) {
            var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
            var r = window.location.href.split('?')[1] && window.location.href.split('?')[1].match(reg);
            if (r != null) {
                return decodeURIComponent(r[2]);
            }
            return null;
        },
        beforeUpload: function beforeUpload(file) {
            if (!this.checkAccept(file)) {
                return false;
            }

            if (!this.checkSize(file)) {
                return false;
            }
            return true;
        },
        checkSize: function checkSize(file) {
            var fileType = file.name.slice(file.name.lastIndexOf('.') + 1, file.name.length);
            if (this.isImage(fileType)) {
                var isLt2M = file.size / 1024 / 1024 < 20;
                if (!isLt2M) {
                    this.loading = false;
                    (0, _vant.Toast)('\u56FE\u7247\u5927\u5C0F\u4E0D\u80FD\u8D85\u8FC7 20M!');
                    return;
                }
            } else {
                var _isLt2M = file.size / 1024 / 1024 < 200;
                if (!_isLt2M) {
                    this.loading = false;
                    (0, _vant.Toast)('\u6587\u6863\u5927\u5C0F\u4E0D\u80FD\u8D85\u8FC7 200M!');
                    return;
                }
            }
            return true;
        },
        checkAccept: function checkAccept(file) {
            var inst = this;
            var matchOne = false;
            var extList = inst.fileExt.split(",");
            for (var i = 0; i < extList.length; i++) {
                matchOne = new RegExp(extList[i] + "$").test(file.name.toLowerCase());
                if (matchOne) {
                    break;
                }
            }

            if (!matchOne) {
                this.loading = false;
                inst._showError('上传文件的后缀名必须是: ' + inst.fileExt + ' 之一');
                return false;
            }

            return true;
        },
        getUploadFinished: function getUploadFinished() {
            var fla = true;
            this.dataList.forEach(function (e) {
                if (!e.id) {
                    fla = false;
                }
            });
            return fla;
        },
        getAttachIds: function getAttachIds() {
            return VueHelper.getIdList(this.dataList);
        },
        setImagePreview: function setImagePreview() {
            var file_head = document.getElementById("file_head");
            var file = file_head.files[0];
            file.uid = file.lastModified;
            console.log(file_head.files[0].lastModified);
            var content = {
                file: file
            };
            this.myUpload(content);
        },
        setFilePreview: function setFilePreview() {
            var file_head2 = document.getElementById("file_head2");
            var file = file_head2.files[0];
            file.uid = file.lastModified;
            console.log(file_head2.files[0].lastModified);
            var content = {
                file: file
            };
            this.myUpload(content);
        },
        uploadfile: function uploadfile(upfile, name, uid) {
            console.log(upfile.requestUrls[0]);
            var inst = this;
            var url = Urls.new_upload_attach;
            var newUrl = upfile.requestUrls[0].replace('http://xmoty.oss-cn-shenzhen.aliyuncs.com', 'https://xmyun.zhoty.com').replace('https://xmoty.oss-cn-shenzhen.aliyuncs.com', 'https://xmyun.zhoty.com');
            var params = {
                url: newUrl,
                size: upfile.headers['content-length'] ? upfile.headers['content-length'] : 0,
                contentType: upfile.headers['content-type'],
                name: name,
                uid: uid
            };
            this.$root.ajaxPost(url, params, function (server_data) {
                inst.dataList.forEach(function (e) {
                    if (e.uid == server_data.uid) {
                        e.id = server_data.id;
                        e.url = server_data.url;
                    }
                });
                inst.list.push({ id: server_data.id, name: server_data.name, url: server_data.url, icon: inst.dataList[0].iconUrl });
                _weixinJsSdk2.default.miniProgram.redirectTo({
                    url: inst.redirectUrl + '?dataList=' + (0, _stringify2.default)(inst.list) + '&dataForm=' + (0, _stringify2.default)(inst.dataForm)
                });
            });
        },
        myUpload: function myUpload(content) {
            var multipartUpload = function () {
                var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                    var result, head, iconUrl, hz;
                    return _regenerator2.default.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    _context.prev = 0;
                                    _context.next = 3;
                                    return inst.client.multipartUpload('xmerp/xmfiles/' + date.year + '/' + _month + '/' + _date + '/' + fileName + '.' + fileType, content.file, {
                                        progress: progress,

                                        meta: {
                                            year: 2020,
                                            people: 'test'
                                        }
                                    });

                                case 3:
                                    result = _context.sent;
                                    _context.next = 6;
                                    return inst.client.head('xmerp/xmfiles/' + date.year + '/' + _month + '/' + _date + '/' + fileName + '.' + fileType);

                                case 6:
                                    head = _context.sent;

                                    console.log(head);
                                    iconUrl = void 0;
                                    hz = inst.getCaption(head.res.requestUrls[0], 1);
                                    _context.t0 = hz;
                                    _context.next = _context.t0 === 'xls' ? 13 : _context.t0 === 'xlsx' ? 13 : _context.t0 === 'doc' ? 15 : _context.t0 === 'docx' ? 15 : _context.t0 === 'ppt' ? 17 : _context.t0 === 'pptx' ? 17 : _context.t0 === 'pdf' ? 19 : _context.t0 === 'rar' ? 21 : _context.t0 === 'zip' ? 21 : _context.t0 === 'jpg' ? 23 : _context.t0 === 'png' ? 23 : _context.t0 === 'gif' ? 23 : _context.t0 === 'jpeg' ? 23 : _context.t0 === 'bmp' ? 23 : 25;
                                    break;

                                case 13:
                                    iconUrl = 'http://xmyun.zhoty.com/resource/xapp-pm/static/image/fileShare/xls.png';
                                    return _context.abrupt('break', 27);

                                case 15:
                                    iconUrl = 'http://xmyun.zhoty.com/resource/xapp-pm/static/image/fileShare/word.png';
                                    return _context.abrupt('break', 27);

                                case 17:
                                    iconUrl = 'http://xmyun.zhoty.com/resource/xapp-pm/static/image/fileShare/ppt.png';
                                    return _context.abrupt('break', 27);

                                case 19:
                                    iconUrl = 'http://xmyun.zhoty.com/resource/xapp-pm/static/image/fileShare/pdf.png';
                                    return _context.abrupt('break', 27);

                                case 21:
                                    iconUrl = 'http://xmyun.zhoty.com/resource/xapp-pm/static/image/fileShare/zip.png';
                                    return _context.abrupt('break', 27);

                                case 23:
                                    iconUrl = head.res.requestUrls[0];
                                    return _context.abrupt('break', 27);

                                case 25:
                                    iconUrl = 'http://xmyun.zhoty.com/resource/xapp-pm/static/image/fileShare/tongyong.png';
                                    return _context.abrupt('break', 27);

                                case 27:

                                    inst.dataList.forEach(function (e) {
                                        if (content.file.uid == e.uid) {
                                            e.loading = false;
                                            e.iconUrl = iconUrl;
                                        }
                                    });

                                    _context.next = 30;
                                    return inst.uploadfile(head.res, content.file.name, content.file.uid);

                                case 30:
                                    _context.next = 36;
                                    break;

                                case 32:
                                    _context.prev = 32;
                                    _context.t1 = _context['catch'](0);

                                    if (_context.t1.code === 'ConnectionTimeoutError') {
                                        console.log('TimeoutError');
                                    }
                                    console.log(_context.t1);

                                case 36:
                                case 'end':
                                    return _context.stop();
                            }
                        }
                    }, _callee, this, [[0, 32]]);
                }));

                return function multipartUpload() {
                    return _ref.apply(this, arguments);
                };
            }();

            var fileType = content.file.name.slice(content.file.name.lastIndexOf('.') + 1, content.file.name.length);
            var imgLi = ['jpg', 'jpeg', 'png', 'bmp', 'gif'];
            if (imgLi.includes(fileType)) {
                var isLt2M = content.file.size / 1024 / 1024 < 20;
                if (!isLt2M) {
                    this.loading = false;
                    (0, _vant.Toast)('\u56FE\u7247\u5927\u5C0F\u4E0D\u80FD\u8D85\u8FC7 20M!');
                    return;
                }
            } else {
                var _isLt2M2 = content.file.size / 1024 / 1024 < 200;
                if (!_isLt2M2) {
                    this.loading = false;
                    (0, _vant.Toast)('\u6587\u6863\u5927\u5C0F\u4E0D\u80FD\u8D85\u8FC7 200M!');
                    return;
                }
            }

            console.log('aaaaaa');
            this.loading = true;
            var inst = this;
            var nowDate = new Date();
            var date = {
                year: nowDate.getFullYear(),
                month: nowDate.getMonth() + 1,
                date: nowDate.getDate()
            };

            var _month = date.month < 10 ? '0' + date.month : date.month;
            var _date = date.date < 10 ? '0' + date.date : date.date;
            var systemDate = date.year + _month + _date;
            var fileName = date.year + _month + _date + Date.now();

            if (!this.ext.includes(fileType)) {
                this.loading = false;
                (0, _vant.Toast)('\u4E0D\u652F\u6301' + fileType + '\u7C7B\u578B\u6587\u4EF6\u4E0A\u4F20');
                return;
            }

            inst.dataList.push({
                loading: true,
                percentage: 0,
                name: content.file.name,
                uid: content.file.uid
            });

            var progress = function progress(p, _checkpoint) {
                inst.dataList.forEach(function (e) {
                    if (_checkpoint && _checkpoint.file.uid == e.uid) {
                        e.percentage = Number((p * 100).toFixed(0));
                    }
                });
            };

            multipartUpload();
        },
        showAttachs: function showAttachs(attachIds) {
            if (!attachIds) return;
            var inst = this;
            var url = Urls.file_get_attach_list;
            var params = {
                'attachIds': (0, _stringify2.default)(attachIds)
            };
            console.log('params', params);

            this.$root.ajaxPost(url, params, function (data) {
                if (!data) {
                    return;
                }

                inst.dataList = [];

                for (var i = 0; i < data.length; i++) {
                    var attach = data[i];

                    var file = {
                        'id': attach.id,
                        'name': attach.name,
                        'url': attach.url,
                        'raw': { 'size': attach.size }
                    };
                    if (inst.mode == 'upload') {
                        inst._changeThumbnailIf(attach.url);
                    } else {
                        var previewUrl = inst.isImage(attach.url) ? attach.url : '/static/img/document.png';
                        file['previewUrl'] = previewUrl;
                    }
                    inst.dataList.push(file);
                }
                for (var _i = 0; _i < inst.dataList.length; _i++) {
                    var hz = inst.getCaption(inst.dataList[_i].url, 1);
                    switch (hz) {
                        case 'xls':case 'xlsx':
                            inst.dataList[_i].iconUrl = 'http://xmyun.zhoty.com/resource/xapp-pm/static/image/fileShare/xls.png';
                            break;
                        case 'doc':case 'docx':
                            inst.dataList[_i].iconUrl = 'http://xmyun.zhoty.com/resource/xapp-pm/static/image/fileShare/word.png';
                            break;
                        case 'ppt':case 'pptx':
                            inst.dataList[_i].iconUrl = 'http://xmyun.zhoty.com/resource/xapp-pm/static/image/fileShare/ppt.png';
                            break;
                        case 'pdf':
                            inst.dataList[_i].iconUrl = 'http://xmyun.zhoty.com/resource/xapp-pm/static/image/fileShare/pdf.png';
                            break;
                        case 'zip':case 'rar':
                            inst.dataList[_i].iconUrl = 'http://xmyun.zhoty.com/resource/xapp-pm/static/image/fileShare/zip.png';
                            break;
                        case 'jpg':case 'png':case 'gif':case 'jpeg':case 'bmp':
                            inst.dataList[_i].iconUrl = inst.dataList[_i].url;
                            break;
                        default:
                            inst.dataList[_i].iconUrl = 'http://xmyun.zhoty.com/resource/xapp-pm/static/image/fileShare/tongyong.png';
                            break;
                    }
                }
            });
        },
        getCaption: function getCaption(obj, state) {
            var index = obj.lastIndexOf("\.");
            if (state == 0) {
                obj = obj.substring(0, index);
            } else {
                obj = obj.substring(index + 1, obj.length);
            }
            return obj;
        },
        _showError: function _showError(msg) {
            this.$notify.error({
                title: '错误',
                message: msg,
                duration: 3000,
                position: 'bottom-right'
            });
        },
        _showSucc: function _showSucc(msg) {
            this.$notify({
                title: '成功',
                message: msg,
                type: 'success',
                duration: 3000,
                position: 'bottom-right'
            });
        },
        _changeThumbnailIf: function _changeThumbnailIf(file_url) {
            if (!this.isImage(file_url)) {
                this.$nextTick(function () {
                    $(".el-upload-list__item-thumbnail[src='" + file_url + "']").attr('src', '../static/img/document.png');
                });
            }
        },
        isImage: function isImage(data) {
            var imgLi = ['jpg', 'jpeg', 'png', 'bmp', 'gif'];
            var matchOne = false;

            for (var i = 0; i < imgLi.length; i++) {
                matchOne = new RegExp(imgLi[i] + "$").test(data.toLowerCase());
                if (matchOne) {
                    break;
                }
            }
            return matchOne;
        },
        deleteFile: function deleteFile(id) {
            this.delId = id;
            this.secondDelete();
        },
        secondDelete: function secondDelete() {
            var inst = this;
            var url = Urls.file_delete_attach;
            var params = {
                'id': this.delId
            };
            this.$root.doPost(url, params, function (server_data) {
                if (!inst.$root.isUserLogin(server_data)) {
                    return;
                }

                if (server_data.error) {
                    inst.$root.showGlobalError(server_data.error);
                    return;
                }

                var deleteId = inst.delId;
                for (var i = 0; i < inst.dataList.length; i++) {
                    if (deleteId == inst.dataList[i].id) {
                        inst.dataList.splice(i, 1);
                        break;
                    }
                }
            });
        },
        download: function download(url) {
            window.open(url);
        }
    }
};

/***/ }),

/***/ 833:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(170);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(169);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _stringify = __webpack_require__(92);

var _stringify2 = _interopRequireDefault(_stringify);

var _Urls = __webpack_require__(12);

var Urls = _interopRequireWildcard(_Urls);

var _VueHelper = __webpack_require__(17);

var VueHelper = _interopRequireWildcard(_VueHelper);

var _axios = __webpack_require__(94);

var _axios2 = _interopRequireDefault(_axios);

var _aliOss = __webpack_require__(168);

var _aliOss2 = _interopRequireDefault(_aliOss);

var _weixinJsSdk = __webpack_require__(250);

var _weixinJsSdk2 = _interopRequireDefault(_weixinJsSdk);

var _qs = __webpack_require__(1522);

var _qs2 = _interopRequireDefault(_qs);

var _vant = __webpack_require__(83);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            dirId: '',
            fileType: 1,
            phone: '',
            projectId: '',
            client: new _aliOss2.default({
                region: 'oss-cn-shenzhen',
                accessKeyId: 'LTAI4GGHb3kkSnv9MdPdPb4Y',
                accessKeySecret: 'yEOrbRYDSIJpgjGiZk9yTsuSAyava9',
                bucket: 'xmoty',
                timeout: 600000
            }),
            dataList: [],
            delId: '',
            toast: null,
            JumpLogo: '',
            ext: ['jpg', 'jpeg', 'png', 'bmp', 'gif', 'pdf', 'doc', 'docx', 'xls', 'xlsx', 'zip', 'rar']
        };
    },
    mounted: function mounted() {
        this.dirId = this.$route.query.dirId;
        this.phone = this.$route.query.phone;
        this.projectId = this.$route.query.projectId;
        this.JumpLogo = this.$route.query.JumpLogo;
        console.log(this.$route.query);
        this.authorizationToAppJump();
    },

    methods: {
        authorizationToAppJump: function authorizationToAppJump() {
            var inst = this;
            var url = Urls.authorizationToAppJump;
            var params = {
                phone: this.phone
            };
            this.$root.doPost(url, params, function (server_data) {
                if (!inst.$root.isUserLogin(server_data)) {
                    return;
                }

                if (server_data.error) {
                    alert(server_data.error);

                    return;
                }

                inst.token = server_data.data.token;
            });
        },
        saveDocFileBatch: function saveDocFileBatch() {
            var _this = this;

            var list = this.dataList.map(function (e) {
                var obj = {
                    iconUrl: e.iconUrl,
                    fileSize: e.fileSize,
                    fileFormat: e.fileFormat,
                    fileUrl: e.fileUrl,
                    fileName: e.fileName,
                    originalName: e.name
                };
                return obj;
            });

            var inst = this;
            var url = Urls.project_saveDocFileBatch;
            var params = {
                dirId: this.dirId,
                fileType: this.fileType,
                projectDocFiles: (0, _stringify2.default)(list)
            };

            (0, _axios2.default)({
                url: url,
                method: 'post',
                data: _qs2.default.stringify(params),
                headers: {
                    'Authorization': this.token
                }
            }).then(function (res) {
                if (res.data.error) {
                    alert(res.data.error);
                    return;
                }
                _this.toast.clear();
                if (_this.JumpLogo == 'WithData') {
                    _weixinJsSdk2.default.miniProgram.redirectTo({
                        url: '/pages/packageInfo/pages/projectInFormation/main?id=' + _this.projectId
                    });
                } else {
                    _weixinJsSdk2.default.miniProgram.redirectTo({
                        url: '/pages/packageInfo/pages/projectDetail/main?id=' + _this.projectId + '&activeIndex=2'
                    });
                }
            });
        },
        setImagePreview: function setImagePreview() {
            this.fileType = 2;
            var file_head = document.getElementById("file_head");
            var file = file_head.files[0];
            file.uid = file.lastModified;
            console.log(file_head.files[0].lastModified);
            var content = {
                file: file
            };
            this.myUpload(content);
        },
        setFilePreview: function setFilePreview() {
            this.fileType = 1;
            var file_head2 = document.getElementById("file_head2");
            var file = file_head2.files[0];
            file.uid = file.lastModified;
            console.log(file_head2.files[0].lastModified);
            var content = {
                file: file
            };
            this.myUpload(content);
        },
        myUpload: function myUpload(content) {
            var multipartUpload = function () {
                var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                    var result, head, iconUrl, hz;
                    return _regenerator2.default.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    _context.prev = 0;
                                    _context.next = 3;
                                    return inst.client.multipartUpload('xmerp/xmfiles/' + date.year + '/' + _month + '/' + _date + '/' + fileName + '.' + fileType, content.file, {
                                        progress: progress,

                                        meta: {
                                            year: 2020,
                                            people: 'test'
                                        }
                                    });

                                case 3:
                                    result = _context.sent;
                                    _context.next = 6;
                                    return inst.client.head('xmerp/xmfiles/' + date.year + '/' + _month + '/' + _date + '/' + fileName + '.' + fileType);

                                case 6:
                                    head = _context.sent;

                                    console.log('h----', head);
                                    iconUrl = void 0;
                                    hz = inst.getCaption(head.res.requestUrls[0], 1);
                                    _context.t0 = hz;
                                    _context.next = _context.t0 === 'xls' ? 13 : _context.t0 === 'xlsx' ? 13 : _context.t0 === 'doc' ? 15 : _context.t0 === 'docx' ? 15 : _context.t0 === 'ppt' ? 17 : _context.t0 === 'pptx' ? 17 : _context.t0 === 'pdf' ? 19 : _context.t0 === 'rar' ? 21 : _context.t0 === 'zip' ? 21 : _context.t0 === 'jpg' ? 23 : _context.t0 === 'png' ? 23 : _context.t0 === 'gif' ? 23 : _context.t0 === 'jpeg' ? 23 : _context.t0 === 'bmp' ? 23 : 25;
                                    break;

                                case 13:
                                    iconUrl = 'http://xmyun.zhoty.com/resource/xapp-pm/static/image/fileShare/xls.png';
                                    return _context.abrupt('break', 27);

                                case 15:
                                    iconUrl = 'http://xmyun.zhoty.com/resource/xapp-pm/static/image/fileShare/word.png';
                                    return _context.abrupt('break', 27);

                                case 17:
                                    iconUrl = 'http://xmyun.zhoty.com/resource/xapp-pm/static/image/fileShare/ppt.png';
                                    return _context.abrupt('break', 27);

                                case 19:
                                    iconUrl = 'http://xmyun.zhoty.com/resource/xapp-pm/static/image/fileShare/pdf.png';
                                    return _context.abrupt('break', 27);

                                case 21:
                                    iconUrl = 'http://xmyun.zhoty.com/resource/xapp-pm/static/image/fileShare/zip.png';
                                    return _context.abrupt('break', 27);

                                case 23:
                                    iconUrl = head.res.requestUrls[0];
                                    return _context.abrupt('break', 27);

                                case 25:
                                    iconUrl = 'http://xmyun.zhoty.com/resource/xapp-pm/static/image/fileShare/tongyong.png';
                                    return _context.abrupt('break', 27);

                                case 27:

                                    inst.dataList.forEach(function (e) {
                                        if (content.file.uid == e.uid) {
                                            e.loading = false;
                                            e.iconUrl = iconUrl;
                                            e.fileSize = head.res.headers['content-length'] ? head.res.headers['content-length'] : 0;
                                            e.fileFormat = head.res.headers['content-type'];
                                            e.fileUrl = head.res.requestUrls[0].replace('http://xmoty.oss-cn-shenzhen.aliyuncs.com', 'https://xmyun.zhoty.com').replace('https://xmoty.oss-cn-shenzhen.aliyuncs.com', 'https://xmyun.zhoty.com');
                                            e.fileName = iconUrl;
                                        }
                                    });

                                    inst.saveDocFileBatch();
                                    _context.next = 35;
                                    break;

                                case 31:
                                    _context.prev = 31;
                                    _context.t1 = _context['catch'](0);

                                    if (_context.t1.code === 'ConnectionTimeoutError') {
                                        console.log('TimeoutError');
                                    }
                                    console.log(_context.t1);

                                case 35:
                                case 'end':
                                    return _context.stop();
                            }
                        }
                    }, _callee, this, [[0, 31]]);
                }));

                return function multipartUpload() {
                    return _ref.apply(this, arguments);
                };
            }();

            this.toast = _vant.Toast.loading({
                duration: 0,
                message: '上传中...',
                forbidClick: true
            });
            var inst = this;
            var nowDate = new Date();
            var date = {
                year: nowDate.getFullYear(),
                month: nowDate.getMonth() + 1,
                date: nowDate.getDate()
            };

            var _month = date.month < 10 ? '0' + date.month : date.month;
            var _date = date.date < 10 ? '0' + date.date : date.date;
            var systemDate = date.year + _month + _date;
            var fileName = date.year + _month + _date + Date.now();
            console.log(content);

            var fileType = content.file.name.slice(content.file.name.lastIndexOf('.') + 1, content.file.name.length);

            if (!this.ext.includes(fileType)) {
                this.loading = false;
                (0, _vant.Toast)('\u4E0D\u652F\u6301' + fileType + '\u7C7B\u578B\u6587\u4EF6\u4E0A\u4F20');
                return;
            }
            switch (fileType) {
                case 'jpg':case 'png':case 'gif':case 'jpeg':case 'bmp':
                    inst.fileType = 2;
                    break;
                default:
                    inst.fileType = 1;
                    break;
            }


            inst.dataList.push({
                loading: true,
                percentage: 0,
                name: content.file.name,
                uid: content.file.uid
            });

            var progress = function progress(p, _checkpoint) {
                inst.dataList.forEach(function (e) {
                    if (_checkpoint && _checkpoint.file.uid == e.uid) {
                        e.percentage = Number((p * 100).toFixed(0));
                    }
                });
            };

            multipartUpload();
        },
        getCaption: function getCaption(obj, state) {
            var index = obj.lastIndexOf("\.");
            if (state == 0) {
                obj = obj.substring(0, index);
            } else {
                obj = obj.substring(index + 1, obj.length);
            }
            return obj;
        }
    }
};

/***/ }),

/***/ 834:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toConsumableArray2 = __webpack_require__(31);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _defineProperty2 = __webpack_require__(93);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _Events = __webpack_require__(204);

var Events = _interopRequireWildcard(_Events);

var _ModalLoginWidget = __webpack_require__(753);

var _ModalLoginWidget2 = _interopRequireDefault(_ModalLoginWidget);

var _MenuUtils = __webpack_require__(91);

var _MenuUtils2 = _interopRequireDefault(_MenuUtils);

var _Urls = __webpack_require__(12);

var Urls = _interopRequireWildcard(_Urls);

var _VueHelper = __webpack_require__(17);

var VueHelper = _interopRequireWildcard(_VueHelper);

var _Navi = __webpack_require__(264);

var _Navi2 = _interopRequireDefault(_Navi);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        ModalLoginWidget: _ModalLoginWidget2.default, Navi: _Navi2.default
    },
    data: function data() {
        var _ref;

        return _ref = {
            nodes: this.$router.options.routes,
            sysName: '新美云平台',
            collapsed: false,
            account: '',
            realName: '',
            avatarPath: '',
            isProd: '',
            form: {
                name: '',
                region: '',
                date1: '',
                date2: '',
                delivery: false,
                type: [],
                resource: '',
                desc: ''
            },

            loading: false,
            msgType: 1,
            messageIntval: null,
            messageCount: 0,
            popover: false,
            pageSize: 10,
            pageNo: 1,
            pageCount: 0,
            msgList: [],

            isAwait: 'Y'
        }, (0, _defineProperty3.default)(_ref, 'pageNo', 1), (0, _defineProperty3.default)(_ref, 'pageCount2', 0), (0, _defineProperty3.default)(_ref, 'msgList2', []), (0, _defineProperty3.default)(_ref, 'messageCount2', 0), _ref;
    },
    created: function created() {
        var _nodes;

        var inst = this;
        var data = JSON.parse(window.sessionStorage.getItem('userPre'));

        this.nodes = [];
        (_nodes = this.nodes).push.apply(_nodes, (0, _toConsumableArray3.default)(data));
    },

    methods: {
        toMsg: function toMsg(type) {
            if (type == 1) {
                this.msgType = 1;
                this.pageNo = 1;
                this.getNews();
            } else if (type == 2) {
                this.msgType = 2;
                this.pageNo2 = 1;
                this.isAwait = 'Y';
                this.getCopyNews();
            }
        },
        load: function load() {
            if (this.pageCount > this.pageNo) {
                this.pageNo++;
                this.getNews();
            }
        },
        load2: function load2() {
            if (this.pageCount2 > this.pageNo2) {
                this.pageNo2++;
                this.getCopyNews();
            }
        },
        getNews: function getNews() {
            var inst = this;
            var url = Urls.message_unreadMsgPage;
            var params = {
                pageNo: inst.pageNo,
                pageSize: inst.pageSize
            };
            inst.loading = true;
            inst.$root.doPost(url, params, function (server_data) {
                inst.loading = false;
                if (!inst.$root.isUserLogin(server_data)) {
                    return;
                }

                if (server_data.error) {
                    inst.$root.showGlobalError(server_data.error);
                    return;
                };
                inst.pageCount = server_data.data.pageCount;
                if (inst.pageNo == 1) {
                    inst.msgList = server_data.data.dataList;
                    inst.messageCount = server_data.data.totalCount;
                } else {
                    inst.msgList = inst.msgList.concat(server_data.data.dataList);
                }
            }, null, 1);
        },
        getUnreadCount: function getUnreadCount() {
            var inst = this;
            var url = Urls.message_unreadMsgCount;
            inst.$root.doPost(url, {}, function (server_data) {
                if (!inst.$root.isUserLogin(server_data)) {
                    return;
                }

                if (server_data.error) {
                    inst.$root.showGlobalError(server_data.error);
                    return;
                };
                inst.messageCount = server_data.data;
            }, null, 1);
        },
        getCopyNews: function getCopyNews() {
            var inst = this;
            var url = Urls.message_unreadCopyMsgPage;
            var params = {
                pageNo: inst.pageNo2,
                pageSize: inst.pageSize,
                isAwait: inst.isAwait
            };
            inst.loading = true;
            inst.$root.doPost(url, params, function (server_data) {
                inst.loading = false;
                if (!inst.$root.isUserLogin(server_data)) {
                    return;
                }

                if (server_data.error) {
                    inst.$root.showGlobalError(server_data.error);
                    return;
                };
                inst.pageCount2 = server_data.data.pageCount;
                if (inst.pageNo2 == 1) {
                    inst.msgList2 = server_data.data.dataList;
                    if (inst.isAwait) {
                        inst.messageCount2 = server_data.data.totalCount;
                    }
                } else {
                    inst.msgList2 = inst.msgList2.concat(server_data.data.dataList);
                }
            }, null, 1);
        },
        getUnreadCopyCount: function getUnreadCopyCount() {
            var inst = this;
            var url = Urls.message_unreadCopyMsgCount;
            inst.$root.doPost(url, { isAwait: 'Y' }, function (server_data) {
                if (!inst.$root.isUserLogin(server_data)) {
                    return;
                }

                if (server_data.error) {
                    inst.$root.showGlobalError(server_data.error);
                    return;
                };
                inst.messageCount2 = server_data.data;
            }, null, 1);
        },
        awaitChange: function awaitChange() {
            this.pageNo2 = 1;
            this.getCopyNews();
            if (this.$refs.msg2) {
                this.$refs.msg2.scrollTop = 0;
            }
        },

        toLogout: function toLogout() {
            var _this = this;
            this.$confirm('确认退出吗?', '提示', {}).then(function () {
                sessionStorage.removeItem('user');
                sessionStorage.removeItem('userPre');
                _this.loginOut();
            }).catch(function () {});
        },
        loginOut: function loginOut() {
            var inst = this;
            var url = Urls.user_logout;
            var params = {};
            inst.$root.doPost(url, params, function (server_data) {

                if (!inst.$root.isUserLogin(server_data)) {
                    return;
                }

                if (server_data.error) {
                    inst.$root.showGlobalError(server_data.error);
                    return;
                };
                inst.$router.push('/login');

                window.location.reload();
            });
        },
        changeUser: function changeUser() {
            this.loginOut();
        },

        collapse: function collapse() {
            this.collapsed = !this.collapsed;
        },
        showMenu: function showMenu(i, status) {
            this.$refs.menuCollapsed.getElementsByClassName('submenu-hook-' + i)[0].style.display = status ? 'block' : 'none';
        }
    },
    mounted: function mounted() {

        var user = sessionStorage.getItem('user');
        if (user) {
            user = JSON.parse(user);
            console.log("======", user);
            this.account = user.account || '';
            this.realName = user.realName || '';
            this.avatarPath = user.avatarPath;
            this.isProd = user.isProd;
        }

        var inst = this;
        this.$root.Bus.$on(Events.GLOBAL_USER_NOT_LOGIN, function () {
            inst.$refs.modalLogin.show();
        });

        inst.getUnreadCount();
        inst.getUnreadCopyCount();
        inst.messageIntval = setInterval(function () {
            inst.getUnreadCount();
            inst.getUnreadCopyCount();
        }, 1000 * 300);
    },

    computed: {
        key: function key() {
            return this.$route.path + Math.random();
        },
        showMessageStyle: function showMessageStyle() {
            var interval = 5;
        }
    },
    destroyed: function destroyed() {
        clearInterval(this.messageIntval);
    }
};

/***/ }),

/***/ 835:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(170);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(169);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _stringify = __webpack_require__(92);

var _stringify2 = _interopRequireDefault(_stringify);

var _jquery331SlimMin = __webpack_require__(366);

var _jquery331SlimMin2 = _interopRequireDefault(_jquery331SlimMin);

var _Urls = __webpack_require__(12);

var Urls = _interopRequireWildcard(_Urls);

var _VueHelper = __webpack_require__(17);

var VueHelper = _interopRequireWildcard(_VueHelper);

var _axios = __webpack_require__(94);

var _axios2 = _interopRequireDefault(_axios);

var _aliOss = __webpack_require__(168);

var _aliOss2 = _interopRequireDefault(_aliOss);

var _weixinJsSdk = __webpack_require__(250);

var _weixinJsSdk2 = _interopRequireDefault(_weixinJsSdk);

var _vant = __webpack_require__(83);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        fileExt: { type: String, default: "jpg,jpeg,png,bmp,gif,pdf,doc,docx,xls,xlsx,zip,rar" }
    },
    data: function data() {
        return {
            client: new _aliOss2.default({
                region: 'oss-cn-shenzhen',
                accessKeyId: 'LTAI4GGHb3kkSnv9MdPdPb4Y',
                accessKeySecret: 'yEOrbRYDSIJpgjGiZk9yTsuSAyava9',
                bucket: 'xmoty',
                timeout: 600000
            }),
            url: '',
            name: 'files',
            dataList: [],
            dialogVisible: false,
            delId: '',
            fileList: [],
            num: 0,
            loading: false,
            Journal: '',
            proId: '',
            content: '',
            list: [],
            ext: ['jpg', 'jpeg', 'png', 'bmp', 'gif', 'pdf', 'doc', 'docx', 'xls', 'xlsx', 'zip', 'rar']
        };
    },
    mounted: function mounted() {
        this.fileList = this.getUrlParam('dataList');
        this.Journal = this.$route.query.Journal;
        this.proId = this.$route.query.proId;
        this.content = this.$route.query.content;
        console.log(this.$route.query.content);
        this.list = JSON.parse(this.$route.query.dataList);
    },

    methods: {
        changeURLArg: function changeURLArg(url, arg, arg_val) {
            var pattern = arg + '=([^&]*)';
            var replaceText = arg + '=' + arg_val;
            if (url.match(pattern)) {
                var tmp = '/(' + arg + '=)([^&]*)/gi';
                tmp = url.replace(eval(tmp), replaceText);
                return tmp;
            } else {
                if (url.match('[\?]')) {
                    return url + '&' + replaceText;
                } else {
                    return url + '?' + replaceText;
                }
            }
            return url + '\n' + arg + '\n' + arg_val;
        },
        save: function save() {
            var dataList = [];
            this.dataList.map(function (item) {
                dataList.push({
                    id: item.id,
                    url: item.url
                });
            });
            var str = this.changeURLArg(window.location.href, 'dataList', (0, _stringify2.default)(this.fileList.concat(dataList)));
            _weixinJsSdk2.default.miniProgram.navigateTo({
                url: '/pages/packageMoney/pages/applyStampEditNew/main?' + str.split('?')[1]
            });
        },
        getUrlParam: function getUrlParam(name) {
            var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
            var r = window.location.href.split('?')[1] && window.location.href.split('?')[1].match(reg);
            if (r != null) {
                return decodeURIComponent(r[2]);
            }
            return null;
        },
        beforeUpload: function beforeUpload(file) {
            if (!this.checkAccept(file)) {
                return false;
            }

            if (!this.checkSize(file)) {
                return false;
            }
            return true;
        },
        checkSize: function checkSize(file) {
            if (this.isImage(file.name)) {
                var isLt2M = file.size / 1024 / 1024 < 20;
                if (!isLt2M) {
                    this.$message.error('图片大小不能超过 20M!');
                    return false;
                }
            } else {
                var _isLt2M = file.size / 1024 / 1024 < 200;
                if (!_isLt2M) {
                    this.$message.error('文档大小不能超过 200M!');
                    return false;
                }
            }
            return true;
        },
        checkAccept: function checkAccept(file) {
            var inst = this;
            var matchOne = false;
            var extList = inst.fileExt.split(",");
            for (var i = 0; i < extList.length; i++) {
                matchOne = new RegExp(extList[i] + "$").test(file.name.toLowerCase());
                if (matchOne) {
                    break;
                }
            }

            if (!matchOne) {
                this.loading = false;
                inst._showError('上传文件的后缀名必须是: ' + inst.fileExt + ' 之一');
                return false;
            }

            return true;
        },
        getUploadFinished: function getUploadFinished() {
            var fla = true;
            this.dataList.forEach(function (e) {
                if (!e.id) {
                    fla = false;
                }
            });
            return fla;
        },
        getAttachIds: function getAttachIds() {
            return VueHelper.getIdList(this.dataList);
        },
        setImagePreview: function setImagePreview() {
            var file_head = document.getElementById("file_head");
            var file = file_head.files[0];
            file.uid = file.lastModified;
            console.log(file_head.files[0].lastModified);
            var content = {
                file: file
            };
            this.myUpload(content);
        },
        setFilePreview: function setFilePreview() {
            var file_head2 = document.getElementById("file_head2");
            var file = file_head2.files[0];
            file.uid = file.lastModified;
            console.log(file_head2.files[0].lastModified);
            var content = {
                file: file
            };
            this.myUpload(content);
        },
        uploadfile: function uploadfile(upfile, name, uid) {
            console.log(upfile.requestUrls[0]);
            var inst = this;
            var url = Urls.new_upload_attach;
            var newUrl = upfile.requestUrls[0].replace('http://xmoty.oss-cn-shenzhen.aliyuncs.com', 'https://xmyun.zhoty.com').replace('https://xmoty.oss-cn-shenzhen.aliyuncs.com', 'https://xmyun.zhoty.com');
            var params = {
                url: newUrl,
                size: upfile.headers['content-length'] ? upfile.headers['content-length'] : 0,
                contentType: upfile.headers['content-type'],
                name: name,
                uid: uid
            };
            this.$root.ajaxPost(url, params, function (server_data) {
                inst.dataList.forEach(function (e) {
                    if (e.uid == server_data.uid) {
                        e.id = server_data.id;
                        e.url = server_data.url;
                    }
                });


                inst.list.push({ id: server_data.id, url: server_data.url, icon: inst.dataList[0].iconUrl });
                _weixinJsSdk2.default.miniProgram.redirectTo({
                    url: '/pages/packageInfo/pages/projectLogEdit/main?proId=' + inst.proId + '&pid=' + inst.proId + "&content=" + inst.content + '&dataList=' + (0, _stringify2.default)(inst.list)
                });
            });
        },
        myUpload: function myUpload(content) {
            var multipartUpload = function () {
                var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                    var result, head, iconUrl, hz;
                    return _regenerator2.default.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    _context.prev = 0;
                                    _context.next = 3;
                                    return inst.client.multipartUpload('xmerp/xmfiles/' + date.year + '/' + _month + '/' + _date + '/' + fileName + '.' + fileType, content.file, {
                                        progress: progress,

                                        meta: {
                                            year: 2020,
                                            people: 'test'
                                        }
                                    });

                                case 3:
                                    result = _context.sent;
                                    _context.next = 6;
                                    return inst.client.head('xmerp/xmfiles/' + date.year + '/' + _month + '/' + _date + '/' + fileName + '.' + fileType);

                                case 6:
                                    head = _context.sent;

                                    console.log(head);
                                    iconUrl = void 0;
                                    hz = inst.getCaption(head.res.requestUrls[0], 1);
                                    _context.t0 = hz;
                                    _context.next = _context.t0 === 'xls' ? 13 : _context.t0 === 'xlsx' ? 13 : _context.t0 === 'doc' ? 15 : _context.t0 === 'docx' ? 15 : _context.t0 === 'ppt' ? 17 : _context.t0 === 'pptx' ? 17 : _context.t0 === 'pdf' ? 19 : _context.t0 === 'rar' ? 21 : _context.t0 === 'zip' ? 21 : _context.t0 === 'jpg' ? 23 : _context.t0 === 'png' ? 23 : _context.t0 === 'gif' ? 23 : _context.t0 === 'jpeg' ? 23 : _context.t0 === 'bmp' ? 23 : 25;
                                    break;

                                case 13:
                                    iconUrl = 'http://xmyun.zhoty.com/resource/xapp-pm/static/image/fileShare/xls.png';
                                    return _context.abrupt('break', 27);

                                case 15:
                                    iconUrl = 'http://xmyun.zhoty.com/resource/xapp-pm/static/image/fileShare/word.png';
                                    return _context.abrupt('break', 27);

                                case 17:
                                    iconUrl = 'http://xmyun.zhoty.com/resource/xapp-pm/static/image/fileShare/ppt.png';
                                    return _context.abrupt('break', 27);

                                case 19:
                                    iconUrl = 'http://xmyun.zhoty.com/resource/xapp-pm/static/image/fileShare/pdf.png';
                                    return _context.abrupt('break', 27);

                                case 21:
                                    iconUrl = 'http://xmyun.zhoty.com/resource/xapp-pm/static/image/fileShare/zip.png';
                                    return _context.abrupt('break', 27);

                                case 23:
                                    iconUrl = head.res.requestUrls[0];
                                    return _context.abrupt('break', 27);

                                case 25:
                                    iconUrl = 'http://xmyun.zhoty.com/resource/xapp-pm/static/image/fileShare/tongyong.png';
                                    return _context.abrupt('break', 27);

                                case 27:

                                    inst.dataList.forEach(function (e) {
                                        if (content.file.uid == e.uid) {
                                            e.loading = false;
                                            e.iconUrl = iconUrl;
                                        }
                                    });

                                    _context.next = 30;
                                    return inst.uploadfile(head.res, content.file.name, content.file.uid);

                                case 30:
                                    _context.next = 36;
                                    break;

                                case 32:
                                    _context.prev = 32;
                                    _context.t1 = _context['catch'](0);

                                    if (_context.t1.code === 'ConnectionTimeoutError') {
                                        console.log('TimeoutError');
                                    }
                                    console.log(_context.t1);

                                case 36:
                                case 'end':
                                    return _context.stop();
                            }
                        }
                    }, _callee, this, [[0, 32]]);
                }));

                return function multipartUpload() {
                    return _ref.apply(this, arguments);
                };
            }();

            this.loading = true;
            var inst = this;
            var nowDate = new Date();
            var date = {
                year: nowDate.getFullYear(),
                month: nowDate.getMonth() + 1,
                date: nowDate.getDate()
            };

            var _month = date.month < 10 ? '0' + date.month : date.month;
            var _date = date.date < 10 ? '0' + date.date : date.date;
            var systemDate = date.year + _month + _date;
            var fileName = date.year + _month + _date + Date.now();

            var fileType = content.file.name.slice(content.file.name.lastIndexOf('.') + 1, content.file.name.length);

            if (!this.ext.includes(fileType)) {
                this.loading = false;
                (0, _vant.Toast)('\u4E0D\u652F\u6301' + fileType + '\u7C7B\u578B\u6587\u4EF6\u4E0A\u4F20');
                return;
            }

            inst.dataList.push({
                loading: true,
                percentage: 0,
                name: content.file.name,
                uid: content.file.uid
            });

            var progress = function progress(p, _checkpoint) {
                inst.dataList.forEach(function (e) {
                    if (_checkpoint && _checkpoint.file.uid == e.uid) {
                        e.percentage = Number((p * 100).toFixed(0));
                    }
                });
            };

            multipartUpload();
        },
        showAttachs: function showAttachs(attachIds) {
            if (!attachIds) return;
            var inst = this;
            var url = Urls.file_get_attach_list;
            var params = {
                'attachIds': (0, _stringify2.default)(attachIds)
            };
            console.log('params', params);

            this.$root.ajaxPost(url, params, function (data) {
                if (!data) {
                    return;
                }

                inst.dataList = [];

                for (var i = 0; i < data.length; i++) {
                    var attach = data[i];

                    var file = {
                        'id': attach.id,
                        'name': attach.name,
                        'url': attach.url,
                        'raw': { 'size': attach.size }
                    };
                    if (inst.mode == 'upload') {
                        inst._changeThumbnailIf(attach.url);
                    } else {
                        var previewUrl = inst.isImage(attach.url) ? attach.url : '/static/img/document.png';
                        file['previewUrl'] = previewUrl;
                    }
                    inst.dataList.push(file);
                }
                for (var _i = 0; _i < inst.dataList.length; _i++) {
                    var hz = inst.getCaption(inst.dataList[_i].url, 1);
                    switch (hz) {
                        case 'xls':case 'xlsx':
                            inst.dataList[_i].iconUrl = 'http://xmyun.zhoty.com/resource/xapp-pm/static/image/fileShare/xls.png';
                            break;
                        case 'doc':case 'docx':
                            inst.dataList[_i].iconUrl = 'http://xmyun.zhoty.com/resource/xapp-pm/static/image/fileShare/word.png';
                            break;
                        case 'ppt':case 'pptx':
                            inst.dataList[_i].iconUrl = 'http://xmyun.zhoty.com/resource/xapp-pm/static/image/fileShare/ppt.png';
                            break;
                        case 'pdf':
                            inst.dataList[_i].iconUrl = 'http://xmyun.zhoty.com/resource/xapp-pm/static/image/fileShare/pdf.png';
                            break;
                        case 'zip':case 'rar':
                            inst.dataList[_i].iconUrl = 'http://xmyun.zhoty.com/resource/xapp-pm/static/image/fileShare/zip.png';
                            break;
                        case 'jpg':case 'png':case 'gif':case 'jpeg':case 'bmp':
                            inst.dataList[_i].iconUrl = inst.dataList[_i].url;
                            break;
                        default:
                            inst.dataList[_i].iconUrl = 'http://xmyun.zhoty.com/resource/xapp-pm/static/image/fileShare/tongyong.png';
                            break;
                    }
                }
            });
        },
        getCaption: function getCaption(obj, state) {
            var index = obj.lastIndexOf("\.");
            if (state == 0) {
                obj = obj.substring(0, index);
            } else {
                obj = obj.substring(index + 1, obj.length);
            }
            return obj;
        },
        _showError: function _showError(msg) {
            this.$notify.error({
                title: '错误',
                message: msg,
                duration: 3000,
                position: 'bottom-right'
            });
        },
        _showSucc: function _showSucc(msg) {
            this.$notify({
                title: '成功',
                message: msg,
                type: 'success',
                duration: 3000,
                position: 'bottom-right'
            });
        },
        _changeThumbnailIf: function _changeThumbnailIf(file_url) {
            if (!this.isImage(file_url)) {
                this.$nextTick(function () {
                    (0, _jquery331SlimMin2.default)(".el-upload-list__item-thumbnail[src='" + file_url + "']").attr('src', '../static/img/document.png');
                });
            }
        },
        isImage: function isImage(data) {
            var imgLi = ['jpg', 'jpeg', 'png', 'bmp', 'gif'];
            var matchOne = false;

            for (var i = 0; i < imgLi.length; i++) {
                matchOne = new RegExp(imgLi[i] + "$").test(data.toLowerCase());
                if (matchOne) {
                    break;
                }
            }
            return matchOne;
        },
        deleteFile: function deleteFile(id) {
            this.delId = id;
            this.secondDelete();
        },
        secondDelete: function secondDelete() {
            var inst = this;
            var url = Urls.file_delete_attach;
            var params = {
                'id': this.delId
            };
            this.$root.doPost(url, params, function (server_data) {
                if (!inst.$root.isUserLogin(server_data)) {
                    return;
                }

                if (server_data.error) {
                    inst.$root.showGlobalError(server_data.error);
                    return;
                }

                var deleteId = inst.delId;
                for (var i = 0; i < inst.dataList.length; i++) {
                    if (deleteId == inst.dataList[i].id) {
                        inst.dataList.splice(i, 1);
                        break;
                    }
                }
            });
        },
        download: function download(url) {
            window.open(url);
        }
    }
};

/***/ }),

/***/ 836:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(92);

var _stringify2 = _interopRequireDefault(_stringify);

var _Urls = __webpack_require__(12);

var Urls = _interopRequireWildcard(_Urls);

var _VueHelper = __webpack_require__(17);

var VueHelper = _interopRequireWildcard(_VueHelper);

var _axios = __webpack_require__(94);

var _axios2 = _interopRequireDefault(_axios);

var _MenuUtils = __webpack_require__(91);

var _MenuUtils2 = _interopRequireDefault(_MenuUtils);

var _allMenu = __webpack_require__(171);

var _allMenu2 = _interopRequireDefault(_allMenu);

var _menu = __webpack_require__(172);

var _menu2 = _interopRequireDefault(_menu);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            flag: false,
            isLoading: false,
            loginForm: {
                account: '',
                password: '',
                userCode: ''
            },
            errorMsg: '',
            evnMsg: '',
            phone: '',
            certificate: '',
            switchFlag: false,
            countdown: 60,
            countDownSet: null,

            qrcodeLoading: true,
            isScanCode: true,
            sid: '',
            wxQrcode: '',
            qrcodePoll: null,
            isEXPIRED: false,
            loginStatus: ''
        };
    },
    created: function created() {},
    mounted: function mounted() {
        this.getWxLoginQrcode();
    },

    methods: {
        toggleLogin: function toggleLogin() {
            clearInterval(this.qrcodePoll);
            this.isScanCode = !this.isScanCode;
            if (this.isScanCode) {
                this.getWxLoginQrcode();
            }
        },
        getWxLoginQrcode: function getWxLoginQrcode() {
            var _this = this;

            this.qrcodeLoading = true;
            this.isEXPIRED = false;
            clearInterval(this.qrcodePoll);
            var url = Urls.wxlogin_qrcode;
            this.$root.doPost(url, {}, function (server_data) {
                _this.qrcodeLoading = false;
                var _server_data$data = server_data.data,
                    sid = _server_data$data.sid,
                    wxQrcode = _server_data$data.wxQrcode;

                _this.sid = sid;
                _this.wxQrcode = wxQrcode;
                _this.qrcodePoll = setInterval(function () {
                    _this.scanPoll();
                }, 2000);
            });
        },
        scanPoll: function scanPoll() {
            var _this2 = this;

            var url = Urls.scan_poll;
            var params = {
                sid: this.sid
            };
            this.$root.doPost(url, params, function (server_data) {
                var _server_data$data2 = server_data.data,
                    loginStatus = _server_data$data2.loginStatus,
                    nonceToken = _server_data$data2.nonceToken;

                _this2.loginStatus = loginStatus;

                if (loginStatus != 'WAITING') {
                    clearInterval(_this2.qrcodePoll);
                    _this2.wxQrcode = '';
                    _this2.isEXPIRED = true;
                }
                if (loginStatus == 'SUCCEED') {
                    _this2.getUserLoginInfo(nonceToken);
                }
            });
        },
        getUserLoginInfo: function getUserLoginInfo(nonceToken) {
            var _this3 = this;

            var url = Urls.token_login_info;
            var params = {
                nonceToken: nonceToken
            };
            this.$root.doPost(url, params, function (server_data) {
                _this3.generateRouter(server_data);
            });
        },
        getCode: function getCode() {
            this.switchFlag = true;
            var inst = this;
            var url = Urls.login_code;
            var params = {
                phone: this.phone
            };
            this.$root.doGet(url, params, function (server_data) {
                inst.countdown = 60;

                if (!inst.$root.isUserLogin(server_data)) {
                    return;
                }

                if (server_data.error) {
                    inst.$root.showGlobalError(server_data.error);
                    return;
                }
                inst.countDownSet = setInterval(function () {
                    if (inst.countdown > 0) {
                        inst.countdown--;
                    } else {
                        inst.switchFlag = false;
                        clearInterval(inst.countDownSet);
                    }
                }, 1000);
            });
        },
        doLogin: function doLogin() {
            var inst = this;
            inst.isLoading = true;
            var url = void 0,
                certificate = void 0,
                params = void 0;
            if (this.evnMsg) {
                url = Urls.login_by_code;
                params = VueHelper.makeSearchParams({
                    phone: this.phone,
                    smsCode: this.loginForm.userCode
                });
            } else {
                certificate = localStorage.getItem(this.loginForm.account + 'certificate');
                url = Urls.user_login;
                params = VueHelper.makeSearchParams({
                    account: this.loginForm.account,
                    password: this.loginForm.password,
                    certificate: certificate || this.certificate,
                    from_global_modal: 'N'
                });
            }
            _axios2.default.post(url, params).then(function (response) {
                console.log(response);
                inst.isLoading = false;

                var server_data = response.data;
                if (server_data.error) {
                    if (server_data.data) {
                        inst.evnMsg = server_data.error;
                        inst.phone = server_data.data.phone;
                        return;
                    }
                    inst.errorMsg = server_data.error;
                    return;
                }
                inst.errorMsg = '';
                sessionStorage.setItem('user', (0, _stringify2.default)(server_data.data));
                if (server_data.data.certificate) {
                    inst.certificate = server_data.data.certificate;
                    localStorage.setItem(inst.loginForm.account + 'certificate', inst.certificate);
                }
                var role = server_data.data.roleValue;
                console.log("role:" + role);

                var menu = _menu2.default;

                var roleMeun = server_data.data.roleMeun;
                var menuData = [];

                roleMeun.forEach(function (element, index) {
                    if (!element.children.length && element.workBenchList.length) {
                        menuData.push({
                            path: '/p' + index,
                            component: "HomeView",
                            redirect: element.workBenchList[0].benchPath,
                            name: element.menuName,
                            parent: true,
                            children: [{
                                pageAddress: element.workBenchList[0].benchComponent,
                                path: element.workBenchList[0].benchPath,
                                name: element.menuName
                            }]
                        });
                    } else if (!element.children[0].children.length) {
                        var data = {
                            path: '/p' + index,
                            redirect: '',
                            component: "HomeView",
                            name: element.menuName,
                            icon: element.menuIcon,
                            parent: true,
                            children: []
                        };
                        element.children.forEach(function (element2, index2) {
                            if (!element2.workBenchList.length) return;
                            data.children.push({
                                pageAddress: element2.workBenchList[0].benchComponent,
                                path: element2.workBenchList[0].benchPath,
                                name: element2.menuName,
                                icon: element2.menuIcon
                            });
                            if (index2 === 0) {
                                data.redirect = element2.workBenchList[0].benchPath;
                            }
                        });

                        menuData.push(data);
                    } else {
                        var _data = {
                            path: '/p' + index,
                            redirect: '',
                            component: "HomeView",
                            name: element.menuName,
                            icon: element.menuIcon,
                            parent: true,
                            children: []
                        };
                        element.children.forEach(function (element2, index2) {
                            var data2 = {
                                parent: true,
                                component: "Navigation",
                                path: "/home",
                                name: element2.menuName,
                                icon: element2.menuIcon,
                                children: [{
                                    pageAddress: 'views/welcomeView',
                                    path: "/home/welcomeView",
                                    hidden: true,
                                    name: "工作台"
                                }]
                            };
                            element2.children.forEach(function (element3, index3) {
                                if (!element3.workBenchList.length) return;
                                data2.children.push({
                                    pageAddress: element3.workBenchList[0].benchComponent,
                                    path: element3.workBenchList[0].benchPath,
                                    name: element3.menuName,
                                    icon: element3.menuIcon
                                });

                                if (index2 === 0 && index3 === 0) {
                                    if (_data.path == '/p0') {
                                        _data.redirect = '/home/welcomeView';
                                    } else {
                                        _data.redirect = element3.workBenchList[0].benchPath;
                                    }
                                }

                                for (var i = 0; i < menu.length; i++) {
                                    var obj = menu[i];
                                    if (obj.menuId == element.menuCode) {
                                        for (var j = 0; j < obj.children.length; j++) {
                                            var obj2 = obj.children[j];
                                            if (obj2.menuId == element2.menuCode) {
                                                data2.children = data2.children.concat(obj2.children);
                                                break;
                                            }
                                        }
                                    }
                                }
                            });
                            _data.children.push(data2);
                        });
                        menuData.push(_data);
                    }
                });

                if (menuData.length) {
                    menuData[0].path = '/';
                }

                menu.forEach(function (element, index) {
                    if (element.hidden && !element.redirect) {
                        menuData = menuData.concat(element);
                    }
                });

                window.sessionStorage.setItem('userPre', (0, _stringify2.default)(menuData));
                var routes = [];
                (0, _MenuUtils2.default)(routes, menuData);
                console.log("登录routes", routes);
                inst.$router.addRoutes(routes);
                inst.$router.push('/');

                sessionStorage.token = server_data.data.token;
            }).catch(function (error) {
                console.log(error);
                inst.$message({
                    message: '似乎网络不可用',
                    type: 'error'
                });
            });
        },
        generateRouter: function generateRouter(server_data) {
            this.errorMsg = '';
            sessionStorage.setItem('user', (0, _stringify2.default)(server_data.data));
            if (server_data.data.certificate) {
                this.certificate = server_data.data.certificate;
                localStorage.setItem(this.loginForm.account + 'certificate', this.certificate);
            }
            var role = server_data.data.roleValue;
            console.log("role:" + role);

            var menu = _menu2.default;

            var roleMeun = server_data.data.roleMeun;
            var menuData = [];

            roleMeun.forEach(function (element, index) {
                if (!element.children.length && element.workBenchList.length) {
                    menuData.push({
                        path: '/p' + index,
                        component: "HomeView",
                        redirect: element.workBenchList[0].benchPath,
                        name: element.menuName,
                        parent: true,
                        children: [{
                            pageAddress: element.workBenchList[0].benchComponent,
                            path: element.workBenchList[0].benchPath,
                            name: element.menuName
                        }]
                    });
                } else if (!element.children[0].children.length) {
                    var data = {
                        path: '/p' + index,
                        redirect: '',
                        component: "HomeView",
                        name: element.menuName,
                        icon: element.menuIcon,
                        parent: true,
                        children: []
                    };
                    element.children.forEach(function (element2, index2) {
                        if (!element2.workBenchList.length) return;
                        data.children.push({
                            pageAddress: element2.workBenchList[0].benchComponent,
                            path: element2.workBenchList[0].benchPath,
                            name: element2.menuName,
                            icon: element2.menuIcon
                        });
                        if (index2 === 0) {
                            data.redirect = element2.workBenchList[0].benchPath;
                        }
                    });

                    menuData.push(data);
                } else {
                    var _data2 = {
                        path: '/p' + index,
                        redirect: '',
                        component: "HomeView",
                        name: element.menuName,
                        icon: element.menuIcon,
                        parent: true,
                        children: []
                    };
                    element.children.forEach(function (element2, index2) {
                        var data2 = {
                            parent: true,
                            component: "Navigation",
                            path: "/home",
                            name: element2.menuName,
                            icon: element2.menuIcon,
                            children: [{
                                pageAddress: 'views/welcomeView',
                                path: "/home/welcomeView",
                                hidden: true,
                                name: "工作台"
                            }]
                        };
                        element2.children.forEach(function (element3, index3) {
                            if (!element3.workBenchList.length) return;
                            data2.children.push({
                                pageAddress: element3.workBenchList[0].benchComponent,
                                path: element3.workBenchList[0].benchPath,
                                name: element3.menuName,
                                icon: element3.menuIcon
                            });
                            if (index2 === 0 && index3 === 0) {
                                if (_data2.path == '/p0') {
                                    _data2.redirect = '/home/welcomeView';
                                } else {
                                    _data2.redirect = element3.workBenchList[0].benchPath;
                                }
                            }

                            for (var i = 0; i < menu.length; i++) {
                                var obj = menu[i];
                                if (obj.menuId == element.menuCode) {
                                    for (var j = 0; j < obj.children.length; j++) {
                                        var obj2 = obj.children[j];
                                        if (obj2.menuId == element2.menuCode) {
                                            data2.children = data2.children.concat(obj2.children);
                                            break;
                                        }
                                    }
                                }
                            }
                        });
                        _data2.children.push(data2);
                    });
                    menuData.push(_data2);
                }
            });

            if (menuData.length) {
                menuData[0].path = '/';
            }

            menu.forEach(function (element, index) {
                if (element.hidden && !element.redirect) {
                    menuData = menuData.concat(element);
                }
            });

            window.sessionStorage.setItem('userPre', (0, _stringify2.default)(menuData));
            var routes = [];
            (0, _MenuUtils2.default)(routes, menuData);
            console.log("登录routes", routes);
            this.$router.addRoutes(routes);
            this.$router.push('/');

            sessionStorage.token = server_data.data.token;
        }
    },
    beforeDestroy: function beforeDestroy() {
        clearInterval(this.countDownSet);
        clearInterval(this.qrcodePoll);
    },
    destroyed: function destroyed() {
        clearInterval(this.countDownSet);
        clearInterval(this.qrcodePoll);
    }
};

/***/ }),

/***/ 837:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toConsumableArray2 = __webpack_require__(31);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _MenuUtils = __webpack_require__(91);

var _MenuUtils2 = _interopRequireDefault(_MenuUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {},
    data: function data() {
        return {
            isProd: '',
            isActiveName: '',
            isShowNoPass: false };
    },
    created: function created() {
        var _nodes;

        var inst = this;
        var data = JSON.parse(window.sessionStorage.getItem('userPre'));

        this.nodes = [];
        (_nodes = this.nodes).push.apply(_nodes, (0, _toConsumableArray3.default)(data));
    },

    methods: {
        pushHandle: function pushHandle(disable, path) {
            if (!disable) {
                this.$router.push(path);
            } else {}
        }
    },
    mounted: function mounted() {
        var user = sessionStorage.getItem('user');
        if (user) {
            user = JSON.parse(user);
            this.isProd = user.isProd;
        }
    },


    computed: {}
};

/***/ }),

/***/ 838:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toConsumableArray2 = __webpack_require__(31);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _Events = __webpack_require__(204);

var Events = _interopRequireWildcard(_Events);

var _Navi = __webpack_require__(264);

var _Navi2 = _interopRequireDefault(_Navi);

var _MenuUtils = __webpack_require__(91);

var _MenuUtils2 = _interopRequireDefault(_MenuUtils);

var _Urls = __webpack_require__(12);

var Urls = _interopRequireWildcard(_Urls);

var _VueHelper = __webpack_require__(17);

var VueHelper = _interopRequireWildcard(_VueHelper);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        Navi: _Navi2.default
    },
    data: function data() {
        return {
            nodes: this.$router.options.routes,
            isCollapse: false
        };
    },
    created: function created() {
        var _nodes;

        var inst = this;
        var data = JSON.parse(window.sessionStorage.getItem('userPre'));

        this.nodes = [];
        (_nodes = this.nodes).push.apply(_nodes, (0, _toConsumableArray3.default)(data));
        console.log(this.nodes);
    },

    methods: {
        toggle: function toggle() {
            this.$nextTick(function () {
                var myEvent = new Event('resize');
                window.dispatchEvent(myEvent);
            });
        }
    },
    mounted: function mounted() {},


    computed: {
        secendNode: function secendNode() {
            var inst = this;
            var path = this.$route.path;
            for (var i = 0; i < this.nodes.length; i++) {
                var item = this.nodes[i];
                console.log(item);
                if (!item.children) {
                    continue;
                }
                for (var j = 0; j < item.children.length; j++) {
                    var children = item.children[j];

                    if (!children.children) {
                        continue;
                    }
                    for (var k = 0; k < children.children.length; k++) {
                        var child = children.children[k];

                        if (child.path == path) {
                            inst.isActiveName = item.name;
                            return item.children;
                            break;
                        }
                    }
                }
            }

            return [];
        }
    }
};

/***/ }),

/***/ 839:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(92);

var _stringify2 = _interopRequireDefault(_stringify);

var _Urls = __webpack_require__(12);

var Urls = _interopRequireWildcard(_Urls);

var _VueHelper = __webpack_require__(17);

var VueHelper = _interopRequireWildcard(_VueHelper);

var _MenuUtils = __webpack_require__(91);

var _MenuUtils2 = _interopRequireDefault(_MenuUtils);

var _allMenu = __webpack_require__(171);

var _allMenu2 = _interopRequireDefault(_allMenu);

var _menu = __webpack_require__(172);

var _menu2 = _interopRequireDefault(_menu);

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

var _appNav = __webpack_require__(249);

var _appNav2 = _interopRequireDefault(_appNav);

var _vant = __webpack_require__(83);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            checked: false,
            navIndex: 0,
            show: false,
            code: '031ajC000wIBEM1aMd200nMtb10ajC0y',
            pageNo: 1,
            pageSize: 10,
            pageCount: 0,
            agentList: [],
            totalCount: 0,
            openWxMsgRemid: ''
        };
    },
    created: function created() {
        var userInfo = JSON.parse(sessionStorage.getItem('user'));
        this.openWxMsgRemid = userInfo && userInfo.openWxMsgRemid;

        this.getAgentList();
    },

    components: {
        Dialog: _vant.Dialog, Toast: _vant.Toast, Nav: _appNav2.default
    },
    methods: {
        changeStatu: function changeStatu() {
            var inst = this;
            var userInfo = JSON.parse(sessionStorage.getItem('user'));
            var url = Urls.message_open_close;
            var params = { userId: userInfo.userId };
            this.$root.doGet(url, params, function (server_data) {
                if (server_data.error) {
                    (0, _vant.Toast)(server_data.error);
                    return;
                }
                inst.openWxMsgRemid = server_data.data.openWxMsgRemid;
                userInfo.openWxMsgRemid = inst.openWxMsgRemid;
                sessionStorage.setItem('user', (0, _stringify2.default)(userInfo));
            });
        },
        load: function load() {
            if (this.pageCount > this.pageNo) {
                this.pageNo++;
                this.getAgentList();
            }
        },
        GetUrlParame: function GetUrlParame(parameName) {
            var parames = window.location.search;
            if (parames.indexOf(parameName) > -1) {
                var parameValue = "";
                parameValue = parames.substring(parames.indexOf(parameName), parames.length);
                if (parameValue.indexOf("&") > -1) {
                    parameValue = parameValue.substring(0, parameValue.indexOf("&"));
                    parameValue = parameValue.replace(parameName + "=", "");
                    return parameValue;
                }
                return "";
            }
        },
        wxAutoLogin: function wxAutoLogin() {
            var inst = this;
            var url = Urls.wx_auto_login;
            var params = {
                wxCode: this.code
            };
            this.$root.doPost(url, params, function (server_data) {
                if (server_data.returnCode == 30) {
                    sessionStorage.setItem('wxOpenId', server_data.data.wxOpenId);
                    var _str = window.location.href;
                    window.location.href = _str.split('?')[0] + '#' + '/appLogin';
                    return;
                }
                sessionStorage.setItem('user', (0, _stringify2.default)(server_data.data));
                inst.openWxMsgRemid = server_data.data.openWxMsgRemid;
                var role = server_data.data.roleValue;

                var menu = _menu2.default;

                var roleMeun = server_data.data.roleMeun;
                var menuData = [];

                roleMeun.forEach(function (element, index) {
                    if (!element.children.length && element.workBenchList.length) {
                        menuData.push({
                            path: '/p' + index,
                            component: "HomeView",
                            redirect: element.workBenchList[0].benchPath,
                            name: element.menuName,
                            parent: true,
                            children: [{
                                pageAddress: element.workBenchList[0].benchComponent,
                                path: element.workBenchList[0].benchPath,
                                name: element.menuName
                            }]
                        });
                    } else if (!element.children[0].children.length) {
                        var data = {
                            path: '/p' + index,
                            redirect: '',
                            component: "HomeView",
                            name: element.menuName,
                            icon: element.menuIcon,
                            parent: true,
                            children: []
                        };
                        element.children.forEach(function (element2, index2) {
                            if (!element2.workBenchList.length) return;
                            data.children.push({
                                pageAddress: element2.workBenchList[0].benchComponent,
                                path: element2.workBenchList[0].benchPath,
                                name: element2.menuName,
                                icon: element2.menuIcon
                            });
                            if (index2 === 0) {
                                data.redirect = element2.workBenchList[0].benchPath;
                            }
                        });

                        menuData.push(data);
                    } else {
                        var _data = {
                            path: '/p' + index,
                            redirect: '',
                            component: "HomeView",
                            name: element.menuName,
                            icon: element.menuIcon,
                            parent: true,
                            children: []
                        };
                        element.children.forEach(function (element2, index2) {
                            var data2 = {
                                parent: true,
                                component: "Navigation",
                                path: "/home",
                                name: element2.menuName,
                                icon: element2.menuIcon,
                                children: []
                            };
                            element2.children.forEach(function (element3, index3) {
                                if (!element3.workBenchList.length) return;
                                data2.children.push({
                                    pageAddress: element3.workBenchList[0].benchComponent,
                                    path: element3.workBenchList[0].benchPath,
                                    name: element3.menuName,
                                    icon: element3.menuIcon
                                });
                                if (index2 === 0 && index3 === 0) {
                                    _data.redirect = element3.workBenchList[0].benchPath;
                                }

                                for (var i = 0; i < menu.length; i++) {
                                    var obj = menu[i];
                                    if (obj.menuId == element.menuCode) {
                                        for (var j = 0; j < obj.children.length; j++) {
                                            var obj2 = obj.children[j];
                                            if (obj2.menuId == element2.menuCode) {
                                                data2.children = data2.children.concat(obj2.children);
                                                break;
                                            }
                                        }
                                    }
                                }
                            });
                            _data.children.push(data2);
                        });
                        menuData.push(_data);
                    }
                });

                if (menuData.length) {
                    menuData[0].path = '/';
                }

                menu.forEach(function (element, index) {
                    if (element.hidden && !element.redirect) {
                        menuData = menuData.concat(element);
                    }
                });

                window.sessionStorage.setItem('userPre', (0, _stringify2.default)(menuData));
                var routes = [];
                (0, _MenuUtils2.default)(routes, menuData);
                inst.$router.addRoutes(routes);

                sessionStorage.token = server_data.data.token;
                inst.getAgentList();
                inst.$refs.nav.getUnreadCount();
                inst.$refs.nav.getUnreadCopyCount();
                var str = window.location.href;
                window.location.href = str.split('?')[0] + '#' + '/appLogin/agent';
            });
        },
        formatTime: function formatTime(data) {
            if (data) {
                return (0, _moment2.default)(data).format("HH:mm");
            } else {
                return '';
            }
        },
        getAgentList: function getAgentList() {
            var inst = this;
            var url = Urls.message_unreadMsgPage;
            var params = {
                pageNo: this.pageNo,
                pageSize: this.pageSize
            };
            this.$root.doPost(url, params, function (server_data) {
                if (server_data.sessionExpire == 'Y') {
                    var local = window.location.href;
                    var appid = 'wxc3eb167e153f976a';
                    inst.code = inst.GetUrlParame("code");
                    if (inst.code == null || inst.code === '') {
                        window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + appid + '&redirect_uri=' + encodeURIComponent(local) + '&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect';
                    } else {
                        inst.wxAutoLogin();
                    }
                }
                var page = server_data.data;
                page.dataList.map(function (item) {
                    var pre = new Date(new Date().toLocaleDateString()).getTime() - 1;
                    var old = new Date(new Date().toLocaleDateString()).getTime() - 1 - 24 * 60 * 60 * 1000;
                    var getTime = new Date(inst.$root.formatDay(item.initiateTime)).getTime();
                    if (getTime < old) {
                        item.initiateTime = inst.$root.formatDay(item.initiateTime);
                    } else if (old < getTime && getTime < pre) {
                        item.initiateTime = '昨天';
                    } else {
                        item.initiateTime = inst.formatTime(item.initiateTime);
                    }
                });

                if (inst.pageNo == 1) {
                    inst.agentList = page.dataList;
                    inst.pageCount = page.pageCount;
                } else {
                    inst.agentList = inst.agentList.concat(page.dataList);
                }
                inst.totalCount = page.totalCount;
            });
        }
    }
};

/***/ }),

/***/ 840:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Urls = __webpack_require__(12);

var Urls = _interopRequireWildcard(_Urls);

var _VueHelper = __webpack_require__(17);

var VueHelper = _interopRequireWildcard(_VueHelper);

var _vant = __webpack_require__(83);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = {
    props: {
        navIndex: {
            type: Number,
            default: 0
        }
    },
    data: function data() {
        return {
            messageIntval: null,
            messageCount: 0,
            messageCount2: 0
        };
    },

    components: {
        Toast: _vant.Toast
    },
    created: function created() {
        var _this = this;

        this.messageCount = sessionStorage.getItem('messageCount') ? sessionStorage.getItem('messageCount') : 0;
        this.messageCount2 = sessionStorage.getItem('messageCount2') ? sessionStorage.getItem('messageCount2') : 0;
        this.getUnreadCount();
        this.getUnreadCopyCount();
        this.messageIntval = setInterval(function () {
            _this.getUnreadCount();
            _this.getUnreadCopyCount();
        }, 1000 * 10);
    },

    methods: {
        goRout: function goRout(navIndex) {
            switch (navIndex) {
                case 0:
                    this.$router.push('/appLogin/agent');break;
                case 1:
                    this.$router.push('/appLogin/copy');break;
                case 2:
                    this.$router.push('/appLogin/appUserInfo');break;
            }
        },
        getUnreadCount: function getUnreadCount() {
            var inst = this;
            var url = Urls.message_unreadMsgCount;
            inst.$root.doPost(url, {}, function (server_data) {
                inst.messageCount = server_data.data > 99 ? '99+' : server_data.data;
                sessionStorage.setItem('messageCount', inst.messageCount);
            }, null, 1);
        },
        getUnreadCopyCount: function getUnreadCopyCount() {
            var inst = this;
            var url = Urls.message_unreadCopyMsgCount;
            inst.$root.doPost(url, { isAwait: 'Y' }, function (server_data) {
                inst.messageCount2 = server_data.data > 99 ? '99+' : server_data.data;
                sessionStorage.setItem('messageCount2', inst.messageCount2);
            }, null, 1);
        }
    },
    destroyed: function destroyed() {
        clearInterval(this.messageIntval);
    }
};

/***/ }),

/***/ 841:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(93);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _appNav = __webpack_require__(249);

var _appNav2 = _interopRequireDefault(_appNav);

var _Urls = __webpack_require__(12);

var Urls = _interopRequireWildcard(_Urls);

var _VueHelper = __webpack_require__(17);

var VueHelper = _interopRequireWildcard(_VueHelper);

var _vant = __webpack_require__(83);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            show: false,
            userInfo: {
                avatarPath: 'https://xmyun.zhoty.com/resource/xmwebapp/user-portrait.png'
            }
        };
    },
    created: function created() {
        this.userInfo = JSON.parse(sessionStorage.getItem('user'));
        if (!userInfo.wxOpenId) {
            this.$router.push('/appLogin/agent');
        }
    },

    components: (0, _defineProperty3.default)({
        Nav: _appNav2.default, Toast: _vant.Toast }, _vant.Dialog.Component.name, _vant.Dialog.Component),
    methods: {
        btn: function btn() {
            this.show = true;
        },
        removeInfo: function removeInfo() {
            var inst = this;
            var url = Urls.wx_remove_info;
            inst.$root.doPost(url, { userId: this.userInfo.userId }, function (server_data) {
                if (server_data.sessionExpire == 'Y') {
                    return;
                }

                if (server_data.error) {
                    (0, _vant.Toast)(server_data.error);
                    return;
                };
                sessionStorage.clear();
                inst.$router.push('/appLogin/agent');
            }, null, 1);
        }
    }
};

/***/ }),

/***/ 842:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(92);

var _stringify2 = _interopRequireDefault(_stringify);

var _Urls = __webpack_require__(12);

var Urls = _interopRequireWildcard(_Urls);

var _VueHelper = __webpack_require__(17);

var VueHelper = _interopRequireWildcard(_VueHelper);

var _MenuUtils = __webpack_require__(91);

var _MenuUtils2 = _interopRequireDefault(_MenuUtils);

var _allMenu = __webpack_require__(171);

var _allMenu2 = _interopRequireDefault(_allMenu);

var _menu = __webpack_require__(172);

var _menu2 = _interopRequireDefault(_menu);

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

var _appNav = __webpack_require__(249);

var _appNav2 = _interopRequireDefault(_appNav);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            checked: true,
            pageNo: 1,
            pageSize: 10,
            pageCount: 0,
            copytList: [],
            openWxMsgRemid: ''
        };
    },
    created: function created() {
        var userInfo = JSON.parse(sessionStorage.getItem('user'));
        this.openWxMsgRemid = userInfo && userInfo.openWxMsgRemid;
        this.getCopytList();
    },

    methods: {
        changeStatu: function changeStatu() {
            var inst = this;
            var userInfo = JSON.parse(sessionStorage.getItem('user'));
            var url = Urls.message_open_close;
            var params = { userId: userInfo.userId };
            this.$root.doGet(url, params, function (server_data) {
                if (server_data.error) {
                    Toast(server_data.error);
                    return;
                }
                inst.openWxMsgRemid = server_data.data.openWxMsgRemid;
                userInfo.openWxMsgRemid = inst.openWxMsgRemid;
                sessionStorage.setItem('user', (0, _stringify2.default)(userInfo));
            });
        },
        GetUrlParame: function GetUrlParame(parameName) {
            var parames = window.location.search;
            if (parames.indexOf(parameName) > -1) {
                var parameValue = "";
                parameValue = parames.substring(parames.indexOf(parameName), parames.length);
                if (parameValue.indexOf("&") > -1) {
                    parameValue = parameValue.substring(0, parameValue.indexOf("&"));
                    parameValue = parameValue.replace(parameName + "=", "");
                    return parameValue;
                }
                return "";
            }
        },
        wxAutoLogin: function wxAutoLogin() {
            var inst = this;
            var url = Urls.wx_auto_login;
            var params = {
                wxCode: this.code
            };
            this.$root.doPost(url, params, function (server_data) {
                if (server_data.returnCode == 30) {
                    sessionStorage.setItem('wxOpenId', server_data.data.wxOpenId);
                    var _str = window.location.href;
                    window.location.href = _str.split('?')[0] + '#' + '/appLogin';
                    return;
                }
                sessionStorage.setItem('user', (0, _stringify2.default)(server_data.data));
                inst.openWxMsgRemid = server_data.data.openWxMsgRemid;
                var role = server_data.data.roleValue;

                var menu = _menu2.default;

                var roleMeun = server_data.data.roleMeun;
                var menuData = [];

                roleMeun.forEach(function (element, index) {
                    if (!element.children.length && element.workBenchList.length) {
                        menuData.push({
                            path: '/p' + index,
                            component: "HomeView",
                            redirect: element.workBenchList[0].benchPath,
                            name: element.menuName,
                            parent: true,
                            children: [{
                                pageAddress: element.workBenchList[0].benchComponent,
                                path: element.workBenchList[0].benchPath,
                                name: element.menuName
                            }]
                        });
                    } else if (!element.children[0].children.length) {
                        var data = {
                            path: '/p' + index,
                            redirect: '',
                            component: "HomeView",
                            name: element.menuName,
                            icon: element.menuIcon,
                            parent: true,
                            children: []
                        };
                        element.children.forEach(function (element2, index2) {
                            if (!element2.workBenchList.length) return;
                            data.children.push({
                                pageAddress: element2.workBenchList[0].benchComponent,
                                path: element2.workBenchList[0].benchPath,
                                name: element2.menuName,
                                icon: element2.menuIcon
                            });
                            if (index2 === 0) {
                                data.redirect = element2.workBenchList[0].benchPath;
                            }
                        });

                        menuData.push(data);
                    } else {
                        var _data = {
                            path: '/p' + index,
                            redirect: '',
                            component: "HomeView",
                            name: element.menuName,
                            icon: element.menuIcon,
                            parent: true,
                            children: []
                        };
                        element.children.forEach(function (element2, index2) {
                            var data2 = {
                                parent: true,
                                component: "Navigation",
                                path: "/home",
                                name: element2.menuName,
                                icon: element2.menuIcon,
                                children: []
                            };
                            element2.children.forEach(function (element3, index3) {
                                if (!element3.workBenchList.length) return;
                                data2.children.push({
                                    pageAddress: element3.workBenchList[0].benchComponent,
                                    path: element3.workBenchList[0].benchPath,
                                    name: element3.menuName,
                                    icon: element3.menuIcon
                                });
                                if (index2 === 0 && index3 === 0) {
                                    _data.redirect = element3.workBenchList[0].benchPath;
                                }

                                for (var i = 0; i < menu.length; i++) {
                                    var obj = menu[i];
                                    if (obj.menuId == element.menuCode) {
                                        for (var j = 0; j < obj.children.length; j++) {
                                            var obj2 = obj.children[j];
                                            if (obj2.menuId == element2.menuCode) {
                                                data2.children = data2.children.concat(obj2.children);
                                                break;
                                            }
                                        }
                                    }
                                }
                            });
                            _data.children.push(data2);
                        });
                        menuData.push(_data);
                    }
                });

                if (menuData.length) {
                    menuData[0].path = '/';
                }

                menu.forEach(function (element, index) {
                    if (element.hidden && !element.redirect) {
                        menuData = menuData.concat(element);
                    }
                });

                window.sessionStorage.setItem('userPre', (0, _stringify2.default)(menuData));
                var routes = [];
                (0, _MenuUtils2.default)(routes, menuData);
                inst.$router.addRoutes(routes);


                sessionStorage.token = server_data.data.token;
                inst.getCopytList();
                inst.$refs.nav.getUnreadCount();
                inst.$refs.nav.getUnreadCopyCount();
                var str = window.location.href;
                window.location.href = str.split('?')[0] + '#' + '/appLogin/copy';
            });
        },
        formatTime: function formatTime(data) {
            if (data) {
                return (0, _moment2.default)(data).format("HH:mm");
            } else {
                return '';
            }
        },
        load: function load() {
            if (this.pageCount > this.pageNo) {
                this.pageNo++;
                this.getCopytList();
            }
        },
        getCopytList: function getCopytList() {
            var _ref = [this.checked ? 'Y' : '', this, Urls.message_unreadCopyMsgPage],
                isAwait = _ref[0],
                inst = _ref[1],
                url = _ref[2];

            var params = {
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                isAwait: isAwait
            };
            this.$root.doPost(url, params, function (server_data) {
                if (server_data.sessionExpire == 'Y') {
                    var local = window.location.href;
                    var appid = 'wxc3eb167e153f976a';
                    inst.code = inst.GetUrlParame("code");
                    if (inst.code == null || inst.code === '') {
                        window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + appid + '&redirect_uri=' + encodeURIComponent(local) + '&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect';
                    } else {
                        inst.wxAutoLogin();
                    }
                }
                var page = server_data.data;
                page.dataList.map(function (item) {
                    var pre = new Date(new Date().toLocaleDateString()).getTime() - 1;
                    var old = new Date(new Date().toLocaleDateString()).getTime() - 1 - 24 * 60 * 60 * 1000;
                    var getTime = new Date(inst.$root.formatDay(item.initiateTime)).getTime();
                    if (getTime < old) {
                        item.initiateTime = inst.$root.formatDay(item.initiateTime);
                    } else if (old < getTime && getTime < pre) {
                        item.initiateTime = '昨天';
                    } else {
                        item.initiateTime = inst.formatTime(item.initiateTime);
                    }
                });
                if (inst.pageNo == 1) {
                    inst.copytList = page.dataList;
                    inst.pageCount = page.pageCount;
                } else {
                    inst.copytList = inst.copytList.concat(page.dataList);
                }
                inst.totalCount = page.totalCount;
            });
        }
    },
    components: {
        Nav: _appNav2.default
    }
};

/***/ }),

/***/ 843:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(31);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _HeadControl = __webpack_require__(43);

var _HeadControl2 = _interopRequireDefault(_HeadControl);

var _Urls = __webpack_require__(12);

var Urls = _interopRequireWildcard(_Urls);

var _VueHelper = __webpack_require__(17);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    HeadControl: _HeadControl2.default
  },
  data: function data() {
    return {
      orgCode: "",
      dataRange: [],
      progressData: {},
      progressMaxNum: 0,
      progressMaxPercent: 0,
      designRegionData: [],
      abnormalData: [],
      percent1: 0,
      abnormalTotal: 0,
      abnormalTypeData: {},
      abnormalMaxNum: 0,
      abnormalMaxPercent: 0,
      screenWidth: document.body.clientWidth,
      isH5: false,
      reportList: []
    };
  },

  methods: {
    init: function init() {
      this.$refs.headControl.getDatas('month');
      this.$refs.headControl.getSysOrg();
    },
    changeVal: function changeVal(val) {
      this.orgCode = val;
      this.getProgressData();
      this.getDesignRegionData();
      this.getAbnormalData();
      this.getAbnormalTypeData();
      this.getBuyingIsMoneyAndNumber();
    },
    changDate: function changDate(val) {
      this.dataRange = val;
      this.getProgressData();
      this.getDesignRegionData();
      this.getAbnormalData();
      this.getAbnormalTypeData();
      this.getBuyingIsMoneyAndNumber();
    },
    changePicker: function changePicker(val) {
      this.dataRange = val;
      this.getProgressData();
      this.getDesignRegionData();
      this.getAbnormalData();
      this.getAbnormalTypeData();
      this.getBuyingIsMoneyAndNumber();
    },
    aFormat: function aFormat(amount) {
      return (0, _VueHelper.amountFormat)(amount);
    },
    getBuyingIsMoneyAndNumber: function getBuyingIsMoneyAndNumber() {
      var _this = this;

      var url = Urls.getEchartsProjectOrDesignOrBuyingIsMoneyAndNumber;
      var params = {
        orgCode: this.orgCode || "",
        startTime: this.dataRange.length ? this.dataRange[0] : "",
        endTime: this.dataRange.length ? this.dataRange[1] : "",
        contractCat: 'DESIGN'
      };
      this.$root.doPost(url, params, function (server_data) {
        if (!_this.$root.isUserLogin(server_data)) {
          return;
        }

        if (server_data.error) {
          _this.$root.showGlobalError(server_data.error);
          return;
        }
        _this.reportList = server_data.data.reportList;
      });
    },
    initProgressChart: function initProgressChart() {
      var _this2 = this;

      this.progressDataChart = this.$echarts.init(this.$refs.progressData);
      var option = {
        textStyle: {
          fontFamily: 'PingFang-M'
        },
        title: {
          text: "进度比例",
          padding: this.isH5 ? [24, 0, 0, 20] : [24, 0, 0, 30],
          textStyle: {
            fontWeight: 'normal'
          }
        },
        grid: {
          left: this.isH5 ? 24 : 33,
          top: 97,
          right: this.isH5 ? 24 : 33,
          bottom: 29,
          containLabel: true
        },
        opacity: 0.1,
        tooltip: {
          trigger: "axis",
          formatter: function formatter(params) {
            var message = '';
            params.reverse().forEach(function (item, index) {
              if (item.seriesIndex == 1) {
                message += item.axisValue + ': ' + item.data + '个' + '<br>';
              } else {
                message += '占比: ' + item.data + '%';
              }
            });
            return "<div style=\"padding: 5px 8px; font-size: 12px\">" + message + "</div>";
          }
        },
        legend: {
          data: this.progressData.legend,
          itemWidth: 40,
          itemHeight: 8,
          top: '20',
          left: this.isH5 ? '120' : '180',
          itemGap: 20,
          textStyle: {
            fontSize: '13',
            height: 10,
            rich: {
              a: {
                verticalAlign: 'middle'
              }
            }
          }
        },
        xAxis: [{
          type: "category",
          data: this.progressData.xAxis.data,

          splitLine: {
            show: this.progressData.series[1].data.reduce(function (a, b) {
              return a + b;
            }) === 0 ? false : true,
            lineStyle: {
              color: "#ddd"
            }
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: this.progressData.series[1].data.reduce(function (a, b) {
              return a + b;
            }) === 0 ? true : false,
            lineStyle: {
              color: '#ddd'
            }
          },
          axisLabel: {
            color: '#666',
            margin: 20
          },
          axisPointer: {
            type: 'none'
          }
        }],
        yAxis: [{
          show: this.progressData.series[1].data.reduce(function (a, b) {
            return a + b;
          }) === 0 ? false : true,

          type: "value",
          name: "百分比",
          min: 0,
          max: this.progressMaxPercent,
          splitNumber: 5,
          interval: this.progressMaxPercent / 5,
          axisLabel: {
            formatter: "{value}%",
            margin: 20
          },

          nameTextStyle: {
            padding: [0, 65, 0, 0]
          },
          axisTick: {
            length: 16,
            lineStyle: {
              color: "#ddd"
            }
          },
          axisLine: {
            show: false
          },
          splitLine: {
            show: false
          }
        }, {
          show: this.progressData.series[1].data.reduce(function (a, b) {
            return a + b;
          }) === 0 ? false : true,
          type: "value",
          name: "数量（个）",
          min: 0,
          max: this.progressMaxNum,
          splitNumber: 5,
          interval: this.progressMaxNum / 5,

          nameTextStyle: {
            padding: [0, 0, 0, 40]
          },
          axisTick: {
            length: 16,
            lineStyle: {
              color: "#ddd"
            }
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            margin: 20,
            formatter: function formatter(value) {
              return parseInt(value);
            }
          },
          splitLine: {
            lineStyle: {
              color: "#ddd"
            }
          }
        }],
        series: [{
          name: this.progressData.series[0].name,
          type: "bar",
          barWidth: '60%',
          data: this.progressData.series[0].data,
          itemStyle: {
            normal: {
              color: 'rgba(87, 185, 255, 0.35)',
              borderColor: this.progressData.series[1].data.reduce(function (a, b) {
                return a + b;
              }) === 0 ? 'rgba(87, 185, 255, 0)' : 'rgba(87, 185, 255, 1)'
            }
          },
          yAxisIndex: 0
        }, {
          name: this.progressData.series[1].name,
          type: "line",
          symbol: "rect",
          symbolSize: 9,
          hoverAnimation: false,
          data: this.progressData.series[1].data,
          itemStyle: {
            normal: {
              color: "#61d9ac",
              opacity: this.progressData.series[1].data.reduce(function (a, b) {
                return a + b;
              }) === 0 ? 0 : 1
            },
            emphasis: {
              borderWidth: 3,
              borderColor: '#61d9ac',
              color: '#61d9ac'
            }
          },
          lineStyle: {
            normal: {
              opacity: this.progressData.series[1].data.reduce(function (a, b) {
                return a + b;
              }) === 0 ? 0 : 1
            }
          },
          yAxisIndex: 1
        }]
      };
      this.progressDataChart.setOption(option);
      window.addEventListener("resize", function () {
        _this2.isH5 ? _this2.progressDataChart.resize({ width: _this2.screenWidth - 24 }) : _this2.progressDataChart.resize();
      });
      this.isH5 ? this.progressDataChart.resize({ width: this.screenWidth - 24 }) : this.progressDataChart.resize();
    },
    initAbnormalDataChart: function initAbnormalDataChart() {
      var _this3 = this;

      this.abnormalDataChart = this.$echarts.init(this.$refs.abnormalData);
      var option = {
        textStyle: {
          fontFamily: 'PingFang-M'
        },
        color: ["#57B9FF", "#FFB96E", "#E5E5E5"],
        series: [{
          name: this.abnormalData[0].name,
          type: "pie",
          startAngle: 180,
          center: this.isH5 ? ["25%", "50%"] : ["30%", "50%"],
          radius: this.isH5 ? ["35%", "39%"] : this.radius,
          avoidLabelOverlap: false,
          hoverAnimation: false,
          selectedOffset: 0,
          label: {
            normal: {
              show: false,
              position: "center",

              formatter: function formatter(params) {
                _this3.percent1 = params.percent.toFixed(0);
                var str = "{a|" + params.name + "}\n{b|" + params.value + "}{a|\u4E2A}\n{c|" + _this3.percent1 + "%}";
                return str;
              },
              textStyle: {
                rich: {
                  a: {
                    color: "#666",
                    fontSize: this.isH5 ? 12 : 14,
                    lineHeight: this.isH5 ? 20 : 25
                  },
                  b: {
                    color: "#333",
                    fontSize: this.isH5 ? 18 : 26,
                    fontWeight: 500,
                    lineHeight: this.isH5 ? 20 : 30
                  },
                  c: {
                    fontSize: this.isH5 ? 12 : 14,
                    lineHeight: this.isH5 ? 15 : 20
                  }
                }
              }
            }
          },
          labelLine: {
            show: false
          },
          data: [{
            value: this.abnormalData[0].value,
            name: this.abnormalData[0].name,
            selected: true,
            label: {
              normal: {
                show: true,
                fontSize: "20",
                color: "#57B9FF"
              }
            }
          }, {
            value: this.abnormalData[0].value === 0 ? 10 : this.abnormalData[1].value,
            name: this.abnormalData[0].name,
            itemStyle: {
              normal: { color: "#e5e5e5" },
              emphasis: { color: "#e5e5e5" }
            }
          }]
        }, {
          name: this.abnormalData[1].name,
          type: "pie",
          startAngle: this.startAngle,

          center: ["70%", "50%"],
          radius: this.isH5 ? ["35%", "39%"] : this.radius,
          avoidLabelOverlap: false,
          hoverAnimation: false,
          selectedOffset: 0,
          label: {
            normal: {
              show: false,
              position: "center",
              formatter: function formatter(params) {
                var str = "{a|" + params.name + "}\n{b|" + params.value + "}{a|\u4E2A}\n{c|" + (_this3.abnormalTotal === 0 ? 0 : 100 - _this3.percent1) + "%}";
                return str;
              },
              textStyle: {
                rich: {
                  a: {
                    color: "#666",
                    fontSize: this.isH5 ? 12 : 14,
                    lineHeight: this.isH5 ? 20 : 25
                  },
                  b: {
                    color: "#333",
                    fontSize: this.isH5 ? 18 : 26,
                    fontWeight: 500,
                    lineHeight: this.isH5 ? 20 : 30
                  },
                  c: {
                    fontSize: this.isH5 ? 12 : 14,
                    lineHeight: this.isH5 ? 15 : 20
                  }
                }
              }
            }
          },
          labelLine: {
            show: false
          },
          data: [{
            value: this.abnormalData[1].value,
            name: this.abnormalData[1].name,
            selected: true,
            label: {
              normal: {
                show: true,
                fontSize: "20",
                color: "#FFB96E"
              }
            }
          }, {
            value: this.abnormalData[1].value === 0 ? 10 : this.abnormalData[0].value,
            name: this.abnormalData[1].name,
            itemStyle: {
              normal: { color: "#e5e5e5" },
              emphasis: { color: "#e5e5e5" }
            }
          }]
        }]
      };
      this.abnormalDataChart.setOption(option);
      window.addEventListener("resize", function () {
        _this3.isH5 ? _this3.abnormalDataChart.resize({ width: (_this3.screenWidth - 24) * 0.8 }) : _this3.abnormalDataChart.resize();
      });
      this.isH5 ? this.abnormalDataChart.resize({ width: (this.screenWidth - 24) * 0.8 }) : this.abnormalDataChart.resize();
    },
    initAbnormalTypeChart: function initAbnormalTypeChart() {
      var _this4 = this;

      this.abnormalTypeChart = this.$echarts.init(this.$refs.abnormalType);
      var option = {
        textStyle: {
          fontFamily: 'PingFang-M'
        },
        title: {
          text: "异常类型",
          padding: this.isH5 ? [24, 0, 0, 20] : [24, 0, 0, 30],
          textStyle: {
            fontWeight: 'normal'
          }
        },
        grid: {
          left: this.isH5 ? 24 : 33,
          top: 97,
          right: this.isH5 ? 24 : 33,
          bottom: 17,
          containLabel: true
        },
        opacity: 0.1,
        tooltip: {
          trigger: "axis",
          formatter: function formatter(params) {
            var message = '';
            params.reverse().forEach(function (item, index) {
              if (item.seriesIndex == 1) {
                message += item.axisValue + ': ' + item.data + '个' + '<br>';
              } else {
                message += '占比: ' + item.data + '%';
              }
            });
            return "<div style=\"padding: 5px 8px; font-size: 12px\">" + message + "</div>";
          }
        },
        legend: {
          data: this.abnormalTypeData.legend,
          itemWidth: 40,
          itemHeight: 8,
          top: '20',
          left: this.isH5 ? '120' : '180',
          itemGap: 20,
          textStyle: {
            fontSize: '13',
            height: 10,
            rich: {
              a: {
                verticalAlign: 'middle'
              }
            }
          }
        },
        xAxis: [{
          type: "category",
          data: this.abnormalTypeData.xAxis.data,
          axisPointer: {
            type: 'none'
          },

          splitLine: {
            show: this.abnormalTypeData.series[1].data.reduce(function (a, b) {
              return a + b;
            }) === 0 ? false : true,
            lineStyle: {
              color: "#ddd"
            }
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: this.abnormalTypeData.series[1].data.reduce(function (a, b) {
              return a + b;
            }) === 0 ? true : false,
            lineStyle: {
              color: '#ddd'
            }
          },
          axisLabel: {
            color: '#666',
            margin: 12
          }
        }],
        yAxis: [{
          show: this.abnormalTypeData.series[1].data.reduce(function (a, b) {
            return a + b;
          }) === 0 ? false : true,

          type: "value",
          name: "百分比",
          min: 0,
          max: this.abnormalMaxPercent,
          splitNumber: 5,
          interval: this.abnormalMaxPercent / 5,
          axisLabel: {
            formatter: "{value}%",
            margin: 20
          },

          nameTextStyle: {
            padding: [0, 65, 0, 0]
          },
          axisTick: {
            length: 16,
            lineStyle: {
              color: "#ddd"
            }
          },
          axisLine: {
            show: false
          },
          splitLine: {
            show: false
          }
        }, {
          show: this.abnormalTypeData.series[1].data.reduce(function (a, b) {
            return a + b;
          }) === 0 ? false : true,
          type: "value",
          name: "数量（个）",
          min: 0,
          max: this.abnormalMaxNum,
          splitNumber: 5,
          interval: this.abnormalMaxNum / 5,

          nameTextStyle: {
            padding: [0, 0, 0, 40]
          },
          axisTick: {
            length: 16,
            lineStyle: {
              color: "#ddd"
            }
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            margin: 20,
            formatter: function formatter(value) {
              return parseInt(value);
            }
          },
          splitLine: {
            lineStyle: {
              color: "#ddd"
            }
          }
        }],
        series: [{
          name: this.abnormalTypeData.series[0].name,
          type: "bar",
          barWidth: '60%',
          data: this.abnormalTypeData.series[0].data,
          itemStyle: {
            normal: {
              color: 'rgba(87, 185, 255, 0.35)',
              borderColor: this.abnormalTypeData.series[1].data.reduce(function (a, b) {
                return a + b;
              }) === 0 ? 'rgba(87, 185, 255, 0)' : 'rgba(87, 185, 255, 1)'
            }
          },
          yAxisIndex: 0
        }, {
          name: this.abnormalTypeData.series[1].name,
          type: "line",
          symbol: "rect",
          symbolSize: 9,
          hoverAnimation: false,
          data: this.abnormalTypeData.series[1].data,
          itemStyle: {
            normal: {
              color: "#61d9ac",
              opacity: this.abnormalTypeData.series[1].data.reduce(function (a, b) {
                return a + b;
              }) === 0 ? 0 : 1
            },
            emphasis: {
              borderWidth: 3,
              borderColor: '#61d9ac',
              color: '#61d9ac'
            }
          },
          lineStyle: {
            normal: {
              opacity: this.abnormalTypeData.series[1].data.reduce(function (a, b) {
                return a + b;
              }) === 0 ? 0 : 1
            }
          },
          yAxisIndex: 1
        }]
      };
      this.abnormalTypeChart.setOption(option);
      window.addEventListener("resize", function () {
        _this4.isH5 ? _this4.abnormalTypeChart.resize({ width: _this4.screenWidth - 24 }) : _this4.abnormalTypeChart.resize();
      });
      this.isH5 ? this.abnormalTypeChart.resize({ width: this.screenWidth - 24 }) : this.abnormalTypeChart.resize();
    },
    getProgressData: function getProgressData() {
      var _this5 = this;

      var url = Urls.getEchartsDesignTypeReportItemData;
      var params = {
        orgCode: this.orgCode || "",
        startTime: this.dataRange.length ? this.dataRange[0] : "",
        endTime: this.dataRange.length ? this.dataRange[1] : ""
      };
      this.$root.doPost(url, params, function (server_data) {
        if (!_this5.$root.isUserLogin(server_data)) {
          return;
        }

        if (server_data.error) {
          _this5.$root.showGlobalError(server_data.error);
          return;
        }
        _this5.progressData = server_data.data;
      });
    },
    getDesignRegionData: function getDesignRegionData() {
      var _this6 = this;

      var url = Urls.getEchartsDesignReportDataByRegion;
      var params = {
        orgCode: this.orgCode || "",
        startTime: this.dataRange.length ? this.dataRange[0] : "",
        endTime: this.dataRange.length ? this.dataRange[1] : "",
        itemCode: "PROJECT_REGION"
      };
      this.$root.doPost(url, params, function (server_data) {
        if (!_this6.$root.isUserLogin(server_data)) {
          return;
        }

        if (server_data.error) {
          _this6.$root.showGlobalError(server_data.error);
          return;
        }
        _this6.designRegionData = server_data.data.reportList;
      });
    },
    getAbnormalData: function getAbnormalData() {
      var _this7 = this;

      var url = Urls.getEchartsDesignReportItemData;
      var params = {
        orgCode: this.orgCode || "",
        startTime: this.dataRange.length ? this.dataRange[0] : "",
        endTime: this.dataRange.length ? this.dataRange[1] : ""
      };
      this.$root.doPost(url, params, function (server_data) {
        if (!_this7.$root.isUserLogin(server_data)) {
          return;
        }

        if (server_data.error) {
          _this7.$root.showGlobalError(server_data.error);
          return;
        }
        _this7.abnormalData = server_data.data;
        _this7.abnormalTotal = 0;
        _this7.abnormalData.forEach(function (item) {
          _this7.abnormalTotal += item.value;
        });
      });
    },
    getAbnormalTypeData: function getAbnormalTypeData() {
      var _this8 = this;

      var url = Urls.getEchartsDesignAbnormalTypeReportItemData;
      var params = {
        orgCode: this.orgCode || "",
        startTime: this.dataRange.length ? this.dataRange[0] : "",
        endTime: this.dataRange.length ? this.dataRange[1] : ""
      };
      this.$root.doPost(url, params, function (server_data) {
        if (!_this8.$root.isUserLogin(server_data)) {
          return;
        }

        if (server_data.error) {
          _this8.$root.showGlobalError(server_data.error);
          return;
        }
        _this8.abnormalTypeData = server_data.data;
      });
    }
  },
  computed: {
    startAngle: function startAngle() {
      var total = this.abnormalData[0].value + this.abnormalData[1].value;
      if (total === 0) {
        return 180;
      } else {
        var res = this.abnormalData[0].value / total * 360;
        if (res > 180) {
          return 360 + (180 - res);
        } else {
          return 180 - res;
        }
      }
    },
    radius: function radius() {
      return this.screenWidth < 1366 ? ["45%", "49%"] : ["50%", "54%"];
    }
  },
  watch: {
    progressData: function progressData(newVal) {
      if (newVal) {
        this.progressMaxNum = Math.ceil(Math.max.apply(Math, (0, _toConsumableArray3.default)(newVal.series[1].data)) / 10) * 10;
        this.progressMaxPercent = Math.ceil(Math.max.apply(Math, (0, _toConsumableArray3.default)(newVal.series[0].data)) / 10) * 10;
        this.initProgressChart();
      }
    },
    abnormalData: function abnormalData(newVal) {
      if (newVal) {
        this.initAbnormalDataChart();
      }
    },
    abnormalTypeData: function abnormalTypeData(newVal) {
      if (newVal) {
        this.abnormalMaxNum = Math.ceil(Math.max.apply(Math, (0, _toConsumableArray3.default)(newVal.series[1].data)) / 10) * 10;
        this.abnormalMaxPercent = Math.ceil(Math.max.apply(Math, (0, _toConsumableArray3.default)(newVal.series[0].data)) / 10) * 10;
        this.initAbnormalTypeChart();
      }
    },
    screenWidth: function screenWidth(newVal) {
      this.initAbnormalDataChart();
    }
  },
  mounted: function mounted() {
    var _this9 = this;

    if (this.$route.query.identification) {
      this.isH5 = true;
    }
    window.onresize = function () {
      return function () {
        window.screenWidth = document.body.clientWidth;
        _this9.screenWidth = window.screenWidth;
      }();
    };
  }
};

/***/ }),

/***/ 844:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(31);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _Urls = __webpack_require__(12);

var Urls = _interopRequireWildcard(_Urls);

var _HeadControl = __webpack_require__(43);

var _HeadControl2 = _interopRequireDefault(_HeadControl);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      orgCode: "",
      dataRange: [],
      abnormalNum: {},
      abnormalProgressList: [],
      abnormalTypeData: {},
      maxNum: 0,
      maxPercent: 0,
      screenWidth: document.body.clientWidth,
      isH5: false
    };
  },

  components: {
    HeadControl: _HeadControl2.default
  },
  methods: {
    init: function init() {
      this.$refs.headControl.getDatas('month');
      this.$refs.headControl.getSysOrg();
    },
    changeVal: function changeVal(val) {
      this.orgCode = val;
      this.getAbnormalNum();
      this.getProjectAbnormalData();
    },
    changDate: function changDate(val) {
      this.dataRange = val;
      this.getAbnormalNum();
      this.getProjectAbnormalData();
    },
    changePicker: function changePicker(val) {
      this.dataRange = val;
      this.getAbnormalNum();
      this.getProjectAbnormalData();
    },
    getAbnormalNum: function getAbnormalNum() {
      var _this = this;

      var url = Urls.getEchartsAbnormalReportDataBySource;
      var params = {
        orgCode: this.orgCode || "",
        startTime: this.dataRange.length ? this.dataRange[0] : "",
        endTime: this.dataRange.length ? this.dataRange[1] : "",
        itemCode: "ABNROMAL_NUM"
      };
      this.$root.doPost(url, params, function (server_data) {
        if (!_this.$root.isUserLogin(server_data)) {
          return;
        }

        if (server_data.error) {
          _this.$root.showGlobalError(server_data.error);
          return;
        }
        _this.abnormalNum = server_data.data;
      });
    },
    getProjectAbnormalData: function getProjectAbnormalData() {
      var _this2 = this;

      var url = Urls.getEchartsAbnormalTypeReportItemData;
      var params = {
        orgCode: this.orgCode,
        startTime: this.dataRange.length ? this.dataRange[0] : "",
        endTime: this.dataRange.length ? this.dataRange[1] : "",
        itemCode: "ABNORMAL_TYPE"
      };
      this.$root.doPost(url, params, function (server_data) {
        if (!_this2.$root.isUserLogin(server_data)) {
          return;
        }

        if (server_data.error) {
          _this2.$root.showGlobalError(server_data.error);
          return;
        }
        _this2.abnormalTypeData = server_data.data;
      });
    },
    initAbnormalNumChart: function initAbnormalNumChart() {
      var _this3 = this;

      this.abnormalNumChart = this.$echarts.init(this.$refs.abnormalNum);
      var option = {
        textStyle: {
          fontFamily: 'PingFang-M'
        },
        grid: {
          left: this.isH5 ? 20 : 60,
          top: 32,
          right: this.isH5 ? 20 : 60,
          bottom: 30
        },
        xAxis: {
          show: false,
          type: "value"
        },
        tooltip: {
          trigger: 'item',
          formatter: function formatter(params) {
            return "<div style=\"font-size:14px; padding:4px;\">\n                         <div>" + params.name + "\uFF1A" + _this3.abnormalNum.series[0].data[params.dataIndex] + "\u4E2A</div>\n                         <div>\u5360\u6BD4\uFF1A" + params.value + "%</div>\n                     </div>";
          }
        },
        yAxis: [{
          type: "category",
          inverse: true,
          axisLabel: {
            formatter: function formatter(val, index) {
              var res = "";
              _this3.abnormalNum.series[0].data.forEach(function (item, i) {
                if (i == index) {
                  res = item;
                }
              });
              return val + ("\uFF08" + res + "\u4E2A\uFF09");
            },
            textStyle: {
              color: "#666666",
              fontSize: "14",
              lineHeight: 20
            },
            padding: [0, 0, 40, 15],
            align: 'left',
            rich: {}
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          data: this.abnormalNum.yAxis.data
        }, {
          type: "category",
          inverse: true,
          axisTick: "none",
          axisLine: "none",
          position: "left",
          show: true,
          axisLabel: {
            textStyle: {
              color: "#57b9ff",
              fontSize: "14"
            },
            padding: [0, 0, -40, 15],
            formatter: "({value}%)",
            align: 'left',
            rich: {}
          },
          data: this.abnormalNum.series[0].percent
        }],
        series: [{
          type: "bar",
          zlevel: 1,
          itemStyle: {
            normal: {
              barBorderRadius: 10,
              color: "#57b9ff"
            }
          },
          barWidth: 10,
          data: this.abnormalNum.series[0].percent
        }, {
          type: "bar",
          silent: true,
          barWidth: 10,
          barGap: "-100%",
          data: this.abnormalProgressList,
          itemStyle: {
            normal: {
              color: "#eeeeee",
              barBorderRadius: 10
            }
          }
        }]
      };
      this.abnormalNumChart.setOption(option);
      window.addEventListener("resize", function () {
        _this3.isH5 ? _this3.abnormalNumChart.resize({ width: _this3.screenWidth - 24 }) : _this3.abnormalNumChart.resize();
      });
      this.isH5 ? this.abnormalNumChart.resize({ width: this.screenWidth - 24 }) : this.abnormalNumChart.resize();
    },
    initAbnormalTypeChart: function initAbnormalTypeChart() {
      var _this4 = this;

      this.abnormalTypeChart = this.$echarts.init(this.$refs.abnormalType);
      var option = {
        textStyle: {
          fontFamily: 'PingFang-M'
        },
        title: {
          text: "异常类型",
          padding: this.isH5 ? [24, 0, 0, 20] : [24, 0, 0, 30],
          textStyle: {
            fontWeight: 'normal'
          }
        },
        grid: {
          left: this.isH5 ? 24 : 33,
          top: 97,
          right: this.isH5 ? 30 : 33,
          bottom: 29,
          containLabel: true
        },
        opacity: 0.1,
        tooltip: {
          trigger: "axis",
          formatter: function formatter(params) {
            var message = '';
            params.reverse().forEach(function (item, index) {
              if (item.seriesIndex == 1) {
                message += item.axisValue + ': ' + item.data + '个' + '<br>';
              } else {
                message += '占比: ' + item.data + '%';
              }
            });
            return "<div style=\"padding: 5px 8px; font-size: 12px\">" + message + "</div>";
          }
        },
        legend: {
          data: this.abnormalTypeData.legend,
          itemWidth: 40,
          itemHeight: 8,
          top: '20',
          left: this.isH5 ? '120' : '180',
          itemGap: 20,
          textStyle: {
            fontSize: '13',
            height: 10,
            rich: {
              a: {
                verticalAlign: 'middle'
              }
            }
          }
        },
        xAxis: [{
          type: "category",
          data: this.abnormalTypeData.xAxis.data,
          axisPointer: {
            type: 'none'
          },
          zlevel: 5,

          splitLine: {
            show: this.abnormalTypeData.series[1].data.reduce(function (a, b) {
              return a + b;
            }) === 0 ? false : true,
            lineStyle: {
              color: "#ddd"
            }
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: this.abnormalTypeData.series[1].data.reduce(function (a, b) {
              return a + b;
            }) === 0 ? true : false,
            lineStyle: {
              color: '#ddd'
            }
          },
          axisLabel: {
            color: '#666',
            margin: 20
          }
        }],
        yAxis: [{
          show: this.abnormalTypeData.series[1].data.reduce(function (a, b) {
            return a + b;
          }) === 0 ? false : true,

          type: "value",
          name: "百分比",
          min: 0,
          max: this.maxPercent,
          splitNumber: 5,
          interval: this.maxPercent / 5,
          axisLabel: {
            formatter: "{value}%",
            margin: 20
          },

          nameTextStyle: {
            padding: [0, 65, 0, 0]
          },
          axisTick: {
            length: 16,
            lineStyle: {
              color: "#ddd"
            }
          },
          axisLine: {
            show: false
          },
          splitLine: {
            show: false
          }
        }, {
          show: this.abnormalTypeData.series[1].data.reduce(function (a, b) {
            return a + b;
          }) === 0 ? false : true,
          type: "value",
          name: "数量（个）",
          min: 0,
          max: this.maxNum,
          splitNumber: 5,
          interval: this.maxNum / 5,

          nameTextStyle: {
            padding: [0, 0, 0, 60]
          },
          axisTick: {
            length: 16,
            lineStyle: {
              color: "#ddd"
            }
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            margin: 20,
            formatter: function formatter(value) {
              return parseInt(value);
            }
          },
          splitLine: {
            lineStyle: {
              color: "#ddd"
            }
          }
        }],
        series: [{
          name: this.abnormalTypeData.series[0].name,
          type: "bar",
          barWidth: "40%",
          data: this.abnormalTypeData.series[0].data,
          itemStyle: {
            normal: {
              color: 'rgba(87, 185, 255, 0.35)',
              borderColor: this.abnormalTypeData.series[1].data.reduce(function (a, b) {
                return a + b;
              }) === 0 ? 'rgba(87, 185, 255, 0)' : 'rgba(87, 185, 255, 1)'
            }
          },
          yAxisIndex: 0
        }, {
          name: this.abnormalTypeData.series[1].name,
          type: "line",
          symbol: "rect",
          symbolSize: 9,
          hoverAnimation: false,
          data: this.abnormalTypeData.series[1].data,
          itemStyle: {
            normal: {
              color: "#61d9ac",
              opacity: this.abnormalTypeData.series[1].data.reduce(function (a, b) {
                return a + b;
              }) === 0 ? 0 : 1
            },
            emphasis: {
              borderWidth: 3,
              borderColor: '#61d9ac',
              color: '#61d9ac'
            }
          },
          lineStyle: {
            normal: {
              opacity: this.abnormalTypeData.series[1].data.reduce(function (a, b) {
                return a + b;
              }) === 0 ? 0 : 1
            }
          },
          yAxisIndex: 1
        }]
      };
      this.abnormalTypeChart.setOption(option);
      window.addEventListener("resize", function () {
        _this4.isH5 ? _this4.abnormalTypeChart.resize({ width: _this4.screenWidth - 24 }) : _this4.abnormalTypeChart.resize();
      });
      this.isH5 ? this.abnormalTypeChart.resize({ width: this.screenWidth - 24 }) : this.abnormalTypeChart.resize();
    }
  },
  watch: {
    abnormalNum: function abnormalNum(newVal) {
      var _this5 = this;

      this.abnormalProgressList = [];
      if (newVal) {
        newVal.series[0].data.forEach(function (item, index) {
          _this5.abnormalProgressList[index] = 100;
        });
        this.initAbnormalNumChart();
      }
    },
    abnormalTypeData: function abnormalTypeData(newVal) {
      if (newVal) {
        this.maxNum = Math.ceil(Math.max.apply(Math, (0, _toConsumableArray3.default)(newVal.series[1].data)) / 10) * 10;
        this.maxPercent = Math.ceil(Math.max.apply(Math, (0, _toConsumableArray3.default)(newVal.series[0].data)) / 10) * 10;
        this.initAbnormalTypeChart();
      }
    }
  },
  mounted: function mounted() {
    var _this6 = this;

    if (this.$route.query.identification) {
      this.isH5 = true;
    }
    window.onresize = function () {
      return function () {
        window.screenWidth = document.body.clientWidth;
        _this6.screenWidth = window.screenWidth;
      }();
    };
  }
};

/***/ }),

/***/ 845:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(93);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _toConsumableArray2 = __webpack_require__(31);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _HeadControl = __webpack_require__(43);

var _HeadControl2 = _interopRequireDefault(_HeadControl);

var _Urls = __webpack_require__(12);

var Urls = _interopRequireWildcard(_Urls);

var _VueHelper = __webpack_require__(17);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    HeadControl: _HeadControl2.default
  },
  data: function data() {
    return {
      orgCode: "",
      dataRange: [],
      reportList: [],
      ProgressDataList: '',
      SendOrdersDataList: '',
      RegionDataList: '',
      ApplyingProjectList: '',
      ProjectLevelList: '',
      progressLsit: [],
      Judge: '',
      screenWidth: document.body.clientWidth };
  },

  methods: {
    init: function init() {
      this.$refs.headControl.getDatas('month');
      this.$refs.headControl.getSysOrg();
    },
    changeVal: function changeVal(val) {
      this.orgCode = val;
      this.getProgressData();
      this.getSendOrdersData();
      this.getRegion();
      this.getApplyingProject();
      this.getProjectLevel();
      this.getBuyingIsMoneyAndNumber();
    },
    changDate: function changDate(val) {
      this.dataRange = val;
      this.getProgressData();
      this.getSendOrdersData();
      this.getRegion();
      this.getApplyingProject();
      this.getProjectLevel();
      this.getBuyingIsMoneyAndNumber();
    },
    changePicker: function changePicker(val) {
      this.dataRange = val;
      this.getProgressData();
      this.getSendOrdersData();
      this.getRegion();
      this.getApplyingProject();
      this.getProjectLevel();
      this.getBuyingIsMoneyAndNumber();
    },
    aFormat: function aFormat(amount) {
      return (0, _VueHelper.amountFormat)(amount);
    },
    getBuyingIsMoneyAndNumber: function getBuyingIsMoneyAndNumber() {
      var _this2 = this;

      var url = Urls.getEchartsProjectOrDesignOrBuyingIsMoneyAndNumber;
      var params = {
        orgCode: this.orgCode || "",
        startTime: this.dataRange.length ? this.dataRange[0] : "",
        endTime: this.dataRange.length ? this.dataRange[1] : "",
        contractCat: 'PROJECT'
      };
      this.$root.doPost(url, params, function (server_data) {
        if (!_this2.$root.isUserLogin(server_data)) {
          return;
        }

        if (server_data.error) {
          _this2.$root.showGlobalError(server_data.error);
          return;
        }
        _this2.reportList = server_data.data.reportList;
      });
    },
    getProgressData: function getProgressData() {
      var _this = this;
      var url = Urls.getEchartsCollectReportDataByProgressRatio;
      var params = {
        orgCode: this.orgCode || "",
        startTime: this.dataRange.length ? this.dataRange[0] : "",
        endTime: this.dataRange.length ? this.dataRange[1] : "",
        itemCode: ''
      };
      this.$root.doPost(url, params, function (server_data) {
        if (!_this.$root.isUserLogin(server_data)) {
          return;
        }

        if (server_data.error) {
          _this.$root.showGlobalError(server_data.error);
          return;
        }
        _this.ProgressDataList = server_data.data;
      });
    },
    initChart1: function initChart1() {
      var _this3 = this;

      var _ProgressDataList = this.ProgressDataList,
          legend = _ProgressDataList.legend,
          series = _ProgressDataList.series,
          xAxis = _ProgressDataList.xAxis;

      var statePercent = Math.ceil(Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].data)) / 10) * 10;
      var stateEntries = Math.ceil(Math.max.apply(Math, (0, _toConsumableArray3.default)(series[1].data)) / 10) * 10;
      var Chart1 = this.$echarts.getInstanceByDom(this.$refs.ProgressProportion);
      if (Chart1 == null) {
        this.myChart1 = this.$echarts.init(this.$refs.ProgressProportion);
      }
      var option = {
        textStyle: {
          fontFamily: 'PingFang-M'
        },
        title: {
          text: '进度比例',
          top: '24',
          left: this.$route.query.identification ? '20' : '30',
          textStyle: {
            fontWeight: 500
          }
        },
        grid: {
          left: this.$route.query.identification ? '34' : this.screenWidth <= 1366 ? '8%' : '5%',
          right: this.$route.query.identification ? '15%' : '4.5%',
          bottom: '20px',
          top: this.$route.query.identification ? '30%' : '90px',
          containLabel: true
        },
        opacity: 0.1,
        tooltip: {
          trigger: 'axis',
          formatter: function formatter(params) {
            var h = '<div>';
            params.reverse().forEach(function (item) {
              if (item.seriesIndex == 1) {
                h += '<div>' + item.axisValue + '\uFF1A' + item.data + '\u4E2A</div>';
              } else {
                h += '<div>\u5360\u6BD4\uFF1A' + item.data + '%</div></div>';
              }
            });
            return h;
          }
        },
        legend: {
          data: legend,
          itemWidth: 40,
          itemHeight: 8,
          itemGap: 20,
          x: this.$route.query.identification ? '110' : '180',
          y: '24',
          textStyle: {
            fontSize: '13',
            height: 10,
            rich: {
              a: {
                verticalAlign: 'middle'
              }
            }
          }
        },
        xAxis: [(0, _defineProperty3.default)({
          type: 'category',
          offset: 5,
          data: xAxis.data,
          axisPointer: {
            type: 'shadow'
          },

          splitLine: {
            show: Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].data).concat((0, _toConsumableArray3.default)(series[1].data))) == 0 ? false : true,
            lineStyle: {
              color: '#DDDDDD'
            }
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#DDDDDD'
            }
          },
          axisLabel: {
            color: '#666666'
          }
        }, 'axisPointer', {
          type: 'none'
        })],
        yAxis: [{
          offset: 5,
          type: 'value',
          name: '百分比',
          show: Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].data)) == 0 ? false : true,
          min: 0,
          max: statePercent,
          splitNumber: 5,
          interval: statePercent / 5,
          axisLabel: {
            formatter: '{value}%',
            textStyle: {
              color: '#666666'
            }
          },

          splitLine: {
            show: true,
            lineStyle: {
              color: '#DDDDDD'
            }
          },

          nameTextStyle: {
            color: '#666666',
            padding: this.$route.query.identification ? [0, 30, 0, 0] : [0, 40, 0, 0]
          },
          axisTick: false,
          axisLine: {
            show: false }
        }, {
          type: 'value',
          name: '数量（个）',
          show: Math.max.apply(Math, (0, _toConsumableArray3.default)(series[1].data)) == 0 ? false : true,
          min: 0,
          max: stateEntries,

          splitNumber: 5,
          interval: stateEntries / 5,
          axisLabel: {
            formatter: function formatter(params) {
              return parseInt(params);
            },
            textStyle: {
              color: '#666666'
            }
          },

          splitLine: {
            show: true,
            lineStyle: {
              color: '#DDDDDD'
            }
          },

          nameTextStyle: {
            color: '#666666',
            padding: [0, 20, 0, 38]
          },
          axisTick: false,
          axisLine: {
            show: false }
        }],
        series: [{
          name: series[0].name,
          type: 'bar',
          barWidth: this.$route.query.identification ? '50%' : '80%',
          data: series[0].data,
          itemStyle: {
            normal: {
              color: 'rgba(87,185,255,0.35)',
              borderColor: Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].data)) == 0 ? 'rgba(87,185,255,0)' : 'rgba(87,185,255,1)'
            }
          }
        }, {
          name: series[1].name,
          type: 'line',
          symbol: 'rect',
          symbolSize: 9,
          yAxisIndex: 1,
          hoverAnimation: false,
          data: series[1].data,
          itemStyle: {
            normal: {
              color: '#72d8c0',
              opacity: series[1].data.reduce(function (a, b) {
                return a + b;
              }) === 0 ? 0 : 1
            },
            emphasis: {
              borderWidth: 3,
              borderColor: '#61d9ac',
              color: '#61d9ac'
            }
          },
          lineStyle: {
            normal: {
              opacity: series[1].data.reduce(function (a, b) {
                return a + b;
              }) === 0 ? 0 : 1
            }
          }
        }]
      };
      this.myChart1.setOption(option);
      window.addEventListener("resize", function () {
        if (_this3.$route.query.identification) {
          var resize = {
            width: _this3.screenWidth
          };
          _this3.myChart1.resize(resize);
        } else {
          _this3.myChart1.resize();
        }
      });
    },
    getSendOrdersData: function getSendOrdersData() {
      var _this = this;
      var url = Urls.getEchartsCollectReportDataByDispatchRatio;
      var params = {
        orgCode: this.orgCode || "",
        startTime: this.dataRange.length ? this.dataRange[0] : "",
        endTime: this.dataRange.length ? this.dataRange[1] : "",
        itemCode: ''
      };
      this.$root.doPost(url, params, function (server_data) {
        if (!_this.$root.isUserLogin(server_data)) {
          return;
        }

        if (server_data.error) {
          _this.$root.showGlobalError(server_data.error);
          return;
        }
        _this.SendOrdersDataList = server_data.data;
      });
    },
    initChart2: function initChart2() {
      var _this4 = this;

      var JudgeConditions = this.$route.query.identification;
      var res = this.SendOrdersDataList.every(function (item) {
        if (item.value == 0) return true;else false;
      });
      this.Judge = res;
      var Chart2 = this.$echarts.getInstanceByDom(this.$refs.SendOrders);
      if (Chart2 == null) {
        this.myChart2 = this.$echarts.init(this.$refs.SendOrders);
      }
      var option = {
        textStyle: {
          fontFamily: 'PingFang-M'
        },
        title: {
          text: '派单比例',
          top: '24',
          left: this.$route.query.identification ? '20' : '30',
          textStyle: {
            fontWeight: 500
          }
        },
        tooltip: {
          show: this.$route.query.identification ? true : this.screenWidth <= 1366 ? true : this.screenWidth == 1536 ? true : false,
          trigger: 'item',
          formatter: function formatter(params) {
            return '<div style="font-size:14px; padding:4px;">\n                                <div>' + params.name + '\uFF1A' + params.data.value + '\u4E2A</div>\n                                <div>\u5360\u6BD4\uFF1A' + params.data.percent + '%</div>\n                            </div>';
          }
        },
        color: ["#59b9fe", "#62d8ae", "#ffb971"],
        legend: {
          orient: this.$route.query.identification ? "horizontal" : "vertical",
          x: this.$route.query.identification ? '120' : '35',
          y: this.$route.query.identification ? '24' : '70',
          itemGap: 14,
          itemWidth: 10,
          itemHeight: 11,
          data: this.SendOrdersDataList,
          formatter: function formatter(name) {
            return '{a|' + name + '}';
          },
          textStyle: {
            color: '#666666',
            height: 10,
            rich: {
              a: {
                lineHeight: 14
              }
            }
          }
        },
        series: [{
          name: '项目类型',
          stillShowZeroSum: false,
          type: 'pie',
          radius: this.$route.query.identification ? ['40%', '60%'] : this.screenWidth <= 1366 ? ['38%', '52%'] : this.screenWidth == 1536 ? ['40%', '60%'] : ['35%', '50%'],
          center: this.$route.query.identification ? ['50%', '55%'] : this.screenWidth <= 1366 ? ['60%', '50%'] : ['58%', '55%'],
          silent: this.$route.query.identification ? false : this.screenWidth <= 1366 ? false : this.screenWidth == 1536 ? false : true,
          itemStyle: {
            align: 'left',
            normal: {
              borderWidthLeft: this.$route.query.identification ? 'none' : this.screenWidth <= 1366 ? 'none' : this.screenWidth == 1536 ? 'none' : 1,
              borderColor: this.$route.query.identification ? 'none' : this.screenWidth <= 1366 ? 'none' : this.screenWidth == 1536 ? 'none' : '#fff',
              label: {
                show: res ? false : true,
                align: 'left',
                position: this.$route.query.identification ? 'inside' : this.screenWidth <= 1366 ? 'inside' : this.screenWidth == 1536 ? 'inside' : 'outside',
                padding: [15, 0, 0, 0],
                color: "#fff",
                fontSize: this.$route.query.identification ? 15 : 12,
                formatter: function formatter(params) {
                  if (JudgeConditions == 'pplet' || _this4.screenWidth <= 1366 || _this4.screenWidth == 1536) {
                    return params.data.percent == 0 ? '' : params.data.percent + '%';
                  } else {
                    return '{left|\n' + params.data.name + '\uFF1A' + params.data.value + '\u4E2A\n\u5360\u6BD4\uFF1A' + params.data.percent + '%\n}';
                  }
                },
                rich: {
                  left: {
                    align: 'left',
                    lineHeight: 15,
                    color: '#666666'
                  }
                }
              }
            }

          },
          labelLine: {
            normal: {
              show: res ? false : true,
              length: this.$route.query.identification ? 5 : this.screenWidth <= 1366 ? 10 : 15,
              length2: this.$route.query.identification ? 20 : this.screenWidth <= 1366 ? 30 : 15
            }
          },
          data: this.SendOrdersDataList
        }]
      };
      this.myChart2.setOption(option);
      window.addEventListener("resize", function () {
        if (_this4.$route.query.identification) {
          var resize = {
            width: _this4.screenWidth
          };
          _this4.myChart2.resize(resize);
        } else {
          _this4.myChart2.resize();
        }
      });
    },
    getRegion: function getRegion() {
      var _this = this;
      var url = Urls.getEchartsCollectReportDataByRegion;
      var params = {
        orgCode: this.orgCode || "",
        startTime: this.dataRange.length ? this.dataRange[0] : "",
        endTime: this.dataRange.length ? this.dataRange[1] : "",
        itemCode: 'PROJECT_REGION'
      };
      this.$root.doPost(url, params, function (server_data) {
        if (!_this.$root.isUserLogin(server_data)) {
          return;
        }

        if (server_data.error) {
          _this.$root.showGlobalError(server_data.error);
          return;
        }
        _this.RegionDataList = server_data.data.reportList;
      });
    },
    getApplyingProject: function getApplyingProject() {
      var _this = this;
      var url = Urls.getEchartsCollectReportDataBySource;
      var params = {
        orgCode: this.orgCode || "",
        startTime: this.dataRange.length ? this.dataRange[0] : "",
        endTime: this.dataRange.length ? this.dataRange[1] : "",
        itemCode: ''
      };
      this.$root.doPost(url, params, function (server_data) {
        if (!_this.$root.isUserLogin(server_data)) {
          return;
        }

        if (server_data.error) {
          _this.$root.showGlobalError(server_data.error);
          return;
        }
        _this.ApplyingProjectList = server_data.data;
      });
    },
    initChart3: function initChart3() {
      var _this5 = this;

      var _ApplyingProjectList = this.ApplyingProjectList,
          series = _ApplyingProjectList.series,
          yAxis = _ApplyingProjectList.yAxis;

      var Chart3 = this.$echarts.getInstanceByDom(this.$refs.schedule);
      if (Chart3 == null) {
        this.myChart3 = this.$echarts.init(this.$refs.schedule);
      }
      var option = {
        textStyle: {
          fontFamily: 'PingFang-M'
        },
        title: {
          text: '报建项目',
          top: '24',
          left: this.$route.query.identification ? '20' : '30',
          textStyle: {
            fontWeight: 500
          }
        },
        tooltip: {
          show: true,
          trigger: 'item',
          formatter: function formatter(params) {
            var string = '<div style="padding:4px;">\n                          <div>' + params.name + '\uFF1A' + series[0].data[params.dataIndex] + '\u4E2A</div>\n                          <div>\u5360\u6BD4\uFF1A' + params.value + '%</div>\n                        </div>\n                      ';
            return string;
          }
        },
        grid: {
          left: this.$route.query.identification ? '25' : '32',
          top: this.$route.query.identification ? '55' : '55',
          right: this.$route.query.identification ? '15' : '35',
          bottom: this.$route.query.identification ? '18' : '25'
        },
        xAxis: {
          show: false,
          type: "value"
        },
        yAxis: [{
          type: "category",
          inverse: true,
          axisLabel: {
            formatter: function formatter(val, index) {
              var res = "";
              series[0].data.forEach(function (item, i) {
                if (i == index) {
                  res = item;
                }
              });
              return val + ('\uFF08' + res + '\u4E2A\uFF09');
            },
            textStyle: {
              color: "#666666",
              fontSize: "14",
              lineHeight: 20
            },
            padding: [0, -100, 35, 10],
            align: 'left',
            rich: {}
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          data: yAxis.data
        }, {
          type: "category",
          inverse: true,
          axisTick: "none",
          axisLine: "none",
          position: "left",
          show: true,
          axisLabel: {
            textStyle: {
              color: "#57b9ff",
              fontSize: "14"
            },
            padding: [0, -45, -45, 15],
            formatter: "({value}%)",
            align: 'left',
            rich: {}
          },
          data: series[0].percent
        }],
        series: [{
          type: "bar",
          zlevel: 1,
          itemStyle: {
            normal: {
              barBorderRadius: 10,
              color: "#57b9ff"
            }
          },
          barWidth: 10,
          data: series[0].percent
        }, {
          type: "bar",
          silent: true,
          barWidth: 10,
          barGap: "-100%",
          data: this.progressLsit,
          itemStyle: {
            normal: {
              color: "#eeeeee",
              barBorderRadius: 10
            }
          }
        }]
      };
      this.myChart3.setOption(option);
      window.addEventListener("resize", function () {
        if (_this5.$route.query.identification) {
          var resize = {
            width: _this5.screenWidth - 21
          };
          _this5.myChart3.resize(resize);
        } else {
          _this5.myChart3.resize();
        }
      });
    },
    getProjectLevel: function getProjectLevel() {
      var _this = this;
      var url = Urls.getEchartsCollectReportDataByGrade;
      var params = {
        orgCode: this.orgCode || "",
        startTime: this.dataRange.length ? this.dataRange[0] : "",
        endTime: this.dataRange.length ? this.dataRange[1] : "",
        itemCode: 'CONTRACT_LEVEL'
      };
      this.$root.doPost(url, params, function (server_data) {
        if (!_this.$root.isUserLogin(server_data)) {
          return;
        }

        if (server_data.error) {
          _this.$root.showGlobalError(server_data.error);
          return;
        }
        _this.ProjectLevelList = server_data.data;
      });
    },
    initChart4: function initChart4() {
      var _this6 = this;

      var _ProjectLevelList = this.ProjectLevelList,
          legend = _ProjectLevelList.legend,
          series = _ProjectLevelList.series,
          xAxis = _ProjectLevelList.xAxis;

      var statePercent = Math.ceil(Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].data)) / 10) * 10;
      var stateEntries = Math.ceil(Math.max.apply(Math, (0, _toConsumableArray3.default)(series[1].data)) / 10) * 10;
      var Chart4 = this.$echarts.getInstanceByDom(this.$refs.ProjectLevel);
      if (Chart4 == null) {
        this.myChart4 = this.$echarts.init(this.$refs.ProjectLevel);
      }
      var option = {
        textStyle: {
          fontFamily: 'PingFang-M'
        },
        title: {
          text: '项目等级',
          top: '24',
          left: this.$route.query.identification ? '20' : '30',
          textStyle: {
            fontWeight: 500
          }
        },
        grid: {
          left: this.$route.query.identification ? '32' : this.screenWidth <= 1366 ? '8%' : '6%',
          right: this.$route.query.identification ? '10%' : '4.5%',
          bottom: '20px',
          top: this.$route.query.identification ? '25%' : '90px',
          containLabel: true
        },
        opacity: 0.1,
        tooltip: {
          trigger: 'axis',
          formatter: function formatter(params) {
            var h = '<div>';
            params.reverse().forEach(function (item) {
              if (item.seriesIndex == 1) {
                h += '<div>' + item.axisValue + '\uFF1A' + item.data + '\u4E2A</div>';
              } else {
                h += '<div>\u5360\u6BD4\uFF1A' + item.data + '%</div></div>';
              }
            });
            return h;
          }
        },
        legend: {
          data: legend,
          itemWidth: 40,
          itemHeight: 8,
          itemGap: 20,
          left: this.$route.query.identification ? '110' : '180',
          top: '24',
          textStyle: {
            fontSize: '13',
            height: 10,
            rich: {
              a: {
                verticalAlign: 'middle'
              }
            }
          }
        },
        xAxis: [(0, _defineProperty3.default)({
          type: 'category',
          offset: 5,
          data: xAxis.data,
          axisPointer: {
            type: 'shadow'
          },

          splitLine: {
            show: Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].data).concat((0, _toConsumableArray3.default)(series[1].data))) == 0 ? false : true,
            lineStyle: {
              color: '#DDDDDD'
            }
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#DDDDDD'
            }
          },
          axisLabel: {
            color: '#666666'
          }
        }, 'axisPointer', {
          type: 'none'
        })],
        yAxis: [{
          offset: 5,
          type: 'value',
          name: '百分比',
          show: Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].data)) == 0 ? false : true,
          min: 0,
          max: statePercent,
          splitNumber: 5,
          interval: statePercent / 5,
          axisLabel: {
            formatter: '{value}%',
            textStyle: {
              color: '#666666'
            }
          },

          splitLine: {
            show: true,
            lineStyle: {
              color: '#DDDDDD'
            }
          },

          nameTextStyle: {
            color: '#666666',
            padding: this.$route.query.identification ? [0, 22, 0, 0] : [0, 40, 0, 0]
          },
          axisTick: false,
          axisLine: {
            show: false }
        }, {
          type: 'value',
          name: '数量（个）',
          show: Math.max.apply(Math, (0, _toConsumableArray3.default)(series[1].data)) == 0 ? false : true,
          min: 0,
          max: stateEntries,

          splitNumber: 5,
          interval: stateEntries / 5,
          axisLabel: {
            formatter: function formatter(params) {
              return parseInt(params);
            },
            textStyle: {
              color: '#666666'
            }
          },

          splitLine: {
            show: true,
            lineStyle: {
              color: '#DDDDDD'
            }
          },

          nameTextStyle: {
            color: '#666666',
            padding: this.$route.query.identification ? [0, 15, 0, 38] : [0, 20, 0, 38]
          },
          axisTick: false,
          axisLine: {
            show: false }
        }],
        series: [{
          name: series[0].name,
          type: 'bar',
          barWidth: this.$route.query.identification ? '30%' : this.screenWidth <= 1366 ? '50%' : '70%',
          data: series[0].data,
          itemStyle: {
            normal: {
              color: 'rgba(87,185,255,0.35)',
              borderColor: Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].data)) == 0 ? 'rgba(87,185,255,0)' : 'rgba(87,185,255,1)'
            }
          }
        }, {
          name: series[1].name,
          type: 'line',
          symbol: 'rect',
          symbolSize: 9,
          yAxisIndex: 1,
          hoverAnimation: false,
          data: series[1].data,
          itemStyle: {
            normal: {
              color: '#72d8c0',
              opacity: series[1].data.reduce(function (a, b) {
                return a + b;
              }) === 0 ? 0 : 1
            },
            emphasis: {
              borderWidth: 3,
              borderColor: '#61d9ac',
              color: '#61d9ac'
            }
          },
          lineStyle: {
            normal: {
              opacity: series[1].data.reduce(function (a, b) {
                return a + b;
              }) === 0 ? 0 : 1
            }
          }
        }]
      };
      this.myChart4.setOption(option);
      window.addEventListener("resize", function () {
        if (_this6.$route.query.identification) {
          var resize = {
            width: _this6.screenWidth - 21
          };
          _this6.myChart4.resize(resize);
        } else {
          _this6.myChart4.resize();
        }
      });
    }
  },
  mounted: function mounted() {
    var _this = this;
    window.onresize = function () {
      return function () {
        window.screenWidth = document.body.clientWidth + 17;
        _this.screenWidth = window.screenWidth;
      }();
    };
    console.log(this.screenWidth);
  },

  watch: {
    ProgressDataList: function ProgressDataList() {
      this.$nextTick(function () {
        var myEvent = new Event('resize');
        window.dispatchEvent(myEvent);
      });
      this.initChart1();
    },
    SendOrdersDataList: function SendOrdersDataList(val) {
      this.$nextTick(function () {
        var myEvent = new Event('resize');
        window.dispatchEvent(myEvent);
      });
      this.initChart2();
    },
    ApplyingProjectList: function ApplyingProjectList(val) {
      for (var i = 0; i < val.series[0].data.length; i++) {
        this.progressLsit.push(100);
      }
      this.$nextTick(function () {
        var myEvent = new Event('resize');
        window.dispatchEvent(myEvent);
      });
      this.initChart3();
    },
    ProjectLevelList: function ProjectLevelList() {
      this.$nextTick(function () {
        var myEvent = new Event('resize');
        window.dispatchEvent(myEvent);
      });
      this.initChart4();
    }
  }
};

/***/ }),

/***/ 846:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(31);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _HeadControl = __webpack_require__(43);

var _HeadControl2 = _interopRequireDefault(_HeadControl);

var _TableContentOverflow = __webpack_require__(745);

var _TableContentOverflow2 = _interopRequireDefault(_TableContentOverflow);

var _Urls = __webpack_require__(12);

var Urls = _interopRequireWildcard(_Urls);

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    HeadControl: _HeadControl2.default,
    TableContentOverflow: _TableContentOverflow2.default
  },
  data: function data() {
    return {
      orgCode: "",
      dataRange: [],
      checkProjectData: {},
      projectLevelData: {},
      maxNum: 0,
      maxPercent: 0,
      projectDataList: [],
      regionDataList: [],
      activeProjectName: "ALL",
      projectRankList: [],
      activeDirectorName: 'ALL',
      directorScoreList: [],
      screenWidth: document.body.clientWidth,
      isH5: false,
      x: 0,
      y: 0,
      ClickText: '',
      TextShow: false,
      actived: 0
    };
  },

  methods: {
    getText: function getText(e, val) {
      var identification = this.$route.query.identification;
      this.x = e.layerX + 40;
      this.TextShow = true;
    },
    init: function init() {
      this.$refs.headControl.getDatas('month');
      this.$refs.headControl.getSysOrg();
    },
    changeVal: function changeVal(val) {
      this.orgCode = val;
      this.getCheckProjectData();
      this.getProjectLevelData();
      this.getProjectData();
      this.getRegionData();
      this.getProjectScoreRank();
      this.getDirectorScoreRank();
    },
    changDate: function changDate(val) {
      this.dataRange = val;
      this.getCheckProjectData();
      this.getProjectLevelData();
      this.getProjectData();
      this.getRegionData();
      this.getProjectScoreRank();
      this.getDirectorScoreRank();
    },
    changePicker: function changePicker(val) {
      this.dataRange = val;
      this.getCheckProjectData();
      this.getProjectLevelData();
      this.getProjectData();
      this.getRegionData();
      this.getProjectScoreRank();
      this.getDirectorScoreRank();
    },
    handleClick: function handleClick(type) {
      if (type !== this.activeProjectName) {
        this.activeProjectName = type;
        this.getProjectScoreRank();
      }
    },
    handleClick2: function handleClick2(type) {
      if (type !== this.activeDirectorName) {
        this.activeDirectorName = type;
        this.getDirectorScoreRank();
      }
    },
    initCheckProjectChart: function initCheckProjectChart() {
      var _this = this;

      this.checkProjectChart = this.$echarts.init(this.$refs.checkProject);
      var option = {
        textStyle: {
          fontFamily: 'PingFang-M'
        },
        title: {
          text: "检查项目",
          padding: this.isH5 ? [24, 0, 0, 20] : [24, 0, 0, 30],
          textStyle: {
            fontWeight: 'normal'
          }
        },
        tooltip: {
          show: true,
          trigger: "axis",
          formatter: function formatter(params) {
            var str = "<div>" + (0, _moment2.default)(params[0].axisValue).format("M月DD日") + "</div>\n                         <div>\u68C0\u67E5\u9879\u76EE\uFF1A" + params[0].data + "\u4E2A</div>";
            return "<div style=\"padding: 5px 10px; font-size: 12px\">" + str + "</div>";
          }
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.checkProjectData.xAxis.data,
          axisTick: {
            show: false
          },
          axisLine: {
            show: this.checkProjectData.series[0].data.reduce(function (a, b) {
              return a + b;
            }) === 0 ? true : false,
            lineStyle: {
              color: '#ddd'
            }
          },
          splitLine: {
            show: this.checkProjectData.series[0].data.reduce(function (a, b) {
              return a + b;
            }) === 0 ? false : true,
            lineStyle: {
              color: '#ddd'
            }
          },
          axisLabel: {
            interval: this.screenWidth < 1366 ? 'auto' : parseInt(this.checkProjectData.xAxis.data.length / 10),
            color: '#666',
            show: this.isH5 ? false : true,
            margin: 20
          }
        },
        yAxis: {
          type: "value",
          show: this.checkProjectData.series[0].data.reduce(function (a, b) {
            return a + b;
          }) === 0 ? false : true,
          name: "数量(个)",
          minInterval: 1,
          nameGap: 16,
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          splitLine: {
            show: this.checkProjectData.series[0].data.reduce(function (a, b) {
              return a + b;
            }) === 0 ? false : true,
            lineStyle: {
              color: '#ddd'
            }
          }
        },
        grid: {
          left: this.isH5 ? 45 : 60,
          right: this.isH5 ? 25 : 60,
          top: 95,
          bottom: 57
        },
        series: [{
          data: this.checkProjectData.series[0].data,
          type: "line",
          smooth: true,
          symbol: "circle",
          lineStyle: {
            normal: {
              color: "#5ebbff",
              opacity: this.checkProjectData.series[0].data.reduce(function (a, b) {
                return a + b;
              }) === 0 ? 0 : 1
            }
          },
          itemStyle: {
            normal: {
              color: "#57B9FF",
              borderType: "solid",
              borderColor: "#fff",
              opacity: this.checkProjectData.series[0].data.reduce(function (a, b) {
                return a + b;
              }) === 0 ? 0 : 1
            }
          },
          areaStyle: {
            normal: {
              color: "#e6f5ff"
            }
          }
        }]
      };
      this.checkProjectChart.setOption(option);
      window.addEventListener("resize", function () {
        _this.isH5 ? _this.checkProjectChart.resize({ width: _this.screenWidth - 24 }) : _this.checkProjectChart.resize();
      });
      this.isH5 ? this.checkProjectChart.resize({ width: this.screenWidth - 24 }) : this.checkProjectChart.resize();
    },
    initProjectLevelChart: function initProjectLevelChart() {
      var _this2 = this;

      this.projectLevelChart = this.$echarts.init(this.$refs.projectLevel);
      var option = {
        textStyle: {
          fontFamily: 'PingFang-M'
        },
        title: {
          text: "项目等级",
          padding: this.isH5 ? [24, 0, 0, 20] : [24, 0, 0, 30],
          textStyle: {
            fontWeight: 'normal'
          }
        },
        grid: {
          left: this.isH5 ? 20 : 33,
          top: 97,
          right: this.isH5 ? 20 : 33,
          bottom: 29,
          containLabel: true
        },
        opacity: 0.1,
        tooltip: {
          trigger: "axis",
          formatter: function formatter(params) {
            var message = '';
            params.reverse().forEach(function (item, index) {
              if (item.seriesIndex == 1) {
                message += item.axisValue + ': ' + item.data + '个' + '<br>';
              } else {
                message += '占比: ' + item.data + '%';
              }
            });
            return "<div style=\"padding: 5px 8px; font-size: 12px\">" + message + "</div>";
          }
        },
        legend: {
          data: this.projectLevelData.legend,
          itemWidth: 40,
          itemHeight: 8,
          top: '20',
          left: this.isH5 ? '120' : '180',
          itemGap: 20,
          textStyle: {
            fontSize: '13',
            height: 10,
            rich: {
              a: {
                verticalAlign: 'middle'
              }
            }
          }
        },
        xAxis: [{
          type: "category",
          data: this.projectLevelData.xAxis.data,
          axisPointer: {
            type: 'none'
          },

          splitLine: {
            show: this.projectLevelData.series[1].data.reduce(function (a, b) {
              return a + b;
            }) === 0 ? false : true,
            lineStyle: {
              color: "#ddd"
            }
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: this.projectLevelData.series[1].data.reduce(function (a, b) {
              return a + b;
            }) === 0 ? true : false,
            lineStyle: {
              color: '#ddd'
            }
          },
          axisLabel: {
            color: '#666',
            margin: 20
          }
        }],
        yAxis: [{
          show: this.projectLevelData.series[1].data.reduce(function (a, b) {
            return a + b;
          }) === 0 ? false : true,

          type: "value",
          name: "百分比",
          min: 0,
          max: this.maxPercent,
          splitNumber: 5,
          interval: this.maxPercent / 5,
          axisLabel: {
            formatter: "{value}%",
            margin: 20
          },

          nameTextStyle: {
            padding: [0, 65, 0, 0]
          },
          axisTick: {
            length: 16,
            lineStyle: {
              color: "#ddd"
            }
          },
          axisLine: {
            show: false
          },
          splitLine: {
            show: false
          }
        }, {
          show: this.projectLevelData.series[1].data.reduce(function (a, b) {
            return a + b;
          }) === 0 ? false : true,
          type: "value",
          name: "数量（个）",
          min: 0,
          max: this.maxNum,
          splitNumber: 5,
          interval: this.maxNum / 5,

          nameTextStyle: {
            padding: [0, 0, 0, 40]
          },
          axisTick: {
            length: 16,
            lineStyle: {
              color: "#ddd"
            }
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            margin: 20,
            formatter: function formatter(value) {
              return parseInt(value);
            }
          },
          splitLine: {
            lineStyle: {
              color: "#ddd"
            }
          }
        }],
        series: [{
          name: this.projectLevelData.series[0].name,
          type: "bar",
          barWidth: '60%',
          data: this.projectLevelData.series[0].data,
          itemStyle: {
            normal: {
              color: 'rgba(87, 185, 255, 0.35)',
              borderColor: this.projectLevelData.series[1].data.reduce(function (a, b) {
                return a + b;
              }) === 0 ? 'rgba(87, 185, 255, 0)' : 'rgba(87, 185, 255, 1)'
            }
          },
          yAxisIndex: 0
        }, {
          name: this.projectLevelData.series[1].name,
          type: "line",
          symbol: "rect",
          symbolSize: 9,
          hoverAnimation: false,
          data: this.projectLevelData.series[1].data,
          itemStyle: {
            normal: {
              color: "#61d9ac",
              opacity: this.projectLevelData.series[1].data.reduce(function (a, b) {
                return a + b;
              }) === 0 ? 0 : 1
            },
            emphasis: {
              borderWidth: 3,
              borderColor: '#61d9ac',
              color: '#61d9ac'
            }
          },
          lineStyle: {
            normal: {
              opacity: this.projectLevelData.series[1].data.reduce(function (a, b) {
                return a + b;
              }) === 0 ? 0 : 1
            }
          },
          yAxisIndex: 1
        }]
      };
      this.projectLevelChart.setOption(option);
      window.addEventListener("resize", function () {
        _this2.isH5 ? _this2.projectLevelChart.resize({ width: _this2.screenWidth - 24 }) : _this2.projectLevelChart.resize();
      });
      this.isH5 ? this.projectLevelChart.resize({ width: this.screenWidth - 24 }) : this.projectLevelChart.resize();
    },
    getCheckProjectData: function getCheckProjectData() {
      var _this3 = this;

      var url = Urls.getEchartsPollingReportDataByTrend;
      var params = {
        orgCode: this.orgCode || "",
        startTime: this.dataRange.length ? this.dataRange[0] : "",
        endTime: this.dataRange.length ? this.dataRange[1] : ""
      };
      this.$root.doPost(url, params, function (server_data) {
        if (!_this3.$root.isUserLogin(server_data)) {
          return;
        }

        if (server_data.error) {
          _this3.$root.showGlobalError(server_data.error);
          return;
        }
        _this3.checkProjectData = server_data.data;
      });
    },
    getProjectLevelData: function getProjectLevelData() {
      var _this4 = this;

      var url = Urls.getEchartsPollingReportDataByGrade;
      var params = {
        orgCode: this.orgCode || "",
        startTime: this.dataRange.length ? this.dataRange[0] : "",
        endTime: this.dataRange.length ? this.dataRange[1] : "",
        itemCode: "CONTRACT_LEVEL"
      };
      this.$root.doPost(url, params, function (server_data) {
        if (!_this4.$root.isUserLogin(server_data)) {
          return;
        }

        if (server_data.error) {
          _this4.$root.showGlobalError(server_data.error);
          return;
        }
        _this4.projectLevelData = server_data.data;
      });
    },
    getProjectData: function getProjectData() {
      var _this5 = this;

      var url = Urls.getEchartsPollingReportDataByProject;
      var params = {
        orgCode: this.orgCode || "",
        startTime: this.dataRange.length ? this.dataRange[0] : "",
        endTime: this.dataRange.length ? this.dataRange[1] : ""
      };
      this.$root.doPost(url, params, function (server_data) {
        if (!_this5.$root.isUserLogin(server_data)) {
          return;
        }

        if (server_data.error) {
          _this5.$root.showGlobalError(server_data.error);
          return;
        }
        _this5.projectDataList = server_data.data.reportList;
      });
    },
    getRegionData: function getRegionData() {
      var _this6 = this;

      var url = Urls.getEchartsPollingReportDataByRegion;
      var params = {
        orgCode: this.orgCode || "",
        startTime: this.dataRange.length ? this.dataRange[0] : "",
        endTime: this.dataRange.length ? this.dataRange[1] : "",
        itemCode: "ENGINEER_PROJECT_REGION"
      };
      this.$root.doPost(url, params, function (server_data) {
        if (!_this6.$root.isUserLogin(server_data)) {
          return;
        }

        if (server_data.error) {
          _this6.$root.showGlobalError(server_data.error);
          return;
        }
        _this6.regionDataList = server_data.data.reportList;
      });
    },
    getProjectScoreRank: function getProjectScoreRank() {
      var _this7 = this;

      var url = Urls.getEchartsPollingReportDataByProjectScore;
      var params = {
        orgCode: this.orgCode || "",
        startTime: this.dataRange.length ? this.dataRange[0] : "",
        endTime: this.dataRange.length ? this.dataRange[1] : "",
        itemCode: this.activeProjectName
      };
      this.$root.doPost(url, params, function (server_data) {
        if (!_this7.$root.isUserLogin(server_data)) {
          return;
        }

        if (server_data.error) {
          _this7.$root.showGlobalError(server_data.error);
          return;
        }
        _this7.projectRankList = server_data.data;
      });
    },
    getDirectorScoreRank: function getDirectorScoreRank() {
      var _this8 = this;

      var url = Urls.getEchartsPollingReportDataByDirectorScore;
      var params = {
        orgCode: this.orgCode || "",
        startTime: this.dataRange.length ? this.dataRange[0] : "",
        endTime: this.dataRange.length ? this.dataRange[1] : "",
        itemCode: this.activeDirectorName
      };
      this.$root.doPost(url, params, function (server_data) {
        if (!_this8.$root.isUserLogin(server_data)) {
          return;
        }

        if (server_data.error) {
          _this8.$root.showGlobalError(server_data.error);
          return;
        }
        _this8.directorScoreList = server_data.data;
      });
    }
  },
  watch: {
    checkProjectData: function checkProjectData(newVal) {
      if (newVal) {
        this.initCheckProjectChart();
      }
    },
    projectLevelData: function projectLevelData(newVal) {
      if (newVal) {
        this.maxNum = Math.ceil(Math.max.apply(Math, (0, _toConsumableArray3.default)(newVal.series[1].data)) / 10) * 10;
        this.maxPercent = Math.ceil(Math.max.apply(Math, (0, _toConsumableArray3.default)(newVal.series[0].data)) / 10) * 10;
        this.initProjectLevelChart();
      }
    },
    screenWidth: function screenWidth() {
      this.initCheckProjectChart();
    }
  },
  mounted: function mounted() {
    var _this9 = this;

    if (this.$route.query.identification) {
      this.isH5 = true;
    }
    window.onresize = function () {
      return function () {
        window.screenWidth = document.body.clientWidth;
        _this9.screenWidth = window.screenWidth;
      }();
    };
  }
};

/***/ }),

/***/ 847:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(93);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _toConsumableArray2 = __webpack_require__(31);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _components$data$comp;

var _HeadControl = __webpack_require__(43);

var _HeadControl2 = _interopRequireDefault(_HeadControl);

var _Urls = __webpack_require__(12);

var Urls = _interopRequireWildcard(_Urls);

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (_components$data$comp = {
  components: {},
  data: function data() {
    return {
      orgCode: "",
      dataRange: [],
      count: 0,
      sendOrdersNum: {},
      projectAreaData: [],
      residentData: {},
      notResidentNumList: [],
      residentNumList: [],
      projectGradeData: {},
      maxNum: 0,
      maxPercent: 0,
      screenWidth: document.body.clientWidth,
      isH5: false
    };
  }
}, (0, _defineProperty3.default)(_components$data$comp, "components", {
  HeadControl: _HeadControl2.default
}), (0, _defineProperty3.default)(_components$data$comp, "methods", {
  init: function init() {
    this.$refs.headControl.getDatas('month');
    this.$refs.headControl.getSysOrg();
  },
  changeVal: function changeVal(val) {
    this.orgCode = val;
    this.getSendOrdersNum();
    this.getProjectAreaNum();
    this.getResidentPersentData();
    this.getProjectGradeData();
  },
  changDate: function changDate(val) {
    this.dataRange = val;
    this.getSendOrdersNum();
    this.getProjectAreaNum();
    this.getResidentPersentData();
    this.getProjectGradeData();
  },
  changePicker: function changePicker(val) {
    this.dataRange = val;
    this.getSendOrdersNum();
    this.getProjectAreaNum();
    this.getResidentPersentData();
    this.getProjectGradeData();
  },
  initSendOrdersNum: function initSendOrdersNum() {
    var _this = this;

    this.myChart = this.$echarts.init(this.$refs.sendOrdersNum);
    var option = {
      textStyle: {
        fontFamily: 'PingFang-M'
      },
      title: {
        text: "派单数量",
        padding: this.isH5 ? [24, 0, 0, 20] : [24, 0, 0, 30],
        textStyle: {
          fontWeight: 'normal'
        }
      },
      tooltip: {
        show: true,
        trigger: "axis",
        formatter: function formatter(params) {
          var str = "<div>" + (0, _moment2.default)(params[0].axisValue).format("M月DD日") + "</div>\n                         <div>\u6D3E\u5355\u6570\u91CF\uFF1A" + params[0].data + "\u4E2A</div>";
          return "<div style=\"padding: 5px 10px; font-size: 12px\">" + str + "</div>";
        }
      },
      xAxis: {
        type: "category",
        boundaryGap: false,
        data: this.sendOrdersNum.xAxis.data,
        axisTick: {
          show: false
        },
        axisLine: {
          show: this.sendOrdersNum.series[0].data.reduce(function (a, b) {
            return a + b;
          }) === 0 ? true : false,
          lineStyle: {
            color: '#ddd'
          }
        },
        splitLine: {
          show: this.sendOrdersNum.series[0].data.reduce(function (a, b) {
            return a + b;
          }) === 0 ? false : true,
          lineStyle: {
            color: '#ddd'
          }
        },
        axisLabel: {
          interval: parseInt(this.sendOrdersNum.xAxis.data.length / 10),
          color: '#666',
          show: this.isH5 ? false : true,
          margin: 20
        }
      },
      yAxis: {
        type: "value",
        show: this.sendOrdersNum.series[0].data.reduce(function (a, b) {
          return a + b;
        }) === 0 ? false : true,
        name: "数量(个)",
        minInterval: 1,
        nameGap: 16,
        axisTick: {
          show: false
        },
        axisLine: {
          show: false
        },
        splitLine: {
          show: true,
          lineStyle: {
            color: '#ddd'
          }
        }
      },
      grid: {
        left: this.isH5 ? 40 : 60,
        right: this.isH5 ? 30 : 60,
        top: 95,
        bottom: this.isH5 ? 30 : 60
      },
      series: [{
        data: this.sendOrdersNum.series[0].data,
        type: "line",
        smooth: true,
        symbol: "circle",

        lineStyle: {
          normal: {
            color: "#5ebbff",
            opacity: this.sendOrdersNum.series[0].data.reduce(function (a, b) {
              return a + b;
            }) === 0 ? 0 : 1
          }
        },
        itemStyle: {
          normal: {
            color: "#57B9FF",
            borderType: "solid",
            borderColor: "#fff",
            opacity: this.sendOrdersNum.series[0].data.reduce(function (a, b) {
              return a + b;
            }) === 0 ? 0 : 1
          }
        },
        areaStyle: {
          normal: {
            color: "#e6f5ff"
          }
        }
      }]
    };
    this.myChart.setOption(option);
    window.addEventListener("resize", function () {
      _this.isH5 ? _this.myChart.resize({ width: _this.screenWidth - 24 }) : _this.myChart.resize();
    });
    this.isH5 ? this.myChart.resize({ width: this.screenWidth - 24 }) : this.myChart.resize();
  },
  initResidentPerChart: function initResidentPerChart() {
    var _this2 = this;

    this.residentPerChart = this.$echarts.init(this.$refs.residentPer);
    var option = {
      textStyle: {
        fontFamily: 'PingFang-M'
      },
      title: {
        text: "驻场比例",
        padding: this.isH5 ? [24, 0, 0, 20] : [24, 0, 0, 30],
        textStyle: {
          fontWeight: 'normal'
        }
      },
      grid: {
        left: 36,
        right: 34,
        bottom: 22,
        top: 68
      },
      xAxis: {
        show: false,
        type: "value"
      },
      tooltip: {
        trigger: 'item',
        formatter: function formatter(params) {
          var index = params.dataIndex;
          return "<div style=\"font-size:14px; padding:4px;\">\n                         <div>" + params.seriesName + "\uFF1A" + _this2.residentData.series[index].data[params.seriesIndex] + "\u4E2A</div>\n                         <div>\u5360\u6BD4\uFF1A" + params.value + "%</div>\n                     </div>";
        }
      },
      yAxis: [{
        type: "category",
        data: this.residentData.yAxis.data,
        inverse: true,
        axisLine: {
          show: false
        },
        axisTick: {
          show: false
        },
        axisLabel: {
          align: "left",
          padding: [-50, -40, -10, 10],
          fontSize: 14,
          color: "#333",
          rich: {}
        }
      }, {
        type: "category",
        inverse: true,
        axisTick: "none",
        axisLine: "none",
        position: "left",
        show: true,
        axisLabel: {
          textStyle: {
            color: "#57b9ff",
            fontSize: "14"
          },
          align: 'left',
          padding: this.isH5 ? [30, 140, -10, 90] : [30, 140, -10, 100],
          formatter: "{value}%",
          rich: {}
        },
        data: this.epcProject
      }, {
        type: "category",
        inverse: true,
        axisTick: "none",
        axisLine: "none",
        position: "right",
        show: true,
        axisLabel: {
          textStyle: {
            color: "#FFB96E",
            fontSize: "14"
          },
          padding: this.isH5 ? [40, -100, 0, -20] : [40, -100, 0, -40],
          formatter: "{value}%",
          rich: {}
        },
        data: this.largeProject
      }],
      series: [{
        name: "驻场",
        type: "bar",
        zlevel: 1,
        show: true,
        stack: "total",
        itemStyle: {
          normal: {
            barBorderRadius: [10, 0, 0, 10],
            color: "#57b9ff",
            label: {
              show: false
            }
          }
        },
        barWidth: 10,
        barGap: "-100%",
        data: this.epcProject
      }, {
        name: "不驻场",
        type: "bar",
        zlevel: 1,
        stack: "total",
        itemStyle: {
          normal: {
            barBorderRadius: [0, 10, 10, 0],
            color: "#FFB96E",
            label: {
              show: false
            }
          }
        },
        label: {
          show: true
        },
        barWidth: 10,
        barGap: "-100%",
        data: this.largeProject
      }, {
        type: "bar",
        silent: true,
        barWidth: 10,
        barGap: "-100%",
        data: [100, 100],
        itemStyle: {
          normal: {
            color: "#eeeeee",
            barBorderRadius: 10
          }
        }
      }]
    };
    this.residentPerChart.setOption(option);
    window.addEventListener("resize", function () {
      _this2.isH5 ? _this2.residentPerChart.resize({ width: _this2.screenWidth - 24 }) : _this2.residentPerChart.resize();
    });
    this.isH5 ? this.residentPerChart.resize({ width: this.screenWidth - 24 }) : this.residentPerChart.resize();
  },
  initProjectGradeChart: function initProjectGradeChart() {
    var _this3 = this;

    this.projectGradeChart = this.$echarts.init(this.$refs.projectGrade);
    var option = {
      textStyle: {
        fontFamily: 'PingFang-M'
      },
      title: {
        text: "项目等级",
        padding: this.isH5 ? [24, 0, 0, 20] : [24, 0, 0, 30],
        textStyle: {
          fontWeight: 'normal'
        }
      },
      grid: {
        left: this.isH5 ? 70 : 80,
        top: 112,
        right: this.isH5 ? 60 : 63,
        bottom: 57
      },
      tooltip: {
        trigger: "axis",
        formatter: function formatter(params) {
          var message = '';
          params.reverse().forEach(function (item, index) {
            if (item.seriesIndex == 1) {
              message += item.axisValue + ': ' + item.data + '个' + '<br>';
            } else {
              message += '占比: ' + item.data + '%';
            }
          });
          return "<div style=\"padding: 5px 8px; font-size: 12px\">" + message + "</div>";
        }
      },
      axisPointer: {
        type: 'none'
      },
      legend: {
        data: this.projectGradeData.legend,
        itemWidth: 40,
        itemHeight: 8,
        top: '20',
        left: this.isH5 ? '120' : '180',
        itemGap: 20,
        textStyle: {
          fontSize: '13',
          height: 10,
          rich: {
            a: {
              verticalAlign: 'middle'
            }
          }
        }
      },
      xAxis: [{
        type: "category",
        data: this.projectGradeData.xAxis.data,
        axisPointer: {
          type: 'none'
        },

        splitLine: {
          show: this.projectGradeData.series[1].data.reduce(function (a, b) {
            return a + b;
          }) === 0 ? false : true,
          lineStyle: {
            color: "#ddd"
          }
        },
        axisTick: {
          show: false
        },
        axisLine: {
          show: this.projectGradeData.series[1].data.reduce(function (a, b) {
            return a + b;
          }) === 0 ? true : false,
          lineStyle: {
            color: '#ddd'
          }
        },
        axisLabel: {
          color: '#666'
        }
      }],
      yAxis: [{
        type: "value",
        name: "百分比",
        min: 0,
        max: this.maxPercent,
        splitNumber: 5,
        interval: this.maxPercent / 5,
        axisLabel: {
          formatter: "{value}%",
          margin: 20
        },

        nameTextStyle: {
          padding: [0, 65, 0, 0]
        },
        axisTick: {
          length: 16,
          lineStyle: {
            color: "#ddd"
          }
        },
        axisLine: {
          show: false
        },
        show: this.projectGradeData.series[1].data.reduce(function (a, b) {
          return a + b;
        }) === 0 ? false : true,
        splitLine: {
          show: false
        }
      }, {
        type: "value",
        name: "数量（个）",
        min: 0,
        max: this.maxNum,
        splitNumber: 5,
        interval: this.maxNum / 5,

        nameTextStyle: {
          padding: [0, 0, 0, 40]
        },
        axisTick: {
          length: 16,
          lineStyle: {
            color: "#ddd"
          }
        },
        axisLine: {
          show: false
        },
        axisLabel: {
          margin: 20,
          formatter: function formatter(value) {
            return parseInt(value);
          }
        },
        splitLine: {
          lineStyle: {
            color: '#ddd'
          }
        },
        show: this.projectGradeData.series[1].data.reduce(function (a, b) {
          return a + b;
        }) === 0 ? false : true
      }],
      series: [{
        name: this.projectGradeData.series[0].name,
        type: "bar",
        barWidth: "60%",
        data: this.projectGradeData.series[0].data,
        itemStyle: {
          normal: {
            color: 'rgba(87, 185, 255, 0.35)',
            borderColor: this.projectGradeData.series[1].data.reduce(function (a, b) {
              return a + b;
            }) === 0 ? 'rgba(87, 185, 255, 0)' : 'rgba(87, 185, 255, 1)'
          }
        },
        yAxisIndex: 0
      }, {
        name: this.projectGradeData.series[1].name,
        type: "line",
        symbol: "rect",
        symbolSize: 9,
        hoverAnimation: false,
        data: this.projectGradeData.series[1].data,
        itemStyle: {
          normal: {
            opacity: this.projectGradeData.series[1].data.reduce(function (a, b) {
              return a + b;
            }) === 0 ? 0 : 1,
            color: "#61d9ac"
          },
          emphasis: {
            borderWidth: 3,
            borderColor: '#61d9ac',
            color: '#61d9ac'
          }
        },
        lineStyle: {
          normal: {
            opacity: this.projectGradeData.series[1].data.reduce(function (a, b) {
              return a + b;
            }) === 0 ? 0 : 1
          }
        },
        yAxisIndex: 1
      }]
    };
    this.projectGradeChart.setOption(option);
    window.addEventListener("resize", function () {
      _this3.isH5 ? _this3.projectGradeChart.resize({ width: _this3.screenWidth - 24 }) : _this3.projectGradeChart.resize();
    });
    this.isH5 ? this.projectGradeChart.resize({ width: this.screenWidth - 24 }) : this.projectGradeChart.resize();
  },
  getSendOrdersNum: function getSendOrdersNum() {
    var _this4 = this;

    var url = Urls.getEchartsDispatchReportDataByTrend;
    var params = {
      orgCode: this.orgCode || "",
      startTime: this.dataRange.length ? this.dataRange[0] : "",
      endTime: this.dataRange.length ? this.dataRange[1] : ""
    };
    this.$root.doPost(url, params, function (server_data) {
      if (!_this4.$root.isUserLogin(server_data)) {
        return;
      }

      if (server_data.error) {
        _this4.$root.showGlobalError(server_data.error);
        return;
      }
      _this4.sendOrdersNum = server_data.data;
    });
  },
  getProjectAreaNum: function getProjectAreaNum() {
    var _this5 = this;

    var url = Urls.getEchartsDispatchReportDataByRegion;
    var params = {
      orgCode: this.orgCode || "",
      startTime: this.dataRange.length ? this.dataRange[0] : "",
      endTime: this.dataRange.length ? this.dataRange[1] : ""
    };
    this.$root.doPost(url, params, function (server_data) {
      if (!_this5.$root.isUserLogin(server_data)) {
        return;
      }

      if (server_data.error) {
        _this5.$root.showGlobalError(server_data.error);
        return;
      }
      _this5.projectAreaData = server_data.data.reportList;
    });
  },
  getResidentPersentData: function getResidentPersentData() {
    var _this6 = this;

    var url = Urls.getEchartsDispatchReportDataBySource;
    var params = {
      orgCode: this.orgCode || "",
      startTime: this.dataRange.length ? this.dataRange[0] : "",
      endTime: this.dataRange.length ? this.dataRange[1] : ""
    };
    this.$root.doPost(url, params, function (server_data) {
      if (!_this6.$root.isUserLogin(server_data)) {
        return;
      }

      if (server_data.error) {
        _this6.$root.showGlobalError(server_data.error);
        return;
      }
      _this6.residentData = server_data.data;
    });
  },
  getProjectGradeData: function getProjectGradeData() {
    var _this7 = this;

    var url = Urls.getEchartsDispatchReportDataByGrade;
    var params = {
      orgCode: this.orgCode || "",
      startTime: this.dataRange.length ? this.dataRange[0] : "",
      endTime: this.dataRange.length ? this.dataRange[1] : "",
      itemCode: 'CONTRACT_LEVEL'
    };
    this.$root.doPost(url, params, function (server_data) {
      if (!_this7.$root.isUserLogin(server_data)) {
        return;
      }

      if (server_data.error) {
        _this7.$root.showGlobalError(server_data.error);
        return;
      }
      _this7.projectGradeData = server_data.data;
    });
  }
}), (0, _defineProperty3.default)(_components$data$comp, "watch", {
  sendOrdersNum: function sendOrdersNum(newVal) {
    if (newVal) {
      this.count = newVal.report.count;
      this.initSendOrdersNum();
    }
  },
  residentData: function residentData(newVal) {
    var _this8 = this;

    if (newVal) {
      this.notResidentNumList = [];
      this.residentNumList = [];
      newVal.series.forEach(function (item) {
        item.data.forEach(function (val, index) {
          if (index === 0) {
            _this8.residentNumList.push(val);
          }
          if (index === 1) {
            _this8.notResidentNumList.push(val);
          }
        });
      });
      this.$nextTick(function () {
        var myEvent = new Event('resize');
        window.dispatchEvent(myEvent);
      });
      this.initResidentPerChart();
    }
  },
  projectGradeData: function projectGradeData(newVal) {
    if (newVal) {
      this.maxNum = Math.ceil(Math.max.apply(Math, (0, _toConsumableArray3.default)(newVal.series[1].data)) / 10) * 10;
      this.maxPercent = Math.ceil(Math.max.apply(Math, (0, _toConsumableArray3.default)(newVal.series[0].data)) / 10) * 10;
      this.initProjectGradeChart();
    }
  }
}), (0, _defineProperty3.default)(_components$data$comp, "computed", {
  epcProject: function epcProject() {
    return [this.residentData.series[0].percent[0], this.residentData.series[1].percent[0]];
  },
  largeProject: function largeProject() {
    return [this.residentData.series[0].percent[1], this.residentData.series[1].percent[1]];
  },
  isShowResidentChart: function isShowResidentChart() {
    var res = this.residentData.series.forEach(function (item) {
      item.data.map(function (value) {
        return value === 0;
      });
    });
    return res;
  }
}), (0, _defineProperty3.default)(_components$data$comp, "mounted", function mounted() {
  var _this9 = this;

  if (this.$route.query.identification) {
    this.isH5 = true;
  }
  window.onresize = function () {
    return function () {
      window.screenWidth = document.body.clientWidth;
      _this9.screenWidth = window.screenWidth;
    }();
  };
}), _components$data$comp);

/***/ }),

/***/ 848:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(170);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(169);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _stringify = __webpack_require__(92);

var _stringify2 = _interopRequireDefault(_stringify);

var _jquery331SlimMin = __webpack_require__(366);

var _jquery331SlimMin2 = _interopRequireDefault(_jquery331SlimMin);

var _Urls = __webpack_require__(12);

var Urls = _interopRequireWildcard(_Urls);

var _VueHelper = __webpack_require__(17);

var VueHelper = _interopRequireWildcard(_VueHelper);

var _axios = __webpack_require__(94);

var _axios2 = _interopRequireDefault(_axios);

var _aliOss = __webpack_require__(168);

var _aliOss2 = _interopRequireDefault(_aliOss);

var _weixinJsSdk = __webpack_require__(250);

var _weixinJsSdk2 = _interopRequireDefault(_weixinJsSdk);

var _vant = __webpack_require__(83);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        fileExt: { type: String, default: "jpg,jpeg,png,bmp,gif,pdf,doc,docx,xls,xlsx,zip,rar" }
    },
    data: function data() {
        return {
            client: new _aliOss2.default({
                region: 'oss-cn-shenzhen',
                accessKeyId: 'LTAI4GGHb3kkSnv9MdPdPb4Y',
                accessKeySecret: 'yEOrbRYDSIJpgjGiZk9yTsuSAyava9',
                bucket: 'xmoty',
                timeout: 600000
            }),
            url: '',
            name: 'files',
            dataList: [],
            dialogVisible: false,
            delId: '',
            fileList: [],
            num: 0,
            loading: false,
            ext: ['jpg', 'jpeg', 'png', 'bmp', 'gif', 'pdf', 'doc', 'docx', 'xls', 'xlsx', 'zip', 'rar']
        };
    },
    mounted: function mounted() {
        this.fileList = JSON.parse(this.getUrlParam('dataList'));
    },

    methods: {
        changeURLArg: function changeURLArg(url, arg, arg_val) {
            var pattern = arg + '=([^&]*)';
            var replaceText = arg + '=' + arg_val;
            if (url.match(pattern)) {
                var tmp = '/(' + arg + '=)([^&]*)/gi';
                tmp = url.replace(eval(tmp), replaceText);
                return tmp;
            } else {
                if (url.match('[\?]')) {
                    return url + '&' + replaceText;
                } else {
                    return url + '?' + replaceText;
                }
            }
            return url + '\n' + arg + '\n' + arg_val;
        },
        save: function save() {
            var dataList = [];
            this.dataList.map(function (item) {
                dataList.push({
                    id: item.id,
                    url: item.url
                });
            });
            var str = this.changeURLArg(window.location.href, 'dataList', (0, _stringify2.default)(this.fileList.concat(dataList)));
            _weixinJsSdk2.default.miniProgram.navigateTo({
                url: '/pages/packageMoney/pages/applyStampEditNew/main?' + str.split('?')[1]
            });
        },
        getUrlParam: function getUrlParam(name) {
            var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
            var r = window.location.href.split('?')[1] && window.location.href.split('?')[1].match(reg);
            if (r != null) {
                return decodeURIComponent(r[2]);
            }
            return null;
        },
        beforeUpload: function beforeUpload(file) {
            if (!this.checkAccept(file)) {
                return false;
            }

            if (!this.checkSize(file)) {
                return false;
            }
            return true;
        },
        checkSize: function checkSize(file) {
            if (this.isImage(file.name)) {
                var isLt2M = file.size / 1024 / 1024 < 20;
                if (!isLt2M) {
                    this.$message.error('图片大小不能超过 20M!');
                    return false;
                }
            } else {
                var _isLt2M = file.size / 1024 / 1024 < 200;
                if (!_isLt2M) {
                    this.$message.error('文档大小不能超过 200M!');
                    return false;
                }
            }
            return true;
        },
        checkAccept: function checkAccept(file) {
            var inst = this;
            var matchOne = false;
            var extList = inst.fileExt.split(",");
            for (var i = 0; i < extList.length; i++) {
                matchOne = new RegExp(extList[i] + "$").test(file.name.toLowerCase());
                if (matchOne) {
                    break;
                }
            }

            if (!matchOne) {
                inst._showError('上传文件的后缀名必须是: ' + inst.fileExt + ' 之一');
                return false;
            }

            return true;
        },
        getUploadFinished: function getUploadFinished() {
            var fla = true;
            this.dataList.forEach(function (e) {
                if (!e.id) {
                    fla = false;
                }
            });
            return fla;
        },
        getAttachIds: function getAttachIds() {
            return VueHelper.getIdList(this.dataList);
        },
        setFilePreview: function setFilePreview() {
            var file_head2 = document.getElementById("file_head2");
            var file = file_head2.files[0];
            file.uid = file.lastModified;
            console.log(file_head2.files[0].lastModified);
            var content = {
                file: file
            };
            this.myUpload(content);
        },
        uploadfile: function uploadfile(upfile, name, uid) {
            console.log(upfile.requestUrls[0]);
            var inst = this;
            var url = Urls.new_upload_attach;
            var newUrl = upfile.requestUrls[0].replace('http://xmoty.oss-cn-shenzhen.aliyuncs.com', 'https://xmyun.zhoty.com').replace('https://xmoty.oss-cn-shenzhen.aliyuncs.com', 'https://xmyun.zhoty.com');
            var params = {
                url: newUrl,
                size: upfile.headers['content-length'] ? upfile.headers['content-length'] : 0,
                contentType: upfile.headers['content-type'],
                name: name,
                uid: uid
            };
            this.$root.ajaxPost(url, params, function (server_data) {
                inst.num = inst.num + 1;

                inst.dataList.forEach(function (e) {
                    if (e.uid == server_data.uid) {
                        e.id = server_data.id;
                        e.url = server_data.url;
                    }
                });
                if (inst.dataList.length == inst.num) {
                    var dataList = [];
                    inst.dataList.map(function (item) {
                        dataList.push({
                            id: item.id,
                            url: item.url
                        });
                    });
                    var str = inst.changeURLArg(window.location.href, 'dataList', (0, _stringify2.default)(inst.fileList.concat(dataList)));
                    _weixinJsSdk2.default.miniProgram.redirectTo({
                        url: '/pages/packageMoney/pages/applyStampEditNew/main?' + str.split('?')[1]
                    });
                }
            });
        },
        myUpload: function myUpload(content) {
            var multipartUpload = function () {
                var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                    var result, head, iconUrl, hz;
                    return _regenerator2.default.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    _context.prev = 0;
                                    _context.next = 3;
                                    return inst.client.multipartUpload('xmerp/xmfiles/' + date.year + '/' + _month + '/' + _date + '/' + fileName + '.' + fileType, content.file, {
                                        progress: progress,

                                        meta: {
                                            year: 2020,
                                            people: 'test'
                                        }
                                    });

                                case 3:
                                    result = _context.sent;
                                    _context.next = 6;
                                    return inst.client.head('xmerp/xmfiles/' + date.year + '/' + _month + '/' + _date + '/' + fileName + '.' + fileType);

                                case 6:
                                    head = _context.sent;

                                    console.log(head);
                                    iconUrl = void 0;
                                    hz = inst.getCaption(head.res.requestUrls[0], 1);
                                    _context.t0 = hz;
                                    _context.next = _context.t0 === 'xls' ? 13 : _context.t0 === 'xlsx' ? 13 : _context.t0 === 'doc' ? 15 : _context.t0 === 'docx' ? 15 : _context.t0 === 'ppt' ? 17 : _context.t0 === 'pptx' ? 17 : _context.t0 === 'pdf' ? 19 : _context.t0 === 'rar' ? 21 : _context.t0 === 'zip' ? 21 : _context.t0 === 'jpg' ? 23 : _context.t0 === 'png' ? 23 : _context.t0 === 'gif' ? 23 : _context.t0 === 'jpeg' ? 23 : _context.t0 === 'bmp' ? 23 : 25;
                                    break;

                                case 13:
                                    iconUrl = 'http://xmyun.zhoty.com/resource/xapp-pm/static/image/fileShare/xls.png';
                                    return _context.abrupt('break', 27);

                                case 15:
                                    iconUrl = 'http://xmyun.zhoty.com/resource/xapp-pm/static/image/fileShare/word.png';
                                    return _context.abrupt('break', 27);

                                case 17:
                                    iconUrl = 'http://xmyun.zhoty.com/resource/xapp-pm/static/image/fileShare/ppt.png';
                                    return _context.abrupt('break', 27);

                                case 19:
                                    iconUrl = 'http://xmyun.zhoty.com/resource/xapp-pm/static/image/fileShare/pdf.png';
                                    return _context.abrupt('break', 27);

                                case 21:
                                    iconUrl = 'http://xmyun.zhoty.com/resource/xapp-pm/static/image/fileShare/zip.png';
                                    return _context.abrupt('break', 27);

                                case 23:
                                    iconUrl = head.res.requestUrls[0];
                                    return _context.abrupt('break', 27);

                                case 25:
                                    iconUrl = 'http://xmyun.zhoty.com/resource/xapp-pm/static/image/fileShare/tongyong.png';
                                    return _context.abrupt('break', 27);

                                case 27:

                                    inst.dataList.forEach(function (e) {
                                        if (content.file.uid == e.uid) {
                                            e.loading = false;
                                            e.iconUrl = iconUrl;
                                        }
                                    });

                                    _context.next = 30;
                                    return inst.uploadfile(head.res, content.file.name, content.file.uid);

                                case 30:
                                    _context.next = 36;
                                    break;

                                case 32:
                                    _context.prev = 32;
                                    _context.t1 = _context['catch'](0);

                                    if (_context.t1.code === 'ConnectionTimeoutError') {
                                        console.log('TimeoutError');
                                    }
                                    console.log(_context.t1);

                                case 36:
                                case 'end':
                                    return _context.stop();
                            }
                        }
                    }, _callee, this, [[0, 32]]);
                }));

                return function multipartUpload() {
                    return _ref.apply(this, arguments);
                };
            }();

            this.loading = true;
            var inst = this;
            var nowDate = new Date();
            var date = {
                year: nowDate.getFullYear(),
                month: nowDate.getMonth() + 1,
                date: nowDate.getDate()
            };

            var _month = date.month < 10 ? '0' + date.month : date.month;
            var _date = date.date < 10 ? '0' + date.date : date.date;
            var systemDate = date.year + _month + _date;
            var fileName = date.year + _month + _date + Date.now();

            var fileType = content.file.name.slice(content.file.name.lastIndexOf('.') + 1, content.file.name.length);

            if (!this.ext.includes(fileType)) {
                this.loading = false;
                (0, _vant.Toast)('\u4E0D\u652F\u6301' + fileType + '\u7C7B\u578B\u6587\u4EF6\u4E0A\u4F20');
                return;
            }

            inst.dataList.push({
                loading: true,
                percentage: 0,
                name: content.file.name,
                uid: content.file.uid
            });

            var progress = function progress(p, _checkpoint) {
                inst.dataList.forEach(function (e) {
                    if (_checkpoint && _checkpoint.file.uid == e.uid) {
                        e.percentage = Number((p * 100).toFixed(0));
                    }
                });
            };

            multipartUpload();
        },
        showAttachs: function showAttachs(attachIds) {
            if (!attachIds) return;
            var inst = this;
            var url = Urls.file_get_attach_list;
            var params = {
                'attachIds': (0, _stringify2.default)(attachIds)
            };
            console.log('params', params);

            this.$root.ajaxPost(url, params, function (data) {
                if (!data) {
                    return;
                }

                inst.dataList = [];

                for (var i = 0; i < data.length; i++) {
                    var attach = data[i];

                    var file = {
                        'id': attach.id,
                        'name': attach.name,
                        'url': attach.url,
                        'raw': { 'size': attach.size }
                    };
                    if (inst.mode == 'upload') {
                        inst._changeThumbnailIf(attach.url);
                    } else {
                        var previewUrl = inst.isImage(attach.url) ? attach.url : '/static/img/document.png';
                        file['previewUrl'] = previewUrl;
                    }
                    inst.dataList.push(file);
                }
                for (var _i = 0; _i < inst.dataList.length; _i++) {
                    var hz = inst.getCaption(inst.dataList[_i].url, 1);
                    switch (hz) {
                        case 'xls':case 'xlsx':
                            inst.dataList[_i].iconUrl = 'http://xmyun.zhoty.com/resource/xapp-pm/static/image/fileShare/xls.png';
                            break;
                        case 'doc':case 'docx':
                            inst.dataList[_i].iconUrl = 'http://xmyun.zhoty.com/resource/xapp-pm/static/image/fileShare/word.png';
                            break;
                        case 'ppt':case 'pptx':
                            inst.dataList[_i].iconUrl = 'http://xmyun.zhoty.com/resource/xapp-pm/static/image/fileShare/ppt.png';
                            break;
                        case 'pdf':
                            inst.dataList[_i].iconUrl = 'http://xmyun.zhoty.com/resource/xapp-pm/static/image/fileShare/pdf.png';
                            break;
                        case 'zip':case 'rar':
                            inst.dataList[_i].iconUrl = 'http://xmyun.zhoty.com/resource/xapp-pm/static/image/fileShare/zip.png';
                            break;
                        case 'jpg':case 'png':case 'gif':case 'jpeg':case 'bmp':
                            inst.dataList[_i].iconUrl = inst.dataList[_i].url;
                            break;
                        default:
                            inst.dataList[_i].iconUrl = 'http://xmyun.zhoty.com/resource/xapp-pm/static/image/fileShare/tongyong.png';
                            break;
                    }
                }
            });
        },
        getCaption: function getCaption(obj, state) {
            var index = obj.lastIndexOf("\.");
            if (state == 0) {
                obj = obj.substring(0, index);
            } else {
                obj = obj.substring(index + 1, obj.length);
            }
            return obj;
        },
        _showError: function _showError(msg) {
            this.$notify.error({
                title: '错误',
                message: msg,
                duration: 3000,
                position: 'bottom-right'
            });
        },
        _showSucc: function _showSucc(msg) {
            this.$notify({
                title: '成功',
                message: msg,
                type: 'success',
                duration: 3000,
                position: 'bottom-right'
            });
        },
        _changeThumbnailIf: function _changeThumbnailIf(file_url) {
            if (!this.isImage(file_url)) {
                this.$nextTick(function () {
                    (0, _jquery331SlimMin2.default)(".el-upload-list__item-thumbnail[src='" + file_url + "']").attr('src', '../static/img/document.png');
                });
            }
        },
        isImage: function isImage(data) {
            var imgLi = ['jpg', 'jpeg', 'png', 'bmp', 'gif'];
            var matchOne = false;

            for (var i = 0; i < imgLi.length; i++) {
                matchOne = new RegExp(imgLi[i] + "$").test(data.toLowerCase());
                if (matchOne) {
                    break;
                }
            }
            return matchOne;
        },
        deleteFile: function deleteFile(id) {
            this.delId = id;
            this.secondDelete();
        },
        secondDelete: function secondDelete() {
            var inst = this;
            var url = Urls.file_delete_attach;
            var params = {
                'id': this.delId
            };
            this.$root.doPost(url, params, function (server_data) {
                if (!inst.$root.isUserLogin(server_data)) {
                    return;
                }

                if (server_data.error) {
                    inst.$root.showGlobalError(server_data.error);
                    return;
                }

                var deleteId = inst.delId;
                for (var i = 0; i < inst.dataList.length; i++) {
                    if (deleteId == inst.dataList[i].id) {
                        inst.dataList.splice(i, 1);
                        break;
                    }
                }
            });
        },
        download: function download(url) {
            window.open(url);
        }
    }
};

/***/ }),

/***/ 849:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Urls = __webpack_require__(12);

var Urls = _interopRequireWildcard(_Urls);

var _HeadControl = __webpack_require__(43);

var _HeadControl2 = _interopRequireDefault(_HeadControl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = {
  data: function data() {
    return {
      orgCode: "",
      dataRange: [],
      settlementData: {},
      iconAndImg: {},
      projectTypeData: [],
      screenWidth: document.body.clientWidth,
      cooperationTypeData: [],
      isH5: false
    };
  },

  components: {
    HeadControl: _HeadControl2.default
  },
  methods: {
    init: function init() {
      this.$refs.headControl.getDatas('month');
      this.$refs.headControl.getSysOrg();
    },
    changeVal: function changeVal(val) {
      this.orgCode = val;
      this.getSettlementProjectData();
      this.getSettlementProjectTypeData();
      this.getCooperationTypeData();
    },
    changDate: function changDate(val) {
      this.dataRange = val;
      this.getSettlementProjectData();
      this.getSettlementProjectTypeData();
      this.getCooperationTypeData();
    },
    changePicker: function changePicker(val) {
      this.dataRange = val;
      this.getSettlementProjectData();
      this.getSettlementProjectTypeData();
      this.getCooperationTypeData();
    },
    getSettlementProjectData: function getSettlementProjectData() {
      var _this = this;

      var url = Urls.getEchartsSettlementReportDataByProject;
      var params = {
        orgCode: this.orgCode || "",
        startTime: this.dataRange.length ? this.dataRange[0] : "",
        endTime: this.dataRange.length ? this.dataRange[1] : ""
      };
      this.$root.doPost(url, params, function (server_data) {
        if (!_this.$root.isUserLogin(server_data)) {
          return;
        }

        if (server_data.error) {
          _this.$root.showGlobalError(server_data.error);
          return;
        }
        _this.settlementData = server_data.data;
      });
    },
    getSettlementProjectTypeData: function getSettlementProjectTypeData() {
      var _this2 = this;

      var url = Urls.getEchartsSettlementReportDataByType;
      var params = {
        orgCode: this.orgCode || "",
        startTime: this.dataRange.length ? this.dataRange[0] : "",
        endTime: this.dataRange.length ? this.dataRange[1] : "",
        itemCode: 'PROJECT_CATEGORY'
      };
      this.$root.doPost(url, params, function (server_data) {
        if (!_this2.$root.isUserLogin(server_data)) {
          return;
        }

        if (server_data.error) {
          _this2.$root.showGlobalError(server_data.error);
          return;
        }
        _this2.projectTypeData = server_data.data;
      });
    },
    getCooperationTypeData: function getCooperationTypeData() {
      var _this3 = this;

      var url = Urls.getEchartsSettlementReportDataByCooperationType;
      var params = {
        orgCode: this.orgCode || "",
        startTime: this.dataRange.length ? this.dataRange[0] : "",
        endTime: this.dataRange.length ? this.dataRange[1] : "",
        itemCode: 'COOPERATION_TYPE'
      };
      this.$root.doPost(url, params, function (server_data) {
        if (!_this3.$root.isUserLogin(server_data)) {
          return;
        }

        if (server_data.error) {
          _this3.$root.showGlobalError(server_data.error);
          return;
        }
        _this3.cooperationTypeData = server_data.data;
      });
    },
    initSettlementNumChart: function initSettlementNumChart() {
      var _this4 = this;

      this.settlementNumChart = this.$echarts.init(this.$refs.settlementNum, { width: 'auto' });
      var option = {
        textStyle: {
          fontFamily: 'PingFang-M'
        },
        grid: {
          left: this.isH5 ? 20 : 60,
          top: 32,
          right: this.isH5 ? 20 : 60,
          bottom: 30
        },
        tooltip: {
          trigger: 'item',
          formatter: function formatter(params) {
            return "<div style=\"font-size:14px; padding:4px;\">\n                         <div>" + params.name + "\uFF1A" + _this4.settlementData.series[0].data[params.dataIndex] + "\u4E2A</div>\n                         <div>\u5360\u6BD4\uFF1A" + params.value + "%</div>\n                     </div>";
          }
        },
        xAxis: {
          show: false,
          type: "value"
        },
        yAxis: [{
          type: "category",
          inverse: true,
          axisLabel: {
            formatter: function formatter(val, index) {
              var res = "";
              _this4.settlementData.series[0].data.forEach(function (item, i) {
                if (i == index) {
                  res = item;
                }
              });
              return val + ("\uFF08" + res + "\u4E2A\uFF09");
            },
            textStyle: {
              color: "#666666",
              fontSize: "14",
              lineHeight: 20
            },
            padding: [0, -110, 35, 15],
            align: "left",
            rich: {}
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          data: this.settlementData.yAxis.data
        }, {
          type: "category",
          inverse: true,
          axisTick: "none",
          axisLine: "none",
          position: "left",
          show: true,
          axisLabel: {
            textStyle: {
              color: "#57b9ff",
              fontSize: "14"
            },
            padding: [0, -45, -45, 15],
            formatter: "({value}%)",
            align: "left",
            rich: {}
          },
          data: this.settlementData.series[0].percent
        }],
        series: [{
          type: "bar",
          zlevel: 1,
          itemStyle: {
            normal: {
              barBorderRadius: 10,
              color: "#57b9ff"
            }
          },
          barWidth: 10,
          data: this.settlementData.series[0].percent
        }, {
          type: "bar",
          silent: true,
          barWidth: 10,
          barGap: "-100%",
          data: [100, 100],
          itemStyle: {
            normal: {
              color: "#eeeeee",
              barBorderRadius: 10
            }
          }
        }]
      };
      this.settlementNumChart.setOption(option);

      window.addEventListener("resize", function () {
        _this4.isH5 ? _this4.settlementNumChart.resize({ width: _this4.screenWidth - 24 }) : _this4.settlementNumChart.resize();
      });
      this.isH5 ? this.settlementNumChart.resize({ width: this.screenWidth - 24 }) : this.settlementNumChart.resize();
    },
    initProjectTypeChart: function initProjectTypeChart() {
      var _this5 = this;

      this.projectTypeChart = this.$echarts.init(this.$refs.projectType);
      var option = {
        textStyle: {
          fontFamily: 'PingFang-M'
        },
        title: {
          text: "项目类型",
          padding: this.isH5 ? [24, 0, 0, 15] : [24, 0, 0, 30],
          textStyle: {
            fontWeight: 'normal'
          }
        },
        tooltip: {
          show: this.isH5 ? true : this.screenWidth <= 1366 ? true : false,
          trigger: 'item',
          formatter: function formatter(params) {
            return "<div style=\"font-size:14px; padding:4px;\">\n                         <div>" + params.name + "\uFF1A" + params.value + "\u4E2A</div>\n                         <div>\u5360\u6BD4\uFF1A" + params.data.percent + "%</div>\n                     </div>";
          }
        },
        color: ["#59b9fe", "#62d8ae", "#ffb971"],
        legend: {
          orient: this.isH5 ? "horizontal" : "vertical",
          x: this.isH5 ? '120' : '30',
          y: this.isH5 ? '20' : '70',
          itemGap: 14,
          itemWidth: 10,
          itemHeight: 10,
          data: this.projectTypeData,
          formatter: function formatter(name) {
            return name;
          }
        },
        series: [{
          name: "项目类型",
          type: "pie",
          stillShowZeroSum: false,
          radius: ['40%', '60%'],
          center: ["50%", "50%"],
          silent: this.isH5 ? false : this.screenWidth <= 1366 ? false : true,
          itemStyle: {
            align: "left",
            normal: {
              borderWidthLeft: this.isH5 ? 'none' : this.screenWidth <= 1366 ? 'none' : 1,
              borderColor: this.isH5 ? 'none' : this.screenWidth <= 1366 ? 'none' : '#fff',
              label: {
                show: this.projectTypeChartShow ? true : false,
                position: this.isH5 ? 'inside' : this.screenWidth <= 1366 ? 'inside' : 'outside',
                fontSize: 12,
                formatter: function formatter(params) {
                  if (_this5.isH5 || _this5.screenWidth <= 1366) {
                    return params.value == 0 ? '' : params.data.percent + "%";
                  } else {
                    return "{left|" + params.name + "\uFF1A" + params.value + "\u4E2A\n\u5360\u6BD4\uFF1A" + params.data.percent + "%}";
                  }
                },
                rich: {
                  left: {
                    align: "left",
                    lineHeight: 15,
                    color: "#666666"
                  }
                }
              }
            }
          },
          labelLine: {
            normal: {
              show: this.projectTypeChartShow ? true : false,
              length: 15,
              length2: this.isH5 ? 15 : 20
            }
          },
          data: this.projectTypeData
        }]
      };
      this.projectTypeChart.setOption(option);
      window.addEventListener("resize", function () {
        _this5.isH5 ? _this5.projectTypeChart.resize({ width: _this5.screenWidth - 24 }) : _this5.projectTypeChart.resize();
      });
      this.isH5 ? this.projectTypeChart.resize({ width: this.screenWidth - 24 }) : this.projectTypeChart.resize();
    },
    initCooperationTypeChart: function initCooperationTypeChart() {
      var _this6 = this;

      this.cooperationTypeChart = this.$echarts.init(this.$refs.cooperationType);
      var option = {
        textStyle: {
          fontFamily: 'PingFang-M'
        },
        title: {
          text: "合作类型",
          padding: this.isH5 ? [24, 0, 0, 15] : [24, 0, 0, 30],
          textStyle: {
            fontWeight: 'normal'
          }
        },
        tooltip: {
          show: this.isH5 ? true : this.screenWidth <= 1366 ? true : false,
          trigger: 'item',
          formatter: function formatter(params) {
            return "<div style=\"font-size:14px; padding:4px;\">\n                         <div>" + params.name + "\uFF1A" + params.value + "\u4E2A</div>\n                         <div>\u5360\u6BD4\uFF1A" + params.data.percent + "%</div>\n                     </div>";
          }
        },
        color: ["#59b9fe", "#62d8ae", "#ffb971"],
        legend: {
          orient: this.isH5 ? "horizontal" : "vertical",
          x: this.isH5 ? '120' : '30',
          y: this.isH5 ? '20' : '70',
          itemGap: 14,
          itemWidth: 10,
          itemHeight: 10,
          data: this.cooperationTypeData,
          formatter: function formatter(name) {
            return name;
          }
        },
        series: [{
          name: "合作类型",
          type: "pie",
          stillShowZeroSum: false,
          radius: ["0%", "60%"],
          center: ["50%", "50%"],
          silent: this.isH5 ? false : this.screenWidth <= 1366 ? false : true,
          itemStyle: {
            align: "left",
            normal: {
              borderWidthLeft: this.isH5 ? 'none' : this.screenWidth <= 1366 ? 'none' : 1,
              borderColor: this.isH5 ? 'none' : this.screenWidth <= 1366 ? 'none' : '#fff',
              label: {
                show: this.cooperationChartShow ? true : false,
                position: this.isH5 ? 'inside' : this.screenWidth <= 1366 ? 'inside' : 'outside',
                fontSize: 12,
                formatter: function formatter(params) {
                  if (_this6.isH5 || _this6.screenWidth <= 1366) {
                    return params.value == 0 ? '' : params.data.percent + "%";
                  } else {
                    return "{left|" + params.name + "\uFF1A" + params.value + "\u4E2A\n\u5360\u6BD4\uFF1A" + params.data.percent + "%}";
                  }
                },
                rich: {
                  left: {
                    align: "left",
                    lineHeight: this.isH5 ? 12 : 18,
                    color: "#666666"
                  }
                }
              }
            }
          },
          labelLine: {
            normal: {
              show: this.cooperationChartShow ? true : false,
              length: 15,
              length2: this.isH5 ? 15 : 20
            }
          },
          data: this.cooperationTypeData
        }]
      };
      this.cooperationTypeChart.setOption(option);
      window.addEventListener("resize", function () {
        _this6.isH5 ? _this6.cooperationTypeChart.resize({ width: _this6.screenWidth - 24 }) : _this6.cooperationTypeChart.resize();
      });
      this.isH5 ? this.cooperationTypeChart.resize({ width: this.screenWidth - 24 }) : this.cooperationTypeChart.resize();
    }
  },
  watch: {
    settlementData: function settlementData(newVal) {
      if (newVal) {
        this.iconAndImg = newVal.report;
        this.initSettlementNumChart();
        this.settlementNumChart.resize();
      }
    },
    projectTypeData: function projectTypeData(newVal) {
      if (newVal) {
        this.initProjectTypeChart();
      }
    },
    cooperationTypeData: function cooperationTypeData(newVal) {
      if (newVal) {
        this.initCooperationTypeChart();
      }
    },
    screenWidth: function screenWidth() {
      if (this.cooperationChartShow) {
        this.initCooperationTypeChart();
      }
      if (this.projectTypeChartShow) {
        this.initProjectTypeChart();
      }
    }
  },
  computed: {
    projectTypeChartShow: function projectTypeChartShow() {
      return this.projectTypeData.some(function (item) {
        return item.value > 0;
      });
    },
    cooperationChartShow: function cooperationChartShow() {
      return this.cooperationTypeData.some(function (item) {
        return item.value > 0;
      });
    }
  },
  mounted: function mounted() {
    var _this7 = this;

    if (this.$route.query.identification) {
      this.isH5 = true;
    }
    window.onresize = function () {
      return function () {
        window.screenWidth = document.body.clientWidth;
        _this7.screenWidth = window.screenWidth;
      }();
    };
  }
};

/***/ }),

/***/ 850:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(31);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _Urls = __webpack_require__(12);

var Urls = _interopRequireWildcard(_Urls);

var _HeadControl = __webpack_require__(43);

var _HeadControl2 = _interopRequireDefault(_HeadControl);

var _VueHelper = __webpack_require__(17);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    HeadControl: _HeadControl2.default
  },
  data: function data() {
    return {
      dataRange: [],
      summaryList: {},
      invoiceList: {},
      invoiceTotal: {},
      payableList: {},
      payableTotal: {},
      isH5: false,
      screenWidth: document.body.clientWidth
    };
  },

  methods: {
    init: function init() {
      this.$refs.HeadControl.getDatas('month');
    },
    changePicker: function changePicker(data) {
      this.dataRange = data;
      this.getSummaryData();
      this.getInvoiceData();
      this.getPayableData();
    },
    changDate: function changDate(data) {
      this.dataRange = data;
      this.getSummaryData();
      this.getInvoiceData();
      this.getPayableData();
    },
    aFormat: function aFormat(amount) {
      return (0, _VueHelper.amountFormat)(amount);
    },
    getSummaryData: function getSummaryData() {
      var _this = this;

      var url = Urls.financeReturnedSummaryReportItemData;
      var params = {
        startTime: this.dataRange.length ? this.dataRange[0] : "",
        endTime: this.dataRange.length ? this.dataRange[1] : ""
      };
      this.$root.doPost(url, params, function (server_data) {
        if (!_this.$root.isUserLogin(server_data)) {
          return;
        }

        if (server_data.error) {
          _this.$root.showGlobalError(server_data.error);
          return;
        }
        _this.summaryList = server_data.data.series;
      });
    },
    initChart: function initChart() {
      var _this2 = this;

      this.myChart = this.$echarts.init(this.$refs.invoiceTotal, { width: 'auto' });
      var _invoiceList = this.invoiceList,
          legend = _invoiceList.legend,
          series = _invoiceList.series,
          xAxis = _invoiceList.xAxis;

      var maxAmount = Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].data).concat((0, _toConsumableArray3.default)(series[1].data)));

      var option = {
        textStyle: {
          fontFamily: 'PingFang-M'
        },
        title: {
          text: "代付金额&实付金额走势",
          top: "24",
          left: this.isH5 ? "15" : "30",
          textStyle: {
            fontWeight: 500
          }
        },
        grid: {
          left: (0, _VueHelper.floatWidth)(maxAmount, 9) + 25,
          right: this.isH5 ? "20" : '40',
          top: "100",
          bottom: this.isH5 ? 30 : 50
        },
        tooltip: {
          show: true,
          trigger: "axis",
          formatter: function formatter(params) {
            var h = '<div style="padding: 5px 10px; font-size: 12px">';
            params.forEach(function (item) {
              if (item.seriesIndex == 0) {
                h += '<div >' + (0, _VueHelper.EchartsformatDate)(item.axisValue) + '</div>\n                        <div>' + item.marker + item.seriesName + '\uFF1A' + (0, _VueHelper.amountFormat)(item.value) + '\u5143</div>\n                      ';
              } else {
                if (params.length == 1) {
                  h += '<div >' + (0, _VueHelper.EchartsformatDate)(item.axisValue) + '</div>';
                }
                h += '<div>' + item.marker + item.seriesName + '\uFF1A' + (0, _VueHelper.amountFormat)(item.value) + '\u5143</div></div>';
              }
            });

            return h;
          },
          axisPointer: {
            lineStyle: {
              color: '#DDDDDD',
              type: 'solid'
            }
          }
        },
        legend: {
          show: true,
          x: this.isH5 ? 250 : 300,
          y: this.isH5 ? 13 : 25,
          icon: "circle",
          itemGap: this.isH5 ? 10 : 25,
          itemWidth: 8,
          itemHeight: 8,
          textStyle: {
            color: "#646464",
            height: 10,
            rich: {
              a: {
                verticalAlign: "middle"
              }
            }
          },
          data: legend
        },
        xAxis: [{
          type: "category",
          boundaryGap: 0,
          axisLine: {
            show: Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].data).concat((0, _toConsumableArray3.default)(series[1].data))) == 0 ? true : false,
            lineStyle: {
              color: '#dddddd'
            }
          },
          axisLabel: {
            color: "#666666",
            interval: this.screenWidth <= 1366 || (0, _VueHelper.checkDay)(this.dataRange) < 30 ? 'auto' : Math.ceil(xAxis.data.length / 10),

            show: this.isH5 ? false : true,
            margin: 15
          },
          splitLine: {
            show: Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].data).concat((0, _toConsumableArray3.default)(series[1].data))) == 0 ? false : true,
            lineStyle: {
              color: "#dddddd",
              type: "solid"
            }
          },
          axisTick: {
            show: false
          },
          data: xAxis.data
        }],
        yAxis: [{
          type: "value",
          name: "金额(万)",
          min: 0,
          max: maxAmount,
          splitNumber: 5,
          interval: maxAmount < 0.05 * 10000 ? maxAmount : maxAmount / 5,
          show: Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].data).concat((0, _toConsumableArray3.default)(series[1].data))) == 0 ? false : true,
          splitLine: {
            show: Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].data).concat((0, _toConsumableArray3.default)(series[1].data))) == 0 ? false : true,
            lineStyle: {
              color: "#dddddd",
              type: "solid"
            }
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            show: true,

            textStyle: {
              color: "#666666"
            },
            formatter: function formatter(params) {
              var res = (0, _VueHelper.floatDiv)(params, 10000);
              res.toFixed(2);
              return Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].data).concat((0, _toConsumableArray3.default)(series[1].data))) == 0 ? params : params == 0 ? 0 : (0, _VueHelper.subStringNum)(res, 2);
            }
          },
          axisTick: {
            show: false
          },

          nameTextStyle: {
            padding: [0, 0, 0, -20],
            color: "#666666"
          }
        }],
        series: [{
          name: series[0].name,
          type: "line",
          smooth: true,
          symbolSize: 2,
          showSymbol: false,
          itemStyle: {
            normal: {
              opacity: Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].data).concat((0, _toConsumableArray3.default)(series[1].data))) == 0 ? 0 : 1,
              color: "#5ebbff",
              lineStyle: {
                color: "#5ebbff",
                width: 2,
                opacity: Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].data).concat((0, _toConsumableArray3.default)(series[1].data))) == 0 ? 0 : 1
              }
            }
          },
          areaStyle: {
            normal: {
              color: "#e6f5ff"
            }
          },
          data: series[0].data
        }, {
          name: series[1].name,
          type: "line",
          smooth: true,
          stack: "总量",
          symbolSize: 2,
          showSymbol: false,
          itemStyle: {
            normal: {
              opacity: Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].data).concat((0, _toConsumableArray3.default)(series[1].data))) == 0 ? 0 : 1,
              color: "#61D9AC",
              lineStyle: {
                color: "#61D9AC",
                width: 2,
                opacity: Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].data).concat((0, _toConsumableArray3.default)(series[1].data))) == 0 ? 0 : 1
              }
            }
          },
          areaStyle: {
            normal: {
              color: "#61D9AC",
              opacity: 0.15
            }
          },
          data: series[1].data
        }]
      };
      this.myChart.setOption(option);
      window.addEventListener("resize", function () {
        _this2.isH5 ? _this2.myChart.resize({ width: _this2.screenWidth - 24 }) : _this2.myChart.resize();
      });
      this.isH5 ? this.myChart.resize({ width: this.screenWidth - 24 }) : this.myChart.resize();
    },
    getInvoiceData: function getInvoiceData() {
      var _this3 = this;

      var url = Urls.payableReturnedReportItemData;
      var params = {
        startTime: this.dataRange.length ? this.dataRange[0] : "",
        endTime: this.dataRange.length ? this.dataRange[1] : ""
      };
      this.$root.doPost(url, params, function (server_data) {
        if (!_this3.$root.isUserLogin(server_data)) {
          return;
        }

        if (server_data.error) {
          _this3.$root.showGlobalError(server_data.error);
          return;
        }
        _this3.invoiceList = server_data.data;
        _this3.invoiceTotal = server_data.data.amountAndCount;
        _this3.initChart();
      });
    },
    initChart2: function initChart2() {
      var _this4 = this;

      this.myChart2 = this.$echarts.init(this.$refs.payableTotal, { width: 'auto' });
      var _payableList = this.payableList,
          legend = _payableList.legend,
          series = _payableList.series,
          xAxis = _payableList.xAxis;

      var maxAmount = Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].data).concat((0, _toConsumableArray3.default)(series[1].data)));

      var option = {
        textStyle: {
          fontFamily: 'PingFang-M'
        },
        title: {
          text: "劳务金额&实付金额走势",
          top: "24",
          left: this.isH5 ? "15" : "30",
          textStyle: {
            fontWeight: 500
          }
        },
        grid: {
          left: (0, _VueHelper.floatWidth)(maxAmount, 9) + 25,
          right: this.isH5 ? "20" : '40',
          top: "100",
          bottom: this.isH5 ? 30 : 50
        },
        tooltip: {
          show: true,
          trigger: "axis",
          formatter: function formatter(params) {
            var h = '<div style="padding: 5px 10px; font-size: 12px">';
            params.forEach(function (item) {
              if (item.seriesIndex == 0) {
                h += '<div >' + (0, _VueHelper.EchartsformatDate)(item.axisValue) + '</div>\n                        <div><div>' + item.marker + item.seriesName + '\uFF1A' + (0, _VueHelper.amountFormat)(item.value) + '\u5143</div>\n                      ';
              } else {
                if (params.length == 1) {
                  h += '<div >' + (0, _VueHelper.EchartsformatDate)(item.axisValue) + '</div>';
                }
                h += '<div>' + item.marker + item.seriesName + '\uFF1A' + (0, _VueHelper.amountFormat)(item.value) + '\u5143</div></div>';
              }
            });

            return h;
          },
          axisPointer: {
            lineStyle: {
              color: '#DDDDDD',
              type: 'solid'
            }
          }
        },
        legend: {
          show: true,
          x: this.isH5 ? 250 : 300,
          y: this.isH5 ? 13 : 25,
          icon: "circle",
          itemGap: this.isH5 ? 10 : 25,
          itemWidth: 8,
          itemHeight: 8,
          textStyle: {
            color: "#646464",
            height: 10,
            rich: {
              a: {
                verticalAlign: "middle"
              }
            }
          },
          data: legend
        },
        xAxis: [{
          type: "category",
          boundaryGap: 0,
          axisLine: {
            show: Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].data).concat((0, _toConsumableArray3.default)(series[1].data))) == 0 ? true : false,
            lineStyle: {
              color: '#dddddd'
            }
          },
          axisLabel: {
            color: "#666666",
            interval: this.screenWidth <= 1366 || (0, _VueHelper.checkDay)(this.dataRange) < 30 ? 'auto' : Math.ceil(xAxis.data.length / 10),

            show: this.isH5 ? false : true,
            margin: 15
          },
          splitLine: {
            show: Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].data).concat((0, _toConsumableArray3.default)(series[1].data))) == 0 ? false : true,
            lineStyle: {
              color: "#dddddd",
              type: "solid"
            }
          },
          axisTick: {
            show: false
          },
          data: xAxis.data
        }],
        yAxis: [{
          type: "value",
          name: "金额(万)",
          min: 0,
          max: maxAmount,
          splitNumber: 5,
          interval: maxAmount < 0.05 * 10000 ? maxAmount : maxAmount / 5,
          show: Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].data).concat((0, _toConsumableArray3.default)(series[1].data))) == 0 ? false : true,
          splitLine: {
            show: Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].data).concat((0, _toConsumableArray3.default)(series[1].data))) == 0 ? false : true,
            lineStyle: {
              color: "#dddddd",
              type: "solid"
            }
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            show: true,

            textStyle: {
              color: "#666666"
            },
            formatter: function formatter(params) {
              var res = (0, _VueHelper.floatDiv)(params, 10000);
              res.toFixed(2);
              return Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].data).concat((0, _toConsumableArray3.default)(series[1].data))) == 0 ? params : params == 0 ? 0 : (0, _VueHelper.subStringNum)(res, 2);
            }
          },
          axisTick: {
            show: false
          },

          nameTextStyle: {
            padding: [0, 0, 0, -20],
            color: "#666666"
          }
        }],
        series: [{
          name: series[0].name,
          type: "line",
          smooth: true,
          symbolSize: 2,
          showSymbol: false,
          itemStyle: {
            normal: {
              opacity: Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].data).concat((0, _toConsumableArray3.default)(series[1].data))) == 0 ? 0 : 1,
              color: "#5ebbff",
              lineStyle: {
                color: "#5ebbff",
                width: 2,
                opacity: Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].data).concat((0, _toConsumableArray3.default)(series[1].data))) == 0 ? 0 : 1
              }
            }
          },

          data: series[0].data
        }, {
          name: series[1].name,
          type: "line",
          smooth: true,
          stack: "总量",
          symbolSize: 2,
          showSymbol: false,
          itemStyle: {
            normal: {
              opacity: Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].data).concat((0, _toConsumableArray3.default)(series[1].data))) == 0 ? 0 : 1,
              color: "#72d8c0",
              lineStyle: {
                color: "#72d8c0",
                width: 2,
                opacity: Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].data).concat((0, _toConsumableArray3.default)(series[1].data))) == 0 ? 0 : 1
              }
            }
          },

          data: series[1].data
        }]
      };
      this.myChart2.setOption(option);
      window.addEventListener("resize", function () {
        _this4.isH5 ? _this4.myChart2.resize({ width: _this4.screenWidth - 24 }) : _this4.myChart2.resize();
      });
      this.isH5 ? this.myChart2.resize({ width: this.screenWidth - 24 }) : this.myChart2.resize();
    },
    getPayableData: function getPayableData() {
      var _this5 = this;

      var url = Urls.laborReturnedReportItemData;
      var params = {
        startTime: this.dataRange.length ? this.dataRange[0] : "",
        endTime: this.dataRange.length ? this.dataRange[1] : ""
      };
      this.$root.doPost(url, params, function (server_data) {
        if (!_this5.$root.isUserLogin(server_data)) {
          return;
        }

        if (server_data.error) {
          _this5.$root.showGlobalError(server_data.error);
          return;
        }
        _this5.payableList = server_data.data;
        _this5.payableTotal = server_data.data.amountAndCount;
        _this5.initChart2();
      });
    }
  },
  mounted: function mounted() {
    var _this6 = this;

    if (this.$route.query.identification) {
      this.isH5 = true;
    }
    window.onresize = function () {
      return function () {
        window.screenWidth = document.body.clientWidth;
        _this6.screenWidth = window.screenWidth;
      }();
    };
  }
};

/***/ }),

/***/ 851:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(31);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _Urls = __webpack_require__(12);

var Urls = _interopRequireWildcard(_Urls);

var _HeadControl = __webpack_require__(43);

var _HeadControl2 = _interopRequireDefault(_HeadControl);

var _VueHelper = __webpack_require__(17);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    HeadControl: _HeadControl2.default
  },
  data: function data() {
    return {
      dataRange: [],
      summaryList: {},
      invoiceList: {},
      invoiceTotal: {},
      payableList: {},
      payableTotal: {},
      screenWidth: document.body.clientWidth,
      isH5: false
    };
  },
  mounted: function mounted() {
    if (this.$route.query.identification) {
      this.isH5 = true;
    }
    var _this = this;
    window.onresize = function () {
      return function () {
        window.screenWidth = document.body.clientWidth + 17;
        _this.screenWidth = window.screenWidth;
      }();
    };
  },

  methods: {
    init: function init() {
      this.$refs.HeadControl.getDatas('month');
    },
    changePicker: function changePicker(data) {
      this.dataRange = data;
      this.getSummaryData();
      this.getInvoiceData();
      this.getPayableData();
    },
    changDate: function changDate(data) {
      this.dataRange = data;
      this.getSummaryData();
      this.getInvoiceData();
      this.getPayableData();
    },
    aFormat: function aFormat(amount) {
      return (0, _VueHelper.amountFormat)(amount);
    },
    getSummaryData: function getSummaryData() {
      var _this2 = this;

      var url = Urls.financeReceivableSummaryReportItemData;
      var params = {
        startTime: this.dataRange.length ? this.dataRange[0] : "",
        endTime: this.dataRange.length ? this.dataRange[1] : ""
      };
      this.$root.doPost(url, params, function (server_data) {
        if (!_this2.$root.isUserLogin(server_data)) {
          return;
        }

        if (server_data.error) {
          _this2.$root.showGlobalError(server_data.error);
          return;
        }
        _this2.summaryList = server_data.data.series;
      });
    },
    initChart: function initChart() {
      var _this3 = this;

      this.myChart = this.$echarts.init(this.$refs.invoiceTotal, { width: 'auto' });
      var _invoiceList = this.invoiceList,
          legend = _invoiceList.legend,
          series = _invoiceList.series,
          xAxis = _invoiceList.xAxis;

      var maxAmount = Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].data).concat((0, _toConsumableArray3.default)(series[1].data)));
      var option = {
        textStyle: {
          fontFamily: 'PingFang-M'
        },
        title: {
          text: "开票金额&回款金额走势",
          top: "24",
          left: this.isH5 ? "15" : "30",
          textStyle: {
            fontWeight: 500
          }
        },
        grid: {
          left: (0, _VueHelper.floatWidth)(maxAmount, 9) + 25,
          right: this.isH5 ? "20" : '40',
          top: "100",
          bottom: this.isH5 ? 30 : 50
        },
        tooltip: {
          show: true,
          trigger: "axis",
          formatter: function formatter(params) {
            var h = '<div style="padding: 5px 10px; font-size: 12px">';
            params.forEach(function (item) {
              if (item.seriesIndex == 0) {
                h += '<div >' + (0, _VueHelper.EchartsformatDate)(item.axisValue) + '</div>\n                        <div>' + item.marker + item.seriesName + '\uFF1A' + (0, _VueHelper.amountFormat)(item.value) + '\u5143</div>\n                      ';
              } else {
                if (params.length == 1) {
                  h += '<div >' + (0, _VueHelper.EchartsformatDate)(item.axisValue) + '</div>';
                }
                h += '<div>' + item.marker + item.seriesName + '\uFF1A' + (0, _VueHelper.amountFormat)(item.value) + '\u5143</div></div>';
              }
            });

            return h;
          },
          axisPointer: {
            lineStyle: {
              color: '#DDDDDD',
              type: 'solid'
            }
          }
        },
        legend: {
          show: true,
          x: this.isH5 ? 250 : 300,
          y: this.isH5 ? 13 : 25,
          icon: "circle",
          itemGap: this.isH5 ? 10 : 25,
          itemWidth: 8,
          itemHeight: 8,
          textStyle: {
            color: "#646464",
            height: 10,
            rich: {
              a: {
                verticalAlign: "middle"
              }
            }
          },
          data: legend
        },
        xAxis: [{
          type: "category",
          boundaryGap: 0,
          axisLine: {
            show: Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].data).concat((0, _toConsumableArray3.default)(series[1].data))) == 0 ? true : false,
            lineStyle: {
              color: '#dddddd'
            }
          },
          axisLabel: {
            color: "#666666",
            interval: this.screenWidth <= 1366 || (0, _VueHelper.checkDay)(this.dataRange) < 30 ? 'auto' : Math.ceil(xAxis.data.length / 10),
            show: this.isH5 ? false : true,
            margin: 15
          },
          splitLine: {
            show: Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].data).concat((0, _toConsumableArray3.default)(series[1].data))) == 0 ? false : true,
            lineStyle: {
              color: "#dddddd",
              type: "solid"
            }
          },
          axisTick: {
            show: false
          },
          data: xAxis.data
        }],
        yAxis: [{
          type: "value",
          name: "金额(万)",
          min: 0,
          max: maxAmount,
          splitNumber: 5,
          interval: maxAmount < 0.05 * 10000 ? maxAmount : maxAmount / 5,
          show: Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].data).concat((0, _toConsumableArray3.default)(series[1].data))) == 0 ? false : true,
          splitLine: {
            show: Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].data).concat((0, _toConsumableArray3.default)(series[1].data))) == 0 ? false : true,
            lineStyle: {
              color: "#dddddd",
              type: "solid"
            }
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            show: true,

            textStyle: {
              color: "#666666"
            },
            formatter: function formatter(params) {
              var res = (0, _VueHelper.floatDiv)(params, 10000);
              res.toFixed(2);
              return Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].data).concat((0, _toConsumableArray3.default)(series[1].data))) == 0 ? params : params == 0 ? 0 : (0, _VueHelper.subStringNum)(res, 2);
            }
          },
          axisTick: {
            show: false
          },

          nameTextStyle: {
            padding: [0, 0, 0, -20],
            color: "#666666"
          }
        }],
        series: [{
          name: series[0].name,
          type: "line",
          smooth: true,
          symbolSize: 2,
          showSymbol: false,
          itemStyle: {
            normal: {
              opacity: Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].data).concat((0, _toConsumableArray3.default)(series[1].data))) == 0 ? 0 : 1,
              color: "#5ebbff",
              lineStyle: {
                color: "#5ebbff",
                width: 2,
                opacity: Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].data).concat((0, _toConsumableArray3.default)(series[1].data))) == 0 ? 0 : 1
              }
            }
          },
          areaStyle: {
            normal: {
              color: "#e6f5ff"
            }
          },
          data: series[0].data
        }, {
          name: series[1].name,
          type: "line",
          smooth: true,
          stack: "总量",
          symbolSize: 2,
          showSymbol: false,
          itemStyle: {
            normal: {
              opacity: Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].data).concat((0, _toConsumableArray3.default)(series[1].data))) == 0 ? 0 : 1,
              color: "#61D9AC",
              lineStyle: {
                color: "#61D9AC",
                width: 2,
                opacity: Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].data).concat((0, _toConsumableArray3.default)(series[1].data))) == 0 ? 0 : 1
              }
            }
          },
          areaStyle: {
            normal: {
              color: "#61D9AC",
              opacity: 0.15
            }
          },
          data: series[1].data
        }]
      };
      this.myChart.setOption(option);
      window.addEventListener("resize", function () {
        _this3.isH5 ? _this3.myChart.resize({ width: _this3.screenWidth - 24 }) : _this3.myChart.resize();
      });
      this.isH5 ? this.myChart.resize({ width: this.screenWidth - 24 }) : this.myChart.resize();
    },
    getInvoiceData: function getInvoiceData() {
      var _this4 = this;

      var url = Urls.invoiceTicktReceivableReportItemData;
      var params = {
        startTime: this.dataRange.length ? this.dataRange[0] : "",
        endTime: this.dataRange.length ? this.dataRange[1] : ""
      };
      this.$root.doPost(url, params, function (server_data) {
        if (!_this4.$root.isUserLogin(server_data)) {
          return;
        }

        if (server_data.error) {
          _this4.$root.showGlobalError(server_data.error);
          return;
        }
        _this4.invoiceList = server_data.data;
        _this4.invoiceTotal = server_data.data.amountAndCount;
        _this4.initChart();
      });
    },
    initChart2: function initChart2() {
      var _this5 = this;

      this.myChart2 = this.$echarts.init(this.$refs.payableTotal, { width: 'auto' });
      var _payableList = this.payableList,
          legend = _payableList.legend,
          series = _payableList.series,
          xAxis = _payableList.xAxis;

      var maxAmount = Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].data).concat((0, _toConsumableArray3.default)(series[1].data)));
      var option = {
        textStyle: {
          fontFamily: 'PingFang-M'
        },
        title: {
          text: "代付金额&回票金额走势",
          top: "24",
          left: this.isH5 ? "15" : "30",
          textStyle: {
            fontWeight: 500
          }
        },
        grid: {
          left: (0, _VueHelper.floatWidth)(maxAmount, 9) + 25,
          right: this.isH5 ? "20" : '40',
          top: "100",
          bottom: this.isH5 ? 30 : 50
        },
        tooltip: {
          show: true,
          trigger: "axis",
          formatter: function formatter(params) {
            var h = '<div style="padding: 5px 10px; font-size: 12px">';
            params.forEach(function (item) {
              if (item.seriesIndex == 0) {
                h += '<div >' + (0, _VueHelper.EchartsformatDate)(item.axisValue) + '</div>\n                        <div><div>' + item.marker + item.seriesName + '\uFF1A' + (0, _VueHelper.amountFormat)(item.value) + '\u5143</div>\n                      ';
              } else {
                if (params.length == 1) {
                  h += '<div >' + (0, _VueHelper.EchartsformatDate)(item.axisValue) + '</div>';
                }
                h += '<div>' + item.marker + item.seriesName + '\uFF1A' + (0, _VueHelper.amountFormat)(item.value) + '\u5143</div></div>';
              }
            });

            return h;
          },
          axisPointer: {
            lineStyle: {
              color: '#DDDDDD',
              type: 'solid'
            }
          }
        },
        legend: {
          show: true,
          x: this.isH5 ? 250 : 300,
          y: this.isH5 ? 13 : 25,
          icon: "circle",
          itemGap: this.isH5 ? 10 : 25,
          itemWidth: 8,
          itemHeight: 8,
          textStyle: {
            color: "#646464",
            height: 10,
            rich: {
              a: {
                verticalAlign: "middle"
              }
            }
          },
          data: legend
        },
        xAxis: [{
          type: "category",
          boundaryGap: 0,
          axisLine: {
            show: Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].data).concat((0, _toConsumableArray3.default)(series[1].data))) == 0 ? true : false,
            lineStyle: {
              color: '#dddddd'
            }
          },
          axisLabel: {
            color: "#666666",
            interval: this.screenWidth <= 1366 || (0, _VueHelper.checkDay)(this.dataRange) < 30 ? 'auto' : Math.ceil(xAxis.data.length / 10),
            show: this.isH5 ? false : true,
            margin: 15
          },
          splitLine: {
            show: Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].data).concat((0, _toConsumableArray3.default)(series[1].data))) == 0 ? false : true,
            lineStyle: {
              color: "#dddddd",
              type: "solid"
            }
          },
          axisTick: {
            show: false
          },
          data: xAxis.data
        }],
        yAxis: [{
          type: "value",
          name: "金额(万)",
          min: 0,
          max: maxAmount,
          splitNumber: 5,
          interval: maxAmount < 0.05 * 10000 ? maxAmount : maxAmount / 5,
          show: Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].data).concat((0, _toConsumableArray3.default)(series[1].data))) == 0 ? false : true,
          splitLine: {
            show: Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].data).concat((0, _toConsumableArray3.default)(series[1].data))) == 0 ? false : true,
            lineStyle: {
              color: "#dddddd",
              type: "solid"
            }
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            show: true,

            textStyle: {
              color: "#666666"
            },
            formatter: function formatter(params) {
              var res = (0, _VueHelper.floatDiv)(params, 10000);
              res.toFixed(2);
              return Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].data).concat((0, _toConsumableArray3.default)(series[1].data))) == 0 ? params : params == 0 ? 0 : (0, _VueHelper.subStringNum)(res, 2);
            }
          },
          axisTick: {
            show: false
          },

          nameTextStyle: {
            padding: [0, 0, 0, -20],
            color: "#666666"
          }
        }],
        series: [{
          name: series[0].name,
          type: "line",
          smooth: true,
          symbolSize: 2,
          showSymbol: false,
          itemStyle: {
            normal: {
              opacity: Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].data).concat((0, _toConsumableArray3.default)(series[1].data))) == 0 ? 0 : 1,
              color: "#5ebbff",
              lineStyle: {
                color: "#5ebbff",
                width: 2,
                opacity: Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].data).concat((0, _toConsumableArray3.default)(series[1].data))) == 0 ? 0 : 1
              }
            }
          },

          data: series[0].data
        }, {
          name: series[1].name,
          type: "line",
          smooth: true,
          stack: "总量",
          symbolSize: 2,
          showSymbol: false,
          itemStyle: {
            normal: {
              opacity: Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].data).concat((0, _toConsumableArray3.default)(series[1].data))) == 0 ? 0 : 1,
              color: "#72d8c0",
              lineStyle: {
                color: "#72d8c0",
                width: 2,
                opacity: Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].data).concat((0, _toConsumableArray3.default)(series[1].data))) == 0 ? 0 : 1
              }
            }
          },

          data: series[1].data
        }]
      };
      this.myChart2.setOption(option);
      window.addEventListener("resize", function () {
        _this5.isH5 ? _this5.myChart2.resize({ width: _this5.screenWidth - 24 }) : _this5.myChart2.resize();
      });
      this.isH5 ? this.myChart2.resize({ width: this.screenWidth - 24 }) : this.myChart2.resize();
    },
    getPayableData: function getPayableData() {
      var _this6 = this;

      var url = Urls.payableReceivableReportItemData;
      var params = {
        startTime: this.dataRange.length ? this.dataRange[0] : "",
        endTime: this.dataRange.length ? this.dataRange[1] : ""
      };
      this.$root.doPost(url, params, function (server_data) {
        if (!_this6.$root.isUserLogin(server_data)) {
          return;
        }

        if (server_data.error) {
          _this6.$root.showGlobalError(server_data.error);
          return;
        }
        _this6.payableList = server_data.data;
        _this6.payableTotal = server_data.data.amountAndCount;
        _this6.initChart2();
      });
    }
  }
};

/***/ }),

/***/ 852:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(93);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _toConsumableArray2 = __webpack_require__(31);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _Urls = __webpack_require__(12);

var Urls = _interopRequireWildcard(_Urls);

var _HeadControl = __webpack_require__(43);

var _HeadControl2 = _interopRequireDefault(_HeadControl);

var _VueHelper = __webpack_require__(17);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    HeadControl: _HeadControl2.default
  },
  data: function data() {
    return {
      screenWidth: document.body.clientWidth,
      isH5: false,
      dataRange: [],
      summaryList: {},
      currentTrendList: {},
      summaryTypeList: {},
      proportionList: {},
      paymentTypeList: {}
    };
  },
  mounted: function mounted() {
    var _this = this;

    if (this.$route.query.identification) {
      this.isH5 = true;
    }
    window.onresize = function () {
      return function () {
        window.screenWidth = document.body.clientWidth;
        _this.screenWidth = window.screenWidth;
      }();
    };
  },

  methods: {
    init: function init() {
      this.$refs.HeadControl.getDatas('month');
    },
    changePicker: function changePicker(data) {
      this.dataRange = data;
      this.getSummaryData();
      this.getTrendData();
      this.getSummaryType();
      this.getProportionData();
      this.getPaymentType();
    },
    changDate: function changDate(data) {
      this.dataRange = data;
      this.getSummaryData();
      this.getTrendData();
      this.getSummaryType();
      this.getProportionData();
      this.getPaymentType();
    },
    aFormat: function aFormat(amount) {
      return (0, _VueHelper.amountFormat)(amount);
    },
    getSummaryData: function getSummaryData() {
      var _this2 = this;

      var url = Urls.getEchartsSummaryFinanceIncomeReportItemData;
      var params = {
        startTime: this.dataRange.length ? this.dataRange[0] : "",
        endTime: this.dataRange.length ? this.dataRange[1] : ""
      };
      this.$root.doPost(url, params, function (server_data) {
        if (!_this2.$root.isUserLogin(server_data)) {
          return;
        }

        if (server_data.error) {
          _this2.$root.showGlobalError(server_data.error);
          return;
        }
        _this2.summaryList = server_data.data.series;
      });
    },
    initCurrentTrendChart: function initCurrentTrendChart() {
      var _this3 = this;

      this.currentTrendChart = this.$echarts.init(this.$refs.currentTrend, { width: 'auto' });
      var _currentTrendList = this.currentTrendList,
          legend = _currentTrendList.legend,
          series = _currentTrendList.series,
          xAxis = _currentTrendList.xAxis;

      var maxAmount = Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].data).concat((0, _toConsumableArray3.default)(series[1].data)));
      var option = {
        textStyle: {
          fontFamily: 'PingFang-M'
        },
        title: {
          text: "流水走势",
          top: "24",
          left: this.isH5 ? "15" : "30",
          textStyle: {
            fontWeight: 500
          }
        },
        grid: {
          left: (0, _VueHelper.floatWidth)(maxAmount, 9) + 25,
          right: this.isH5 ? '15' : "40",
          top: "100",
          bottom: "50"
        },
        tooltip: {
          show: true,
          trigger: "axis",
          formatter: function formatter(params) {
            var h = '<div style="padding: 5px 10px; font-size: 12px">';
            params.forEach(function (item) {
              if (item.seriesIndex == 0) {
                h += '<div >' + (0, _VueHelper.EchartsformatDate)(item.axisValue) + '</div>\n                        <div><div>' + item.marker + item.seriesName + '\uFF1A' + (0, _VueHelper.amountFormat)(item.value) + '\u5143</div>\n                      ';
              } else {
                if (params.length == 1) {
                  h += '<div >' + (0, _VueHelper.EchartsformatDate)(item.axisValue) + '</div>';
                }
                h += '<div>' + item.marker + item.seriesName + '\uFF1A' + (0, _VueHelper.amountFormat)(item.value) + '\u5143</div></div>';
              }
            });

            return h;
          },
          axisPointer: {
            lineStyle: {
              color: '#DDDDDD',
              type: 'solid'
            }
          }
        },
        legend: {
          show: true,
          x: this.isH5 ? 150 : 200,
          y: "26",
          icon: "circle",
          itemGap: 25,
          itemWidth: 8,
          itemHeight: 8,
          textStyle: {
            color: "#646464",
            height: 10,
            rich: {
              a: {
                verticalAlign: "middle"
              }
            }
          },
          data: legend
        },
        xAxis: [{
          type: "category",
          boundaryGap: 0,
          axisLine: {
            show: Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].data).concat((0, _toConsumableArray3.default)(series[1].data))) == 0 ? true : false,
            lineStyle: {
              color: '#dddddd'
            }
          },
          axisLabel: {
            show: this.isH5 ? false : true,
            color: "#666666",
            interval: this.screenWidth <= 1366 || (0, _VueHelper.checkDay)(this.dataRange) < 30 ? 'auto' : Math.ceil(xAxis.data.length / 10),

            margin: 15
          },
          splitLine: {
            show: Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].data).concat((0, _toConsumableArray3.default)(series[1].data))) == 0 ? false : true,
            lineStyle: {
              color: '#dddddd'
            }
          },
          axisTick: {
            show: false
          },
          data: xAxis.data
        }],
        yAxis: [{
          type: "value",
          name: "金额(万)",
          min: 0,
          max: maxAmount,
          splitNumber: 5,
          interval: maxAmount < 0.05 * 10000 ? maxAmount : maxAmount / 5,
          show: Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].data).concat((0, _toConsumableArray3.default)(series[1].data))) == 0 ? false : true,
          splitLine: {
            show: Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].data).concat((0, _toConsumableArray3.default)(series[1].data))) == 0 ? false : true,
            lineStyle: {
              color: "#dddddd",
              type: "solid"
            }
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            show: true,

            color: "#666666",
            formatter: function formatter(params) {
              var res = (0, _VueHelper.floatDiv)(params, 10000);
              res.toFixed(2);
              return Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].data).concat((0, _toConsumableArray3.default)(series[1].data))) == 0 ? params : params == 0 ? 0 : (0, _VueHelper.subStringNum)(res, 2);
            }
          },
          axisTick: {
            show: false
          },

          nameTextStyle: {
            padding: [0, 0, 0, -20],
            color: "#666666"
          }
        }],
        series: [{
          name: series[0].name,
          type: "line",
          smooth: true,
          symbolSize: 2,
          showSymbol: false,
          itemStyle: {
            normal: {
              opacity: Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].data).concat((0, _toConsumableArray3.default)(series[1].data))) == 0 ? 0 : 1,
              color: "#5ebbff",
              lineStyle: {
                color: "#5ebbff",
                width: 2,
                opacity: Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].data).concat((0, _toConsumableArray3.default)(series[1].data))) == 0 ? 0 : 1
              }
            }
          },
          areaStyle: {
            normal: {
              color: "#e6f5ff"
            }
          },
          data: series[0].data
        }, {
          name: series[1].name,
          type: "line",
          smooth: true,
          stack: "总量",
          symbolSize: 2,
          showSymbol: false,
          itemStyle: {
            normal: {
              opacity: Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].data).concat((0, _toConsumableArray3.default)(series[1].data))) == 0 ? 0 : 1,
              color: "#72d8c0",
              lineStyle: {
                color: "#72d8c0",
                width: 2,
                opacity: Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].data).concat((0, _toConsumableArray3.default)(series[1].data))) == 0 ? 0 : 1
              }
            }
          },
          areaStyle: {
            normal: {
              color: "#cdedf2"
            }
          },
          data: series[1].data
        }]
      };
      this.currentTrendChart.setOption(option);
      window.addEventListener("resize", function () {
        _this3.isH5 ? _this3.currentTrendChart.resize({ width: _this3.screenWidth - 24 }) : _this3.currentTrendChart.resize();
      });
      this.isH5 ? this.currentTrendChart.resize({ width: this.screenWidth - 24 }) : this.currentTrendChart.resize();
    },
    getTrendData: function getTrendData() {
      var _this4 = this;

      var url = Urls.getEchartsTrendFinanceIncomeData;
      var params = {
        startTime: this.dataRange.length ? this.dataRange[0] : "",
        endTime: this.dataRange.length ? this.dataRange[1] : ""
      };
      this.$root.doPost(url, params, function (server_data) {
        if (!_this4.$root.isUserLogin(server_data)) {
          return;
        }

        if (server_data.error) {
          _this4.$root.showGlobalError(server_data.error);
          return;
        }
        _this4.currentTrendList = server_data.data;
        _this4.initCurrentTrendChart();
      });
    },
    getSummaryType: function getSummaryType() {
      var _this5 = this;

      var url = Urls.getEchartsSummaryFinanceIncomeTypeReportItemData;
      var params = {
        startTime: this.dataRange.length ? this.dataRange[0] : "",
        endTime: this.dataRange.length ? this.dataRange[1] : ""
      };
      this.$root.doPost(url, params, function (server_data) {
        if (!_this5.$root.isUserLogin(server_data)) {
          return;
        }

        if (server_data.error) {
          _this5.$root.showGlobalError(server_data.error);
          return;
        }
        _this5.summaryTypeList = server_data.data.series;
      });
    },
    initProportionChart: function initProportionChart() {
      var _this6 = this;

      this.proportionChart = this.$echarts.init(this.$refs.proportion, { width: 'auto' });
      var _proportionList = this.proportionList,
          series = _proportionList.series,
          yAxis = _proportionList.yAxis;

      var option = {
        textStyle: {
          fontFamily: 'PingFang-M'
        },
        title: {
          text: '已认领收款占比',
          top: "24",
          left: this.isH5 ? "15" : "30",
          textStyle: {
            fontWeight: 500
          }
        },
        grid: {
          left: this.isH5 ? '15' : "40",
          right: this.isH5 ? '15' : "40",
          bottom: 10,
          top: 60
        },
        tooltip: {
          trigger: 'item',
          formatter: function formatter(params) {
            console.log(params);
            return '<div style="font-size:14px; padding:4px;">\n                         <div>' + params.name + '\uFF1A ' + series[0].data[params.dataIndex] + '\u7B14</div>\n                         <div>\u91D1\u989D\uFF1A' + (0, _VueHelper.amountFormat)(series[0].amountData[params.dataIndex]) + '\u5143</div>\n                         <div>\u5360\u6BD4\uFF1A' + series[0].percent[params.dataIndex] + '%</div>\n                     </div>';
          }
        },
        xAxis: {
          show: false,
          type: 'value'
        },
        yAxis: [{
          type: 'category',
          inverse: true,
          axisLabel: {
            formatter: function formatter(val, index) {
              return val + (' \uFF08' + series[0].data[index] + '\u7B14\uFF09');
            },
            textStyle: {
              color: '#666666',
              fontSize: '14',
              lineHeight: 20
            },
            padding: [0, 0, 35, 10],
            align: 'left',
            rich: {}
          },
          splitLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          data: yAxis.data
        }, {
          type: 'category',
          inverse: true,
          axisTick: 'none',
          axisLine: 'none',
          position: 'left',
          show: true,
          axisLabel: {
            textStyle: {
              color: '#57b9ff',
              fontSize: 14
            },
            padding: [-20, 0, -60, 10],
            formatter: function formatter(val, index) {
              return '{color|' + (0, _VueHelper.amountFormat)(series[0].amountData[index]) + '\u5143} \xA0\uFF08' + val + '%\uFF09';
            },
            align: 'left',
            rich: {
              color: {
                color: '#333',
                fontSize: 14
              }
            }
          },
          data: series[0].percent
        }],
        series: [{
          type: 'bar',
          zlevel: 1,

          itemStyle: {
            normal: {
              barBorderRadius: 10,
              color: '#57b9ff'
            }
          },
          barWidth: 10,
          data: series[0].percent
        }, {
          name: '背景',
          type: 'bar',
          silent: true,
          barWidth: 10,
          barGap: '-100%',
          data: [100, 100, 100],
          itemStyle: {
            normal: {
              color: '#dddddd',
              barBorderRadius: 10
            }
          }
        }]
      };
      this.proportionChart.setOption(option);
      window.addEventListener("resize", function () {
        _this6.isH5 ? _this6.proportionChart.resize({ width: _this6.screenWidth - 24 }) : _this6.proportionChart.resize();
      });
      this.isH5 ? this.proportionChart.resize({ width: this.screenWidth - 24 }) : this.proportionChart.resize();
    },
    getProportionData: function getProportionData() {
      var _this7 = this;

      var url = Urls.getEchartsClaimedFinanceIncomeTypeReportItemData;
      var params = {
        startTime: this.dataRange.length ? this.dataRange[0] : "",
        endTime: this.dataRange.length ? this.dataRange[1] : ""
      };
      this.$root.doPost(url, params, function (server_data) {
        if (!_this7.$root.isUserLogin(server_data)) {
          return;
        }

        if (server_data.error) {
          _this7.$root.showGlobalError(server_data.error);
          return;
        }
        _this7.proportionList = server_data.data;
        _this7.initProportionChart();
      });
    },
    initPaymentTypeChart: function initPaymentTypeChart() {
      var _this8 = this,
          _ref;

      var widthPx = this.screenWidth;
      this.paymentTypeChart = this.$echarts.init(this.$refs.paymenttype, { width: 'auto' });
      var _paymentTypeList = this.paymentTypeList,
          amount = _paymentTypeList.amount,
          legend = _paymentTypeList.legend,
          max = _paymentTypeList.max,
          series = _paymentTypeList.series,
          xAxis = _paymentTypeList.xAxis;

      var maxPercent = Math.ceil(Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].data)) / 10) * 10;
      var maxAmount = Math.ceil(Math.max.apply(Math, (0, _toConsumableArray3.default)(series[1].data)));
      var option = {
        textStyle: {
          fontFamily: 'PingFang-M'
        },
        title: {
          text: '付款类型',
          top: "24",
          left: this.isH5 ? "15" : "30",

          textStyle: {
            fontWeight: 500
          }
        },
        grid: {
          left: this.isH5 ? '15' : '40',
          right: this.isH5 ? '15' : '40',
          bottom: '20px',
          top: '100px',
          containLabel: true
        },
        opacity: 0.1,
        tooltip: {
          trigger: 'axis',
          formatter: function formatter(params) {
            var h = '<div style="padding: 0 10px; font-size: 12px">';
            params.reverse().forEach(function (item) {
              if (item.seriesIndex == 1) {
                h += '\n                    <div>' + item.name + '</div>\n                    <div>\u91D1\u989D\uFF1A' + (0, _VueHelper.amountFormat)(item.data) + '\u5143</div>\n                  ';
              } else {
                h += '<div>\u5360\u6BD4\uFF1A' + item.data + '%</div></div>';
              }
            });

            return h;
          }
        },
        legend: {
          data: legend,
          itemWidth: 30,
          itemHeight: 8,
          itemGap: 20,
          x: this.isH5 ? 150 : 200,
          y: "26",
          textStyle: {
            fontSize: '12',
            color: '#666666',
            height: 10,
            rich: {
              a: {
                verticalAlign: 'middle'
              }
            }
          }
        },
        xAxis: [(_ref = {
          type: 'category',
          offset: 5,
          data: xAxis.data,
          axisPointer: {
            type: 'shadow'
          },

          splitLine: {
            show: Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].data)) == 0 ? false : true,
            lineStyle: {
              color: '#dddddd'
            }
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#dddddd'
            }
          }
        }, (0, _defineProperty3.default)(_ref, 'axisPointer', {
          type: 'none'
        }), (0, _defineProperty3.default)(_ref, 'axisLabel', {
          color: '#666666',

          formatter: function formatter(params) {
            if (widthPx <= 1366 || widthPx == 1536) {
              var newParamsName = "";
              var paramsNameNumber = params.length;
              var provideNumber = _this8.isH5 ? 2 : 3;
              var rowNumber = Math.ceil(paramsNameNumber / provideNumber);
              if (paramsNameNumber > provideNumber) {
                for (var p = 0; p < rowNumber; p++) {
                  var tempStr = "";
                  var start = p * provideNumber;
                  var end = start + provideNumber;
                  if (p == rowNumber - 1) {
                    tempStr = params.substring(start, paramsNameNumber);
                  } else {
                    tempStr = params.substring(start, end) + "\n";
                  }
                  newParamsName += tempStr;
                }
              } else {
                newParamsName = params;
              }
              return newParamsName;
            } else {
              return params;
            }
          }
        }), _ref)],
        yAxis: [{
          offset: 5,
          type: 'value',
          name: '百分比',
          min: 0,
          max: maxPercent,
          splitNumber: 5,
          interval: maxPercent / 5,
          axisLabel: {
            color: '#666666',
            formatter: '{value}%'
          },

          splitLine: {
            show: true,
            lineStyle: {
              color: '#dddddd'
            }
          },

          nameTextStyle: {
            color: '#666666',
            padding: [0, 0, 0, -30]
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: false },
          show: Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].data)) == 0 ? false : true
        }, {
          type: 'value',
          name: '金额（万）',
          min: 0,
          max: maxAmount,
          splitNumber: 5,
          interval: maxAmount / 5,
          axisLabel: {
            color: '#666666',
            formatter: function formatter(params) {
              var res = (0, _VueHelper.floatDiv)(params, 10000);
              res.toFixed(2);
              return Math.max.apply(Math, (0, _toConsumableArray3.default)(series[1].data)) == 0 ? params : params == 0 ? 0 : (0, _VueHelper.subStringNum)(res, 2);
            }
          },

          nameTextStyle: {
            color: '#666666',
            padding: [0, -20, 0, 0]
          },
          axisTick: false,
          axisLine: {
            show: false },
          splitLine: {
            show: false
          },
          show: Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].data)) == 0 ? false : true
        }],
        series: [{
          name: series[0].name,
          type: 'bar',

          barWidth: '60%',
          data: series[0].data,
          itemStyle: {
            normal: {
              color: 'rgba(87, 185, 255, 0.35)',
              borderColor: Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].data)) == 0 ? 'rgba(87, 185, 255, 0)' : 'rgba(87, 185, 255, 1)'
            }
          }
        }, {
          name: series[1].name,
          hoverAnimation: false,
          type: 'line',
          yAxisIndex: "1",
          symbol: 'rect',
          symbolSize: 9,
          data: series[1].data,
          itemStyle: {
            emphasis: {
              borderWidth: 3,
              borderColor: '#61d9ac',
              color: '#61d9ac'
            },
            normal: {
              color: '#61D9AC',
              opacity: Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].data)) == 0 ? 0 : 1,
              lineStyle: {
                opacity: Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].data)) == 0 ? 0 : 1
              }
            }
          }
        }]
      };
      this.paymentTypeChart.setOption(option);
      window.addEventListener("resize", function () {
        _this8.isH5 ? _this8.paymentTypeChart.resize({ width: _this8.screenWidth - 24 }) : _this8.paymentTypeChart.resize();
      });
      this.isH5 ? this.paymentTypeChart.resize({ width: this.screenWidth - 24 }) : this.paymentTypeChart.resize();
    },
    getPaymentType: function getPaymentType() {
      var _this9 = this;

      var url = Urls.getEchartsFoldOrPostFinanceIncomeData;
      var params = {
        startTime: this.dataRange.length ? this.dataRange[0] : "",
        endTime: this.dataRange.length ? this.dataRange[1] : ""
      };
      this.$root.doPost(url, params, function (server_data) {
        if (!_this9.$root.isUserLogin(server_data)) {
          return;
        }

        if (server_data.error) {
          _this9.$root.showGlobalError(server_data.error);
          return;
        }
        _this9.paymentTypeList = server_data.data;
        _this9.initPaymentTypeChart();
      });
    }
  }
};

/***/ }),

/***/ 853:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _OperationaDataReportOne = __webpack_require__(758);

var _OperationaDataReportOne2 = _interopRequireDefault(_OperationaDataReportOne);

var _bidsData = __webpack_require__(705);

var _bidsData2 = _interopRequireDefault(_bidsData);

var _signedData = __webpack_require__(706);

var _signedData2 = _interopRequireDefault(_signedData);

var _OperationaDataReportThree = __webpack_require__(759);

var _OperationaDataReportThree2 = _interopRequireDefault(_OperationaDataReportThree);

var _collectData = __webpack_require__(696);

var _collectData2 = _interopRequireDefault(_collectData);

var _EliteDirectorDataReportOne = __webpack_require__(757);

var _EliteDirectorDataReportOne2 = _interopRequireDefault(_EliteDirectorDataReportOne);

var _EliteCertificateDataReportTwo = __webpack_require__(756);

var _EliteCertificateDataReportTwo2 = _interopRequireDefault(_EliteCertificateDataReportTwo);

var _CustomerOwnerDataReportOne = __webpack_require__(754);

var _CustomerOwnerDataReportOne2 = _interopRequireDefault(_CustomerOwnerDataReportOne);

var _CustomerOwnerDataReportTwo = __webpack_require__(755);

var _CustomerOwnerDataReportTwo2 = _interopRequireDefault(_CustomerOwnerDataReportTwo);

var _waterData = __webpack_require__(703);

var _waterData2 = _interopRequireDefault(_waterData);

var _receivableData = __webpack_require__(702);

var _receivableData2 = _interopRequireDefault(_receivableData);

var _dealWithData = __webpack_require__(701);

var _dealWithData2 = _interopRequireDefault(_dealWithData);

var _closeAccountsData = __webpack_require__(700);

var _closeAccountsData2 = _interopRequireDefault(_closeAccountsData);

var _sendOrdersData = __webpack_require__(698);

var _sendOrdersData2 = _interopRequireDefault(_sendOrdersData);

var _pollingData = __webpack_require__(697);

var _pollingData2 = _interopRequireDefault(_pollingData);

var _abnormalData = __webpack_require__(695);

var _abnormalData2 = _interopRequireDefault(_abnormalData);

var _designData = __webpack_require__(694);

var _designData2 = _interopRequireDefault(_designData);

var _sellingData = __webpack_require__(707);

var _sellingData2 = _interopRequireDefault(_sellingData);

var _Urls = __webpack_require__(12);

var Urls = _interopRequireWildcard(_Urls);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    CustomerOwnerDataReportTwo: _CustomerOwnerDataReportTwo2.default,
    CustomerOwnerDataReportOne: _CustomerOwnerDataReportOne2.default,
    HoldCertificateData: _EliteCertificateDataReportTwo2.default,
    OperationaDataReportOne: _OperationaDataReportOne2.default,
    BidsData: _bidsData2.default,

    SignedData: _signedData2.default,
    CollectData: _collectData2.default,
    OperationaDataReportThree: _OperationaDataReportThree2.default,
    EliteDirectorDataReportOne: _EliteDirectorDataReportOne2.default,
    waterData: _waterData2.default,
    receivableData: _receivableData2.default,
    dealWithData: _dealWithData2.default,
    closeAccountsData: _closeAccountsData2.default,
    sendOrdersData: _sendOrdersData2.default,
    pollingData: _pollingData2.default,
    abnormalData: _abnormalData2.default,
    designData: _designData2.default,
    sellingData: _sellingData2.default
  },
  data: function data() {
    return {
      isCollapse: true,
      identification: '',
      TreeList: [],
      phone: '',
      selsectData: '签约数据'
    };
  },
  created: function created() {
    this.phone = this.$route.query.phone;
    if (this.phone) {
      this.getPermissions();
    }
  },
  mounted: function mounted() {},

  methods: {
    initData: function initData(tyep) {
      var _this2 = this;

      switch (tyep) {
        case '立项数据':
          this.$nextTick(function () {
            _this2.$refs.OperationaDataReportOne.init();
          });
          break;
        case '招标数据':
          this.$nextTick(function () {
            _this2.$refs.BidsData.init();
          });
          break;

        case '签约数据':
          this.$nextTick(function () {
            _this2.$refs.SignedData.init();
          });
          break;
        case '丢单数据':
          this.$nextTick(function () {
            _this2.$refs.OperationaDataReportThree.init();
          });
          break;

        case '汇总数据':
          this.$nextTick(function () {
            _this2.$refs.CollectData.init();
          });
          break;

        case '总监数据':
          this.$nextTick(function () {
            _this2.$refs.EliteDirectorDataReportOne.init();
          });
          break;
        case '持证数据':
          this.$nextTick(function () {
            _this2.$refs.HoldCertificateData.init();
          });
          break;

        case '甲方数据':
          this.$nextTick(function () {
            _this2.$refs.CustomerOwnerDataReportOne.init();
          });
          break;
        case '入库备案数据':
          this.$nextTick(function () {
            _this2.$refs.CustomerOwnerDataReportTwo.init();
          });
          break;

        case '流水数据':
          this.$nextTick(function () {
            _this2.$refs.waterData.init();
          });
          break;
        case '应收数据':
          this.$nextTick(function () {
            _this2.$refs.receivableData.init();
          });
          break;
        case '应付数据':
          this.$nextTick(function () {
            _this2.$refs.dealWithData.init();
          });
          break;
        case '结算数据':
          this.$nextTick(function () {
            _this2.$refs.closeAccountsData.init();
          });
          break;
        case '派单数据':
          this.$nextTick(function () {
            _this2.$refs.sendOrdersData.init();
          });
          break;
        case '巡检数据':
          this.$nextTick(function () {
            _this2.$refs.pollingData.init();
          });
          break;
        case '异常数据':
          this.$nextTick(function () {
            _this2.$refs.abnormalData.init();
          });
          break;
        case '设计数据':
          this.$nextTick(function () {
            _this2.$refs.designData.init();
          });
          break;
        case '购销数据':
          this.$nextTick(function () {
            _this2.$refs.sellingData.init();
          });
          break;
      }
    },
    getPermissions: function getPermissions() {
      var _this = this;
      var url = Urls.getAuthorizeBackRole;
      var params = {
        phone: this.phone
      };
      this.$root.doPost(url, params, function (server_data) {
        if (server_data.error) {
          _this.$root.showGlobalError(server_data.error);
          return;
        }
        sessionStorage.setItem('token', server_data.data.token);
        _this.getMenuBar();
        _this.initData(_this.selsectData);
      });
    },
    selsectOpen: function selsectOpen(val) {
      this.selsectData = val;
      this.isCollapse = !this.isCollapse;
      this.initData(val);
    },
    Optionsidebar: function Optionsidebar() {
      this.isCollapse = !this.isCollapse;
    },
    getMenuBar: function getMenuBar() {
      var _this = this;
      var url = Urls.getXappReportMenuByRole;
      var params = '';
      this.$root.doPost(url, params, function (server_data) {
        if (server_data.error) {
          _this.$root.showGlobalError(server_data.error);
          return;
        }
        _this.TreeList = server_data.data[0].children;
      });
    },
    showOption: function showOption() {
      this.isCollapse = true;
    }
  },
  watch: {}
};

/***/ }),

/***/ 854:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toConsumableArray2 = __webpack_require__(31);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _Urls = __webpack_require__(12);

var Urls = _interopRequireWildcard(_Urls);

var _HeadControl = __webpack_require__(43);

var _HeadControl2 = _interopRequireDefault(_HeadControl);

var _VueHelper = __webpack_require__(17);

var _china = __webpack_require__(1723);

var _china2 = _interopRequireDefault(_china);

var _VueHelper2 = __webpack_require__(17);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        HeadControl: _HeadControl2.default
    },
    data: function data() {
        return {
            screenWidth: document.body.clientWidth,
            orgCode: '',
            dataRange: [],
            BidsDataList: '',
            aggregation: [],
            activeProjectName: 'BID',
            RankingDataList: '',
            ChanDataList: '',
            identification: ''
        };
    },
    mounted: function mounted() {
        var _this = this;
        window.onresize = function () {
            return function () {
                window.screenWidth = document.body.clientWidth;
                _this.screenWidth = window.screenWidth;
            }();
        };
        this.identification = this.$route.query.identification;
    },

    methods: {
        handleClick: function handleClick(type) {
            this.activeProjectName = type;
            this.getRanking();
        },
        getRanking: function getRanking() {
            var _this = this;
            var url = Urls.getEchartsBidsReportDataByProvince;
            var params = {
                orgCode: this.orgCode,
                startTime: this.dataRange.length ? this.dataRange[0] : '',
                endTime: this.dataRange.length ? this.dataRange[1] : '',
                itemCode: this.activeProjectName
            };
            this.$root.doPost(url, params, function (server_data) {
                if (!_this.$root.isUserLogin(server_data)) {
                    return;
                }

                if (server_data.error) {
                    _this.$root.showGlobalError(server_data.error);
                    return;
                }
                _this.RankingDataList = server_data.data;
            });
        },
        init: function init() {
            this.$refs.HeadControl.getDatas('month');
            this.$refs.HeadControl.getSysOrg();
        },
        changeVal: function changeVal(val) {
            this.orgCode = val;
            this.getDataAggregation();
            this.getBidsDataList();
            this.getRanking();
            this.getChnaDataList();
        },
        changDate: function changDate(val) {
            this.dataRange = val;
            this.getDataAggregation();
            this.getBidsDataList();
            this.getRanking();
            this.getChnaDataList();

            this.mapEcharts();
        },
        changePicker: function changePicker(val) {
            this.dataRange = val;
            this.getDataAggregation();
            this.getBidsDataList();
            this.getRanking();
            this.getChnaDataList();
        },
        getOrgCode: function getOrgCode() {
            this.$refs.HeadControl.getSysOrg();
        },
        getDataAggregation: function getDataAggregation() {
            var _this = this;
            var url = Urls.getEchartsBidsReportData;
            var params = {
                orgCode: this.orgCode,
                startTime: this.dataRange.length ? this.dataRange[0] : '',
                endTime: this.dataRange.length ? this.dataRange[1] : '',
                itemCode: ''
            };
            this.$root.doPost(url, params, function (server_data) {
                if (!_this.$root.isUserLogin(server_data)) {
                    return;
                }

                if (server_data.error) {
                    _this.$root.showGlobalError(server_data.error);
                    return;
                }
                _this.aggregation = server_data.data.reportList;
            });
        },
        getBidsDataList: function getBidsDataList() {
            var _this = this;
            var url = Urls.getEchartsBidsReportDataByTrend;
            var params = {
                orgCode: this.orgCode,
                startTime: this.dataRange.length ? this.dataRange[0] : '',
                endTime: this.dataRange.length ? this.dataRange[1] : '',
                itemCode: ''
            };
            this.$root.doPost(url, params, function (server_data) {
                if (!_this.$root.isUserLogin(server_data)) {
                    return;
                }

                if (server_data.error) {
                    _this.$root.showGlobalError(server_data.error);
                    return;
                }
                _this.BidsDataList = server_data.data;
            });
        },
        initChart: function initChart() {
            var _this2 = this;

            var series = this.BidsDataList.series;
            var Chart = this.$echarts.getInstanceByDom(this.$refs.bidsDataEcharts);
            if (Chart == null) {
                this.myChart = this.$echarts.init(this.$refs.bidsDataEcharts);
            }
            var option = {
                textStyle: {
                    fontFamily: 'PingFang-M'
                },
                title: {
                    text: '投标&中标数量走势',
                    top: '24',
                    left: this.$route.query.identification ? '20' : '30',
                    textStyle: {
                        fontWeight: 500
                    }
                },
                grid: {
                    left: this.$route.query.identification ? '52' : '65',
                    right: this.$route.query.identification ? '48' : '50',
                    top: this.$route.query.identification ? '100' : '100',
                    bottom: this.$route.query.identification ? '25' : '50'
                },
                tooltip: {
                    show: true,
                    trigger: "axis",
                    formatter: function formatter(params) {
                        var h = '<div>';
                        params.forEach(function (item) {
                            if (item.seriesIndex == 0) {
                                h += ' ' + (0, _VueHelper.EchartsformatDate)(item.axisValue) + '</div>\n                                        <div>' + item.marker + item.seriesName + '\uFF1A' + item.value + '\u4E2A \uFF08' + series[item.seriesIndex].number[item.dataIndex] + '\u4EBA\uFF09</div>';
                            } else {
                                if (params.length == 1) {
                                    h += '<div >' + (0, _VueHelper.EchartsformatDate)(item.axisValue) + '</div>';
                                }
                                h += '<div>' + item.marker + item.seriesName + '\uFF1A' + item.value + '\u4E2A \uFF08' + series[item.seriesIndex].number[item.dataIndex] + '\u4EBA\uFF09</div>';
                            }
                        });

                        return h;
                    },
                    axisPointer: {
                        lineStyle: {
                            color: '#DDDDDD',
                            type: 'solid'
                        }
                    }
                },
                legend: {
                    show: true,
                    x: this.$route.query.identification ? '240' : '290',
                    y: this.$route.query.identification ? '18' : '26',
                    icon: 'circle',
                    itemGap: this.$route.query.identification ? 10 : 25,
                    itemWidth: 8,
                    itemHeight: 7,
                    textStyle: {
                        color: '#666666',
                        height: 10,
                        rich: {
                            a: {
                                verticalAlign: 'middle'
                            }
                        }
                    },
                    data: this.BidsDataList.legend
                },
                xAxis: [{
                    type: 'category',
                    boundaryGap: 0,
                    axisLine: {
                        show: Math.max.apply(Math, (0, _toConsumableArray3.default)(this.BidsDataList.series[0].data).concat((0, _toConsumableArray3.default)(this.BidsDataList.series[1].data))) == 0 ? true : false,
                        lineStyle: {
                            color: '#DDDDDD'
                        }
                    },
                    axisLabel: {
                        show: this.$route.query.identification ? false : true,
                        color: '#666666',
                        interval: this.screenWidth <= 1366 || (0, _VueHelper.checkDay)(this.dataRange) < 30 ? "auto" : Math.ceil(this.BidsDataList.xAxis.data.length / 10),
                        padding: [8, 0, 0, 0],
                        fontSize: this.screenWidth <= 1366 ? 10 : 12
                    },
                    splitLine: {
                        show: Math.max.apply(Math, (0, _toConsumableArray3.default)(this.BidsDataList.series[0].data).concat((0, _toConsumableArray3.default)(this.BidsDataList.series[1].data))) == 0 ? false : true,
                        lineStyle: {
                            color: '#DDDDDD',
                            type: 'solid'
                        }
                    },
                    axisTick: {
                        show: false
                    },

                    data: this.BidsDataList.xAxis.data
                }],
                yAxis: [{
                    type: 'value',
                    name: '数量(个)',
                    minInterval: 1,
                    show: Math.max.apply(Math, (0, _toConsumableArray3.default)(this.BidsDataList.series[0].data).concat((0, _toConsumableArray3.default)(this.BidsDataList.series[1].data))) == 0 ? false : true,
                    splitLine: {
                        show: Math.max.apply(Math, (0, _toConsumableArray3.default)(this.BidsDataList.series[0].data).concat((0, _toConsumableArray3.default)(this.BidsDataList.series[1].data))) == 0 ? false : true,
                        lineStyle: {
                            color: '#DDDDDD',
                            type: 'solid'
                        }
                    },
                    axisLine: {
                        show: false
                    },
                    axisLabel: {
                        show: true,

                        textStyle: {
                            color: '#666666'

                        }
                    },
                    axisTick: {
                        show: false
                    },

                    nameTextStyle: {
                        padding: [0, 15, 0, 0],
                        color: '#666666'
                    }
                }],
                series: [{
                    name: this.BidsDataList.series[0].name,
                    type: 'line',
                    smooth: true,
                    symbolSize: 5,
                    showSymbol: false,
                    itemStyle: {
                        normal: {
                            opacity: Math.max.apply(Math, (0, _toConsumableArray3.default)(this.BidsDataList.series[0].data)) == 0 ? 0 : 1,
                            color: '#5ebbff',
                            lineStyle: {
                                color: "#5ebbff",
                                width: 2,
                                opacity: Math.max.apply(Math, (0, _toConsumableArray3.default)(this.BidsDataList.series[0].data)) == 0 ? 0 : 1
                            }
                        }
                    },
                    areaStyle: {
                        normal: {
                            offset: 0.03,
                            color: '#e6f5ff'
                        }
                    },
                    data: this.BidsDataList.series[0].data
                }, {
                    name: this.BidsDataList.series[1].name,
                    type: 'line',
                    smooth: true,
                    stack: '总量',
                    symbolSize: 5,
                    showSymbol: false,
                    itemStyle: {
                        normal: {
                            opacity: Math.max.apply(Math, (0, _toConsumableArray3.default)(this.BidsDataList.series[1].data)) == 0 ? 0 : 1,
                            color: '#72d8c0',
                            lineStyle: {
                                color: "#72d8c0",
                                width: 2,
                                opacity: Math.max.apply(Math, (0, _toConsumableArray3.default)(this.BidsDataList.series[1].data)) == 0 ? 0 : 1
                            }
                        }
                    },
                    areaStyle: {
                        normal: {
                            offset: 0.05,
                            color: '#cdedf2'
                        }
                    },
                    data: this.BidsDataList.series[1].data
                }]
            };
            this.myChart.setOption(option);
            window.addEventListener("resize", function () {
                if (_this2.$route.query.identification) {
                    var resize = {
                        width: _this2.screenWidth - 21
                    };
                    _this2.myChart.resize(resize);
                } else {
                    _this2.myChart.resize();
                }
            });
        },
        getChnaDataList: function getChnaDataList() {
            var _this = this;
            var url = Urls.getEchartsBidsReportDataByMapOfChina;
            var params = {
                orgCode: this.orgCode,
                startTime: this.dataRange.length ? this.dataRange[0] : '',
                endTime: this.dataRange.length ? this.dataRange[1] : '',
                itemCode: ''
            };
            this.$root.doPost(url, params, function (server_data) {
                if (!_this.$root.isUserLogin(server_data)) {
                    return;
                }

                if (server_data.error) {
                    _this.$root.showGlobalError(server_data.error);
                    return;
                }
                _this.ChanDataList = server_data.data;
            });
        },
        mapEcharts: function mapEcharts() {
            var _this3 = this;

            (0, _VueHelper2.loadScript)('https://cdn.jsdelivr.net/npm/echarts@5.3.1/dist/echarts.min.js').then(function () {
                var ChanDataList = _this3.ChanDataList;
                var myEcharts = echarts.init(_this3.$refs.ChinaMap);
                echarts.registerMap('chinaMaps', _china2.default);
                var option = {
                    textStyle: {
                        fontFamily: 'PingFang-M'
                    },
                    title: {
                        text: '全国投/中标数据',
                        top: '24',
                        left: _this3.$route.query.identification ? '20' : '30',
                        textStyle: {
                            fontWeight: 500
                        }
                    },
                    tooltip: {
                        show: true,
                        formatter: function formatter(params) {
                            var str = '\n                                    <div>' + params.data.name + '</div>\n                                    <div>\u6295\u6807\uFF1A' + params.data.bidMapData.count + '\u4E2A\uFF08' + params.data.bidMapData.totalCount + '\u4EBA\uFF09</div>\n                                    <div>\u4E2D\u6807\uFF1A' + params.data.biddingMapData.count + '\u4E2A\uFF08' + params.data.biddingMapData.totalCount + '\u4EBA\uFF09</div>\n                            ';
                            return str;
                        }
                    },
                    series: [{
                        type: 'map',
                        map: 'chinaMaps',
                        aspectScale: 0.75,
                        layoutCenter: ["50%", "50%"],
                        layoutSize: _this3.$route.query.identification ? '90%' : '120%',
                        roam: _this3.$route.query.identification ? false : false,
                        geoIndex: 0,
                        label: {
                            normal: {
                                show: _this3.$route.query.identification ? false : true,
                                textStyle: {
                                    color: '#333333'
                                }
                            }
                        },
                        itemStyle: {
                            normal: {
                                borderColor: '#a5b9ec',
                                borderWidth: 0.8,
                                areaColor: {
                                    type: 'linear-gradient',
                                    colorStops: [{
                                        offset: 0,
                                        color: '#f4f4f4' }],
                                    global: true }
                            },
                            emphasis: {
                                areaColor: '#8cd5e6',
                                borderColor: '#5cbbd1'
                            }
                        },
                        select: {
                            disabled: _this3.$route.query.identification ? false : true,
                            itemStyle: {
                                areaColor: "#8cd5e6"
                            }
                        },
                        zlevel: 1,
                        data: ChanDataList
                    }]
                };
                myEcharts.setOption(option);
            });
        }
    },
    watch: {
        BidsDataList: function BidsDataList() {
            this.$nextTick(function () {
                var myEvent = new Event('resize');
                window.dispatchEvent(myEvent);
            });
            this.initChart();
        },
        ChanDataList: function ChanDataList() {
            this.mapEcharts();
        }
    }
};

/***/ }),

/***/ 855:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(31);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _HeadControl = __webpack_require__(43);

var _HeadControl2 = _interopRequireDefault(_HeadControl);

var _signedDataEcharts = __webpack_require__(1638);

var _signedDataEcharts2 = _interopRequireDefault(_signedDataEcharts);

var _Urls = __webpack_require__(12);

var Urls = _interopRequireWildcard(_Urls);

var _VueHelper = __webpack_require__(17);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    HeadControl: _HeadControl2.default,
    signedDataEcharts: _signedDataEcharts2.default
  },
  data: function data() {
    return {
      screenWidth: document.body.clientWidth,
      orgCode: '',
      dataRange: [],
      ContractInformation: '',
      ContractAmountList: '',
      ContractNumberList: '',
      ProjectTypeList: '',
      PieprojectTypeList: '',
      CooperationTypeList: '',
      ProjectLevelList: '',
      RankingProjectAmountList: '',
      DirectorRankingList: '',
      ProjectAreaList: '',
      Maxmoney: ''
    };
  },
  mounted: function mounted() {
    var start = new Date();
    var end = new Date();
    start.setDate(1);
    start.setHours(0);
    start.setSeconds(0);
    start.setMinutes(0);
    start.setTime(start.getTime());
    this.dataRange = [this.$root.formatDay(start), this.$root.formatDay(end)];
    var _this = this;
    window.onresize = function () {
      return function () {
        window.screenWidth = document.body.clientWidth + 17;
        _this.screenWidth = window.screenWidth;
      }();
    };
  },

  methods: {
    init: function init() {
      this.$refs.HeadControl.getDatas('month');
      this.$refs.HeadControl.getSysOrg();
    },
    changeVal: function changeVal(val) {
      this.orgCode = val;
      this.getContractAmount();
      this.getContractNumber();
      this.getProjectType();
      this.getPieprojectType();
      this.getCooperationType();
      this.getProjectLevel();
      this.getRankingProjectAmount();
      this.getDirectorRanking('AMOUNT');
      this.getProjectArea();
    },
    changDate: function changDate(val) {
      this.dataRange = val;
      this.getContractAmount();
      this.getContractNumber();
      this.getProjectType();
      this.getPieprojectType();
      this.getCooperationType();
      this.getProjectLevel();
      this.getRankingProjectAmount();
      this.getDirectorRanking('AMOUNT');
      this.getProjectArea();
    },
    changePicker: function changePicker(val) {
      this.dataRange = val;
      this.getContractAmount();
      this.getContractNumber();
      this.getProjectType();
      this.getPieprojectType();
      this.getCooperationType();
      this.getProjectLevel();
      this.getRankingProjectAmount();
      this.getDirectorRanking('AMOUNT');
      this.getProjectArea();
    },
    getOrgCode: function getOrgCode() {
      this.$refs.HeadControl.getSysOrg();
    },
    AmountFormat: function AmountFormat(val) {
      return (0, _VueHelper.amountFormat)(val);
    },
    getContractAmount: function getContractAmount() {
      var _this = this;
      var url = Urls.getEchartsSignedReportDataByInfo;
      var params = {
        orgCode: this.orgCode,
        startTime: this.dataRange.length ? this.dataRange[0] : '',
        endTime: this.dataRange.length ? this.dataRange[1] : '',
        itemCode: 'CONTRACT_MONEY'
      };
      this.$root.doPost(url, params, function (server_data) {
        if (!_this.$root.isUserLogin(server_data)) {
          return;
        }

        if (server_data.error) {
          _this.$root.showGlobalError(server_data.error);
          return;
        }
        _this.ContractInformation = server_data.data.reportList;
        _this.ContractAmountList = server_data.data;
      });
    },
    initChart: function initChart() {
      var _this2 = this;

      var _ContractAmountList = this.ContractAmountList,
          legend = _ContractAmountList.legend,
          series = _ContractAmountList.series,
          xAxis = _ContractAmountList.xAxis;

      var MaxMoneyLength = (0, _VueHelper.subStringNum)((0, _VueHelper.floatDiv)(this.Maxmoney, 10000), 2);
      var width = MaxMoneyLength.toString().length;
      var WidthPx = width * 10 + 20;
      var Chart = this.$echarts.getInstanceByDom(this.$refs.ContractAmount);
      if (Chart == null) {
        this.myChart = this.$echarts.init(this.$refs.ContractAmount);
      }
      var option = {
        textStyle: {
          fontFamily: 'PingFang-M'
        },
        title: {
          text: '合同额&回款额走势',
          top: '24',
          left: this.$route.query.identification ? '20' : '30',
          textStyle: {
            fontWeight: 500
          }
        },
        grid: {
          left: this.$route.query.identification ? '52' : '70',
          right: this.$route.query.identification ? '48' : '30',
          top: this.$route.query.identification ? '100' : '100',
          bottom: this.$route.query.identification ? '25' : '50'
        },
        tooltip: {
          show: true,
          trigger: "axis",
          formatter: function formatter(params) {
            var h = '<div style="padding: 5px 10px; font-size: 12px">';
            params.forEach(function (item) {
              if (item.seriesIndex == 0) {
                h += '<div >' + (0, _VueHelper.EchartsformatDate)(item.axisValue) + '</div>\n                                  <div><div>' + item.marker + item.seriesName + '\uFF1A' + (0, _VueHelper.amountFormat)(item.value) + '\u5143</div>\n                                ';
              } else {
                if (params.length == 1) {
                  h += '<div >' + (0, _VueHelper.EchartsformatDate)(item.axisValue) + '</div>';
                }
                h += '<div>' + item.marker + item.seriesName + '\uFF1A' + (0, _VueHelper.amountFormat)(item.value) + '\u5143</div></div>';
              }
            });

            return h;
          },
          axisPointer: {
            lineStyle: {
              color: '#DDDDDD',
              type: 'solid'
            }
          }
        },
        legend: {
          show: true,
          x: this.$route.query.identification ? '240' : '260',
          y: this.$route.query.identification ? '18' : '26',
          icon: 'circle',
          itemGap: this.$route.query.identification ? 10 : 25,
          itemWidth: 8,
          itemHeight: 7,
          textStyle: {
            color: '#666666',
            height: 10,
            rich: {
              a: {
                verticalAlign: 'middle'
              }
            }
          },
          data: legend
        },
        xAxis: [{
          type: 'category',
          boundaryGap: 0,
          axisLine: {
            show: Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].data).concat((0, _toConsumableArray3.default)(series[1].data))) == 0 ? true : false,
            lineStyle: {
              color: '#DDDDDD'
            }
          },
          axisLabel: {
            show: this.$route.query.identification ? false : true,
            color: '#666666',
            interval: this.screenWidth <= 1366 || this.screenWidth == 1536 || (0, _VueHelper.checkDay)(this.dataRange) < 30 ? 'auto' : Math.ceil(xAxis.data.length / 10),
            padding: [8, 0, 0, 0]
          },
          splitLine: {
            show: Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].data).concat((0, _toConsumableArray3.default)(series[1].data))) == 0 ? false : true,
            lineStyle: {
              color: '#DDDDDD',
              type: 'solid'
            }
          },
          axisTick: {
            show: false
          },

          data: xAxis.data
        }],
        yAxis: [{
          type: 'value',
          name: '金额(万)',

          show: Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].data).concat((0, _toConsumableArray3.default)(series[1].data))) == 0 ? false : true,
          splitLine: {
            show: Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].data).concat((0, _toConsumableArray3.default)(series[1].data))) == 0 ? false : true,
            lineStyle: {
              color: '#DDDDDD',
              type: 'solid'
            }
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: '#666666'
            },
            formatter: function formatter(params) {
              var res = (0, _VueHelper.floatDiv)(params, 10000);
              res.toFixed(2);
              return Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].data).concat((0, _toConsumableArray3.default)(series[1].data))) == 0 ? params : params == 0 ? 0 : (0, _VueHelper.subStringNum)(res, 2);
            }
          },
          axisTick: {
            show: false
          },

          nameTextStyle: {
            align: 'left',

            color: '#666666'
          }
        }],
        series: [{
          name: series[0].name,
          type: 'line',
          smooth: true,
          symbolSize: 2,
          showSymbol: false,
          itemStyle: {
            normal: {
              opacity: Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].data)) == 0 ? 0 : 1,
              color: '#5ebbff',
              lineStyle: {
                color: "#5ebbff",
                width: 2,
                opacity: Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].data)) == 0 ? 0 : 1
              }
            }
          },
          areaStyle: {
            normal: {
              color: '#e6f5ff'
            }
          },
          data: series[0].data
        }, {
          name: series[1].name,
          type: 'line',
          smooth: true,
          stack: '总量',
          symbolSize: 2,
          showSymbol: false,
          itemStyle: {
            normal: {
              opacity: Math.max.apply(Math, (0, _toConsumableArray3.default)(series[1].data)) == 0 ? 0 : 1,
              color: '#72d8c0',
              lineStyle: {
                color: "#72d8c0",
                width: 2,
                opacity: Math.max.apply(Math, (0, _toConsumableArray3.default)(series[1].data)) == 0 ? 0 : 1
              }
            }
          },
          areaStyle: {
            normal: {
              color: '#cdedf2'
            }
          },
          data: series[1].data
        }]
      };
      this.myChart.setOption(option);
      window.addEventListener("resize", function () {
        if (_this2.$route.query.identification) {
          var resize = {
            width: _this2.screenWidth - 21
          };
          _this2.myChart.resize(resize);
        } else {
          _this2.myChart.resize();
        }
      });
    },
    getContractNumber: function getContractNumber() {
      var _this = this;
      var url = Urls.getEchartsSignedReportDataByInfo;
      var params = {
        orgCode: this.orgCode,
        startTime: this.dataRange.length ? this.dataRange[0] : '',
        endTime: this.dataRange.length ? this.dataRange[1] : '',
        itemCode: 'CONTRACT_NUMBER'
      };
      this.$root.doPost(url, params, function (server_data) {
        if (!_this.$root.isUserLogin(server_data)) {
          return;
        }

        if (server_data.error) {
          _this.$root.showGlobalError(server_data.error);
          return;
        }
        _this.ContractNumberList = server_data.data;
      });
    },
    initChart1: function initChart1() {
      var _this3 = this;

      var _ContractNumberList = this.ContractNumberList,
          legend = _ContractNumberList.legend,
          series = _ContractNumberList.series,
          xAxis = _ContractNumberList.xAxis;

      var Chart1 = this.$echarts.getInstanceByDom(this.$refs.ContractNumber);
      if (Chart1 == null) {
        this.myChart1 = this.$echarts.init(this.$refs.ContractNumber);
      }
      var option = {
        textStyle: {
          fontFamily: 'PingFang-M'
        },
        title: {
          text: '合同个数&签约人数走势',
          top: '24',
          left: this.$route.query.identification ? '20' : '30',
          textStyle: {
            fontWeight: 500
          }
        },
        grid: {
          left: this.$route.query.identification ? '52' : '60',
          right: this.$route.query.identification ? '48' : '30',
          top: this.$route.query.identification ? '100' : '100',
          bottom: this.$route.query.identification ? '25' : '50'
        },
        tooltip: {
          show: true,
          trigger: "axis",
          formatter: function formatter(params) {
            var h = '<div style="padding: 5px 10px; font-size: 12px">';
            params.forEach(function (item) {
              if (item.seriesIndex == 0) {
                h += '<div >' + (0, _VueHelper.EchartsformatDate)(item.axisValue) + '</div>\n                                <div><div>' + item.marker + item.seriesName + '\uFF1A' + item.value + '\u4E2A</div>\n                              ';
              } else {
                if (params.length == 1) {
                  h += '<div >' + (0, _VueHelper.EchartsformatDate)(item.axisValue) + '</div>';
                }
                h += '<div>' + item.marker + item.seriesName + '\uFF1A' + item.value + '\u4EBA</div></div>';
              }
            });
            return h;
          },
          axisPointer: {
            lineStyle: {
              color: '#DDDDDD',
              type: 'solid'
            }
          }
        },
        legend: {
          show: true,
          x: this.$route.query.identification ? '240' : '290',
          y: this.$route.query.identification ? '18' : '26',
          icon: 'circle',
          itemGap: this.$route.query.identification ? 10 : 25,
          itemWidth: 8,
          itemHeight: 7,
          textStyle: {
            color: '#666666',
            height: 10,
            rich: {
              a: {
                verticalAlign: 'middle'
              }
            }
          },
          data: legend
        },
        xAxis: [{
          type: 'category',
          boundaryGap: 0,
          axisLine: {
            show: Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].data).concat((0, _toConsumableArray3.default)(series[1].data))) == 0 ? true : false,
            lineStyle: {
              color: '#DDDDDD'
            }
          },
          axisLabel: {
            show: this.$route.query.identification ? false : true,
            color: '#666666',
            interval: this.screenWidth <= 1366 || this.screenWidth == 1536 || (0, _VueHelper.checkDay)(this.dataRange) < 30 ? "auto" : Math.ceil(xAxis.data.length / 10),
            padding: [8, 0, 0, 0]
          },
          splitLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          data: xAxis.data
        }],
        yAxis: [{
          type: 'value',
          name: '数量(个)',
          minInterval: 1,
          min: 0,

          show: Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].data).concat((0, _toConsumableArray3.default)(series[1].data))) == 0 ? false : true,
          splitLine: {
            show: Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].data).concat((0, _toConsumableArray3.default)(series[1].data))) == 0 ? false : true,
            lineStyle: {
              color: '#DDDDDD',
              type: 'solid'
            }
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            show: true,

            textStyle: {
              color: '#666666'

            }
          },
          axisTick: {
            show: false
          },

          nameTextStyle: {
            align: 'left',

            color: '#666666'
          }
        }],
        series: [{
          name: series[0].name,
          type: 'line',
          smooth: true,
          symbolSize: 2,
          showSymbol: false,
          itemStyle: {
            normal: {
              opacity: Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].data)) == 0 ? 0 : 1,
              color: '#5ebbff',
              lineStyle: {
                color: "#5ebbff",
                width: 2,
                opacity: Math.max.apply(Math, (0, _toConsumableArray3.default)(series[0].data)) == 0 ? 0 : 1
              }
            }
          },
          data: series[0].data
        }, {
          name: series[1].name,
          type: 'line',
          smooth: true,
          stack: '总量',
          symbolSize: 2,
          showSymbol: false,
          itemStyle: {
            normal: {
              opacity: Math.max.apply(Math, (0, _toConsumableArray3.default)(series[1].data)) == 0 ? 0 : 1,
              color: '#72d8c0',
              lineStyle: {
                color: "#72d8c0",
                width: 2,
                opacity: Math.max.apply(Math, (0, _toConsumableArray3.default)(series[1].data)) == 0 ? 0 : 1
              }
            }
          },
          data: series[1].data
        }]
      };
      this.myChart1.setOption(option);
      window.addEventListener("resize", function () {
        if (_this3.$route.query.identification) {
          var resize = {
            width: _this3.screenWidth - 21
          };
          _this3.myChart1.resize(resize);
        } else {
          _this3.myChart1.resize();
        }
      });
    },
    getProjectType: function getProjectType() {
      var _this = this;
      var url = Urls.getEchartsSignedReportDataByEngineeringType;
      var params = {
        orgCode: this.orgCode,
        startTime: this.dataRange.length ? this.dataRange[0] : '',
        endTime: this.dataRange.length ? this.dataRange[1] : '',
        itemCode: 'ENGINEERING_TYPE'
      };
      this.$root.doPost(url, params, function (server_data) {
        if (!_this.$root.isUserLogin(server_data)) {
          return;
        }

        if (server_data.error) {
          _this.$root.showGlobalError(server_data.error);
          return;
        }
        _this.ProjectTypeList = server_data.data;
      });
    },
    getPieprojectType: function getPieprojectType() {
      var _this = this;
      var url = Urls.getEchartsSignedReportDataByProjectType;
      var params = {
        orgCode: this.orgCode,
        startTime: this.dataRange.length ? this.dataRange[0] : '',
        endTime: this.dataRange.length ? this.dataRange[1] : '',
        itemCode: 'PROJECT_CATEGORY'
      };
      this.$root.doPost(url, params, function (server_data) {
        if (!_this.$root.isUserLogin(server_data)) {
          return;
        }

        if (server_data.error) {
          _this.$root.showGlobalError(server_data.error);
          return;
        }
        _this.PieprojectTypeList = server_data.data;
      });
    },
    getCooperationType: function getCooperationType() {
      var _this = this;
      var url = Urls.getEchartsSignedReportDataByCooperationType;
      var params = {
        orgCode: this.orgCode,
        startTime: this.dataRange.length ? this.dataRange[0] : '',
        endTime: this.dataRange.length ? this.dataRange[1] : '',
        itemCode: 'COOPERATION_TYPE'
      };
      this.$root.doPost(url, params, function (server_data) {
        if (!_this.$root.isUserLogin(server_data)) {
          return;
        }

        if (server_data.error) {
          _this.$root.showGlobalError(server_data.error);
          return;
        }
        _this.CooperationTypeList = server_data.data;
      });
    },
    getProjectLevel: function getProjectLevel() {
      var _this = this;
      var url = Urls.getEchartsSignedReportDataByGrade;
      var params = {
        orgCode: this.orgCode,
        startTime: this.dataRange.length ? this.dataRange[0] : '',
        endTime: this.dataRange.length ? this.dataRange[1] : '',
        itemCode: 'CONTRACT_LEVEL'
      };
      this.$root.doPost(url, params, function (server_data) {
        if (!_this.$root.isUserLogin(server_data)) {
          return;
        }

        if (server_data.error) {
          _this.$root.showGlobalError(server_data.error);
          return;
        }
        _this.ProjectLevelList = server_data.data;
      });
    },
    getRankingProjectAmount: function getRankingProjectAmount() {
      var _this = this;
      var url = Urls.getEchartsSignedReportDataByProjectMoney;
      var params = {
        orgCode: this.orgCode,
        startTime: this.dataRange.length ? this.dataRange[0] : '',
        endTime: this.dataRange.length ? this.dataRange[1] : '',
        itemCode: ''
      };
      this.$root.doPost(url, params, function (server_data) {
        if (!_this.$root.isUserLogin(server_data)) {
          return;
        }

        if (server_data.error) {
          _this.$root.showGlobalError(server_data.error);
          return;
        }
        _this.RankingProjectAmountList = server_data.data;
      });
    },
    getDirectorRanking: function getDirectorRanking(type) {
      console.log('type', type);
      var _this = this;
      var url = void 0;
      if (type === 'AMOUNT') {
        url = Urls.getEchartsSignedReportDataByDirectorMoney;
      } else {
        url = Urls.getEchartsSignedReportDataByProjectNumber;
      }
      var params = {
        orgCode: this.orgCode,
        startTime: this.dataRange.length ? this.dataRange[0] : '',
        endTime: this.dataRange.length ? this.dataRange[1] : '',
        itemCode: ''
      };
      this.$root.doPost(url, params, function (server_data) {
        if (!_this.$root.isUserLogin(server_data)) {
          return;
        }

        if (server_data.error) {
          _this.$root.showGlobalError(server_data.error);
          return;
        }
        _this.DirectorRankingList = server_data.data;
      });
    },
    getProjectArea: function getProjectArea() {
      var _this = this;
      var url = Urls.getEchartsSignedReportDataByRegion;
      var params = {
        orgCode: this.orgCode,
        startTime: this.dataRange.length ? this.dataRange[0] : '',
        endTime: this.dataRange.length ? this.dataRange[1] : '',
        itemCode: 'PROJECT_REGION'
      };
      this.$root.doPost(url, params, function (server_data) {
        if (!_this.$root.isUserLogin(server_data)) {
          return;
        }

        if (server_data.error) {
          _this.$root.showGlobalError(server_data.error);
          return;
        }
        _this.ProjectAreaList = server_data.data;
      });
    }
  },
  watch: {
    ContractAmountList: function ContractAmountList(val) {
      this.$nextTick(function () {
        var myEvent = new Event('resize');
        window.dispatchEvent(myEvent);
      });
      this.Maxmoney = Math.max.apply(Math, (0, _toConsumableArray3.default)(val.series[0].data).concat((0, _toConsumableArray3.default)(val.series[1].data)));
      this.initChart();
    },
    ContractNumberList: function ContractNumberList() {
      this.$nextTick(function () {
        var myEvent = new Event('resize');
        window.dispatchEvent(myEvent);
      });
      this.initChart1();
    }
  }
};

/***/ }),

/***/ 856:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(31);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _HeadControl = __webpack_require__(43);

var _HeadControl2 = _interopRequireDefault(_HeadControl);

var _Urls = __webpack_require__(12);

var Urls = _interopRequireWildcard(_Urls);

var _VueHelper = __webpack_require__(17);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    HeadControl: _HeadControl2.default
  },
  data: function data() {
    return {
      orgCode: "",
      dataRange: [],
      progressData: {},
      progressMaxNum: 0,
      progressMaxPercent: 0,
      designRegionData: [],
      abnormalData: [],
      percent1: 0,
      abnormalTotal: 0,
      abnormalTypeData: {},
      abnormalMaxNum: 0,
      abnormalMaxPercent: 0,
      screenWidth: document.body.clientWidth,
      isH5: false,
      reportList: [{
        "amount": 422520.0000,
        "count": 1,
        "itemIcon": "https://xmyun.zhoty.com/xmerp/pcadmin/static/images/yysj-qysj-qyhte.png",
        "itemName": "签约合同金额"
      }, {
        "amount": 422520.0000,
        "count": 1,
        "itemIcon": "https://xmyun.zhoty.com/xmerp/pcadmin/static/images/yysj-qysj-qyhtgs.png",
        "itemName": "签约数量"
      }]
    };
  },

  methods: {
    init: function init() {
      this.$refs.headControl.getDatas('month');
      this.$refs.headControl.getSysOrg();
    },
    changeVal: function changeVal(val) {
      this.orgCode = val;
      this.getProgressData();
      this.getDesignRegionData();
      this.getAbnormalData();
      this.getAbnormalTypeData();
      this.getBuyingIsMoneyAndNumber();
    },
    changDate: function changDate(val) {
      this.dataRange = val;
      this.getProgressData();
      this.getDesignRegionData();
      this.getAbnormalData();
      this.getAbnormalTypeData();
      this.getBuyingIsMoneyAndNumber();
    },
    changePicker: function changePicker(val) {
      this.dataRange = val;
      this.getProgressData();
      this.getDesignRegionData();
      this.getAbnormalData();
      this.getAbnormalTypeData();
      this.getBuyingIsMoneyAndNumber();
    },
    aFormat: function aFormat(amount) {
      return (0, _VueHelper.amountFormat)(amount);
    },
    getBuyingIsMoneyAndNumber: function getBuyingIsMoneyAndNumber() {
      var _this = this;

      var url = Urls.getEchartsProjectOrDesignOrBuyingIsMoneyAndNumber;
      var params = {
        orgCode: this.orgCode || "",
        startTime: this.dataRange.length ? this.dataRange[0] : "",
        endTime: this.dataRange.length ? this.dataRange[1] : "",
        contractCat: 'BUYING'
      };
      this.$root.doPost(url, params, function (server_data) {
        if (!_this.$root.isUserLogin(server_data)) {
          return;
        }

        if (server_data.error) {
          _this.$root.showGlobalError(server_data.error);
          return;
        }
        _this.reportList = server_data.data.reportList;
      });
    },
    initProgressChart: function initProgressChart() {
      var _this2 = this;

      this.progressDataChart = this.$echarts.init(this.$refs.progressData);
      var option = {
        textStyle: {
          fontFamily: 'PingFang-M'
        },
        title: {
          text: "进度比例",
          padding: this.isH5 ? [24, 0, 0, 20] : [24, 0, 0, 30],
          textStyle: {
            fontWeight: 'normal'
          }
        },
        grid: {
          left: this.isH5 ? 24 : 33,
          top: 97,
          right: this.isH5 ? 24 : 33,
          bottom: 29,
          containLabel: true
        },
        opacity: 0.1,
        tooltip: {
          trigger: "axis",
          formatter: function formatter(params) {
            var message = '';
            params.reverse().forEach(function (item, index) {
              if (item.seriesIndex == 1) {
                message += item.axisValue + ': ' + item.data + '个' + '<br>';
              } else {
                message += '占比: ' + item.data + '%';
              }
            });
            return "<div style=\"padding: 5px 8px; font-size: 12px\">" + message + "</div>";
          }
        },
        legend: {
          data: this.progressData.legend,
          itemWidth: 40,
          itemHeight: 8,
          top: '20',
          left: this.isH5 ? '120' : '180',
          itemGap: 20,
          textStyle: {
            fontSize: '13',
            height: 10,
            rich: {
              a: {
                verticalAlign: 'middle'
              }
            }
          }
        },
        xAxis: [{
          type: "category",
          data: this.progressData.xAxis.data,

          splitLine: {
            show: this.progressData.series[1].data.reduce(function (a, b) {
              return a + b;
            }) === 0 ? false : true,
            lineStyle: {
              color: "#ddd"
            }
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: this.progressData.series[1].data.reduce(function (a, b) {
              return a + b;
            }) === 0 ? true : false,
            lineStyle: {
              color: '#ddd'
            }
          },
          axisLabel: {
            color: '#666',
            margin: 20
          },
          axisPointer: {
            type: 'none'
          }
        }],
        yAxis: [{
          show: this.progressData.series[1].data.reduce(function (a, b) {
            return a + b;
          }) === 0 ? false : true,

          type: "value",
          name: "百分比",
          min: 0,
          max: this.progressMaxPercent,
          splitNumber: 5,
          interval: this.progressMaxPercent / 5,
          axisLabel: {
            formatter: "{value}%",
            margin: 20
          },

          nameTextStyle: {
            padding: [0, 65, 0, 0]
          },
          axisTick: {
            length: 16,
            lineStyle: {
              color: "#ddd"
            }
          },
          axisLine: {
            show: false
          },
          splitLine: {
            show: false
          }
        }, {
          show: this.progressData.series[1].data.reduce(function (a, b) {
            return a + b;
          }) === 0 ? false : true,
          type: "value",
          name: "数量（个）",
          min: 0,
          max: this.progressMaxNum,
          splitNumber: 5,
          interval: this.progressMaxNum / 5,

          nameTextStyle: {
            padding: [0, 0, 0, 40]
          },
          axisTick: {
            length: 16,
            lineStyle: {
              color: "#ddd"
            }
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            margin: 20,
            formatter: function formatter(value) {
              return parseInt(value);
            }
          },
          splitLine: {
            lineStyle: {
              color: "#ddd"
            }
          }
        }],
        series: [{
          name: this.progressData.series[0].name,
          type: "bar",
          barWidth: '60%',
          data: this.progressData.series[0].data,
          itemStyle: {
            normal: {
              color: 'rgba(87, 185, 255, 0.35)',
              borderColor: this.progressData.series[1].data.reduce(function (a, b) {
                return a + b;
              }) === 0 ? 'rgba(87, 185, 255, 0)' : 'rgba(87, 185, 255, 1)'
            }
          },
          yAxisIndex: 0
        }, {
          name: this.progressData.series[1].name,
          type: "line",
          symbol: "rect",
          symbolSize: 9,
          hoverAnimation: false,
          data: this.progressData.series[1].data,
          itemStyle: {
            normal: {
              color: "#61d9ac",
              opacity: this.progressData.series[1].data.reduce(function (a, b) {
                return a + b;
              }) === 0 ? 0 : 1
            },
            emphasis: {
              borderWidth: 3,
              borderColor: '#61d9ac',
              color: '#61d9ac'
            }
          },
          lineStyle: {
            normal: {
              opacity: this.progressData.series[1].data.reduce(function (a, b) {
                return a + b;
              }) === 0 ? 0 : 1
            }
          },
          yAxisIndex: 1
        }]
      };
      this.progressDataChart.setOption(option);
      window.addEventListener("resize", function () {
        _this2.isH5 ? _this2.progressDataChart.resize({ width: _this2.screenWidth - 24 }) : _this2.progressDataChart.resize();
      });
      this.isH5 ? this.progressDataChart.resize({ width: this.screenWidth - 24 }) : this.progressDataChart.resize();
    },
    initAbnormalDataChart: function initAbnormalDataChart() {
      var _this3 = this;

      this.abnormalDataChart = this.$echarts.init(this.$refs.abnormalData);
      var option = {
        textStyle: {
          fontFamily: 'PingFang-M'
        },
        color: ["#57B9FF", "#FFB96E", "#E5E5E5"],
        series: [{
          name: this.abnormalData[0].name,
          type: "pie",
          startAngle: 180,
          center: this.isH5 ? ["25%", "50%"] : ["30%", "50%"],
          radius: this.isH5 ? ["35%", "39%"] : this.radius,
          avoidLabelOverlap: false,
          hoverAnimation: false,
          selectedOffset: 0,
          label: {
            normal: {
              show: false,
              position: "center",

              formatter: function formatter(params) {
                _this3.percent1 = params.percent.toFixed(0);
                var str = "{a|" + params.name + "}\n{b|" + params.value + "}{a|\u4E2A}\n{c|" + _this3.percent1 + "%}";
                return str;
              },
              textStyle: {
                rich: {
                  a: {
                    color: "#666",
                    fontSize: this.isH5 ? 12 : 14,
                    lineHeight: this.isH5 ? 20 : 25
                  },
                  b: {
                    color: "#333",
                    fontSize: this.isH5 ? 18 : 26,
                    fontWeight: 500,
                    lineHeight: this.isH5 ? 20 : 30
                  },
                  c: {
                    fontSize: this.isH5 ? 12 : 14,
                    lineHeight: this.isH5 ? 15 : 20
                  }
                }
              }
            }
          },
          labelLine: {
            show: false
          },
          data: [{
            value: this.abnormalData[0].value,
            name: this.abnormalData[0].name,
            selected: true,
            label: {
              normal: {
                show: true,
                fontSize: "20",
                color: "#57B9FF"
              }
            }
          }, {
            value: this.abnormalData[0].value === 0 ? 10 : this.abnormalData[1].value,
            name: this.abnormalData[0].name,
            itemStyle: {
              normal: { color: "#e5e5e5" },
              emphasis: { color: "#e5e5e5" }
            }
          }]
        }, {
          name: this.abnormalData[1].name,
          type: "pie",
          startAngle: this.startAngle,

          center: ["70%", "50%"],
          radius: this.isH5 ? ["35%", "39%"] : this.radius,
          avoidLabelOverlap: false,
          hoverAnimation: false,
          selectedOffset: 0,
          label: {
            normal: {
              show: false,
              position: "center",
              formatter: function formatter(params) {
                var str = "{a|" + params.name + "}\n{b|" + params.value + "}{a|\u4E2A}\n{c|" + (_this3.abnormalTotal === 0 ? 0 : 100 - _this3.percent1) + "%}";
                return str;
              },
              textStyle: {
                rich: {
                  a: {
                    color: "#666",
                    fontSize: this.isH5 ? 12 : 14,
                    lineHeight: this.isH5 ? 20 : 25
                  },
                  b: {
                    color: "#333",
                    fontSize: this.isH5 ? 18 : 26,
                    fontWeight: 500,
                    lineHeight: this.isH5 ? 20 : 30
                  },
                  c: {
                    fontSize: this.isH5 ? 12 : 14,
                    lineHeight: this.isH5 ? 15 : 20
                  }
                }
              }
            }
          },
          labelLine: {
            show: false
          },
          data: [{
            value: this.abnormalData[1].value,
            name: this.abnormalData[1].name,
            selected: true,
            label: {
              normal: {
                show: true,
                fontSize: "20",
                color: "#FFB96E"
              }
            }
          }, {
            value: this.abnormalData[1].value === 0 ? 10 : this.abnormalData[0].value,
            name: this.abnormalData[1].name,
            itemStyle: {
              normal: { color: "#e5e5e5" },
              emphasis: { color: "#e5e5e5" }
            }
          }]
        }]
      };
      this.abnormalDataChart.setOption(option);
      window.addEventListener("resize", function () {
        _this3.isH5 ? _this3.abnormalDataChart.resize({ width: (_this3.screenWidth - 24) * 0.8 }) : _this3.abnormalDataChart.resize();
      });
      this.isH5 ? this.abnormalDataChart.resize({ width: (this.screenWidth - 24) * 0.8 }) : this.abnormalDataChart.resize();
    },
    initAbnormalTypeChart: function initAbnormalTypeChart() {
      var _this4 = this;

      this.abnormalTypeChart = this.$echarts.init(this.$refs.abnormalType);
      var option = {
        textStyle: {
          fontFamily: 'PingFang-M'
        },
        title: {
          text: "异常类型",
          padding: this.isH5 ? [24, 0, 0, 20] : [24, 0, 0, 30],
          textStyle: {
            fontWeight: 'normal'
          }
        },
        grid: {
          left: this.isH5 ? 24 : 33,
          top: 97,
          right: this.isH5 ? 24 : 33,
          bottom: 17,
          containLabel: true
        },
        opacity: 0.1,
        tooltip: {
          trigger: "axis",
          formatter: function formatter(params) {
            var message = '';
            params.reverse().forEach(function (item, index) {
              if (item.seriesIndex == 1) {
                message += item.axisValue + ': ' + item.data + '个' + '<br>';
              } else {
                message += '占比: ' + item.data + '%';
              }
            });
            return "<div style=\"padding: 5px 8px; font-size: 12px\">" + message + "</div>";
          }
        },
        legend: {
          data: this.abnormalTypeData.legend,
          itemWidth: 40,
          itemHeight: 8,
          top: '20',
          left: this.isH5 ? '120' : '180',
          itemGap: 20,
          textStyle: {
            fontSize: '13',
            height: 10,
            rich: {
              a: {
                verticalAlign: 'middle'
              }
            }
          }
        },
        xAxis: [{
          type: "category",
          data: this.abnormalTypeData.xAxis.data,
          axisPointer: {
            type: 'none'
          },

          splitLine: {
            show: this.abnormalTypeData.series[1].data.reduce(function (a, b) {
              return a + b;
            }) === 0 ? false : true,
            lineStyle: {
              color: "#ddd"
            }
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: this.abnormalTypeData.series[1].data.reduce(function (a, b) {
              return a + b;
            }) === 0 ? true : false,
            lineStyle: {
              color: '#ddd'
            }
          },
          axisLabel: {
            color: '#666',
            margin: 12
          }
        }],
        yAxis: [{
          show: this.abnormalTypeData.series[1].data.reduce(function (a, b) {
            return a + b;
          }) === 0 ? false : true,

          type: "value",
          name: "百分比",
          min: 0,
          max: this.abnormalMaxPercent,
          splitNumber: 5,
          interval: this.abnormalMaxPercent / 5,
          axisLabel: {
            formatter: "{value}%",
            margin: 20
          },

          nameTextStyle: {
            padding: [0, 65, 0, 0]
          },
          axisTick: {
            length: 16,
            lineStyle: {
              color: "#ddd"
            }
          },
          axisLine: {
            show: false
          },
          splitLine: {
            show: false
          }
        }, {
          show: this.abnormalTypeData.series[1].data.reduce(function (a, b) {
            return a + b;
          }) === 0 ? false : true,
          type: "value",
          name: "数量（个）",
          min: 0,
          max: this.abnormalMaxNum,
          splitNumber: 5,
          interval: this.abnormalMaxNum / 5,

          nameTextStyle: {
            padding: [0, 0, 0, 40]
          },
          axisTick: {
            length: 16,
            lineStyle: {
              color: "#ddd"
            }
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            margin: 20,
            formatter: function formatter(value) {
              return parseInt(value);
            }
          },
          splitLine: {
            lineStyle: {
              color: "#ddd"
            }
          }
        }],
        series: [{
          name: this.abnormalTypeData.series[0].name,
          type: "bar",
          barWidth: '60%',
          data: this.abnormalTypeData.series[0].data,
          itemStyle: {
            normal: {
              color: 'rgba(87, 185, 255, 0.35)',
              borderColor: this.abnormalTypeData.series[1].data.reduce(function (a, b) {
                return a + b;
              }) === 0 ? 'rgba(87, 185, 255, 0)' : 'rgba(87, 185, 255, 1)'
            }
          },
          yAxisIndex: 0
        }, {
          name: this.abnormalTypeData.series[1].name,
          type: "line",
          symbol: "rect",
          symbolSize: 9,
          hoverAnimation: false,
          data: this.abnormalTypeData.series[1].data,
          itemStyle: {
            normal: {
              color: "#61d9ac",
              opacity: this.abnormalTypeData.series[1].data.reduce(function (a, b) {
                return a + b;
              }) === 0 ? 0 : 1
            },
            emphasis: {
              borderWidth: 3,
              borderColor: '#61d9ac',
              color: '#61d9ac'
            }
          },
          lineStyle: {
            normal: {
              opacity: this.abnormalTypeData.series[1].data.reduce(function (a, b) {
                return a + b;
              }) === 0 ? 0 : 1
            }
          },
          yAxisIndex: 1
        }]
      };
      this.abnormalTypeChart.setOption(option);
      window.addEventListener("resize", function () {
        _this4.isH5 ? _this4.abnormalTypeChart.resize({ width: _this4.screenWidth - 24 }) : _this4.abnormalTypeChart.resize();
      });
      this.isH5 ? this.abnormalTypeChart.resize({ width: this.screenWidth - 24 }) : this.abnormalTypeChart.resize();
    },
    getProgressData: function getProgressData() {
      var _this5 = this;

      var url = Urls.getEchartsBuyingTypeReportItemData;
      var params = {
        orgCode: this.orgCode || "",
        startTime: this.dataRange.length ? this.dataRange[0] : "",
        endTime: this.dataRange.length ? this.dataRange[1] : ""
      };
      this.$root.doPost(url, params, function (server_data) {
        if (!_this5.$root.isUserLogin(server_data)) {
          return;
        }

        if (server_data.error) {
          _this5.$root.showGlobalError(server_data.error);
          return;
        }
        _this5.progressData = server_data.data;
      });
    },
    getDesignRegionData: function getDesignRegionData() {
      var _this6 = this;

      var url = Urls.getEchartsBuyingReportDataByRegion;
      var params = {
        orgCode: this.orgCode || "",
        startTime: this.dataRange.length ? this.dataRange[0] : "",
        endTime: this.dataRange.length ? this.dataRange[1] : "",
        itemCode: "PROJECT_REGION"
      };
      this.$root.doPost(url, params, function (server_data) {
        if (!_this6.$root.isUserLogin(server_data)) {
          return;
        }

        if (server_data.error) {
          _this6.$root.showGlobalError(server_data.error);
          return;
        }
        _this6.designRegionData = server_data.data.reportList;
      });
    },
    getAbnormalData: function getAbnormalData() {
      var _this7 = this;

      var url = Urls.getEchartsBuyingReportItemData;
      var params = {
        orgCode: this.orgCode || "",
        startTime: this.dataRange.length ? this.dataRange[0] : "",
        endTime: this.dataRange.length ? this.dataRange[1] : ""
      };
      this.$root.doPost(url, params, function (server_data) {
        if (!_this7.$root.isUserLogin(server_data)) {
          return;
        }

        if (server_data.error) {
          _this7.$root.showGlobalError(server_data.error);
          return;
        }
        _this7.abnormalData = server_data.data;
        _this7.abnormalTotal = 0;
        _this7.abnormalData.forEach(function (item) {
          _this7.abnormalTotal += item.value;
        });
      });
    },
    getAbnormalTypeData: function getAbnormalTypeData() {
      var _this8 = this;

      var url = Urls.getEchartsBuyingAbnormalTypeReportItemData;
      var params = {
        orgCode: this.orgCode || "",
        startTime: this.dataRange.length ? this.dataRange[0] : "",
        endTime: this.dataRange.length ? this.dataRange[1] : ""
      };
      this.$root.doPost(url, params, function (server_data) {
        if (!_this8.$root.isUserLogin(server_data)) {
          return;
        }

        if (server_data.error) {
          _this8.$root.showGlobalError(server_data.error);
          return;
        }
        _this8.abnormalTypeData = server_data.data;
      });
    }
  },
  computed: {
    startAngle: function startAngle() {
      var total = this.abnormalData[0].value + this.abnormalData[1].value;
      if (total === 0) {
        return 180;
      } else {
        var res = this.abnormalData[0].value / total * 360;
        if (res > 180) {
          return 360 + (180 - res);
        } else {
          return 180 - res;
        }
      }
    },
    radius: function radius() {
      return this.screenWidth < 1366 ? ["45%", "49%"] : ["50%", "54%"];
    }
  },
  watch: {
    progressData: function progressData(newVal) {
      if (newVal) {
        this.progressMaxNum = Math.ceil(Math.max.apply(Math, (0, _toConsumableArray3.default)(newVal.series[1].data)) / 10) * 10;
        this.progressMaxPercent = Math.ceil(Math.max.apply(Math, (0, _toConsumableArray3.default)(newVal.series[0].data)) / 10) * 10;
        this.initProgressChart();
      }
    },
    abnormalData: function abnormalData(newVal) {
      if (newVal) {
        this.initAbnormalDataChart();
      }
    },
    abnormalTypeData: function abnormalTypeData(newVal) {
      if (newVal) {
        this.abnormalMaxNum = Math.ceil(Math.max.apply(Math, (0, _toConsumableArray3.default)(newVal.series[1].data)) / 10) * 10;
        this.abnormalMaxPercent = Math.ceil(Math.max.apply(Math, (0, _toConsumableArray3.default)(newVal.series[0].data)) / 10) * 10;
        this.initAbnormalTypeChart();
      }
    },
    screenWidth: function screenWidth(newVal) {
      this.initAbnormalDataChart();
    }
  },
  mounted: function mounted() {
    var _this9 = this;

    if (this.$route.query.identification) {
      this.isH5 = true;
    }
    window.onresize = function () {
      return function () {
        window.screenWidth = document.body.clientWidth;
        _this9.screenWidth = window.screenWidth;
      }();
    };
  }
};

/***/ }),

/***/ 857:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _welcomeViewModules = __webpack_require__(1640);

var _welcomeViewModules2 = _interopRequireDefault(_welcomeViewModules);

var _Urls = __webpack_require__(12);

var Urls = _interopRequireWildcard(_Urls);

var _welcomeViewApprove = __webpack_require__(1639);

var _welcomeViewApprove2 = _interopRequireDefault(_welcomeViewApprove);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: { welcomeViewModulesVue: _welcomeViewModules2.default, welcomeViewApproveVue: _welcomeViewApprove2.default },
  data: function data() {
    return {
      activeName: "Wait",
      activeName1: "message",
      ProjectManagementList: [],
      SkipList: [{
        name: "登记立项",
        src: "https://xmyun.zhoty.com/xmerp/pcadmin/static/images/workbench/app-djlx.png"
      }, {
        name: "在跟项目",
        src: "https://xmyun.zhoty.com/xmerp/pcadmin/static/images/workbench/app-zgxm.png"
      }, {
        name: "在建项目",
        src: "https://xmyun.zhoty.com/xmerp/pcadmin/static/images/workbench/app-zjxm.png"
      }, {
        name: "完工项目",
        src: "https://xmyun.zhoty.com/xmerp/pcadmin/static/images/workbench/app-wgxm.png"
      }, {
        name: "合同管理",
        src: "https://xmyun.zhoty.com/xmerp/pcadmin/static/images/workbench/app-htgl.png"
      }, {
        name: "资料管理",
        src: "https://xmyun.zhoty.com/xmerp/pcadmin/static/images/workbench/app-zlgl.png"
      }, {
        name: "项目用印",
        src: "https://xmyun.zhoty.com/xmerp/pcadmin/static/images/workbench/app-xmyy.png"
      }, {
        name: "材料代付",
        src: "https://xmyun.zhoty.com/xmerp/pcadmin/static/images/workbench/app-cldf.png"
      }, {
        name: "劳务支付",
        src: "https://xmyun.zhoty.com/xmerp/pcadmin/static/images/workbench/app-lwzf.png"
      }, {
        name: "财务管理",
        src: "https://xmyun.zhoty.com/xmerp/pcadmin/static/images/workbench/app-cwgl.png"
      }],
      requestList: [{
        name: "项目用印",
        src: "https://xmyun.zhoty.com/xmerp/pcadmin/static/images/workbench/fqsq-xiangmuyongyin.png"
      }, {
        name: "其他用印",
        src: "https://xmyun.zhoty.com/xmerp/pcadmin/static/images/workbench/fqsq-qitayongyin.png"
      }, {
        name: "劳务支付",
        src: "https://xmyun.zhoty.com/xmerp/pcadmin/static/images/workbench/fqsq-laowuzhifu.png"
      }, {
        name: "代付材料",
        src: "https://xmyun.zhoty.com/xmerp/pcadmin/static/images/workbench/fqsq-daifucailiao.png"
      }, {
        name: "登记立项",
        src: "https://xmyun.zhoty.com/xmerp/pcadmin/static/images/workbench/fqsq-dengjilixiang.png"
      }, {
        name: "开票申请",
        src: "https://xmyun.zhoty.com/xmerp/pcadmin/static/images/workbench/fqsq-kaipiaoshengqing.png"
      }],
      NewsList: [],
      CopyNewsList: [],
      COMP_NOTICELIST: [],
      COMP_NEWSLIST: [],
      COMP_INSTLIST: [],
      Newstotal: 0,
      CopyNewtotal: 0,
      username: "",
      time: "",
      timeId: null
    };
  },
  created: function created() {
    var userInfo = JSON.parse(sessionStorage.getItem("user"));
    this.username = userInfo.realName;
    this.getNews();
    this.getCopyNews();
    this.getworkbench_data();
    this.getSystemNoticePage("COMP_NOTICE");
  },

  methods: {
    handleClick1: function handleClick1(value, e) {
      switch (value.name) {
        case "message":
          this.getSystemNoticePage("COMP_NOTICE");
          break;
        case "news":
          this.getSystemNoticePage("COMP_NEWS");
          break;
        case "announcement":
          this.getSystemNoticePage("COMP_INST");
          break;
      }
    },
    Skip: function Skip(value) {
      switch (value) {
        case "djlx":
          this.$router.push("/common/projectPreparation");
          break;
        case "zgxm":
          this.$router.push("/cm/project/followUpProject");
          break;
        case "zjxm":
          this.$router.push("/cm/project/underConstructionProject");
          break;
        case "wgxm":
          this.$router.push("/cm/project/finishedProject");
          break;
        case "htgl":
          this.$router.push("/common/CMcontractData");
          break;
        case "zlgl":
          this.$router.push("/common/fileList");
          break;
        case "xmyy":
          this.$router.push("/cm/sealApplicationIndexView");
          break;
        case "cldf":
          this.$router.push("/common/materialList");
          break;
        case "lwzf":
          this.$router.push("/common/servicePayList2");
          break;
        case "cwgl":
          this.$router.push("/fm/FMStatProjectIndexView");
          break;
      }
    },
    SkipAdd: function SkipAdd(value) {
      switch (value) {
        case "xiangmuyongyin":
          this.$router.push({
            path: "/cm/sealApplicationIndexView",
            query: {
              mark: true
            }
          });
          break;
        case "qitayongyin":
          this.$router.push("/cm/sealApplicationOtheradd");
          break;
        case "laowuzhifu":
          this.$router.push({
            path: "/common/servicePayList",
            query: {
              mark: true
            }
          });
          break;
        case "daifucailiao":
          this.$router.push({
            path: "/common/materialList",
            query: {
              mark: true
            }
          });
          break;
        case "dengjilixiang":
          this.$router.push("/common/proPreparationAdd");
          break;
        case "kaipiaoshengqing":
          this.$router.push({
            path: "/fm/FmOutPutTicket",
            query: {
              mark: true
            }
          });
          break;
      }
    },
    handleClick: function handleClick(value, e) {
      switch (value.name) {
        case "Wait":
          this.getNews();
          break;
        case "Send":
          this.getCopyNews();
          break;
      }
    },
    getNews: function getNews() {
      var inst = this;
      var url = Urls.message_unreadMsgPage;
      var params = {
        pageNo: 1,
        pageSize: 3
      };
      this.$root.doPost(url, params, function (server_data) {
        if (!inst.$root.isUserLogin(server_data)) {
          return;
        }

        if (server_data.error) {
          inst.$root.showGlobalError(server_data.error);
          return;
        }
        inst.NewsList = server_data.data.dataList;
        inst.Newstotal = server_data.data.totalCount;
      });
    },
    getCopyNews: function getCopyNews() {
      var inst = this;
      var url = Urls.message_unreadCopyMsgPage;
      var params = {
        pageNo: 1,
        pageSize: 3,
        isAwait: "Y"
      };
      this.$root.doPost(url, params, function (server_data) {
        if (!inst.$root.isUserLogin(server_data)) {
          return;
        }

        if (server_data.error) {
          inst.$root.showGlobalError(server_data.error);
          return;
        }
        inst.CopyNewsList = server_data.data.dataList;
        inst.CopyNewtotal = server_data.data.totalCount;
      });
    },
    getSystemNoticePage: function getSystemNoticePage(value) {
      var inst = this;
      var url = Urls.NoticeGetSystemNoticePage;
      var params = {
        pageNo: 1,
        pageSize: 5,
        noticeType: value
      };
      this.$root.doPost(url, params, function (server_data) {
        if (!inst.$root.isUserLogin(server_data)) {
          return;
        }

        if (server_data.error) {
          inst.$root.showGlobalError(server_data.error);
          return;
        }
        if (value === "COMP_NOTICE") {
          inst.COMP_NOTICELIST = server_data.data.dataList;
        } else if (value === "COMP_NEWS") {
          inst.COMP_NEWSLIST = server_data.data.dataList;
        } else {
          inst.COMP_INSTLIST = server_data.data.dataList;
        }
      });
    },
    getworkbench_data: function getworkbench_data() {
      var inst = this;
      var url = Urls.workbench_data;
      var params = {};
      this.$root.doPost(url, params, function (server_data) {
        if (!inst.$root.isUserLogin(server_data)) {
          return;
        }

        if (server_data.error) {
          inst.$root.showGlobalError(server_data.error);
          return;
        }
        inst.ProjectManagementList = server_data.data;
      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.timeId = setInterval(function () {
      _this.time = new Date();
    }, 1000);
  },
  beforeDestroy: function beforeDestroy() {
    this.timeId && clearInterval(this.timeId);
  }
};

/***/ }),

/***/ 858:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var app_server = "https://pcapi.xmoty.com";exports.app_server = app_server;

/***/ }),

/***/ 859:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(21);

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__(741);

var _App2 = _interopRequireDefault(_App);

var _elementUi = __webpack_require__(371);

var _elementUi2 = _interopRequireDefault(_elementUi);

__webpack_require__(738);

var _echarts = __webpack_require__(737);

var echarts = _interopRequireWildcard(_echarts);

__webpack_require__(736);

var _vueRouter = __webpack_require__(742);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _store = __webpack_require__(735);

var _store2 = _interopRequireDefault(_store);

var _vuex = __webpack_require__(205);

var _vuex2 = _interopRequireDefault(_vuex);

var _routes2 = __webpack_require__(733);

var _routes3 = _interopRequireDefault(_routes2);

__webpack_require__(739);

var _VueHelper = __webpack_require__(17);

var VueHelper = _interopRequireWildcard(_VueHelper);

var _Events = __webpack_require__(204);

var Events = _interopRequireWildcard(_Events);

var _Urls = __webpack_require__(12);

var Urls = _interopRequireWildcard(_Urls);

var _MenuUtils = __webpack_require__(91);

var _MenuUtils2 = _interopRequireDefault(_MenuUtils);

__webpack_require__(732);

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

__webpack_require__(729);

var _ajaxHook = __webpack_require__(730);

var _rem = __webpack_require__(734);

var _rem2 = _interopRequireDefault(_rem);

var _vant = __webpack_require__(83);

__webpack_require__(740);

var _xmDialog = __webpack_require__(731);

var _xmDialog2 = _interopRequireDefault(_xmDialog);

var _axios = __webpack_require__(94);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.prototype.$echarts = echarts;
_vue2.default.prototype.$moment = _moment2.default;

_vue2.default.$XmDialog = _vue2.default.prototype.$XmDialog = _xmDialog2.default.install;

(0, _ajaxHook.proxy)({
    onRequest: function onRequest(config, handler) {
        if (config.headers.authorization || config.url.indexOf("play.xmoty.com/xmlive") != -1) {} else {
            config.headers.authorization = window.sessionStorage.getItem('token');
        }

        handler.next(config);
    },

    onError: function onError(err, handler) {
        handler.next(err);
    },

    onResponse: function onResponse(response, handler) {
        handler.next(response);
    }
}), _vue2.default.use(_elementUi2.default);
_vue2.default.use(_vueRouter2.default);
_vue2.default.use(_vuex2.default);
_vue2.default.use(_vant.Checkbox);
_vue2.default.use(_vant.CheckboxGroup);
_vue2.default.use(echarts);
_vue2.default.use(_vant.Popup);
_vue2.default.use(_vant.Checkbox);
_vue2.default.use(_vant.CheckboxGroup);
_vue2.default.use(echarts);

var router = new _vueRouter2.default({
    routes: _routes3.default
});

if (window.location.hash != '#/login') {
    var data = JSON.parse(window.sessionStorage.getItem('userPre'));
    if (data) {
        var _routes = [];
        (0, _MenuUtils2.default)(_routes, data);
        router.addRoutes(_routes);
        console.log(_routes, '--------------------');
    }
}

var benchBtns = [],
    benchId = void 0;
router.beforeEach(function (to, from, next) {
    document.body.scrollTop = 0;

    document.documentElement.scrollTop = 0;

    window.pageYOffset = 0;

    var isH5 = to.path == '/fileh5' || to.path == '/h5upload' || to.path == '/JournalFileh5' || to.path == '/CommonUploadH5' || to.path == '/operationDataH5' || to.path == '/pdfViewH5' || to.path == '/businessInfoH5';

    var isScreen = to.path === '/datav/index' || to.path === '/datavIndex' || to.path === '/bizCompasition' || to.path === '/datav/biz' || to.path === '/datav/pm' || to.path === '/datav/project' || to.path === '/datav/customer' || to.path === '/forgotPassword';
    if (to.path == '/login') {
        console.log('登录/login');
        sessionStorage.removeItem('user');
        next();
    } else if (to.path == '/appLogin' || to.path.startsWith('/appLogin')) {
        var user = JSON.parse(sessionStorage.getItem('user'));
        _vue2.default.prototype.$wxOpenId = user && user.wxOpenId ? false : true;
        document.getElementById('meta').content = 'width=device-width,initial-scale=1.0';
        next();
    } else if (isH5) {
        document.getElementById('meta').content = 'width=device-width,initial-scale=1.0,user-scalable=no';
        next();
    } else {
        var _user = JSON.parse(sessionStorage.getItem('user'));
        _vue2.default.prototype.$wxOpenId = _user && _user.wxOpenId ? false : true;

        if (!_user && to.path != '/login') {
            if (isScreen) {
                next();
            } else {
                next({ path: '/login' });
            }
        } else {
            var userInfo = JSON.parse(sessionStorage.getItem('user'));
            var roleMeun = userInfo.roleMeun;
            try {
                var inst = undefined;
                roleMeun.forEach(function (element) {
                    element.children.forEach(function (element2) {
                        if (element2.children.length) {
                            element2.children.forEach(function (element3) {
                                if (element3.workBenchList[0].benchPath == to.path) {
                                    benchBtns = element3.workBenchList[0].benchBtns;
                                    benchId = element3.benchId;
                                    _store2.default.commit('setParam', element3.workBenchList[0].benchParam);
                                    _store2.default.commit('setBenchId', element3.benchId);
                                    throw Error();
                                }
                            });
                        } else {
                            if (element2.workBenchList[0].benchPath == to.path) {
                                benchBtns = element2.workBenchList[0].benchBtns;
                                benchId = element2.benchId;
                                _store2.default.commit('setParam', element2.workBenchList[0].benchParam);
                                _store2.default.commit('setBenchId', element2.benchId);
                                throw Error();
                            }
                        }
                    });
                });
            } catch (e) {}
            document.getElementById('meta').content = '';
            next();
        }
    }
});

router.onError(function (error) {

    var pattern = /Loading chunk (\d)+ failed/g;
    var isChunkLoadFailed = error.message.match(pattern);
    var targetPath = router.history.pending.fullPath;
    if (isChunkLoadFailed) {
        router.replace(targetPath);
    }
});

var Bus = new _vue2.default();

_axios2.default.defaults.withCredentials = true;

var enumMap = {};

_vue2.default.filter('money', function (value) {
    if (!value) return '0.00';
    var result = 0;
    if (typeof value == 'string') {
        result = parseFloat(value).toFixed(2);
    } else {
        result = value.toFixed(2);
    }

    var value2Array = result.split(".");
    var intPart = value2Array[0];
    var intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
    var floatPart = ".00";
    floatPart = value2Array[1];
    return intPartFormat + '.' + floatPart;
});

_vue2.default.filter('w_money', function (val) {
    if (!val) return '0.00';
    var result = 0;
    if (typeof val == 'string') {
        result = parseFloat(val).toFixed(2);
    } else {
        result = val.toFixed(2);
    }
    return (result / 10000).toFixed(2);
});
new _vue2.default({
    router: router,
    store: _store2.default,

    data: {
        Bus: Bus,
        enumMap: enumMap,
        benchId: '' },
    methods: {
        getBenchBtns: function getBenchBtns() {
            return benchBtns;
        },
        isGet: function isGet(tag) {
            var flag = false;
            benchBtns.forEach(function (e) {
                if (tag == e.btnCode || tag == e.btnValue) {
                    flag = true;
                }
            });
            return flag;
        },
        getbenchId: function getbenchId() {
            return benchId;
        },

        doPost: function doPost(url, params, succ_func, error_func, noLoading) {

            var theParams = null;
            if (params) {
                theParams = VueHelper.makeSearchParams(params);
            }
            var inst = this;
            var loading = void 0;
            if (!noLoading) {
                loading = this.$loading({
                    lock: true,
                    text: '',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0)',
                    customClass: 'loading-custom',
                    fullscreen: false
                });
            }
            _axios2.default.post(url, theParams).then(function (response) {

                var server_data = response.data;
                succ_func(server_data);
                if (loading) loading.close();
            }).catch(function (error) {
                if (loading) loading.close();
                if (error_func) {
                    error_func(error);
                } else {
                    console.log('=================== error ===============');
                    console.log('请求失败', error);
                }
            });
        },
        doGet: function doGet(url, params, succ_func, error_func, noLoading) {

            var inst = this;

            var theParams = null;
            if (params) {
                theParams = { params: params };
            }
            var loading = void 0;
            if (!noLoading) {
                loading = this.$loading({
                    lock: true,
                    text: '',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0)',
                    customClass: 'loading-custom',
                    fullscreen: false
                });
            }
            _axios2.default.get(url, theParams).then(function (response) {

                var server_data = response.data;
                succ_func(server_data);
                if (loading) loading.close();
            }).catch(function (error) {
                if (loading) loading.close();
                if (error_func) {
                    error_func(error);
                } else {
                    console.log('=================== error ===============');
                    console.log('请求失败', error);
                    inst.$message.error('网络不可用或应用程序出错');
                }
            });
        },
        doPut: function doPut(url, params, succ_func, error_func) {

            var theParams = null;
            if (params) {
                theParams = VueHelper.makeSearchParams(params);
            }
            var inst = this;

            _axios2.default.put(url, theParams).then(function (response) {

                var server_data = response.data;
                succ_func(server_data);
            }).catch(function (error) {
                if (error_func) {
                    error_func(error);
                } else {
                    console.log('=================== error ===============');
                    console.log('请求失败', error);
                }
            });
        },
        doDelete: function doDelete(url, params, succ_func, error_func) {

            var theParams = null;
            if (params) {
                theParams = VueHelper.makeSearchParams(params);
            }
            var inst = this;

            _axios2.default.delete(url, theParams).then(function (response) {
                var server_data = response.data;
                succ_func(server_data);
            }).catch(function (error) {
                if (error_func) {
                    error_func(error);
                } else {
                    console.log('=================== error ===============');
                    console.log('请求失败', error);
                }
            });
        },
        showGlobalError: function showGlobalError(text) {
            this.$message.warning(text);
        },
        showGlobalSucc: function showGlobalSucc(text) {
            this.$message.success(text);
        },
        isUserLogin: function isUserLogin(server_data) {
            if ('Y' == server_data.sessionExpire) {
                this.$router.push('/login');
                return false;
            }
            return true;
        },
        formatDate: function formatDate(data) {
            if (data) {
                return (0, _moment2.default)(data).format("YYYY-MM-DD HH:mm:ss");
            } else {
                return '';
            }
        },
        formatDay: function formatDay(data) {
            if (data) {
                return (0, _moment2.default)(data).format("YYYY-MM-DD");
            } else {
                return '';
            }
        },
        formatDayNY: function formatDayNY(data) {
            if (data) {
                return (0, _moment2.default)(data).format("YYYY-MM");
            } else {
                return '';
            }
        },
        formatTime: function formatTime(data) {
            if (data) {
                return (0, _moment2.default)(data).format("HH:mm:ss");
            } else {
                return '';
            }
        },
        initEnumData: function initEnumData(using_func) {
            var url = Urls.get_all_enum_data_map;

            var params = {};
            var inst = this;
            this.$root.doPost(url, params, function (server_data) {
                if (!inst.$root.isUserLogin(server_data)) {
                    return;
                }

                if (server_data.error) {
                    inst.$root.showGlobalError(server_data.error);
                    return;
                }

                using_func(server_data.data);
            });
        },
        ajaxGet: function ajaxGet(url, params, using_func) {
            var inst = this;
            this.$root.doGet(url, params, function (server_data) {
                if (!inst.$root.isUserLogin(server_data)) {
                    return;
                }

                if (server_data.error) {
                    inst.$root.showGlobalError(server_data.error);
                    return;
                }

                using_func(server_data.data);
            });
        },
        ajaxPost: function ajaxPost(url, params, using_func) {
            var inst = this;
            this.$root.doPost(url, params, function (server_data) {
                if (!inst.$root.isUserLogin(server_data)) {
                    return;
                }

                if (server_data.error) {
                    inst.$root.showGlobalError(server_data.error);
                    return;
                }

                using_func(server_data.data);
            });
        },
        getLoginUser: function getLoginUser() {

            var user = sessionStorage.getItem('user');
            if (user) {
                user = JSON.parse(user);
            }
            return user;
        },
        notLoginforPrint: function notLoginforPrint(server_data) {
            if ('Y' == server_data.sessionExpire) {
                this.$root.showGlobalError(server_data.error);
                setTimeout(function () {
                    if (navigator.userAgent.indexOf("Firefox") != -1 || navigator.userAgent.indexOf("Chrome") != -1) {
                        window.location.href = "about:blank";
                        window.close();
                    } else {
                        window.opener = null;
                        window.open("", "_self");
                        window.close();
                    }
                }, 500);
            }
        },
        gotoDetail: function gotoDetail(item) {
            var path = '';
            var query = { bizItemId: item.bizItemId };
            switch (item.itemCat) {
                case 'LABOR_APPLY':
                    path = '/common/servicePayDetail';
                    break;
                case 'RISK_ FUND_APPLY':
                    path = '/common/RiskFundDetails';
                    break;
                case 'ADVANCE_TAX_APPLY':
                    path = '/common/refundTaxesDetails';
                    break;
                case 'PAID_MATERIAL_APPLY':
                    path = '/common/materialDetail';
                    break;
                case 'PROPERTY_MANAGEMENT_APPLY':
                    path = '/common/depositDetail';
                    break;
                case 'BID_BOND_APPLY':
                    path = '/common/marginDetail';
                    break;
                case 'SEAL_APPLY':
                    path = '/cm/sealApplicationDetail';
                    break;
                case 'CONTRACT_APPLY':
                    path = '/cm/contract/read_view0';
                    break;
                case 'GUARANTEE_LETTER_APPLY':
                    path = '/commonPage/projectManage/guaranteeDetail';
                    break;
                case 'INSURANCE_APPLY':
                    path = '/finance/insuranceDetail';
                    break;
                case 'PUNISHMENT_APPLY':
                    path = '/common/adminSanctionDetail';
                    break;
                case 'LITIGATION_APPLY':
                    path = '/common/litigationDetail';
                    break;
                case 'COMPLAINT_APPLY':
                    path = '/common/complaintDetail';
                    break;
                case 'PROJECT_APPLY':
                    path = '/common/proPreparationDetail';
                    break;
                case 'CASUALTY_APPLY':
                    path = '/common/injuriesDetail';
                    break;
                case 'CREDIT_APPLY':
                    path = '/common/creditDetail';
                    break;
                case 'PROJECT_LOSE_SINGLE':
                    path = '/commonPage/projectManage/losingDetailNew';
                    break;
                case 'PROJECTMANAGER_APPLY':
                    path = '/cd/pm/edit';
                    break;
                case 'ADVANCETAXAPPLY_APPLY':
                    path = '/fm/prepaidTaxDetail';
                    break;
                case 'INVOICEAPPLYDATA_APPLY':
                    path = '/fm/FmOutPutTicketDetail';
                    break;
                case 'INVOICEAPPLYDATA_VOID':
                    path = '/fm/FMVoidRecordDetail';
                    break;
                case 'INVOICEAPPLYDATA_REDRUSH':
                    path = '/fm/FMVoidRecordDetail';
                    query = { bizItemId: item.bizItemId, type: 3, applyType: 3 };
                    break;
                case 'COMPLETION_SETTLE_APPLY':
                    path = '/cm/CMFinishedAccountDetail';
                    query = { bizItemId: item.bizItemId };
                    break;
                case 'OTHER_SEAL_APPLY':
                    path = '/cm/sealApplicationOtherDetail';
                    query = { bizItemId: item.bizItemId };
                    break;
                case 'TICKET_RECORDS':
                    path = '/admin/WorkOrderDetail';
                    query = { bizItemId: item.bizItemId };
                    break;
            }
            if (!path) return;
            this.$router.push({ path: path, query: query });
        },
        isHas: function isHas(code) {
            var btnGroup = JSON.parse(sessionStorage.getItem("user")).buttons;
            var buttons = btnGroup.map(function (item) {
                return item.btnValue || item.btnCode;
            }).filter(Boolean);
            if (buttons.includes(code)) {
                return true;
            } else {
                return false;
            }
        }
    },
    render: function render(h) {
        return h(_App2.default);
    },
    beforeCreate: function beforeCreate() {
        _vue2.default.prototype.$bus = this;
    }
}).$mount('#app');
_rem2.default.setFontSize();

/***/ }),

/***/ 860:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});


var menuED = [{
    path: '/p6',
    redirect: '/ba/cm/projectManagerList',
    component: "HomeView",
    name: '项目总监管理',
    parent: true,
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "项目总监",
        children: [{
            pageAddress: "cd/CDinterviewRecord",
            path: "/cm/pm/interviewRecord",
            hidden: true,
            component: "CDinterviewRecord",
            name: "项目总监管理---访谈记录"
        }, {
            pageAddress: "cd/CDprojectDirector",
            path: "/cm/pm/projectDirector",
            hidden: true,
            component: "CDprojectDirector",
            name: "查看项目总监"
        }, {
            pageAddress: "cd/CDProjectManagerEditView",
            path: "/cd/pm/edit",
            hidden: true,
            component: "CDProjectManagerEditView",
            name: "项目总监详情"
        }]
    }]

}, {
    path: '/p8',
    redirect: '/cm/information/changePW',
    component: "HomeView",
    name: '系统管理',
    parent: true,
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "个人设置",
        children: []
    }]

}];

exports.default = menuED;

/***/ }),

/***/ 861:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});


var menuAdmin = [{
    path: '/p0',
    component: "HomeView",
    name: '营销管理',
    redirect: '/common/injuriesList',
    parent: true,
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "公关管理",
        children: [{
            pageAddress: "commonPage/projectManage/injuriesDetail",
            path: "/common/injuriesDetail",
            component: "injuriesDetail",
            name: "事故详情",
            hidden: true
        }, {
            pageAddress: "commonPage/projectManage/injuriesAdd",
            path: "/common/injuriesAdd",
            component: "injuriesAdd",
            name: "添加伤亡事故",
            hidden: true
        }, {
            pageAddress: "pm/pmInjuriesList",
            path: "/pm/pmInjuriesList",
            hidden: true,
            component: "pmInjuriesList",
            name: "伤亡事故"
        }, {
            pageAddress: "commonPage/complaintManage/addComplainList",
            path: "/common/addComplainList",
            hidden: true,
            component: "addComplainList",
            name: "添加投诉"
        }, {
            pageAddress: "commonPage/complaintManage/complaintDetail",
            path: "/common/complaintDetail",
            hidden: true,
            component: "complaintDetail",
            name: "投诉详情"
        }]
    }, {
        parent: true,
        component: "Navigation",
        redirect: '/common/problemFeedbackList',
        path: "/home",
        name: "反馈管理",
        children: [{
            path: "/common/problemFeedbackDetail",
            hidden: true,
            component: "ProblemFeedbackDetailView",
            name: "问题反馈详情"
        }]
    }]
}, {
    path: '/p4',
    redirect: '/common/materialList',
    component: "HomeView",
    name: '材料管理',
    parent: true,


    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "代付材料",
        children: [{
            pageAddress: "commonPage/financeManage/materialDetail",
            path: "/common/materialDetail",
            hidden: true,
            name: "代付材料申请详情"

        }, {
            pageAddress: "commonPage/financeManage/marginDetail",
            path: "/common/marginDetail",
            hidden: true,
            name: "代付投标保证金申请详情"
        }, {
            pageAddress: "commonPage/financeManage/depositDetail",
            path: "/common/depositDetail",
            hidden: true,
            name: "代付物业押金申请详情"
        }, {
            pageAddress: "commonPage/financeManage/purchaseDetail",
            path: "/common/purchaseDetail",
            hidden: true,
            name: "材料购销合同详情"
        }, {
            pageAddress: "commonPage/financeManage/purchaseApply",
            path: "/common/purchaseApply",
            hidden: true,
            name: "新增材料购销合同"
        }]
    }, {
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "众惠材料",
        children: []
    }]

}, {
    path: '/p5',
    redirect: '/fm/FMStatProjectIndexView',
    component: "HomeView",
    name: '财务管理',
    parent: true,
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "总表视图",
        children: [{
            pageAddress: "commonPage/dataReport/financeDataInfo",
            path: "/common/financeDataInfo",
            component: "financeDataInfo",
            hidden: true,
            name: "财务数据详情"
        }, {
            pageAddress: "fm/FMStatProjectReadView",
            path: "/fm/FMStatProjectReadView",
            hidden: true,
            name: "项目细节"
        }]
    }, {
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "资金管理",
        children: [{
            pageAddress: "fm/FMFinanceIncomeEditView",
            path: "/fm/financeIncome/edit",
            hidden: true,
            name: "收款流水细节"
        }, {
            pageAddress: "fm/FMFinanceIncomeReadView",
            path: "/fm/financeIncome/read",
            hidden: true,
            name: "流水信息"
        }, {
            pageAddress: "commonPage/financeManage/servicePayEdit",
            path: "/common/servicePayEdit",
            hidden: true,
            name: "编辑劳务支付"
        }, {
            pageAddress: "commonPage/financeManage/servicePayDetail",
            path: "/common/servicePayDetail",
            hidden: true,
            name: "劳务支付详情"
        }, {
            pageAddress: "fm/FMDeductionDetail",
            path: "/fm/FMDeductionDetail",
            hidden: true,
            name: "手动扣款详情"
        }, {
            pageAddress: "fm/FMAddDeduction",
            path: "/fm/FMAddDeduction",
            hidden: true,
            name: "添加手动扣款"
        }, {
            pageAddress: "fm/FMStatProjectReadView",
            path: "/fm/FMStatProjectReadView",
            hidden: true,
            name: "项目细节"
        }, {
            pageAddress: "commonPage/financeManage/applyPaymentDetail",
            path: "/common/applyPaymentDetail",
            hidden: true,
            name: "用款申请详情"
        }]
    }, {
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "发票管理",
        children: [{
            pageAddress: "fm/FmOutPutTicketDetail",
            path: "/fm/FmOutPutTicketDetail",
            hidden: true,
            name: "开票详情"
        }, {
            pageAddress: "fm/FmAddOutPutTicket",
            path: "/fm/FmAddOutPutTicket",
            hidden: true,
            name: "添加开票"
        }]
    }, {
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "授信管理",
        children: [{
            pageAddress: "commonPage/CreditDetail",
            path: "/common/creditDetail",
            hidden: true,
            component: "CreditDetail",
            name: "授信详情"
        }]
    }]

}, {
    path: '/p6',
    redirect: '/cm/pm/projectManagerList',
    component: "HomeView",
    name: '项目总监管理',
    parent: true,
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "项目总监",
        children: [{
            pageAddress: "cd/pmBlackDetail",
            path: "/cd/pm/pmBlackDetail",
            component: "pmBlackDetail",
            name: "项目总监详情",
            hidden: true
        }, {
            pageAddress: "cm/CMProjectManagerEditView",
            path: "/cm/pm/add",
            component: "CMProjectManagerEditView",
            name: "添加项目总监",
            hidden: true
        }, {
            pageAddress: "cm/CMProjectManagerEditView",
            path: "/cm/pm/edit",
            hidden: true,
            component: "CMProjectManagerEditView",
            name: "编辑项目总监"
        }, {
            pageAddress: "cm/CMProjectManagerReadView",
            path: "/cm/pm/read_view",
            hidden: true,
            component: "CMProjectManagerReadView",
            name: "项目总监信息(只读)"
        }, {
            pageAddress: "cm/CMIntroducerAddView",
            path: "/cm/introducer/edit",
            hidden: true,
            component: "CMIntroducerAddView",
            name: "介绍人编辑"
        }, {
            pageAddress: "cm/CMIntroducerInfoView",
            path: "/cm/introducer/info",
            hidden: true,
            component: "CMIntroducerInfoView",
            name: "查看介绍人"
        }, {
            pageAddress: "cm/CMIntroducerInfo",
            path: "/cm/introducer/infor",
            hidden: true,
            name: "项目总监关系管理详情"
        }, {
            pageAddress: "cd/CDProjectManagerEditView",
            path: "/cd/pm/edit",
            hidden: true,
            component: "CDProjectManagerEditView",
            name: "项目总监详情"
        }, {
            pageAddress: "cd/CDprojectInformation",
            path: "/cd/pm/projectInformation",
            hidden: true,
            component: "CDprojectInformation",
            name: "查看项目总监项目信息"
        }, {
            pageAddress: "cd/CDinterviewRecord",
            path: "/cm/pm/interviewRecord",
            hidden: true,
            component: "CDinterviewRecord",
            name: "项目总监管理---访谈记录"
        }, {
            pageAddress: "cd/CDprojectDirector",
            path: "/cm/pm/projectDirector",
            hidden: true,
            component: "CDprojectDirector",
            name: "查看项目总监"
        }, {
            pageAddress: "pm/pmComplaintList",
            path: "/pm/pmComplaintList",
            hidden: true,
            component: "pmComplaintList",
            name: "投诉处理"
        }, {
            pageAddress: "commonPage/pmManage/pmInterviewDetail",
            path: "/common/pmInterviewDetail",
            component: "pmInterviewDetail",
            hidden: true,
            name: "访谈记录详情"
        }, {
            pageAddress: "commonPage/pmManage/pmInterviewAdd",
            path: "/common/pmInterviewAdd",
            component: "pmInterviewAdd",
            hidden: true,
            name: "添加访谈记录"
        }]
    }]

}, {
    path: '/p8',
    redirect: '/user/index',
    component: "HomeView",
    name: '系统管理',
    parent: true,
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "账户设置",
        children: []
    }, {
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "通用设置",
        children: [{
            path: '/admin/SubCompanyInfo',
            component: "SubCompanyInfo",
            hidden: true,
            name: '新美子公司详情'
        }, {
            path: '/admin/SubCompanyEditView',
            component: "SubCompanyEditView",
            hidden: true,
            name: '编辑子公司'
        }]
    }, {
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "个人设置",
        children: []
    }]

}, {
    pageAddress: "commonPage/dataReport/printSettleForm",
    path: "/common/printSettleForm",
    component: "printSettleForm",
    hidden: true,
    name: "打印结算表"
}, {
    pageAddress: "commonPage/financeManage/NewXiangmushitu",
    path: "/common/New",
    hidden: true,
    name: "项目视图新建页面导出数据"
}, {
    pageAddress: "commonPage/financeManage/depositPrint",
    path: "/common/depositPrint",
    hidden: true,
    name: "打印物业押金"
}, {
    pageAddress: "commonPage/financeManage/marginPrint",
    path: "/common/marginPrint",
    hidden: true,
    name: "打印代付投标保证金"
}, {
    pageAddress: "commonPage/financeManage/materialPrint",
    path: "/common/materialPrint",
    hidden: true,
    name: "打印付款申请单"
}, {
    pageAddress: "commonPage/financeManage/serviceFeePrint",
    path: "/common/serviceFeePrint",
    hidden: true
}, {
    pageAddress: "commonPage/enginnerManage/finishProjectTable",
    path: "/common/finishProjectTable",
    component: "finishProjectTable",
    hidden: true
}, {
    pageAddress: "commonPage/enginnerManage/startProjectTable",
    path: "/common/startProjectTable",
    component: "startProjectTable",
    hidden: true
}, {
    pageAddress: "commonPage/enginnerManage/finishProjectTable",
    path: "/common/finishProjectTable",
    component: "finishProjectTable",
    hidden: true
}, {
    pageAddress: "commonPage/enginnerManage/constructionScoreDetail",
    path: "/common/constructionScoreDetail",
    component: "constructionScoreDetail",
    hidden: true
}, {
    pageAddress: "commonPage/enginnerManage/returnVisitTable",
    path: "/common/returnVisitTable",
    component: "returnVisitTable",
    hidden: true
}];

exports.default = menuAdmin;

/***/ }),

/***/ 862:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});


var menuBoss = [{
    path: '/p5',
    redirect: '/common/financeData',
    component: "HomeView",
    name: '财务管理',
    parent: true,
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "总表视图",
        children: [{
            pageAddress: "commonPage/dataReport/financeDataInfo",
            path: "/common/financeDataInfo",
            component: "financeDataInfo",
            hidden: true,
            name: "财务数据详情"
        }]
    }]

}, {
    path: '/p8',
    redirect: '/cm/information/changePW',
    component: "HomeView",
    name: '系统管理',
    parent: true,
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "个人设置",
        children: []
    }]

}, {
    pageAddress: "commonPage/dataReport/printSettleForm",
    path: "/common/printSettleForm",
    component: "printSettleForm",
    hidden: true,
    name: "打印结算表"
}];

exports.default = menuBoss;

/***/ }),

/***/ 863:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var menuBusinessAttache = [{
    path: '/p0',
    component: "HomeView",
    name: '营销管理',
    redirect: '/common/problemFeedbackList',
    parent: true,
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "反馈管理",
        children: [{
            path: "/common/problemFeedbackDetail",
            hidden: true,
            component: "ProblemFeedbackDetailView",
            name: "问题反馈详情"
        }]
    }]
}, {
    path: '/p6',
    component: "HomeView",
    name: '项目总监管理',
    redirect: '/ba/cm/projectManagerList',
    parent: true,
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "项目总监",
        children: [{
            pageAddress: "ba/BAProjectManagerEditView",
            path: "/ba/pm/add",
            component: "BAProjectManagerEditView",
            name: "添加项目总监",
            hidden: true
        }, {
            pageAddress: "ba/BAProjectManagerEditView",
            path: "/ba/pm/edit",
            hidden: true,
            component: "BAProjectManagerEditView",
            name: "编辑项目总监"
        }, {
            pageAddress: "bm/BMProjectManagerReadView",
            path: "/ba/pm/read_view",
            hidden: true,
            component: "BMProjectManagerReadView",
            name: "项目总监详情"
        }, {
            pageAddress: "ba/BAProjectManagerEditMoreView",
            path: "/ba/pm/editMore",
            hidden: true,
            component: "BAProjectManagerEditMoreView",
            name: "编辑项目总监更多信息"
        }]
    }]
}, {
    path: '/p8',
    redirect: '/me/change_password',
    component: "HomeView",
    name: '系统管理',
    parent: true,
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "个人设置",
        children: []
    }]

}];

exports.default = menuBusinessAttache;

/***/ }),

/***/ 864:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var menuBusinessManager = [{
    path: '/p0',
    component: "HomeView",
    name: '营销管理',
    redirect: '/common/problemFeedbackList',
    parent: true,
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "反馈管理",
        children: [{
            path: "/common/problemFeedbackDetail",
            hidden: true,
            component: "ProblemFeedbackDetailView",
            name: "问题反馈详情"
        }]
    }]
}, {
    path: '/p6',
    component: "HomeView",
    name: '项目总监管理',
    redirect: '/ba/cm/projectManagerList',
    parent: true,
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "项目总监",
        children: [{
            pageAddress: "ba/BAProjectManagerEditView",
            path: "/ba/pm/edit",
            hidden: true,
            component: "BAProjectManagerEditView",
            name: "编辑项目总监"
        }, {
            pageAddress: "bm/BMProjectManagerReadView",
            path: "/ba/pm/read_view",
            hidden: true,
            component: "BMProjectManagerReadView",
            name: "项目总监详情"
        }, {
            pageAddress: "bm/BMProjectManagerEditMoreView",
            path: "/bm/pm/editMore",
            hidden: true,
            component: "BMProjectManagerEditMoreView",
            name: "编辑项目总监更多信息"
        }, {
            pageAddress: "cm/CMIntroducerInfoView",
            path: "/cm/introducer/info",
            hidden: true,
            component: "CMIntroducerInfoView",
            name: "查看介绍人"
        }, {
            pageAddress: "cm/CMIntroducerInfo",
            path: "/cm/introducer/infor",
            hidden: true,
            name: "项目总监关系管理详情"
        }]
    }]
}, {
    path: '/p8',
    redirect: '/me/change_password',
    component: "HomeView",
    name: '系统管理',
    parent: true,
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "个人设置",
        children: []
    }]

}];

exports.default = menuBusinessManager;

/***/ }),

/***/ 865:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var menuChiefQualityOfficer = [{
    path: '/p0',
    component: "HomeView",
    name: '营销管理',
    redirect: '/common/injuriesList',
    parent: true,
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "公关管理",
        children: [{
            pageAddress: "commonPage/projectManage/injuriesDetail",
            path: "/common/injuriesDetail",
            component: "injuriesDetail",
            name: "事故详情",
            hidden: true
        }, {
            pageAddress: "commonPage/projectManage/injuriesModify",
            path: "/common/injuriesModify",
            component: "injuriesModify",
            name: "编辑事故详情",
            hidden: true
        }, {
            pageAddress: "commonPage/complaintManage/addComplainList",
            path: "/common/addComplainList",
            hidden: true,
            component: "addComplainList",
            name: "添加投诉"
        }, {
            pageAddress: "commonPage/complaintManage/complaintDetail",
            path: "/common/complaintDetail",
            hidden: true,
            component: "complaintDetail",
            name: "投诉详情"
        }]
    }]
}, {
    path: '/p8',
    redirect: '/user/index',
    component: "HomeView",
    name: '系统管理',
    parent: true,
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "账户设置",
        children: []
    }, {
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "个人设置",
        children: []
    }]

}, {
    pageAddress: "commonPage/dataReport/printSettleForm",
    path: "/common/printSettleForm",
    component: "printSettleForm",
    hidden: true,
    name: "打印结算表"
}, {
    pageAddress: "commonPage/enginnerManage/finishProjectTable",
    path: "/common/finishProjectTable",
    component: "finishProjectTable",
    hidden: true
}, {
    pageAddress: "commonPage/enginnerManage/startProjectTable",
    path: "/common/startProjectTable",
    component: "startProjectTable",
    hidden: true
}, {
    pageAddress: "commonPage/enginnerManage/finishProjectTable",
    path: "/common/finishProjectTable",
    component: "finishProjectTable",
    hidden: true
}, {
    pageAddress: "commonPage/enginnerManage/constructionScoreDetail",
    path: "/common/constructionScoreDetail",
    component: "constructionScoreDetail",
    hidden: true
}, {
    pageAddress: "commonPage/enginnerManage/returnVisitTable",
    path: "/common/returnVisitTable",
    component: "returnVisitTable",
    hidden: true
}];
exports.default = menuChiefQualityOfficer;

/***/ }),

/***/ 866:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});


var menuCm = [{
    path: '/p0',
    component: "HomeView",
    name: '营销管理',
    redirect: '/common/injuriesList',
    parent: true,
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "公关管理",
        children: [{
            pageAddress: "commonPage/projectManage/injuriesDetail",
            path: "/common/injuriesDetail",
            component: "injuriesDetail",
            name: "事故详情",
            hidden: true
        }, {
            pageAddress: "commonPage/projectManage/injuriesAdd",
            path: "/common/injuriesAdd",
            component: "injuriesAdd",
            name: "添加伤亡事故",
            hidden: true
        }, {
            pageAddress: "pm/pmInjuriesList",
            path: "/pm/pmInjuriesList",
            hidden: true,
            component: "pmInjuriesList",
            name: "伤亡事故"
        }, {
            pageAddress: "commonPage/complaintManage/addComplainList",
            path: "/common/addComplainList",
            hidden: true,
            component: "addComplainList",
            name: "添加投诉"
        }, {
            pageAddress: "commonPage/complaintManage/complaintDetail",
            path: "/common/complaintDetail",
            hidden: true,
            component: "complaintDetail",
            name: "投诉详情"
        }]
    }, {
        parent: true,
        component: "Navigation",
        redirect: '/common/problemFeedbackList',
        path: "/home",
        name: "反馈管理",
        children: [{
            path: "/common/problemFeedbackDetail",
            hidden: true,
            component: "ProblemFeedbackDetailView",
            name: "问题反馈详情"
        }]
    }]
}, {
    path: '/p4',
    redirect: '/common/materialList',
    component: "HomeView",
    name: '材料管理',
    parent: true,
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "代付材料",
        children: [{
            pageAddress: "commonPage/financeManage/addMargin",
            path: "/common/addMargin",
            hidden: true,
            name: "新增代付投标保证金申请"
        }, {
            pageAddress: "commonPage/financeManage/deposit",
            path: "/common/deposit",
            hidden: true,
            name: "新增代付物业押金"
        }, {
            pageAddress: "commonPage/financeManage/editDeposit",
            path: "/common/editDeposit",
            hidden: true,
            name: "编辑代付物业押金"
        }, {
            pageAddress: "commonPage/financeManage/depositDetail",
            path: "/common/depositDetail",
            hidden: true,
            name: "代付物业押金详情"
        }, {
            pageAddress: "commonPage/financeManage/editMargin",
            path: "/common/editMargin",
            hidden: true,
            name: "编辑代付投标保证金申请"
        }, {
            pageAddress: "commonPage/financeManage/marginDetail",
            path: "/common/marginDetail",
            hidden: true,
            name: "代付投标保证金申请详情"
        }, {
            pageAddress: "commonPage/financeManage/materialDetail",
            path: "/common/materialDetail",
            hidden: true,
            name: "代付材料申请详情"
        }, {
            pageAddress: "commonPage/financeManage/materialApply",
            path: "/common/materialApply",
            hidden: true,
            name: "编辑代付材料申请"
        }, {
            pageAddress: "commonPage/financeManage/purchaseDetail",
            path: "/common/purchaseDetail",
            hidden: true,
            name: "材料购销合同详情"
        }, {
            pageAddress: "commonPage/financeManage/purchaseApply",
            path: "/common/purchaseApply",
            hidden: true,
            name: "新增材料购销合同"
        }]
    }]

}, {
    path: '/p5',
    redirect: '/fm/FMStatProjectIndexView',
    component: "HomeView",
    name: '财务管理',
    parent: true,
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "总表视图",
        children: [{
            pageAddress: "fm/FMStatProjectReadView",
            path: "/fm/FMStatProjectReadView",
            hidden: true,
            name: "项目细节"
        }, {
            pageAddress: "fm/FMDeductionDetail",
            path: "/fm/FMDeductionDetail",
            hidden: true,
            name: "手动扣款详情"
        }]
    }, {
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "资金管理",
        children: [{
            pageAddress: "cm/CMFinanceIncomeEditView",
            path: "/cm/financeIncome/edit",
            hidden: true,
            name: "认领收款流水"
        }, {
            pageAddress: "cm/CMFinanceIncomeEditView",
            path: "/cm/financeIncome/edit",
            hidden: true,
            name: "重新认领收款流水"
        }, {
            pageAddress: "process/CommonFinanceIncomeReadView",
            path: "/cm/common/finance_income/read_view",
            hidden: true,
            name: "收款流水细节"
        }, {
            pageAddress: "commonPage/financeManage/servicePayApply",
            path: "/common/servicePayApply",
            hidden: true,
            name: "新增劳务支付"
        }, {
            pageAddress: "commonPage/financeManage/servicePayEdit",
            path: "/common/servicePayEdit",
            hidden: true,
            name: "编辑劳务支付"
        }, {
            pageAddress: "commonPage/financeManage/servicePayDetail",
            path: "/common/servicePayDetail",
            hidden: true,
            name: "劳务支付详情"
        }, {
            pageAddress: "commonPage/financeManage/applyPaymentDetail",
            path: "/common/applyPaymentDetail",
            hidden: true,
            name: "用款申请详情"
        }, {
            pageAddress: "cm/ApplyData/ApplyDataEditView01",
            path: "/cm/applyData/edit01",
            hidden: true,
            component: "ApplyDataEditView01",
            name: "盖章申请"
        }, {

            pageAddress: "cm/ApplyData/ApplyDataEditView02",
            path: "/cm/applyData/edit02",
            hidden: true,
            component: "ApplyDataEditView02",
            name: "发票申请"
        }, {
            pageAddress: "cm/ApplyData/ApplyDataEditView03",
            path: "/cm/applyData/edit03",
            hidden: true,
            component: "ApplyDataEditView03",
            name: "提现申请"
        }, {
            pageAddress: "cm/ApplyData/ApplyDataReadView03",
            path: "/cm/applyData/read03",
            hidden: true,
            component: "ApplyDataReadView03",
            name: "提现申请只读"
        }, {
            pageAddress: "cm/ApplyData/ApplyDataEditView04",
            path: "/cm/applyData/edit04",
            hidden: true,
            component: "ApplyDataEditView04",
            name: "代付材料申请"
        }, {
            pageAddress: "cm/ApplyData/ApplyDataEditView05",
            path: "/cm/applyData/edit05",
            hidden: true,
            component: "ApplyDataEditView05",
            name: "授信提额申请"
        }, {
            pageAddress: "fee/FeeApplicationView01",
            path: "/cm/fee/application01",
            hidden: true,
            component: "FeeApplicationView01",
            name: "联盟成员保证金"
        }, {
            pageAddress: "fee/FeeApplicationView02",
            path: "/cm/fee/application02",
            hidden: true,
            component: "FeeApplicationView02",
            name: "发票申请"
        }, {
            pageAddress: "fee/FeeApplicationView03",
            path: "/cm/fee/application03",
            hidden: true,
            component: "FeeApplicationView03",
            name: "发票项目总监签收单"
        }, {
            pageAddress: "fee/FeeApplicationView04",
            path: "/cm/fee/application04",
            hidden: true,
            component: "FeeApplicationView04",
            name: "发票客户签收单"
        }, {
            pageAddress: "fee/FeeApplicationView05",
            path: "/cm/fee/application05",
            hidden: true,
            component: "FeeApplicationView05",
            name: "设计费提现申请"
        }, {
            pageAddress: "fee/FeeApplicationView06",
            path: "/cm/fee/application06",
            hidden: true,
            component: "FeeApplicationView06",
            name: "用款申请"
        }, {
            pageAddress: "fee/FeeApplicationView07",
            path: "/cm/fee/application07",
            hidden: true,
            component: "FeeApplicationView07",
            name: "代付付款申请"
        }, {
            pageAddress: "fee/FeeApplicationView08",
            path: "/cm/fee/application08",
            hidden: true,
            component: "FeeApplicationView08",
            name: "项目保证金取款申请"
        }, {
            pageAddress: "fee/FeeApplicationView09",
            path: "/cm/fee/application09",
            hidden: true,
            component: "FeeApplicationView09",
            name: "投标保证金转入单"
        }, {
            pageAddress: "fee/FeeApplicationView10",
            path: "/cm/fee/application10",
            hidden: true,
            component: "FeeApplicationView10",
            name: "存留资金做保证金使用申请"
        }, {
            pageAddress: "fee/FeeApplicationView11",
            path: "/cm/fee/application11",
            hidden: true,
            component: "FeeApplicationView11",
            name: "投标保证金退款申请"
        }, {
            pageAddress: "fee/FeeApplicationView12",
            path: "/cm/fee/application12",
            hidden: true,
            component: "FeeApplicationView12",
            name: "商业保函申请"
        }, {
            pageAddress: "fee/FeeApplicationView13",
            path: "/cm/fee/application13",
            hidden: true,
            component: "FeeApplicationView13",
            name: "商业保函费用转入单"
        }, {
            pageAddress: "fee/FeeApplicationView14",
            path: "/cm/fee/application14",
            hidden: true,
            component: "FeeApplicationView14",
            name: "存留资金做商业保函费使用申请"
        }, {
            pageAddress: "fee/FeeApplicationView15",
            path: "/cm/fee/application15",
            hidden: true,
            component: "FeeApplicationView15",
            name: "商业保函项目总监领取单"
        }, {
            pageAddress: "fee/FeeApplicationView16",
            path: "/cm/fee/application16",
            hidden: true,
            component: "FeeApplicationView16",
            name: "商业保函客户领取单"
        }, {
            pageAddress: "fee/FeeApplicationView17",
            path: "/cm/fee/application17",
            hidden: true,
            component: "FeeApplicationView17",
            name: "工程保证金转入单"
        }, {
            pageAddress: "fee/FeeApplicationView18",
            path: "/cm/fee/application18",
            hidden: true,
            component: "FeeApplicationView18",
            name: "存留资金做工程保证金使用申请"
        }, {
            pageAddress: "fee/FeeApplicationView19",
            path: "/cm/fee/application19",
            hidden: true,
            component: "FeeApplicationView19",
            name: "工程保证金退款申请"
        }, {
            pageAddress: "fee/FeeApplicationView20",
            path: "/cm/fee/application20",
            hidden: true,
            component: "FeeApplicationView20",
            name: "外经证申请"
        }, {
            pageAddress: "fee/FeeApplicationView21",
            path: "/cm/fee/application21",
            hidden: true,
            component: "FeeApplicationView21",
            name: "项目间转账申请"
        }, {
            pageAddress: "fee/FeeApplicationView22",
            path: "/cm/fee/application22",
            hidden: true,
            component: "FeeApplicationView22",
            name: "盖章申请"
        }, {
            pageAddress: "fee/FeeApplicationView23",
            path: "/cm/fee/application23",
            hidden: true,
            component: "FeeApplicationView23",
            name: "临时扣项增项"
        }, {
            pageAddress: "cm/CMFeeApplicationView24",
            path: "/cm/fee/application24",
            hidden: true,
            component: "CMFeeApplicationView24",
            name: "银行收款流水"
        }]
    }, {
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "发票管理",
        children: [{
            pageAddress: "fm/FmOutPutTicketDetail",
            path: "/fm/FmOutPutTicketDetail",
            hidden: true,
            name: "开票详情"
        }, {
            pageAddress: "fm/FmAddOutPutTicket",
            path: "/fm/FmAddOutPutTicket",
            hidden: true,
            name: "添加开票"
        }, {
            pageAddress: "fm/FmEditOutPutTicket",
            path: "/fm/FmEditOutPutTicket",
            hidden: true,
            name: "编辑开票"
        }]
    }, {
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "授信管理",
        children: [{
            pageAddress: "commonPage/CreditDetail",
            path: "/common/creditDetail",
            hidden: true,
            component: "CreditDetail",
            name: "授信详情"
        }]
    }]

}, {
    path: '/p6',
    redirect: '/ba/cm/projectManagerList',
    component: "HomeView",
    name: '项目总监管理',
    parent: true,
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "项目总监",
        children: [{
            pageAddress: "ba/BAProjectManagerEditView",
            path: "/ba/pm/edit",
            hidden: true,
            component: "BAProjectManagerEditView",
            name: "编辑项目总监"
        }, {
            pageAddress: "cd/CDprojectDirector",
            path: "/cm/pm/projectDirector",
            hidden: true,
            component: "CDprojectDirector",
            name: "查看项目总监"
        }, {
            pageAddress: "cd/CDProjectManagerEditView",
            path: "/cd/pm/edit",
            hidden: true,
            component: "CDProjectManagerEditView",
            name: "项目总监详情"
        }, {
            pageAddress: "cm/CMIntroducerAddView",
            path: "/cm/introducer/edit",
            hidden: true,
            component: "CMIntroducerAddView",
            name: "介绍人编辑"
        }, {
            pageAddress: "cm/CMIntroducerInfoView",
            path: "/cm/introducer/info",
            hidden: true,
            component: "CMIntroducerInfoView",
            name: "查看介绍人"
        }, {
            pageAddress: "cm/CMIntroducerInfo",
            path: "/cm/introducer/infor",
            hidden: true,
            name: "项目总监关系管理详情"
        }, {
            pageAddress: "cd/CDprojectInformation",
            path: "/cd/pm/projectInformation",
            hidden: true,
            component: "CDprojectInformation",
            name: "查看项目总监项目信息"
        }, {
            pageAddress: "cd/CDinterviewRecord",
            path: "/cm/pm/interviewRecord",
            hidden: true,
            component: "CDinterviewRecord",
            name: "项目总监管理---访谈记录"
        }, {
            pageAddress: "pm/pmComplaintList",
            path: "/pm/pmComplaintList",
            hidden: true,
            component: "pmComplaintList",
            name: "投诉处理"
        }, {
            pageAddress: "commonPage/pmManage/pmInterviewDetail",
            path: "/common/pmInterviewDetail",
            component: "pmInterviewDetail",
            hidden: true,
            name: "访谈记录详情"
        }, {
            pageAddress: "commonPage/pmManage/pmInterviewAdd",
            path: "/common/pmInterviewAdd",
            component: "pmInterviewAdd",
            hidden: true,
            name: "添加访谈记录"
        }, {
            pageAddress: "cd/pmBlackDetail",
            path: "/cd/pm/pmBlackDetail",
            component: "pmBlackDetail",
            name: "项目总监详情",
            hidden: true
        }]
    }]

}, {
    path: '/p8',
    redirect: '/cm/information/changePW',
    component: "HomeView",
    name: '系统管理',
    parent: true,
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "个人设置",
        children: []
    }]

}, {
    pageAddress: "fm/printOutPutTicket",
    path: "/common/printOutPutTicket",
    component: "printOutPutTicket",
    hidden: true,
    name: "打印销项票"
}, {
    pageAddress: "commonPage/dataReport/printSettleForm",
    path: "/common/printSettleForm",
    component: "printSettleForm",
    hidden: true,
    name: "打印结算表"
}, {
    pageAddress: "commonPage/financeManage/NewXiangmushitu",
    path: "/common/New",
    hidden: true,
    name: "项目视图新建页面导出数据"
}, {
    pageAddress: "commonPage/financeManage/depositPrint",
    path: "/common/depositPrint",
    hidden: true,
    name: "打印物业押金"
}, {
    pageAddress: "commonPage/financeManage/marginPrint",
    path: "/common/marginPrint",
    hidden: true,
    name: "打印代付投标保证金"
}, {
    pageAddress: "commonPage/financeManage/materialPrint",
    path: "/common/materialPrint",
    hidden: true,
    name: "打印付款申请单"
}, {
    pageAddress: "commonPage/financeManage/serviceFeePrint",
    path: "/common/serviceFeePrint",
    hidden: true
}];

exports.default = menuCm;

/***/ }),

/***/ 867:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});


var menuCmDirector = [{
    path: '/p0',
    component: "HomeView",
    name: '营销管理',
    redirect: '/common/injuriesList',
    parent: true,
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "公关管理",
        children: [{
            pageAddress: "commonPage/projectManage/injuriesDetail",
            path: "/common/injuriesDetail",
            component: "injuriesDetail",
            name: "事故详情",
            hidden: true
        }, {
            pageAddress: "commonPage/projectManage/injuriesModify",
            path: "/common/injuriesModify",
            component: "injuriesModify",
            name: "编辑事故详情",
            hidden: true
        }, {
            pageAddress: "commonPage/complaintManage/addComplainList",
            path: "/common/addComplainList",
            hidden: true,
            component: "addComplainList",
            name: "添加投诉"
        }, {
            pageAddress: "commonPage/complaintManage/complaintDetail",
            path: "/common/complaintDetail",
            hidden: true,
            component: "complaintDetail",
            name: "投诉详情"
        }]
    }, {
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "反馈管理",
        children: [{
            path: "/common/problemFeedbackDetail",
            hidden: true,
            component: "ProblemFeedbackDetailView",
            name: "问题反馈详情"
        }]
    }]
}, {
    path: '/p4',
    component: "HomeView",
    name: '材料管理',
    redirect: '/common/materialList',
    parent: true,
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "代付材料",
        children: [{
            pageAddress: "commonPage/financeManage/materialDetail",
            path: "/common/materialDetail",
            hidden: true,
            name: "代付材料申请详情"
        }, {
            pageAddress: "commonPage/financeManage/purchaseDetail",
            path: "/common/purchaseDetail",
            hidden: true,
            name: "材料购销合同详情"
        }, {
            pageAddress: "commonPage/financeManage/purchaseApply",
            path: "/common/purchaseApply",
            hidden: true,
            name: "新增材料购销合同"
        }]
    }]
}, {
    path: '/p5',
    component: "HomeView",
    name: '财务管理',
    redirect: '/fm/FMStatProjectIndexView',
    parent: true,
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "总表视图",
        children: []
    }, {
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "资金管理",
        children: [{
            pageAddress: "process/CommonFinanceIncomeReadView",
            path: "/cm/common/finance_income/read_view",
            hidden: true,
            name: "收款流水细节"
        }, {
            pageAddress: "commonPage/financeManage/servicePayDetail",
            path: "/common/servicePayDetail",
            hidden: true,
            name: "劳务支付详情"
        }, {
            pageAddress: "fm/FMDeductionDetail",
            path: "/fm/FMDeductionDetail",
            hidden: true,
            name: "手动扣款详情"
        }, {
            pageAddress: "fm/FMStatProjectReadView",
            path: "/fm/FMStatProjectReadView",
            hidden: true,
            name: "项目细节"
        }, {
            pageAddress: "commonPage/financeManage/applyPaymentDetail",
            path: "/common/applyPaymentDetail",
            hidden: true,
            name: "用款申请详情"
        }]
    }, {
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "授信管理",
        children: [{
            pageAddress: "commonPage/CreditDetail",
            path: "/common/creditDetail",
            hidden: true,
            component: "CreditDetail",
            name: "授信详情"
        }]
    }]
}, {
    path: '/p6',
    component: "HomeView",
    name: '项目总监管理',
    redirect: '/ba/cm/projectManagerList',
    parent: true,
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "项目总监",
        children: [{
            pageAddress: "cd/CDprojectDirector",
            path: "/cm/pm/projectDirector",
            hidden: true,
            component: "CDprojectDirector",
            name: "查看项目总监"
        }, {
            pageAddress: "cd/CDProjectManagerEditView",
            path: "/cd/pm/edit",
            hidden: true,
            component: "CDProjectManagerEditView",
            name: "项目总监详情"
        }, {
            pageAddress: "cd/CDinterviewRecord",
            path: "/cm/pm/interviewRecord",
            hidden: true,
            component: "CDinterviewRecord",
            name: "项目总监管理---访谈记录"
        }, {
            pageAddress: "cd/CDprojectInformation",
            path: "/cd/pm/projectInformation",
            hidden: true,
            component: "CDprojectInformation",
            name: "查看项目总监项目信息"
        }, {
            pageAddress: "commonPage/pmManage/pmInterviewDetail",
            path: "/common/pmInterviewDetail",
            component: "pmInterviewDetail",
            hidden: true,
            name: "访谈记录详情"
        }, {
            pageAddress: "cd/pmBlackDetail",
            path: "/cd/pm/pmBlackDetail",
            component: "pmBlackDetail",
            name: "项目总监详情",
            hidden: true
        }, {
            pageAddress: "cm/CMIntroducerInfo",
            path: "/cm/introducer/infor",
            hidden: true,
            name: "项目总监关系管理详情"
        }, {
            pageAddress: "cd/CDIntroducerInfoView",
            path: "/cd/introducer/info",
            hidden: true,
            component: "CDIntroducerInfoView",
            name: "联盟团队详情"
        }, {
            pageAddress: "pm/pmInjuriesList",
            path: "/pm/pmInjuriesList",
            hidden: true,
            component: "pmInjuriesList",
            name: "伤亡事故"
        }, {
            pageAddress: "pm/pmComplaintList",
            path: "/pm/pmComplaintList",
            hidden: true,
            component: "pmComplaintList",
            name: "投诉处理"
        }]
    }]
}, {
    path: '/p8',
    redirect: '/user/index',
    component: "HomeView",
    name: '系统管理',
    parent: true,
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "账户设置",
        children: [{
            pageAddress: "commonPage/AccountDetail",
            path: "/UserIndexView/detail",
            hidden: true,
            component: "AccountDetail",
            name: "员工账号详情"
        }]
    }, {
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "个人设置",
        children: []
    }]

}, {
    pageAddress: "commonPage/dataReport/printSettleForm",
    path: "/common/printSettleForm",
    component: "printSettleForm",
    hidden: true,
    name: "打印结算表"
}, {
    pageAddress: "commonPage/financeManage/NewXiangmushitu",
    path: "/common/New",
    hidden: true,
    name: "项目视图新建页面导出数据"
}, {
    pageAddress: "commonPage/financeManage/materialPrint",
    path: "/common/materialPrint",
    hidden: true,
    name: "打印付款申请单"
}];

exports.default = menuCmDirector;

/***/ }),

/***/ 868:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});


var menuCommonAccounting = [{
    path: '/p4',
    redirect: '/common/materialList',
    component: "HomeView",
    name: '材料管理',
    parent: true,
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "代付材料",
        children: [{
            pageAddress: "commonPage/financeManage/materialDetail",
            path: "/common/materialDetail",
            hidden: true,
            name: "代付材料申请详情"
        }, {
            pageAddress: "commonPage/financeManage/marginDetail",
            path: "/common/marginDetail",
            hidden: true,
            name: "代付投标保证金申请详情"
        }, {
            pageAddress: "commonPage/financeManage/depositDetail",
            path: "/common/depositDetail",
            hidden: true,
            name: "代付物业押金申请详情"
        }, {
            pageAddress: "commonPage/financeManage/purchaseDetail",
            path: "/common/purchaseDetail",
            hidden: true,
            name: "材料购销合同详情"
        }, {
            pageAddress: "commonPage/financeManage/purchaseApply",
            path: "/common/purchaseApply",
            hidden: true,
            name: "新增材料购销合同"
        }, {
            pageAddress: "fm/FMStatProjectReadView",
            path: "/fm/FMStatProjectReadView",
            hidden: true,
            name: "项目细节"
        }]
    }, {
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "众惠材料",
        children: []
    }]

}, {
    path: '/p5',
    component: "HomeView",
    name: '财务管理',
    redirect: '/common/financeData',
    parent: true,
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "总表视图",
        children: [{
            pageAddress: "commonPage/dataReport/financeDataInfo",
            path: "/common/financeDataInfo",
            component: "financeDataInfo",
            hidden: true,
            name: "财务数据详情"
        }]
    }, {
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "资金管理",
        children: [{
            pageAddress: "fm/FMFinanceIncomeEditView",
            path: "/fm/financeIncome/edit",
            hidden: true,
            name: "收款流水细节"
        }, {
            pageAddress: "fm/FMFinanceIncomeReadView",
            path: "/fm/financeIncome/read",
            hidden: true,
            name: "流水信息"
        }, {
            pageAddress: "commonPage/financeManage/servicePayEdit",
            path: "/common/servicePayEdit",
            hidden: true,
            name: "编辑劳务支付"
        }, {
            pageAddress: "commonPage/financeManage/servicePayDetail",
            path: "/common/servicePayDetail",
            hidden: true,
            name: "劳务支付详情"
        }, {
            pageAddress: "fm/FMDeductionDetail",
            path: "/fm/FMDeductionDetail",
            hidden: true,
            name: "手动扣款详情"
        }, {
            pageAddress: "fm/FMAddDeduction",
            path: "/fm/FMAddDeduction",
            hidden: true,
            name: "添加手动扣款"
        }, {
            pageAddress: "fm/FMStatProjectReadView",
            path: "/fm/FMStatProjectReadView",
            hidden: true,
            name: "项目细节"
        }, {
            pageAddress: "commonPage/financeManage/applyPaymentDetail",
            path: "/common/applyPaymentDetail",
            hidden: true,
            name: "用款申请详情"
        }]
    }, {
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "发票管理",
        children: [{
            pageAddress: "fm/FmOutPutTicketDetail",
            path: "/fm/FmOutPutTicketDetail",
            hidden: true,
            name: "开票详情"
        }]
    }]
}, {
    path: '/p8',
    redirect: '/cm/information/changePW',
    component: "HomeView",
    name: '系统管理',
    parent: true,
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "个人设置",
        children: []
    }]

}, {
    pageAddress: "commonPage/dataReport/printSettleForm",
    path: "/common/printSettleForm",
    component: "printSettleForm",
    hidden: true,
    name: "打印结算表"
}, {
    pageAddress: "commonPage/financeManage/NewXiangmushitu",
    path: "/common/New",
    hidden: true,
    name: "项目视图新建页面导出数据"
}, {
    pageAddress: "commonPage/financeManage/depositPrint",
    path: "/common/depositPrint",
    hidden: true,
    name: "打印物业押金"
}, {
    pageAddress: "commonPage/financeManage/marginPrint",
    path: "/common/marginPrint",
    hidden: true,
    name: "打印代付投标保证金"
}, {
    pageAddress: "commonPage/financeManage/materialPrint",
    path: "/common/materialPrint",
    hidden: true,
    name: "打印付款申请单"
}, {
    pageAddress: "commonPage/financeManage/serviceFeePrint",
    path: "/common/serviceFeePrint",
    hidden: true
}];

exports.default = menuCommonAccounting;

/***/ }),

/***/ 869:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var menuDevtest = [{
    path: '/',
    component: "HomeView",
    name: '测试组件',
    parent: true,
    children: [{
        pageAddress: "devtest/TestNewSelectOrCreateBankWidget",
        path: '/devtest/TestNewSelectOrCreateBankWidget/index',
        name: '新版银行选择组件'
    }, {
        pageAddress: "devtest/TestNewSelectOperationWidget",
        path: '/devtest/TestNewSelectOperationWidget/index',
        name: '新版选择子公司和运营中心'
    }, {
        pageAddress: "devtest/TestUploadIdCard",
        path: '/devtest/TestUploadIdCard/index',
        name: '身份证上传'
    }, {
        pageAddress: "devtest/TestCompanySelectWidget",
        path: '/devtest/TestCompanySelectWidget/index',
        name: '甲方公司选择组件'
    }, {
        pageAddress: "devtest/TestDistrictIndex",
        path: '/devtest/TestDistrictIndex/index',
        name: '选择地址组件'
    }, {
        pageAddress: "devtest/TestFileAttachUpload",
        path: '/devtest/TestFileAttachUpload/index',
        name: '上传图片组件'
    }, {
        pageAddress: "devtest/TestProjectSelectWidget",
        path: '/devtest/TestProjectSelectWidget/index',
        name: '选择项目组件'
    }, {
        pageAddress: "devtest/TestBackUserSelectWidget",
        path: '/devtest/TestBackUserSelectWidget/index',
        name: '选择用户组件'
    }, {
        pageAddress: "devtest/TestBankInfoSelectOrCreateWidget",
        path: '/devtest/TestBankInfoSelectOrCreateWidget/index',
        name: '选择银行以及分行组件'
    }, {
        pageAddress: "devtest/TestBusinessIntroducerSelectOrCreateWidget",
        path: '/devtest/TestBusinessIntroducerSelectOrCreateWidget/index',
        name: '选择业务介绍人'
    }, {
        pageAddress: "devtest/TestChiefInspSelectWidget",
        path: '/devtest/TestChiefInspSelectWidget/index',
        name: '选择项目总监'
    }, {
        pageAddress: "devtest/TestContractSelectWidget",
        path: '/devtest/TestContractSelectWidget/index',
        name: '选择合同'
    }, {
        pageAddress: "devtest/TestCustomerSelectOrCreateWidget",
        path: '/devtest/TestCustomerSelectOrCreateWidget/index',
        name: '选择客户'
    }, {
        pageAddress: "devtest/TestDModal",
        path: '/devtest/TestDModal/index',
        name: '模态框组件'
    }, {
        pageAddress: "devtest/TestEngineering",
        path: '/devtest/TestEngineering/index',
        name: '工装类型'
    }, {
        pageAddress: "devtest/TestOperationCenterSelectOrCreateWidget",
        path: '/devtest/TestOperationCenterSelectOrCreateWidget/index',
        name: '选择运营中心组件'
    }, {
        pageAddress: "devtest/TestManContractSelectWidget",
        path: '/devtest/TestManContractSelectWidget/index',
        name: '选择主合同组件'
    }, {
        pageAddress: "devtest/TestDColumnAmount",
        path: '/devtest/TestDColumnAmount/index',
        name: '加减输入框'
    }, {
        pageAddress: "devtest/TestDColumnDatePicker",
        path: '/devtest/TestDColumnDatePicker/index',
        name: '日期选择组件'
    }, {
        pageAddress: "devtest/TestDColumnChooseXmCompany",
        path: '/devtest/TestDColumnChooseXmCompany/index',
        name: '新美子公司'
    }, {
        pageAddress: "devtest/TestFileUploadWidget",
        path: '/devtest/FileUploadWidget/index',
        name: '新版上传组件'
    }]
}, {
    path: '/',
    component: "HomeView",
    name: '原型页面',
    parent: true,
    children: [{
        pageAddress: "devtest/ProtoMessageBox",
        path: '/devtest/ProtoMessageBox/index',
        name: '消息框'
    }, {
        pageAddress: "devtest/ProtoSelectBank",
        path: '/devtest/ProtoSelectBank/index',
        name: '选择银行'
    }, {
        pageAddress: "devtest/ProtoSelectCompanyAndOperations",
        path: '/devtest/ProtoSelectCompanyAndOperations/index',
        name: '选择公司和运营中心'
    }, {
        pageAddress: "devtest/ProtoUploadIdCard",
        path: '/devtest/ProtoUploadIdCard/index',
        name: '上传身份证'
    }]
}];

exports.default = menuDevtest;

/***/ }),

/***/ 870:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});


var menuDxmbzjl = [{
    path: '/p8',
    redirect: '/user/index',
    component: "HomeView",
    name: '系统管理',
    parent: true,
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "个人设置",
        children: []
    }]

}, {
    pageAddress: "commonPage/dataReport/printSettleForm",
    path: "/common/printSettleForm",
    component: "printSettleForm",
    hidden: true,
    name: "打印结算表"
}, {
    pageAddress: "commonPage/financeManage/NewXiangmushitu",
    path: "/common/New",
    hidden: true,
    name: "项目视图新建页面导出数据"
}, {
    pageAddress: "commonPage/financeManage/depositPrint",
    path: "/common/depositPrint",
    hidden: true,
    name: "打印物业押金"
}, {
    pageAddress: "commonPage/financeManage/marginPrint",
    path: "/common/marginPrint",
    hidden: true,
    name: "打印代付投标保证金"
}, {
    pageAddress: "commonPage/financeManage/materialPrint",
    path: "/common/materialPrint",
    hidden: true,
    name: "打印付款申请单"
}, {
    pageAddress: "commonPage/financeManage/serviceFeePrint",
    path: "/common/serviceFeePrint",
    hidden: true
}, {
    pageAddress: "commonPage/enginnerManage/finishProjectTable",
    path: "/common/finishProjectTable",
    component: "finishProjectTable",
    hidden: true
}, {
    pageAddress: "commonPage/enginnerManage/startProjectTable",
    path: "/common/startProjectTable",
    component: "startProjectTable",
    hidden: true
}, {
    pageAddress: "commonPage/enginnerManage/finishProjectTable",
    path: "/common/finishProjectTable",
    component: "finishProjectTable",
    hidden: true
}, {
    pageAddress: "commonPage/enginnerManage/constructionScoreDetail",
    path: "/common/constructionScoreDetail",
    component: "constructionScoreDetail",
    hidden: true
}, {
    pageAddress: "commonPage/enginnerManage/returnVisitTable",
    path: "/common/returnVisitTable",
    component: "returnVisitTable",
    hidden: true
}];

exports.default = menuDxmbzjl;

/***/ }),

/***/ 871:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});


var menuFinance = [{
    path: '/p4',
    redirect: '/common/materialList',
    component: "HomeView",
    name: '材料管理',
    parent: true,
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "代付材料",
        children: [{
            pageAddress: "commonPage/financeManage/materialDetail",
            path: "/common/materialDetail",
            hidden: true,
            name: "代付材料申请详情"
        }, {
            pageAddress: "commonPage/financeManage/marginDetail",
            path: "/common/marginDetail",
            hidden: true,
            name: "代付投标保证金申请详情"
        }, {
            pageAddress: "commonPage/financeManage/depositDetail",
            path: "/common/depositDetail",
            hidden: true,
            name: "代付物业押金申请详情"
        }, {
            pageAddress: "commonPage/financeManage/purchaseDetail",
            path: "/common/purchaseDetail",
            hidden: true,
            name: "材料购销合同详情"
        }, {
            pageAddress: "commonPage/financeManage/purchaseApply",
            path: "/common/purchaseApply",
            hidden: true,
            name: "新增材料购销合同"
        }, {
            pageAddress: "fm/FMStatProjectReadView",
            path: "/fm/FMStatProjectReadView",
            hidden: true,
            name: "项目细节"
        }]
    }, {
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "众惠材料",
        children: []
    }]

}, {
    path: '/p5',
    component: "HomeView",
    name: '财务管理',
    redirect: '/fm/FMStatProjectIndexView',
    parent: true,
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "总表视图",
        children: [{
            pageAddress: "commonPage/dataReport/financeDataInfo",
            path: "/common/financeDataInfo",
            component: "financeDataInfo",
            hidden: true,
            name: "财务数据详情"
        }]
    }, {
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "资金管理",
        children: [{
            pageAddress: "finance/FinanceFinanceIncomeEditView",
            path: "/finance/financeIncome/edit",
            hidden: true,
            name: "编辑收款流水"
        }, {
            pageAddress: "finance/FinanceXmFinanceItemEditView",
            path: "/finance/FinanceXmFinanceItemEditView",
            hidden: true,
            name: "编辑退预缴录入"
        }, {
            pageAddress: "process/CommonFinanceIncomeReadView",
            path: "/process/common/finance_income/read_view",
            hidden: true,
            name: "收款流水细节"
        }, {
            pageAddress: "commonPage/financeManage/servicePayDetail",
            path: "/common/servicePayDetail",
            hidden: true,
            name: "劳务支付详情"
        }]
    }]
}, {
    path: '/p8',
    redirect: '/cm/information/changePW',
    component: "HomeView",
    name: '系统管理',
    parent: true,
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "个人设置",
        children: []
    }]

}, {
    pageAddress: "commonPage/dataReport/printSettleForm",
    path: "/common/printSettleForm",
    component: "printSettleForm",
    hidden: true,
    name: "打印结算表"
}, {
    pageAddress: "commonPage/financeManage/NewXiangmushitu",
    path: "/common/New",
    hidden: true,
    name: "项目视图新建页面导出数据"
}, {
    pageAddress: "commonPage/financeManage/depositPrint",
    path: "/common/depositPrint",
    hidden: true,
    name: "打印物业押金"
}, {
    pageAddress: "commonPage/financeManage/marginPrint",
    path: "/common/marginPrint",
    hidden: true,
    name: "打印代付投标保证金"
}, {
    pageAddress: "commonPage/financeManage/materialPrint",
    path: "/common/materialPrint",
    hidden: true,
    name: "打印付款申请单"
}, {
    pageAddress: "commonPage/financeManage/serviceFeePrint",
    path: "/common/serviceFeePrint",
    hidden: true
}];

exports.default = menuFinance;

/***/ }),

/***/ 872:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});


var menuFinanceDirector = [{
    path: '/p4',
    redirect: '/common/materialList',
    component: "HomeView",
    name: '材料管理',
    parent: true,
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "代付材料",
        children: [{
            pageAddress: "commonPage/financeManage/materialDetail",
            path: "/common/materialDetail",
            hidden: true,
            name: "代付材料申请详情"
        }, {
            pageAddress: "commonPage/financeManage/purchaseDetail",
            path: "/common/purchaseDetail",
            hidden: true,
            name: "材料购销合同详情"
        }]
    }, {
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "众惠材料",
        children: []
    }]

}, {
    path: '/p5',
    redirect: '/fm/FMStatProjectIndexView',
    component: "HomeView",
    name: '财务管理',
    parent: true,
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "总表视图",
        children: [{
            pageAddress: "commonPage/dataReport/financeDataInfo",
            path: "/common/financeDataInfo",
            component: "financeDataInfo",
            hidden: true,
            name: "财务数据详情"
        }, {
            pageAddress: "fm/FMStatProjectReadView",
            path: "/fm/FMStatProjectReadView",
            hidden: true,
            name: "项目细节"
        }]
    }, {
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "资金管理",
        children: [{
            pageAddress: "fm/FMFinanceIncomeReadView",
            path: "/fm/financeIncome/read",
            hidden: true,
            name: "流水信息"
        }, {
            pageAddress: "commonPage/financeManage/applyPaymentDetail",
            path: "/common/applyPaymentDetail",
            hidden: true,
            name: "用款申请详情"
        }]
    }, {
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "发票管理",
        children: [{
            pageAddress: "fm/FmOutPutTicketDetail",
            path: "/fm/FmOutPutTicketDetail",
            hidden: true,
            name: "开票详情"
        }, {
            pageAddress: "fm/FmAddOutPutTicket",
            path: "/fm/FmAddOutPutTicket",
            hidden: true,
            name: "添加开票"
        }]
    }]

}, {
    path: '/p8',
    redirect: '/user/index',
    component: "HomeView",
    name: '系统管理',
    parent: true,
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "账户设置",
        children: []
    }, {
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "个人设置",
        children: []
    }]

}, {
    pageAddress: "commonPage/dataReport/printSettleForm",
    path: "/common/printSettleForm",
    component: "printSettleForm",
    hidden: true,
    name: "打印结算表"
}, {
    pageAddress: "commonPage/financeManage/NewXiangmushitu",
    path: "/common/New",
    hidden: true,
    name: "项目视图新建页面导出数据"
}];

exports.default = menuFinanceDirector;

/***/ }),

/***/ 873:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});


var menuFinanceManager = [{
    path: '/p4',
    redirect: '/common/materialList',
    component: "HomeView",
    name: '材料管理',
    parent: true,
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "代付材料",
        children: [{
            pageAddress: "commonPage/financeManage/materialDetail",
            path: "/common/materialDetail",
            hidden: true,
            name: "代付材料申请详情"
        }, {
            pageAddress: "commonPage/financeManage/marginDetail",
            path: "/common/marginDetail",
            hidden: true,
            name: "代付投标保证金申请详情"
        }, {
            pageAddress: "commonPage/financeManage/depositDetail",
            path: "/common/depositDetail",
            hidden: true,
            name: "代付物业押金详情"
        }, {
            pageAddress: "commonPage/financeManage/purchaseDetail",
            path: "/common/purchaseDetail",
            hidden: true,
            name: "材料购销合同详情"
        }, {
            pageAddress: "commonPage/financeManage/purchaseApply",
            path: "/common/purchaseApply",
            hidden: true,
            name: "新增材料购销合同"
        }]
    }, {
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "众惠材料",
        children: []
    }]

}, {
    path: '/p5',
    redirect: '/fm/FMStatProjectIndexView',
    component: "HomeView",
    name: '财务管理',
    parent: true,
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "总表视图",
        children: [{
            pageAddress: "commonPage/dataReport/financeDataInfo",
            path: "/common/financeDataInfo",
            component: "financeDataInfo",
            hidden: true,
            name: "财务数据详情"
        }]
    }, {
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "资金管理",
        children: [{
            pageAddress: "fm/FMFinanceIncomeEditView",
            path: "/fm/financeIncome/edit",
            hidden: true,
            name: "收款流水细节"
        }, {
            pageAddress: "fm/FMFinanceIncomeReadView",
            path: "/fm/financeIncome/read",
            hidden: true,
            name: "流水信息"
        }, {
            pageAddress: "commonPage/financeManage/servicePayEdit",
            path: "/common/servicePayEdit",
            hidden: true,
            name: "编辑劳务支付"
        }, {
            pageAddress: "commonPage/financeManage/servicePayDetail",
            path: "/common/servicePayDetail",
            hidden: true,
            name: "劳务支付详情"
        }, {
            pageAddress: "fm/FMDeductionDetail",
            path: "/fm/FMDeductionDetail",
            hidden: true,
            name: "手动扣款详情"
        }, {
            pageAddress: "fm/FMAddDeduction",
            path: "/fm/FMAddDeduction",
            hidden: true,
            name: "添加手动扣款"
        }, {
            pageAddress: "fm/FMStatProjectReadView",
            path: "/fm/FMStatProjectReadView",
            hidden: true,
            name: "项目细节"
        }, {
            pageAddress: "commonPage/financeManage/applyPaymentDetail",
            path: "/common/applyPaymentDetail",
            hidden: true,
            name: "用款申请详情"
        }]
    }, {
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "发票管理",
        children: [{
            pageAddress: "fm/FmOutPutTicketDetail",
            path: "/fm/FmOutPutTicketDetail",
            hidden: true,
            name: "开票详情"
        }, {
            pageAddress: "fm/FmAddOutPutTicket",
            path: "/fm/FmAddOutPutTicket",
            hidden: true,
            name: "添加开票"
        }]
    }]

}, {
    path: '/p8',
    redirect: '/pm/personaldata/changePassWord',
    component: "HomeView",
    name: '系统管理',
    parent: true,
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "个人设置",
        children: []
    }]

}, {
    pageAddress: "fm/printOutPutTicket",
    path: "/common/printOutPutTicket",
    component: "printOutPutTicket",
    hidden: true,
    name: "打印销项票"
}, {
    pageAddress: "commonPage/dataReport/printSettleForm",
    path: "/common/printSettleForm",
    component: "printSettleForm",
    hidden: true,
    name: "打印结算表"
}, {
    pageAddress: "commonPage/financeManage/NewXiangmushitu",
    path: "/common/New",
    hidden: true,
    name: "项目视图新建页面导出数据"
}, {
    pageAddress: "commonPage/financeManage/depositPrint",
    path: "/common/depositPrint",
    hidden: true,
    name: "打印物业押金"
}, {
    pageAddress: "commonPage/financeManage/marginPrint",
    path: "/common/marginPrint",
    hidden: true,
    name: "打印代付投标保证金"
}, {
    pageAddress: "commonPage/financeManage/materialPrint",
    path: "/common/materialPrint",
    hidden: true,
    name: "打印付款申请单"
}, {
    pageAddress: "fm/receiptConfirmation",
    path: "/fm/financeIncome/receiptConfirmation",
    hidden: true
}, {
    pageAddress: "commonPage/financeManage/serviceFeePrint",
    path: "/common/serviceFeePrint",
    hidden: true
}];

exports.default = menuFinanceManager;

/***/ }),

/***/ 874:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});


var menuGeneralManager = [{
    path: '/p5',
    component: "HomeView",
    name: '财务管理',
    redirect: '/common/financeData',
    parent: true,
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "总表视图",
        children: [{
            pageAddress: "commonPage/dataReport/financeDataInfo",
            path: "/common/financeDataInfo",
            component: "financeDataInfo",
            hidden: true,
            name: "财务数据详情"
        }]
    }]
}, {
    path: '/p8',
    redirect: '/general/change_password',
    component: "HomeView",
    name: '系统管理',
    parent: true,
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "个人设置",
        children: []
    }]

}, {
    pageAddress: "commonPage/dataReport/printSettleForm",
    path: "/common/printSettleForm",
    component: "printSettleForm",
    hidden: true,
    name: "打印结算表"
}];

exports.default = menuGeneralManager;

/***/ }),

/***/ 875:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});


var menuGm = [{
    path: '/p5',
    redirect: '/common/financeData',
    component: "HomeView",
    name: '财务管理',
    parent: true,
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "总表视图",
        children: [{
            pageAddress: "commonPage/dataReport/financeDataInfo",
            path: "/common/financeDataInfo",
            component: "financeDataInfo",
            hidden: true,
            name: "财务数据详情"
        }]
    }]

}, {
    path: '/p8',
    redirect: '/cm/information/changePW',
    component: "HomeView",
    name: '系统管理',
    parent: true,
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "个人设置",
        children: []
    }]

}, {
    pageAddress: "commonPage/dataReport/printSettleForm",
    path: "/common/printSettleForm",
    component: "printSettleForm",
    hidden: true,
    name: "打印结算表"
}];

exports.default = menuGm;

/***/ }),

/***/ 876:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var menuInsCommissioner = [{
    path: '/p0',
    redirect: '/common/injuriesList',
    component: "HomeView",
    name: '营销管理',
    parent: true,
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "公关管理",
        children: [{
            pageAddress: "commonPage/projectManage/injuriesDetail",
            path: "/common/injuriesDetail",
            component: "injuriesDetail",
            name: "伤亡事故详情",
            hidden: true
        }]
    }]

}, {
    path: '/p5',
    redirect: '/finance/insurance',
    component: "HomeView",
    name: '财务管理',
    parent: true,
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "资金管理",
        children: []
    }]

}, {
    path: '/p8',
    redirect: '/me/change_password',
    component: "HomeView",
    name: '系统管理',
    parent: true,
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "个人设置",
        children: []
    }]

}];
exports.default = menuInsCommissioner;

/***/ }),

/***/ 877:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});


var menuInvoice = [{
    path: '/p4',
    redirect: '/common/materialList',
    component: "HomeView",
    name: '材料管理',
    parent: true,
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "代付材料",
        children: [{
            pageAddress: "commonPage/financeManage/materialDetail",
            path: "/common/materialDetail",
            hidden: true,
            name: "代付材料申请详情"
        }, {
            pageAddress: "commonPage/financeManage/marginDetail",
            path: "/common/marginDetail",
            hidden: true,
            name: "代付投标保证金申请详情"
        }, {
            pageAddress: "commonPage/financeManage/depositDetail",
            path: "/common/depositDetail",
            hidden: true,
            name: "代付物业押金详情"
        }, {
            pageAddress: "commonPage/financeManage/purchaseDetail",
            path: "/common/purchaseDetail",
            hidden: true,
            name: "材料购销合同详情"
        }, {
            pageAddress: "commonPage/financeManage/purchaseApply",
            path: "/common/purchaseApply",
            hidden: true,
            name: "新增材料购销合同"
        }]
    }, {
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "众惠材料",
        children: []
    }]

}, {
    path: '/p5',
    redirect: '/fm/FMStatProjectIndexView',
    component: "HomeView",
    name: '财务管理',
    parent: true,
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "总表视图",
        children: [{
            pageAddress: "commonPage/dataReport/financeDataInfo",
            path: "/common/financeDataInfo",
            component: "financeDataInfo",
            hidden: true,
            name: "财务数据详情"
        }]
    }, {
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "资金管理",
        children: [{
            pageAddress: "fm/FMFinanceIncomeEditView",
            path: "/fm/financeIncome/edit",
            hidden: true,
            name: "收款流水细节"
        }, {
            pageAddress: "fm/FMFinanceIncomeReadView",
            path: "/fm/financeIncome/read",
            hidden: true,
            name: "流水信息"
        }, {
            pageAddress: "commonPage/financeManage/servicePayEdit",
            path: "/common/servicePayEdit",
            hidden: true,
            name: "编辑劳务支付"
        }, {
            pageAddress: "commonPage/financeManage/servicePayDetail",
            path: "/common/servicePayDetail",
            hidden: true,
            name: "劳务支付详情"
        }, {
            pageAddress: "fm/FMDeductionDetail",
            path: "/fm/FMDeductionDetail",
            hidden: true,
            name: "手动扣款详情"
        }, {
            pageAddress: "fm/FMAddDeduction",
            path: "/fm/FMAddDeduction",
            hidden: true,
            name: "添加手动扣款"
        }, {
            pageAddress: "fm/FMStatProjectReadView",
            path: "/fm/FMStatProjectReadView",
            hidden: true,
            name: "项目细节"
        }, {
            pageAddress: "commonPage/financeManage/applyPaymentDetail",
            path: "/common/applyPaymentDetail",
            hidden: true,
            name: "用款申请详情"
        }]
    }, {
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "发票管理",
        children: [{
            pageAddress: "fm/FmOutPutTicketDetail",
            path: "/fm/FmOutPutTicketDetail",
            hidden: true,
            name: "开票详情"
        }, {
            pageAddress: "fm/FmAddOutPutTicket",
            path: "/fm/FmAddOutPutTicket",
            hidden: true,
            name: "添加开票"
        }]
    }]

}, {
    path: '/p8',
    redirect: '/pm/personaldata/changePassWord',
    component: "HomeView",
    name: '系统管理',
    parent: true,
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "个人设置",
        children: []
    }]

}, {
    pageAddress: "fm/printOutPutTicket",
    path: "/common/printOutPutTicket",
    component: "printOutPutTicket",
    hidden: true,
    name: "打印销项票"
}, {
    pageAddress: "commonPage/dataReport/printSettleForm",
    path: "/common/printSettleForm",
    component: "printSettleForm",
    hidden: true,
    name: "打印结算表"
}, {
    pageAddress: "commonPage/financeManage/NewXiangmushitu",
    path: "/common/New",
    hidden: true,
    name: "项目视图新建页面导出数据"
}, {
    pageAddress: "commonPage/financeManage/depositPrint",
    path: "/common/depositPrint",
    hidden: true,
    name: "打印物业押金"
}, {
    pageAddress: "commonPage/financeManage/marginPrint",
    path: "/common/marginPrint",
    hidden: true,
    name: "打印代付投标保证金"
}, {
    pageAddress: "commonPage/financeManage/materialPrint",
    path: "/common/materialPrint",
    hidden: true,
    name: "打印付款申请单"
}, {
    pageAddress: "fm/receiptConfirmation",
    path: "/fm/financeIncome/receiptConfirmation",
    hidden: true
}, {
    pageAddress: "commonPage/financeManage/serviceFeePrint",
    path: "/common/serviceFeePrint",
    hidden: true
}];

exports.default = menuInvoice;

/***/ }),

/***/ 878:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});


var menuLaw = [{
    path: '/p0',
    component: "HomeView",
    name: '营销管理',
    redirect: '/common/complaintList',
    parent: true,
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "公关管理",
        children: [{
            pageAddress: "commonPage/complaintManage/addComplainList",
            path: "/common/addComplainList",
            hidden: true,
            component: "addComplainList",
            name: "添加投诉"
        }, {
            pageAddress: "commonPage/complaintManage/complaintDetail",
            path: "/common/complaintDetail",
            hidden: true,
            component: "complaintDetail",
            name: "投诉详情"
        }]
    }]
}, {
    path: '/p5',
    component: "HomeView",
    name: '财务管理',
    redirect: '/common/financeData',
    parent: true,
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "总表视图",
        children: [{
            pageAddress: "commonPage/dataReport/financeDataInfo",
            path: "/common/financeDataInfo",
            component: "financeDataInfo",
            hidden: true,
            name: "财务数据详情"
        }]
    }]
}, {
    path: '/p8',
    redirect: '/cm/information/changePW',
    component: "HomeView",
    name: '系统管理',
    parent: true,
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "个人设置",
        children: []
    }]

}, {
    pageAddress: "commonPage/dataReport/printSettleForm",
    path: "/common/printSettleForm",
    component: "printSettleForm",
    hidden: true,
    name: "打印结算表"
}];

exports.default = menuLaw;

/***/ }),

/***/ 879:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});


var menuMallFinance = [{
    path: '/p4',
    redirect: '/common/materialList',
    component: "HomeView",
    name: '材料管理',
    parent: true,
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "代付材料",
        children: [{
            pageAddress: "commonPage/financeManage/materialDetail",
            path: "/common/materialDetail",
            hidden: true,
            name: "代付材料申请详情"
        }, {
            pageAddress: "commonPage/financeManage/marginDetail",
            path: "/common/marginDetail",
            hidden: true,
            name: "代付投标保证金申请详情"
        }, {
            pageAddress: "commonPage/financeManage/depositDetail",
            path: "/common/depositDetail",
            hidden: true,
            name: "代付物业押金详情"
        }, {
            pageAddress: "commonPage/financeManage/purchaseDetail",
            path: "/common/purchaseDetail",
            hidden: true,
            name: "材料购销合同详情"
        }, {
            pageAddress: "commonPage/financeManage/purchaseApply",
            path: "/common/purchaseApply",
            hidden: true,
            name: "新增材料购销合同"
        }]
    }, {
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "众惠材料",
        children: []
    }]

}, {
    path: '/p5',
    redirect: '/fm/FMStatProjectIndexView',
    component: "HomeView",
    name: '财务管理',
    parent: true,
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "总表视图",
        children: [{
            pageAddress: "commonPage/dataReport/financeDataInfo",
            path: "/common/financeDataInfo",
            component: "financeDataInfo",
            hidden: true,
            name: "财务数据详情"
        }]
    }, {
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "资金管理",
        children: [{
            pageAddress: "fm/FMDeductionDetail",
            path: "/fm/FMDeductionDetail",
            hidden: true,
            name: "手动扣款详情"
        }, {
            pageAddress: "fm/FMAddDeduction",
            path: "/fm/FMAddDeduction",
            hidden: true,
            name: "添加手动扣款"
        }, {
            pageAddress: "fm/FMStatProjectReadView",
            path: "/fm/FMStatProjectReadView",
            hidden: true,
            name: "项目细节"
        }]
    }]

}, {
    path: '/p8',
    redirect: '/pm/personaldata/changePassWord',
    component: "HomeView",
    name: '系统管理',
    parent: true,
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "个人设置",
        children: []
    }]

}, {
    pageAddress: "commonPage/dataReport/printSettleForm",
    path: "/common/printSettleForm",
    component: "printSettleForm",
    hidden: true,
    name: "打印结算表"
}, {
    pageAddress: "commonPage/financeManage/NewXiangmushitu",
    path: "/common/New",
    hidden: true,
    name: "项目视图新建页面导出数据"
}];

exports.default = menuMallFinance;

/***/ }),

/***/ 880:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});


var menuMallMaterialManager = [{
    path: '/p0',
    redirect: '/common/complaintList',
    component: "HomeView",
    name: '营销管理',
    parent: true,
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "公关管理",
        children: [{
            pageAddress: "commonPage/complaintManage/addComplainList",
            path: "/common/addComplainList",
            hidden: true,
            component: "addComplainList",
            name: "添加投诉"
        }, {
            pageAddress: "commonPage/complaintManage/complaintDetail",
            path: "/common/complaintDetail",
            hidden: true,
            component: "complaintDetail",
            name: "投诉详情"
        }]
    }]

}, {
    path: '/p8',
    redirect: '/me/change_password',
    component: "HomeView",
    name: '系统管理',
    parent: true,
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "个人设置",
        children: []
    }]

}];

exports.default = menuMallMaterialManager;

/***/ }),

/***/ 881:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var menuMarketingManager = [{
    path: '/p0',
    component: "HomeView",
    name: '营销管理',
    parent: true,
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "合同管理",
        children: [{
            pageAddress: "CommonContractModifyDetail",
            path: "/common/contractModify/CommonContractModifyDetail",
            hidden: true,
            name: "变更合同详情"
        }, {
            pageAddress: "commonPage/dataReport/contractDataInfo",
            path: "/common/contractDataInfo",
            component: "contractDataInfo",
            hidden: true,
            name: "合同详情"
        }]
    }, {
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "公关管理",
        children: [{
            pageAddress: "commonPage/projectManage/injuriesDetail",
            path: "/common/injuriesDetail",
            component: "injuriesDetail",
            name: "事故详情",
            hidden: true
        }, {
            pageAddress: "commonPage/projectManage/injuriesAdd",
            path: "/common/injuriesAdd",
            component: "injuriesAdd",
            name: "添加伤亡事故",
            hidden: true
        }, {
            pageAddress: "pm/pmInjuriesList",
            path: "/pm/pmInjuriesList",
            hidden: true,
            component: "pmInjuriesList",
            name: "伤亡事故"
        }, {
            pageAddress: "commonPage/complaintManage/addComplainList",
            path: "/common/addComplainList",
            hidden: true,
            component: "addComplainList",
            name: "添加投诉"
        }, {
            pageAddress: "commonPage/complaintManage/complaintDetail",
            path: "/common/complaintDetail",
            hidden: true,
            component: "complaintDetail",
            name: "投诉详情"
        }]
    }, {
        parent: true,
        component: "Navigation",
        redirect: '/common/problemFeedbackList',
        path: "/home",
        name: "反馈管理",
        children: [{
            path: "/common/problemFeedbackDetail",
            hidden: true,
            component: "ProblemFeedbackDetailView",
            name: "问题反馈详情"
        }]
    }]
}, {
    path: '/p8',
    redirect: '/me/change_password',
    component: "HomeView",
    name: '系统管理',
    parent: true,
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "个人设置",
        children: []
    }]

}];
exports.default = menuMarketingManager;

/***/ }),

/***/ 882:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});


var menuPaymentDocumenter = [{
    path: '/p4',
    redirect: '/common/materialList',
    component: "HomeView",
    name: '材料管理',
    parent: true,
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "代付材料",
        children: [{
            pageAddress: "commonPage/financeManage/materialDetail",
            path: "/common/materialDetail",
            hidden: true,
            name: "代付材料申请详情"
        }, {
            pageAddress: "commonPage/financeManage/depositDetail",
            path: "/common/depositDetail",
            hidden: true,
            name: "代付物业押金详情"
        }, {
            pageAddress: "commonPage/financeManage/marginDetail",
            path: "/common/marginDetail",
            hidden: true,
            name: "代付投标保证金申请详情"
        }, {
            pageAddress: "commonPage/financeManage/purchaseDetail",
            path: "/common/purchaseDetail",
            hidden: true,
            name: "材料购销合同详情"
        }]
    }]

}, {
    path: '/p8',
    redirect: '/pm/personaldata/changePassWord',
    component: "HomeView",
    name: '系统管理',
    parent: true,
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "个人设置",
        children: []
    }]

}, {
    pageAddress: "commonPage/financeManage/materialPrint",
    path: "/common/materialPrint",
    hidden: true,
    name: "打印付款申请单"
}];
exports.default = menuPaymentDocumenter;

/***/ }),

/***/ 883:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});


var menuProductionManager = [{
    path: '/p4',
    redirect: '/common/materialList',
    component: "HomeView",
    name: '材料管理',
    parent: true,
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "代付材料",
        children: [{
            pageAddress: "commonPage/financeManage/materialDetail",
            path: "/common/materialDetail",
            hidden: true,
            name: "代付材料申请详情"
        }, {
            pageAddress: "commonPage/financeManage/purchaseDetail",
            path: "/common/purchaseDetail",
            hidden: true,
            name: "材料购销合同详情"
        }, {
            pageAddress: "commonPage/financeManage/purchaseApply",
            path: "/common/purchaseApply",
            hidden: true,
            name: "新增材料购销合同"
        }, {
            pageAddress: "commonPage/financeManage/addMargin",
            path: "/common/addMargin",
            hidden: true,
            name: "新增代付投标保证金申请"
        }, {
            pageAddress: "commonPage/financeManage/deposit",
            path: "/common/deposit",
            hidden: true,
            name: "新增代付物业押金"
        }, {
            pageAddress: "commonPage/financeManage/editDeposit",
            path: "/common/editDeposit",
            hidden: true,
            name: "编辑代付物业押金"
        }, {
            pageAddress: "commonPage/financeManage/depositDetail",
            path: "/common/depositDetail",
            hidden: true,
            name: "代付物业押金详情"
        }, {
            pageAddress: "commonPage/financeManage/editMargin",
            path: "/common/editMargin",
            hidden: true,
            name: "编辑代付投标保证金申请"
        }, {
            pageAddress: "commonPage/financeManage/marginDetail",
            path: "/common/marginDetail",
            hidden: true,
            name: "代付投标保证金申请详情"
        }]
    }]

}, {
    path: '/p5',
    redirect: '/common/applyPaymentList',
    component: "HomeView",
    name: '财务管理',
    parent: true,
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "资金管理",
        children: [{
            pageAddress: "commonPage/financeManage/applyPaymentDetail",
            path: "/common/applyPaymentDetail",
            hidden: true,
            name: "用款申请详情"
        }]
    }]

}, {
    path: '/p8',
    redirect: '/pm/personaldata/changePassWord',
    component: "HomeView",
    name: '系统管理',
    parent: true,
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "个人设置",
        children: []
    }]

}, {
    pageAddress: "commonPage/financeManage/NewXiangmushitu",
    path: "/common/New",
    hidden: true,
    name: "项目视图新建页面导出数据"
}, {
    pageAddress: "commonPage/financeManage/materialPrint",
    path: "/common/materialPrint",
    hidden: true,
    name: "打印付款申请单"
}, {
    pageAddress: "commonPage/financeManage/depositPrint",
    path: "/common/depositPrint",
    hidden: true,
    name: "打印物业押金"
}, {
    pageAddress: "commonPage/financeManage/marginPrint",
    path: "/common/marginPrint",
    hidden: true,
    name: "打印代付投标保证金"
}];

exports.default = menuProductionManager;

/***/ }),

/***/ 884:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});


var menuProjectSupervisor = [{
    path: '/p8',
    redirect: '/cm/information/changePW',
    component: "HomeView",
    name: '系统管理',
    parent: true,
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "个人设置",
        children: []
    }]

}, {
    pageAddress: "commonPage/enginnerManage/startProjectTable",
    path: "/common/startProjectTable",
    component: "startProjectTable",
    hidden: true
}, {
    pageAddress: "commonPage/enginnerManage/constructionScoreDetail",
    path: "/common/constructionScoreDetail",
    component: "constructionScoreDetail",
    hidden: true
}];

exports.default = menuProjectSupervisor;

/***/ }),

/***/ 885:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});


var menuSettlementsAccounting = [{
    path: '/p4',
    redirect: '/common/materialList',
    component: "HomeView",
    name: '材料管理',
    parent: true,
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "代付材料",
        children: [{
            pageAddress: "commonPage/financeManage/materialDetail",
            path: "/common/materialDetail",
            hidden: true,
            name: "代付材料申请详情"
        }, {
            pageAddress: "commonPage/financeManage/marginDetail",
            path: "/common/marginDetail",
            hidden: true,
            name: "代付投标保证金申请详情"
        }, {
            pageAddress: "commonPage/financeManage/depositDetail",
            path: "/common/depositDetail",
            hidden: true,
            name: "代付物业押金申请详情"
        }, {
            pageAddress: "commonPage/financeManage/purchaseDetail",
            path: "/common/purchaseDetail",
            hidden: true,
            name: "材料购销合同详情"
        }, {
            pageAddress: "commonPage/financeManage/purchaseApply",
            path: "/common/purchaseApply",
            hidden: true,
            name: "新增材料购销合同"
        }, {
            pageAddress: "fm/FMStatProjectReadView",
            path: "/fm/FMStatProjectReadView",
            hidden: true,
            name: "项目细节"
        }]
    }, {
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "众惠材料",
        children: []
    }]

}, {
    path: '/p5',
    component: "HomeView",
    name: '财务管理',
    redirect: '/common/financeData',
    parent: true,
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "总表视图",
        children: [{
            pageAddress: "commonPage/dataReport/financeDataInfo",
            path: "/common/financeDataInfo",
            component: "financeDataInfo",
            hidden: true,
            name: "财务数据详情"
        }]
    }, {
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "资金管理",
        children: [{
            pageAddress: "fm/FMFinanceIncomeEditView",
            path: "/fm/financeIncome/edit",
            hidden: true,
            name: "收款流水细节"
        }, {
            pageAddress: "fm/FMFinanceIncomeReadView",
            path: "/fm/financeIncome/read",
            hidden: true,
            name: "流水信息"
        }, {
            pageAddress: "commonPage/financeManage/servicePayEdit",
            path: "/common/servicePayEdit",
            hidden: true,
            name: "编辑劳务支付"
        }, {
            pageAddress: "commonPage/financeManage/servicePayDetail",
            path: "/common/servicePayDetail",
            hidden: true,
            name: "劳务支付详情"
        }, {
            pageAddress: "fm/FMDeductionDetail",
            path: "/fm/FMDeductionDetail",
            hidden: true,
            name: "手动扣款详情"
        }, {
            pageAddress: "fm/FMAddDeduction",
            path: "/fm/FMAddDeduction",
            hidden: true,
            name: "添加手动扣款"
        }, {
            pageAddress: "fm/FMStatProjectReadView",
            path: "/fm/FMStatProjectReadView",
            hidden: true,
            name: "项目细节"
        }, {
            pageAddress: "commonPage/financeManage/applyPaymentDetail",
            path: "/common/applyPaymentDetail",
            hidden: true,
            name: "用款申请详情"
        }]
    }, {
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "发票管理",
        children: [{
            pageAddress: "fm/FmOutPutTicketDetail",
            path: "/fm/FmOutPutTicketDetail",
            hidden: true,
            name: "开票详情"
        }]
    }]
}, {
    path: '/p8',
    redirect: '/cm/information/changePW',
    component: "HomeView",
    name: '系统管理',
    parent: true,
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "个人设置",
        children: []
    }]

}, {
    pageAddress: "commonPage/dataReport/printSettleForm",
    path: "/common/printSettleForm",
    component: "printSettleForm",
    hidden: true,
    name: "打印结算表"
}, {
    pageAddress: "commonPage/financeManage/NewXiangmushitu",
    path: "/common/New",
    hidden: true,
    name: "项目视图新建页面导出数据"
}, {
    pageAddress: "commonPage/financeManage/depositPrint",
    path: "/common/depositPrint",
    hidden: true,
    name: "打印物业押金"
}, {
    pageAddress: "commonPage/financeManage/marginPrint",
    path: "/common/marginPrint",
    hidden: true,
    name: "打印代付投标保证金"
}, {
    pageAddress: "commonPage/financeManage/materialPrint",
    path: "/common/materialPrint",
    hidden: true,
    name: "打印付款申请单"
}, {
    pageAddress: "commonPage/financeManage/serviceFeePrint",
    path: "/common/serviceFeePrint",
    hidden: true
}];

exports.default = menuSettlementsAccounting;

/***/ }),

/***/ 886:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});


var menuSupervisor = [{
    path: '/p8',
    redirect: '/cm/information/changePW',
    component: "HomeView",
    name: '系统管理',
    parent: true,
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "个人设置",
        children: []
    }]

}, {
    pageAddress: "commonPage/enginnerManage/finishProjectTable",
    path: "/common/finishProjectTable",
    component: "finishProjectTable",
    hidden: true
}, {
    pageAddress: "commonPage/enginnerManage/startProjectTable",
    path: "/common/startProjectTable",
    component: "startProjectTable",
    hidden: true
}, {
    pageAddress: "commonPage/enginnerManage/finishProjectTable",
    path: "/common/finishProjectTable",
    component: "finishProjectTable",
    hidden: true
}, {
    pageAddress: "commonPage/enginnerManage/constructionScoreDetail",
    path: "/common/constructionScoreDetail",
    component: "constructionScoreDetail",
    hidden: true
}, {
    pageAddress: "commonPage/enginnerManage/returnVisitTable",
    path: "/common/returnVisitTable",
    component: "returnVisitTable",
    hidden: true
}];

exports.default = menuSupervisor;

/***/ }),

/***/ 887:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});


var menuTaxAccounting = [{
    path: '/p4',
    redirect: '/common/materialList',
    component: "HomeView",
    name: '材料管理',
    parent: true,
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "代付材料",
        children: [{
            pageAddress: "commonPage/financeManage/materialDetail",
            path: "/common/materialDetail",
            hidden: true,
            name: "代付材料申请详情"
        }, {
            pageAddress: "commonPage/financeManage/marginDetail",
            path: "/common/marginDetail",
            hidden: true,
            name: "代付投标保证金申请详情"
        }, {
            pageAddress: "commonPage/financeManage/depositDetail",
            path: "/common/depositDetail",
            hidden: true,
            name: "代付物业押金申请详情"
        }, {
            pageAddress: "commonPage/financeManage/purchaseDetail",
            path: "/common/purchaseDetail",
            hidden: true,
            name: "材料购销合同详情"
        }, {
            pageAddress: "commonPage/financeManage/purchaseApply",
            path: "/common/purchaseApply",
            hidden: true,
            name: "新增材料购销合同"
        }, {
            pageAddress: "fm/FMStatProjectReadView",
            path: "/fm/FMStatProjectReadView",
            hidden: true,
            name: "项目细节"
        }]
    }, {
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "众惠材料",
        children: []
    }]

}, {
    path: '/p5',
    component: "HomeView",
    name: '财务管理',
    redirect: '/common/financeData',
    parent: true,
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "总表视图",
        children: [{
            pageAddress: "commonPage/dataReport/financeDataInfo",
            path: "/common/financeDataInfo",
            component: "financeDataInfo",
            hidden: true,
            name: "财务数据详情"
        }]
    }, {
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "资金管理",
        children: [{
            pageAddress: "fm/FMFinanceIncomeEditView",
            path: "/fm/financeIncome/edit",
            hidden: true,
            name: "收款流水细节"
        }, {
            pageAddress: "fm/FMFinanceIncomeReadView",
            path: "/fm/financeIncome/read",
            hidden: true,
            name: "流水信息"
        }, {
            pageAddress: "commonPage/financeManage/servicePayEdit",
            path: "/common/servicePayEdit",
            hidden: true,
            name: "编辑劳务支付"
        }, {
            pageAddress: "commonPage/financeManage/servicePayDetail",
            path: "/common/servicePayDetail",
            hidden: true,
            name: "劳务支付详情"
        }, {
            pageAddress: "fm/FMDeductionDetail",
            path: "/fm/FMDeductionDetail",
            hidden: true,
            name: "手动扣款详情"
        }, {
            pageAddress: "fm/FMAddDeduction",
            path: "/fm/FMAddDeduction",
            hidden: true,
            name: "添加手动扣款"
        }, {
            pageAddress: "fm/FMStatProjectReadView",
            path: "/fm/FMStatProjectReadView",
            hidden: true,
            name: "项目细节"
        }, {
            pageAddress: "commonPage/financeManage/applyPaymentDetail",
            path: "/common/applyPaymentDetail",
            hidden: true,
            name: "用款申请详情"
        }]
    }, {
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "发票管理",
        children: [{
            pageAddress: "fm/FmOutPutTicketDetail",
            path: "/fm/FmOutPutTicketDetail",
            hidden: true,
            name: "开票详情"
        }]
    }]
}, {
    path: '/p8',
    redirect: '/cm/information/changePW',
    component: "HomeView",
    name: '系统管理',
    parent: true,
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "个人设置",
        children: []
    }]

}, {
    pageAddress: "commonPage/dataReport/printSettleForm",
    path: "/common/printSettleForm",
    component: "printSettleForm",
    hidden: true,
    name: "打印结算表"
}, {
    pageAddress: "commonPage/financeManage/NewXiangmushitu",
    path: "/common/New",
    hidden: true,
    name: "项目视图新建页面导出数据"
}, {
    pageAddress: "commonPage/financeManage/depositPrint",
    path: "/common/depositPrint",
    hidden: true,
    name: "打印物业押金"
}, {
    pageAddress: "commonPage/financeManage/marginPrint",
    path: "/common/marginPrint",
    hidden: true,
    name: "打印代付投标保证金"
}, {
    pageAddress: "commonPage/financeManage/materialPrint",
    path: "/common/materialPrint",
    hidden: true,
    name: "打印付款申请单"
}, {
    pageAddress: "commonPage/financeManage/serviceFeePrint",
    path: "/common/serviceFeePrint",
    hidden: true
}];

exports.default = menuTaxAccounting;

/***/ }),

/***/ 888:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});


var menuYxbfzc = [{
    path: '/p6',
    component: "HomeView",
    name: '项目总监管理',
    parent: true,
    redirect: '/ba/cm/projectManagerList',
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "项目总监",
        children: [{
            pageAddress: "cd/CDinterviewRecord",
            path: "/cm/pm/interviewRecord",
            hidden: true,
            component: "CDinterviewRecord",
            name: "项目总监管理---访谈记录"
        }, {
            pageAddress: "cd/CDprojectDirector",
            path: "/cm/pm/projectDirector",
            hidden: true,
            component: "CDprojectDirector",
            name: "查看项目总监"
        }, {
            pageAddress: "cd/CDProjectManagerEditView",
            path: "/cd/pm/edit",
            hidden: true,
            component: "CDProjectManagerEditView",
            name: "项目总监详情"
        }]
    }]
}, {
    path: '/p8',
    redirect: '/user/index',
    component: "HomeView",
    name: '系统管理',
    parent: true,
    children: [{
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "账户设置",
        children: [{
            pageAddress: "commonPage/AccountDetail",
            path: "/UserIndexView/detail",
            hidden: true,
            component: "AccountDetail",
            name: "员工账号详情"
        }]
    }, {
        parent: true,
        component: "Navigation",
        path: "/home",
        name: "个人设置",
        children: []
    }]

}, {
    pageAddress: "commonPage/dataReport/printSettleForm",
    path: "/common/printSettleForm",
    component: "printSettleForm",
    hidden: true,
    name: "打印结算表"
}, {
    pageAddress: "commonPage/financeManage/NewXiangmushitu",
    path: "/common/New",
    hidden: true,
    name: "项目视图新建页面导出数据"
}, {
    pageAddress: "commonPage/financeManage/depositPrint",
    path: "/common/depositPrint",
    hidden: true,
    name: "打印物业押金"
}, {
    pageAddress: "commonPage/financeManage/marginPrint",
    path: "/common/marginPrint",
    hidden: true,
    name: "打印代付投标保证金"
}, {
    pageAddress: "commonPage/financeManage/materialPrint",
    path: "/common/materialPrint",
    hidden: true,
    name: "打印付款申请单"
}, {
    pageAddress: "commonPage/financeManage/serviceFeePrint",
    path: "/common/serviceFeePrint",
    hidden: true
}];

exports.default = menuYxbfzc;

/***/ }),

/***/ 889:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (name) {
  return function () {
    return __webpack_require__(1722)("./" + name + ".vue");
  };
};

/***/ }),

/***/ 890:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var increment = exports.increment = function increment(_ref) {
    var commit = _ref.commit;

    commit('INCREMENT');
};
var decrement = exports.decrement = function decrement(_ref2) {
    var commit = _ref2.commit;

    commit('DECREMENT');
};

/***/ }),

/***/ 891:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var getCount = exports.getCount = function getCount(state) {
    return state.count;
};

/***/ }),

/***/ 892:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var treeState = exports.treeState = {
    state: function state() {
        return {
            showTree: false
        };
    },

    mutations: {
        setShowTree: function setShowTree(state, n) {
            state.showTree = n;
        }
    },

    getters: {
        getShowTree: function getShowTree(state) {
            return state.showTree;
        }
    },

    actions: {}
};

var benchParam = exports.benchParam = {
    state: function state() {
        return {
            param: '',
            benchId: '' };
    },

    mutations: {
        setParam: function setParam(state, code) {
            state.param = code;
        },
        setBenchId: function setBenchId(state, id) {
            state.benchId = id;
        }
    },

    getters: {
        getParam: function getParam(state) {
            return state.param;
        },
        getBenchId: function getBenchId(state) {
            return state.benchId;
        }
    }
};

var showState = exports.showState = {
    state: function state() {
        return {
            isShow: false
        };
    },

    mutations: {
        setShow: function setShow(state, n) {
            state.isShow = n;
        }
    },

    getters: {
        getShow: function getShow(state) {
            return state.isShow;
        }
    }
};

var projectInfo = exports.projectInfo = {
    state: function state() {
        return {
            contractCat: '',
            projectProgress: '',
            contractName: '',
            contractNo: '',
            projectStatus: '',
            status: '',
            dataForm: {}
        };
    },

    mutations: {
        setContractCat: function setContractCat(state, n) {
            state.contractCat = n;
        },
        setProjectProgress: function setProjectProgress(state, n) {
            state.projectProgress = n;
        },
        setContractName: function setContractName(state, n) {
            state.contractName = n;
        },
        setContractNo: function setContractNo(state, n) {
            state.contractNo = n;
        },
        setProjectStatus: function setProjectStatus(state, n) {
            state.projectStatus = n;
        },
        setStatus: function setStatus(state, n) {
            state.status = n;
        },
        setDataForm: function setDataForm(state, n) {
            state.dataForm = n;
        }
    },

    getters: {
        getContractCat: function getContractCat(state) {
            return state.contractCat;
        },
        getProjectProgress: function getProjectProgress(state) {
            return state.projectProgress;
        },
        getContractName: function getContractName(state) {
            return state.contractName;
        },
        getContractNo: function getContractNo(state) {
            return state.contractNo;
        },
        getProjectStatus: function getProjectStatus(state) {
            return state.projectStatus;
        },
        getStatus: function getStatus(state) {
            return state.status;
        },
        getDataForm: function getDataForm(state) {
            return state.dataForm;
        }
    }
};

/***/ }),

/***/ 91:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(261);

var _assign2 = _interopRequireDefault(_assign);

var _lazyLoading = __webpack_require__(889);

var _lazyLoading2 = _interopRequireDefault(_lazyLoading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (routers, data) {
  generaMenu(routers, data);
};

function generaMenu(routers, data) {

  data.forEach(function (item) {
    var menu = (0, _assign2.default)({}, item);

    if (item.pageAddress && item.pageAddress != "") {
      menu.component = (0, _lazyLoading2.default)(item.pageAddress);
    } else {
      menu.component = (0, _lazyLoading2.default)(item.component);
    }

    if (item.parent) {
      menu.children = [];
      generaMenu(menu.children, item.children);
    }
    routers.push(menu);
  });
}

/***/ })

},[859]);


// WEBPACK FOOTER //
// static/js/app.737dca535d2f1b3707e3.js